//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import { DateTime, Duration } from "luxon";

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AcademicTitleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getAcademicTitles(personId: number, filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetAcademicTitleSearchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/AcademicTitle/GetAcademicTitles?";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined and cannot be null.");
        else
            url_ += "PersonId=" + encodeURIComponent("" + personId) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAcademicTitles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAcademicTitles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAcademicTitleSearchOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAcademicTitleSearchOutputDto>;
        }));
    }

    protected processGetAcademicTitles(response: HttpResponseBase): Observable<GetAcademicTitleSearchOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAcademicTitleSearchOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAcademicTitle(id: number | undefined): Observable<AcademicTitleDto> {
        let url_ = this.baseUrl + "/api/services/app/AcademicTitle/GetAcademicTitle?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAcademicTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAcademicTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AcademicTitleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AcademicTitleDto>;
        }));
    }

    protected processGetAcademicTitle(response: HttpResponseBase): Observable<AcademicTitleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AcademicTitleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    postAcademicTitle(body: CreateAcademicTitleDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/AcademicTitle/PostAcademicTitle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostAcademicTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostAcademicTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processPostAcademicTitle(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    putAcademicTitle(id: number | undefined, body: AcademicTitleDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AcademicTitle/PutAcademicTitle?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutAcademicTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutAcademicTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutAcademicTitle(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param reason (optional) 
     * @return Success
     */
    deleteAcademicTitle(id: number | undefined, reason: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AcademicTitle/DeleteAcademicTitle?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (reason === null)
            throw new Error("The parameter 'reason' cannot be null.");
        else if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAcademicTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAcademicTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAcademicTitle(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    isTenantAvailable(body: IsTenantAvailableInput | undefined): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTenantAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTenantAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IsTenantAvailableOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IsTenantAvailableOutput>;
        }));
    }

    protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsTenantAvailableOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resolveTenantId(body: ResolveTenantIdInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Account/ResolveTenantId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResolveTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResolveTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processResolveTenantId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    register(body: RegisterInput | undefined): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterOutput>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendPasswordResetCode(body: SendPasswordResetCodeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendPasswordResetCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendPasswordResetCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPasswordResetCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendPasswordResetCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: ResetPasswordInput | undefined): Observable<ResetPasswordOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResetPasswordOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResetPasswordOutput>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<ResetPasswordOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResetPasswordOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendEmailActivationLink(body: SendEmailActivationLinkInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendEmailActivationLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmailActivationLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmailActivationLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendEmailActivationLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    activateEmail(body: ActivateEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/ActivateEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivateEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    impersonateUser(body: ImpersonateUserInput | undefined): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/ImpersonateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImpersonateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImpersonateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonateOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonateOutput>;
        }));
    }

    protected processImpersonateUser(response: HttpResponseBase): Observable<ImpersonateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    impersonateTenant(body: ImpersonateTenantInput | undefined): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/ImpersonateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImpersonateTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImpersonateTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonateOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonateOutput>;
        }));
    }

    protected processImpersonateTenant(response: HttpResponseBase): Observable<ImpersonateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    delegatedImpersonate(body: DelegatedImpersonateInput | undefined): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/DelegatedImpersonate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelegatedImpersonate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelegatedImpersonate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonateOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonateOutput>;
        }));
    }

    protected processDelegatedImpersonate(response: HttpResponseBase): Observable<ImpersonateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    backToImpersonator(): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/BackToImpersonator";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBackToImpersonator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBackToImpersonator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonateOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonateOutput>;
        }));
    }

    protected processBackToImpersonator(response: HttpResponseBase): Observable<ImpersonateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    switchToLinkedAccount(body: SwitchToLinkedAccountInput | undefined): Observable<SwitchToLinkedAccountOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/SwitchToLinkedAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSwitchToLinkedAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSwitchToLinkedAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwitchToLinkedAccountOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwitchToLinkedAccountOutput>;
        }));
    }

    protected processSwitchToLinkedAccount(response: HttpResponseBase): Observable<SwitchToLinkedAccountOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SwitchToLinkedAccountOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AdditionalInformationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getForEntity(discriminator: AdditionalInformationDiscriminator, entityId: number): Observable<GetAdditionalInformationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AdditionalInformation/GetForEntity?";
        if (discriminator === undefined || discriminator === null)
            throw new Error("The parameter 'discriminator' must be defined and cannot be null.");
        else
            url_ += "Discriminator=" + encodeURIComponent("" + discriminator) + "&";
        if (entityId === undefined || entityId === null)
            throw new Error("The parameter 'entityId' must be defined and cannot be null.");
        else
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForEntity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForEntity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAdditionalInformationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAdditionalInformationDto[]>;
        }));
    }

    protected processGetForEntity(response: HttpResponseBase): Observable<GetAdditionalInformationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAdditionalInformationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<GetAdditionalInformationDto> {
        let url_ = this.baseUrl + "/api/services/app/AdditionalInformation/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAdditionalInformationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAdditionalInformationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetAdditionalInformationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAdditionalInformationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(discriminator: AdditionalInformationDiscriminator, entityId: number, body: AdditionalInformationDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/AdditionalInformation/Create?";
        if (discriminator === undefined || discriminator === null)
            throw new Error("The parameter 'discriminator' must be defined and cannot be null.");
        else
            url_ += "Discriminator=" + encodeURIComponent("" + discriminator) + "&";
        if (entityId === undefined || entityId === null)
            throw new Error("The parameter 'entityId' must be defined and cannot be null.");
        else
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    update(id: number | undefined, body: AdditionalInformationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdditionalInformation/Update?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdditionalInformation/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AddressServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    gridSearch(body: AddressSearchInput | undefined): Observable<AddressSearchOutput> {
        let url_ = this.baseUrl + "/api/services/app/Address/GridSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGridSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGridSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddressSearchOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddressSearchOutput>;
        }));
    }

    protected processGridSearch(response: HttpResponseBase): Observable<AddressSearchOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddressSearchOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    formSearch(body: FormAddressSearchInput | undefined): Observable<AddressSearchOutput> {
        let url_ = this.baseUrl + "/api/services/app/Address/FormSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFormSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFormSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddressSearchOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddressSearchOutput>;
        }));
    }

    protected processFormSearch(response: HttpResponseBase): Observable<AddressSearchOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddressSearchOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AddressAutocompleteServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param postCode (optional) 
     * @return Success
     */
    getCitiesByPostCode(postCode: string | undefined): Observable<KeyValuePairOfStringString[]> {
        let url_ = this.baseUrl + "/api/services/app/AddressAutocomplete/GetCitiesByPostCode?";
        if (postCode === null)
            throw new Error("The parameter 'postCode' cannot be null.");
        else if (postCode !== undefined)
            url_ += "postCode=" + encodeURIComponent("" + postCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCitiesByPostCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCitiesByPostCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValuePairOfStringString[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValuePairOfStringString[]>;
        }));
    }

    protected processGetCitiesByPostCode(response: HttpResponseBase): Observable<KeyValuePairOfStringString[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KeyValuePairOfStringString.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param postCode (optional) 
     * @param cantonAbbreviation (optional) 
     * @return Success
     */
    isPostCodeInCanton(postCode: string | undefined, cantonAbbreviation: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/AddressAutocomplete/IsPostCodeInCanton?";
        if (postCode === null)
            throw new Error("The parameter 'postCode' cannot be null.");
        else if (postCode !== undefined)
            url_ += "postCode=" + encodeURIComponent("" + postCode) + "&";
        if (cantonAbbreviation === null)
            throw new Error("The parameter 'cantonAbbreviation' cannot be null.");
        else if (cantonAbbreviation !== undefined)
            url_ += "cantonAbbreviation=" + encodeURIComponent("" + cantonAbbreviation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsPostCodeInCanton(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsPostCodeInCanton(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsPostCodeInCanton(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param cityId (optional) 
     * @param street (optional) 
     * @return Success
     */
    getStreetsByCity(cityId: number | undefined, street: string | undefined): Observable<KeyValuePairOfStringString[]> {
        let url_ = this.baseUrl + "/api/services/app/AddressAutocomplete/GetStreetsByCity?";
        if (cityId === null)
            throw new Error("The parameter 'cityId' cannot be null.");
        else if (cityId !== undefined)
            url_ += "cityId=" + encodeURIComponent("" + cityId) + "&";
        if (street === null)
            throw new Error("The parameter 'street' cannot be null.");
        else if (street !== undefined)
            url_ += "street=" + encodeURIComponent("" + street) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStreetsByCity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStreetsByCity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValuePairOfStringString[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValuePairOfStringString[]>;
        }));
    }

    protected processGetStreetsByCity(response: HttpResponseBase): Observable<KeyValuePairOfStringString[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KeyValuePairOfStringString.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param streetId (optional) 
     * @param houseNumber (optional) 
     * @return Success
     */
    getHouseNumbersByStreetId(streetId: number | undefined, houseNumber: string | undefined): Observable<KeyValuePairOfStringString[]> {
        let url_ = this.baseUrl + "/api/services/app/AddressAutocomplete/GetHouseNumbersByStreetId?";
        if (streetId === null)
            throw new Error("The parameter 'streetId' cannot be null.");
        else if (streetId !== undefined)
            url_ += "streetId=" + encodeURIComponent("" + streetId) + "&";
        if (houseNumber === null)
            throw new Error("The parameter 'houseNumber' cannot be null.");
        else if (houseNumber !== undefined)
            url_ += "houseNumber=" + encodeURIComponent("" + houseNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHouseNumbersByStreetId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHouseNumbersByStreetId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValuePairOfStringString[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValuePairOfStringString[]>;
        }));
    }

    protected processGetHouseNumbersByStreetId(response: HttpResponseBase): Observable<KeyValuePairOfStringString[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KeyValuePairOfStringString.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AlaAcademicTitleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateAlaAcademicTitle(body: CreateOrUpdateAlaAcademicTitleInput | undefined): Observable<CreateOrUpdateAlaAcademicTitleOutput> {
        let url_ = this.baseUrl + "/api/services/app/AlaAcademicTitle/CreateOrUpdateAlaAcademicTitle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateAlaAcademicTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateAlaAcademicTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateAlaAcademicTitleOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateAlaAcademicTitleOutput>;
        }));
    }

    protected processCreateOrUpdateAlaAcademicTitle(response: HttpResponseBase): Observable<CreateOrUpdateAlaAcademicTitleOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateAlaAcademicTitleOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    createBlankAlaAcademicTitle(caseId: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/AlaAcademicTitle/CreateBlankAlaAcademicTitle?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBlankAlaAcademicTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBlankAlaAcademicTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateBlankAlaAcademicTitle(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param academicTitleId (optional) 
     * @return Success
     */
    deleteAlaAcademicTitle(caseId: string | undefined, academicTitleId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AlaAcademicTitle/DeleteAlaAcademicTitle?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (academicTitleId === null)
            throw new Error("The parameter 'academicTitleId' cannot be null.");
        else if (academicTitleId !== undefined)
            url_ += "academicTitleId=" + encodeURIComponent("" + academicTitleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAlaAcademicTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAlaAcademicTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAlaAcademicTitle(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getAlaAcademicTitleFiles(caseId: string, step: AlaStatus | undefined): Observable<AlaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/AlaAcademicTitle/GetAlaAcademicTitleFiles?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAlaAcademicTitleFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlaAcademicTitleFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaDocumentsOutput>;
        }));
    }

    protected processGetAlaAcademicTitleFiles(response: HttpResponseBase): Observable<AlaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param alaAcademicTitleId (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(alaAcademicTitleId: number | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AlaAcademicTitle/UploadFiles?";
        if (alaAcademicTitleId === null)
            throw new Error("The parameter 'alaAcademicTitleId' cannot be null.");
        else if (alaAcademicTitleId !== undefined)
            url_ += "alaAcademicTitleId=" + encodeURIComponent("" + alaAcademicTitleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AlaApplicantPersonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateAlaApplicantPerson | undefined): Observable<AlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/AlaApplicantPerson/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<AlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AlaApplicantSponsorshipServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateAlaApplicantSponsorship | undefined): Observable<AlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/AlaApplicantSponsorship/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<AlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AlaBusinessServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: AlaBusinessDto | undefined): Observable<AlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/AlaBusiness/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<AlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AlaContactServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateAlaContact | undefined): Observable<AlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/AlaContact/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<AlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AlaCurrentAssistantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: CreateOrUpdateAlaCurrentAssistantsInput | undefined): Observable<AlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/AlaCurrentAssistant/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<AlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<AlaCurrentAssistantDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AlaCurrentAssistant/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaCurrentAssistantDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaCurrentAssistantDto[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AlaCurrentAssistantDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AlaCurrentAssistantDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    createBlankAlaCurrentAssistant(caseId: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/AlaCurrentAssistant/CreateBlankAlaCurrentAssistant?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBlankAlaCurrentAssistant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBlankAlaCurrentAssistant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateBlankAlaCurrentAssistant(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param currentAssistantId (optional) 
     * @return Success
     */
    deleteAlaCurrentAssistant(caseId: string | undefined, currentAssistantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AlaCurrentAssistant/DeleteAlaCurrentAssistant?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (currentAssistantId === null)
            throw new Error("The parameter 'currentAssistantId' cannot be null.");
        else if (currentAssistantId !== undefined)
            url_ += "currentAssistantId=" + encodeURIComponent("" + currentAssistantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAlaCurrentAssistant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAlaCurrentAssistant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAlaCurrentAssistant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AlaDiplomaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateAlaDiploma | undefined): Observable<AlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/AlaDiploma/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<AlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AlaDocumentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getDocuments(body: GetAlaDocumentsInput | undefined): Observable<AlaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/AlaDocument/GetDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaDocumentsOutput>;
        }));
    }

    protected processGetDocuments(response: HttpResponseBase): Observable<AlaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AlaDocument/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getFile(body: GetAlaFileInput | undefined): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/AlaDocument/GetFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    deleteFile(caseId: string, step: AlaStatus | undefined, id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AlaDocument/DeleteFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AlaEmploymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: AlaEmploymentDto | undefined): Observable<AlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/AlaEmployment/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<AlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AlaInvoiceAddressServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: AlaInvoiceAddressDto | undefined): Observable<AlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/AlaInvoiceAddress/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<AlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<AlaInvoiceAddressDto> {
        let url_ = this.baseUrl + "/api/services/app/AlaInvoiceAddress/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaInvoiceAddressDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaInvoiceAddressDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AlaInvoiceAddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlaInvoiceAddressDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AlaLanguageSkillServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateAlaLanguageSkillInput | undefined): Observable<AlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/AlaLanguageSkill/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<AlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AlaMedicalFieldDirectorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateAlaMedicalFieldDirector | undefined): Observable<AlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/AlaMedicalFieldDirector/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<AlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AlapServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAlap(body: CreateAlaInput | undefined): Observable<CreateAlaOutput> {
        let url_ = this.baseUrl + "/api/services/app/Alap/CreateAlap";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAlap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAlap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateAlaOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateAlaOutput>;
        }));
    }

    protected processCreateAlap(response: HttpResponseBase): Observable<CreateAlaOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateAlaOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMyAlaps(): Observable<AlaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Alap/GetMyAlaps";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyAlaps(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyAlaps(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaDto[]>;
        }));
    }

    protected processGetMyAlaps(response: HttpResponseBase): Observable<AlaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AlaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getNextStatus(caseId: string, status: AlaStatus): Observable<AlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/Alap/GetNextStatus?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined and cannot be null.");
        else
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaStatus>;
        }));
    }

    protected processGetNextStatus(response: HttpResponseBase): Observable<AlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param gln (optional) 
     * @return Success
     */
    getAlapsForPerson(gln: string | undefined): Observable<AlaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Alap/GetAlapsForPerson?";
        if (gln === null)
            throw new Error("The parameter 'gln' cannot be null.");
        else if (gln !== undefined)
            url_ += "gln=" + encodeURIComponent("" + gln) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAlapsForPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlapsForPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaDto[]>;
        }));
    }

    protected processGetAlapsForPerson(response: HttpResponseBase): Observable<AlaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AlaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getLicenceForAla(caseId: string | undefined): Observable<ProfessionalLicenceDto> {
        let url_ = this.baseUrl + "/api/services/app/Alap/GetLicenceForAla?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLicenceForAla(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLicenceForAla(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfessionalLicenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfessionalLicenceDto>;
        }));
    }

    protected processGetLicenceForAla(response: HttpResponseBase): Observable<ProfessionalLicenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfessionalLicenceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getAlap(caseId: string | undefined): Observable<GetAlaOutput> {
        let url_ = this.baseUrl + "/api/services/app/Alap/GetAlap?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAlap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAlaOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAlaOutput>;
        }));
    }

    protected processGetAlap(response: HttpResponseBase): Observable<GetAlaOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAlaOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param applicantComment (optional) 
     * @return Success
     */
    releaseAlap(caseId: string | undefined, applicantComment: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Alap/ReleaseAlap?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (applicantComment === null)
            throw new Error("The parameter 'applicantComment' cannot be null.");
        else if (applicantComment !== undefined)
            url_ += "applicantComment=" + encodeURIComponent("" + applicantComment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseAlap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseAlap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReleaseAlap(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getEvaluationComments(caseId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Alap/GetEvaluationComments?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvaluationComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvaluationComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetEvaluationComments(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    validateThatAllMandatoryDocumentsHaveBeenUploaded(caseId: string | undefined): Observable<AlaStatus[]> {
        let url_ = this.baseUrl + "/api/services/app/Alap/ValidateThatAllMandatoryDocumentsHaveBeenUploaded?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaStatus[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaStatus[]>;
        }));
    }

    protected processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response: HttpResponseBase): Observable<AlaStatus[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AlaPersonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateAlaPerson | undefined): Observable<AlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/AlaPerson/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<AlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AlaPostgraduateTitleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLiaPostgraduateTitles(body: CreateOrUpdateAlaPostgraduateTitleInput | undefined): Observable<CreateOrUpdateAlaPostgraduateTitleOutput> {
        let url_ = this.baseUrl + "/api/services/app/AlaPostgraduateTitle/CreateOrUpdateLiaPostgraduateTitles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLiaPostgraduateTitles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLiaPostgraduateTitles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateAlaPostgraduateTitleOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateAlaPostgraduateTitleOutput>;
        }));
    }

    protected processCreateOrUpdateLiaPostgraduateTitles(response: HttpResponseBase): Observable<CreateOrUpdateAlaPostgraduateTitleOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateAlaPostgraduateTitleOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AlaPreviousEmploymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: CreateOrUpdateAlaPreviousEmploymentInput | undefined): Observable<AlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/AlaPreviousEmployment/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<AlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<AlaPreviousEmploymentDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AlaPreviousEmployment/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaPreviousEmploymentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaPreviousEmploymentDto[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AlaPreviousEmploymentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AlaPreviousEmploymentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    createBlankAlaPreviousEmployment(caseId: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/AlaPreviousEmployment/CreateBlankAlaPreviousEmployment?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBlankAlaPreviousEmployment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBlankAlaPreviousEmployment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateBlankAlaPreviousEmployment(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param previousEmploymentId (optional) 
     * @return Success
     */
    deleteAlaPreviousEmployment(caseId: string | undefined, previousEmploymentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AlaPreviousEmployment/DeleteAlaPreviousEmployment?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (previousEmploymentId === null)
            throw new Error("The parameter 'previousEmploymentId' cannot be null.");
        else if (previousEmploymentId !== undefined)
            url_ += "previousEmploymentId=" + encodeURIComponent("" + previousEmploymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAlaPreviousEmployment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAlaPreviousEmployment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAlaPreviousEmployment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getAlaPreviousEmploymentFiles(caseId: string, step: AlaStatus | undefined): Observable<AlaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/AlaPreviousEmployment/GetAlaPreviousEmploymentFiles?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAlaPreviousEmploymentFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlaPreviousEmploymentFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaDocumentsOutput>;
        }));
    }

    protected processGetAlaPreviousEmploymentFiles(response: HttpResponseBase): Observable<AlaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AlasServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAlas(body: CreateAlaInput | undefined): Observable<CreateAlaOutput> {
        let url_ = this.baseUrl + "/api/services/app/Alas/CreateAlas";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAlas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAlas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateAlaOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateAlaOutput>;
        }));
    }

    protected processCreateAlas(response: HttpResponseBase): Observable<CreateAlaOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateAlaOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMyAlases(): Observable<AlaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Alas/GetMyAlases";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyAlases(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyAlases(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaDto[]>;
        }));
    }

    protected processGetMyAlases(response: HttpResponseBase): Observable<AlaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AlaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getNextStatus(caseId: string, status: AlaStatus): Observable<AlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/Alas/GetNextStatus?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined and cannot be null.");
        else
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaStatus>;
        }));
    }

    protected processGetNextStatus(response: HttpResponseBase): Observable<AlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param gln (optional) 
     * @return Success
     */
    getAlasesForPerson(gln: string | undefined): Observable<AlaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Alas/GetAlasesForPerson?";
        if (gln === null)
            throw new Error("The parameter 'gln' cannot be null.");
        else if (gln !== undefined)
            url_ += "gln=" + encodeURIComponent("" + gln) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAlasesForPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlasesForPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaDto[]>;
        }));
    }

    protected processGetAlasesForPerson(response: HttpResponseBase): Observable<AlaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AlaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getLicenceForAla(caseId: string | undefined): Observable<CorporateLicenceDto> {
        let url_ = this.baseUrl + "/api/services/app/Alas/GetLicenceForAla?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLicenceForAla(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLicenceForAla(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CorporateLicenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CorporateLicenceDto>;
        }));
    }

    protected processGetLicenceForAla(response: HttpResponseBase): Observable<CorporateLicenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CorporateLicenceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getAla(caseId: string | undefined): Observable<GetAlaOutput> {
        let url_ = this.baseUrl + "/api/services/app/Alas/GetAla?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAla(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAla(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAlaOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAlaOutput>;
        }));
    }

    protected processGetAla(response: HttpResponseBase): Observable<GetAlaOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAlaOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param applicantComment (optional) 
     * @return Success
     */
    releaseAlas(caseId: string | undefined, applicantComment: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Alas/ReleaseAlas?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (applicantComment === null)
            throw new Error("The parameter 'applicantComment' cannot be null.");
        else if (applicantComment !== undefined)
            url_ += "applicantComment=" + encodeURIComponent("" + applicantComment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseAlas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseAlas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReleaseAlas(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getEvaluationComments(caseId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Alas/GetEvaluationComments?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvaluationComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvaluationComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetEvaluationComments(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    validateThatAllMandatoryDocumentsHaveBeenUploaded(caseId: string | undefined): Observable<AlaStatus[]> {
        let url_ = this.baseUrl + "/api/services/app/Alas/ValidateThatAllMandatoryDocumentsHaveBeenUploaded?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaStatus[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaStatus[]>;
        }));
    }

    protected processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response: HttpResponseBase): Observable<AlaStatus[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AlaTrustworthinessServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    proceed(caseId: string | undefined): Observable<AlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/AlaTrustworthiness/Proceed?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProceed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProceed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaStatus>;
        }));
    }

    protected processProceed(response: HttpResponseBase): Observable<AlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getAlaTrustworthinessFiles(caseId: string, step: AlaStatus | undefined): Observable<AlaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/AlaTrustworthiness/GetAlaTrustworthinessFiles?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAlaTrustworthinessFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlaTrustworthinessFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlaDocumentsOutput>;
        }));
    }

    protected processGetAlaTrustworthinessFiles(response: HttpResponseBase): Observable<AlaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AlaTrustworthiness/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ApplicationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getApplication(caseId: string | undefined): Observable<ApplicationDto> {
        let url_ = this.baseUrl + "/api/services/app/Application/GetApplication?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationDto>;
        }));
    }

    protected processGetApplication(response: HttpResponseBase): Observable<ApplicationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getResultDocuments(caseId: string | undefined): Observable<GetResultDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Application/GetResultDocuments?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetResultDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetResultDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetResultDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetResultDocumentsOutput>;
        }));
    }

    protected processGetResultDocuments(response: HttpResponseBase): Observable<GetResultDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetResultDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadResultDocument(body: GeneralResultDocumentInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Application/UploadResultDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadResultDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadResultDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadResultDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param docId (optional) 
     * @return Success
     */
    deleteResultDocument(caseId: string | undefined, docId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Application/DeleteResultDocument?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (docId === null)
            throw new Error("The parameter 'docId' cannot be null.");
        else if (docId !== undefined)
            url_ += "docId=" + encodeURIComponent("" + docId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteResultDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteResultDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteResultDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getResultFile(caseId: string, id: number): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Application/GetResultFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetResultFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetResultFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetResultFile(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getApplicationHistoryStatusDocument(caseId: string, id: number): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Application/GetApplicationHistoryStatusDocument?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationHistoryStatusDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationHistoryStatusDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetApplicationHistoryStatusDocument(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getApplicationAuthorityHistoryDocument(caseId: string, id: number): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Application/GetApplicationAuthorityHistoryDocument?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationAuthorityHistoryDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationAuthorityHistoryDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetApplicationAuthorityHistoryDocument(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    assignApplication(body: AssignApplicationInput | undefined): Observable<AssignApplicationOutput> {
        let url_ = this.baseUrl + "/api/services/app/Application/AssignApplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignApplicationOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignApplicationOutput>;
        }));
    }

    protected processAssignApplication(response: HttpResponseBase): Observable<AssignApplicationOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssignApplicationOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    unassignApplication(caseId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Application/UnassignApplication?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnassignApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnassignApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnassignApplication(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    startPreEvaluation(caseId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Application/StartPreEvaluation?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartPreEvaluation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartPreEvaluation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStartPreEvaluation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    reactivateApplication(caseId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Application/ReactivateApplication?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReactivateApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReactivateApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReactivateApplication(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    startEvaluation(caseId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Application/StartEvaluation?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartEvaluation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartEvaluation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStartEvaluation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateEvaluation(body: EvaluationInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Application/UpdateEvaluation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEvaluation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEvaluation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateEvaluation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    requestForSupplementalInformation(body: RequestForSupplementalInformationInput | undefined): Observable<ApplicationDto> {
        let url_ = this.baseUrl + "/api/services/app/Application/RequestForSupplementalInformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestForSupplementalInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestForSupplementalInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationDto>;
        }));
    }

    protected processRequestForSupplementalInformation(response: HttpResponseBase): Observable<ApplicationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setSupplementalInformationReminderDate(body: SetSupplementalInformationReminderDateInput | undefined): Observable<ApplicationDto> {
        let url_ = this.baseUrl + "/api/services/app/Application/SetSupplementalInformationReminderDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetSupplementalInformationReminderDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetSupplementalInformationReminderDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationDto>;
        }));
    }

    protected processSetSupplementalInformationReminderDate(response: HttpResponseBase): Observable<ApplicationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    withdrawApplication(caseId: string | undefined, body: WithdrawApplicationInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Application/WithdrawApplication?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWithdrawApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWithdrawApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processWithdrawApplication(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    deleteApplication(caseId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Application/DeleteApplication?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteApplication(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    setApplicationUnderConstruction(caseId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Application/SetApplicationUnderConstruction?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetApplicationUnderConstruction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetApplicationUnderConstruction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetApplicationUnderConstruction(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param contextLicenceId (optional) 
     * @return Success
     */
    formallyEvaluateApplication(caseId: string | undefined, contextLicenceId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Application/FormallyEvaluateApplication?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (contextLicenceId === null)
            throw new Error("The parameter 'contextLicenceId' cannot be null.");
        else if (contextLicenceId !== undefined)
            url_ += "contextLicenceId=" + encodeURIComponent("" + contextLicenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFormallyEvaluateApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFormallyEvaluateApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFormallyEvaluateApplication(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    acceptApplication(caseId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Application/AcceptApplication?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAcceptApplication(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    rejectApplication(caseId: string | undefined, body: RejectApplicationInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Application/RejectApplication?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRejectApplication(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    notConsiderApplication(caseId: string | undefined, body: NotConsiderApplicationInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Application/NotConsiderApplication?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotConsiderApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotConsiderApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processNotConsiderApplication(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param stepId (optional) 
     * @return Success
     */
    setStepToReview(caseId: string | undefined, stepId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Application/SetStepToReview?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (stepId === null)
            throw new Error("The parameter 'stepId' cannot be null.");
        else if (stepId !== undefined)
            url_ += "stepId=" + encodeURIComponent("" + stepId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetStepToReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetStepToReview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetStepToReview(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getSupplementalClaimAnnexFilesOfStep(caseId: string, applicationWizardStep: number): Observable<GeneralDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Application/GetSupplementalClaimAnnexFilesOfStep?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (applicationWizardStep === undefined || applicationWizardStep === null)
            throw new Error("The parameter 'applicationWizardStep' must be defined and cannot be null.");
        else
            url_ += "ApplicationWizardStep=" + encodeURIComponent("" + applicationWizardStep) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupplementalClaimAnnexFilesOfStep(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupplementalClaimAnnexFilesOfStep(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralDocumentsOutput>;
        }));
    }

    protected processGetSupplementalClaimAnnexFilesOfStep(response: HttpResponseBase): Observable<GeneralDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAuthorityFile(caseId: string, id: number): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Application/GetAuthorityFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuthorityFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuthorityFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetAuthorityFile(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param wizardStep (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadAuthorityFiles(wizardStep: number | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Application/UploadAuthorityFiles?";
        if (wizardStep === null)
            throw new Error("The parameter 'wizardStep' cannot be null.");
        else if (wizardStep !== undefined)
            url_ += "wizardStep=" + encodeURIComponent("" + wizardStep) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadAuthorityFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadAuthorityFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadAuthorityFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    deleteAuthorityFile(id: number, caseId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Application/DeleteAuthorityFile?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAuthorityFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAuthorityFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAuthorityFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    deleteAuthorityFiles(wizardStep: number, caseId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Application/DeleteAuthorityFiles?";
        if (wizardStep === undefined || wizardStep === null)
            throw new Error("The parameter 'wizardStep' must be defined and cannot be null.");
        else
            url_ += "WizardStep=" + encodeURIComponent("" + wizardStep) + "&";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAuthorityFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAuthorityFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAuthorityFiles(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getJournalRecords(caseId: string | undefined): Observable<ApplicationJournalRecordDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Application/GetJournalRecords?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJournalRecords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJournalRecords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationJournalRecordDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationJournalRecordDto[]>;
        }));
    }

    protected processGetJournalRecords(response: HttpResponseBase): Observable<ApplicationJournalRecordDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApplicationJournalRecordDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param wizardStep (optional) 
     * @return Success
     */
    getLatestApplicationJournalRecord(caseId: string | undefined, wizardStep: number | undefined): Observable<ApplicationJournalRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/Application/GetLatestApplicationJournalRecord?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (wizardStep === null)
            throw new Error("The parameter 'wizardStep' cannot be null.");
        else if (wizardStep !== undefined)
            url_ += "WizardStep=" + encodeURIComponent("" + wizardStep) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestApplicationJournalRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestApplicationJournalRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationJournalRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationJournalRecordDto>;
        }));
    }

    protected processGetLatestApplicationJournalRecord(response: HttpResponseBase): Observable<ApplicationJournalRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationJournalRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createJournalRecord(body: CreateApplicationJournalRecordInput | undefined): Observable<ApplicationJournalRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/Application/CreateJournalRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateJournalRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateJournalRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationJournalRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationJournalRecordDto>;
        }));
    }

    protected processCreateJournalRecord(response: HttpResponseBase): Observable<ApplicationJournalRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationJournalRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param recordId (optional) 
     * @return Success
     */
    deleteJournalRecord(caseId: string | undefined, recordId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Application/DeleteJournalRecord?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (recordId === null)
            throw new Error("The parameter 'recordId' cannot be null.");
        else if (recordId !== undefined)
            url_ += "RecordId=" + encodeURIComponent("" + recordId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteJournalRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteJournalRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteJournalRecord(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setApplicationsInSubmitted(body: string[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Application/SetApplicationsInSubmitted";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetApplicationsInSubmitted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetApplicationsInSubmitted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetApplicationsInSubmitted(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    generateGuid(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Application/GenerateGuid";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateGuid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateGuid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGenerateGuid(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ApplicationEmploymentPersonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ApplicationEmploymentPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/ApplicationEmploymentPerson/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationEmploymentPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationEmploymentPersonDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApplicationEmploymentPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationEmploymentPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ApplicationEmploymentPersonDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ApplicationEmploymentPerson/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AssistantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param personId (optional) 
     * @param personalLicenceId (optional) 
     * @param corporateLicenceId (optional) 
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getAssistants(personId: number | undefined, personalLicenceId: number | undefined, corporateLicenceId: number | undefined, filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetAssistantSearchOutput> {
        let url_ = this.baseUrl + "/api/services/app/Assistant/GetAssistants?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "PersonId=" + encodeURIComponent("" + personId) + "&";
        if (personalLicenceId === null)
            throw new Error("The parameter 'personalLicenceId' cannot be null.");
        else if (personalLicenceId !== undefined)
            url_ += "PersonalLicenceId=" + encodeURIComponent("" + personalLicenceId) + "&";
        if (corporateLicenceId === null)
            throw new Error("The parameter 'corporateLicenceId' cannot be null.");
        else if (corporateLicenceId !== undefined)
            url_ += "CorporateLicenceId=" + encodeURIComponent("" + corporateLicenceId) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssistants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssistants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAssistantSearchOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAssistantSearchOutput>;
        }));
    }

    protected processGetAssistants(response: HttpResponseBase): Observable<GetAssistantSearchOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAssistantSearchOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAssistant(id: number | undefined): Observable<AssistantDto> {
        let url_ = this.baseUrl + "/api/services/app/Assistant/GetAssistant?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssistant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssistant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssistantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssistantDto>;
        }));
    }

    protected processGetAssistant(response: HttpResponseBase): Observable<AssistantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssistantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    postAssistant(body: CreateAssistantDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Assistant/PostAssistant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostAssistant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostAssistant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processPostAssistant(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    putAssistant(id: number | undefined, body: AssistantDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Assistant/PutAssistant?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutAssistant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutAssistant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutAssistant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteAssistant(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Assistant/DeleteAssistant?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAssistant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAssistant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAssistant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AuditLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param serviceName (optional) 
     * @param methodName (optional) 
     * @param browserInfo (optional) 
     * @param hasException (optional) 
     * @param minExecutionDuration (optional) 
     * @param maxExecutionDuration (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getAuditLogs(startDate: DateTime | undefined, endDate: DateTime | undefined, userName: string | undefined, serviceName: string | undefined, methodName: string | undefined, browserInfo: string | undefined, hasException: boolean | undefined, minExecutionDuration: number | undefined, maxExecutionDuration: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfAuditLogListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogs?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (userName === null)
            throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (serviceName === null)
            throw new Error("The parameter 'serviceName' cannot be null.");
        else if (serviceName !== undefined)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&";
        if (methodName === null)
            throw new Error("The parameter 'methodName' cannot be null.");
        else if (methodName !== undefined)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&";
        if (browserInfo === null)
            throw new Error("The parameter 'browserInfo' cannot be null.");
        else if (browserInfo !== undefined)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&";
        if (hasException === null)
            throw new Error("The parameter 'hasException' cannot be null.");
        else if (hasException !== undefined)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&";
        if (minExecutionDuration === null)
            throw new Error("The parameter 'minExecutionDuration' cannot be null.");
        else if (minExecutionDuration !== undefined)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&";
        if (maxExecutionDuration === null)
            throw new Error("The parameter 'maxExecutionDuration' cannot be null.");
        else if (maxExecutionDuration !== undefined)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuditLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuditLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfAuditLogListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfAuditLogListDto>;
        }));
    }

    protected processGetAuditLogs(response: HttpResponseBase): Observable<PagedResultDtoOfAuditLogListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAuditLogListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param serviceName (optional) 
     * @param methodName (optional) 
     * @param browserInfo (optional) 
     * @param hasException (optional) 
     * @param minExecutionDuration (optional) 
     * @param maxExecutionDuration (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getAuditLogsToExcel(startDate: DateTime | undefined, endDate: DateTime | undefined, userName: string | undefined, serviceName: string | undefined, methodName: string | undefined, browserInfo: string | undefined, hasException: boolean | undefined, minExecutionDuration: number | undefined, maxExecutionDuration: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogsToExcel?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (userName === null)
            throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (serviceName === null)
            throw new Error("The parameter 'serviceName' cannot be null.");
        else if (serviceName !== undefined)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&";
        if (methodName === null)
            throw new Error("The parameter 'methodName' cannot be null.");
        else if (methodName !== undefined)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&";
        if (browserInfo === null)
            throw new Error("The parameter 'browserInfo' cannot be null.");
        else if (browserInfo !== undefined)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&";
        if (hasException === null)
            throw new Error("The parameter 'hasException' cannot be null.");
        else if (hasException !== undefined)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&";
        if (minExecutionDuration === null)
            throw new Error("The parameter 'minExecutionDuration' cannot be null.");
        else if (minExecutionDuration !== undefined)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&";
        if (maxExecutionDuration === null)
            throw new Error("The parameter 'maxExecutionDuration' cannot be null.");
        else if (maxExecutionDuration !== undefined)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuditLogsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuditLogsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetAuditLogsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEntityHistoryObjectTypes(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityHistoryObjectTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityHistoryObjectTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityHistoryObjectTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetEntityHistoryObjectTypes(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param entityTypeFullName (optional) 
     * @param entityId (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getEntityChanges(startDate: DateTime | undefined, endDate: DateTime | undefined, userName: string | undefined, entityTypeFullName: string | undefined, entityId: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfEntityChangeListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityChanges?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (userName === null)
            throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (entityTypeFullName === null)
            throw new Error("The parameter 'entityTypeFullName' cannot be null.");
        else if (entityTypeFullName !== undefined)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfEntityChangeListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfEntityChangeListDto>;
        }));
    }

    protected processGetEntityChanges(response: HttpResponseBase): Observable<PagedResultDtoOfEntityChangeListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfEntityChangeListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param entityTypeFullName (optional) 
     * @param entityId (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getEntityTypeChanges(entityTypeFullName: string | undefined, entityId: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfEntityChangeListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityTypeChanges?";
        if (entityTypeFullName === null)
            throw new Error("The parameter 'entityTypeFullName' cannot be null.");
        else if (entityTypeFullName !== undefined)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityTypeChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityTypeChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfEntityChangeListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfEntityChangeListDto>;
        }));
    }

    protected processGetEntityTypeChanges(response: HttpResponseBase): Observable<PagedResultDtoOfEntityChangeListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfEntityChangeListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param entityTypeFullName (optional) 
     * @param entityId (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getEntityChangesToExcel(startDate: DateTime | undefined, endDate: DateTime | undefined, userName: string | undefined, entityTypeFullName: string | undefined, entityId: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityChangesToExcel?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (userName === null)
            throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (entityTypeFullName === null)
            throw new Error("The parameter 'entityTypeFullName' cannot be null.");
        else if (entityTypeFullName !== undefined)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityChangesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityChangesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetEntityChangesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param entityChangeId (optional) 
     * @return Success
     */
    getEntityPropertyChanges(entityChangeId: number | undefined): Observable<EntityPropertyChangeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityPropertyChanges?";
        if (entityChangeId === null)
            throw new Error("The parameter 'entityChangeId' cannot be null.");
        else if (entityChangeId !== undefined)
            url_ += "entityChangeId=" + encodeURIComponent("" + entityChangeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityPropertyChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityPropertyChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityPropertyChangeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityPropertyChangeDto[]>;
        }));
    }

    protected processGetEntityPropertyChanges(response: HttpResponseBase): Observable<EntityPropertyChangeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntityPropertyChangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param entityTypeFullName (optional) 
     * @param entityId (optional) 
     * @return Success
     */
    getDeleteReason(entityTypeFullName: string | undefined, entityId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetDeleteReason?";
        if (entityTypeFullName === null)
            throw new Error("The parameter 'entityTypeFullName' cannot be null.");
        else if (entityTypeFullName !== undefined)
            url_ += "entityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeleteReason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeleteReason(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetDeleteReason(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BusinessServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param isArchived (optional) 
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getBusinesses(isArchived: boolean | undefined, filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetBusinessesOutput> {
        let url_ = this.baseUrl + "/api/services/app/Business/GetBusinesses?";
        if (isArchived === null)
            throw new Error("The parameter 'isArchived' cannot be null.");
        else if (isArchived !== undefined)
            url_ += "IsArchived=" + encodeURIComponent("" + isArchived) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBusinesses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBusinesses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBusinessesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBusinessesOutput>;
        }));
    }

    protected processGetBusinesses(response: HttpResponseBase): Observable<GetBusinessesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBusinessesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchBusinessesForSponsorship(body: BusinessSearchInput | undefined): Observable<BusinessSearchOutput> {
        let url_ = this.baseUrl + "/api/services/app/Business/SearchBusinessesForSponsorship";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchBusinessesForSponsorship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchBusinessesForSponsorship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessSearchOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessSearchOutput>;
        }));
    }

    protected processSearchBusinessesForSponsorship(response: HttpResponseBase): Observable<BusinessSearchOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BusinessSearchOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    formSearch(body: BusinessFormSearchInput | undefined): Observable<BusinessFormSearchOutput> {
        let url_ = this.baseUrl + "/api/services/app/Business/FormSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFormSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFormSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessFormSearchOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessFormSearchOutput>;
        }));
    }

    protected processFormSearch(response: HttpResponseBase): Observable<BusinessFormSearchOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BusinessFormSearchOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sponsorshipId (optional) 
     * @return Success
     */
    getBusinessesForSponsorship(sponsorshipId: number | undefined): Observable<BusinessDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Business/GetBusinessesForSponsorship?";
        if (sponsorshipId === null)
            throw new Error("The parameter 'sponsorshipId' cannot be null.");
        else if (sponsorshipId !== undefined)
            url_ += "sponsorshipId=" + encodeURIComponent("" + sponsorshipId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBusinessesForSponsorship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBusinessesForSponsorship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessDto[]>;
        }));
    }

    protected processGetBusinessesForSponsorship(response: HttpResponseBase): Observable<BusinessDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BusinessDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param corporateLicenceId (optional) 
     * @return Success
     */
    getBusinessesForCorporateLicence(corporateLicenceId: number | undefined): Observable<BusinessDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Business/GetBusinessesForCorporateLicence?";
        if (corporateLicenceId === null)
            throw new Error("The parameter 'corporateLicenceId' cannot be null.");
        else if (corporateLicenceId !== undefined)
            url_ += "corporateLicenceId=" + encodeURIComponent("" + corporateLicenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBusinessesForCorporateLicence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBusinessesForCorporateLicence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessDto[]>;
        }));
    }

    protected processGetBusinessesForCorporateLicence(response: HttpResponseBase): Observable<BusinessDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BusinessDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    createBlankBusiness(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Business/CreateBlankBusiness";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBlankBusiness(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBlankBusiness(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateBlankBusiness(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateNursingInstitution(body: CreateOrUpdateBusinessNursingInstitutionInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Business/CreateOrUpdateNursingInstitution";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateNursingInstitution(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateNursingInstitution(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateNursingInstitution(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateBusiness(body: UpdateBusinessInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Business/UpdateBusiness";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBusiness(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBusiness(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateBusiness(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param isArchived (optional) 
     * @return Success
     */
    setArchiveFlag(id: number | undefined, isArchived: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Business/SetArchiveFlag?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (isArchived === null)
            throw new Error("The parameter 'isArchived' cannot be null.");
        else if (isArchived !== undefined)
            url_ += "isArchived=" + encodeURIComponent("" + isArchived) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetArchiveFlag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetArchiveFlag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetArchiveFlag(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param businessId (optional) 
     * @return Success
     */
    getBusinessById(businessId: number | undefined): Observable<BusinessDto> {
        let url_ = this.baseUrl + "/api/services/app/Business/GetBusinessById?";
        if (businessId === null)
            throw new Error("The parameter 'businessId' cannot be null.");
        else if (businessId !== undefined)
            url_ += "businessId=" + encodeURIComponent("" + businessId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBusinessById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBusinessById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessDto>;
        }));
    }

    protected processGetBusinessById(response: HttpResponseBase): Observable<BusinessDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BusinessDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createBusiness(body: CreateBusinessDto | undefined): Observable<BusinessDto> {
        let url_ = this.baseUrl + "/api/services/app/Business/CreateBusiness";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBusiness(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBusiness(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessDto>;
        }));
    }

    protected processCreateBusiness(response: HttpResponseBase): Observable<BusinessDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BusinessDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sponsorshipId (optional) 
     * @param employmentAddressId (optional) 
     * @return Success
     */
    createBusinessFromEmploymentAddress(sponsorshipId: number | undefined, employmentAddressId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Business/CreateBusinessFromEmploymentAddress?";
        if (sponsorshipId === null)
            throw new Error("The parameter 'sponsorshipId' cannot be null.");
        else if (sponsorshipId !== undefined)
            url_ += "sponsorshipId=" + encodeURIComponent("" + sponsorshipId) + "&";
        if (employmentAddressId === null)
            throw new Error("The parameter 'employmentAddressId' cannot be null.");
        else if (employmentAddressId !== undefined)
            url_ += "employmentAddressId=" + encodeURIComponent("" + employmentAddressId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBusinessFromEmploymentAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBusinessFromEmploymentAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateBusinessFromEmploymentAddress(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param employmentAddressId (optional) 
     * @param businessId (optional) 
     * @return Success
     */
    replaceEmploymentAddressWithBusiness(employmentAddressId: number | undefined, businessId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Business/ReplaceEmploymentAddressWithBusiness?";
        if (employmentAddressId === null)
            throw new Error("The parameter 'employmentAddressId' cannot be null.");
        else if (employmentAddressId !== undefined)
            url_ += "employmentAddressId=" + encodeURIComponent("" + employmentAddressId) + "&";
        if (businessId === null)
            throw new Error("The parameter 'businessId' cannot be null.");
        else if (businessId !== undefined)
            url_ += "businessId=" + encodeURIComponent("" + businessId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReplaceEmploymentAddressWithBusiness(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReplaceEmploymentAddressWithBusiness(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReplaceEmploymentAddressWithBusiness(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param reason (optional) 
     * @return Success
     */
    deleteBusiness(id: number | undefined, reason: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Business/DeleteBusiness?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (reason === null)
            throw new Error("The parameter 'reason' cannot be null.");
        else if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBusiness(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBusiness(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteBusiness(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deassignBusinessFromSponsorship(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Business/DeassignBusinessFromSponsorship?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeassignBusinessFromSponsorship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeassignBusinessFromSponsorship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeassignBusinessFromSponsorship(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAndLinkBusiness(body: CreateAndLinkBusinessInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Business/CreateAndLinkBusiness";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAndLinkBusiness(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAndLinkBusiness(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateAndLinkBusiness(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAndLinkBusinessToExpenseHealthCarePersonalLicenceEmployment(body: CreateAndLinkBusinessInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Business/CreateAndLinkBusinessToExpenseHealthCarePersonalLicenceEmployment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAndLinkBusinessToExpenseHealthCarePersonalLicenceEmployment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAndLinkBusinessToExpenseHealthCarePersonalLicenceEmployment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateAndLinkBusinessToExpenseHealthCarePersonalLicenceEmployment(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param businessId (optional) 
     * @param sponsorshipId (optional) 
     * @param employmentAddressToReplaceId (optional) 
     * @return Success
     */
    linkBusinessToSponsorship(businessId: number | undefined, sponsorshipId: number | undefined, employmentAddressToReplaceId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Business/LinkBusinessToSponsorship?";
        if (businessId === null)
            throw new Error("The parameter 'businessId' cannot be null.");
        else if (businessId !== undefined)
            url_ += "businessId=" + encodeURIComponent("" + businessId) + "&";
        if (sponsorshipId === null)
            throw new Error("The parameter 'sponsorshipId' cannot be null.");
        else if (sponsorshipId !== undefined)
            url_ += "sponsorshipId=" + encodeURIComponent("" + sponsorshipId) + "&";
        if (employmentAddressToReplaceId === null)
            throw new Error("The parameter 'employmentAddressToReplaceId' cannot be null.");
        else if (employmentAddressToReplaceId !== undefined)
            url_ += "employmentAddressToReplaceId=" + encodeURIComponent("" + employmentAddressToReplaceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkBusinessToSponsorship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkBusinessToSponsorship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLinkBusinessToSponsorship(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param newBusinessId (optional) 
     * @param sponsorshipId (optional) 
     * @param businessToDeleteId (optional) 
     * @return Success
     */
    replaceBusiness(newBusinessId: number | undefined, sponsorshipId: number | undefined, businessToDeleteId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Business/ReplaceBusiness?";
        if (newBusinessId === null)
            throw new Error("The parameter 'newBusinessId' cannot be null.");
        else if (newBusinessId !== undefined)
            url_ += "newBusinessId=" + encodeURIComponent("" + newBusinessId) + "&";
        if (sponsorshipId === null)
            throw new Error("The parameter 'sponsorshipId' cannot be null.");
        else if (sponsorshipId !== undefined)
            url_ += "sponsorshipId=" + encodeURIComponent("" + sponsorshipId) + "&";
        if (businessToDeleteId === null)
            throw new Error("The parameter 'businessToDeleteId' cannot be null.");
        else if (businessToDeleteId !== undefined)
            url_ += "businessToDeleteId=" + encodeURIComponent("" + businessToDeleteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReplaceBusiness(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReplaceBusiness(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReplaceBusiness(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param businessId (optional) 
     * @return Success
     */
    makeBusinessDefinite(businessId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Business/MakeBusinessDefinite?";
        if (businessId === null)
            throw new Error("The parameter 'businessId' cannot be null.");
        else if (businessId !== undefined)
            url_ += "businessId=" + encodeURIComponent("" + businessId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMakeBusinessDefinite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMakeBusinessDefinite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMakeBusinessDefinite(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CachingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getAllCaches(): Observable<ListResultDtoOfCacheDto> {
        let url_ = this.baseUrl + "/api/services/app/Caching/GetAllCaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCaches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCaches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfCacheDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfCacheDto>;
        }));
    }

    protected processGetAllCaches(response: HttpResponseBase): Observable<ListResultDtoOfCacheDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfCacheDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    clearCache(body: EntityDtoOfString | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Caching/ClearCache";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearCache(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearCache(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    clearAllCaches(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Caching/ClearAllCaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearAllCaches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearAllCaches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearAllCaches(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ChatServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getUserChatFriendsWithSettings(): Observable<GetUserChatFriendsWithSettingsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Chat/GetUserChatFriendsWithSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserChatFriendsWithSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserChatFriendsWithSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserChatFriendsWithSettingsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserChatFriendsWithSettingsOutput>;
        }));
    }

    protected processGetUserChatFriendsWithSettings(response: HttpResponseBase): Observable<GetUserChatFriendsWithSettingsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserChatFriendsWithSettingsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) The field UserId must be between 1 and 9.223372036854776E+18.
     * @param minMessageId (optional) 
     * @return Success
     */
    getUserChatMessages(tenantId: number | undefined, userId: number | undefined, minMessageId: number | undefined): Observable<ListResultDtoOfChatMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Chat/GetUserChatMessages?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (minMessageId === null)
            throw new Error("The parameter 'minMessageId' cannot be null.");
        else if (minMessageId !== undefined)
            url_ += "MinMessageId=" + encodeURIComponent("" + minMessageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserChatMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserChatMessages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfChatMessageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfChatMessageDto>;
        }));
    }

    protected processGetUserChatMessages(response: HttpResponseBase): Observable<ListResultDtoOfChatMessageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfChatMessageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    markAllUnreadMessagesOfUserAsRead(body: MarkAllUnreadMessagesOfUserAsReadInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Chat/MarkAllUnreadMessagesOfUserAsRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAllUnreadMessagesOfUserAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAllUnreadMessagesOfUserAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarkAllUnreadMessagesOfUserAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCla(body: CreateClaInput | undefined): Observable<CreateClaOutput> {
        let url_ = this.baseUrl + "/api/services/app/Cla/CreateCla";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCla(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCla(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateClaOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateClaOutput>;
        }));
    }

    protected processCreateCla(response: HttpResponseBase): Observable<CreateClaOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateClaOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMyClas(): Observable<ClaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Cla/GetMyClas";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyClas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyClas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaDto[]>;
        }));
    }

    protected processGetMyClas(response: HttpResponseBase): Observable<ClaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getNextStatus(caseId: string, status: ClaStatus): Observable<ClaStatus> {
        let url_ = this.baseUrl + "/api/services/app/Cla/GetNextStatus?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined and cannot be null.");
        else
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaStatus>;
        }));
    }

    protected processGetNextStatus(response: HttpResponseBase): Observable<ClaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getClasForSponsorship(uid: string): Observable<ClaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Cla/GetClasForSponsorship?";
        if (uid === undefined || uid === null)
            throw new Error("The parameter 'uid' must be defined and cannot be null.");
        else
            url_ += "uid=" + encodeURIComponent("" + uid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClasForSponsorship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClasForSponsorship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaDto[]>;
        }));
    }

    protected processGetClasForSponsorship(response: HttpResponseBase): Observable<ClaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getCorporateLicenceForCla(caseId: string | undefined): Observable<GetClaCorporateLicenceDto> {
        let url_ = this.baseUrl + "/api/services/app/Cla/GetCorporateLicenceForCla?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCorporateLicenceForCla(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCorporateLicenceForCla(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetClaCorporateLicenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetClaCorporateLicenceDto>;
        }));
    }

    protected processGetCorporateLicenceForCla(response: HttpResponseBase): Observable<GetClaCorporateLicenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetClaCorporateLicenceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getCla(caseId: string | undefined): Observable<GetClaOutput> {
        let url_ = this.baseUrl + "/api/services/app/Cla/GetCla?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCla(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCla(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetClaOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetClaOutput>;
        }));
    }

    protected processGetCla(response: HttpResponseBase): Observable<GetClaOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetClaOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param applicantComment (optional) 
     * @return Success
     */
    releaseCla(caseId: string | undefined, applicantComment: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Cla/ReleaseCla?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (applicantComment === null)
            throw new Error("The parameter 'applicantComment' cannot be null.");
        else if (applicantComment !== undefined)
            url_ += "applicantComment=" + encodeURIComponent("" + applicantComment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseCla(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseCla(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReleaseCla(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getEvaluationComments(caseId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Cla/GetEvaluationComments?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvaluationComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvaluationComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetEvaluationComments(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    validateThatAllMandatoryDocumentsHaveBeenUploaded(caseId: string | undefined): Observable<ClaStatus[]> {
        let url_ = this.baseUrl + "/api/services/app/Cla/ValidateThatAllMandatoryDocumentsHaveBeenUploaded?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaStatus[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaStatus[]>;
        }));
    }

    protected processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response: HttpResponseBase): Observable<ClaStatus[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaAidingResourcesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param aidingResourcesId (optional) 
     * @return Success
     */
    createPlaceholderAidingResources(caseId: string | undefined, aidingResourcesId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ClaAidingResources/CreatePlaceholderAidingResources?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (aidingResourcesId === null)
            throw new Error("The parameter 'aidingResourcesId' cannot be null.");
        else if (aidingResourcesId !== undefined)
            url_ += "AidingResourcesId=" + encodeURIComponent("" + aidingResourcesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderAidingResources(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderAidingResources(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderAidingResources(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAidingResourcesList(body: UpdateClaAidingResourcesInput | undefined): Observable<UpdateClaAidingResourcesOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaAidingResources/UpdateAidingResourcesList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAidingResourcesList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAidingResourcesList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaAidingResourcesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaAidingResourcesOutput>;
        }));
    }

    protected processUpdateAidingResourcesList(response: HttpResponseBase): Observable<UpdateClaAidingResourcesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaAidingResourcesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaAssistantPhysicianServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    createPlaceholderAssistantPhysician(caseId: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ClaAssistantPhysician/CreatePlaceholderAssistantPhysician?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderAssistantPhysician(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderAssistantPhysician(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderAssistantPhysician(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAssistantPhysicians(body: UpdateClaAssistantPhysiciansInput | undefined): Observable<UpdateClaAssistantPhysiciansOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaAssistantPhysician/UpdateAssistantPhysicians";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAssistantPhysicians(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAssistantPhysicians(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaAssistantPhysiciansOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaAssistantPhysiciansOutput>;
        }));
    }

    protected processUpdateAssistantPhysicians(response: HttpResponseBase): Observable<UpdateClaAssistantPhysiciansOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaAssistantPhysiciansOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaBusinessServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    createPlaceholderBusiness(caseId: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ClaBusiness/CreatePlaceholderBusiness?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderBusiness(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderBusiness(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderBusiness(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateBusinesses(body: UpdateClaBusinessesInput | undefined): Observable<UpdateClaBusinessesOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaBusiness/UpdateBusinesses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBusinesses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBusinesses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaBusinessesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaBusinessesOutput>;
        }));
    }

    protected processUpdateBusinesses(response: HttpResponseBase): Observable<UpdateClaBusinessesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaBusinessesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param businessId (optional) 
     * @return Success
     */
    createPlaceholderBusinessDirector(caseId: string | undefined, businessId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ClaBusiness/CreatePlaceholderBusinessDirector?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (businessId === null)
            throw new Error("The parameter 'businessId' cannot be null.");
        else if (businessId !== undefined)
            url_ += "businessId=" + encodeURIComponent("" + businessId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderBusinessDirector(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderBusinessDirector(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderBusinessDirector(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateBusinessDirectors(body: UpdateClaBusinessDirectorsInput | undefined): Observable<UpdateClaBusinessDirectorsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaBusiness/UpdateBusinessDirectors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBusinessDirectors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBusinessDirectors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaBusinessDirectorsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaBusinessDirectorsOutput>;
        }));
    }

    protected processUpdateBusinessDirectors(response: HttpResponseBase): Observable<UpdateClaBusinessDirectorsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaBusinessDirectorsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaDocumentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getDocuments(body: GetClaDocumentsInput | undefined): Observable<ClaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/GetDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaDocumentsOutput>;
        }));
    }

    protected processGetDocuments(response: HttpResponseBase): Observable<ClaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getSponsorshipDirectorFiles(body: GetClaSubItemDocumentsInput | undefined): Observable<ClaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/GetSponsorshipDirectorFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSponsorshipDirectorFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSponsorshipDirectorFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaDocumentsOutput>;
        }));
    }

    protected processGetSponsorshipDirectorFiles(response: HttpResponseBase): Observable<ClaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMedicalFieldDirectorDocuments(body: GetClaDocumentsInput | undefined): Observable<ClaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/GetMedicalFieldDirectorDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicalFieldDirectorDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicalFieldDirectorDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaDocumentsOutput>;
        }));
    }

    protected processGetMedicalFieldDirectorDocuments(response: HttpResponseBase): Observable<ClaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMedicalFieldDirectorRepresentativeDocuments(body: GetClaDocumentsInput | undefined): Observable<ClaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/GetMedicalFieldDirectorRepresentativeDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicalFieldDirectorRepresentativeDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicalFieldDirectorRepresentativeDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaDocumentsOutput>;
        }));
    }

    protected processGetMedicalFieldDirectorRepresentativeDocuments(response: HttpResponseBase): Observable<ClaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getBusinessFiles(body: GetClaSubItemDocumentsInput | undefined): Observable<ClaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/GetBusinessFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBusinessFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBusinessFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaDocumentsOutput>;
        }));
    }

    protected processGetBusinessFiles(response: HttpResponseBase): Observable<ClaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getBusinessDirectorFiles(body: GetClaSubItemDocumentsInput | undefined): Observable<ClaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/GetBusinessDirectorFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBusinessDirectorFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBusinessDirectorFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaDocumentsOutput>;
        }));
    }

    protected processGetBusinessDirectorFiles(response: HttpResponseBase): Observable<ClaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getRangeOfServicesFiles(body: GetClaSubItemDocumentsInput | undefined): Observable<ClaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/GetRangeOfServicesFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRangeOfServicesFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRangeOfServicesFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaDocumentsOutput>;
        }));
    }

    protected processGetRangeOfServicesFiles(response: HttpResponseBase): Observable<ClaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPersonelFiles(body: GetClaSubItemDocumentsInput | undefined): Observable<ClaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/GetPersonelFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonelFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonelFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaDocumentsOutput>;
        }));
    }

    protected processGetPersonelFiles(response: HttpResponseBase): Observable<ClaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getInfrastructureFiles(body: GetClaSubItemDocumentsInput | undefined): Observable<ClaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/GetInfrastructureFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInfrastructureFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInfrastructureFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaDocumentsOutput>;
        }));
    }

    protected processGetInfrastructureFiles(response: HttpResponseBase): Observable<ClaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getSecurityFiles(body: GetClaSubItemDocumentsInput | undefined): Observable<ClaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/GetSecurityFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSecurityFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSecurityFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaDocumentsOutput>;
        }));
    }

    protected processGetSecurityFiles(response: HttpResponseBase): Observable<ClaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMedicalFieldPersonFiles(body: GetClaSubItemDocumentsInput | undefined): Observable<ClaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/GetMedicalFieldPersonFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMedicalFieldPersonFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMedicalFieldPersonFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaDocumentsOutput>;
        }));
    }

    protected processGetMedicalFieldPersonFiles(response: HttpResponseBase): Observable<ClaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAssistantPhysicianFiles(body: GetClaSubItemDocumentsInput | undefined): Observable<ClaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/GetAssistantPhysicianFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssistantPhysicianFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssistantPhysicianFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaDocumentsOutput>;
        }));
    }

    protected processGetAssistantPhysicianFiles(response: HttpResponseBase): Observable<ClaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getRangeOfProductsFiles(body: GetClaSubItemDocumentsInput | undefined): Observable<ClaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/GetRangeOfProductsFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRangeOfProductsFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRangeOfProductsFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaDocumentsOutput>;
        }));
    }

    protected processGetRangeOfProductsFiles(response: HttpResponseBase): Observable<ClaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getDrugProductionFiles(body: GetClaSubItemDocumentsInput | undefined): Observable<ClaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/GetDrugProductionFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDrugProductionFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDrugProductionFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaDocumentsOutput>;
        }));
    }

    protected processGetDrugProductionFiles(response: HttpResponseBase): Observable<ClaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getOnlineDrugSalesFiles(body: GetClaSubItemDocumentsInput | undefined): Observable<ClaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/GetOnlineDrugSalesFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOnlineDrugSalesFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOnlineDrugSalesFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaDocumentsOutput>;
        }));
    }

    protected processGetOnlineDrugSalesFiles(response: HttpResponseBase): Observable<ClaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param directorId (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadSponsorshipDirectorFiles(directorId: number | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/UploadSponsorshipDirectorFiles?";
        if (directorId === null)
            throw new Error("The parameter 'directorId' cannot be null.");
        else if (directorId !== undefined)
            url_ += "directorId=" + encodeURIComponent("" + directorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadSponsorshipDirectorFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadSponsorshipDirectorFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadSponsorshipDirectorFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadMedicalFieldDirectorFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/UploadMedicalFieldDirectorFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadMedicalFieldDirectorFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadMedicalFieldDirectorFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadMedicalFieldDirectorFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadMedicalFieldDirectorRepresentativeFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/UploadMedicalFieldDirectorRepresentativeFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadMedicalFieldDirectorRepresentativeFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadMedicalFieldDirectorRepresentativeFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadMedicalFieldDirectorRepresentativeFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param businessId (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadBusinessFiles(businessId: number | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/UploadBusinessFiles?";
        if (businessId === null)
            throw new Error("The parameter 'businessId' cannot be null.");
        else if (businessId !== undefined)
            url_ += "businessId=" + encodeURIComponent("" + businessId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadBusinessFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadBusinessFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadBusinessFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param directorId (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadBusinessDirectorFiles(directorId: number | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/UploadBusinessDirectorFiles?";
        if (directorId === null)
            throw new Error("The parameter 'directorId' cannot be null.");
        else if (directorId !== undefined)
            url_ += "directorId=" + encodeURIComponent("" + directorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadBusinessDirectorFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadBusinessDirectorFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadBusinessDirectorFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param rangeOfServicesId (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadRangeOfServicesFiles(rangeOfServicesId: number | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/UploadRangeOfServicesFiles?";
        if (rangeOfServicesId === null)
            throw new Error("The parameter 'rangeOfServicesId' cannot be null.");
        else if (rangeOfServicesId !== undefined)
            url_ += "rangeOfServicesId=" + encodeURIComponent("" + rangeOfServicesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadRangeOfServicesFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadRangeOfServicesFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadRangeOfServicesFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personelId (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadPersonelFiles(personelId: number | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/UploadPersonelFiles?";
        if (personelId === null)
            throw new Error("The parameter 'personelId' cannot be null.");
        else if (personelId !== undefined)
            url_ += "personelId=" + encodeURIComponent("" + personelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadPersonelFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadPersonelFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadPersonelFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param infrastructureId (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadInfrastructureFiles(infrastructureId: number | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/UploadInfrastructureFiles?";
        if (infrastructureId === null)
            throw new Error("The parameter 'infrastructureId' cannot be null.");
        else if (infrastructureId !== undefined)
            url_ += "infrastructureId=" + encodeURIComponent("" + infrastructureId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadInfrastructureFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadInfrastructureFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadInfrastructureFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param securityId (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadSecurityFiles(securityId: number | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/UploadSecurityFiles?";
        if (securityId === null)
            throw new Error("The parameter 'securityId' cannot be null.");
        else if (securityId !== undefined)
            url_ += "securityId=" + encodeURIComponent("" + securityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadSecurityFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadSecurityFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadSecurityFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param medicalFieldPersonId (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadMedicalFieldPersonFiles(medicalFieldPersonId: number | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/UploadMedicalFieldPersonFiles?";
        if (medicalFieldPersonId === null)
            throw new Error("The parameter 'medicalFieldPersonId' cannot be null.");
        else if (medicalFieldPersonId !== undefined)
            url_ += "medicalFieldPersonId=" + encodeURIComponent("" + medicalFieldPersonId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadMedicalFieldPersonFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadMedicalFieldPersonFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadMedicalFieldPersonFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param assistantPhysicianId (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadAssistantPhysicianFiles(assistantPhysicianId: number | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/UploadAssistantPhysicianFiles?";
        if (assistantPhysicianId === null)
            throw new Error("The parameter 'assistantPhysicianId' cannot be null.");
        else if (assistantPhysicianId !== undefined)
            url_ += "assistantPhysicianId=" + encodeURIComponent("" + assistantPhysicianId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadAssistantPhysicianFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadAssistantPhysicianFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadAssistantPhysicianFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param rangeOfProductsId (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadRangeOfProductsFiles(rangeOfProductsId: number | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/UploadRangeOfProductsFiles?";
        if (rangeOfProductsId === null)
            throw new Error("The parameter 'rangeOfProductsId' cannot be null.");
        else if (rangeOfProductsId !== undefined)
            url_ += "rangeOfProductsId=" + encodeURIComponent("" + rangeOfProductsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadRangeOfProductsFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadRangeOfProductsFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadRangeOfProductsFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param drugProductionId (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadDrugProductionFiles(drugProductionId: number | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/UploadDrugProductionFiles?";
        if (drugProductionId === null)
            throw new Error("The parameter 'drugProductionId' cannot be null.");
        else if (drugProductionId !== undefined)
            url_ += "drugProductionId=" + encodeURIComponent("" + drugProductionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadDrugProductionFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadDrugProductionFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadDrugProductionFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param businessId (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadOnlineDrugSalesFiles(businessId: number | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/UploadOnlineDrugSalesFiles?";
        if (businessId === null)
            throw new Error("The parameter 'businessId' cannot be null.");
        else if (businessId !== undefined)
            url_ += "businessId=" + encodeURIComponent("" + businessId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadOnlineDrugSalesFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadOnlineDrugSalesFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadOnlineDrugSalesFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getFile(body: GetClaFileInput | undefined): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/GetFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    deleteFile(caseId: string, step: ClaStatus | undefined, id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ClaDocument/DeleteFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaDrugChambersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param drugChambersId (optional) 
     * @return Success
     */
    createPlaceholderDrugChambers(caseId: string | undefined, drugChambersId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ClaDrugChambers/CreatePlaceholderDrugChambers?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (drugChambersId === null)
            throw new Error("The parameter 'drugChambersId' cannot be null.");
        else if (drugChambersId !== undefined)
            url_ += "DrugChambersId=" + encodeURIComponent("" + drugChambersId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderDrugChambers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderDrugChambers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderDrugChambers(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDrugChambersList(body: UpdateClaDrugChambersInput | undefined): Observable<UpdateClaDrugChambersOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaDrugChambers/UpdateDrugChambersList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDrugChambersList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDrugChambersList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaDrugChambersOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaDrugChambersOutput>;
        }));
    }

    protected processUpdateDrugChambersList(response: HttpResponseBase): Observable<UpdateClaDrugChambersOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaDrugChambersOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaFloorsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param nursingBedsId (optional) 
     * @return Success
     */
    createPlaceholderFloors(caseId: string | undefined, nursingBedsId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ClaFloors/CreatePlaceholderFloors?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (nursingBedsId === null)
            throw new Error("The parameter 'nursingBedsId' cannot be null.");
        else if (nursingBedsId !== undefined)
            url_ += "NursingBedsId=" + encodeURIComponent("" + nursingBedsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderFloors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderFloors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderFloors(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateFloorsList(body: UpdateClaFloorsInput | undefined): Observable<UpdateClaFloorsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaFloors/UpdateFloorsList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFloorsList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFloorsList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaFloorsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaFloorsOutput>;
        }));
    }

    protected processUpdateFloorsList(response: HttpResponseBase): Observable<UpdateClaFloorsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaFloorsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaInfrastructureServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param infrastructureId (optional) 
     * @return Success
     */
    createPlaceholderInfrastructure(caseId: string | undefined, infrastructureId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ClaInfrastructure/CreatePlaceholderInfrastructure?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (infrastructureId === null)
            throw new Error("The parameter 'infrastructureId' cannot be null.");
        else if (infrastructureId !== undefined)
            url_ += "infrastructureId=" + encodeURIComponent("" + infrastructureId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderInfrastructure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderInfrastructure(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderInfrastructure(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateInfrastructureList(body: UpdateClaInfrastructureInput | undefined): Observable<UpdateClaInfrastructureOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaInfrastructure/UpdateInfrastructureList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateInfrastructureList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInfrastructureList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaInfrastructureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaInfrastructureOutput>;
        }));
    }

    protected processUpdateInfrastructureList(response: HttpResponseBase): Observable<UpdateClaInfrastructureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaInfrastructureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaInvoiceAddressServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateClaInvoiceAddress(body: CreateOrUpdateClaInvoiceAddressInput | undefined): Observable<ClaStatus> {
        let url_ = this.baseUrl + "/api/services/app/ClaInvoiceAddress/CreateOrUpdateClaInvoiceAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateClaInvoiceAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateClaInvoiceAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaStatus>;
        }));
    }

    protected processCreateOrUpdateClaInvoiceAddress(response: HttpResponseBase): Observable<ClaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaMedicalFieldDirectorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    createPlaceholderMedicalFieldDirector(caseId: string | undefined): Observable<ClaMedicalFieldDirectorDto> {
        let url_ = this.baseUrl + "/api/services/app/ClaMedicalFieldDirector/CreatePlaceholderMedicalFieldDirector?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderMedicalFieldDirector(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderMedicalFieldDirector(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaMedicalFieldDirectorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaMedicalFieldDirectorDto>;
        }));
    }

    protected processCreatePlaceholderMedicalFieldDirector(response: HttpResponseBase): Observable<ClaMedicalFieldDirectorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaMedicalFieldDirectorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMedicalFieldDirector(body: UpdateClaMedicalFieldDirectorInput | undefined): Observable<UpdateClaMedicalFieldDirectorOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaMedicalFieldDirector/UpdateMedicalFieldDirector";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMedicalFieldDirector(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMedicalFieldDirector(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaMedicalFieldDirectorOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaMedicalFieldDirectorOutput>;
        }));
    }

    protected processUpdateMedicalFieldDirector(response: HttpResponseBase): Observable<UpdateClaMedicalFieldDirectorOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaMedicalFieldDirectorOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaMedicalFieldDirectorRepresentativeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    createPlaceholderMedicalFieldDirectorRepresentative(caseId: string | undefined): Observable<ClaMedicalFieldDirectorRepresentativeDto> {
        let url_ = this.baseUrl + "/api/services/app/ClaMedicalFieldDirectorRepresentative/CreatePlaceholderMedicalFieldDirectorRepresentative?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderMedicalFieldDirectorRepresentative(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderMedicalFieldDirectorRepresentative(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaMedicalFieldDirectorRepresentativeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaMedicalFieldDirectorRepresentativeDto>;
        }));
    }

    protected processCreatePlaceholderMedicalFieldDirectorRepresentative(response: HttpResponseBase): Observable<ClaMedicalFieldDirectorRepresentativeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaMedicalFieldDirectorRepresentativeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMedicalFieldDirectorRepresentative(body: UpdateClaMedicalFieldDirectorRepresentativeInput | undefined): Observable<UpdateClaMedicalFieldDirectorRepresentativeOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaMedicalFieldDirectorRepresentative/UpdateMedicalFieldDirectorRepresentative";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMedicalFieldDirectorRepresentative(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMedicalFieldDirectorRepresentative(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaMedicalFieldDirectorRepresentativeOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaMedicalFieldDirectorRepresentativeOutput>;
        }));
    }

    protected processUpdateMedicalFieldDirectorRepresentative(response: HttpResponseBase): Observable<UpdateClaMedicalFieldDirectorRepresentativeOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaMedicalFieldDirectorRepresentativeOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaMedicalFieldPersonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    createPlaceholderMedicalFieldPerson(caseId: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ClaMedicalFieldPerson/CreatePlaceholderMedicalFieldPerson?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderMedicalFieldPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderMedicalFieldPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderMedicalFieldPerson(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMedicalFieldPersons(body: UpdateClaMedicalFieldPersonsInput | undefined): Observable<UpdateClaMedicalFieldPersonsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaMedicalFieldPerson/UpdateMedicalFieldPersons";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMedicalFieldPersons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMedicalFieldPersons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaMedicalFieldPersonsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaMedicalFieldPersonsOutput>;
        }));
    }

    protected processUpdateMedicalFieldPersons(response: HttpResponseBase): Observable<UpdateClaMedicalFieldPersonsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaMedicalFieldPersonsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaNursingBedsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param nursingBedsId (optional) 
     * @return Success
     */
    createPlaceholderNursingBeds(caseId: string | undefined, nursingBedsId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ClaNursingBeds/CreatePlaceholderNursingBeds?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (nursingBedsId === null)
            throw new Error("The parameter 'nursingBedsId' cannot be null.");
        else if (nursingBedsId !== undefined)
            url_ += "NursingBedsId=" + encodeURIComponent("" + nursingBedsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderNursingBeds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderNursingBeds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderNursingBeds(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateNursingBedsList(body: UpdateClaNursingBedsInput | undefined): Observable<UpdateClaNursingBedsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaNursingBeds/UpdateNursingBedsList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNursingBedsList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNursingBedsList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaNursingBedsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaNursingBedsOutput>;
        }));
    }

    protected processUpdateNursingBedsList(response: HttpResponseBase): Observable<UpdateClaNursingBedsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaNursingBedsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaPersonelServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param personelId (optional) 
     * @return Success
     */
    createPlaceholderPersonel(caseId: string | undefined, personelId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ClaPersonel/CreatePlaceholderPersonel?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (personelId === null)
            throw new Error("The parameter 'personelId' cannot be null.");
        else if (personelId !== undefined)
            url_ += "personelId=" + encodeURIComponent("" + personelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderPersonel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderPersonel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderPersonel(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePersonelList(body: UpdateClaPersonelInput | undefined): Observable<UpdateClaPersonelOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaPersonel/UpdatePersonelList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePersonelList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePersonelList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaPersonelOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaPersonelOutput>;
        }));
    }

    protected processUpdatePersonelList(response: HttpResponseBase): Observable<UpdateClaPersonelOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaPersonelOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaQualityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param qualityId (optional) 
     * @return Success
     */
    createPlaceholderQuality(caseId: string | undefined, qualityId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ClaQuality/CreatePlaceholderQuality?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (qualityId === null)
            throw new Error("The parameter 'qualityId' cannot be null.");
        else if (qualityId !== undefined)
            url_ += "QualityId=" + encodeURIComponent("" + qualityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderQuality(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderQuality(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderQuality(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateQualityList(body: UpdateClaQualityInput | undefined): Observable<UpdateClaQualityOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaQuality/UpdateQualityList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateQualityList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateQualityList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaQualityOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaQualityOutput>;
        }));
    }

    protected processUpdateQualityList(response: HttpResponseBase): Observable<UpdateClaQualityOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaQualityOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaRangeOfServicesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param rangeOfServicesId (optional) 
     * @return Success
     */
    createPlaceholderRangeOfServices(caseId: string | undefined, rangeOfServicesId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ClaRangeOfServices/CreatePlaceholderRangeOfServices?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (rangeOfServicesId === null)
            throw new Error("The parameter 'rangeOfServicesId' cannot be null.");
        else if (rangeOfServicesId !== undefined)
            url_ += "rangeOfServicesId=" + encodeURIComponent("" + rangeOfServicesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderRangeOfServices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderRangeOfServices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderRangeOfServices(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateRangeOfServicesList(body: UpdateClaRangeOfServicesInput | undefined): Observable<UpdateClaRangeOfServicesOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaRangeOfServices/UpdateRangeOfServicesList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRangeOfServicesList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRangeOfServicesList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaRangeOfServicesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaRangeOfServicesOutput>;
        }));
    }

    protected processUpdateRangeOfServicesList(response: HttpResponseBase): Observable<UpdateClaRangeOfServicesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaRangeOfServicesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaSanitaryFacilitiesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param sanitaryFacilitiesId (optional) 
     * @return Success
     */
    createPlaceholderSanitaryFacilities(caseId: string | undefined, sanitaryFacilitiesId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ClaSanitaryFacilities/CreatePlaceholderSanitaryFacilities?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (sanitaryFacilitiesId === null)
            throw new Error("The parameter 'sanitaryFacilitiesId' cannot be null.");
        else if (sanitaryFacilitiesId !== undefined)
            url_ += "SanitaryFacilitiesId=" + encodeURIComponent("" + sanitaryFacilitiesId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderSanitaryFacilities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderSanitaryFacilities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderSanitaryFacilities(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSanitaryFacilitiesList(body: UpdateClaSanitaryFacilitiesInput | undefined): Observable<UpdateClaSanitaryFacilitiesOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaSanitaryFacilities/UpdateSanitaryFacilitiesList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSanitaryFacilitiesList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSanitaryFacilitiesList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaSanitaryFacilitiesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaSanitaryFacilitiesOutput>;
        }));
    }

    protected processUpdateSanitaryFacilitiesList(response: HttpResponseBase): Observable<UpdateClaSanitaryFacilitiesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaSanitaryFacilitiesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaSecurityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param securityId (optional) 
     * @return Success
     */
    createPlaceholderSecurity(caseId: string | undefined, securityId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ClaSecurity/CreatePlaceholderSecurity?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (securityId === null)
            throw new Error("The parameter 'securityId' cannot be null.");
        else if (securityId !== undefined)
            url_ += "SecurityId=" + encodeURIComponent("" + securityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderSecurity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderSecurity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderSecurity(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSecurityList(body: UpdateClaSecurityInput | undefined): Observable<UpdateClaSecurityOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaSecurity/UpdateSecurityList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSecurityList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSecurityList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaSecurityOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaSecurityOutput>;
        }));
    }

    protected processUpdateSecurityList(response: HttpResponseBase): Observable<UpdateClaSecurityOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaSecurityOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaServiceAreasServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param serviceAreaId (optional) 
     * @return Success
     */
    createPlaceholderServiceArea(caseId: string | undefined, serviceAreaId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ClaServiceAreas/CreatePlaceholderServiceArea?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (serviceAreaId === null)
            throw new Error("The parameter 'serviceAreaId' cannot be null.");
        else if (serviceAreaId !== undefined)
            url_ += "ServiceAreaId=" + encodeURIComponent("" + serviceAreaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderServiceArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderServiceArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderServiceArea(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateServiceAreasList(body: UpdateClaServiceAreasInput | undefined): Observable<UpdateClaServiceAreasOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaServiceAreas/UpdateServiceAreasList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateServiceAreasList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateServiceAreasList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaServiceAreasOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaServiceAreasOutput>;
        }));
    }

    protected processUpdateServiceAreasList(response: HttpResponseBase): Observable<UpdateClaServiceAreasOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaServiceAreasOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaSponsorshipServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateSponsorship(body: CreateOrUpdateClaSponsorshipInput | undefined): Observable<ClaStatus> {
        let url_ = this.baseUrl + "/api/services/app/ClaSponsorship/CreateOrUpdateSponsorship";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateSponsorship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateSponsorship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaStatus>;
        }));
    }

    protected processCreateOrUpdateSponsorship(response: HttpResponseBase): Observable<ClaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    createPlaceholderSponsorshipDirector(caseId: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ClaSponsorship/CreatePlaceholderSponsorshipDirector?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderSponsorshipDirector(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderSponsorshipDirector(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderSponsorshipDirector(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSponsorshipDirectors(body: UpdateClaSponsorshipDirectorsInput | undefined): Observable<UpdateClaSponsorshipDirectorsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaSponsorship/UpdateSponsorshipDirectors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSponsorshipDirectors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSponsorshipDirectors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaSponsorshipDirectorsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaSponsorshipDirectorsOutput>;
        }));
    }

    protected processUpdateSponsorshipDirectors(response: HttpResponseBase): Observable<UpdateClaSponsorshipDirectorsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaSponsorshipDirectorsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaStatusWizardStepServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param sponsorshipTypeId (optional) 
     * @param applicationType (optional) 
     * @return Success
     */
    getAllBySponsorshipTypeIdAndApplicationType(sponsorshipTypeId: string | undefined, applicationType: ApplicationType | undefined): Observable<ClaStatusWizardStepDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ClaStatusWizardStep/GetAllBySponsorshipTypeIdAndApplicationType?";
        if (sponsorshipTypeId === null)
            throw new Error("The parameter 'sponsorshipTypeId' cannot be null.");
        else if (sponsorshipTypeId !== undefined)
            url_ += "sponsorshipTypeId=" + encodeURIComponent("" + sponsorshipTypeId) + "&";
        if (applicationType === null)
            throw new Error("The parameter 'applicationType' cannot be null.");
        else if (applicationType !== undefined)
            url_ += "applicationType=" + encodeURIComponent("" + applicationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBySponsorshipTypeIdAndApplicationType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBySponsorshipTypeIdAndApplicationType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaStatusWizardStepDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaStatusWizardStepDto[]>;
        }));
    }

    protected processGetAllBySponsorshipTypeIdAndApplicationType(response: HttpResponseBase): Observable<ClaStatusWizardStepDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClaStatusWizardStepDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateClaStatusWizardStepInput | undefined): Observable<ClaStatusWizardStepDto> {
        let url_ = this.baseUrl + "/api/services/app/ClaStatusWizardStep/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaStatusWizardStepDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaStatusWizardStepDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ClaStatusWizardStepDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaStatusWizardStepDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMany(body: UpdateClaStatusWizardStepsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ClaStatusWizardStep/UpdateMany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateMany(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @param sponsorshipTypeId (optional) 
     * @param applicationType (optional) 
     * @return Success
     */
    delete(step: number | undefined, sponsorshipTypeId: string | undefined, applicationType: ApplicationType | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ClaStatusWizardStep/Delete?";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "step=" + encodeURIComponent("" + step) + "&";
        if (sponsorshipTypeId === null)
            throw new Error("The parameter 'sponsorshipTypeId' cannot be null.");
        else if (sponsorshipTypeId !== undefined)
            url_ += "sponsorshipTypeId=" + encodeURIComponent("" + sponsorshipTypeId) + "&";
        if (applicationType === null)
            throw new Error("The parameter 'applicationType' cannot be null.");
        else if (applicationType !== undefined)
            url_ += "applicationType=" + encodeURIComponent("" + applicationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaTreatmentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param businessId (optional) 
     * @return Success
     */
    createPlaceholderTreatment(caseId: string | undefined, businessId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ClaTreatment/CreatePlaceholderTreatment?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (businessId === null)
            throw new Error("The parameter 'businessId' cannot be null.");
        else if (businessId !== undefined)
            url_ += "businessId=" + encodeURIComponent("" + businessId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderTreatment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderTreatment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderTreatment(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTreatmentList(body: UpdateClaTreatmentInput | undefined): Observable<UpdateClaTreatmentOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaTreatment/UpdateTreatmentList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTreatmentList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTreatmentList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaTreatmentOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaTreatmentOutput>;
        }));
    }

    protected processUpdateTreatmentList(response: HttpResponseBase): Observable<UpdateClaTreatmentOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaTreatmentOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ClaWheelchairAccessibilityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param wheelchairAccessibilityId (optional) 
     * @return Success
     */
    createPlaceholderWheelchairAccessibility(caseId: string | undefined, wheelchairAccessibilityId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ClaWheelchairAccessibility/CreatePlaceholderWheelchairAccessibility?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (wheelchairAccessibilityId === null)
            throw new Error("The parameter 'wheelchairAccessibilityId' cannot be null.");
        else if (wheelchairAccessibilityId !== undefined)
            url_ += "WheelchairAccessibilityId=" + encodeURIComponent("" + wheelchairAccessibilityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderWheelchairAccessibility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderWheelchairAccessibility(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderWheelchairAccessibility(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateWheelchairAccessibilityList(body: UpdateClaWheelchairAccessibilityInput | undefined): Observable<UpdateClaWheelchairAccessibilityOutput> {
        let url_ = this.baseUrl + "/api/services/app/ClaWheelchairAccessibility/UpdateWheelchairAccessibilityList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWheelchairAccessibilityList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWheelchairAccessibilityList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateClaWheelchairAccessibilityOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateClaWheelchairAccessibilityOutput>;
        }));
    }

    protected processUpdateWheelchairAccessibilityList(response: HttpResponseBase): Observable<UpdateClaWheelchairAccessibilityOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateClaWheelchairAccessibilityOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CodeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getAllCodes(): Observable<CodeListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Code/GetAllCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CodeListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CodeListDto[]>;
        }));
    }

    protected processGetAllCodes(response: HttpResponseBase): Observable<CodeListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CodeListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param codeCategory (optional) 
     * @param filter (optional) 
     * @param isSystem (optional) 
     * @param codeSubcategory (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getCodes(codeCategory: CodeCategory | undefined, filter: string | undefined, isSystem: boolean | undefined, codeSubcategory: CodeSubcategory | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfCodeListDto> {
        let url_ = this.baseUrl + "/api/services/app/Code/GetCodes?";
        if (codeCategory === null)
            throw new Error("The parameter 'codeCategory' cannot be null.");
        else if (codeCategory !== undefined)
            url_ += "CodeCategory=" + encodeURIComponent("" + codeCategory) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (isSystem === null)
            throw new Error("The parameter 'isSystem' cannot be null.");
        else if (isSystem !== undefined)
            url_ += "IsSystem=" + encodeURIComponent("" + isSystem) + "&";
        if (codeSubcategory === null)
            throw new Error("The parameter 'codeSubcategory' cannot be null.");
        else if (codeSubcategory !== undefined)
            url_ += "CodeSubcategory=" + encodeURIComponent("" + codeSubcategory) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfCodeListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfCodeListDto>;
        }));
    }

    protected processGetCodes(response: HttpResponseBase): Observable<PagedResultDtoOfCodeListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCodeListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param codeCategory (optional) 
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param codeSubcategory (optional) 
     * @param isSystem (optional) 
     * @return Success
     */
    getCodesToExcel(codeCategory: CodeCategory | undefined, filter: string | undefined, sorting: string | undefined, codeSubcategory: CodeSubcategory | undefined, isSystem: boolean | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Code/GetCodesToExcel?";
        if (codeCategory === null)
            throw new Error("The parameter 'codeCategory' cannot be null.");
        else if (codeCategory !== undefined)
            url_ += "CodeCategory=" + encodeURIComponent("" + codeCategory) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (codeSubcategory === null)
            throw new Error("The parameter 'codeSubcategory' cannot be null.");
        else if (codeSubcategory !== undefined)
            url_ += "CodeSubcategory=" + encodeURIComponent("" + codeSubcategory) + "&";
        if (isSystem === null)
            throw new Error("The parameter 'isSystem' cannot be null.");
        else if (isSystem !== undefined)
            url_ += "IsSystem=" + encodeURIComponent("" + isSystem) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCodesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCodesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetCodesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCodeForEdit(id: string | undefined): Observable<GetCodeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Code/GetCodeForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCodeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCodeForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCodeForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCodeForEditOutput>;
        }));
    }

    protected processGetCodeForEdit(response: HttpResponseBase): Observable<GetCodeForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCodeForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateCode(body: CreateOrUpdateCodeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Code/CreateOrUpdateCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteCode(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Code/DeleteCode?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CommonLookupServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param onlyFreeItems (optional) 
     * @return Success
     */
    getEditionsForCombobox(onlyFreeItems: boolean | undefined): Observable<ListResultDtoOfSubscribableEditionComboboxItemDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetEditionsForCombobox?";
        if (onlyFreeItems === null)
            throw new Error("The parameter 'onlyFreeItems' cannot be null.");
        else if (onlyFreeItems !== undefined)
            url_ += "onlyFreeItems=" + encodeURIComponent("" + onlyFreeItems) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionsForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionsForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfSubscribableEditionComboboxItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfSubscribableEditionComboboxItemDto>;
        }));
    }

    protected processGetEditionsForCombobox(response: HttpResponseBase): Observable<ListResultDtoOfSubscribableEditionComboboxItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfSubscribableEditionComboboxItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    findUsers(body: FindUsersInput | undefined): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/FindUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfNameValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfNameValueDto>;
        }));
    }

    protected processFindUsers(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getDefaultEditionName(): Observable<GetDefaultEditionNameOutput> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetDefaultEditionName";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDefaultEditionName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultEditionName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDefaultEditionNameOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDefaultEditionNameOutput>;
        }));
    }

    protected processGetDefaultEditionName(response: HttpResponseBase): Observable<GetDefaultEditionNameOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDefaultEditionNameOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ConfigServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getConfig(): Observable<ConfigDto> {
        let url_ = this.baseUrl + "/api/services/app/Config/GetConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfigDto>;
        }));
    }

    protected processGetConfig(response: HttpResponseBase): Observable<ConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfigDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCurrentUserSetting(body: UpdateCurrentUserSettingInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Config/UpdateCurrentUserSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCurrentUserSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCurrentUserSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCurrentUserSetting(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getExternalSystemCredentials(): Observable<GetExternalSystemCredentials> {
        let url_ = this.baseUrl + "/api/services/app/Config/GetExternalSystemCredentials";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalSystemCredentials(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalSystemCredentials(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetExternalSystemCredentials>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetExternalSystemCredentials>;
        }));
    }

    protected processGetExternalSystemCredentials(response: HttpResponseBase): Observable<GetExternalSystemCredentials> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetExternalSystemCredentials.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateExternalSystemCertificate(body: CreateOrUpdateExternalSystemCertificateInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Config/CreateOrUpdateExternalSystemCertificate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateExternalSystemCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateExternalSystemCertificate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateExternalSystemCertificate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateExternalSystemCredentials(body: CreateOrUpdateExternalSystemCredentialsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Config/CreateOrUpdateExternalSystemCredentials";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateExternalSystemCredentials(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateExternalSystemCredentials(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateExternalSystemCredentials(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param key (optional) 
     * @param value (optional) 
     * @return Success
     */
    updateMaintenanceSetting(key: string | undefined, value: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Config/UpdateMaintenanceSetting?";
        if (key === null)
            throw new Error("The parameter 'key' cannot be null.");
        else if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        if (value === null)
            throw new Error("The parameter 'value' cannot be null.");
        else if (value !== undefined)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMaintenanceSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMaintenanceSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateMaintenanceSetting(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMaintenanceConfiguration(): Observable<MaintenanceConfigDto> {
        let url_ = this.baseUrl + "/api/services/app/Config/GetMaintenanceConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMaintenanceConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaintenanceConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaintenanceConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaintenanceConfigDto>;
        }));
    }

    protected processGetMaintenanceConfiguration(response: HttpResponseBase): Observable<MaintenanceConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MaintenanceConfigDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param key (optional) 
     * @param value (optional) 
     * @return Success
     */
    updateSironaSetting(key: string | undefined, value: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Config/UpdateSironaSetting?";
        if (key === null)
            throw new Error("The parameter 'key' cannot be null.");
        else if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        if (value === null)
            throw new Error("The parameter 'value' cannot be null.");
        else if (value !== undefined)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSironaSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSironaSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSironaSetting(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getSironaSettings(): Observable<SironaSettingDto> {
        let url_ = this.baseUrl + "/api/services/app/Config/GetSironaSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSironaSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSironaSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SironaSettingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SironaSettingDto>;
        }));
    }

    protected processGetSironaSettings(response: HttpResponseBase): Observable<SironaSettingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SironaSettingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEnvironment(): Observable<EnvironmentDto> {
        let url_ = this.baseUrl + "/api/services/app/Config/GetEnvironment";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEnvironment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEnvironment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnvironmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnvironmentDto>;
        }));
    }

    protected processGetEnvironment(response: HttpResponseBase): Observable<EnvironmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnvironmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CorporateLicenceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchCorporateLicences(body: SearchCorporateLicencesInputDto | undefined): Observable<SearchCorporateLicencesOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/CorporateLicence/SearchCorporateLicences";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchCorporateLicences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchCorporateLicences(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchCorporateLicencesOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchCorporateLicencesOutputDto>;
        }));
    }

    protected processSearchCorporateLicences(response: HttpResponseBase): Observable<SearchCorporateLicencesOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchCorporateLicencesOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sponsorshipId (optional) 
     * @return Success
     */
    getCorporateLicences(sponsorshipId: number | undefined): Observable<GetCorporateLicencesOutput> {
        let url_ = this.baseUrl + "/api/services/app/CorporateLicence/GetCorporateLicences?";
        if (sponsorshipId === null)
            throw new Error("The parameter 'sponsorshipId' cannot be null.");
        else if (sponsorshipId !== undefined)
            url_ += "sponsorshipId=" + encodeURIComponent("" + sponsorshipId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCorporateLicences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCorporateLicences(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCorporateLicencesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCorporateLicencesOutput>;
        }));
    }

    protected processGetCorporateLicences(response: HttpResponseBase): Observable<GetCorporateLicencesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCorporateLicencesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchCorporateLicencesByUidAndType(body: SearchCorporateLicencesByUidAndTypeInputDto | undefined): Observable<GetCorporateLicencesOutput> {
        let url_ = this.baseUrl + "/api/services/app/CorporateLicence/SearchCorporateLicencesByUidAndType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchCorporateLicencesByUidAndType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchCorporateLicencesByUidAndType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCorporateLicencesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCorporateLicencesOutput>;
        }));
    }

    protected processSearchCorporateLicencesByUidAndType(response: HttpResponseBase): Observable<GetCorporateLicencesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCorporateLicencesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param businessId (optional) 
     * @return Success
     */
    getCorporateLicencesForBusiness(businessId: number | undefined): Observable<GetCorporateLicencesOutput> {
        let url_ = this.baseUrl + "/api/services/app/CorporateLicence/GetCorporateLicencesForBusiness?";
        if (businessId === null)
            throw new Error("The parameter 'businessId' cannot be null.");
        else if (businessId !== undefined)
            url_ += "businessId=" + encodeURIComponent("" + businessId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCorporateLicencesForBusiness(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCorporateLicencesForBusiness(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCorporateLicencesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCorporateLicencesOutput>;
        }));
    }

    protected processGetCorporateLicencesForBusiness(response: HttpResponseBase): Observable<GetCorporateLicencesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCorporateLicencesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @return Success
     */
    getAssistantAndDelegatedLicencesForAssistantPerson(personId: number | undefined): Observable<CorporateLicenceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CorporateLicence/GetAssistantAndDelegatedLicencesForAssistantPerson?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssistantAndDelegatedLicencesForAssistantPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssistantAndDelegatedLicencesForAssistantPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CorporateLicenceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CorporateLicenceDto[]>;
        }));
    }

    protected processGetAssistantAndDelegatedLicencesForAssistantPerson(response: HttpResponseBase): Observable<CorporateLicenceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CorporateLicenceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CorporateLicenceDto> {
        let url_ = this.baseUrl + "/api/services/app/CorporateLicence/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CorporateLicenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CorporateLicenceDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CorporateLicenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CorporateLicenceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getHistory(id: number | undefined): Observable<CorporateLicenceHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CorporateLicence/GetHistory?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CorporateLicenceHistoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CorporateLicenceHistoryDto[]>;
        }));
    }

    protected processGetHistory(response: HttpResponseBase): Observable<CorporateLicenceHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CorporateLicenceHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCorporateLicenceDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/CorporateLicence/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    update(id: number | undefined, body: UpdateCorporateLicenceDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CorporateLicence/Update?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    canDelete(id: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/CorporateLicence/CanDelete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCanDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCanDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCanDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CorporateLicence/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createRenewal(body: CreateCorporateLicenceRenewalDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/CorporateLicence/CreateRenewal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRenewal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRenewal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateRenewal(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateRenewal(id: number | undefined, body: UpdateCorporateLicenceRenewalDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CorporateLicence/UpdateRenewal?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRenewal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRenewal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateRenewal(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createMutation(corporateLicenceId: number, body: CorporateLicenceMutationDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/CorporateLicence/CreateMutation?";
        if (corporateLicenceId === undefined || corporateLicenceId === null)
            throw new Error("The parameter 'corporateLicenceId' must be defined and cannot be null.");
        else
            url_ += "corporateLicenceId=" + encodeURIComponent("" + corporateLicenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMutation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMutation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateMutation(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMutation(id: number, body: CorporateLicenceMutationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CorporateLicence/UpdateMutation?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMutation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMutation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateMutation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CorporateLicenceRestrictionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<GetCorporateLicenceRestrictionDto> {
        let url_ = this.baseUrl + "/api/services/app/CorporateLicenceRestriction/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCorporateLicenceRestrictionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCorporateLicenceRestrictionDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetCorporateLicenceRestrictionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCorporateLicenceRestrictionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    post(body: CreateCorporateLicenceRestrictionDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/CorporateLicenceRestriction/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    put(id: number | undefined, body: UpdateCorporateLicenceRestrictionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CorporateLicenceRestriction/Put?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CorporateLicenceRestriction/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CriminalPenaltyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getAndCreateIfNotExisting(discriminator: CriminalPenaltyDiscriminator, entityId: number): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/CriminalPenalty/GetAndCreateIfNotExisting?";
        if (discriminator === undefined || discriminator === null)
            throw new Error("The parameter 'discriminator' must be defined and cannot be null.");
        else
            url_ += "Discriminator=" + encodeURIComponent("" + discriminator) + "&";
        if (entityId === undefined || entityId === null)
            throw new Error("The parameter 'entityId' must be defined and cannot be null.");
        else
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAndCreateIfNotExisting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAndCreateIfNotExisting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetAndCreateIfNotExisting(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getRecords(id_Discriminator: CriminalPenaltyDiscriminator, id_EntityId: number, recordDiscriminator: CriminalPenaltyRecordDiscriminator, filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetCriminalPenaltyRecordSearchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/CriminalPenalty/GetRecords?";
        if (id_Discriminator === undefined || id_Discriminator === null)
            throw new Error("The parameter 'id_Discriminator' must be defined and cannot be null.");
        else
            url_ += "Id.Discriminator=" + encodeURIComponent("" + id_Discriminator) + "&";
        if (id_EntityId === undefined || id_EntityId === null)
            throw new Error("The parameter 'id_EntityId' must be defined and cannot be null.");
        else
            url_ += "Id.EntityId=" + encodeURIComponent("" + id_EntityId) + "&";
        if (recordDiscriminator === undefined || recordDiscriminator === null)
            throw new Error("The parameter 'recordDiscriminator' must be defined and cannot be null.");
        else
            url_ += "RecordDiscriminator=" + encodeURIComponent("" + recordDiscriminator) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCriminalPenaltyRecordSearchOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCriminalPenaltyRecordSearchOutputDto>;
        }));
    }

    protected processGetRecords(response: HttpResponseBase): Observable<GetCriminalPenaltyRecordSearchOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCriminalPenaltyRecordSearchOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRecord(id: number | undefined): Observable<GetCriminalPenaltyRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/CriminalPenalty/GetRecord?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCriminalPenaltyRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCriminalPenaltyRecordDto>;
        }));
    }

    protected processGetRecord(response: HttpResponseBase): Observable<GetCriminalPenaltyRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCriminalPenaltyRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createRecord(discriminator: CriminalPenaltyDiscriminator, entityId: number, body: CreateCriminalPenaltyRecordDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/CriminalPenalty/CreateRecord?";
        if (discriminator === undefined || discriminator === null)
            throw new Error("The parameter 'discriminator' must be defined and cannot be null.");
        else
            url_ += "Discriminator=" + encodeURIComponent("" + discriminator) + "&";
        if (entityId === undefined || entityId === null)
            throw new Error("The parameter 'entityId' must be defined and cannot be null.");
        else
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateRecord(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateRecord(id: number | undefined, body: UpdateCriminalPenaltyRecordDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CriminalPenalty/UpdateRecord?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateRecord(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param from (optional) 
     * @param to (optional) 
     * @return Success
     */
    getLicenceApplicationStatisticData(from: DateTime | undefined, to: DateTime | undefined): Observable<LicenceApplicationStatisticDto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetLicenceApplicationStatisticData?";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLicenceApplicationStatisticData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLicenceApplicationStatisticData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LicenceApplicationStatisticDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LicenceApplicationStatisticDto>;
        }));
    }

    protected processGetLicenceApplicationStatisticData(response: HttpResponseBase): Observable<LicenceApplicationStatisticDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenceApplicationStatisticDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getLicenceApplicationFinishedStatisticData(): Observable<LicenceApplicationFinishedStatisticDto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetLicenceApplicationFinishedStatisticData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLicenceApplicationFinishedStatisticData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLicenceApplicationFinishedStatisticData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LicenceApplicationFinishedStatisticDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LicenceApplicationFinishedStatisticDto>;
        }));
    }

    protected processGetLicenceApplicationFinishedStatisticData(response: HttpResponseBase): Observable<LicenceApplicationFinishedStatisticDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenceApplicationFinishedStatisticDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getNumberOfResponsibleLicenceApplications(): Observable<LicenceApplicationResponsibleStatisticDto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetNumberOfResponsibleLicenceApplications";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNumberOfResponsibleLicenceApplications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNumberOfResponsibleLicenceApplications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LicenceApplicationResponsibleStatisticDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LicenceApplicationResponsibleStatisticDto>;
        }));
    }

    protected processGetNumberOfResponsibleLicenceApplications(response: HttpResponseBase): Observable<LicenceApplicationResponsibleStatisticDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenceApplicationResponsibleStatisticDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param includeCompleted (optional) 
     * @return Success
     */
    getOwnResponsobilityEntities(includeCompleted: boolean | undefined): Observable<OwnResponsobilityEntityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetOwnResponsobilityEntities?";
        if (includeCompleted === null)
            throw new Error("The parameter 'includeCompleted' cannot be null.");
        else if (includeCompleted !== undefined)
            url_ += "includeCompleted=" + encodeURIComponent("" + includeCompleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOwnResponsobilityEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOwnResponsobilityEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OwnResponsobilityEntityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OwnResponsobilityEntityDto[]>;
        }));
    }

    protected processGetOwnResponsobilityEntities(response: HttpResponseBase): Observable<OwnResponsobilityEntityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OwnResponsobilityEntityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DiplomaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getDiplomas(personId: number, filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetDiplomaSearchOutput> {
        let url_ = this.baseUrl + "/api/services/app/Diploma/GetDiplomas?";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined and cannot be null.");
        else
            url_ += "PersonId=" + encodeURIComponent("" + personId) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiplomas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiplomas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDiplomaSearchOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDiplomaSearchOutput>;
        }));
    }

    protected processGetDiplomas(response: HttpResponseBase): Observable<GetDiplomaSearchOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDiplomaSearchOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param diplomaId (optional) 
     * @return Success
     */
    getDiploma(diplomaId: number | undefined): Observable<DiplomaDto> {
        let url_ = this.baseUrl + "/api/services/app/Diploma/GetDiploma?";
        if (diplomaId === null)
            throw new Error("The parameter 'diplomaId' cannot be null.");
        else if (diplomaId !== undefined)
            url_ += "diplomaId=" + encodeURIComponent("" + diplomaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiploma(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiploma(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiplomaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiplomaDto>;
        }));
    }

    protected processGetDiploma(response: HttpResponseBase): Observable<DiplomaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiplomaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    postDiploma(body: CreateDiplomaDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Diploma/PostDiploma";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostDiploma(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostDiploma(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processPostDiploma(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    putDiploma(id: number | undefined, body: DiplomaDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Diploma/PutDiploma?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutDiploma(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutDiploma(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutDiploma(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteDiploma(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Diploma/DeleteDiploma?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDiploma(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDiploma(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDiploma(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DistrictServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getAllDistricts(): Observable<DistrictDto[]> {
        let url_ = this.baseUrl + "/api/services/app/District/GetAllDistricts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDistricts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDistricts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DistrictDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DistrictDto[]>;
        }));
    }

    protected processGetAllDistricts(response: HttpResponseBase): Observable<DistrictDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DistrictDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getPlzForDistrict(districtCodeId: string, filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetDistrictPlzSearchOutput> {
        let url_ = this.baseUrl + "/api/services/app/District/GetPlzForDistrict?";
        if (districtCodeId === undefined || districtCodeId === null)
            throw new Error("The parameter 'districtCodeId' must be defined and cannot be null.");
        else
            url_ += "DistrictCodeId=" + encodeURIComponent("" + districtCodeId) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlzForDistrict(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlzForDistrict(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDistrictPlzSearchOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDistrictPlzSearchOutput>;
        }));
    }

    protected processGetPlzForDistrict(response: HttpResponseBase): Observable<GetDistrictPlzSearchOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDistrictPlzSearchOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param districtId (optional) 
     * @return Success
     */
    getDistrict(districtId: string | undefined): Observable<DistrictDto> {
        let url_ = this.baseUrl + "/api/services/app/District/GetDistrict?";
        if (districtId === null)
            throw new Error("The parameter 'districtId' cannot be null.");
        else if (districtId !== undefined)
            url_ += "districtId=" + encodeURIComponent("" + districtId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDistrict(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDistrict(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DistrictDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DistrictDto>;
        }));
    }

    protected processGetDistrict(response: HttpResponseBase): Observable<DistrictDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DistrictDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    postDistrict(body: DistrictDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/District/PostDistrict";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostDistrict(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostDistrict(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processPostDistrict(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    putDistrict(body: DistrictDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/District/PutDistrict";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutDistrict(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutDistrict(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutDistrict(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param districtId (optional) 
     * @return Success
     */
    deleteDistrict(districtId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/District/DeleteDistrict?";
        if (districtId === null)
            throw new Error("The parameter 'districtId' cannot be null.");
        else if (districtId !== undefined)
            url_ += "districtId=" + encodeURIComponent("" + districtId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDistrict(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDistrict(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDistrict(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param districtId (optional) 
     * @param body (optional) 
     * @return Success
     */
    addPlzToDistrict(districtId: string | undefined, body: DistrictPlzDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/District/AddPlzToDistrict?";
        if (districtId === null)
            throw new Error("The parameter 'districtId' cannot be null.");
        else if (districtId !== undefined)
            url_ += "districtId=" + encodeURIComponent("" + districtId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPlzToDistrict(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPlzToDistrict(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddPlzToDistrict(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param districtId (optional) 
     * @param plz (optional) 
     * @return Success
     */
    removePlzFromDistrict(districtId: string | undefined, plz: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/District/RemovePlzFromDistrict?";
        if (districtId === null)
            throw new Error("The parameter 'districtId' cannot be null.");
        else if (districtId !== undefined)
            url_ += "districtId=" + encodeURIComponent("" + districtId) + "&";
        if (plz === null)
            throw new Error("The parameter 'plz' cannot be null.");
        else if (plz !== undefined)
            url_ += "plz=" + encodeURIComponent("" + plz) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemovePlzFromDistrict(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemovePlzFromDistrict(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemovePlzFromDistrict(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DocumentManagementSystemServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    search(body: GetDmsSearchInput | undefined): Observable<GetDmsSearchOutput> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystem/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDmsSearchOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDmsSearchOutput>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<GetDmsSearchOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDmsSearchOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<GetDocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystem/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDocumentDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetDocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDocumentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateDocumentDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystem/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    update(id: number | undefined, body: UpdateDocumentDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystem/Update?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getDocumentFile(id: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystem/GetDocumentFile?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetDocumentFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param versionId (optional) 
     * @return Success
     */
    getDocumentVersionFile(versionId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystem/GetDocumentVersionFile?";
        if (versionId === null)
            throw new Error("The parameter 'versionId' cannot be null.");
        else if (versionId !== undefined)
            url_ += "versionId=" + encodeURIComponent("" + versionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentVersionFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentVersionFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetDocumentVersionFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param documentId (optional) 
     * @return Success
     */
    getLastWordVersionId(documentId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystem/GetLastWordVersionId?";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastWordVersionId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastWordVersionId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetLastWordVersionId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystem/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    addLinks(id: number | undefined, body: LinkDto[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystem/AddLinks?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddLinks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddLinks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddLinks(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    removeLink(id: number | undefined, discriminator: string, entityId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystem/RemoveLink?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (discriminator === undefined || discriminator === null)
            throw new Error("The parameter 'discriminator' must be defined and cannot be null.");
        else
            url_ += "Discriminator=" + encodeURIComponent("" + discriminator) + "&";
        if (entityId === undefined || entityId === null)
            throw new Error("The parameter 'entityId' must be defined and cannot be null.");
        else
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    sendDocument(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystem/SendDocument?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    generateWebdavAccessPath(id: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystem/GenerateWebdavAccessPath?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateWebdavAccessPath(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateWebdavAccessPath(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGenerateWebdavAccessPath(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DocumentManagementSystemScanImportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFile(body: ScanImportFileDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystemScanImport/UploadFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DocumentManagementSystemTemplateServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    search(body: SearchTemplatesInput | undefined): Observable<SearchTemplateOutput> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystemTemplate/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchTemplateOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchTemplateOutput>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<SearchTemplateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchTemplateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param entityType (optional) 
     * @param parentEntityId (optional) 
     * @return Success
     */
    getSelectableEntityList(entityType: DmsTemplateSelectableEntityType | undefined, parentEntityId: number | undefined): Observable<DmsTemplateSelectableEntityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystemTemplate/GetSelectableEntityList?";
        if (entityType === null)
            throw new Error("The parameter 'entityType' cannot be null.");
        else if (entityType !== undefined)
            url_ += "entityType=" + encodeURIComponent("" + entityType) + "&";
        if (parentEntityId === null)
            throw new Error("The parameter 'parentEntityId' cannot be null.");
        else if (parentEntityId !== undefined)
            url_ += "parentEntityId=" + encodeURIComponent("" + parentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSelectableEntityList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSelectableEntityList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DmsTemplateSelectableEntityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DmsTemplateSelectableEntityDto[]>;
        }));
    }

    protected processGetSelectableEntityList(response: HttpResponseBase): Observable<DmsTemplateSelectableEntityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DmsTemplateSelectableEntityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generate(body: GenerateDocumentFromTemplateInputDto | undefined): Observable<GenerateDocumentFromTemplateResultDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystemTemplate/Generate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenerateDocumentFromTemplateResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenerateDocumentFromTemplateResultDto>;
        }));
    }

    protected processGenerate(response: HttpResponseBase): Observable<GenerateDocumentFromTemplateResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenerateDocumentFromTemplateResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generateFromTemplateDiscriminator(body: GenerateFromTemplateDiscriminatorInputDto | undefined): Observable<GenerateDocumentFromTemplateResultDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystemTemplate/GenerateFromTemplateDiscriminator";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateFromTemplateDiscriminator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateFromTemplateDiscriminator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenerateDocumentFromTemplateResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenerateDocumentFromTemplateResultDto>;
        }));
    }

    protected processGenerateFromTemplateDiscriminator(response: HttpResponseBase): Observable<GenerateDocumentFromTemplateResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenerateDocumentFromTemplateResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DocumentManagementSystemTemplateAdministrationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    search(body: SearchTemplatesInput | undefined): Observable<SearchTemplateOutput> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystemTemplateAdministration/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchTemplateOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchTemplateOutput>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<SearchTemplateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchTemplateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param discriminator (optional) 
     * @return Success
     */
    countTemplates(discriminator: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystemTemplateAdministration/CountTemplates?";
        if (discriminator === null)
            throw new Error("The parameter 'discriminator' cannot be null.");
        else if (discriminator !== undefined)
            url_ += "discriminator=" + encodeURIComponent("" + discriminator) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCountTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCountTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCountTemplates(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<GetTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystemTemplateAdministration/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTemplateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTemplateDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getFile(id: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystemTemplateAdministration/GetFile?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param discriminator (optional) 
     * @param body (optional) 
     * @return Success
     */
    create(discriminator: string | undefined, body: CreateUpdateTemplateDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystemTemplateAdministration/Create?";
        if (discriminator === null)
            throw new Error("The parameter 'discriminator' cannot be null.");
        else if (discriminator !== undefined)
            url_ += "discriminator=" + encodeURIComponent("" + discriminator) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    update(id: number | undefined, body: CreateUpdateTemplateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystemTemplateAdministration/Update?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystemTemplateAdministration/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    generateXmlSchema(templateDiscriminator: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/DocumentManagementSystemTemplateAdministration/GenerateXmlSchema?";
        if (templateDiscriminator === undefined || templateDiscriminator === null)
            throw new Error("The parameter 'templateDiscriminator' must be defined and cannot be null.");
        else
            url_ += "templateDiscriminator=" + encodeURIComponent("" + templateDiscriminator) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateXmlSchema(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateXmlSchema(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGenerateXmlSchema(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EditionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getEditions(): Observable<ListResultDtoOfEditionListDto> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfEditionListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfEditionListDto>;
        }));
    }

    protected processGetEditions(response: HttpResponseBase): Observable<ListResultDtoOfEditionListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfEditionListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEditionForEdit(id: number | undefined): Observable<GetEditionEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditionForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEditionEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEditionEditOutput>;
        }));
    }

    protected processGetEditionForEdit(response: HttpResponseBase): Observable<GetEditionEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEditionEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createEdition(body: CreateEditionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/CreateEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateEdition(body: UpdateEditionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/UpdateEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteEdition(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/DeleteEdition?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    moveTenantsToAnotherEdition(body: MoveTenantsToAnotherEditionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/MoveTenantsToAnotherEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveTenantsToAnotherEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveTenantsToAnotherEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMoveTenantsToAnotherEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param selectedEditionId (optional) 
     * @param addAllItem (optional) 
     * @param onlyFreeItems (optional) 
     * @return Success
     */
    getEditionComboboxItems(selectedEditionId: number | undefined, addAllItem: boolean | undefined, onlyFreeItems: boolean | undefined): Observable<SubscribableEditionComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditionComboboxItems?";
        if (selectedEditionId === null)
            throw new Error("The parameter 'selectedEditionId' cannot be null.");
        else if (selectedEditionId !== undefined)
            url_ += "selectedEditionId=" + encodeURIComponent("" + selectedEditionId) + "&";
        if (addAllItem === null)
            throw new Error("The parameter 'addAllItem' cannot be null.");
        else if (addAllItem !== undefined)
            url_ += "addAllItem=" + encodeURIComponent("" + addAllItem) + "&";
        if (onlyFreeItems === null)
            throw new Error("The parameter 'onlyFreeItems' cannot be null.");
        else if (onlyFreeItems !== undefined)
            url_ += "onlyFreeItems=" + encodeURIComponent("" + onlyFreeItems) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionComboboxItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionComboboxItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscribableEditionComboboxItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscribableEditionComboboxItemDto[]>;
        }));
    }

    protected processGetEditionComboboxItems(response: HttpResponseBase): Observable<SubscribableEditionComboboxItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubscribableEditionComboboxItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param editionId (optional) 
     * @return Success
     */
    getTenantCount(editionId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetTenantCount?";
        if (editionId === null)
            throw new Error("The parameter 'editionId' cannot be null.");
        else if (editionId !== undefined)
            url_ += "editionId=" + encodeURIComponent("" + editionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetTenantCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EhcServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param professionId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createEhc(professionId: string | undefined, body: ApplicationType | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Ehc/CreateEhc?";
        if (professionId === null)
            throw new Error("The parameter 'professionId' cannot be null.");
        else if (professionId !== undefined)
            url_ += "professionId=" + encodeURIComponent("" + professionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEhc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEhc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateEhc(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getEhc(caseId: string | undefined): Observable<GetEhcOutput> {
        let url_ = this.baseUrl + "/api/services/app/Ehc/GetEhc?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEhc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEhc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEhcOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEhcOutput>;
        }));
    }

    protected processGetEhc(response: HttpResponseBase): Observable<GetEhcOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEhcOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getActiveProfessions(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/Ehc/GetActiveProfessions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveProfessions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveProfessions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetActiveProfessions(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getExpenseHealthCarePersonalLicenceForEhc(caseId: string | undefined): Observable<GetEhcPersonalLicenceDto> {
        let url_ = this.baseUrl + "/api/services/app/Ehc/GetExpenseHealthCarePersonalLicenceForEhc?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExpenseHealthCarePersonalLicenceForEhc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExpenseHealthCarePersonalLicenceForEhc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEhcPersonalLicenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEhcPersonalLicenceDto>;
        }));
    }

    protected processGetExpenseHealthCarePersonalLicenceForEhc(response: HttpResponseBase): Observable<GetEhcPersonalLicenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEhcPersonalLicenceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getEhcs(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetEhcApplicationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Ehc/GetEhcs?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEhcs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEhcs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEhcApplicationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEhcApplicationsOutput>;
        }));
    }

    protected processGetEhcs(response: HttpResponseBase): Observable<GetEhcApplicationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEhcApplicationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    canGrantEhc(caseId: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Ehc/CanGrantEhc?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCanGrantEhc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCanGrantEhc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCanGrantEhc(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getNextStatus(caseId: string, status: EhcStatus): Observable<EhcStatus> {
        let url_ = this.baseUrl + "/api/services/app/Ehc/GetNextStatus?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined and cannot be null.");
        else
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcStatus>;
        }));
    }

    protected processGetNextStatus(response: HttpResponseBase): Observable<EhcStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMyEhcs(): Observable<EhcDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Ehc/GetMyEhcs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyEhcs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyEhcs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcDto[]>;
        }));
    }

    protected processGetMyEhcs(response: HttpResponseBase): Observable<EhcDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EhcDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personGln (optional) 
     * @return Success
     */
    getEhcsForPerson(personGln: string | undefined): Observable<EhcDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Ehc/GetEhcsForPerson?";
        if (personGln === null)
            throw new Error("The parameter 'personGln' cannot be null.");
        else if (personGln !== undefined)
            url_ += "personGln=" + encodeURIComponent("" + personGln) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEhcsForPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEhcsForPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcDto[]>;
        }));
    }

    protected processGetEhcsForPerson(response: HttpResponseBase): Observable<EhcDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EhcDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getEvaluationComments(caseId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Ehc/GetEvaluationComments?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvaluationComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvaluationComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetEvaluationComments(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    withdrawEhc(caseId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Ehc/WithdrawEhc?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWithdrawEhc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWithdrawEhc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processWithdrawEhc(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param applicantComment (optional) 
     * @return Success
     */
    releaseEhc(caseId: string | undefined, applicantComment: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Ehc/ReleaseEhc?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (applicantComment === null)
            throw new Error("The parameter 'applicantComment' cannot be null.");
        else if (applicantComment !== undefined)
            url_ += "applicantComment=" + encodeURIComponent("" + applicantComment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseEhc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseEhc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReleaseEhc(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    validateThatAllMandatoryDocumentsHaveBeenUploaded(caseId: string | undefined): Observable<EhcStatus[]> {
        let url_ = this.baseUrl + "/api/services/app/Ehc/ValidateThatAllMandatoryDocumentsHaveBeenUploaded?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcStatus[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcStatus[]>;
        }));
    }

    protected processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response: HttpResponseBase): Observable<EhcStatus[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    hasStep(caseId: string | undefined, body: EhcStatus | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Ehc/HasStep?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasStep(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasStep(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processHasStep(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    hasPostgraduateTitle(caseId: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Ehc/HasPostgraduateTitle?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasPostgraduateTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasPostgraduateTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processHasPostgraduateTitle(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EhcCapServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchEhcCap(body: GetEhcCapSearchInput | undefined): Observable<GetEhcCapSearchOutput> {
        let url_ = this.baseUrl + "/api/services/app/EhcCap/SearchEhcCap";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchEhcCap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchEhcCap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEhcCapSearchOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEhcCapSearchOutput>;
        }));
    }

    protected processSearchEhcCap(response: HttpResponseBase): Observable<GetEhcCapSearchOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEhcCapSearchOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ehcCapId (optional) 
     * @return Success
     */
    getEhcCap(ehcCapId: number | undefined): Observable<EhcCapDto> {
        let url_ = this.baseUrl + "/api/services/app/EhcCap/GetEhcCap?";
        if (ehcCapId === null)
            throw new Error("The parameter 'ehcCapId' cannot be null.");
        else if (ehcCapId !== undefined)
            url_ += "ehcCapId=" + encodeURIComponent("" + ehcCapId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEhcCap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEhcCap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcCapDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcCapDto>;
        }));
    }

    protected processGetEhcCap(response: HttpResponseBase): Observable<EhcCapDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EhcCapDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    postEhcCap(body: CreateOrUpdateEhcCapDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/EhcCap/PostEhcCap";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostEhcCap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostEhcCap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processPostEhcCap(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ehcCapId (optional) 
     * @param body (optional) 
     * @return Success
     */
    putEhcCap(ehcCapId: number | undefined, body: CreateOrUpdateEhcCapDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EhcCap/PutEhcCap?";
        if (ehcCapId === null)
            throw new Error("The parameter 'ehcCapId' cannot be null.");
        else if (ehcCapId !== undefined)
            url_ += "ehcCapId=" + encodeURIComponent("" + ehcCapId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutEhcCap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutEhcCap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutEhcCap(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ehcCapId (optional) 
     * @return Success
     */
    deleteEhcCap(ehcCapId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EhcCap/DeleteEhcCap?";
        if (ehcCapId === null)
            throw new Error("The parameter 'ehcCapId' cannot be null.");
        else if (ehcCapId !== undefined)
            url_ += "ehcCapId=" + encodeURIComponent("" + ehcCapId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEhcCap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEhcCap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteEhcCap(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param postgraduateTitleId (optional) 
     * @param postCode (optional) 
     * @return Success
     */
    isTitleStopped(postgraduateTitleId: string | undefined, postCode: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/EhcCap/IsTitleStopped?";
        if (postgraduateTitleId === null)
            throw new Error("The parameter 'postgraduateTitleId' cannot be null.");
        else if (postgraduateTitleId !== undefined)
            url_ += "postgraduateTitleId=" + encodeURIComponent("" + postgraduateTitleId) + "&";
        if (postCode === null)
            throw new Error("The parameter 'postCode' cannot be null.");
        else if (postCode !== undefined)
            url_ += "postCode=" + encodeURIComponent("" + postCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTitleStopped(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTitleStopped(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsTitleStopped(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    isOneOrMoreTitleStopped(body: GetOneOrMoreTitleStoppedInputDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/EhcCap/IsOneOrMoreTitleStopped";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsOneOrMoreTitleStopped(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsOneOrMoreTitleStopped(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsOneOrMoreTitleStopped(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    importEhcCap(body: ImportEhcCapExcelFileDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EhcCap/ImportEhcCap";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportEhcCap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportEhcCap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportEhcCap(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EhcCapWaitListServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchEhcCapWaitList(body: GetEhcCapWaitListSearchInput | undefined): Observable<GetEhcCapWaitListSearchOutput> {
        let url_ = this.baseUrl + "/api/services/app/EhcCapWaitList/SearchEhcCapWaitList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchEhcCapWaitList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchEhcCapWaitList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEhcCapWaitListSearchOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEhcCapWaitListSearchOutput>;
        }));
    }

    protected processSearchEhcCapWaitList(response: HttpResponseBase): Observable<GetEhcCapWaitListSearchOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEhcCapWaitListSearchOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEhcCapWaitList(id: number | undefined): Observable<EhcCapWaitListEntryDto> {
        let url_ = this.baseUrl + "/api/services/app/EhcCapWaitList/GetEhcCapWaitList?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEhcCapWaitList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEhcCapWaitList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcCapWaitListEntryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcCapWaitListEntryDto>;
        }));
    }

    protected processGetEhcCapWaitList(response: HttpResponseBase): Observable<EhcCapWaitListEntryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EhcCapWaitListEntryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createEhcCapWaitListEntryFromApplication(body: CreateEhcCapWaitListEntryFromApplicationDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/EhcCapWaitList/CreateEhcCapWaitListEntryFromApplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEhcCapWaitListEntryFromApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEhcCapWaitListEntryFromApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateEhcCapWaitListEntryFromApplication(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createEhcCapWaitListEntry(body: CreateEhcCapWaitListEntryDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/EhcCapWaitList/CreateEhcCapWaitListEntry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEhcCapWaitListEntry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEhcCapWaitListEntry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateEhcCapWaitListEntry(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param reason (optional) 
     * @return Success
     */
    deleteEhcCapWaitListEntry(id: number | undefined, reason: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EhcCapWaitList/DeleteEhcCapWaitListEntry?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (reason === null)
            throw new Error("The parameter 'reason' cannot be null.");
        else if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEhcCapWaitListEntry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEhcCapWaitListEntry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteEhcCapWaitListEntry(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    notConsiderWithdrawOrRejectApplication(caseId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EhcCapWaitList/NotConsiderWithdrawOrRejectApplication?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotConsiderWithdrawOrRejectApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotConsiderWithdrawOrRejectApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processNotConsiderWithdrawOrRejectApplication(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    isApplicationOnEhcCapWaitList(caseId: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/EhcCapWaitList/IsApplicationOnEhcCapWaitList?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsApplicationOnEhcCapWaitList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsApplicationOnEhcCapWaitList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsApplicationOnEhcCapWaitList(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    isApplicationDeletedFromEhcCapWaitList(caseId: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/EhcCapWaitList/IsApplicationDeletedFromEhcCapWaitList?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsApplicationDeletedFromEhcCapWaitList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsApplicationDeletedFromEhcCapWaitList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsApplicationDeletedFromEhcCapWaitList(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EhcContactServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getLiaContactReadOnly(caseId: string | undefined): Observable<LiaContactDto> {
        let url_ = this.baseUrl + "/api/services/app/EhcContact/GetLiaContactReadOnly?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLiaContactReadOnly(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLiaContactReadOnly(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaContactDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaContactDto>;
        }));
    }

    protected processGetLiaContactReadOnly(response: HttpResponseBase): Observable<LiaContactDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LiaContactDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    proceedEhcContact(caseId: string | undefined): Observable<EhcStatus> {
        let url_ = this.baseUrl + "/api/services/app/EhcContact/ProceedEhcContact?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProceedEhcContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProceedEhcContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcStatus>;
        }));
    }

    protected processProceedEhcContact(response: HttpResponseBase): Observable<EhcStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateEhcContact(body: CreateOrUpdateEhcContactInput | undefined): Observable<EhcStatus> {
        let url_ = this.baseUrl + "/api/services/app/EhcContact/CreateOrUpdateEhcContact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateEhcContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateEhcContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcStatus>;
        }));
    }

    protected processCreateOrUpdateEhcContact(response: HttpResponseBase): Observable<EhcStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EhcDocumentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getEhcDocuments(caseId: string, step: EhcStatus | undefined): Observable<EhcDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/EhcDocument/GetEhcDocuments?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEhcDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEhcDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcDocumentsOutput>;
        }));
    }

    protected processGetEhcDocuments(response: HttpResponseBase): Observable<EhcDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EhcDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EhcDocument/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getFile(caseId: string, step: EhcStatus | undefined, id: number): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/EhcDocument/GetFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    deleteFile(caseId: string, step: EhcStatus | undefined, id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EhcDocument/DeleteFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EhcElectronicPatientRecordServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateEhcElectronicPatientRecord(body: CreateOrUpdateEhcElectronicPatientRecordInput | undefined): Observable<EhcStatus> {
        let url_ = this.baseUrl + "/api/services/app/EhcElectronicPatientRecord/CreateOrUpdateEhcElectronicPatientRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateEhcElectronicPatientRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateEhcElectronicPatientRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcStatus>;
        }));
    }

    protected processCreateOrUpdateEhcElectronicPatientRecord(response: HttpResponseBase): Observable<EhcStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EhcEmploymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getEmployments(caseId: string | undefined): Observable<EhcEmploymentOutput> {
        let url_ = this.baseUrl + "/api/services/app/EhcEmployment/GetEmployments?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcEmploymentOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcEmploymentOutput>;
        }));
    }

    protected processGetEmployments(response: HttpResponseBase): Observable<EhcEmploymentOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EhcEmploymentOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateEhcEmployments(body: CreateOrUpdateEhcEmploymentsInput | undefined): Observable<CreateOrUpdateEhcEmploymentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/EhcEmployment/CreateOrUpdateEhcEmployments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateEhcEmployments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateEhcEmployments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateEhcEmploymentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateEhcEmploymentsOutput>;
        }));
    }

    protected processCreateOrUpdateEhcEmployments(response: HttpResponseBase): Observable<CreateOrUpdateEhcEmploymentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateEhcEmploymentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EhcInvoiceAddressServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    ehcInvoiceAddressOk(caseId: string | undefined): Observable<EhcStatus> {
        let url_ = this.baseUrl + "/api/services/app/EhcInvoiceAddress/EhcInvoiceAddressOk?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEhcInvoiceAddressOk(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEhcInvoiceAddressOk(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcStatus>;
        }));
    }

    protected processEhcInvoiceAddressOk(response: HttpResponseBase): Observable<EhcStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateEhcInvoiceAddress(body: CreateOrUpdateEhcInvoiceAddressInput | undefined): Observable<EhcStatus> {
        let url_ = this.baseUrl + "/api/services/app/EhcInvoiceAddress/CreateOrUpdateEhcInvoiceAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateEhcInvoiceAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateEhcInvoiceAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcStatus>;
        }));
    }

    protected processCreateOrUpdateEhcInvoiceAddress(response: HttpResponseBase): Observable<EhcStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EhcLanguageSkillServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateEhcLanguageSkill(body: CreateOrUpdateEhcLanguageSkillInput | undefined): Observable<EhcStatus> {
        let url_ = this.baseUrl + "/api/services/app/EhcLanguageSkill/CreateOrUpdateEhcLanguageSkill";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateEhcLanguageSkill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateEhcLanguageSkill(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcStatus>;
        }));
    }

    protected processCreateOrUpdateEhcLanguageSkill(response: HttpResponseBase): Observable<EhcStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EhcMedicalFieldServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getPostgraduateTitles(caseId: string | undefined): Observable<MedRegWbtDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EhcMedicalField/GetPostgraduateTitles?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPostgraduateTitles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPostgraduateTitles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MedRegWbtDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MedRegWbtDto[]>;
        }));
    }

    protected processGetPostgraduateTitles(response: HttpResponseBase): Observable<MedRegWbtDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MedRegWbtDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateEhcMedicalField(body: CreateOrUpdateEhcMedicalFieldInput | undefined): Observable<EhcStatus> {
        let url_ = this.baseUrl + "/api/services/app/EhcMedicalField/CreateOrUpdateEhcMedicalField";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateEhcMedicalField(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateEhcMedicalField(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcStatus>;
        }));
    }

    protected processCreateOrUpdateEhcMedicalField(response: HttpResponseBase): Observable<EhcStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EhcPersonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    proceedEhcPerson(caseId: string | undefined): Observable<EhcStatus> {
        let url_ = this.baseUrl + "/api/services/app/EhcPerson/ProceedEhcPerson?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProceedEhcPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProceedEhcPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcStatus>;
        }));
    }

    protected processProceedEhcPerson(response: HttpResponseBase): Observable<EhcStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateEhcPerson(body: CreateOrUpdateEhcPersonInput | undefined): Observable<EhcStatus> {
        let url_ = this.baseUrl + "/api/services/app/EhcPerson/CreateOrUpdateEhcPerson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateEhcPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateEhcPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcStatus>;
        }));
    }

    protected processCreateOrUpdateEhcPerson(response: HttpResponseBase): Observable<EhcStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EhcPostgraduateTitleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getList(caseId: string | undefined): Observable<EhcPostgraduateTitleDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EhcPostgraduateTitle/GetList?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcPostgraduateTitleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcPostgraduateTitleDto[]>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<EhcPostgraduateTitleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EhcPostgraduateTitleDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateEhcPostgraduateTitles(body: CreateOrUpdateEhcPostgraduateTitlesInput | undefined): Observable<CreateOrUpdateEhcPostgraduateTitlesOutput> {
        let url_ = this.baseUrl + "/api/services/app/EhcPostgraduateTitle/CreateOrUpdateEhcPostgraduateTitles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateEhcPostgraduateTitles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateEhcPostgraduateTitles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateEhcPostgraduateTitlesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateEhcPostgraduateTitlesOutput>;
        }));
    }

    protected processCreateOrUpdateEhcPostgraduateTitles(response: HttpResponseBase): Observable<CreateOrUpdateEhcPostgraduateTitlesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateEhcPostgraduateTitlesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateEhcPostgraduateTitlePractices(body: CreateOrUpdateEhcPostgraduateTitlePracticeInput | undefined): Observable<CreateOrUpdateEhcPostgraduateTitlesOutput> {
        let url_ = this.baseUrl + "/api/services/app/EhcPostgraduateTitle/createOrUpdateEhcPostgraduateTitlePractices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateEhcPostgraduateTitlePractices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateEhcPostgraduateTitlePractices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateEhcPostgraduateTitlesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateEhcPostgraduateTitlesOutput>;
        }));
    }

    protected processCreateOrUpdateEhcPostgraduateTitlePractices(response: HttpResponseBase): Observable<CreateOrUpdateEhcPostgraduateTitlesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateEhcPostgraduateTitlesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param titleId (optional) 
     * @return Success
     */
    createBlankPractice(caseId: string | undefined, titleId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EhcPostgraduateTitle/CreateBlankPractice?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (titleId === null)
            throw new Error("The parameter 'titleId' cannot be null.");
        else if (titleId !== undefined)
            url_ += "titleId=" + encodeURIComponent("" + titleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBlankPractice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBlankPractice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateBlankPractice(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param practiceId (optional) 
     * @return Success
     */
    deletePractice(caseId: string | undefined, practiceId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EhcPostgraduateTitle/DeletePractice?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (practiceId === null)
            throw new Error("The parameter 'practiceId' cannot be null.");
        else if (practiceId !== undefined)
            url_ += "practiceId=" + encodeURIComponent("" + practiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePractice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePractice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePractice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateEhcEmployments(body: CreateOrUpdateEhcEmploymentsInput | undefined): Observable<CreateOrUpdateEhcPostgraduateTitlesOutput> {
        let url_ = this.baseUrl + "/api/services/app/EhcPostgraduateTitle/CreateOrUpdateEhcEmployments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateEhcEmployments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateEhcEmployments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateEhcPostgraduateTitlesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateEhcPostgraduateTitlesOutput>;
        }));
    }

    protected processCreateOrUpdateEhcEmployments(response: HttpResponseBase): Observable<CreateOrUpdateEhcPostgraduateTitlesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateEhcPostgraduateTitlesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param practiceId (optional) 
     * @return Success
     */
    getPracticeFiles(caseId: string, practiceId: string | undefined): Observable<EhcDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/EhcPostgraduateTitle/GetPracticeFiles?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (practiceId === null)
            throw new Error("The parameter 'practiceId' cannot be null.");
        else if (practiceId !== undefined)
            url_ += "PracticeId=" + encodeURIComponent("" + practiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPracticeFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPracticeFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcDocumentsOutput>;
        }));
    }

    protected processGetPracticeFiles(response: HttpResponseBase): Observable<EhcDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EhcDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getFile(caseId: string, step: EhcStatus | undefined, id: number): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/EhcPostgraduateTitle/GetFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param practiceId (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadPracticeFiles(practiceId: string | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EhcPostgraduateTitle/UploadPracticeFiles?";
        if (practiceId === null)
            throw new Error("The parameter 'practiceId' cannot be null.");
        else if (practiceId !== undefined)
            url_ += "practiceId=" + encodeURIComponent("" + practiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadPracticeFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadPracticeFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadPracticeFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    deleteFile(caseId: string, step: EhcStatus | undefined, id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EhcPostgraduateTitle/DeleteFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EhcPracticeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateEhcPractices(body: CreateOrUpdateEhcPracticesInput | undefined): Observable<CreateOrUpdateEhcPracticesOutput> {
        let url_ = this.baseUrl + "/api/services/app/EhcPractice/CreateOrUpdateEhcPractices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateEhcPractices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateEhcPractices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateEhcPracticesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateEhcPracticesOutput>;
        }));
    }

    protected processCreateOrUpdateEhcPractices(response: HttpResponseBase): Observable<CreateOrUpdateEhcPracticesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateEhcPracticesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getEhcPractice(caseId: string | undefined): Observable<EhcPracticeDto> {
        let url_ = this.baseUrl + "/api/services/app/EhcPractice/GetEhcPractice?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEhcPractice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEhcPractice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcPracticeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcPracticeDto>;
        }));
    }

    protected processGetEhcPractice(response: HttpResponseBase): Observable<EhcPracticeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EhcPracticeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    createBlankEhcPracticeRecord(caseId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EhcPractice/CreateBlankEhcPracticeRecord?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBlankEhcPracticeRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBlankEhcPracticeRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateBlankEhcPracticeRecord(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param ehcPracticeRecordId (optional) 
     * @return Success
     */
    deleteEhcPracticeRecord(caseId: string | undefined, ehcPracticeRecordId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EhcPractice/DeleteEhcPracticeRecord?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (ehcPracticeRecordId === null)
            throw new Error("The parameter 'ehcPracticeRecordId' cannot be null.");
        else if (ehcPracticeRecordId !== undefined)
            url_ += "ehcPracticeRecordId=" + encodeURIComponent("" + ehcPracticeRecordId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEhcPracticeRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEhcPracticeRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteEhcPracticeRecord(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getEhcPracticeRecordFiles(caseId: string, step: EhcStatus | undefined): Observable<EhcDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/EhcPractice/GetEhcPracticeRecordFiles?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEhcPracticeRecordFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEhcPracticeRecordFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcDocumentsOutput>;
        }));
    }

    protected processGetEhcPracticeRecordFiles(response: HttpResponseBase): Observable<EhcDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EhcDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ehcPracticeRecordId (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(ehcPracticeRecordId: string | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EhcPractice/UploadFiles?";
        if (ehcPracticeRecordId === null)
            throw new Error("The parameter 'ehcPracticeRecordId' cannot be null.");
        else if (ehcPracticeRecordId !== undefined)
            url_ += "ehcPracticeRecordId=" + encodeURIComponent("" + ehcPracticeRecordId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    deleteFile(caseId: string, step: EhcStatus | undefined, id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EhcPractice/DeleteFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getFile(caseId: string, step: EhcStatus | undefined, id: number): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/EhcPractice/GetFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EhcPracticeConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param professionId (optional) 
     * @return Success
     */
    get(professionId: string | undefined): Observable<EhcPracticeConfigurationDto> {
        let url_ = this.baseUrl + "/api/services/app/EhcPracticeConfiguration/Get?";
        if (professionId === null)
            throw new Error("The parameter 'professionId' cannot be null.");
        else if (professionId !== undefined)
            url_ += "professionId=" + encodeURIComponent("" + professionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcPracticeConfigurationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcPracticeConfigurationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<EhcPracticeConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EhcPracticeConfigurationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateEhcPracticeConfigurationInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EhcPracticeConfiguration/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param professionId (optional) 
     * @return Success
     */
    delete(professionId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EhcPracticeConfiguration/Delete?";
        if (professionId === null)
            throw new Error("The parameter 'professionId' cannot be null.");
        else if (professionId !== undefined)
            url_ += "professionId=" + encodeURIComponent("" + professionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EhcQualityMeasurementServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateEhcQualityMeasurement(body: CreateOrUpdateEhcQualityMeasurementInput | undefined): Observable<EhcStatus> {
        let url_ = this.baseUrl + "/api/services/app/EhcQualityMeasurement/CreateOrUpdateEhcQualityMeasurement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateEhcQualityMeasurement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateEhcQualityMeasurement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcStatus>;
        }));
    }

    protected processCreateOrUpdateEhcQualityMeasurement(response: HttpResponseBase): Observable<EhcStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EhcQualitySupportSystemServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateEhcQualitySupportSystem(body: CreateOrUpdateEhcQualitySupportSystemInput | undefined): Observable<EhcStatus> {
        let url_ = this.baseUrl + "/api/services/app/EhcQualitySupportSystem/CreateOrUpdateEhcQualitySupportSystem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateEhcQualitySupportSystem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateEhcQualitySupportSystem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcStatus>;
        }));
    }

    protected processCreateOrUpdateEhcQualitySupportSystem(response: HttpResponseBase): Observable<EhcStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EhcSelfEmploymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateEhcSelfEmployment(body: CreateOrUpdateEhcSelfEmploymentInput | undefined): Observable<EhcStatus> {
        let url_ = this.baseUrl + "/api/services/app/EhcSelfEmployment/CreateOrUpdateEhcSelfEmployment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateEhcSelfEmployment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateEhcSelfEmployment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcStatus>;
        }));
    }

    protected processCreateOrUpdateEhcSelfEmployment(response: HttpResponseBase): Observable<EhcStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EhcStaffServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateEhcStaff(body: CreateOrUpdateEhcStaffInput | undefined): Observable<EhcStatus> {
        let url_ = this.baseUrl + "/api/services/app/EhcStaff/CreateOrUpdateEhcStaff";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateEhcStaff(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateEhcStaff(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcStatus>;
        }));
    }

    protected processCreateOrUpdateEhcStaff(response: HttpResponseBase): Observable<EhcStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EhcStatusWizardStepServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param professionId (optional) 
     * @param applicationType (optional) 
     * @return Success
     */
    getAllByProfessionId(professionId: string | undefined, applicationType: ApplicationType | undefined): Observable<EhcStatusWizardStepDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EhcStatusWizardStep/GetAllByProfessionId?";
        if (professionId === null)
            throw new Error("The parameter 'professionId' cannot be null.");
        else if (professionId !== undefined)
            url_ += "professionId=" + encodeURIComponent("" + professionId) + "&";
        if (applicationType === null)
            throw new Error("The parameter 'applicationType' cannot be null.");
        else if (applicationType !== undefined)
            url_ += "applicationType=" + encodeURIComponent("" + applicationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByProfessionId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByProfessionId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcStatusWizardStepDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcStatusWizardStepDto[]>;
        }));
    }

    protected processGetAllByProfessionId(response: HttpResponseBase): Observable<EhcStatusWizardStepDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EhcStatusWizardStepDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateEhcStatusWizardStepInput | undefined): Observable<EhcStatusWizardStepDto> {
        let url_ = this.baseUrl + "/api/services/app/EhcStatusWizardStep/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EhcStatusWizardStepDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EhcStatusWizardStepDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<EhcStatusWizardStepDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EhcStatusWizardStepDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMany(body: UpdateEhcStatusWizardStepsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EhcStatusWizardStep/UpdateMany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateMany(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @param professionId (optional) 
     * @param applicationType (optional) 
     * @return Success
     */
    delete(step: number | undefined, professionId: string | undefined, applicationType: ApplicationType | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EhcStatusWizardStep/Delete?";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "step=" + encodeURIComponent("" + step) + "&";
        if (professionId === null)
            throw new Error("The parameter 'professionId' cannot be null.");
        else if (professionId !== undefined)
            url_ += "professionId=" + encodeURIComponent("" + professionId) + "&";
        if (applicationType === null)
            throw new Error("The parameter 'applicationType' cannot be null.");
        else if (applicationType !== undefined)
            url_ += "applicationType=" + encodeURIComponent("" + applicationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EmploymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param personId (optional) 
     * @param sponsorshipId (optional) 
     * @param businessId (optional) 
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getEmployments(personId: number | undefined, sponsorshipId: number | undefined, businessId: number | undefined, filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<EmploymentSearchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Employment/GetEmployments?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "PersonId=" + encodeURIComponent("" + personId) + "&";
        if (sponsorshipId === null)
            throw new Error("The parameter 'sponsorshipId' cannot be null.");
        else if (sponsorshipId !== undefined)
            url_ += "SponsorshipId=" + encodeURIComponent("" + sponsorshipId) + "&";
        if (businessId === null)
            throw new Error("The parameter 'businessId' cannot be null.");
        else if (businessId !== undefined)
            url_ += "BusinessId=" + encodeURIComponent("" + businessId) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmploymentSearchOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmploymentSearchOutputDto>;
        }));
    }

    protected processGetEmployments(response: HttpResponseBase): Observable<EmploymentSearchOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmploymentSearchOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sponsorshipId (optional) 
     * @return Success
     */
    getEmploymentsForSponsorship(sponsorshipId: number | undefined): Observable<GetEmploymentDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Employment/GetEmploymentsForSponsorship?";
        if (sponsorshipId === null)
            throw new Error("The parameter 'sponsorshipId' cannot be null.");
        else if (sponsorshipId !== undefined)
            url_ += "sponsorshipId=" + encodeURIComponent("" + sponsorshipId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmploymentsForSponsorship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmploymentsForSponsorship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmploymentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmploymentDto[]>;
        }));
    }

    protected processGetEmploymentsForSponsorship(response: HttpResponseBase): Observable<GetEmploymentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetEmploymentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sponsorshipId (optional) 
     * @return Success
     */
    getEmploymentsWithSensitiveDataForSponsorship(sponsorshipId: number | undefined): Observable<GetEmploymentDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Employment/GetEmploymentsWithSensitiveDataForSponsorship?";
        if (sponsorshipId === null)
            throw new Error("The parameter 'sponsorshipId' cannot be null.");
        else if (sponsorshipId !== undefined)
            url_ += "sponsorshipId=" + encodeURIComponent("" + sponsorshipId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmploymentsWithSensitiveDataForSponsorship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmploymentsWithSensitiveDataForSponsorship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmploymentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmploymentDto[]>;
        }));
    }

    protected processGetEmploymentsWithSensitiveDataForSponsorship(response: HttpResponseBase): Observable<GetEmploymentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetEmploymentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getActiveMedicalFieldDirectorThatWillBeReplacedOrNull(body: GetActiveMedicalFieldDirectorThatWillBeReplacedInput | undefined): Observable<GetEmploymentDto> {
        let url_ = this.baseUrl + "/api/services/app/Employment/GetActiveMedicalFieldDirectorThatWillBeReplacedOrNull";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveMedicalFieldDirectorThatWillBeReplacedOrNull(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveMedicalFieldDirectorThatWillBeReplacedOrNull(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmploymentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmploymentDto>;
        }));
    }

    protected processGetActiveMedicalFieldDirectorThatWillBeReplacedOrNull(response: HttpResponseBase): Observable<GetEmploymentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEmploymentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getActiveMedicalFieldDirectorThatWillBeReplacedForLicenceOrNull(body: GetActiveMedicalFieldDirectorThatWillBeReplacedForLicenceInput | undefined): Observable<GetEmploymentDto> {
        let url_ = this.baseUrl + "/api/services/app/Employment/GetActiveMedicalFieldDirectorThatWillBeReplacedForLicenceOrNull";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveMedicalFieldDirectorThatWillBeReplacedForLicenceOrNull(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveMedicalFieldDirectorThatWillBeReplacedForLicenceOrNull(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmploymentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmploymentDto>;
        }));
    }

    protected processGetActiveMedicalFieldDirectorThatWillBeReplacedForLicenceOrNull(response: HttpResponseBase): Observable<GetEmploymentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEmploymentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @param typeIds (optional) 
     * @return Success
     */
    getEmploymentsForPerson(personId: number | undefined, typeIds: PersonLicenceType[] | undefined): Observable<GetEmploymentDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Employment/GetEmploymentsForPerson?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (typeIds === null)
            throw new Error("The parameter 'typeIds' cannot be null.");
        else if (typeIds !== undefined)
            typeIds && typeIds.forEach(item => { url_ += "typeIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmploymentsForPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmploymentsForPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmploymentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmploymentDto[]>;
        }));
    }

    protected processGetEmploymentsForPerson(response: HttpResponseBase): Observable<GetEmploymentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetEmploymentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param businessId (optional) 
     * @return Success
     */
    getEmploymentsForBusiness(businessId: number | undefined): Observable<GetEmploymentDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Employment/GetEmploymentsForBusiness?";
        if (businessId === null)
            throw new Error("The parameter 'businessId' cannot be null.");
        else if (businessId !== undefined)
            url_ += "businessId=" + encodeURIComponent("" + businessId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmploymentsForBusiness(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmploymentsForBusiness(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmploymentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmploymentDto[]>;
        }));
    }

    protected processGetEmploymentsForBusiness(response: HttpResponseBase): Observable<GetEmploymentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetEmploymentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<GetEmploymentDto> {
        let url_ = this.baseUrl + "/api/services/app/Employment/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmploymentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmploymentDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetEmploymentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEmploymentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateEmploymentDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Employment/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    update(id: number | undefined, body: UpdateEmploymentDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employment/Update?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    canDelete(id: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Employment/CanDelete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCanDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCanDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCanDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employment/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param employmentId (optional) 
     * @param personId (optional) 
     * @param licenceId (optional) 
     * @return Success
     */
    linkPersonToEmployment(employmentId: number | undefined, personId: number | undefined, licenceId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employment/LinkPersonToEmployment?";
        if (employmentId === null)
            throw new Error("The parameter 'employmentId' cannot be null.");
        else if (employmentId !== undefined)
            url_ += "employmentId=" + encodeURIComponent("" + employmentId) + "&";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (licenceId === null)
            throw new Error("The parameter 'licenceId' cannot be null.");
        else if (licenceId !== undefined)
            url_ += "licenceId=" + encodeURIComponent("" + licenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkPersonToEmployment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkPersonToEmployment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLinkPersonToEmployment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param employmentId (optional) 
     * @return Success
     */
    unlinkPersonFromEmployment(employmentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employment/UnlinkPersonFromEmployment?";
        if (employmentId === null)
            throw new Error("The parameter 'employmentId' cannot be null.");
        else if (employmentId !== undefined)
            url_ += "employmentId=" + encodeURIComponent("" + employmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlinkPersonFromEmployment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlinkPersonFromEmployment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlinkPersonFromEmployment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param employmentId (optional) 
     * @param sponsorshipId (optional) 
     * @return Success
     */
    linkSponsorshipToEmployment(employmentId: number | undefined, sponsorshipId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employment/LinkSponsorshipToEmployment?";
        if (employmentId === null)
            throw new Error("The parameter 'employmentId' cannot be null.");
        else if (employmentId !== undefined)
            url_ += "employmentId=" + encodeURIComponent("" + employmentId) + "&";
        if (sponsorshipId === null)
            throw new Error("The parameter 'sponsorshipId' cannot be null.");
        else if (sponsorshipId !== undefined)
            url_ += "sponsorshipId=" + encodeURIComponent("" + sponsorshipId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkSponsorshipToEmployment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkSponsorshipToEmployment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLinkSponsorshipToEmployment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param employmentId (optional) 
     * @return Success
     */
    unlinkSponsorshipFromEmployment(employmentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employment/UnlinkSponsorshipFromEmployment?";
        if (employmentId === null)
            throw new Error("The parameter 'employmentId' cannot be null.");
        else if (employmentId !== undefined)
            url_ += "employmentId=" + encodeURIComponent("" + employmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlinkSponsorshipFromEmployment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlinkSponsorshipFromEmployment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlinkSponsorshipFromEmployment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param employmentId (optional) 
     * @param businessId (optional) 
     * @return Success
     */
    linkBusinessToExpenseHealthCarePersonalLicenceEmployment(employmentId: number | undefined, businessId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employment/LinkBusinessToExpenseHealthCarePersonalLicenceEmployment?";
        if (employmentId === null)
            throw new Error("The parameter 'employmentId' cannot be null.");
        else if (employmentId !== undefined)
            url_ += "employmentId=" + encodeURIComponent("" + employmentId) + "&";
        if (businessId === null)
            throw new Error("The parameter 'businessId' cannot be null.");
        else if (businessId !== undefined)
            url_ += "businessId=" + encodeURIComponent("" + businessId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkBusinessToExpenseHealthCarePersonalLicenceEmployment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkBusinessToExpenseHealthCarePersonalLicenceEmployment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLinkBusinessToExpenseHealthCarePersonalLicenceEmployment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param employmentId (optional) 
     * @return Success
     */
    unlinkBusinessFromExpenseHealthCarePersonalLicenceEmployment(employmentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employment/UnlinkBusinessFromExpenseHealthCarePersonalLicenceEmployment?";
        if (employmentId === null)
            throw new Error("The parameter 'employmentId' cannot be null.");
        else if (employmentId !== undefined)
            url_ += "employmentId=" + encodeURIComponent("" + employmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlinkBusinessFromExpenseHealthCarePersonalLicenceEmployment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlinkBusinessFromExpenseHealthCarePersonalLicenceEmployment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlinkBusinessFromExpenseHealthCarePersonalLicenceEmployment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param employmentId (optional) 
     * @param businessId (optional) 
     * @return Success
     */
    linkBusinessToEmployment(employmentId: number | undefined, businessId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employment/LinkBusinessToEmployment?";
        if (employmentId === null)
            throw new Error("The parameter 'employmentId' cannot be null.");
        else if (employmentId !== undefined)
            url_ += "employmentId=" + encodeURIComponent("" + employmentId) + "&";
        if (businessId === null)
            throw new Error("The parameter 'businessId' cannot be null.");
        else if (businessId !== undefined)
            url_ += "businessId=" + encodeURIComponent("" + businessId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkBusinessToEmployment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkBusinessToEmployment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLinkBusinessToEmployment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param employmentId (optional) 
     * @return Success
     */
    unlinkBusinessFromEmployment(employmentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Employment/UnlinkBusinessFromEmployment?";
        if (employmentId === null)
            throw new Error("The parameter 'employmentId' cannot be null.");
        else if (employmentId !== undefined)
            url_ += "employmentId=" + encodeURIComponent("" + employmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlinkBusinessFromEmployment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlinkBusinessFromEmployment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlinkBusinessFromEmployment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EmploymentAddressServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<EmploymentAddressDto> {
        let url_ = this.baseUrl + "/api/services/app/EmploymentAddress/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmploymentAddressDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmploymentAddressDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<EmploymentAddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmploymentAddressDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateEmploymentAddressInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmploymentAddress/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FileDossierServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    search(body: GetFileDossierSearchInput | undefined): Observable<GetFileDossierSearchOutput> {
        let url_ = this.baseUrl + "/api/services/app/FileDossier/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFileDossierSearchOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFileDossierSearchOutput>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<GetFileDossierSearchOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFileDossierSearchOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<GetFileDossierDto> {
        let url_ = this.baseUrl + "/api/services/app/FileDossier/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFileDossierDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFileDossierDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetFileDossierDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFileDossierDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @param sponsorshipId (optional) 
     * @param body (optional) 
     * @return Success
     */
    create(personId: number | undefined, sponsorshipId: number | undefined, body: CreateOrUpdateFileDossierDto | undefined): Observable<GetFileDossierDto> {
        let url_ = this.baseUrl + "/api/services/app/FileDossier/Create?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (sponsorshipId === null)
            throw new Error("The parameter 'sponsorshipId' cannot be null.");
        else if (sponsorshipId !== undefined)
            url_ += "sponsorshipId=" + encodeURIComponent("" + sponsorshipId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFileDossierDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFileDossierDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<GetFileDossierDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFileDossierDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    update(id: number | undefined, body: CreateOrUpdateFileDossierDto | undefined): Observable<GetFileDossierDto> {
        let url_ = this.baseUrl + "/api/services/app/FileDossier/Update?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFileDossierDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFileDossierDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<GetFileDossierDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFileDossierDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FileDossier/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param generateXml (optional) 
     * @return Success
     */
    generateZipFileArchive(id: number | undefined, generateXml: boolean | undefined): Observable<GenerateZipFileArchiveOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/FileDossier/GenerateZipFileArchive?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (generateXml === null)
            throw new Error("The parameter 'generateXml' cannot be null.");
        else if (generateXml !== undefined)
            url_ += "generateXml=" + encodeURIComponent("" + generateXml) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateZipFileArchive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateZipFileArchive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenerateZipFileArchiveOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenerateZipFileArchiveOutputDto>;
        }));
    }

    protected processGenerateZipFileArchive(response: HttpResponseBase): Observable<GenerateZipFileArchiveOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenerateZipFileArchiveOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FriendshipServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createFriendshipRequest(body: CreateFriendshipRequestInput | undefined): Observable<FriendDto> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/CreateFriendshipRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFriendshipRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFriendshipRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FriendDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FriendDto>;
        }));
    }

    protected processCreateFriendshipRequest(response: HttpResponseBase): Observable<FriendDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FriendDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createFriendshipRequestByUserName(body: CreateFriendshipRequestByUserNameInput | undefined): Observable<FriendDto> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/CreateFriendshipRequestByUserName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFriendshipRequestByUserName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFriendshipRequestByUserName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FriendDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FriendDto>;
        }));
    }

    protected processCreateFriendshipRequestByUserName(response: HttpResponseBase): Observable<FriendDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FriendDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    blockUser(body: BlockUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/BlockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBlockUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBlockUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBlockUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unblockUser(body: UnblockUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/UnblockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnblockUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnblockUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnblockUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    acceptFriendshipRequest(body: AcceptFriendshipRequestInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/AcceptFriendshipRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptFriendshipRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptFriendshipRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAcceptFriendshipRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) The field UserId must be between 1 and 9.223372036854776E+18.
     * @param tenantId (optional) 
     * @return Success
     */
    removeFriend(userId: number | undefined, tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/RemoveFriend?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveFriend(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveFriend(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveFriend(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HealthRegCachingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param externalSystem (optional) 
     * @return Success
     */
    getExportCache(externalSystem: ExternalSystemEnum | undefined): Observable<HealthRegExportCacheOutput> {
        let url_ = this.baseUrl + "/api/services/app/HealthRegCaching/GetExportCache?";
        if (externalSystem === null)
            throw new Error("The parameter 'externalSystem' cannot be null.");
        else if (externalSystem !== undefined)
            url_ += "externalSystem=" + encodeURIComponent("" + externalSystem) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExportCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExportCache(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HealthRegExportCacheOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HealthRegExportCacheOutput>;
        }));
    }

    protected processGetExportCache(response: HttpResponseBase): Observable<HealthRegExportCacheOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthRegExportCacheOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    importCache(body: HealthRegExportCacheInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/HealthRegCaching/ImportCache";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportCache(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processImportCache(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HostDashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getTopStatsData(startDate: DateTime | undefined, endDate: DateTime | undefined): Observable<TopStatsData> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetTopStatsData?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTopStatsData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTopStatsData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TopStatsData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TopStatsData>;
        }));
    }

    protected processGetTopStatsData(response: HttpResponseBase): Observable<TopStatsData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TopStatsData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getRecentTenantsData(): Observable<GetRecentTenantsOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetRecentTenantsData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentTenantsData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentTenantsData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRecentTenantsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRecentTenantsOutput>;
        }));
    }

    protected processGetRecentTenantsData(response: HttpResponseBase): Observable<GetRecentTenantsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRecentTenantsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getSubscriptionExpiringTenantsData(): Observable<GetExpiringTenantsOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetSubscriptionExpiringTenantsData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubscriptionExpiringTenantsData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscriptionExpiringTenantsData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetExpiringTenantsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetExpiringTenantsOutput>;
        }));
    }

    protected processGetSubscriptionExpiringTenantsData(response: HttpResponseBase): Observable<GetExpiringTenantsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetExpiringTenantsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param incomeStatisticsDateInterval (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getIncomeStatistics(incomeStatisticsDateInterval: ChartDateInterval | undefined, startDate: DateTime | undefined, endDate: DateTime | undefined): Observable<GetIncomeStatisticsDataOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetIncomeStatistics?";
        if (incomeStatisticsDateInterval === null)
            throw new Error("The parameter 'incomeStatisticsDateInterval' cannot be null.");
        else if (incomeStatisticsDateInterval !== undefined)
            url_ += "IncomeStatisticsDateInterval=" + encodeURIComponent("" + incomeStatisticsDateInterval) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncomeStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncomeStatistics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetIncomeStatisticsDataOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetIncomeStatisticsDataOutput>;
        }));
    }

    protected processGetIncomeStatistics(response: HttpResponseBase): Observable<GetIncomeStatisticsDataOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetIncomeStatisticsDataOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getEditionTenantStatistics(startDate: DateTime | undefined, endDate: DateTime | undefined): Observable<GetEditionTenantStatisticsOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetEditionTenantStatistics?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionTenantStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionTenantStatistics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEditionTenantStatisticsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEditionTenantStatisticsOutput>;
        }));
    }

    protected processGetEditionTenantStatistics(response: HttpResponseBase): Observable<GetEditionTenantStatisticsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEditionTenantStatisticsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HostSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getAllSettings(): Observable<HostSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HostSettingsEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HostSettingsEditDto>;
        }));
    }

    protected processGetAllSettings(response: HttpResponseBase): Observable<HostSettingsEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HostSettingsEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAllSettings(body: HostSettingsEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAllSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendTestEmail(body: SendTestEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendTestEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEnabledSocialLoginSettings(): Observable<ExternalLoginSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/GetEnabledSocialLoginSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEnabledSocialLoginSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEnabledSocialLoginSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalLoginSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalLoginSettingsDto>;
        }));
    }

    protected processGetEnabledSocialLoginSettings(response: HttpResponseBase): Observable<ExternalLoginSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalLoginSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InstallServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setup(body: InstallDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Install/Setup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAppSettingsJson(): Observable<AppSettingsJsonDto> {
        let url_ = this.baseUrl + "/api/services/app/Install/GetAppSettingsJson";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppSettingsJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppSettingsJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppSettingsJsonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppSettingsJsonDto>;
        }));
    }

    protected processGetAppSettingsJson(response: HttpResponseBase): Observable<AppSettingsJsonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppSettingsJsonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    checkDatabase(): Observable<CheckDatabaseOutput> {
        let url_ = this.baseUrl + "/api/services/app/Install/CheckDatabase";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckDatabase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckDatabase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckDatabaseOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckDatabaseOutput>;
        }));
    }

    protected processCheckDatabase(response: HttpResponseBase): Observable<CheckDatabaseOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckDatabaseOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InvoiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getInvoiceInfo(id: number | undefined): Observable<InvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetInvoiceInfo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoiceInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoiceInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDto>;
        }));
    }

    protected processGetInvoiceInfo(response: HttpResponseBase): Observable<InvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createInvoice(body: CreateInvoiceDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/CreateInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateInvoice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class JobsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    pause(jobName: string, groupName: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/jobs/{groupName}/{jobName}/pause";
        if (jobName === undefined || jobName === null)
            throw new Error("The parameter 'jobName' must be defined.");
        url_ = url_.replace("{jobName}", encodeURIComponent("" + jobName));
        if (groupName === undefined || groupName === null)
            throw new Error("The parameter 'groupName' must be defined.");
        url_ = url_.replace("{groupName}", encodeURIComponent("" + groupName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPause(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPause(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPause(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    resume(jobName: string, groupName: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/jobs/{groupName}/{jobName}/resume";
        if (jobName === undefined || jobName === null)
            throw new Error("The parameter 'jobName' must be defined.");
        url_ = url_.replace("{jobName}", encodeURIComponent("" + jobName));
        if (groupName === undefined || groupName === null)
            throw new Error("The parameter 'groupName' must be defined.");
        url_ = url_.replace("{groupName}", encodeURIComponent("" + groupName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResume(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResume(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResume(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    trigger(jobName: string, groupName: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/jobs/{groupName}/{jobName}/trigger";
        if (jobName === undefined || jobName === null)
            throw new Error("The parameter 'jobName' must be defined.");
        url_ = url_.replace("{jobName}", encodeURIComponent("" + jobName));
        if (groupName === undefined || groupName === null)
            throw new Error("The parameter 'groupName' must be defined.");
        url_ = url_.replace("{groupName}", encodeURIComponent("" + groupName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrigger(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrigger(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTrigger(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    cancel(jobName: string, groupName: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/jobs/{groupName}/{jobName}/cancel";
        if (jobName === undefined || jobName === null)
            throw new Error("The parameter 'jobName' must be defined.");
        url_ = url_.replace("{jobName}", encodeURIComponent("" + jobName));
        if (groupName === undefined || groupName === null)
            throw new Error("The parameter 'groupName' must be defined.");
        url_ = url_.replace("{groupName}", encodeURIComponent("" + groupName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    jobInfoList(): Observable<GetJobInfoListOutput> {
        let url_ = this.baseUrl + "/api/services/jobs/job-info-list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processJobInfoList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processJobInfoList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetJobInfoListOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetJobInfoListOutput>;
        }));
    }

    protected processJobInfoList(response: HttpResponseBase): Observable<GetJobInfoListOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetJobInfoListOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class JobOutputFilesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param type (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    search(type: JobOutputFileType | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetJobOutputFilesResult> {
        let url_ = this.baseUrl + "/api/services/job-output-files/search?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetJobOutputFilesResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetJobOutputFilesResult>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<GetJobOutputFilesResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetJobOutputFilesResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    file(id: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/job-output-files/{id}/file";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LanguageServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getLanguages(): Observable<GetLanguagesOutput> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLanguagesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLanguagesOutput>;
        }));
    }

    protected processGetLanguages(response: HttpResponseBase): Observable<GetLanguagesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLanguagesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getLanguageForEdit(id: number | undefined): Observable<GetLanguageForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguageForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguageForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguageForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLanguageForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLanguageForEditOutput>;
        }));
    }

    protected processGetLanguageForEdit(response: HttpResponseBase): Observable<GetLanguageForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLanguageForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLanguage(body: CreateOrUpdateLanguageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/CreateOrUpdateLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteLanguage(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/DeleteLanguage?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setDefaultLanguage(body: SetDefaultLanguageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/SetDefaultLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetDefaultLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDefaultLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetDefaultLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param baseLanguageName (optional) 
     * @return Success
     */
    getLanguageTextForEdit(sourceName: string, baseLanguageName: string | undefined, targetLanguageName: string, baseValueKey: string): Observable<LanguageTextListDto> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguageTextForEdit?";
        if (sourceName === undefined || sourceName === null)
            throw new Error("The parameter 'sourceName' must be defined and cannot be null.");
        else
            url_ += "SourceName=" + encodeURIComponent("" + sourceName) + "&";
        if (baseLanguageName === null)
            throw new Error("The parameter 'baseLanguageName' cannot be null.");
        else if (baseLanguageName !== undefined)
            url_ += "BaseLanguageName=" + encodeURIComponent("" + baseLanguageName) + "&";
        if (targetLanguageName === undefined || targetLanguageName === null)
            throw new Error("The parameter 'targetLanguageName' must be defined and cannot be null.");
        else
            url_ += "TargetLanguageName=" + encodeURIComponent("" + targetLanguageName) + "&";
        if (baseValueKey === undefined || baseValueKey === null)
            throw new Error("The parameter 'baseValueKey' must be defined and cannot be null.");
        else
            url_ += "BaseValueKey=" + encodeURIComponent("" + baseValueKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguageTextForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguageTextForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LanguageTextListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LanguageTextListDto>;
        }));
    }

    protected processGetLanguageTextForEdit(response: HttpResponseBase): Observable<LanguageTextListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LanguageTextListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param maxResultCount (optional) The field MaxResultCount must be between 0 and 2147483647.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @param sorting (optional) 
     * @param baseLanguageName (optional) 
     * @param targetValueFilter (optional) 
     * @param filterText (optional) 
     * @return Success
     */
    getLanguageTexts(maxResultCount: number | undefined, skipCount: number | undefined, sorting: string | undefined, sourceName: string, baseLanguageName: string | undefined, targetLanguageName: string, targetValueFilter: string | undefined, filterText: string | undefined): Observable<PagedResultDtoOfLanguageTextListDto> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguageTexts?";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (sourceName === undefined || sourceName === null)
            throw new Error("The parameter 'sourceName' must be defined and cannot be null.");
        else
            url_ += "SourceName=" + encodeURIComponent("" + sourceName) + "&";
        if (baseLanguageName === null)
            throw new Error("The parameter 'baseLanguageName' cannot be null.");
        else if (baseLanguageName !== undefined)
            url_ += "BaseLanguageName=" + encodeURIComponent("" + baseLanguageName) + "&";
        if (targetLanguageName === undefined || targetLanguageName === null)
            throw new Error("The parameter 'targetLanguageName' must be defined and cannot be null.");
        else
            url_ += "TargetLanguageName=" + encodeURIComponent("" + targetLanguageName) + "&";
        if (targetValueFilter === null)
            throw new Error("The parameter 'targetValueFilter' cannot be null.");
        else if (targetValueFilter !== undefined)
            url_ += "TargetValueFilter=" + encodeURIComponent("" + targetValueFilter) + "&";
        if (filterText === null)
            throw new Error("The parameter 'filterText' cannot be null.");
        else if (filterText !== undefined)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguageTexts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguageTexts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLanguageTextListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLanguageTextListDto>;
        }));
    }

    protected processGetLanguageTexts(response: HttpResponseBase): Observable<PagedResultDtoOfLanguageTextListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLanguageTextListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateLanguageText(body: UpdateLanguageTextInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/UpdateLanguageText";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLanguageText(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLanguageText(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateLanguageText(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LiaAcademicTitleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLiaAcademicTitle(body: CreateOrUpdateLiaAcademicTitleInput | undefined): Observable<CreateOrUpdateLiaAcademicTitleOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaAcademicTitle/CreateOrUpdateLiaAcademicTitle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLiaAcademicTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLiaAcademicTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateLiaAcademicTitleOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateLiaAcademicTitleOutput>;
        }));
    }

    protected processCreateOrUpdateLiaAcademicTitle(response: HttpResponseBase): Observable<CreateOrUpdateLiaAcademicTitleOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateLiaAcademicTitleOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    createBlankLiaAcademicTitle(caseId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/LiaAcademicTitle/CreateBlankLiaAcademicTitle?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBlankLiaAcademicTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBlankLiaAcademicTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateBlankLiaAcademicTitle(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param academicTitleId (optional) 
     * @return Success
     */
    deleteLiaAcademicTitle(caseId: string | undefined, academicTitleId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LiaAcademicTitle/DeleteLiaAcademicTitle?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (academicTitleId === null)
            throw new Error("The parameter 'academicTitleId' cannot be null.");
        else if (academicTitleId !== undefined)
            url_ += "academicTitleId=" + encodeURIComponent("" + academicTitleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLiaAcademicTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLiaAcademicTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteLiaAcademicTitle(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getLiaAcademicTitleFiles(caseId: string, step: LiaStatus | undefined): Observable<LiaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaAcademicTitle/GetLiaAcademicTitleFiles?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLiaAcademicTitleFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLiaAcademicTitleFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaDocumentsOutput>;
        }));
    }

    protected processGetLiaAcademicTitleFiles(response: HttpResponseBase): Observable<LiaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LiaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param liaAcademicTitleId (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(liaAcademicTitleId: string | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LiaAcademicTitle/UploadFiles?";
        if (liaAcademicTitleId === null)
            throw new Error("The parameter 'liaAcademicTitleId' cannot be null.");
        else if (liaAcademicTitleId !== undefined)
            url_ += "liaAcademicTitleId=" + encodeURIComponent("" + liaAcademicTitleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LiaContactServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLiaContact(body: CreateOrUpdateLiaContactInput | undefined): Observable<LiaStatus> {
        let url_ = this.baseUrl + "/api/services/app/LiaContact/CreateOrUpdateLiaContact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLiaContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLiaContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaStatus>;
        }));
    }

    protected processCreateOrUpdateLiaContact(response: HttpResponseBase): Observable<LiaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LiaContactDuringEmploymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLiaContactDuringEmployment(body: CreateOrUpdateLiaContactDuringEmploymentInput | undefined): Observable<LiaStatus> {
        let url_ = this.baseUrl + "/api/services/app/LiaContactDuringEmployment/CreateOrUpdateLiaContactDuringEmployment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLiaContactDuringEmployment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLiaContactDuringEmployment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaStatus>;
        }));
    }

    protected processCreateOrUpdateLiaContactDuringEmployment(response: HttpResponseBase): Observable<LiaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LiaDiplomaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLiaDiploma(body: CreateOrUpdateLiaDiplomaInput | undefined): Observable<LiaStatus> {
        let url_ = this.baseUrl + "/api/services/app/LiaDiploma/CreateOrUpdateLiaDiploma";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLiaDiploma(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLiaDiploma(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaStatus>;
        }));
    }

    protected processCreateOrUpdateLiaDiploma(response: HttpResponseBase): Observable<LiaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LiaDocumentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getDocuments(caseId: string, step: LiaStatus | undefined): Observable<LiaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaDocument/GetDocuments?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaDocumentsOutput>;
        }));
    }

    protected processGetDocuments(response: HttpResponseBase): Observable<LiaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LiaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LiaDocument/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    deleteFile(caseId: string, step: LiaStatus | undefined, id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LiaDocument/DeleteFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getFile(caseId: string, step: LiaStatus | undefined, id: number): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/LiaDocument/GetFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    fileUploadCompleted(caseId: string | undefined): Observable<LiaStatus> {
        let url_ = this.baseUrl + "/api/services/app/LiaDocument/FileUploadCompleted?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFileUploadCompleted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFileUploadCompleted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaStatus>;
        }));
    }

    protected processFileUploadCompleted(response: HttpResponseBase): Observable<LiaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getLiaDocuments(caseId: string, step: LiaStatus | undefined): Observable<LiaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaDocument/GetLiaDocuments?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLiaDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLiaDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaDocumentsOutput>;
        }));
    }

    protected processGetLiaDocuments(response: HttpResponseBase): Observable<LiaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LiaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LiaEmploymentBServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLiaEmploymentsB(body: CreateOrUpdateLiaEmploymentBInput | undefined): Observable<LiaStatus> {
        let url_ = this.baseUrl + "/api/services/app/LiaEmploymentB/CreateOrUpdateLiaEmploymentsB";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLiaEmploymentsB(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLiaEmploymentsB(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaStatus>;
        }));
    }

    protected processCreateOrUpdateLiaEmploymentsB(response: HttpResponseBase): Observable<LiaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getLiaEmploymentBFiles(caseId: string, step: LiaStatus | undefined): Observable<LiaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaEmploymentB/GetLiaEmploymentBFiles?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLiaEmploymentBFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLiaEmploymentBFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaDocumentsOutput>;
        }));
    }

    protected processGetLiaEmploymentBFiles(response: HttpResponseBase): Observable<LiaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LiaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LiaEmploymentB/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    createBlankLiaEmploymentBRecord(caseId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/LiaEmploymentB/CreateBlankLiaEmploymentBRecord?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBlankLiaEmploymentBRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBlankLiaEmploymentBRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateBlankLiaEmploymentBRecord(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param recordId (optional) 
     * @return Success
     */
    deleteLiaEmploymentBRecord(caseId: string | undefined, recordId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LiaEmploymentB/DeleteLiaEmploymentBRecord?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (recordId === null)
            throw new Error("The parameter 'recordId' cannot be null.");
        else if (recordId !== undefined)
            url_ += "recordId=" + encodeURIComponent("" + recordId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLiaEmploymentBRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLiaEmploymentBRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteLiaEmploymentBRecord(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param typeOfEmploymentId (optional) 
     * @param isMobileEmploymentId (optional) 
     * @param requestsVaccinationLicenceId (optional) 
     * @return Success
     */
    getLiaEmploymentBRecordFiles(caseId: string, typeOfEmploymentId: string | undefined, isMobileEmploymentId: string | undefined, requestsVaccinationLicenceId: string | undefined): Observable<LiaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaEmploymentB/GetLiaEmploymentBRecordFiles?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (typeOfEmploymentId === null)
            throw new Error("The parameter 'typeOfEmploymentId' cannot be null.");
        else if (typeOfEmploymentId !== undefined)
            url_ += "TypeOfEmploymentId=" + encodeURIComponent("" + typeOfEmploymentId) + "&";
        if (isMobileEmploymentId === null)
            throw new Error("The parameter 'isMobileEmploymentId' cannot be null.");
        else if (isMobileEmploymentId !== undefined)
            url_ += "IsMobileEmploymentId=" + encodeURIComponent("" + isMobileEmploymentId) + "&";
        if (requestsVaccinationLicenceId === null)
            throw new Error("The parameter 'requestsVaccinationLicenceId' cannot be null.");
        else if (requestsVaccinationLicenceId !== undefined)
            url_ += "RequestsVaccinationLicenceId=" + encodeURIComponent("" + requestsVaccinationLicenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLiaEmploymentBRecordFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLiaEmploymentBRecordFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaDocumentsOutput>;
        }));
    }

    protected processGetLiaEmploymentBRecordFiles(response: HttpResponseBase): Observable<LiaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LiaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param liaEmploymentBId (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadRecordFiles(liaEmploymentBId: string | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LiaEmploymentB/UploadRecordFiles?";
        if (liaEmploymentBId === null)
            throw new Error("The parameter 'liaEmploymentBId' cannot be null.");
        else if (liaEmploymentBId !== undefined)
            url_ += "liaEmploymentBId=" + encodeURIComponent("" + liaEmploymentBId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadRecordFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadRecordFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadRecordFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LiaGuaranteeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    proceed(caseId: string | undefined): Observable<LiaStatus> {
        let url_ = this.baseUrl + "/api/services/app/LiaGuarantee/Proceed?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProceed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProceed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaStatus>;
        }));
    }

    protected processProceed(response: HttpResponseBase): Observable<LiaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getLiaGuaranteeFiles(caseId: string, step: LiaStatus | undefined): Observable<LiaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaGuarantee/GetLiaGuaranteeFiles?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLiaGuaranteeFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLiaGuaranteeFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaDocumentsOutput>;
        }));
    }

    protected processGetLiaGuaranteeFiles(response: HttpResponseBase): Observable<LiaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LiaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LiaGuarantee/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LiaInvoiceAddressServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLiaInvoiceAddress(body: CreateOrUpdateLiaInvoiceAddressInput | undefined): Observable<LiaStatus> {
        let url_ = this.baseUrl + "/api/services/app/LiaInvoiceAddress/CreateOrUpdateLiaInvoiceAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLiaInvoiceAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLiaInvoiceAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaStatus>;
        }));
    }

    protected processCreateOrUpdateLiaInvoiceAddress(response: HttpResponseBase): Observable<LiaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LiaLanguageSkillServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLiaLanguageSkill(body: CreateOrUpdateLiaLanguageSkillInput | undefined): Observable<LiaStatus> {
        let url_ = this.baseUrl + "/api/services/app/LiaLanguageSkill/CreateOrUpdateLiaLanguageSkill";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLiaLanguageSkill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLiaLanguageSkill(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaStatus>;
        }));
    }

    protected processCreateOrUpdateLiaLanguageSkill(response: HttpResponseBase): Observable<LiaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getLiaLanguageSkillDocuments(caseId: string, step: LiaStatus | undefined): Observable<LiaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaLanguageSkill/GetLiaLanguageSkillDocuments?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLiaLanguageSkillDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLiaLanguageSkillDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaDocumentsOutput>;
        }));
    }

    protected processGetLiaLanguageSkillDocuments(response: HttpResponseBase): Observable<LiaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LiaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LiaLanguageSkill/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LiaLanguageSkillBServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLiaLanguageSkillB(body: CreateOrUpdateLiaLanguageSkillBInput | undefined): Observable<LiaStatus> {
        let url_ = this.baseUrl + "/api/services/app/LiaLanguageSkillB/CreateOrUpdateLiaLanguageSkillB";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLiaLanguageSkillB(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLiaLanguageSkillB(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaStatus>;
        }));
    }

    protected processCreateOrUpdateLiaLanguageSkillB(response: HttpResponseBase): Observable<LiaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getLiaLanguageSkillBDocuments(caseId: string, step: LiaStatus | undefined): Observable<LiaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaLanguageSkillB/GetLiaLanguageSkillBDocuments?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLiaLanguageSkillBDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLiaLanguageSkillBDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaDocumentsOutput>;
        }));
    }

    protected processGetLiaLanguageSkillBDocuments(response: HttpResponseBase): Observable<LiaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LiaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LiaLanguageSkillB/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LiaLicenceInAnotherCantonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLiaLicenceInAnotherCanton(body: CreateOrUpdateLiaLicenceInAnotherCantonInput | undefined): Observable<LiaStatus> {
        let url_ = this.baseUrl + "/api/services/app/LiaLicenceInAnotherCanton/CreateOrUpdateLiaLicenceInAnotherCanton";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLiaLicenceInAnotherCanton(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLiaLicenceInAnotherCanton(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaStatus>;
        }));
    }

    protected processCreateOrUpdateLiaLicenceInAnotherCanton(response: HttpResponseBase): Observable<LiaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @param hasLicenceId (optional) 
     * @param hasAnyUnsuccessfulLicenceApplicationId (optional) 
     * @param hasRegistryEntry (optional) 
     * @return Success
     */
    getDocuments(caseId: string, step: LiaStatus | undefined, hasLicenceId: string | undefined, hasAnyUnsuccessfulLicenceApplicationId: string | undefined, hasRegistryEntry: boolean | undefined): Observable<LiaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaLicenceInAnotherCanton/GetDocuments?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (hasLicenceId === null)
            throw new Error("The parameter 'hasLicenceId' cannot be null.");
        else if (hasLicenceId !== undefined)
            url_ += "hasLicenceId=" + encodeURIComponent("" + hasLicenceId) + "&";
        if (hasAnyUnsuccessfulLicenceApplicationId === null)
            throw new Error("The parameter 'hasAnyUnsuccessfulLicenceApplicationId' cannot be null.");
        else if (hasAnyUnsuccessfulLicenceApplicationId !== undefined)
            url_ += "hasAnyUnsuccessfulLicenceApplicationId=" + encodeURIComponent("" + hasAnyUnsuccessfulLicenceApplicationId) + "&";
        if (hasRegistryEntry === null)
            throw new Error("The parameter 'hasRegistryEntry' cannot be null.");
        else if (hasRegistryEntry !== undefined)
            url_ += "hasRegistryEntry=" + encodeURIComponent("" + hasRegistryEntry) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaDocumentsOutput>;
        }));
    }

    protected processGetDocuments(response: HttpResponseBase): Observable<LiaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LiaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LiaPersonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLiaPersonWithRegisterCheck(body: CreateOrUpdateLiaPersonWithRegisterCheckInput | undefined): Observable<CreateOrUpdateLiaPersonOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/LiaPerson/CreateOrUpdateLiaPersonWithRegisterCheck";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLiaPersonWithRegisterCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLiaPersonWithRegisterCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateLiaPersonOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateLiaPersonOutputDto>;
        }));
    }

    protected processCreateOrUpdateLiaPersonWithRegisterCheck(response: HttpResponseBase): Observable<CreateOrUpdateLiaPersonOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateLiaPersonOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLiaPersonExtended(body: CreateOrUpdateLiaPersonExtendedInput | undefined): Observable<CreateOrUpdateLiaPersonExtendedOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaPerson/CreateOrUpdateLiaPersonExtended";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLiaPersonExtended(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLiaPersonExtended(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateLiaPersonExtendedOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateLiaPersonExtendedOutput>;
        }));
    }

    protected processCreateOrUpdateLiaPersonExtended(response: HttpResponseBase): Observable<CreateOrUpdateLiaPersonExtendedOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateLiaPersonExtendedOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    updateGlnIfMedRegId(caseId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/LiaPerson/UpdateGlnIfMedRegId?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateGlnIfMedRegId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateGlnIfMedRegId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateGlnIfMedRegId(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    acceptRegisterCheck(caseId: string | undefined): Observable<LiaStatus> {
        let url_ = this.baseUrl + "/api/services/app/LiaPerson/AcceptRegisterCheck?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptRegisterCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptRegisterCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaStatus>;
        }));
    }

    protected processAcceptRegisterCheck(response: HttpResponseBase): Observable<LiaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @param hasLicenceInAnotherCanton (optional) 
     * @param nationality (optional) 
     * @return Success
     */
    getLiaPersonDocuments(caseId: string, step: LiaStatus | undefined, hasLicenceInAnotherCanton: boolean | undefined, nationality: string | undefined): Observable<LiaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaPerson/GetLiaPersonDocuments?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (hasLicenceInAnotherCanton === null)
            throw new Error("The parameter 'hasLicenceInAnotherCanton' cannot be null.");
        else if (hasLicenceInAnotherCanton !== undefined)
            url_ += "hasLicenceInAnotherCanton=" + encodeURIComponent("" + hasLicenceInAnotherCanton) + "&";
        if (nationality === null)
            throw new Error("The parameter 'nationality' cannot be null.");
        else if (nationality !== undefined)
            url_ += "nationality=" + encodeURIComponent("" + nationality) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLiaPersonDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLiaPersonDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaDocumentsOutput>;
        }));
    }

    protected processGetLiaPersonDocuments(response: HttpResponseBase): Observable<LiaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LiaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LiaPerson/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LiaPostgraduateTitleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLiaPostgraduateTitles(body: CreateOrUpdateLiaPostgraduateTitleInput | undefined): Observable<CreateOrUpdateLiaPostgraduateTitleOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaPostgraduateTitle/CreateOrUpdateLiaPostgraduateTitles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLiaPostgraduateTitles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLiaPostgraduateTitles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateLiaPostgraduateTitleOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateLiaPostgraduateTitleOutput>;
        }));
    }

    protected processCreateOrUpdateLiaPostgraduateTitles(response: HttpResponseBase): Observable<CreateOrUpdateLiaPostgraduateTitleOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateLiaPostgraduateTitleOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LiaPostgraduateTitlePrivateLawServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLiaPostgraduateTitlePrivateLaw(body: CreateOrUpdateLiaPostgraduateTitlePrivateLawInput | undefined): Observable<CreateOrUpdateLiaPostgraduateTitlePrivateLawOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaPostgraduateTitlePrivateLaw/CreateOrUpdateLiaPostgraduateTitlePrivateLaw";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLiaPostgraduateTitlePrivateLaw(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLiaPostgraduateTitlePrivateLaw(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateLiaPostgraduateTitlePrivateLawOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateLiaPostgraduateTitlePrivateLawOutput>;
        }));
    }

    protected processCreateOrUpdateLiaPostgraduateTitlePrivateLaw(response: HttpResponseBase): Observable<CreateOrUpdateLiaPostgraduateTitlePrivateLawOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateLiaPostgraduateTitlePrivateLawOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    createBlankLiaPostgraduateTitlePrivateLaw(caseId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/LiaPostgraduateTitlePrivateLaw/CreateBlankLiaPostgraduateTitlePrivateLaw?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBlankLiaPostgraduateTitlePrivateLaw(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBlankLiaPostgraduateTitlePrivateLaw(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateBlankLiaPostgraduateTitlePrivateLaw(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param privateContinuingEducationId (optional) 
     * @return Success
     */
    deletePrivateLiaPostgraduateTitlePrivateLaw(caseId: string | undefined, privateContinuingEducationId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LiaPostgraduateTitlePrivateLaw/DeletePrivateLiaPostgraduateTitlePrivateLaw?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (privateContinuingEducationId === null)
            throw new Error("The parameter 'privateContinuingEducationId' cannot be null.");
        else if (privateContinuingEducationId !== undefined)
            url_ += "privateContinuingEducationId=" + encodeURIComponent("" + privateContinuingEducationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePrivateLiaPostgraduateTitlePrivateLaw(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePrivateLiaPostgraduateTitlePrivateLaw(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePrivateLiaPostgraduateTitlePrivateLaw(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param titleId (optional) 
     * @return Success
     */
    getFiles(caseId: string, titleId: string | undefined): Observable<LiaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaPostgraduateTitlePrivateLaw/GetFiles?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (titleId === null)
            throw new Error("The parameter 'titleId' cannot be null.");
        else if (titleId !== undefined)
            url_ += "TitleId=" + encodeURIComponent("" + titleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaDocumentsOutput>;
        }));
    }

    protected processGetFiles(response: HttpResponseBase): Observable<LiaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LiaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param titleId (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(titleId: string | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LiaPostgraduateTitlePrivateLaw/UploadFiles?";
        if (titleId === null)
            throw new Error("The parameter 'titleId' cannot be null.");
        else if (titleId !== undefined)
            url_ += "titleId=" + encodeURIComponent("" + titleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    deleteFile(caseId: string, step: LiaStatus | undefined, id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LiaPostgraduateTitlePrivateLaw/DeleteFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getFile(caseId: string, step: LiaStatus | undefined, id: number): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/LiaPostgraduateTitlePrivateLaw/GetFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LiaPreviousEmploymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLiaPreviousEmployment(body: CreateOrUpdateLiaPreviousEmploymentInput | undefined): Observable<LiaStatus> {
        let url_ = this.baseUrl + "/api/services/app/LiaPreviousEmployment/CreateOrUpdateLiaPreviousEmployment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLiaPreviousEmployment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLiaPreviousEmployment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaStatus>;
        }));
    }

    protected processCreateOrUpdateLiaPreviousEmployment(response: HttpResponseBase): Observable<LiaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    createBlankLiaPreviousEmploymentRecord(caseId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/LiaPreviousEmployment/CreateBlankLiaPreviousEmploymentRecord?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBlankLiaPreviousEmploymentRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBlankLiaPreviousEmploymentRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateBlankLiaPreviousEmploymentRecord(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param recordId (optional) 
     * @return Success
     */
    deleteLiaPreviousEmploymentRecord(caseId: string | undefined, recordId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LiaPreviousEmployment/DeleteLiaPreviousEmploymentRecord?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (recordId === null)
            throw new Error("The parameter 'recordId' cannot be null.");
        else if (recordId !== undefined)
            url_ += "recordId=" + encodeURIComponent("" + recordId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLiaPreviousEmploymentRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLiaPreviousEmploymentRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteLiaPreviousEmploymentRecord(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getLiaPreviousEmploymentRecordFiles(caseId: string, step: LiaStatus | undefined): Observable<LiaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaPreviousEmployment/GetLiaPreviousEmploymentRecordFiles?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLiaPreviousEmploymentRecordFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLiaPreviousEmploymentRecordFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaDocumentsOutput>;
        }));
    }

    protected processGetLiaPreviousEmploymentRecordFiles(response: HttpResponseBase): Observable<LiaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LiaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param liaEmploymentBId (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadRecordFiles(liaEmploymentBId: string | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LiaPreviousEmployment/UploadRecordFiles?";
        if (liaEmploymentBId === null)
            throw new Error("The parameter 'liaEmploymentBId' cannot be null.");
        else if (liaEmploymentBId !== undefined)
            url_ += "liaEmploymentBId=" + encodeURIComponent("" + liaEmploymentBId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadRecordFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadRecordFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadRecordFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LiaProfessionalResponsibilityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    proceed(caseId: string | undefined): Observable<LiaStatus> {
        let url_ = this.baseUrl + "/api/services/app/LiaProfessionalResponsibility/Proceed?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProceed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProceed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaStatus>;
        }));
    }

    protected processProceed(response: HttpResponseBase): Observable<LiaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getLiaProfessionalResponsibilityFiles(caseId: string, step: LiaStatus | undefined): Observable<LiaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaProfessionalResponsibility/GetLiaProfessionalResponsibilityFiles?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLiaProfessionalResponsibilityFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLiaProfessionalResponsibilityFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaDocumentsOutput>;
        }));
    }

    protected processGetLiaProfessionalResponsibilityFiles(response: HttpResponseBase): Observable<LiaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LiaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LiaProfessionalResponsibility/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LiaRestrictionBServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLiaRestrictionB(body: CreateOrUpdateLiaRestrictionBInput | undefined): Observable<LiaStatus> {
        let url_ = this.baseUrl + "/api/services/app/LiaRestrictionB/CreateOrUpdateLiaRestrictionB";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLiaRestrictionB(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLiaRestrictionB(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaStatus>;
        }));
    }

    protected processCreateOrUpdateLiaRestrictionB(response: HttpResponseBase): Observable<LiaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getAndUpdateLicenceInAnotherCantonStatus(caseId: string | undefined): Observable<LiaLicenceInAnotherCantonCacheDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LiaRestrictionB/GetAndUpdateLicenceInAnotherCantonStatus?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAndUpdateLicenceInAnotherCantonStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAndUpdateLicenceInAnotherCantonStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaLicenceInAnotherCantonCacheDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaLicenceInAnotherCantonCacheDto[]>;
        }));
    }

    protected processGetAndUpdateLicenceInAnotherCantonStatus(response: HttpResponseBase): Observable<LiaLicenceInAnotherCantonCacheDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LiaLicenceInAnotherCantonCacheDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @param areProceedingsDocumentsRequired (optional) 
     * @param areForeignDocumentsRequired (optional) 
     * @param hasLicenceInAnotherCanton (optional) 
     * @param wasSelfEmployedInAnotherCanton (optional) 
     * @return Success
     */
    getLiaRestrictionBDocuments(caseId: string, step: LiaStatus | undefined, areProceedingsDocumentsRequired: boolean | undefined, areForeignDocumentsRequired: boolean | undefined, hasLicenceInAnotherCanton: boolean | undefined, wasSelfEmployedInAnotherCanton: boolean | undefined): Observable<LiaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaRestrictionB/GetLiaRestrictionBDocuments?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (areProceedingsDocumentsRequired === null)
            throw new Error("The parameter 'areProceedingsDocumentsRequired' cannot be null.");
        else if (areProceedingsDocumentsRequired !== undefined)
            url_ += "areProceedingsDocumentsRequired=" + encodeURIComponent("" + areProceedingsDocumentsRequired) + "&";
        if (areForeignDocumentsRequired === null)
            throw new Error("The parameter 'areForeignDocumentsRequired' cannot be null.");
        else if (areForeignDocumentsRequired !== undefined)
            url_ += "areForeignDocumentsRequired=" + encodeURIComponent("" + areForeignDocumentsRequired) + "&";
        if (hasLicenceInAnotherCanton === null)
            throw new Error("The parameter 'hasLicenceInAnotherCanton' cannot be null.");
        else if (hasLicenceInAnotherCanton !== undefined)
            url_ += "hasLicenceInAnotherCanton=" + encodeURIComponent("" + hasLicenceInAnotherCanton) + "&";
        if (wasSelfEmployedInAnotherCanton === null)
            throw new Error("The parameter 'wasSelfEmployedInAnotherCanton' cannot be null.");
        else if (wasSelfEmployedInAnotherCanton !== undefined)
            url_ += "wasSelfEmployedInAnotherCanton=" + encodeURIComponent("" + wasSelfEmployedInAnotherCanton) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLiaRestrictionBDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLiaRestrictionBDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaDocumentsOutput>;
        }));
    }

    protected processGetLiaRestrictionBDocuments(response: HttpResponseBase): Observable<LiaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LiaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LiaRestrictionB/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LiaRestrictionsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLiaRestrictions(body: CreateOrUpdateLiaRestrictionsInput | undefined): Observable<LiaStatus> {
        let url_ = this.baseUrl + "/api/services/app/LiaRestrictions/CreateOrUpdateLiaRestrictions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLiaRestrictions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLiaRestrictions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaStatus>;
        }));
    }

    protected processCreateOrUpdateLiaRestrictions(response: HttpResponseBase): Observable<LiaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @param hasRestrictions (optional) 
     * @param hasImpairments (optional) 
     * @return Success
     */
    getLiaRestrictionDocuments(caseId: string, step: LiaStatus | undefined, hasRestrictions: boolean | undefined, hasImpairments: boolean | undefined): Observable<LiaDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaRestrictions/GetLiaRestrictionDocuments?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (hasRestrictions === null)
            throw new Error("The parameter 'hasRestrictions' cannot be null.");
        else if (hasRestrictions !== undefined)
            url_ += "hasRestrictions=" + encodeURIComponent("" + hasRestrictions) + "&";
        if (hasImpairments === null)
            throw new Error("The parameter 'hasImpairments' cannot be null.");
        else if (hasImpairments !== undefined)
            url_ += "hasImpairments=" + encodeURIComponent("" + hasImpairments) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLiaRestrictionDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLiaRestrictionDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaDocumentsOutput>;
        }));
    }

    protected processGetLiaRestrictionDocuments(response: HttpResponseBase): Observable<LiaDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LiaDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LiaRestrictions/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LiaStatusWizardStepServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param professionId (optional) 
     * @param applicationType (optional) 
     * @return Success
     */
    getAllByProfessionId(professionId: string | undefined, applicationType: ApplicationType | undefined): Observable<LiaStatusWizardStepDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LiaStatusWizardStep/GetAllByProfessionId?";
        if (professionId === null)
            throw new Error("The parameter 'professionId' cannot be null.");
        else if (professionId !== undefined)
            url_ += "professionId=" + encodeURIComponent("" + professionId) + "&";
        if (applicationType === null)
            throw new Error("The parameter 'applicationType' cannot be null.");
        else if (applicationType !== undefined)
            url_ += "applicationType=" + encodeURIComponent("" + applicationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByProfessionId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByProfessionId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaStatusWizardStepDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaStatusWizardStepDto[]>;
        }));
    }

    protected processGetAllByProfessionId(response: HttpResponseBase): Observable<LiaStatusWizardStepDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LiaStatusWizardStepDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateLiaStatusWizardStepInput | undefined): Observable<LiaStatusWizardStepDto> {
        let url_ = this.baseUrl + "/api/services/app/LiaStatusWizardStep/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaStatusWizardStepDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaStatusWizardStepDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<LiaStatusWizardStepDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LiaStatusWizardStepDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMany(body: UpdateLiaStatusWizardStepsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LiaStatusWizardStep/UpdateMany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateMany(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @param professionId (optional) 
     * @param applicationType (optional) 
     * @return Success
     */
    delete(step: number | undefined, professionId: string | undefined, applicationType: ApplicationType | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LiaStatusWizardStep/Delete?";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "step=" + encodeURIComponent("" + step) + "&";
        if (professionId === null)
            throw new Error("The parameter 'professionId' cannot be null.");
        else if (professionId !== undefined)
            url_ += "professionId=" + encodeURIComponent("" + professionId) + "&";
        if (applicationType === null)
            throw new Error("The parameter 'applicationType' cannot be null.");
        else if (applicationType !== undefined)
            url_ += "applicationType=" + encodeURIComponent("" + applicationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LiaTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createLiaType(body: CreateLiaTypeInput | undefined): Observable<CreateLiaTypeOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaType/CreateLiaType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateLiaType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateLiaType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateLiaTypeOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateLiaTypeOutput>;
        }));
    }

    protected processCreateLiaType(response: HttpResponseBase): Observable<CreateLiaTypeOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateLiaTypeOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param professionId (optional) 
     * @return Success
     */
    isUniversitary(professionId: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/LiaType/IsUniversitary?";
        if (professionId === null)
            throw new Error("The parameter 'professionId' cannot be null.");
        else if (professionId !== undefined)
            url_ += "professionId=" + encodeURIComponent("" + professionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsUniversitary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsUniversitary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsUniversitary(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getProfessions(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/LiaType/GetProfessions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfessions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfessions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetProfessions(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getActiveProfessions(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/LiaType/GetActiveProfessions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveProfessions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveProfessions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetActiveProfessions(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param professionId (optional) 
     * @return Success
     */
    isEligibleForEhc(professionId: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/LiaType/IsEligibleForEhc?";
        if (professionId === null)
            throw new Error("The parameter 'professionId' cannot be null.");
        else if (professionId !== undefined)
            url_ += "professionId=" + encodeURIComponent("" + professionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsEligibleForEhc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsEligibleForEhc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsEligibleForEhc(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param professionId (optional) 
     * @return Success
     */
    isExtendedLiaPersonEnabled(professionId: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/LiaType/IsExtendedLiaPersonEnabled?";
        if (professionId === null)
            throw new Error("The parameter 'professionId' cannot be null.");
        else if (professionId !== undefined)
            url_ += "professionId=" + encodeURIComponent("" + professionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsExtendedLiaPersonEnabled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsExtendedLiaPersonEnabled(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsExtendedLiaPersonEnabled(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMyLias(): Observable<LiaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LiaType/GetMyLias";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyLias(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyLias(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaDto[]>;
        }));
    }

    protected processGetMyLias(response: HttpResponseBase): Observable<LiaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LiaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getNextStatus(caseId: string, status: LiaStatus): Observable<LiaStatus> {
        let url_ = this.baseUrl + "/api/services/app/LiaType/GetNextStatus?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined and cannot be null.");
        else
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaStatus>;
        }));
    }

    protected processGetNextStatus(response: HttpResponseBase): Observable<LiaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personGln (optional) 
     * @return Success
     */
    getLiasForPerson(personGln: string | undefined): Observable<LiaSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LiaType/GetLiasForPerson?";
        if (personGln === null)
            throw new Error("The parameter 'personGln' cannot be null.");
        else if (personGln !== undefined)
            url_ += "personGln=" + encodeURIComponent("" + personGln) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLiasForPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLiasForPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaSummaryDto[]>;
        }));
    }

    protected processGetLiasForPerson(response: HttpResponseBase): Observable<LiaSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LiaSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getProfessionalLicenceForLia(caseId: string | undefined): Observable<ProfessionalLicenceDto> {
        let url_ = this.baseUrl + "/api/services/app/LiaType/getProfessionalLicenceForLia?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfessionalLicenceForLia(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfessionalLicenceForLia(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfessionalLicenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfessionalLicenceDto>;
        }));
    }

    protected processGetProfessionalLicenceForLia(response: HttpResponseBase): Observable<ProfessionalLicenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfessionalLicenceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getLia(caseId: string | undefined): Observable<GetLiaOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaType/GetLia?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLia(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLia(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLiaOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLiaOutput>;
        }));
    }

    protected processGetLia(response: HttpResponseBase): Observable<GetLiaOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLiaOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    releaseLia(caseId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LiaType/ReleaseLia?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseLia(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseLia(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReleaseLia(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getEvaluationComments(caseId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/LiaType/GetEvaluationComments?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvaluationComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvaluationComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetEvaluationComments(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param professionId (optional) 
     * @return Success
     */
    getExternalRegisterByProfessionId(professionId: string | undefined): Observable<ExternalSystemEnum> {
        let url_ = this.baseUrl + "/api/services/app/LiaType/GetExternalRegisterByProfessionId?";
        if (professionId === null)
            throw new Error("The parameter 'professionId' cannot be null.");
        else if (professionId !== undefined)
            url_ += "professionId=" + encodeURIComponent("" + professionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalRegisterByProfessionId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalRegisterByProfessionId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalSystemEnum>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalSystemEnum>;
        }));
    }

    protected processGetExternalRegisterByProfessionId(response: HttpResponseBase): Observable<ExternalSystemEnum> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getFailedLiaForProfessionAndGln(caseId: string | undefined): Observable<GetLiaOutput> {
        let url_ = this.baseUrl + "/api/services/app/LiaType/GetFailedLiaForProfessionAndGln?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFailedLiaForProfessionAndGln(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFailedLiaForProfessionAndGln(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLiaOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLiaOutput>;
        }));
    }

    protected processGetFailedLiaForProfessionAndGln(response: HttpResponseBase): Observable<GetLiaOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLiaOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    validateThatAllMandatoryDocumentsHaveBeenUploaded(caseId: string | undefined): Observable<LiaStatus[]> {
        let url_ = this.baseUrl + "/api/services/app/LiaType/ValidateThatAllMandatoryDocumentsHaveBeenUploaded?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaStatus[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaStatus[]>;
        }));
    }

    protected processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response: HttpResponseBase): Observable<LiaStatus[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LicenceInAnotherCantonCacheServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getAndUpdateLicenceInAnotherCantonStatus(caseId: string | undefined): Observable<LiaLicenceInAnotherCantonCacheDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LicenceInAnotherCantonCache/GetAndUpdateLicenceInAnotherCantonStatus?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAndUpdateLicenceInAnotherCantonStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAndUpdateLicenceInAnotherCantonStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LiaLicenceInAnotherCantonCacheDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LiaLicenceInAnotherCantonCacheDto[]>;
        }));
    }

    protected processGetAndUpdateLicenceInAnotherCantonStatus(response: HttpResponseBase): Observable<LiaLicenceInAnotherCantonCacheDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LiaLicenceInAnotherCantonCacheDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MailDistributionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getMailDistributionLists(): Observable<ListResultDtoOfMailDistributionListDto> {
        let url_ = this.baseUrl + "/api/services/app/MailDistribution/GetMailDistributionLists";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMailDistributionLists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMailDistributionLists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfMailDistributionListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfMailDistributionListDto>;
        }));
    }

    protected processGetMailDistributionLists(response: HttpResponseBase): Observable<ListResultDtoOfMailDistributionListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfMailDistributionListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getMailDistributionListUsers(id: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfMailDistributionListUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/MailDistribution/GetMailDistributionListUsers?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMailDistributionListUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMailDistributionListUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMailDistributionListUserListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMailDistributionListUserListDto>;
        }));
    }

    protected processGetMailDistributionListUsers(response: HttpResponseBase): Observable<PagedResultDtoOfMailDistributionListUserListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMailDistributionListUserListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getMailDistributionListEmail(id: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfMailDistributionListEmailListDto> {
        let url_ = this.baseUrl + "/api/services/app/MailDistribution/GetMailDistributionListEmail?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMailDistributionListEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMailDistributionListEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfMailDistributionListEmailListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfMailDistributionListEmailListDto>;
        }));
    }

    protected processGetMailDistributionListEmail(response: HttpResponseBase): Observable<PagedResultDtoOfMailDistributionListEmailListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfMailDistributionListEmailListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addEmailToMailDistributionList(body: AddEmailToMailDistributionListInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MailDistribution/AddEmailToMailDistributionList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddEmailToMailDistributionList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddEmailToMailDistributionList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddEmailToMailDistributionList(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param mailDistributionListId (optional) 
     * @param id (optional) 
     * @return Success
     */
    removeEmailFromMailDistributionList(mailDistributionListId: number | undefined, id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MailDistribution/RemoveEmailFromMailDistributionList?";
        if (mailDistributionListId === null)
            throw new Error("The parameter 'mailDistributionListId' cannot be null.");
        else if (mailDistributionListId !== undefined)
            url_ += "MailDistributionListId=" + encodeURIComponent("" + mailDistributionListId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveEmailFromMailDistributionList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveEmailFromMailDistributionList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveEmailFromMailDistributionList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param mailDistributionListId (optional) 
     * @return Success
     */
    getMailDistributionListConfig(mailDistributionListId: number | undefined): Observable<MailDistributionListConfigurationsDto> {
        let url_ = this.baseUrl + "/api/services/app/MailDistribution/GetMailDistributionListConfig?";
        if (mailDistributionListId === null)
            throw new Error("The parameter 'mailDistributionListId' cannot be null.");
        else if (mailDistributionListId !== undefined)
            url_ += "MailDistributionListId=" + encodeURIComponent("" + mailDistributionListId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMailDistributionListConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMailDistributionListConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MailDistributionListConfigurationsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MailDistributionListConfigurationsDto>;
        }));
    }

    protected processGetMailDistributionListConfig(response: HttpResponseBase): Observable<MailDistributionListConfigurationsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MailDistributionListConfigurationsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMailDistributionListConfig(body: MailDistributionListConfigurationsDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MailDistribution/UpdateMailDistributionListConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMailDistributionListConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMailDistributionListConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUpdateMailDistributionListConfig(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createMailDistributionList(body: CreateMailDistributionListInput | undefined): Observable<MailDistributionListDto> {
        let url_ = this.baseUrl + "/api/services/app/MailDistribution/CreateMailDistributionList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMailDistributionList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMailDistributionList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MailDistributionListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MailDistributionListDto>;
        }));
    }

    protected processCreateMailDistributionList(response: HttpResponseBase): Observable<MailDistributionListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MailDistributionListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMailDistributionList(body: UpdateMailDistributionListInput | undefined): Observable<MailDistributionListDto> {
        let url_ = this.baseUrl + "/api/services/app/MailDistribution/UpdateMailDistributionList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMailDistributionList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMailDistributionList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MailDistributionListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MailDistributionListDto>;
        }));
    }

    protected processUpdateMailDistributionList(response: HttpResponseBase): Observable<MailDistributionListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MailDistributionListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteMailDistributionList(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MailDistribution/DeleteMailDistributionList?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMailDistributionList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMailDistributionList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteMailDistributionList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userIds (optional) 
     * @param mailDistributionListId (optional) 
     * @return Success
     */
    removeUsersFromMailDistributionList(userIds: number[] | undefined, mailDistributionListId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MailDistribution/RemoveUsersFromMailDistributionList?";
        if (userIds === null)
            throw new Error("The parameter 'userIds' cannot be null.");
        else if (userIds !== undefined)
            userIds && userIds.forEach(item => { url_ += "UserIds=" + encodeURIComponent("" + item) + "&"; });
        if (mailDistributionListId === null)
            throw new Error("The parameter 'mailDistributionListId' cannot be null.");
        else if (mailDistributionListId !== undefined)
            url_ += "MailDistributionListId=" + encodeURIComponent("" + mailDistributionListId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveUsersFromMailDistributionList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveUsersFromMailDistributionList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveUsersFromMailDistributionList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addUsersToMailDistributionList(body: AddUsersToMailDistributionListInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MailDistribution/AddUsersToMailDistributionList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUsersToMailDistributionList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUsersToMailDistributionList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddUsersToMailDistributionList(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    findAddableUsers(body: FindMailDistributionListDataInput | undefined): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/MailDistribution/FindAddableUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindAddableUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindAddableUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfNameValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfNameValueDto>;
        }));
    }

    protected processFindAddableUsers(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MedRegServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    search(body: SearchMedRegPersonInput | undefined): Observable<SearchMedRegPersonOutput> {
        let url_ = this.baseUrl + "/api/services/app/MedReg/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchMedRegPersonOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchMedRegPersonOutput>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<SearchMedRegPersonOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchMedRegPersonOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @return Success
     */
    getDetailed(personId: number | undefined): Observable<GetMedRegPersonDetailedOutput> {
        let url_ = this.baseUrl + "/api/services/app/MedReg/GetDetailed?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetailed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetailed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMedRegPersonDetailedOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMedRegPersonDetailedOutput>;
        }));
    }

    protected processGetDetailed(response: HttpResponseBase): Observable<GetMedRegPersonDetailedOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMedRegPersonDetailedOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param gln (optional) 
     * @return Success
     */
    getDetailedByGln(gln: string | undefined): Observable<GetMedRegPersonDetailedOutput> {
        let url_ = this.baseUrl + "/api/services/app/MedReg/GetDetailedByGln?";
        if (gln === null)
            throw new Error("The parameter 'gln' cannot be null.");
        else if (gln !== undefined)
            url_ += "gln=" + encodeURIComponent("" + gln) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetailedByGln(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetailedByGln(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMedRegPersonDetailedOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMedRegPersonDetailedOutput>;
        }));
    }

    protected processGetDetailedByGln(response: HttpResponseBase): Observable<GetMedRegPersonDetailedOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMedRegPersonDetailedOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @return Success
     */
    get(personId: number | undefined): Observable<GetMedRegPersonOutput> {
        let url_ = this.baseUrl + "/api/services/app/MedReg/Get?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMedRegPersonOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMedRegPersonOutput>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetMedRegPersonOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMedRegPersonOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param gln (optional) 
     * @return Success
     */
    getByGln(gln: string | undefined): Observable<GetMedRegPersonOutput> {
        let url_ = this.baseUrl + "/api/services/app/MedReg/GetByGln?";
        if (gln === null)
            throw new Error("The parameter 'gln' cannot be null.");
        else if (gln !== undefined)
            url_ += "gln=" + encodeURIComponent("" + gln) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByGln(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByGln(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMedRegPersonOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMedRegPersonOutput>;
        }));
    }

    protected processGetByGln(response: HttpResponseBase): Observable<GetMedRegPersonOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMedRegPersonOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MigrationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    run(step: MigrationStep, isForEvidence: boolean): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Migration/Run?";
        if (step === undefined || step === null)
            throw new Error("The parameter 'step' must be defined and cannot be null.");
        else
            url_ += "step=" + encodeURIComponent("" + step) + "&";
        if (isForEvidence === undefined || isForEvidence === null)
            throw new Error("The parameter 'isForEvidence' must be defined and cannot be null.");
        else
            url_ += "isForEvidence=" + encodeURIComponent("" + isForEvidence) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRun(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRun(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRun(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    runAdditional(step: MigrationAdditionalStep): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Migration/RunAdditional?";
        if (step === undefined || step === null)
            throw new Error("The parameter 'step' must be defined and cannot be null.");
        else
            url_ += "step=" + encodeURIComponent("" + step) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunAdditional(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunAdditional(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRunAdditional(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    isRunning(): Observable<MigrationIsRunningOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Migration/IsRunning";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsRunning(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsRunning(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MigrationIsRunningOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MigrationIsRunningOutputDto>;
        }));
    }

    protected processIsRunning(response: HttpResponseBase): Observable<MigrationIsRunningOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MigrationIsRunningOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMigrationResult(): Observable<MigrationResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Migration/GetMigrationResult";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMigrationResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMigrationResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MigrationResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MigrationResultDto>;
        }));
    }

    protected processGetMigrationResult(response: HttpResponseBase): Observable<MigrationResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MigrationResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    removeMigrationResult(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Migration/RemoveMigrationResult";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveMigrationResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveMigrationResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveMigrationResult(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    cancel(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Migration/Cancel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadBinaryData(body: MigrationBinaryDataInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Migration/UploadBinaryData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadBinaryData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadBinaryData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUploadBinaryData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBinaryData(id: MigrationBinaryObjectId | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Migration/GetBinaryData?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBinaryData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBinaryData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetBinaryData(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getExcelResults(maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfGetExcelResultData> {
        let url_ = this.baseUrl + "/api/services/app/Migration/GetExcelResults?";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExcelResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExcelResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetExcelResultData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetExcelResultData>;
        }));
    }

    protected processGetExcelResults(response: HttpResponseBase): Observable<PagedResultDtoOfGetExcelResultData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetExcelResultData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getExcelResult(id: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Migration/GetExcelResult?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExcelResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExcelResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetExcelResult(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createMut(body: CreateMutInput | undefined): Observable<CreateMutOutput> {
        let url_ = this.baseUrl + "/api/services/app/Mut/CreateMut";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateMutOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateMutOutput>;
        }));
    }

    protected processCreateMut(response: HttpResponseBase): Observable<CreateMutOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateMutOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMyMuts(): Observable<MutDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Mut/GetMyMuts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyMuts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyMuts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutDto[]>;
        }));
    }

    protected processGetMyMuts(response: HttpResponseBase): Observable<MutDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MutDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getNextStatus(caseId: string, status: MutStatus): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/Mut/GetNextStatus?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined and cannot be null.");
        else
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processGetNextStatus(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param gln (optional) 
     * @return Success
     */
    getMutsForPerson(gln: string | undefined): Observable<MutDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Mut/GetMutsForPerson?";
        if (gln === null)
            throw new Error("The parameter 'gln' cannot be null.");
        else if (gln !== undefined)
            url_ += "gln=" + encodeURIComponent("" + gln) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMutsForPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMutsForPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutDto[]>;
        }));
    }

    protected processGetMutsForPerson(response: HttpResponseBase): Observable<MutDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MutDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getMut(caseId: string | undefined): Observable<GetMutOutput> {
        let url_ = this.baseUrl + "/api/services/app/Mut/GetMut?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMutOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMutOutput>;
        }));
    }

    protected processGetMut(response: HttpResponseBase): Observable<GetMutOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMutOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param applicantComment (optional) 
     * @return Success
     */
    releaseMut(caseId: string | undefined, applicantComment: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Mut/ReleaseMut?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (applicantComment === null)
            throw new Error("The parameter 'applicantComment' cannot be null.");
        else if (applicantComment !== undefined)
            url_ += "applicantComment=" + encodeURIComponent("" + applicantComment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseMut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseMut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReleaseMut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getEvaluationComments(caseId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Mut/GetEvaluationComments?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvaluationComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvaluationComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetEvaluationComments(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    validateThatAllMandatoryDocumentsHaveBeenUploaded(caseId: string | undefined): Observable<MutStatus[]> {
        let url_ = this.baseUrl + "/api/services/app/Mut/ValidateThatAllMandatoryDocumentsHaveBeenUploaded?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus[]>;
        }));
    }

    protected processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response: HttpResponseBase): Observable<MutStatus[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    acceptApplication(caseId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Mut/AcceptApplication?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAcceptApplication(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutAdditionalAcademicTitleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: MutAdditionalAcademicTitleDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutAdditionalAcademicTitle/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<MutAdditionalAcademicTitleDto> {
        let url_ = this.baseUrl + "/api/services/app/MutAdditionalAcademicTitle/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutAdditionalAcademicTitleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutAdditionalAcademicTitleDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MutAdditionalAcademicTitleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MutAdditionalAcademicTitleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutAddressServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: MutAddressDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutAddress/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<MutAddressDto> {
        let url_ = this.baseUrl + "/api/services/app/MutAddress/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutAddressDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutAddressDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MutAddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MutAddressDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutApplicantAdditionalCommentsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: MutApplicantAdditionalCommentsDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutApplicantAdditionalComments/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<MutApplicantAdditionalCommentsDto> {
        let url_ = this.baseUrl + "/api/services/app/MutApplicantAdditionalComments/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutApplicantAdditionalCommentsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutApplicantAdditionalCommentsDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MutApplicantAdditionalCommentsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MutApplicantAdditionalCommentsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutApplicantBusinessServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateUpdateMutApplicantBusinessInput | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutApplicantBusiness/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<MutApplicantBusinessDto> {
        let url_ = this.baseUrl + "/api/services/app/MutApplicantBusiness/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutApplicantBusinessDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutApplicantBusinessDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MutApplicantBusinessDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MutApplicantBusinessDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutApplicantContactServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: MutApplicantContactDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutApplicantContact/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<MutApplicantContactDto> {
        let url_ = this.baseUrl + "/api/services/app/MutApplicantContact/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutApplicantContactDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutApplicantContactDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MutApplicantContactDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MutApplicantContactDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutApplicantPersonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: MutApplicantPersonDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutApplicantPerson/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<MutApplicantPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/MutApplicantPerson/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutApplicantPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutApplicantPersonDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MutApplicantPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MutApplicantPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutApplicantSponsorshipServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: MutApplicantSponsorshipDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutApplicantSponsorship/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<MutApplicantSponsorshipDto> {
        let url_ = this.baseUrl + "/api/services/app/MutApplicantSponsorship/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutApplicantSponsorshipDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutApplicantSponsorshipDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MutApplicantSponsorshipDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MutApplicantSponsorshipDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutationApplicationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getMutationApplications(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetMutationApplicationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/MutationApplication/GetMutationApplications?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMutationApplications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMutationApplications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMutationApplicationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMutationApplicationsOutput>;
        }));
    }

    protected processGetMutationApplications(response: HttpResponseBase): Observable<GetMutationApplicationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMutationApplicationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutBusinessServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: MutBusinessDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutBusiness/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<MutBusinessDto> {
        let url_ = this.baseUrl + "/api/services/app/MutBusiness/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutBusinessDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutBusinessDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MutBusinessDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MutBusinessDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutBusinessChangeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: MutBusinessChangeDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutBusinessChange/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<MutBusinessChangeDto> {
        let url_ = this.baseUrl + "/api/services/app/MutBusinessChange/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutBusinessChangeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutBusinessChangeDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MutBusinessChangeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MutBusinessChangeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutBusinessDirectorsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateUpdateMutBusinessDirectorsInput | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutBusinessDirectors/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<GetMutBusinessDirectorsOutput> {
        let url_ = this.baseUrl + "/api/services/app/MutBusinessDirectors/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMutBusinessDirectorsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMutBusinessDirectorsOutput>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetMutBusinessDirectorsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMutBusinessDirectorsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutBusinessTerminationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: MutBusinessTerminationDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutBusinessTermination/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<MutBusinessTerminationDto> {
        let url_ = this.baseUrl + "/api/services/app/MutBusinessTermination/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutBusinessTerminationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutBusinessTerminationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MutBusinessTerminationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MutBusinessTerminationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutDocumentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getDocuments(body: GetMutDocumentsInput | undefined): Observable<MutDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/MutDocument/GetDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutDocumentsOutput>;
        }));
    }

    protected processGetDocuments(response: HttpResponseBase): Observable<MutDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MutDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MutDocument/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param directorId (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadSponsorshipDirectorFiles(directorId: number | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MutDocument/UploadSponsorshipDirectorFiles?";
        if (directorId === null)
            throw new Error("The parameter 'directorId' cannot be null.");
        else if (directorId !== undefined)
            url_ += "directorId=" + encodeURIComponent("" + directorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadSponsorshipDirectorFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadSponsorshipDirectorFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadSponsorshipDirectorFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getSponsorshipDirectorFiles(body: GetMutSubItemDocumentsInput | undefined): Observable<MutDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/MutDocument/GetSponsorshipDirectorFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSponsorshipDirectorFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSponsorshipDirectorFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutDocumentsOutput>;
        }));
    }

    protected processGetSponsorshipDirectorFiles(response: HttpResponseBase): Observable<MutDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MutDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getFile(body: GetMutFileInput | undefined): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/MutDocument/GetFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    deleteFile(caseId: string, step: MutStatus | undefined, id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MutDocument/DeleteFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutDrugProductionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: MutDrugProductionDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutDrugProduction/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<MutDrugProductionDto> {
        let url_ = this.baseUrl + "/api/services/app/MutDrugProduction/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutDrugProductionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutDrugProductionDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MutDrugProductionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MutDrugProductionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutEmploymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: MutEmploymentDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutEmployment/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<MutEmploymentDto> {
        let url_ = this.baseUrl + "/api/services/app/MutEmployment/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutEmploymentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutEmploymentDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MutEmploymentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MutEmploymentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutEmploymentTerminationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: MutEmploymentTerminationDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutEmploymentTermination/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<MutEmploymentTerminationDto> {
        let url_ = this.baseUrl + "/api/services/app/MutEmploymentTermination/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutEmploymentTerminationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutEmploymentTerminationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MutEmploymentTerminationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MutEmploymentTerminationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutMedicalFieldDirectorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: MutMedicalFieldDirectorDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutMedicalFieldDirector/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<MutMedicalFieldDirectorDto> {
        let url_ = this.baseUrl + "/api/services/app/MutMedicalFieldDirector/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutMedicalFieldDirectorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutMedicalFieldDirectorDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MutMedicalFieldDirectorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MutMedicalFieldDirectorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutOtherServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: MutOtherDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutOther/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<MutOtherDto> {
        let url_ = this.baseUrl + "/api/services/app/MutOther/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutOtherDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutOtherDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MutOtherDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MutOtherDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutPersonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: MutPersonDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutPerson/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<MutPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/MutPerson/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutPersonDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MutPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MutPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutPostgraduateTitlePrivateLawServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: MutPostgraduateTitlePrivateLawDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutPostgraduateTitlePrivateLaw/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<MutPostgraduateTitlePrivateLawDto> {
        let url_ = this.baseUrl + "/api/services/app/MutPostgraduateTitlePrivateLaw/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutPostgraduateTitlePrivateLawDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutPostgraduateTitlePrivateLawDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MutPostgraduateTitlePrivateLawDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MutPostgraduateTitlePrivateLawDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutRangeOfServicesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: MutRangeOfServicesDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutRangeOfServices/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<MutRangeOfServicesDto> {
        let url_ = this.baseUrl + "/api/services/app/MutRangeOfServices/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutRangeOfServicesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutRangeOfServicesDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MutRangeOfServicesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MutRangeOfServicesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutSponsorshipServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: MutSponsorshipDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutSponsorship/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<MutSponsorshipDto> {
        let url_ = this.baseUrl + "/api/services/app/MutSponsorship/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutSponsorshipDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutSponsorshipDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MutSponsorshipDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MutSponsorshipDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutSponsorshipDirectorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateUpdateMutSponsorshipDirectorsInput | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutSponsorshipDirector/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPlaceholder(body: CreateUpdateMutSponsorshipDirectorsInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/MutSponsorshipDirector/CreatePlaceholder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholder(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<GetMutSponsorshipDirectorsOutput> {
        let url_ = this.baseUrl + "/api/services/app/MutSponsorshipDirector/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMutSponsorshipDirectorsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMutSponsorshipDirectorsOutput>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetMutSponsorshipDirectorsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMutSponsorshipDirectorsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutTerminationOfClaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: MutTerminationOfClaDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutTerminationOfCla/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<MutTerminationOfClaDto> {
        let url_ = this.baseUrl + "/api/services/app/MutTerminationOfCla/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutTerminationOfClaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutTerminationOfClaDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MutTerminationOfClaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MutTerminationOfClaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutTransferOfClaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: MutTransferOfClaDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutTransferOfCla/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<MutTransferOfClaDto> {
        let url_ = this.baseUrl + "/api/services/app/MutTransferOfCla/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutTransferOfClaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutTransferOfClaDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MutTransferOfClaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MutTransferOfClaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MutWorkPlaceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: MutWorkPlaceDto | undefined): Observable<MutStatus> {
        let url_ = this.baseUrl + "/api/services/app/MutWorkPlace/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<MutStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<MutWorkPlaceDto> {
        let url_ = this.baseUrl + "/api/services/app/MutWorkPlace/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutWorkPlaceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutWorkPlaceDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MutWorkPlaceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MutWorkPlaceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MySironaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getContactInfo(): Observable<UserContactDto> {
        let url_ = this.baseUrl + "/api/services/app/MySirona/GetContactInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserContactDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserContactDto>;
        }));
    }

    protected processGetContactInfo(response: HttpResponseBase): Observable<UserContactDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserContactDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEmployments(): Observable<GetEmploymentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/MySirona/GetEmployments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmploymentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmploymentsOutput>;
        }));
    }

    protected processGetEmployments(response: HttpResponseBase): Observable<GetEmploymentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEmploymentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getSubmittedEmploymentChangeRequests(): Observable<EmploymentChangeRequestDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MySirona/GetSubmittedEmploymentChangeRequests";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubmittedEmploymentChangeRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubmittedEmploymentChangeRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmploymentChangeRequestDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmploymentChangeRequestDto[]>;
        }));
    }

    protected processGetSubmittedEmploymentChangeRequests(response: HttpResponseBase): Observable<EmploymentChangeRequestDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmploymentChangeRequestDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getExistingEmploymentChangeRequestInfo(): Observable<GetExistingEmploymentChangeRequestInfoOutput> {
        let url_ = this.baseUrl + "/api/services/app/MySirona/GetExistingEmploymentChangeRequestInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExistingEmploymentChangeRequestInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExistingEmploymentChangeRequestInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetExistingEmploymentChangeRequestInfoOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetExistingEmploymentChangeRequestInfoOutput>;
        }));
    }

    protected processGetExistingEmploymentChangeRequestInfo(response: HttpResponseBase): Observable<GetExistingEmploymentChangeRequestInfoOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetExistingEmploymentChangeRequestInfoOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getExistingPersonChangeRequestInfo(): Observable<GetExistingPersonChangeRequestInfoOutput> {
        let url_ = this.baseUrl + "/api/services/app/MySirona/GetExistingPersonChangeRequestInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExistingPersonChangeRequestInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExistingPersonChangeRequestInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetExistingPersonChangeRequestInfoOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetExistingPersonChangeRequestInfoOutput>;
        }));
    }

    protected processGetExistingPersonChangeRequestInfo(response: HttpResponseBase): Observable<GetExistingPersonChangeRequestInfoOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetExistingPersonChangeRequestInfoOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getSponsorshipCount(): Observable<GetSponsorshipCountOutput> {
        let url_ = this.baseUrl + "/api/services/app/MySirona/GetSponsorshipCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSponsorshipCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSponsorshipCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSponsorshipCountOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSponsorshipCountOutput>;
        }));
    }

    protected processGetSponsorshipCount(response: HttpResponseBase): Observable<GetSponsorshipCountOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSponsorshipCountOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEmploymentsCount(): Observable<GetEmploymentsCountOutput> {
        let url_ = this.baseUrl + "/api/services/app/MySirona/GetEmploymentsCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmploymentsCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmploymentsCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmploymentsCountOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmploymentsCountOutput>;
        }));
    }

    protected processGetEmploymentsCount(response: HttpResponseBase): Observable<GetEmploymentsCountOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEmploymentsCountOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getProfessionalLicences(): Observable<GetUserProfessionalLicencesOutput> {
        let url_ = this.baseUrl + "/api/services/app/MySirona/GetProfessionalLicences";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfessionalLicences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfessionalLicences(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserProfessionalLicencesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserProfessionalLicencesOutput>;
        }));
    }

    protected processGetProfessionalLicences(response: HttpResponseBase): Observable<GetUserProfessionalLicencesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserProfessionalLicencesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getProfessionalLicencesCount(): Observable<GetProfessionalLicencesCountOutput> {
        let url_ = this.baseUrl + "/api/services/app/MySirona/GetProfessionalLicencesCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfessionalLicencesCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfessionalLicencesCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfessionalLicencesCountOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfessionalLicencesCountOutput>;
        }));
    }

    protected processGetProfessionalLicencesCount(response: HttpResponseBase): Observable<GetProfessionalLicencesCountOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfessionalLicencesCountOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getIdentificationStatus(): Observable<GetIdentificationStatusOutput> {
        let url_ = this.baseUrl + "/api/services/app/MySirona/GetIdentificationStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIdentificationStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIdentificationStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetIdentificationStatusOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetIdentificationStatusOutput>;
        }));
    }

    protected processGetIdentificationStatus(response: HttpResponseBase): Observable<GetIdentificationStatusOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetIdentificationStatusOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    hasAnyApplicationOrSponsorship(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MySirona/HasAnyApplicationOrSponsorship";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasAnyApplicationOrSponsorship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasAnyApplicationOrSponsorship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processHasAnyApplicationOrSponsorship(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    isUserEmailConfirmed(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/MySirona/IsUserEmailConfirmed";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsUserEmailConfirmed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsUserEmailConfirmed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsUserEmailConfirmed(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NaregServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    search(body: SearchNaregPersonInput | undefined): Observable<SearchNaregPersonOutput> {
        let url_ = this.baseUrl + "/api/services/app/Nareg/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchNaregPersonOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchNaregPersonOutput>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<SearchNaregPersonOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchNaregPersonOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getDetailed(personId: number): Observable<GetNaregPersonDetailedOutput> {
        let url_ = this.baseUrl + "/api/services/app/Nareg/GetDetailed?";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined and cannot be null.");
        else
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetailed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetailed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNaregPersonDetailedOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNaregPersonDetailedOutput>;
        }));
    }

    protected processGetDetailed(response: HttpResponseBase): Observable<GetNaregPersonDetailedOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNaregPersonDetailedOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param gln (optional) 
     * @return Success
     */
    getDetailedByGln(gln: string | undefined): Observable<GetNaregPersonDetailedOutput> {
        let url_ = this.baseUrl + "/api/services/app/Nareg/GetDetailedByGln?";
        if (gln === null)
            throw new Error("The parameter 'gln' cannot be null.");
        else if (gln !== undefined)
            url_ += "gln=" + encodeURIComponent("" + gln) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetailedByGln(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetailedByGln(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNaregPersonDetailedOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNaregPersonDetailedOutput>;
        }));
    }

    protected processGetDetailedByGln(response: HttpResponseBase): Observable<GetNaregPersonDetailedOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNaregPersonDetailedOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    get(personId: number): Observable<GetNaregPersonOutput> {
        let url_ = this.baseUrl + "/api/services/app/Nareg/Get?";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined and cannot be null.");
        else
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNaregPersonOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNaregPersonOutput>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetNaregPersonOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNaregPersonOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param gln (optional) 
     * @return Success
     */
    getByGln(gln: string | undefined): Observable<GetNaregPersonOutput> {
        let url_ = this.baseUrl + "/api/services/app/Nareg/GetByGln?";
        if (gln === null)
            throw new Error("The parameter 'gln' cannot be null.");
        else if (gln !== undefined)
            url_ += "gln=" + encodeURIComponent("" + gln) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByGln(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByGln(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNaregPersonOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNaregPersonOutput>;
        }));
    }

    protected processGetByGln(response: HttpResponseBase): Observable<GetNaregPersonOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNaregPersonOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NotificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param state (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getUserNotifications(state: UserNotificationState | undefined, startDate: DateTime | undefined, endDate: DateTime | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetNotificationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetUserNotifications?";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNotificationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNotificationsOutput>;
        }));
    }

    protected processGetUserNotifications(response: HttpResponseBase): Observable<GetNotificationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNotificationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    shouldUserUpdateApp(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Notification/ShouldUserUpdateApp";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShouldUserUpdateApp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShouldUserUpdateApp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processShouldUserUpdateApp(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    setAllAvailableVersionNotificationAsRead(): Observable<SetNotificationAsReadOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetAllAvailableVersionNotificationAsRead";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAllAvailableVersionNotificationAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAllAvailableVersionNotificationAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SetNotificationAsReadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SetNotificationAsReadOutput>;
        }));
    }

    protected processSetAllAvailableVersionNotificationAsRead(response: HttpResponseBase): Observable<SetNotificationAsReadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SetNotificationAsReadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    setAllNotificationsAsRead(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetAllNotificationsAsRead";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAllNotificationsAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAllNotificationsAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetAllNotificationsAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setNotificationAsRead(body: EntityDtoOfGuid | undefined): Observable<SetNotificationAsReadOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetNotificationAsRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetNotificationAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetNotificationAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SetNotificationAsReadOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SetNotificationAsReadOutput>;
        }));
    }

    protected processSetNotificationAsRead(response: HttpResponseBase): Observable<SetNotificationAsReadOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SetNotificationAsReadOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getNotificationSettings(): Observable<GetNotificationSettingsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNotificationSettingsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNotificationSettingsOutput>;
        }));
    }

    protected processGetNotificationSettings(response: HttpResponseBase): Observable<GetNotificationSettingsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNotificationSettingsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateNotificationSettings(body: UpdateNotificationSettingsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/UpdateNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNotificationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateNotificationSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteNotification(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/DeleteNotification?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param state (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    deleteAllUserNotifications(state: UserNotificationState | undefined, startDate: DateTime | undefined, endDate: DateTime | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/DeleteAllUserNotifications?";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAllUserNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAllUserNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAllUserNotifications(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    createNewVersionReleasedNotification(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/CreateNewVersionReleasedNotification";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateNewVersionReleasedNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNewVersionReleasedNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateNewVersionReleasedNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllNotifiers(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetAllNotifiers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllNotifiers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllNotifiers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllNotifiers(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OlaOnlineDrugSalesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    completeOnlineDrugSales(caseId: string | undefined): Observable<ClaStatus> {
        let url_ = this.baseUrl + "/api/services/app/OlaOnlineDrugSales/CompleteOnlineDrugSales?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteOnlineDrugSales(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteOnlineDrugSales(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaStatus>;
        }));
    }

    protected processCompleteOnlineDrugSales(response: HttpResponseBase): Observable<ClaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OrganizationUnitServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getOrganizationUnits(): Observable<ListResultDtoOfOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnits";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfOrganizationUnitDto>;
        }));
    }

    protected processGetOrganizationUnits(response: HttpResponseBase): Observable<ListResultDtoOfOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) The field Id must be between 1 and 9.223372036854776E+18.
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getOrganizationUnitUsers(id: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfOrganizationUnitUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitUsers?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnitUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnitUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfOrganizationUnitUserListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfOrganizationUnitUserListDto>;
        }));
    }

    protected processGetOrganizationUnitUsers(response: HttpResponseBase): Observable<PagedResultDtoOfOrganizationUnitUserListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOrganizationUnitUserListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) The field Id must be between 1 and 9.223372036854776E+18.
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getOrganizationUnitRoles(id: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfOrganizationUnitRoleListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitRoles?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnitRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnitRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfOrganizationUnitRoleListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfOrganizationUnitRoleListDto>;
        }));
    }

    protected processGetOrganizationUnitRoles(response: HttpResponseBase): Observable<PagedResultDtoOfOrganizationUnitRoleListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOrganizationUnitRoleListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) The field Id must be between 1 and 9.223372036854776E+18.
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getOrganizationUnitProfessions(id: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfOrganizationUnitProfessionListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitProfessions?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnitProfessions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnitProfessions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfOrganizationUnitProfessionListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfOrganizationUnitProfessionListDto>;
        }));
    }

    protected processGetOrganizationUnitProfessions(response: HttpResponseBase): Observable<PagedResultDtoOfOrganizationUnitProfessionListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOrganizationUnitProfessionListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrganizationUnit(body: CreateOrganizationUnitInput | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/CreateOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDto>;
        }));
    }

    protected processCreateOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateOrganizationUnit(body: UpdateOrganizationUnitInput | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/UpdateOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDto>;
        }));
    }

    protected processUpdateOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    moveOrganizationUnit(body: MoveOrganizationUnitInput | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/MoveOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDto>;
        }));
    }

    protected processMoveOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteOrganizationUnit(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/DeleteOrganizationUnit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) The field UserId must be between 1 and 9.223372036854776E+18.
     * @param organizationUnitId (optional) The field OrganizationUnitId must be between 1 and 9.223372036854776E+18.
     * @return Success
     */
    removeUserFromOrganizationUnit(userId: number | undefined, organizationUnitId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/RemoveUserFromOrganizationUnit?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveUserFromOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveUserFromOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveUserFromOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param roleId (optional) The field RoleId must be between 1 and 9.223372036854776E+18.
     * @param organizationUnitId (optional) The field OrganizationUnitId must be between 1 and 9.223372036854776E+18.
     * @return Success
     */
    removeRoleFromOrganizationUnit(roleId: number | undefined, organizationUnitId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/RemoveRoleFromOrganizationUnit?";
        if (roleId === null)
            throw new Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "RoleId=" + encodeURIComponent("" + roleId) + "&";
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveRoleFromOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveRoleFromOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveRoleFromOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param professionId (optional) 
     * @param organizationUnitId (optional) The field OrganizationUnitId must be between 1 and 9.223372036854776E+18.
     * @return Success
     */
    removeProfessionFromOrganizationUnit(professionId: string | undefined, organizationUnitId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/RemoveProfessionFromOrganizationUnit?";
        if (professionId === null)
            throw new Error("The parameter 'professionId' cannot be null.");
        else if (professionId !== undefined)
            url_ += "ProfessionId=" + encodeURIComponent("" + professionId) + "&";
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveProfessionFromOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveProfessionFromOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveProfessionFromOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addUsersToOrganizationUnit(body: UsersToOrganizationUnitInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/AddUsersToOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUsersToOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUsersToOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddUsersToOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addRolesToOrganizationUnit(body: RolesToOrganizationUnitInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/AddRolesToOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddRolesToOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddRolesToOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddRolesToOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addProfessionsToOrganizationUnit(body: ProfessionsToOrganizationUnitInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/AddProfessionsToOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddProfessionsToOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddProfessionsToOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddProfessionsToOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    findUsers(body: FindOrganizationUnitUsersInput | undefined): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/FindUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfNameValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfNameValueDto>;
        }));
    }

    protected processFindUsers(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    findRoles(body: FindOrganizationUnitRolesInput | undefined): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/FindRoles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfNameValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfNameValueDto>;
        }));
    }

    protected processFindRoles(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    findProfessions(body: FindOrganizationUnitProfessionsInput | undefined): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/FindProfessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindProfessions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindProfessions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfNameValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfNameValueDto>;
        }));
    }

    protected processFindProfessions(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAll(): Observable<OrganizationUnitDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<OrganizationUnitDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationUnitDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PdfApplicationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPdfApplication(body: CreatePdfInput | undefined): Observable<CreatePdfOutput> {
        let url_ = this.baseUrl + "/api/services/app/PdfApplication/CreatePdfApplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePdfApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePdfApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatePdfOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatePdfOutput>;
        }));
    }

    protected processCreatePdfApplication(response: HttpResponseBase): Observable<CreatePdfOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreatePdfOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMyPdfs(): Observable<PdfApplicationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PdfApplication/GetMyPdfs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyPdfs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyPdfs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PdfApplicationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PdfApplicationDto[]>;
        }));
    }

    protected processGetMyPdfs(response: HttpResponseBase): Observable<PdfApplicationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PdfApplicationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getPdfApplications(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetPdfApplicationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/PdfApplication/GetPdfApplications?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPdfApplications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPdfApplications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPdfApplicationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPdfApplicationsOutput>;
        }));
    }

    protected processGetPdfApplications(response: HttpResponseBase): Observable<GetPdfApplicationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPdfApplicationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param status (optional) 
     * @return Success
     */
    getNextStatus(caseId: string | undefined, status: PdfStatus | undefined): Observable<PdfStatus> {
        let url_ = this.baseUrl + "/api/services/app/PdfApplication/GetNextStatus?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PdfStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PdfStatus>;
        }));
    }

    protected processGetNextStatus(response: HttpResponseBase): Observable<PdfStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personGln (optional) 
     * @param personId (optional) 
     * @return Success
     */
    getPdfsForPerson(personGln: string | undefined, personId: number | undefined): Observable<PdfSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PdfApplication/GetPdfsForPerson?";
        if (personGln === null)
            throw new Error("The parameter 'personGln' cannot be null.");
        else if (personGln !== undefined)
            url_ += "personGln=" + encodeURIComponent("" + personGln) + "&";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPdfsForPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPdfsForPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PdfSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PdfSummaryDto[]>;
        }));
    }

    protected processGetPdfsForPerson(response: HttpResponseBase): Observable<PdfSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PdfSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param uid (optional) 
     * @param sponsorshipId (optional) 
     * @return Success
     */
    getPdfsForSponsorship(uid: string | undefined, sponsorshipId: number | undefined): Observable<PdfSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PdfApplication/GetPdfsForSponsorship?";
        if (uid === null)
            throw new Error("The parameter 'uid' cannot be null.");
        else if (uid !== undefined)
            url_ += "uid=" + encodeURIComponent("" + uid) + "&";
        if (sponsorshipId === null)
            throw new Error("The parameter 'sponsorshipId' cannot be null.");
        else if (sponsorshipId !== undefined)
            url_ += "sponsorshipId=" + encodeURIComponent("" + sponsorshipId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPdfsForSponsorship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPdfsForSponsorship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PdfSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PdfSummaryDto[]>;
        }));
    }

    protected processGetPdfsForSponsorship(response: HttpResponseBase): Observable<PdfSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PdfSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getPdfApplication(caseId: string | undefined): Observable<GetPdfOutput> {
        let url_ = this.baseUrl + "/api/services/app/PdfApplication/GetPdfApplication?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPdfApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPdfApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPdfOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPdfOutput>;
        }));
    }

    protected processGetPdfApplication(response: HttpResponseBase): Observable<GetPdfOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPdfOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    releasePdf(caseId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PdfApplication/ReleasePdf?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleasePdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleasePdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReleasePdf(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    validateThatAllMandatoryDocumentsHaveBeenUploaded(caseId: string | undefined): Observable<PdfStatus[]> {
        let url_ = this.baseUrl + "/api/services/app/PdfApplication/ValidateThatAllMandatoryDocumentsHaveBeenUploaded?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PdfStatus[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PdfStatus[]>;
        }));
    }

    protected processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response: HttpResponseBase): Observable<PdfStatus[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getEvaluationComments(caseId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/PdfApplication/GetEvaluationComments?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvaluationComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvaluationComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetEvaluationComments(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getPersonId(caseId: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/PdfApplication/GetPersonId?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetPersonId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getSponsorshipId(caseId: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/PdfApplication/GetSponsorshipId?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSponsorshipId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSponsorshipId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetSponsorshipId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PdfDocumentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getDocuments(caseId: string, step: PdfStatus | undefined): Observable<PdfDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/PdfDocument/GetDocuments?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PdfDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PdfDocumentsOutput>;
        }));
    }

    protected processGetDocuments(response: HttpResponseBase): Observable<PdfDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PdfDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PdfDocument/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    deleteFile(caseId: string, step: PdfStatus | undefined, id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PdfDocument/DeleteFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getFile(caseId: string, step: PdfStatus | undefined, id: number): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/PdfDocument/GetFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    getPdfDocuments(caseId: string, step: PdfStatus | undefined): Observable<PdfDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/PdfDocument/GetPdfDocuments?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPdfDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPdfDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PdfDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PdfDocumentsOutput>;
        }));
    }

    protected processGetPdfDocuments(response: HttpResponseBase): Observable<PdfDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PdfDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PdfPersonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdatePdfPerson(body: CreateOrUpdatePdfPersonInput | undefined): Observable<CreateOrUpdatePdfPersonOutput> {
        let url_ = this.baseUrl + "/api/services/app/PdfPerson/CreateOrUpdatePdfPerson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdatePdfPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdatePdfPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdatePdfPersonOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdatePdfPersonOutput>;
        }));
    }

    protected processCreateOrUpdatePdfPerson(response: HttpResponseBase): Observable<CreateOrUpdatePdfPersonOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdatePdfPersonOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getPdfPersonDocuments(caseId: string | undefined): Observable<GeneralDocumentGroupDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PdfPerson/GetPdfPersonDocuments?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPdfPersonDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPdfPersonDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralDocumentGroupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralDocumentGroupDto[]>;
        }));
    }

    protected processGetPdfPersonDocuments(response: HttpResponseBase): Observable<GeneralDocumentGroupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralDocumentGroupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PdfSponsorshipServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateSponsorship(body: CreateOrUpdatePdfSponsorshipInput | undefined): Observable<CreateOrUpdatePdfSponsorshipOutput> {
        let url_ = this.baseUrl + "/api/services/app/PdfSponsorship/CreateOrUpdateSponsorship";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateSponsorship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateSponsorship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdatePdfSponsorshipOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdatePdfSponsorshipOutput>;
        }));
    }

    protected processCreateOrUpdateSponsorship(response: HttpResponseBase): Observable<CreateOrUpdatePdfSponsorshipOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdatePdfSponsorshipOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PendencesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPendence(id: number | undefined): Observable<PendenceDto> {
        let url_ = this.baseUrl + "/api/services/app/Pendences/GetPendence?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PendenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PendenceDto>;
        }));
    }

    protected processGetPendence(response: HttpResponseBase): Observable<PendenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PendenceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPendenceIncludingLinks(id: number | undefined): Observable<PendenceIncludingLinksDto> {
        let url_ = this.baseUrl + "/api/services/app/Pendences/GetPendenceIncludingLinks?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendenceIncludingLinks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendenceIncludingLinks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PendenceIncludingLinksDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PendenceIncludingLinksDto>;
        }));
    }

    protected processGetPendenceIncludingLinks(response: HttpResponseBase): Observable<PendenceIncludingLinksDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PendenceIncludingLinksDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param linkFilter (optional) 
     * @param link_Discriminator (optional) 
     * @param link_EntityId (optional) 
     * @param mustContainReferenceLink (optional) 
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getPendences(linkFilter: string | undefined, link_Discriminator: string | undefined, link_EntityId: number | undefined, mustContainReferenceLink: boolean | undefined, filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetPendencesSearchOutput> {
        let url_ = this.baseUrl + "/api/services/app/Pendences/GetPendences?";
        if (linkFilter === null)
            throw new Error("The parameter 'linkFilter' cannot be null.");
        else if (linkFilter !== undefined)
            url_ += "LinkFilter=" + encodeURIComponent("" + linkFilter) + "&";
        if (link_Discriminator === null)
            throw new Error("The parameter 'link_Discriminator' cannot be null.");
        else if (link_Discriminator !== undefined)
            url_ += "Link.Discriminator=" + encodeURIComponent("" + link_Discriminator) + "&";
        if (link_EntityId === null)
            throw new Error("The parameter 'link_EntityId' cannot be null.");
        else if (link_EntityId !== undefined)
            url_ += "Link.EntityId=" + encodeURIComponent("" + link_EntityId) + "&";
        if (mustContainReferenceLink === null)
            throw new Error("The parameter 'mustContainReferenceLink' cannot be null.");
        else if (mustContainReferenceLink !== undefined)
            url_ += "MustContainReferenceLink=" + encodeURIComponent("" + mustContainReferenceLink) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendences(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPendencesSearchOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPendencesSearchOutput>;
        }));
    }

    protected processGetPendences(response: HttpResponseBase): Observable<GetPendencesSearchOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPendencesSearchOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    putPendence(id: number | undefined, body: PendenceDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Pendences/PutPendence?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutPendence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutPendence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processPutPendence(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param reason (optional) 
     * @return Success
     */
    deletePendence(id: number | undefined, reason: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Pendences/DeletePendence?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (reason === null)
            throw new Error("The parameter 'reason' cannot be null.");
        else if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePendence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePendence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePendence(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ids (optional) 
     * @param reason (optional) 
     * @return Success
     */
    deletePendences(ids: number[] | undefined, reason: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Pendences/DeletePendences?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        if (reason === null)
            throw new Error("The parameter 'reason' cannot be null.");
        else if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePendences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePendences(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePendences(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    assignPendence(body: AssignPendenceInput | undefined): Observable<AssignPendenceOutput> {
        let url_ = this.baseUrl + "/api/services/app/Pendences/AssignPendence";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignPendence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignPendence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignPendenceOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignPendenceOutput>;
        }));
    }

    protected processAssignPendence(response: HttpResponseBase): Observable<AssignPendenceOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssignPendenceOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param pendenceId (optional) 
     * @return Success
     */
    unassignPendence(pendenceId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Pendences/UnassignPendence?";
        if (pendenceId === null)
            throw new Error("The parameter 'pendenceId' cannot be null.");
        else if (pendenceId !== undefined)
            url_ += "pendenceId=" + encodeURIComponent("" + pendenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnassignPendence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnassignPendence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnassignPendence(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    completePendences(body: CompletePendencesInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Pendences/CompletePendences";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompletePendences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompletePendences(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCompletePendences(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPendence(body: CreatePendenceDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Pendences/CreatePendence";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePendence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePendence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePendence(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param pendenceId (optional) 
     * @param body (optional) 
     * @return Success
     */
    addLink(pendenceId: number | undefined, body: PendenceLinkDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Pendences/AddLink?";
        if (pendenceId === null)
            throw new Error("The parameter 'pendenceId' cannot be null.");
        else if (pendenceId !== undefined)
            url_ += "pendenceId=" + encodeURIComponent("" + pendenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param pendenceId (optional) 
     * @param discriminator (optional) 
     * @param entityId (optional) 
     * @return Success
     */
    removeLink(pendenceId: number | undefined, discriminator: string | undefined, entityId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Pendences/RemoveLink?";
        if (pendenceId === null)
            throw new Error("The parameter 'pendenceId' cannot be null.");
        else if (pendenceId !== undefined)
            url_ += "pendenceId=" + encodeURIComponent("" + pendenceId) + "&";
        if (discriminator === null)
            throw new Error("The parameter 'discriminator' cannot be null.");
        else if (discriminator !== undefined)
            url_ += "Discriminator=" + encodeURIComponent("" + discriminator) + "&";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PeopleApplicationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getPeopleApplications(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetPeopleApplicationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/PeopleApplication/GetPeopleApplications?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPeopleApplications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPeopleApplications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPeopleApplicationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPeopleApplicationsOutput>;
        }));
    }

    protected processGetPeopleApplications(response: HttpResponseBase): Observable<GetPeopleApplicationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPeopleApplicationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getProfessions(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/PeopleApplication/GetProfessions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfessions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfessions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetProfessions(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PermissionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getAllPermissions(): Observable<ListResultDtoOfFlatPermissionWithLevelDto> {
        let url_ = this.baseUrl + "/api/services/app/Permission/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfFlatPermissionWithLevelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfFlatPermissionWithLevelDto>;
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<ListResultDtoOfFlatPermissionWithLevelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfFlatPermissionWithLevelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PersonDossierServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    search(body: PersonSearchDto | undefined): Observable<GetPersonDossierSearchOutput> {
        let url_ = this.baseUrl + "/api/services/app/PersonDossier/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPersonDossierSearchOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPersonDossierSearchOutput>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<GetPersonDossierSearchOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPersonDossierSearchOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @return Success
     */
    getPersonSummary(personId: number | undefined): Observable<PersonDossierSummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonDossier/GetPersonSummary?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonDossierSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonDossierSummaryDto>;
        }));
    }

    protected processGetPersonSummary(response: HttpResponseBase): Observable<PersonDossierSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonDossierSummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @return Success
     */
    getPerson(personId: number | undefined): Observable<GetPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonDossier/GetPerson?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPersonDto>;
        }));
    }

    protected processGetPerson(response: HttpResponseBase): Observable<GetPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPerson(body: CreateOrUpdatePersonDto | undefined): Observable<GetPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonDossier/CreatePerson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPersonDto>;
        }));
    }

    protected processCreatePerson(response: HttpResponseBase): Observable<GetPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPersonAndContactFromEmploymentInfo(body: CreatePersonFromEmploymentInfoDto | undefined): Observable<GetPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonDossier/CreatePersonAndContactFromEmploymentInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePersonAndContactFromEmploymentInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePersonAndContactFromEmploymentInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPersonDto>;
        }));
    }

    protected processCreatePersonAndContactFromEmploymentInfo(response: HttpResponseBase): Observable<GetPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPersonAndLinkToEmployment(body: CreatePersonAndLinkToEmploymentInput | undefined): Observable<GetPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonDossier/CreatePersonAndLinkToEmployment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePersonAndLinkToEmployment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePersonAndLinkToEmployment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPersonDto>;
        }));
    }

    protected processCreatePersonAndLinkToEmployment(response: HttpResponseBase): Observable<GetPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPersonFromHealthRegisterInfo(body: CreatePersonFromHealthRegisterInfoDto | undefined): Observable<GetPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonDossier/CreatePersonFromHealthRegisterInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePersonFromHealthRegisterInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePersonFromHealthRegisterInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPersonDto>;
        }));
    }

    protected processCreatePersonFromHealthRegisterInfo(response: HttpResponseBase): Observable<GetPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @param body (optional) 
     * @return Success
     */
    updatePerson(personId: number | undefined, body: CreateOrUpdatePersonDto | undefined): Observable<GetPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonDossier/UpdatePerson?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPersonDto>;
        }));
    }

    protected processUpdatePerson(response: HttpResponseBase): Observable<GetPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @param isArchived (optional) 
     * @return Success
     */
    setArchiveFlag(personId: number | undefined, isArchived: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PersonDossier/SetArchiveFlag?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (isArchived === null)
            throw new Error("The parameter 'isArchived' cannot be null.");
        else if (isArchived !== undefined)
            url_ += "isArchived=" + encodeURIComponent("" + isArchived) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetArchiveFlag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetArchiveFlag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetArchiveFlag(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @return Success
     */
    getContact(personId: number | undefined): Observable<ContactDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonDossier/GetContact?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactDto>;
        }));
    }

    protected processGetContact(response: HttpResponseBase): Observable<ContactDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @param body (optional) 
     * @return Success
     */
    putContact(personId: number | undefined, body: ContactDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PersonDossier/PutContact?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutContact(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @return Success
     */
    getInvoiceAddress(personId: number | undefined): Observable<InvoiceAddressDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonDossier/GetInvoiceAddress?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoiceAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoiceAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceAddressDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceAddressDto>;
        }));
    }

    protected processGetInvoiceAddress(response: HttpResponseBase): Observable<InvoiceAddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceAddressDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @return Success
     */
    getPersonLicences(personId: number | undefined): Observable<PersonLicenceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PersonDossier/GetPersonLicences?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonLicences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonLicences(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonLicenceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonLicenceDto[]>;
        }));
    }

    protected processGetPersonLicences(response: HttpResponseBase): Observable<PersonLicenceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonLicenceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @param body (optional) 
     * @return Success
     */
    putInvoiceAddress(personId: number | undefined, body: InvoiceAddressDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PersonDossier/PutInvoiceAddress?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutInvoiceAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutInvoiceAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutInvoiceAddress(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @return Success
     */
    getProfessionsForPerson(personId: number | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/PersonDossier/GetProfessionsForPerson?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfessionsForPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfessionsForPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetProfessionsForPerson(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PersonLicenceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchPersonLicences(body: SearchPersonLicencesInputDto | undefined): Observable<SearchPersonLicencesOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonLicence/SearchPersonLicences";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchPersonLicences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchPersonLicences(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchPersonLicencesOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchPersonLicencesOutputDto>;
        }));
    }

    protected processSearchPersonLicences(response: HttpResponseBase): Observable<SearchPersonLicencesOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchPersonLicencesOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @param typeIds (optional) 
     * @return Success
     */
    getPersonLicences(personId: number | undefined, typeIds: PersonLicenceType[] | undefined): Observable<GetPersonLicencesOutput> {
        let url_ = this.baseUrl + "/api/services/app/PersonLicence/GetPersonLicences?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (typeIds === null)
            throw new Error("The parameter 'typeIds' cannot be null.");
        else if (typeIds !== undefined)
            typeIds && typeIds.forEach(item => { url_ += "typeIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonLicences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonLicences(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPersonLicencesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPersonLicencesOutput>;
        }));
    }

    protected processGetPersonLicences(response: HttpResponseBase): Observable<GetPersonLicencesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPersonLicencesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PersonLicenceDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonLicence/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonLicenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonLicenceDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PersonLicenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonLicenceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getHistory(id: number | undefined): Observable<PersonLicenceHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PersonLicence/GetHistory?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonLicenceHistoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonLicenceHistoryDto[]>;
        }));
    }

    protected processGetHistory(response: HttpResponseBase): Observable<PersonLicenceHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonLicenceHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @return Success
     */
    getPersonLicencesForAssistantOrDelegatedOrRepresentation(personId: number | undefined): Observable<GetPersonLicencesOutput> {
        let url_ = this.baseUrl + "/api/services/app/PersonLicence/GetPersonLicencesForAssistantOrDelegatedOrRepresentation?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonLicencesForAssistantOrDelegatedOrRepresentation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonLicencesForAssistantOrDelegatedOrRepresentation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPersonLicencesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPersonLicencesOutput>;
        }));
    }

    protected processGetPersonLicencesForAssistantOrDelegatedOrRepresentation(response: HttpResponseBase): Observable<GetPersonLicencesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPersonLicencesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    post(body: CreatePersonLicenceDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/PersonLicence/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    put(id: number | undefined, body: UpdatePersonLicenceDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PersonLicence/Put?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    canDelete(id: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PersonLicence/CanDelete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCanDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCanDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCanDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PersonLicence/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createRenewal(body: CreatePersonLicenceRenewalDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/PersonLicence/CreateRenewal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRenewal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRenewal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateRenewal(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateRenewal(id: number | undefined, body: UpdatePersonLicenceRenewalDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PersonLicence/UpdateRenewal?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRenewal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRenewal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateRenewal(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createProfessionalResponsibility(body: PersonLicenceProfessionalResponsibilityDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/PersonLicence/CreateProfessionalResponsibility";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateProfessionalResponsibility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProfessionalResponsibility(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateProfessionalResponsibility(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProfessionalResponsibility(body: PersonLicenceProfessionalResponsibilityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PersonLicence/UpdateProfessionalResponsibility";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProfessionalResponsibility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProfessionalResponsibility(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateProfessionalResponsibility(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param responsibilityId (optional) 
     * @return Success
     */
    deleteProfessionalResponsibility(responsibilityId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PersonLicence/DeleteProfessionalResponsibility?";
        if (responsibilityId === null)
            throw new Error("The parameter 'responsibilityId' cannot be null.");
        else if (responsibilityId !== undefined)
            url_ += "responsibilityId=" + encodeURIComponent("" + responsibilityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProfessionalResponsibility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProfessionalResponsibility(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteProfessionalResponsibility(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createMutation(personLicenceId: number, body: PersonLicenceMutationDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/PersonLicence/CreateMutation?";
        if (personLicenceId === undefined || personLicenceId === null)
            throw new Error("The parameter 'personLicenceId' must be defined and cannot be null.");
        else
            url_ += "personLicenceId=" + encodeURIComponent("" + personLicenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMutation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMutation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateMutation(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMutation(id: number, body: PersonLicenceMutationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PersonLicence/UpdateMutation?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMutation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMutation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateMutation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PersonLicenceSchoolVaccineServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param licenceId (optional) 
     * @return Success
     */
    getPersonLicenceSchoolVaccine(licenceId: number | undefined): Observable<PersonLicenceSchoolVaccineDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonLicenceSchoolVaccine/GetPersonLicenceSchoolVaccine?";
        if (licenceId === null)
            throw new Error("The parameter 'licenceId' cannot be null.");
        else if (licenceId !== undefined)
            url_ += "licenceId=" + encodeURIComponent("" + licenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPersonLicenceSchoolVaccine(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPersonLicenceSchoolVaccine(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonLicenceSchoolVaccineDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonLicenceSchoolVaccineDto>;
        }));
    }

    protected processGetPersonLicenceSchoolVaccine(response: HttpResponseBase): Observable<PersonLicenceSchoolVaccineDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonLicenceSchoolVaccineDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param licenceId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(licenceId: number | undefined, body: PersonLicenceSchoolVaccineDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PersonLicenceSchoolVaccine/CreateOrUpdate?";
        if (licenceId === null)
            throw new Error("The parameter 'licenceId' cannot be null.");
        else if (licenceId !== undefined)
            url_ += "licenceId=" + encodeURIComponent("" + licenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PostgraduateTitleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getPostgraduateTitles(personId: number, filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetPostgraduateTitleSearchOutput> {
        let url_ = this.baseUrl + "/api/services/app/PostgraduateTitle/GetPostgraduateTitles?";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined and cannot be null.");
        else
            url_ += "PersonId=" + encodeURIComponent("" + personId) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPostgraduateTitles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPostgraduateTitles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPostgraduateTitleSearchOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPostgraduateTitleSearchOutput>;
        }));
    }

    protected processGetPostgraduateTitles(response: HttpResponseBase): Observable<GetPostgraduateTitleSearchOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPostgraduateTitleSearchOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPostgraduateTitle(id: number | undefined): Observable<PostgraduateTitleDto> {
        let url_ = this.baseUrl + "/api/services/app/PostgraduateTitle/GetPostgraduateTitle?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPostgraduateTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPostgraduateTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PostgraduateTitleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PostgraduateTitleDto>;
        }));
    }

    protected processGetPostgraduateTitle(response: HttpResponseBase): Observable<PostgraduateTitleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PostgraduateTitleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    postPostgraduateTitle(body: CreatePostgraduateTitleDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/PostgraduateTitle/PostPostgraduateTitle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostPostgraduateTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostPostgraduateTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processPostPostgraduateTitle(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    putPostgraduateTitle(id: number | undefined, body: PostgraduateTitleDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PostgraduateTitle/PutPostgraduateTitle?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutPostgraduateTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutPostgraduateTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutPostgraduateTitle(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param reason (optional) 
     * @return Success
     */
    deletePostgraduateTitle(id: number | undefined, reason: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PostgraduateTitle/DeletePostgraduateTitle?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (reason === null)
            throw new Error("The parameter 'reason' cannot be null.");
        else if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePostgraduateTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePostgraduateTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePostgraduateTitle(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PostgraduateTitleProfessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param postgraduateTitleId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(postgraduateTitleId: string | undefined, body: string[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PostgraduateTitleProfession/CreateOrUpdate?";
        if (postgraduateTitleId === null)
            throw new Error("The parameter 'postgraduateTitleId' cannot be null.");
        else if (postgraduateTitleId !== undefined)
            url_ += "postgraduateTitleId=" + encodeURIComponent("" + postgraduateTitleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param postgraduateTitleId (optional) 
     * @return Success
     */
    getProfessionsForPostgraduateTitle(postgraduateTitleId: string | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/PostgraduateTitleProfession/GetProfessionsForPostgraduateTitle?";
        if (postgraduateTitleId === null)
            throw new Error("The parameter 'postgraduateTitleId' cannot be null.");
        else if (postgraduateTitleId !== undefined)
            url_ += "postgraduateTitleId=" + encodeURIComponent("" + postgraduateTitleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfessionsForPostgraduateTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfessionsForPostgraduateTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetProfessionsForPostgraduateTitle(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param professionId (optional) 
     * @return Success
     */
    getPostgraduateTitlesForProfession(professionId: string | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/PostgraduateTitleProfession/GetPostgraduateTitlesForProfession?";
        if (professionId === null)
            throw new Error("The parameter 'professionId' cannot be null.");
        else if (professionId !== undefined)
            url_ += "professionId=" + encodeURIComponent("" + professionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPostgraduateTitlesForProfession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPostgraduateTitlesForProfession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetPostgraduateTitlesForProfession(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProfessionRegisterAffiliationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getAllActiveAsString(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/ProfessionRegisterAffiliation/GetAllActiveAsString";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllActiveAsString(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllActiveAsString(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllActiveAsString(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param professionId (optional) 
     * @return Success
     */
    get(professionId: string | undefined): Observable<ProfessionRegisterAffiliationDto> {
        let url_ = this.baseUrl + "/api/services/app/ProfessionRegisterAffiliation/Get?";
        if (professionId === null)
            throw new Error("The parameter 'professionId' cannot be null.");
        else if (professionId !== undefined)
            url_ += "professionId=" + encodeURIComponent("" + professionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfessionRegisterAffiliationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfessionRegisterAffiliationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProfessionRegisterAffiliationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfessionRegisterAffiliationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAll(): Observable<ProfessionRegisterAffiliationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProfessionRegisterAffiliation/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfessionRegisterAffiliationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfessionRegisterAffiliationDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ProfessionRegisterAffiliationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProfessionRegisterAffiliationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ProfessionRegisterAffiliationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProfessionRegisterAffiliation/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProfessionRequirementServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ProfessionRequirementDto> {
        let url_ = this.baseUrl + "/api/services/app/ProfessionRequirement/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfessionRequirementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfessionRequirementDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProfessionRequirementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfessionRequirementDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateProfessionRequirementInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProfessionRequirement/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProfessionRequirement/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param professionId (optional) 
     * @param typeId (optional) 
     * @return Success
     */
    getRequirementByProfessionAndType(professionId: string | undefined, typeId: ProfessionRequirementType | undefined): Observable<ProfessionRequirementDto> {
        let url_ = this.baseUrl + "/api/services/app/ProfessionRequirement/GetRequirementByProfessionAndType?";
        if (professionId === null)
            throw new Error("The parameter 'professionId' cannot be null.");
        else if (professionId !== undefined)
            url_ += "professionId=" + encodeURIComponent("" + professionId) + "&";
        if (typeId === null)
            throw new Error("The parameter 'typeId' cannot be null.");
        else if (typeId !== undefined)
            url_ += "typeId=" + encodeURIComponent("" + typeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequirementByProfessionAndType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequirementByProfessionAndType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfessionRequirementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfessionRequirementDto>;
        }));
    }

    protected processGetRequirementByProfessionAndType(response: HttpResponseBase): Observable<ProfessionRequirementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfessionRequirementDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    dummy(body: AtLeastOnePresent | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProfessionRequirement/Dummy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDummy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDummy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDummy(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    dummy2(body: AtLeastOneEmploymentDefined | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProfessionRequirement/Dummy2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDummy2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDummy2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDummy2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    dummy3(body: ProfessionLiaEmploymentRequirementType | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProfessionRequirement/Dummy3";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDummy3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDummy3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDummy3(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    dummy4(body: ProfessionLiaInvoiceAddressRequirementType | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProfessionRequirement/Dummy4";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDummy4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDummy4(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDummy4(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProfessionRequirementGroupServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ProfessionRequirementGroupDto> {
        let url_ = this.baseUrl + "/api/services/app/ProfessionRequirementGroup/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfessionRequirementGroupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfessionRequirementGroupDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProfessionRequirementGroupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfessionRequirementGroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateProfessionRequirementGroupInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProfessionRequirementGroup/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param groupId (optional) 
     * @param description (optional) 
     * @return Success
     */
    update(groupId: number | undefined, description: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProfessionRequirementGroup/Update?";
        if (groupId === null)
            throw new Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        if (description === null)
            throw new Error("The parameter 'description' cannot be null.");
        else if (description !== undefined)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param groupId (optional) 
     * @return Success
     */
    delete(groupId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProfessionRequirementGroup/Delete?";
        if (groupId === null)
            throw new Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param alternativeId (optional) 
     * @return Success
     */
    getAlternative(alternativeId: number | undefined): Observable<ProfessionRequirementAlternativeDto> {
        let url_ = this.baseUrl + "/api/services/app/ProfessionRequirementGroup/GetAlternative?";
        if (alternativeId === null)
            throw new Error("The parameter 'alternativeId' cannot be null.");
        else if (alternativeId !== undefined)
            url_ += "alternativeId=" + encodeURIComponent("" + alternativeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAlternative(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlternative(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfessionRequirementAlternativeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfessionRequirementAlternativeDto>;
        }));
    }

    protected processGetAlternative(response: HttpResponseBase): Observable<ProfessionRequirementAlternativeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfessionRequirementAlternativeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param groupId (optional) 
     * @return Success
     */
    createAlternative(groupId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ProfessionRequirementGroup/CreateAlternative?";
        if (groupId === null)
            throw new Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAlternative(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAlternative(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateAlternative(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param alternativeId (optional) 
     * @return Success
     */
    deleteAlternative(alternativeId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProfessionRequirementGroup/DeleteAlternative?";
        if (alternativeId === null)
            throw new Error("The parameter 'alternativeId' cannot be null.");
        else if (alternativeId !== undefined)
            url_ += "alternativeId=" + encodeURIComponent("" + alternativeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAlternative(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAlternative(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAlternative(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProfileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getCurrentUserProfileForEdit(): Observable<CurrentUserProfileEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetCurrentUserProfileForEdit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUserProfileForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUserProfileForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrentUserProfileEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrentUserProfileEditDto>;
        }));
    }

    protected processGetCurrentUserProfileForEdit(response: HttpResponseBase): Observable<CurrentUserProfileEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrentUserProfileEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    disableGoogleAuthenticator(body: VerifyAuthenticatorCodeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/DisableGoogleAuthenticator";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableGoogleAuthenticator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableGoogleAuthenticator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDisableGoogleAuthenticator(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    viewRecoveryCodes(body: VerifyAuthenticatorCodeInput | undefined): Observable<UpdateGoogleAuthenticatorKeyOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ViewRecoveryCodes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processViewRecoveryCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processViewRecoveryCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateGoogleAuthenticatorKeyOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateGoogleAuthenticatorKeyOutput>;
        }));
    }

    protected processViewRecoveryCodes(response: HttpResponseBase): Observable<UpdateGoogleAuthenticatorKeyOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateGoogleAuthenticatorKeyOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    generateGoogleAuthenticatorKey(): Observable<GenerateGoogleAuthenticatorKeyOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GenerateGoogleAuthenticatorKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateGoogleAuthenticatorKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateGoogleAuthenticatorKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenerateGoogleAuthenticatorKeyOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenerateGoogleAuthenticatorKeyOutput>;
        }));
    }

    protected processGenerateGoogleAuthenticatorKey(response: HttpResponseBase): Observable<GenerateGoogleAuthenticatorKeyOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenerateGoogleAuthenticatorKeyOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateGoogleAuthenticatorKey(body: UpdateGoogleAuthenticatorKeyInput | undefined): Observable<UpdateGoogleAuthenticatorKeyOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateGoogleAuthenticatorKey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateGoogleAuthenticatorKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateGoogleAuthenticatorKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateGoogleAuthenticatorKeyOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateGoogleAuthenticatorKeyOutput>;
        }));
    }

    protected processUpdateGoogleAuthenticatorKey(response: HttpResponseBase): Observable<UpdateGoogleAuthenticatorKeyOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateGoogleAuthenticatorKeyOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendVerificationSms(body: SendVerificationSmsInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/SendVerificationSms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendVerificationSms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendVerificationSms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendVerificationSms(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    verifySmsCode(body: VerifySmsCodeInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/VerifySmsCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifySmsCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifySmsCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processVerifySmsCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    prepareCollectedData(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/PrepareCollectedData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrepareCollectedData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrepareCollectedData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPrepareCollectedData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCurrentUserProfile(body: CurrentUserProfileEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateCurrentUserProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCurrentUserProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCurrentUserProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCurrentUserProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProfilePicture(body: UpdateProfilePictureInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateProfilePicture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProfilePicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProfilePicture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateProfilePicture(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    verifyAuthenticatorCode(body: VerifyAuthenticatorCodeInput | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Profile/VerifyAuthenticatorCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyAuthenticatorCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyAuthenticatorCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processVerifyAuthenticatorCode(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getPasswordComplexitySetting(): Observable<GetPasswordComplexitySettingOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetPasswordComplexitySetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPasswordComplexitySetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPasswordComplexitySetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPasswordComplexitySettingOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPasswordComplexitySettingOutput>;
        }));
    }

    protected processGetPasswordComplexitySetting(response: HttpResponseBase): Observable<GetPasswordComplexitySettingOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPasswordComplexitySettingOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getProfilePicture(): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePicture";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfilePicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfilePicture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
        }));
    }

    protected processGetProfilePicture(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param username (optional) 
     * @return Success
     */
    getProfilePictureByUserName(username: string | undefined): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePictureByUserName?";
        if (username === null)
            throw new Error("The parameter 'username' cannot be null.");
        else if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfilePictureByUserName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfilePictureByUserName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
        }));
    }

    protected processGetProfilePictureByUserName(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getFriendProfilePicture(userId: number | undefined, tenantId: number | undefined): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetFriendProfilePicture?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFriendProfilePicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFriendProfilePicture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
        }));
    }

    protected processGetFriendProfilePicture(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getProfilePictureByUser(userId: number | undefined): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePictureByUser?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfilePictureByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfilePictureByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
        }));
    }

    protected processGetProfilePictureByUser(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeLanguage(body: ChangeUserLanguageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PsyRegServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    get(personId: number): Observable<GetPsyRegPersonOutput> {
        let url_ = this.baseUrl + "/api/services/app/PsyReg/Get?";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined and cannot be null.");
        else
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPsyRegPersonOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPsyRegPersonOutput>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetPsyRegPersonOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPsyRegPersonOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param gln (optional) 
     * @return Success
     */
    getByGln(gln: string | undefined): Observable<GetPsyRegPersonOutput> {
        let url_ = this.baseUrl + "/api/services/app/PsyReg/GetByGln?";
        if (gln === null)
            throw new Error("The parameter 'gln' cannot be null.");
        else if (gln !== undefined)
            url_ += "gln=" + encodeURIComponent("" + gln) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByGln(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByGln(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPsyRegPersonOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPsyRegPersonOutput>;
        }));
    }

    protected processGetByGln(response: HttpResponseBase): Observable<GetPsyRegPersonOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPsyRegPersonOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getDetailed(personId: number): Observable<GetPsyRegPersonDetailedOutput> {
        let url_ = this.baseUrl + "/api/services/app/PsyReg/GetDetailed?";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined and cannot be null.");
        else
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetailed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetailed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPsyRegPersonDetailedOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPsyRegPersonDetailedOutput>;
        }));
    }

    protected processGetDetailed(response: HttpResponseBase): Observable<GetPsyRegPersonDetailedOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPsyRegPersonDetailedOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param gln (optional) 
     * @return Success
     */
    getDetailedByGln(gln: string | undefined): Observable<GetPsyRegPersonDetailedOutput> {
        let url_ = this.baseUrl + "/api/services/app/PsyReg/GetDetailedByGln?";
        if (gln === null)
            throw new Error("The parameter 'gln' cannot be null.");
        else if (gln !== undefined)
            url_ += "gln=" + encodeURIComponent("" + gln) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetailedByGln(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetailedByGln(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPsyRegPersonDetailedOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPsyRegPersonDetailedOutput>;
        }));
    }

    protected processGetDetailedByGln(response: HttpResponseBase): Observable<GetPsyRegPersonDetailedOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPsyRegPersonDetailedOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    search(body: SearchPsyRegPersonInput | undefined): Observable<SearchPsyRegPersonOutput> {
        let url_ = this.baseUrl + "/api/services/app/PsyReg/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchPsyRegPersonOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchPsyRegPersonOutput>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<SearchPsyRegPersonOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchPsyRegPersonOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RestrictionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<GetRestrictionDto> {
        let url_ = this.baseUrl + "/api/services/app/Restriction/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRestrictionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRestrictionDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetRestrictionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRestrictionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    post(body: CreateRestrictionDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Restriction/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    put(id: number | undefined, body: UpdateRestrictionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Restriction/Put?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    canDelete(id: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Restriction/CanDelete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCanDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCanDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCanDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Restriction/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RlaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createRla(body: CreateRlaInput | undefined): Observable<CreateRlaOutput> {
        let url_ = this.baseUrl + "/api/services/app/Rla/CreateRla";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRla(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRla(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateRlaOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateRlaOutput>;
        }));
    }

    protected processCreateRla(response: HttpResponseBase): Observable<CreateRlaOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateRlaOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMyRlas(): Observable<RlaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Rla/GetMyRlas";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyRlas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyRlas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RlaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RlaDto[]>;
        }));
    }

    protected processGetMyRlas(response: HttpResponseBase): Observable<RlaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RlaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getRla(caseId: string | undefined): Observable<GetRlaOutput> {
        let url_ = this.baseUrl + "/api/services/app/Rla/GetRla?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRla(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRla(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRlaOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRlaOutput>;
        }));
    }

    protected processGetRla(response: HttpResponseBase): Observable<GetRlaOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRlaOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param applicantComment (optional) 
     * @return Success
     */
    releaseRla(caseId: string | undefined, applicantComment: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Rla/ReleaseRla?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (applicantComment === null)
            throw new Error("The parameter 'applicantComment' cannot be null.");
        else if (applicantComment !== undefined)
            url_ += "applicantComment=" + encodeURIComponent("" + applicantComment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseRla(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseRla(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReleaseRla(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getEvaluationComments(caseId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Rla/GetEvaluationComments?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvaluationComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvaluationComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetEvaluationComments(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getProfessionalLicenceForRla(caseId: string | undefined): Observable<ProfessionalLicenceDto> {
        let url_ = this.baseUrl + "/api/services/app/Rla/getProfessionalLicenceForRla?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfessionalLicenceForRla(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfessionalLicenceForRla(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfessionalLicenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfessionalLicenceDto>;
        }));
    }

    protected processGetProfessionalLicenceForRla(response: HttpResponseBase): Observable<ProfessionalLicenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfessionalLicenceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RlaAcademicTitleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateRlaAcademicTitleInput | undefined): Observable<CreateOrUpdateRlaAcademicTitleOutput> {
        let url_ = this.baseUrl + "/api/services/app/RlaAcademicTitle/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateRlaAcademicTitleOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateRlaAcademicTitleOutput>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<CreateOrUpdateRlaAcademicTitleOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrUpdateRlaAcademicTitleOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    createBlank(caseId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/RlaAcademicTitle/CreateBlank?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBlank(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBlank(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateBlank(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param academicTitleId (optional) 
     * @return Success
     */
    delete(caseId: string | undefined, academicTitleId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RlaAcademicTitle/Delete?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (academicTitleId === null)
            throw new Error("The parameter 'academicTitleId' cannot be null.");
        else if (academicTitleId !== undefined)
            url_ += "academicTitleId=" + encodeURIComponent("" + academicTitleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getFiles(caseId: string | undefined): Observable<RlaDocumentGroup[]> {
        let url_ = this.baseUrl + "/api/services/app/RlaAcademicTitle/GetFiles?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RlaDocumentGroup[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RlaDocumentGroup[]>;
        }));
    }

    protected processGetFiles(response: HttpResponseBase): Observable<RlaDocumentGroup[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RlaDocumentGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param rlaAcademicTitleId (optional) 
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(rlaAcademicTitleId: string | undefined, body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RlaAcademicTitle/UploadFiles?";
        if (rlaAcademicTitleId === null)
            throw new Error("The parameter 'rlaAcademicTitleId' cannot be null.");
        else if (rlaAcademicTitleId !== undefined)
            url_ += "rlaAcademicTitleId=" + encodeURIComponent("" + rlaAcademicTitleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RlaApplicantPersonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateRlaApplicantPersonInput | undefined): Observable<RlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/RlaApplicantPerson/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RlaStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<RlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RlaBusinessServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateRlaBusinessInput | undefined): Observable<RlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/RlaBusiness/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RlaStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<RlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RlaContactServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateRlaContactInput | undefined): Observable<RlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/RlaContact/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RlaStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<RlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RlaInvoiceAddressServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateRlaInvoiceAddressInput | undefined): Observable<RlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/RlaInvoiceAddress/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RlaStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<RlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RlaPersonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateRlaPersonInput | undefined): Observable<RlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/RlaPerson/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RlaStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<RlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RlaReplacementServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: CreateOrUpdateRlaReplacementInput | undefined): Observable<RlaStatus> {
        let url_ = this.baseUrl + "/api/services/app/RlaReplacement/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RlaStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RlaStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<RlaStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getRoles(body: GetRolesInput | undefined): Observable<ListResultDtoOfRoleListDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfRoleListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfRoleListDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<ListResultDtoOfRoleListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfRoleListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRoleForEdit(id: number | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRoleForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRoleForEditOutput>;
        }));
    }

    protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRoleForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateRole(body: CreateOrUpdateRoleInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/CreateOrUpdateRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteRole(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/DeleteRole?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SapInvoiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    search(body: SearchInvoicesInput | undefined): Observable<SearchInvoicesOutput> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchInvoicesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchInvoicesOutput>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<SearchInvoicesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchInvoicesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param invoiceId (optional) 
     * @return Success
     */
    get(invoiceId: number | undefined): Observable<SapInvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/Get?";
        if (invoiceId === null)
            throw new Error("The parameter 'invoiceId' cannot be null.");
        else if (invoiceId !== undefined)
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SapInvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SapInvoiceDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SapInvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SapInvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param personId (optional) 
     * @param sponsorshipId (optional) 
     * @return Success
     */
    getEmpty(personId: number | undefined, sponsorshipId: number | undefined): Observable<SapInvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/GetEmpty?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (sponsorshipId === null)
            throw new Error("The parameter 'sponsorshipId' cannot be null.");
        else if (sponsorshipId !== undefined)
            url_ += "sponsorshipId=" + encodeURIComponent("" + sponsorshipId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmpty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmpty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SapInvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SapInvoiceDto>;
        }));
    }

    protected processGetEmpty(response: HttpResponseBase): Observable<SapInvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SapInvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateOrUpdateSapInvoiceDto | undefined): Observable<SapInvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SapInvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SapInvoiceDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<SapInvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SapInvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param invoiceId (optional) 
     * @param body (optional) 
     * @return Success
     */
    update(invoiceId: number | undefined, body: CreateOrUpdateSapInvoiceDto | undefined): Observable<SapInvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/Update?";
        if (invoiceId === null)
            throw new Error("The parameter 'invoiceId' cannot be null.");
        else if (invoiceId !== undefined)
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SapInvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SapInvoiceDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<SapInvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SapInvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param invoiceId (optional) 
     * @param cancellationReasonId (optional) 
     * @return Success
     */
    cancelInvoice(invoiceId: number | undefined, cancellationReasonId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/CancelInvoice?";
        if (invoiceId === null)
            throw new Error("The parameter 'invoiceId' cannot be null.");
        else if (invoiceId !== undefined)
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        if (cancellationReasonId === null)
            throw new Error("The parameter 'cancellationReasonId' cannot be null.");
        else if (cancellationReasonId !== undefined)
            url_ += "cancellationReasonId=" + encodeURIComponent("" + cancellationReasonId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelInvoice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param invoiceId (optional) 
     * @param reason (optional) 
     * @return Success
     */
    delete(invoiceId: number | undefined, reason: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/Delete?";
        if (invoiceId === null)
            throw new Error("The parameter 'invoiceId' cannot be null.");
        else if (invoiceId !== undefined)
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        if (reason === null)
            throw new Error("The parameter 'reason' cannot be null.");
        else if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param measureId (optional) 
     * @return Success
     */
    createInvoiceForPersonDisciplinaryMeasures(measureId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/CreateInvoiceForPersonDisciplinaryMeasures?";
        if (measureId === null)
            throw new Error("The parameter 'measureId' cannot be null.");
        else if (measureId !== undefined)
            url_ += "measureId=" + encodeURIComponent("" + measureId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInvoiceForPersonDisciplinaryMeasures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInvoiceForPersonDisciplinaryMeasures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateInvoiceForPersonDisciplinaryMeasures(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param licenceId (optional) 
     * @return Success
     */
    createInvoiceForPersonLicence(licenceId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/CreateInvoiceForPersonLicence?";
        if (licenceId === null)
            throw new Error("The parameter 'licenceId' cannot be null.");
        else if (licenceId !== undefined)
            url_ += "licenceId=" + encodeURIComponent("" + licenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInvoiceForPersonLicence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInvoiceForPersonLicence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateInvoiceForPersonLicence(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param licenceId (optional) 
     * @return Success
     */
    createInvoiceForPersonLicenceRenewal(licenceId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/CreateInvoiceForPersonLicenceRenewal?";
        if (licenceId === null)
            throw new Error("The parameter 'licenceId' cannot be null.");
        else if (licenceId !== undefined)
            url_ += "licenceId=" + encodeURIComponent("" + licenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInvoiceForPersonLicenceRenewal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInvoiceForPersonLicenceRenewal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateInvoiceForPersonLicenceRenewal(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param licenceId (optional) 
     * @return Success
     */
    createInvoiceForCorporateLicence(licenceId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/CreateInvoiceForCorporateLicence?";
        if (licenceId === null)
            throw new Error("The parameter 'licenceId' cannot be null.");
        else if (licenceId !== undefined)
            url_ += "licenceId=" + encodeURIComponent("" + licenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInvoiceForCorporateLicence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInvoiceForCorporateLicence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateInvoiceForCorporateLicence(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param licenceId (optional) 
     * @return Success
     */
    createInvoiceForCorporateLicenceRenewal(licenceId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/CreateInvoiceForCorporateLicenceRenewal?";
        if (licenceId === null)
            throw new Error("The parameter 'licenceId' cannot be null.");
        else if (licenceId !== undefined)
            url_ += "licenceId=" + encodeURIComponent("" + licenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInvoiceForCorporateLicenceRenewal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInvoiceForCorporateLicenceRenewal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateInvoiceForCorporateLicenceRenewal(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param invoiceId (optional) 
     * @return Success
     */
    releaseInvoice(invoiceId: number | undefined): Observable<SapInvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/ReleaseInvoice?";
        if (invoiceId === null)
            throw new Error("The parameter 'invoiceId' cannot be null.");
        else if (invoiceId !== undefined)
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SapInvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SapInvoiceDto>;
        }));
    }

    protected processReleaseInvoice(response: HttpResponseBase): Observable<SapInvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SapInvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param invoiceId (optional) 
     * @param personId (optional) 
     * @param addressTypeId (optional) 
     * @return Success
     */
    getSapQueryForPerson(invoiceId: number | undefined, personId: number | undefined, addressTypeId: string | undefined): Observable<SapBusinessPartnerSearchQueryDto> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/GetSapQueryForPerson?";
        if (invoiceId === null)
            throw new Error("The parameter 'invoiceId' cannot be null.");
        else if (invoiceId !== undefined)
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (addressTypeId === null)
            throw new Error("The parameter 'addressTypeId' cannot be null.");
        else if (addressTypeId !== undefined)
            url_ += "addressTypeId=" + encodeURIComponent("" + addressTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSapQueryForPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSapQueryForPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SapBusinessPartnerSearchQueryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SapBusinessPartnerSearchQueryDto>;
        }));
    }

    protected processGetSapQueryForPerson(response: HttpResponseBase): Observable<SapBusinessPartnerSearchQueryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SapBusinessPartnerSearchQueryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param invoiceId (optional) 
     * @param businessId (optional) 
     * @return Success
     */
    getSapQueryForBusiness(invoiceId: number | undefined, businessId: number | undefined): Observable<SapBusinessPartnerSearchQueryDto> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/GetSapQueryForBusiness?";
        if (invoiceId === null)
            throw new Error("The parameter 'invoiceId' cannot be null.");
        else if (invoiceId !== undefined)
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        if (businessId === null)
            throw new Error("The parameter 'businessId' cannot be null.");
        else if (businessId !== undefined)
            url_ += "businessId=" + encodeURIComponent("" + businessId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSapQueryForBusiness(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSapQueryForBusiness(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SapBusinessPartnerSearchQueryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SapBusinessPartnerSearchQueryDto>;
        }));
    }

    protected processGetSapQueryForBusiness(response: HttpResponseBase): Observable<SapBusinessPartnerSearchQueryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SapBusinessPartnerSearchQueryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param invoiceId (optional) 
     * @param sponsorshipId (optional) 
     * @param addressTypeId (optional) 
     * @return Success
     */
    getSapQueryForSponsorship(invoiceId: number | undefined, sponsorshipId: number | undefined, addressTypeId: string | undefined): Observable<SapBusinessPartnerSearchQueryDto> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/GetSapQueryForSponsorship?";
        if (invoiceId === null)
            throw new Error("The parameter 'invoiceId' cannot be null.");
        else if (invoiceId !== undefined)
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        if (sponsorshipId === null)
            throw new Error("The parameter 'sponsorshipId' cannot be null.");
        else if (sponsorshipId !== undefined)
            url_ += "sponsorshipId=" + encodeURIComponent("" + sponsorshipId) + "&";
        if (addressTypeId === null)
            throw new Error("The parameter 'addressTypeId' cannot be null.");
        else if (addressTypeId !== undefined)
            url_ += "addressTypeId=" + encodeURIComponent("" + addressTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSapQueryForSponsorship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSapQueryForSponsorship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SapBusinessPartnerSearchQueryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SapBusinessPartnerSearchQueryDto>;
        }));
    }

    protected processGetSapQueryForSponsorship(response: HttpResponseBase): Observable<SapBusinessPartnerSearchQueryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SapBusinessPartnerSearchQueryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param cantonalDepartmentId (optional) 
     * @param body (optional) 
     * @return Success
     */
    searchBusinessPartner(cantonalDepartmentId: string | undefined, body: SapBusinessPartnerSearchQueryDto | undefined): Observable<SapBusinessPartnerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/SearchBusinessPartner?";
        if (cantonalDepartmentId === null)
            throw new Error("The parameter 'cantonalDepartmentId' cannot be null.");
        else if (cantonalDepartmentId !== undefined)
            url_ += "cantonalDepartmentId=" + encodeURIComponent("" + cantonalDepartmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchBusinessPartner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchBusinessPartner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SapBusinessPartnerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SapBusinessPartnerDto[]>;
        }));
    }

    protected processSearchBusinessPartner(response: HttpResponseBase): Observable<SapBusinessPartnerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SapBusinessPartnerDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sapId (optional) 
     * @param personId (optional) 
     * @param businessId (optional) 
     * @param sponsorshipId (optional) 
     * @return Success
     */
    assignBusinessPartner(sapId: string | undefined, personId: number | undefined, businessId: number | undefined, sponsorshipId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/AssignBusinessPartner?";
        if (sapId === null)
            throw new Error("The parameter 'sapId' cannot be null.");
        else if (sapId !== undefined)
            url_ += "sapId=" + encodeURIComponent("" + sapId) + "&";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (businessId === null)
            throw new Error("The parameter 'businessId' cannot be null.");
        else if (businessId !== undefined)
            url_ += "businessId=" + encodeURIComponent("" + businessId) + "&";
        if (sponsorshipId === null)
            throw new Error("The parameter 'sponsorshipId' cannot be null.");
        else if (sponsorshipId !== undefined)
            url_ += "sponsorshipId=" + encodeURIComponent("" + sponsorshipId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignBusinessPartner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignBusinessPartner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssignBusinessPartner(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param invoiceId (optional) 
     * @param addressTypeId (optional) 
     * @param personId (optional) 
     * @param businessId (optional) 
     * @param sponsorshipId (optional) 
     * @param cantonalDepartmentId (optional) 
     * @return Success
     */
    createAndAssignBusinessPartner(invoiceId: number | undefined, addressTypeId: string | undefined, personId: number | undefined, businessId: number | undefined, sponsorshipId: number | undefined, cantonalDepartmentId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/CreateAndAssignBusinessPartner?";
        if (invoiceId === null)
            throw new Error("The parameter 'invoiceId' cannot be null.");
        else if (invoiceId !== undefined)
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        if (addressTypeId === null)
            throw new Error("The parameter 'addressTypeId' cannot be null.");
        else if (addressTypeId !== undefined)
            url_ += "addressTypeId=" + encodeURIComponent("" + addressTypeId) + "&";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (businessId === null)
            throw new Error("The parameter 'businessId' cannot be null.");
        else if (businessId !== undefined)
            url_ += "businessId=" + encodeURIComponent("" + businessId) + "&";
        if (sponsorshipId === null)
            throw new Error("The parameter 'sponsorshipId' cannot be null.");
        else if (sponsorshipId !== undefined)
            url_ += "sponsorshipId=" + encodeURIComponent("" + sponsorshipId) + "&";
        if (cantonalDepartmentId === null)
            throw new Error("The parameter 'cantonalDepartmentId' cannot be null.");
        else if (cantonalDepartmentId !== undefined)
            url_ += "cantonalDepartmentId=" + encodeURIComponent("" + cantonalDepartmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAndAssignBusinessPartner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAndAssignBusinessPartner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateAndAssignBusinessPartner(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchProducts(body: SearchProductsInput | undefined): Observable<SearchProductsOutput> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/SearchProducts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchProductsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchProductsOutput>;
        }));
    }

    protected processSearchProducts(response: HttpResponseBase): Observable<SearchProductsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchProductsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param onlyActive (optional) 
     * @return Success
     */
    getProducts(onlyActive: boolean | undefined): Observable<SapProductDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/GetProducts?";
        if (onlyActive === null)
            throw new Error("The parameter 'onlyActive' cannot be null.");
        else if (onlyActive !== undefined)
            url_ += "onlyActive=" + encodeURIComponent("" + onlyActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SapProductDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SapProductDto[]>;
        }));
    }

    protected processGetProducts(response: HttpResponseBase): Observable<SapProductDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SapProductDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getProduct(id: number | undefined): Observable<SapProductDto> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/GetProduct?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SapProductDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SapProductDto>;
        }));
    }

    protected processGetProduct(response: HttpResponseBase): Observable<SapProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SapProductDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateProduct(body: SapProductDto | undefined): Observable<SapProductDto> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/CreateOrUpdateProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SapProductDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SapProductDto>;
        }));
    }

    protected processCreateOrUpdateProduct(response: HttpResponseBase): Observable<SapProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SapProductDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteProduct(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/DeleteProduct?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteProduct(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchCancellationReasons(body: SearchCancellationReasonsInput | undefined): Observable<SearchCancellationReasonsOutput> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/SearchCancellationReasons";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchCancellationReasons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchCancellationReasons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchCancellationReasonsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchCancellationReasonsOutput>;
        }));
    }

    protected processSearchCancellationReasons(response: HttpResponseBase): Observable<SearchCancellationReasonsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchCancellationReasonsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCancellationReasons(): Observable<SapCancellationReasonDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/GetCancellationReasons";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCancellationReasons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCancellationReasons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SapCancellationReasonDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SapCancellationReasonDto[]>;
        }));
    }

    protected processGetCancellationReasons(response: HttpResponseBase): Observable<SapCancellationReasonDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SapCancellationReasonDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCancellationReason(id: number | undefined): Observable<SapCancellationReasonDto> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/GetCancellationReason?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCancellationReason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCancellationReason(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SapCancellationReasonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SapCancellationReasonDto>;
        }));
    }

    protected processGetCancellationReason(response: HttpResponseBase): Observable<SapCancellationReasonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SapCancellationReasonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateCancellationReason(body: SapCancellationReasonDto | undefined): Observable<SapCancellationReasonDto> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/CreateOrUpdateCancellationReason";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateCancellationReason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateCancellationReason(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SapCancellationReasonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SapCancellationReasonDto>;
        }));
    }

    protected processCreateOrUpdateCancellationReason(response: HttpResponseBase): Observable<SapCancellationReasonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SapCancellationReasonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteCancellationReason(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SapInvoice/DeleteCancellationReason?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCancellationReason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCancellationReason(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCancellationReason(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SensitiveDataServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getHasOngoingLegalProceedingAndCreateIfNotExisting(discriminator: SensitiveDataDiscriminator, entityId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SensitiveData/GetHasOngoingLegalProceedingAndCreateIfNotExisting?";
        if (discriminator === undefined || discriminator === null)
            throw new Error("The parameter 'discriminator' must be defined and cannot be null.");
        else
            url_ += "Discriminator=" + encodeURIComponent("" + discriminator) + "&";
        if (entityId === undefined || entityId === null)
            throw new Error("The parameter 'entityId' must be defined and cannot be null.");
        else
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHasOngoingLegalProceedingAndCreateIfNotExisting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHasOngoingLegalProceedingAndCreateIfNotExisting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetHasOngoingLegalProceedingAndCreateIfNotExisting(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAndCreateIfNotExisting(discriminator: SensitiveDataDiscriminator, entityId: number): Observable<GetSensitiveDataDto> {
        let url_ = this.baseUrl + "/api/services/app/SensitiveData/GetAndCreateIfNotExisting?";
        if (discriminator === undefined || discriminator === null)
            throw new Error("The parameter 'discriminator' must be defined and cannot be null.");
        else
            url_ += "Discriminator=" + encodeURIComponent("" + discriminator) + "&";
        if (entityId === undefined || entityId === null)
            throw new Error("The parameter 'entityId' must be defined and cannot be null.");
        else
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAndCreateIfNotExisting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAndCreateIfNotExisting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSensitiveDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSensitiveDataDto>;
        }));
    }

    protected processGetAndCreateIfNotExisting(response: HttpResponseBase): Observable<GetSensitiveDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSensitiveDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSensitiveData(discriminator: SensitiveDataDiscriminator, entityId: number, body: UpdateSensitiveDataDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SensitiveData/UpdateSensitiveData?";
        if (discriminator === undefined || discriminator === null)
            throw new Error("The parameter 'discriminator' must be defined and cannot be null.");
        else
            url_ += "Discriminator=" + encodeURIComponent("" + discriminator) + "&";
        if (entityId === undefined || entityId === null)
            throw new Error("The parameter 'entityId' must be defined and cannot be null.");
        else
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSensitiveData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSensitiveData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSensitiveData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getRecords(id_Discriminator: SensitiveDataDiscriminator, id_EntityId: number, recordDiscriminator: SensitiveDataRecordDiscriminator, filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetSensitiveDataSearchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/SensitiveData/GetRecords?";
        if (id_Discriminator === undefined || id_Discriminator === null)
            throw new Error("The parameter 'id_Discriminator' must be defined and cannot be null.");
        else
            url_ += "Id.Discriminator=" + encodeURIComponent("" + id_Discriminator) + "&";
        if (id_EntityId === undefined || id_EntityId === null)
            throw new Error("The parameter 'id_EntityId' must be defined and cannot be null.");
        else
            url_ += "Id.EntityId=" + encodeURIComponent("" + id_EntityId) + "&";
        if (recordDiscriminator === undefined || recordDiscriminator === null)
            throw new Error("The parameter 'recordDiscriminator' must be defined and cannot be null.");
        else
            url_ += "RecordDiscriminator=" + encodeURIComponent("" + recordDiscriminator) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSensitiveDataSearchOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSensitiveDataSearchOutputDto>;
        }));
    }

    protected processGetRecords(response: HttpResponseBase): Observable<GetSensitiveDataSearchOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSensitiveDataSearchOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRecord(id: number | undefined): Observable<GetSensitiveDataRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/SensitiveData/GetRecord?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSensitiveDataRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSensitiveDataRecordDto>;
        }));
    }

    protected processGetRecord(response: HttpResponseBase): Observable<GetSensitiveDataRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSensitiveDataRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createRecord(discriminator: SensitiveDataDiscriminator, entityId: number, body: CreateSensitiveDataRecordDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SensitiveData/CreateRecord?";
        if (discriminator === undefined || discriminator === null)
            throw new Error("The parameter 'discriminator' must be defined and cannot be null.");
        else
            url_ += "Discriminator=" + encodeURIComponent("" + discriminator) + "&";
        if (entityId === undefined || entityId === null)
            throw new Error("The parameter 'entityId' must be defined and cannot be null.");
        else
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateRecord(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateRecord(id: number | undefined, body: UpdateSensitiveDataRecordDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SensitiveData/UpdateRecord?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateRecord(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginInformations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCurrentLoginInformationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCurrentLoginInformationsOutput>;
        }));
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    updateUserSignInToken(): Observable<UpdateUserSignInTokenOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/UpdateUserSignInToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserSignInToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserSignInToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateUserSignInTokenOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateUserSignInTokenOutput>;
        }));
    }

    protected processUpdateUserSignInToken(response: HttpResponseBase): Observable<UpdateUserSignInTokenOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateUserSignInTokenOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SidapServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllOperations(body: GetSidapOperationsInputDto | undefined): Observable<GetSidapOperationsOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Sidap/GetAllOperations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOperations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOperations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSidapOperationsOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSidapOperationsOutputDto>;
        }));
    }

    protected processGetAllOperations(response: HttpResponseBase): Observable<GetSidapOperationsOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSidapOperationsOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param operation (optional) 
     * @return Success
     */
    getProtocolInfoFile(operation: string | undefined): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Sidap/GetProtocolInfoFile?";
        if (operation === null)
            throw new Error("The parameter 'operation' cannot be null.");
        else if (operation !== undefined)
            url_ += "operation=" + encodeURIComponent("" + operation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProtocolInfoFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProtocolInfoFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetProtocolInfoFile(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllDocumentTypes(body: GetSidapDocumentGroupsInputDto | undefined): Observable<GetSidapDocumentGroupsOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Sidap/GetAllDocumentTypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDocumentTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDocumentTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSidapDocumentGroupsOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSidapDocumentGroupsOutputDto>;
        }));
    }

    protected processGetAllDocumentTypes(response: HttpResponseBase): Observable<GetSidapDocumentGroupsOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSidapDocumentGroupsOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getAllDocumentTypesToExcel(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Sidap/GetAllDocumentTypesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDocumentTypesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDocumentTypesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetAllDocumentTypesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SlapServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createSlap(body: CreateSlapInput | undefined): Observable<CreateSlapOutput> {
        let url_ = this.baseUrl + "/api/services/app/Slap/CreateSlap";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSlap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSlap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateSlapOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateSlapOutput>;
        }));
    }

    protected processCreateSlap(response: HttpResponseBase): Observable<CreateSlapOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateSlapOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMySlaps(): Observable<SlapDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Slap/GetMySlaps";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMySlaps(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMySlaps(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SlapDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SlapDto[]>;
        }));
    }

    protected processGetMySlaps(response: HttpResponseBase): Observable<SlapDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SlapDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getNextStatus(caseId: string, status: SlapStatus): Observable<SlapStatus> {
        let url_ = this.baseUrl + "/api/services/app/Slap/GetNextStatus?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined and cannot be null.");
        else
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SlapStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SlapStatus>;
        }));
    }

    protected processGetNextStatus(response: HttpResponseBase): Observable<SlapStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param gln (optional) 
     * @return Success
     */
    getSlapsForPerson(gln: string | undefined): Observable<SlapDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Slap/GetSlapsForPerson?";
        if (gln === null)
            throw new Error("The parameter 'gln' cannot be null.");
        else if (gln !== undefined)
            url_ += "gln=" + encodeURIComponent("" + gln) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSlapsForPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSlapsForPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SlapDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SlapDto[]>;
        }));
    }

    protected processGetSlapsForPerson(response: HttpResponseBase): Observable<SlapDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SlapDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getProfessionalLicencePersonIdForSlap(caseId: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Slap/getProfessionalLicencePersonIdForSlap?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfessionalLicencePersonIdForSlap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfessionalLicencePersonIdForSlap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetProfessionalLicencePersonIdForSlap(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getSlap(caseId: string | undefined): Observable<GetSlapOutput> {
        let url_ = this.baseUrl + "/api/services/app/Slap/GetSlap?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSlap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSlap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSlapOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSlapOutput>;
        }));
    }

    protected processGetSlap(response: HttpResponseBase): Observable<GetSlapOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSlapOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param applicantComment (optional) 
     * @return Success
     */
    releaseSlap(caseId: string | undefined, applicantComment: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Slap/ReleaseSlap?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (applicantComment === null)
            throw new Error("The parameter 'applicantComment' cannot be null.");
        else if (applicantComment !== undefined)
            url_ += "applicantComment=" + encodeURIComponent("" + applicantComment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseSlap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseSlap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReleaseSlap(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getEvaluationComments(caseId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Slap/GetEvaluationComments?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvaluationComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvaluationComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetEvaluationComments(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    validateThatAllMandatoryDocumentsHaveBeenUploaded(caseId: string | undefined): Observable<SlapStatus[]> {
        let url_ = this.baseUrl + "/api/services/app/Slap/ValidateThatAllMandatoryDocumentsHaveBeenUploaded?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SlapStatus[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SlapStatus[]>;
        }));
    }

    protected processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response: HttpResponseBase): Observable<SlapStatus[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SlapBusinessServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: SlapBusinessDto | undefined): Observable<SlapStatus> {
        let url_ = this.baseUrl + "/api/services/app/SlapBusiness/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SlapStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SlapStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<SlapStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<SlapBusinessDto> {
        let url_ = this.baseUrl + "/api/services/app/SlapBusiness/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SlapBusinessDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SlapBusinessDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SlapBusinessDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SlapBusinessDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SlapDocumentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getDocuments(body: GetSlapDocumentsInput | undefined): Observable<SlapDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/SlapDocument/GetDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SlapDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SlapDocumentsOutput>;
        }));
    }

    protected processGetDocuments(response: HttpResponseBase): Observable<SlapDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SlapDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SlapDocument/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getFile(body: GetSlapFileInput | undefined): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/SlapDocument/GetFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    deleteFile(caseId: string, step: SlapStatus | undefined, id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SlapDocument/DeleteFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SlapInvoiceAddressServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: SlapInvoiceAddressDto | undefined): Observable<SlapStatus> {
        let url_ = this.baseUrl + "/api/services/app/SlapInvoiceAddress/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SlapStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SlapStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<SlapStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<SlapInvoiceAddressDto> {
        let url_ = this.baseUrl + "/api/services/app/SlapInvoiceAddress/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SlapInvoiceAddressDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SlapInvoiceAddressDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SlapInvoiceAddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SlapInvoiceAddressDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SlapPersonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: SlapPersonDto | undefined): Observable<SlapStatus> {
        let url_ = this.baseUrl + "/api/services/app/SlapPerson/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SlapStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SlapStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<SlapStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<SlapPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/SlapPerson/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SlapPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SlapPersonDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SlapPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SlapPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SlapPracticeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: SlapPracticeDto | undefined): Observable<SlapStatus> {
        let url_ = this.baseUrl + "/api/services/app/SlapPractice/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SlapStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SlapStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<SlapStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<SlapPracticeDto> {
        let url_ = this.baseUrl + "/api/services/app/SlapPractice/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SlapPracticeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SlapPracticeDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SlapPracticeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SlapPracticeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SlapProductPreparationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: SlapProductPreparationDto | undefined): Observable<SlapStatus> {
        let url_ = this.baseUrl + "/api/services/app/SlapProductPreparation/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SlapStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SlapStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<SlapStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<SlapProductPreparationDto> {
        let url_ = this.baseUrl + "/api/services/app/SlapProductPreparation/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SlapProductPreparationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SlapProductPreparationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SlapProductPreparationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SlapProductPreparationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SlapRangeOfProductsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: SlapRangeOfProductsDto | undefined): Observable<SlapStatus> {
        let url_ = this.baseUrl + "/api/services/app/SlapRangeOfProducts/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SlapStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SlapStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<SlapStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<SlapRangeOfProductsDto> {
        let url_ = this.baseUrl + "/api/services/app/SlapRangeOfProducts/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SlapRangeOfProductsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SlapRangeOfProductsDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SlapRangeOfProductsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SlapRangeOfProductsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SlapStatusWizardStepServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param professionId (optional) 
     * @param applicationType (optional) 
     * @return Success
     */
    getAllByProfessionIdAndApplicationType(professionId: string | undefined, applicationType: ApplicationType | undefined): Observable<SlapStatusWizardStepDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SlapStatusWizardStep/GetAllByProfessionIdAndApplicationType?";
        if (professionId === null)
            throw new Error("The parameter 'professionId' cannot be null.");
        else if (professionId !== undefined)
            url_ += "professionId=" + encodeURIComponent("" + professionId) + "&";
        if (applicationType === null)
            throw new Error("The parameter 'applicationType' cannot be null.");
        else if (applicationType !== undefined)
            url_ += "applicationType=" + encodeURIComponent("" + applicationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByProfessionIdAndApplicationType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByProfessionIdAndApplicationType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SlapStatusWizardStepDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SlapStatusWizardStepDto[]>;
        }));
    }

    protected processGetAllByProfessionIdAndApplicationType(response: HttpResponseBase): Observable<SlapStatusWizardStepDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SlapStatusWizardStepDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateSlapStatusWizardStepInput | undefined): Observable<SlapStatusWizardStepDto> {
        let url_ = this.baseUrl + "/api/services/app/SlapStatusWizardStep/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SlapStatusWizardStepDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SlapStatusWizardStepDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<SlapStatusWizardStepDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SlapStatusWizardStepDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMany(body: UpdateSlapStatusWizardStepsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SlapStatusWizardStep/UpdateMany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateMany(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @param professionId (optional) 
     * @param applicationType (optional) 
     * @return Success
     */
    delete(step: number | undefined, professionId: string | undefined, applicationType: ApplicationType | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SlapStatusWizardStep/Delete?";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "step=" + encodeURIComponent("" + step) + "&";
        if (professionId === null)
            throw new Error("The parameter 'professionId' cannot be null.");
        else if (professionId !== undefined)
            url_ += "professionId=" + encodeURIComponent("" + professionId) + "&";
        if (applicationType === null)
            throw new Error("The parameter 'applicationType' cannot be null.");
        else if (applicationType !== undefined)
            url_ += "applicationType=" + encodeURIComponent("" + applicationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SlasDrugProductionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param rangeOfProductsId (optional) 
     * @return Success
     */
    createPlaceholderDrugProduction(caseId: string | undefined, rangeOfProductsId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SlasDrugProduction/CreatePlaceholderDrugProduction?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (rangeOfProductsId === null)
            throw new Error("The parameter 'rangeOfProductsId' cannot be null.");
        else if (rangeOfProductsId !== undefined)
            url_ += "rangeOfProductsId=" + encodeURIComponent("" + rangeOfProductsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderDrugProduction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderDrugProduction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderDrugProduction(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDrugProductionList(body: UpdateSlasDrugProductionInput | undefined): Observable<UpdateSlasDrugProductionOutput> {
        let url_ = this.baseUrl + "/api/services/app/SlasDrugProduction/UpdateDrugProductionList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDrugProductionList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDrugProductionList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateSlasDrugProductionOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateSlasDrugProductionOutput>;
        }));
    }

    protected processUpdateDrugProductionList(response: HttpResponseBase): Observable<UpdateSlasDrugProductionOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateSlasDrugProductionOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SlasDrugProductionThirdPartyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param drugProductionThirdPartyId (optional) 
     * @return Success
     */
    createPlaceholderDrugProductionThirdParty(caseId: string | undefined, drugProductionThirdPartyId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SlasDrugProductionThirdParty/CreatePlaceholderDrugProductionThirdParty?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (drugProductionThirdPartyId === null)
            throw new Error("The parameter 'drugProductionThirdPartyId' cannot be null.");
        else if (drugProductionThirdPartyId !== undefined)
            url_ += "drugProductionThirdPartyId=" + encodeURIComponent("" + drugProductionThirdPartyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderDrugProductionThirdParty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderDrugProductionThirdParty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderDrugProductionThirdParty(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDrugProductionThirdPartyList(body: UpdateSlasDrugProductionThirdPartyInput | undefined): Observable<UpdateSlasDrugProductionThirdPartyOutput> {
        let url_ = this.baseUrl + "/api/services/app/SlasDrugProductionThirdParty/UpdateDrugProductionThirdPartyList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDrugProductionThirdPartyList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDrugProductionThirdPartyList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateSlasDrugProductionThirdPartyOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateSlasDrugProductionThirdPartyOutput>;
        }));
    }

    protected processUpdateDrugProductionThirdPartyList(response: HttpResponseBase): Observable<UpdateSlasDrugProductionThirdPartyOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateSlasDrugProductionThirdPartyOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SlasLocalDrugSalesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param rangeOfProductsId (optional) 
     * @return Success
     */
    createPlaceholderLocalDrugSales(caseId: string | undefined, rangeOfProductsId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SlasLocalDrugSales/CreatePlaceholderLocalDrugSales?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (rangeOfProductsId === null)
            throw new Error("The parameter 'rangeOfProductsId' cannot be null.");
        else if (rangeOfProductsId !== undefined)
            url_ += "rangeOfProductsId=" + encodeURIComponent("" + rangeOfProductsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderLocalDrugSales(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderLocalDrugSales(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderLocalDrugSales(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateLocalDrugSalesList(body: UpdateSlasLocalDrugSalesInput | undefined): Observable<UpdateSlasLocalDrugSalesOutput> {
        let url_ = this.baseUrl + "/api/services/app/SlasLocalDrugSales/UpdateLocalDrugSalesList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLocalDrugSalesList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLocalDrugSalesList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateSlasLocalDrugSalesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateSlasLocalDrugSalesOutput>;
        }));
    }

    protected processUpdateLocalDrugSalesList(response: HttpResponseBase): Observable<UpdateSlasLocalDrugSalesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateSlasLocalDrugSalesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SlasProductPreparationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param rangeOfProductsId (optional) 
     * @return Success
     */
    createPlaceholderProductPreparation(caseId: string | undefined, rangeOfProductsId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SlasProductPreparation/CreatePlaceholderProductPreparation?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (rangeOfProductsId === null)
            throw new Error("The parameter 'rangeOfProductsId' cannot be null.");
        else if (rangeOfProductsId !== undefined)
            url_ += "rangeOfProductsId=" + encodeURIComponent("" + rangeOfProductsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderProductPreparation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderProductPreparation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderProductPreparation(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProductPreparationList(body: UpdateSlasProductPreparationInput | undefined): Observable<UpdateSlasProductPreparationOutput> {
        let url_ = this.baseUrl + "/api/services/app/SlasProductPreparation/UpdateProductPreparationList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProductPreparationList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProductPreparationList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateSlasProductPreparationOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateSlasProductPreparationOutput>;
        }));
    }

    protected processUpdateProductPreparationList(response: HttpResponseBase): Observable<UpdateSlasProductPreparationOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateSlasProductPreparationOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SlasRangeOfProductsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param rangeOfProductsId (optional) 
     * @return Success
     */
    createPlaceholderRangeOfProducts(caseId: string | undefined, rangeOfProductsId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SlasRangeOfProducts/CreatePlaceholderRangeOfProducts?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (rangeOfProductsId === null)
            throw new Error("The parameter 'rangeOfProductsId' cannot be null.");
        else if (rangeOfProductsId !== undefined)
            url_ += "rangeOfProductsId=" + encodeURIComponent("" + rangeOfProductsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePlaceholderRangeOfProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePlaceholderRangeOfProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePlaceholderRangeOfProducts(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateRangeOfProductsList(body: UpdateSlasRangeOfProductsInput | undefined): Observable<UpdateSlasRangeOfProductsOutput> {
        let url_ = this.baseUrl + "/api/services/app/SlasRangeOfProducts/UpdateRangeOfProductsList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRangeOfProductsList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRangeOfProductsList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateSlasRangeOfProductsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateSlasRangeOfProductsOutput>;
        }));
    }

    protected processUpdateRangeOfProductsList(response: HttpResponseBase): Observable<UpdateSlasRangeOfProductsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateSlasRangeOfProductsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SplServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createSpl(body: CreateSplInput | undefined): Observable<CreateSplOutput> {
        let url_ = this.baseUrl + "/api/services/app/Spl/CreateSpl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSpl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSpl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateSplOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateSplOutput>;
        }));
    }

    protected processCreateSpl(response: HttpResponseBase): Observable<CreateSplOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateSplOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMySpls(): Observable<SplDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Spl/GetMySpls";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMySpls(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMySpls(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SplDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SplDto[]>;
        }));
    }

    protected processGetMySpls(response: HttpResponseBase): Observable<SplDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SplDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getNextStatus(caseId: string, status: SplStatus): Observable<SplStatus> {
        let url_ = this.baseUrl + "/api/services/app/Spl/GetNextStatus?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined and cannot be null.");
        else
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SplStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SplStatus>;
        }));
    }

    protected processGetNextStatus(response: HttpResponseBase): Observable<SplStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param gln (optional) 
     * @return Success
     */
    getSplsForPerson(gln: string | undefined): Observable<SplDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Spl/GetSplsForPerson?";
        if (gln === null)
            throw new Error("The parameter 'gln' cannot be null.");
        else if (gln !== undefined)
            url_ += "gln=" + encodeURIComponent("" + gln) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSplsForPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSplsForPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SplDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SplDto[]>;
        }));
    }

    protected processGetSplsForPerson(response: HttpResponseBase): Observable<SplDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SplDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getProfessionalLicencePersonIdForSpl(caseId: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Spl/GetProfessionalLicencePersonIdForSpl?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfessionalLicencePersonIdForSpl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfessionalLicencePersonIdForSpl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetProfessionalLicencePersonIdForSpl(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getSpl(caseId: string | undefined): Observable<GetSplOutput> {
        let url_ = this.baseUrl + "/api/services/app/Spl/GetSpl?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSpl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSplOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSplOutput>;
        }));
    }

    protected processGetSpl(response: HttpResponseBase): Observable<GetSplOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSplOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param applicantComment (optional) 
     * @return Success
     */
    releaseSpl(caseId: string | undefined, applicantComment: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Spl/ReleaseSpl?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        if (applicantComment === null)
            throw new Error("The parameter 'applicantComment' cannot be null.");
        else if (applicantComment !== undefined)
            url_ += "applicantComment=" + encodeURIComponent("" + applicantComment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseSpl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseSpl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReleaseSpl(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    getEvaluationComments(caseId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Spl/GetEvaluationComments?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEvaluationComments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEvaluationComments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetEvaluationComments(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    validateThatAllMandatoryDocumentsHaveBeenUploaded(caseId: string | undefined): Observable<SplStatus[]> {
        let url_ = this.baseUrl + "/api/services/app/Spl/ValidateThatAllMandatoryDocumentsHaveBeenUploaded?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SplStatus[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SplStatus[]>;
        }));
    }

    protected processValidateThatAllMandatoryDocumentsHaveBeenUploaded(response: HttpResponseBase): Observable<SplStatus[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SplDocumentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getDocuments(body: GetSplDocumentsInput | undefined): Observable<SplDocumentsOutput> {
        let url_ = this.baseUrl + "/api/services/app/SplDocument/GetDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SplDocumentsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SplDocumentsOutput>;
        }));
    }

    protected processGetDocuments(response: HttpResponseBase): Observable<SplDocumentsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SplDocumentsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadFiles(body: ApplicationUploadFilesInput | undefined): Observable<GeneralFileInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SplDocument/UploadFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileInfoDto[]>;
        }));
    }

    protected processUploadFiles(response: HttpResponseBase): Observable<GeneralFileInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeneralFileInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getFile(body: GetSplFileInput | undefined): Observable<GeneralFileDto> {
        let url_ = this.baseUrl + "/api/services/app/SplDocument/GetFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralFileDto>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<GeneralFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneralFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param step (optional) 
     * @return Success
     */
    deleteFile(caseId: string, step: SplStatus | undefined, id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SplDocument/DeleteFile?";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "Step=" + encodeURIComponent("" + step) + "&";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SplNarcoticKnowledgeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: SplNarcoticKnowledgeDto | undefined): Observable<SplStatus> {
        let url_ = this.baseUrl + "/api/services/app/SplNarcoticKnowledge/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SplStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SplStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<SplStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<SplNarcoticKnowledgeDto> {
        let url_ = this.baseUrl + "/api/services/app/SplNarcoticKnowledge/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SplNarcoticKnowledgeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SplNarcoticKnowledgeDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SplNarcoticKnowledgeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SplNarcoticKnowledgeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SplPersonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: SplPersonDto | undefined): Observable<SplStatus> {
        let url_ = this.baseUrl + "/api/services/app/SplPerson/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SplStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SplStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<SplStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<SplPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/SplPerson/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SplPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SplPersonDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SplPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SplPersonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SplPostgraduateTitleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param caseId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(caseId: string | undefined, body: CreateOrUpdateSplPostgraduateTitlesInput | undefined): Observable<SplStatus> {
        let url_ = this.baseUrl + "/api/services/app/SplPostgraduateTitle/CreateOrUpdate?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SplStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SplStatus>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<SplStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param caseId (optional) 
     * @return Success
     */
    get(caseId: string | undefined): Observable<SplPostgraduateTitleDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SplPostgraduateTitle/Get?";
        if (caseId === null)
            throw new Error("The parameter 'caseId' cannot be null.");
        else if (caseId !== undefined)
            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SplPostgraduateTitleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SplPostgraduateTitleDto[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SplPostgraduateTitleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SplPostgraduateTitleDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SponsorshipServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param isArchived (optional) 
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getDossiers(isArchived: boolean | undefined, filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetSponsorshipDossierSearchOutput> {
        let url_ = this.baseUrl + "/api/services/app/Sponsorship/GetDossiers?";
        if (isArchived === null)
            throw new Error("The parameter 'isArchived' cannot be null.");
        else if (isArchived !== undefined)
            url_ += "IsArchived=" + encodeURIComponent("" + isArchived) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDossiers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDossiers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSponsorshipDossierSearchOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSponsorshipDossierSearchOutput>;
        }));
    }

    protected processGetDossiers(response: HttpResponseBase): Observable<GetSponsorshipDossierSearchOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSponsorshipDossierSearchOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    formSearch(body: SponsorshipFormSearchInput | undefined): Observable<SponsorshipFormSearchOutput> {
        let url_ = this.baseUrl + "/api/services/app/Sponsorship/FormSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFormSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFormSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SponsorshipFormSearchOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SponsorshipFormSearchOutput>;
        }));
    }

    protected processFormSearch(response: HttpResponseBase): Observable<SponsorshipFormSearchOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SponsorshipFormSearchOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sponsorshipId (optional) 
     * @return Success
     */
    getSponsorship(sponsorshipId: number | undefined): Observable<GetSponsorshipDto> {
        let url_ = this.baseUrl + "/api/services/app/Sponsorship/GetSponsorship?";
        if (sponsorshipId === null)
            throw new Error("The parameter 'sponsorshipId' cannot be null.");
        else if (sponsorshipId !== undefined)
            url_ += "sponsorshipId=" + encodeURIComponent("" + sponsorshipId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSponsorship(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSponsorship(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSponsorshipDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSponsorshipDto>;
        }));
    }

    protected processGetSponsorship(response: HttpResponseBase): Observable<GetSponsorshipDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSponsorshipDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param name (optional) 
     * @return Success
     */
    getSponsorshipsByName(name: string | undefined): Observable<GetSponsorshipDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Sponsorship/GetSponsorshipsByName?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSponsorshipsByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSponsorshipsByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSponsorshipDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSponsorshipDto[]>;
        }));
    }

    protected processGetSponsorshipsByName(response: HttpResponseBase): Observable<GetSponsorshipDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetSponsorshipDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sponsorshipId (optional) 
     * @return Success
     */
    getTotalAllowedBeds(sponsorshipId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Sponsorship/GetTotalAllowedBeds?";
        if (sponsorshipId === null)
            throw new Error("The parameter 'sponsorshipId' cannot be null.");
        else if (sponsorshipId !== undefined)
            url_ += "sponsorshipId=" + encodeURIComponent("" + sponsorshipId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalAllowedBeds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalAllowedBeds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetTotalAllowedBeds(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAll(): Observable<SponsorshipDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Sponsorship/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SponsorshipDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SponsorshipDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SponsorshipDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SponsorshipDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateOrUpdateSponsorshipDto | undefined): Observable<SponsorshipDto> {
        let url_ = this.baseUrl + "/api/services/app/Sponsorship/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SponsorshipDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SponsorshipDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<SponsorshipDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SponsorshipDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param uid (optional) 
     * @param email (optional) 
     * @param phone (optional) 
     * @return Success
     */
    createSponsorshipFromUidRegisterInfo(uid: string | undefined, email: string | undefined, phone: string | undefined): Observable<SponsorshipDto> {
        let url_ = this.baseUrl + "/api/services/app/Sponsorship/CreateSponsorshipFromUidRegisterInfo?";
        if (uid === null)
            throw new Error("The parameter 'uid' cannot be null.");
        else if (uid !== undefined)
            url_ += "uid=" + encodeURIComponent("" + uid) + "&";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (phone === null)
            throw new Error("The parameter 'phone' cannot be null.");
        else if (phone !== undefined)
            url_ += "phone=" + encodeURIComponent("" + phone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSponsorshipFromUidRegisterInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSponsorshipFromUidRegisterInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SponsorshipDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SponsorshipDto>;
        }));
    }

    protected processCreateSponsorshipFromUidRegisterInfo(response: HttpResponseBase): Observable<SponsorshipDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SponsorshipDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: CreateOrUpdateSponsorshipDto | undefined): Observable<GetSponsorshipDto> {
        let url_ = this.baseUrl + "/api/services/app/Sponsorship/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSponsorshipDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSponsorshipDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<GetSponsorshipDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSponsorshipDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param isArchived (optional) 
     * @return Success
     */
    setArchiveFlag(id: number | undefined, isArchived: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Sponsorship/SetArchiveFlag?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (isArchived === null)
            throw new Error("The parameter 'isArchived' cannot be null.");
        else if (isArchived !== undefined)
            url_ += "isArchived=" + encodeURIComponent("" + isArchived) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetArchiveFlag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetArchiveFlag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetArchiveFlag(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateNursingInstitution(body: CreateOrUpdateSponsorshipNursingInstitutionInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Sponsorship/CreateOrUpdateNursingInstitution";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateNursingInstitution(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateNursingInstitution(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateNursingInstitution(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sponsorshipId (optional) 
     * @return Success
     */
    getInvoiceAddress(sponsorshipId: number | undefined): Observable<SponsorshipInvoiceAddressDto> {
        let url_ = this.baseUrl + "/api/services/app/Sponsorship/GetInvoiceAddress?";
        if (sponsorshipId === null)
            throw new Error("The parameter 'sponsorshipId' cannot be null.");
        else if (sponsorshipId !== undefined)
            url_ += "sponsorshipId=" + encodeURIComponent("" + sponsorshipId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoiceAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoiceAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SponsorshipInvoiceAddressDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SponsorshipInvoiceAddressDto>;
        }));
    }

    protected processGetInvoiceAddress(response: HttpResponseBase): Observable<SponsorshipInvoiceAddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SponsorshipInvoiceAddressDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sponsorshipId (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateInvoiceAddress(sponsorshipId: number | undefined, body: SponsorshipInvoiceAddressDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Sponsorship/UpdateInvoiceAddress?";
        if (sponsorshipId === null)
            throw new Error("The parameter 'sponsorshipId' cannot be null.");
        else if (sponsorshipId !== undefined)
            url_ += "sponsorshipId=" + encodeURIComponent("" + sponsorshipId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateInvoiceAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInvoiceAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateInvoiceAddress(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SponsorshipApplicationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getSponsorshipApplications(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetSponsorshipApplicationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/SponsorshipApplication/GetSponsorshipApplications?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSponsorshipApplications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSponsorshipApplications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSponsorshipApplicationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSponsorshipApplicationsOutput>;
        }));
    }

    protected processGetSponsorshipApplications(response: HttpResponseBase): Observable<GetSponsorshipApplicationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSponsorshipApplicationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SponsorshipTypeRegisterAffiliationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getAllActiveAsString(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/SponsorshipTypeRegisterAffiliation/GetAllActiveAsString";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllActiveAsString(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllActiveAsString(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllActiveAsString(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sponsorshipTypeId (optional) 
     * @return Success
     */
    get(sponsorshipTypeId: string | undefined): Observable<SponsorshipTypeRegisterAffiliationDto> {
        let url_ = this.baseUrl + "/api/services/app/SponsorshipTypeRegisterAffiliation/Get?";
        if (sponsorshipTypeId === null)
            throw new Error("The parameter 'sponsorshipTypeId' cannot be null.");
        else if (sponsorshipTypeId !== undefined)
            url_ += "sponsorshipTypeId=" + encodeURIComponent("" + sponsorshipTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SponsorshipTypeRegisterAffiliationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SponsorshipTypeRegisterAffiliationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SponsorshipTypeRegisterAffiliationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SponsorshipTypeRegisterAffiliationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAll(): Observable<SponsorshipTypeRegisterAffiliationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SponsorshipTypeRegisterAffiliation/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SponsorshipTypeRegisterAffiliationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SponsorshipTypeRegisterAffiliationDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SponsorshipTypeRegisterAffiliationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SponsorshipTypeRegisterAffiliationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: SponsorshipTypeRegisterAffiliationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SponsorshipTypeRegisterAffiliation/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SqlQueryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getQueries(categoryId: string): Observable<GetSqlQueryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SqlQuery/GetQueries?";
        if (categoryId === undefined || categoryId === null)
            throw new Error("The parameter 'categoryId' must be defined and cannot be null.");
        else
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQueries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQueries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSqlQueryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSqlQueryDto[]>;
        }));
    }

    protected processGetQueries(response: HttpResponseBase): Observable<GetSqlQueryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetSqlQueryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    runQuery(id: number, body: { [key: string]: any; } | undefined): Observable<RunSqlQueryResultDto> {
        let url_ = this.baseUrl + "/api/services/app/SqlQuery/RunQuery?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RunSqlQueryResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RunSqlQueryResultDto>;
        }));
    }

    protected processRunQuery(response: HttpResponseBase): Observable<RunSqlQueryResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RunSqlQueryResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    runQueryAndExportToExcel(id: number, body: { [key: string]: any; } | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/SqlQuery/RunQueryAndExportToExcel?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunQueryAndExportToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunQueryAndExportToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processRunQueryAndExportToExcel(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SqlQueryAdministrationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    search(body: GetSqlQuerySearchInput | undefined): Observable<GetSqlQuerySearchOutput> {
        let url_ = this.baseUrl + "/api/services/app/SqlQueryAdministration/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSqlQuerySearchOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSqlQuerySearchOutput>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<GetSqlQuerySearchOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSqlQuerySearchOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<SqlQueryDto> {
        let url_ = this.baseUrl + "/api/services/app/SqlQueryAdministration/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SqlQueryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SqlQueryDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SqlQueryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SqlQueryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: SqlQueryDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SqlQueryAdministration/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    update(id: number | undefined, body: SqlQueryDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SqlQueryAdministration/Update?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SqlQueryAdministration/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    analyseQuery(body: string | undefined): Observable<SqlQueryAnalyseResultDto> {
        let url_ = this.baseUrl + "/api/services/app/SqlQueryAdministration/AnalyseQuery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAnalyseQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAnalyseQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SqlQueryAnalyseResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SqlQueryAnalyseResultDto>;
        }));
    }

    protected processAnalyseQuery(response: HttpResponseBase): Observable<SqlQueryAnalyseResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SqlQueryAnalyseResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param filter (optional) 
     * @param subscriptionEndDateStart (optional) 
     * @param subscriptionEndDateEnd (optional) 
     * @param creationDateStart (optional) 
     * @param creationDateEnd (optional) 
     * @param editionId (optional) 
     * @param editionIdSpecified (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getTenants(filter: string | undefined, subscriptionEndDateStart: DateTime | undefined, subscriptionEndDateEnd: DateTime | undefined, creationDateStart: DateTime | undefined, creationDateEnd: DateTime | undefined, editionId: number | undefined, editionIdSpecified: boolean | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfTenantListDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenants?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (subscriptionEndDateStart === null)
            throw new Error("The parameter 'subscriptionEndDateStart' cannot be null.");
        else if (subscriptionEndDateStart !== undefined)
            url_ += "SubscriptionEndDateStart=" + encodeURIComponent(subscriptionEndDateStart ? "" + subscriptionEndDateStart.toString() : "") + "&";
        if (subscriptionEndDateEnd === null)
            throw new Error("The parameter 'subscriptionEndDateEnd' cannot be null.");
        else if (subscriptionEndDateEnd !== undefined)
            url_ += "SubscriptionEndDateEnd=" + encodeURIComponent(subscriptionEndDateEnd ? "" + subscriptionEndDateEnd.toString() : "") + "&";
        if (creationDateStart === null)
            throw new Error("The parameter 'creationDateStart' cannot be null.");
        else if (creationDateStart !== undefined)
            url_ += "CreationDateStart=" + encodeURIComponent(creationDateStart ? "" + creationDateStart.toString() : "") + "&";
        if (creationDateEnd === null)
            throw new Error("The parameter 'creationDateEnd' cannot be null.");
        else if (creationDateEnd !== undefined)
            url_ += "CreationDateEnd=" + encodeURIComponent(creationDateEnd ? "" + creationDateEnd.toString() : "") + "&";
        if (editionId === null)
            throw new Error("The parameter 'editionId' cannot be null.");
        else if (editionId !== undefined)
            url_ += "EditionId=" + encodeURIComponent("" + editionId) + "&";
        if (editionIdSpecified === null)
            throw new Error("The parameter 'editionIdSpecified' cannot be null.");
        else if (editionIdSpecified !== undefined)
            url_ += "EditionIdSpecified=" + encodeURIComponent("" + editionIdSpecified) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTenantListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTenantListDto>;
        }));
    }

    protected processGetTenants(response: HttpResponseBase): Observable<PagedResultDtoOfTenantListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTenantListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTenant(body: CreateTenantInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/CreateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTenantForEdit(id: number | undefined): Observable<TenantEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantEditDto>;
        }));
    }

    protected processGetTenantForEdit(response: HttpResponseBase): Observable<TenantEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTenant(body: TenantEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteTenant(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/DeleteTenant?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTenantFeaturesForEdit(id: number | undefined): Observable<GetTenantFeaturesEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantFeaturesForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantFeaturesForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantFeaturesForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTenantFeaturesEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTenantFeaturesEditOutput>;
        }));
    }

    protected processGetTenantFeaturesForEdit(response: HttpResponseBase): Observable<GetTenantFeaturesEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTenantFeaturesEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTenantFeatures(body: UpdateTenantFeaturesInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenantFeatures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTenantFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTenantFeatures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTenantFeatures(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetTenantSpecificFeatures(body: EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/ResetTenantSpecificFeatures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetTenantSpecificFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetTenantSpecificFeatures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResetTenantSpecificFeatures(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unlockTenantAdmin(body: EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UnlockTenantAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlockTenantAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockTenantAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlockTenantAdmin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantCustomizationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param tenantId (optional) 
     * @param extension (optional) 
     * @return Success
     */
    getTenantLogo(skin: string, tenantId: number | undefined, extension: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/TenantCustomization/GetTenantLogo/{skin}/{tenantId}/{extension}?";
        if (skin === undefined || skin === null)
            throw new Error("The parameter 'skin' must be defined.");
        url_ = url_.replace("{skin}", encodeURIComponent("" + skin));
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (extension === null)
            throw new Error("The parameter 'extension' cannot be null.");
        else if (extension !== undefined)
            url_ += "extension=" + encodeURIComponent("" + extension) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetTenantLogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantIdCookieServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    setTenantIdCookie(tenantId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TenantIdCookie/SetTenantIdCookie?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetTenantIdCookie(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetTenantIdCookie(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetTenantIdCookie(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantRegistrationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    registerTenant(body: RegisterTenantInput | undefined): Observable<RegisterTenantOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/RegisterTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterTenantOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterTenantOutput>;
        }));
    }

    protected processRegisterTenant(response: HttpResponseBase): Observable<RegisterTenantOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterTenantOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEditionsForSelect(): Observable<EditionsSelectOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetEditionsForSelect";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionsForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionsForSelect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditionsSelectOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditionsSelectOutput>;
        }));
    }

    protected processGetEditionsForSelect(response: HttpResponseBase): Observable<EditionsSelectOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditionsSelectOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param editionId (optional) 
     * @return Success
     */
    getEdition(editionId: number | undefined): Observable<EditionSelectDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetEdition?";
        if (editionId === null)
            throw new Error("The parameter 'editionId' cannot be null.");
        else if (editionId !== undefined)
            url_ += "editionId=" + encodeURIComponent("" + editionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditionSelectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditionSelectDto>;
        }));
    }

    protected processGetEdition(response: HttpResponseBase): Observable<EditionSelectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditionSelectDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getAllSettings(): Observable<TenantSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantSettingsEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantSettingsEditDto>;
        }));
    }

    protected processGetAllSettings(response: HttpResponseBase): Observable<TenantSettingsEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantSettingsEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAllSettings(body: TenantSettingsEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAllSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    clearLogo(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearLogo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearLogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    clearEmailLogo(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearEmailLogo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearEmailLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearEmailLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearEmailLogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    clearCustomCss(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearCustomCss";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearCustomCss(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearCustomCss(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearCustomCss(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendTestEmail(body: SendTestEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendTestEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEnabledSocialLoginSettings(): Observable<ExternalLoginSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetEnabledSocialLoginSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEnabledSocialLoginSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEnabledSocialLoginSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalLoginSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalLoginSettingsDto>;
        }));
    }

    protected processGetEnabledSocialLoginSettings(response: HttpResponseBase): Observable<ExternalLoginSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalLoginSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TimingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param defaultTimezoneScope (optional) 
     * @return Success
     */
    getTimezones(defaultTimezoneScope: SettingScopes | undefined): Observable<ListResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/Timing/GetTimezones?";
        if (defaultTimezoneScope === null)
            throw new Error("The parameter 'defaultTimezoneScope' cannot be null.");
        else if (defaultTimezoneScope !== undefined)
            url_ += "DefaultTimezoneScope=" + encodeURIComponent("" + defaultTimezoneScope) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimezones(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimezones(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfNameValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfNameValueDto>;
        }));
    }

    protected processGetTimezones(response: HttpResponseBase): Observable<ListResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param selectedTimezoneId (optional) 
     * @return Success
     */
    getTimezoneComboboxItems(selectedTimezoneId: string | undefined): Observable<ComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Timing/GetTimezoneComboboxItems?";
        if (selectedTimezoneId === null)
            throw new Error("The parameter 'selectedTimezoneId' cannot be null.");
        else if (selectedTimezoneId !== undefined)
            url_ += "SelectedTimezoneId=" + encodeURIComponent("" + selectedTimezoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimezoneComboboxItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimezoneComboboxItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDto[]>;
        }));
    }

    protected processGetTimezoneComboboxItems(response: HttpResponseBase): Observable<ComboboxItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param returnUrl (optional) 
     * @return Success
     */
    windowsAuthenticate(returnUrl: string | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/WindowsAuthenticate?";
        if (returnUrl === null)
            throw new Error("The parameter 'returnUrl' cannot be null.");
        else if (returnUrl !== undefined)
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWindowsAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWindowsAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
        }));
    }

    protected processWindowsAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticate(body: AuthenticateModel | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param refreshToken (optional) 
     * @return Success
     */
    refreshToken(refreshToken: string | undefined): Observable<RefreshTokenResult> {
        let url_ = this.baseUrl + "/api/TokenAuth/RefreshToken?";
        if (refreshToken === null)
            throw new Error("The parameter 'refreshToken' cannot be null.");
        else if (refreshToken !== undefined)
            url_ += "refreshToken=" + encodeURIComponent("" + refreshToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RefreshTokenResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RefreshTokenResult>;
        }));
    }

    protected processRefreshToken(response: HttpResponseBase): Observable<RefreshTokenResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RefreshTokenResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    logOut(): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/LogOut";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogOut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLogOut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendTwoFactorAuthCode(body: SendTwoFactorAuthCodeModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/SendTwoFactorAuthCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTwoFactorAuthCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTwoFactorAuthCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendTwoFactorAuthCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param impersonationToken (optional) 
     * @return Success
     */
    impersonatedAuthenticate(impersonationToken: string | undefined): Observable<RefreshTokenResult> {
        let url_ = this.baseUrl + "/api/TokenAuth/ImpersonatedAuthenticate?";
        if (impersonationToken === null)
            throw new Error("The parameter 'impersonationToken' cannot be null.");
        else if (impersonationToken !== undefined)
            url_ += "impersonationToken=" + encodeURIComponent("" + impersonationToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImpersonatedAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImpersonatedAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RefreshTokenResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RefreshTokenResult>;
        }));
    }

    protected processImpersonatedAuthenticate(response: HttpResponseBase): Observable<RefreshTokenResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RefreshTokenResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userDelegationId (optional) 
     * @param impersonationToken (optional) 
     * @return Success
     */
    delegatedImpersonatedAuthenticate(userDelegationId: number | undefined, impersonationToken: string | undefined): Observable<RefreshTokenResult> {
        let url_ = this.baseUrl + "/api/TokenAuth/DelegatedImpersonatedAuthenticate?";
        if (userDelegationId === null)
            throw new Error("The parameter 'userDelegationId' cannot be null.");
        else if (userDelegationId !== undefined)
            url_ += "userDelegationId=" + encodeURIComponent("" + userDelegationId) + "&";
        if (impersonationToken === null)
            throw new Error("The parameter 'impersonationToken' cannot be null.");
        else if (impersonationToken !== undefined)
            url_ += "impersonationToken=" + encodeURIComponent("" + impersonationToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelegatedImpersonatedAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelegatedImpersonatedAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RefreshTokenResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RefreshTokenResult>;
        }));
    }

    protected processDelegatedImpersonatedAuthenticate(response: HttpResponseBase): Observable<RefreshTokenResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RefreshTokenResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param switchAccountToken (optional) 
     * @return Success
     */
    linkedAccountAuthenticate(switchAccountToken: string | undefined): Observable<RefreshTokenResult> {
        let url_ = this.baseUrl + "/api/TokenAuth/LinkedAccountAuthenticate?";
        if (switchAccountToken === null)
            throw new Error("The parameter 'switchAccountToken' cannot be null.");
        else if (switchAccountToken !== undefined)
            url_ += "switchAccountToken=" + encodeURIComponent("" + switchAccountToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkedAccountAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkedAccountAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RefreshTokenResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RefreshTokenResult>;
        }));
    }

    protected processLinkedAccountAuthenticate(response: HttpResponseBase): Observable<RefreshTokenResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RefreshTokenResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalAuthenticationProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalAuthenticationProviders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalLoginProviderInfoModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalLoginProviderInfoModel[]>;
        }));
    }

    protected processGetExternalAuthenticationProviders(response: HttpResponseBase): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExternalLoginProviderInfoModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    isRefreshTokenAvailable(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/TokenAuth/IsRefreshTokenAvailable";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsRefreshTokenAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsRefreshTokenAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsRefreshTokenAvailable(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    externalAuthenticate(body: ExternalAuthenticateModel | undefined): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalAuthenticateResultModel>;
        }));
    }

    protected processExternalAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TraineePersonLicenceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param licenceId (optional) 
     * @return Success
     */
    getTraineeLicence(licenceId: number | undefined): Observable<TraineePersonLicenceDto> {
        let url_ = this.baseUrl + "/api/services/app/TraineePersonLicence/GetTraineeLicence?";
        if (licenceId === null)
            throw new Error("The parameter 'licenceId' cannot be null.");
        else if (licenceId !== undefined)
            url_ += "licenceId=" + encodeURIComponent("" + licenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTraineeLicence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTraineeLicence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TraineePersonLicenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TraineePersonLicenceDto>;
        }));
    }

    protected processGetTraineeLicence(response: HttpResponseBase): Observable<TraineePersonLicenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TraineePersonLicenceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param licenceId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(licenceId: number | undefined, body: TraineePersonLicenceDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TraineePersonLicence/CreateOrUpdate?";
        if (licenceId === null)
            throw new Error("The parameter 'licenceId' cannot be null.");
        else if (licenceId !== undefined)
            url_ += "licenceId=" + encodeURIComponent("" + licenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TwitterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getRequestToken(): Observable<TwitterGetRequestTokenResponse> {
        let url_ = this.baseUrl + "/api/Twitter/GetRequestToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequestToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TwitterGetRequestTokenResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TwitterGetRequestTokenResponse>;
        }));
    }

    protected processGetRequestToken(response: HttpResponseBase): Observable<TwitterGetRequestTokenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TwitterGetRequestTokenResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param token (optional) 
     * @param verifier (optional) 
     * @return Success
     */
    getAccessToken(token: string | undefined, verifier: string | undefined): Observable<TwitterGetAccessTokenResponse> {
        let url_ = this.baseUrl + "/api/Twitter/GetAccessToken?";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        if (verifier === null)
            throw new Error("The parameter 'verifier' cannot be null.");
        else if (verifier !== undefined)
            url_ += "verifier=" + encodeURIComponent("" + verifier) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccessToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccessToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TwitterGetAccessTokenResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TwitterGetAccessTokenResponse>;
        }));
    }

    protected processGetAccessToken(response: HttpResponseBase): Observable<TwitterGetAccessTokenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TwitterGetAccessTokenResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UiCustomizationSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getUiManagementSettings(): Observable<ThemeSettingsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/GetUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUiManagementSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUiManagementSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ThemeSettingsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ThemeSettingsDto[]>;
        }));
    }

    protected processGetUiManagementSettings(response: HttpResponseBase): Observable<ThemeSettingsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ThemeSettingsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param themeName (optional) 
     * @return Success
     */
    changeThemeWithDefaultValues(themeName: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/ChangeThemeWithDefaultValues?";
        if (themeName === null)
            throw new Error("The parameter 'themeName' cannot be null.");
        else if (themeName !== undefined)
            url_ += "themeName=" + encodeURIComponent("" + themeName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeThemeWithDefaultValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeThemeWithDefaultValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeThemeWithDefaultValues(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUiManagementSettings(body: ThemeSettingsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UpdateUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUiManagementSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUiManagementSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUiManagementSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDefaultUiManagementSettings(body: ThemeSettingsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UpdateDefaultUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDefaultUiManagementSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDefaultUiManagementSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDefaultUiManagementSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    useSystemDefaultSettings(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UseSystemDefaultSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUseSystemDefaultSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUseSystemDefaultSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUseSystemDefaultSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param isDarkModeActive (optional) 
     * @return Success
     */
    changeDarkModeOfCurrentTheme(isDarkModeActive: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/ChangeDarkModeOfCurrentTheme?";
        if (isDarkModeActive === null)
            throw new Error("The parameter 'isDarkModeActive' cannot be null.");
        else if (isDarkModeActive !== undefined)
            url_ += "isDarkModeActive=" + encodeURIComponent("" + isDarkModeActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeDarkModeOfCurrentTheme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeDarkModeOfCurrentTheme(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeDarkModeOfCurrentTheme(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UidRegisterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param uid (optional) 
     * @return Success
     */
    getUidEntityByUidNumberOrNull(uid: string | undefined): Observable<UidEntityDto> {
        let url_ = this.baseUrl + "/api/services/app/UidRegister/GetUidEntityByUidNumberOrNull?";
        if (uid === null)
            throw new Error("The parameter 'uid' cannot be null.");
        else if (uid !== undefined)
            url_ += "uid=" + encodeURIComponent("" + uid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUidEntityByUidNumberOrNull(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUidEntityByUidNumberOrNull(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UidEntityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UidEntityDto>;
        }));
    }

    protected processGetUidEntityByUidNumberOrNull(response: HttpResponseBase): Observable<UidEntityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UidEntityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getUsers(body: GetUsersInput | undefined): Observable<PagedResultDtoOfUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserListDto>;
        }));
    }

    protected processGetUsers(response: HttpResponseBase): Observable<PagedResultDtoOfUserListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAuthorityApplicationLiaUsers(): Observable<GetUserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAuthorityApplicationLiaUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuthorityApplicationLiaUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuthorityApplicationLiaUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserDto[]>;
        }));
    }

    protected processGetAuthorityApplicationLiaUsers(response: HttpResponseBase): Observable<GetUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetUserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getUserList(): Observable<GetUserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserDto[]>;
        }));
    }

    protected processGetUserList(response: HttpResponseBase): Observable<GetUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetUserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param permissions (optional) 
     * @param role (optional) 
     * @param onlyLockedUsers (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getUsersToExcel(filter: string | undefined, permissions: string[] | undefined, role: number | undefined, onlyLockedUsers: boolean | undefined, sorting: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsersToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (permissions === null)
            throw new Error("The parameter 'permissions' cannot be null.");
        else if (permissions !== undefined)
            permissions && permissions.forEach(item => { url_ += "Permissions=" + encodeURIComponent("" + item) + "&"; });
        if (role === null)
            throw new Error("The parameter 'role' cannot be null.");
        else if (role !== undefined)
            url_ += "Role=" + encodeURIComponent("" + role) + "&";
        if (onlyLockedUsers === null)
            throw new Error("The parameter 'onlyLockedUsers' cannot be null.");
        else if (onlyLockedUsers !== undefined)
            url_ += "OnlyLockedUsers=" + encodeURIComponent("" + onlyLockedUsers) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetUsersToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUserForShow(id: number | undefined): Observable<GetUserForShowOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserForShow?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserForShow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserForShow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserForShowOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserForShowOutput>;
        }));
    }

    protected processGetUserForShow(response: HttpResponseBase): Observable<GetUserForShowOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserForShowOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUserForEdit(id: number | undefined): Observable<GetUserForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserForEditOutput>;
        }));
    }

    protected processGetUserForEdit(response: HttpResponseBase): Observable<GetUserForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUserPermissionsForEdit(id: number | undefined): Observable<GetUserPermissionsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserPermissionsForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserPermissionsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPermissionsForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserPermissionsForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserPermissionsForEditOutput>;
        }));
    }

    protected processGetUserPermissionsForEdit(response: HttpResponseBase): Observable<GetUserPermissionsForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserPermissionsForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetUserSpecificPermissions(body: EntityDtoOfInt64 | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetUserSpecificPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetUserSpecificPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetUserSpecificPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResetUserSpecificPermissions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUserPermissions(body: UpdateUserPermissionsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateUserPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUserPermissions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateUser(body: CreateOrUpdateUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateOrUpdateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteUser(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/DeleteUser?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unlockUser(body: EntityDtoOfInt64 | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UnlockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlockUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlockUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserDelegationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getDelegatedUsers(maxResultCount: number | undefined, skipCount: number | undefined, sorting: string | undefined): Observable<PagedResultDtoOfUserDelegationDto> {
        let url_ = this.baseUrl + "/api/services/app/UserDelegation/GetDelegatedUsers?";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDelegatedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDelegatedUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserDelegationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserDelegationDto>;
        }));
    }

    protected processGetDelegatedUsers(response: HttpResponseBase): Observable<PagedResultDtoOfUserDelegationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserDelegationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    delegateNewUser(body: CreateUserDelegationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserDelegation/DelegateNewUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelegateNewUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelegateNewUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelegateNewUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    removeDelegation(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserDelegation/RemoveDelegation?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveDelegation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveDelegation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveDelegation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getActiveUserDelegations(): Observable<UserDelegationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UserDelegation/GetActiveUserDelegations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveUserDelegations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveUserDelegations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDelegationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDelegationDto[]>;
        }));
    }

    protected processGetActiveUserDelegations(response: HttpResponseBase): Observable<UserDelegationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDelegationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserLinkServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    linkToUser(body: LinkToUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/LinkToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkToUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLinkToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getLinkedUsers(maxResultCount: number | undefined, skipCount: number | undefined, sorting: string | undefined): Observable<PagedResultDtoOfLinkedUserDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/GetLinkedUsers?";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLinkedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLinkedUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLinkedUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLinkedUserDto>;
        }));
    }

    protected processGetLinkedUsers(response: HttpResponseBase): Observable<PagedResultDtoOfLinkedUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLinkedUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getRecentlyUsedLinkedUsers(): Observable<ListResultDtoOfLinkedUserDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/GetRecentlyUsedLinkedUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentlyUsedLinkedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentlyUsedLinkedUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfLinkedUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfLinkedUserDto>;
        }));
    }

    protected processGetRecentlyUsedLinkedUsers(response: HttpResponseBase): Observable<ListResultDtoOfLinkedUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfLinkedUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unlinkUser(body: UnlinkUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/UnlinkUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlinkUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlinkUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlinkUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserLoginServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param filter (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param result (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) The field MaxResultCount must be between 1 and 1000.
     * @param skipCount (optional) The field SkipCount must be between 0 and 2147483647.
     * @return Success
     */
    getUserLoginAttempts(filter: string | undefined, startDate: DateTime | undefined, endDate: DateTime | undefined, result: AbpLoginResultType | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfUserLoginAttemptDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLogin/GetUserLoginAttempts?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (result === null)
            throw new Error("The parameter 'result' cannot be null.");
        else if (result !== undefined)
            url_ += "Result=" + encodeURIComponent("" + result) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserLoginAttempts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserLoginAttempts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserLoginAttemptDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserLoginAttemptDto>;
        }));
    }

    protected processGetUserLoginAttempts(response: HttpResponseBase): Observable<PagedResultDtoOfUserLoginAttemptDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserLoginAttemptDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class VisibilityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @return Success
     */
    getVisibility(applicationType: ApplicationType, caseId: string): Observable<GetVisibilityOutput> {
        let url_ = this.baseUrl + "/api/services/app/Visibility/GetVisibility?";
        if (applicationType === undefined || applicationType === null)
            throw new Error("The parameter 'applicationType' must be defined and cannot be null.");
        else
            url_ += "ApplicationType=" + encodeURIComponent("" + applicationType) + "&";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined and cannot be null.");
        else
            url_ += "CaseId=" + encodeURIComponent("" + caseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVisibility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVisibility(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetVisibilityOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetVisibilityOutput>;
        }));
    }

    protected processGetVisibility(response: HttpResponseBase): Observable<GetVisibilityOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetVisibilityOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WebLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44301";
    }

    /**
     * @param key (optional) 
     * @return Success
     */
    getLatestWebLogs(key: string | undefined): Observable<GetLatestWebLogsOutput> {
        let url_ = this.baseUrl + "/api/services/app/WebLog/GetLatestWebLogs?";
        if (key === null)
            throw new Error("The parameter 'key' cannot be null.");
        else if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestWebLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestWebLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLatestWebLogsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLatestWebLogsOutput>;
        }));
    }

    protected processGetLatestWebLogs(response: HttpResponseBase): Observable<GetLatestWebLogsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLatestWebLogsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    downloadWebLogs(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/WebLog/DownloadWebLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadWebLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadWebLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processDownloadWebLogs(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class ComboboxItemDto implements IComboboxItemDto {
    value!: string | undefined;
    displayText!: string | undefined;
    isSelected!: boolean;

    constructor(data?: IComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): ComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface IComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean;
}

export class EntityDto implements IEntityDto {
    id!: number;

    constructor(data?: IEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityDto {
    id: number;
}

export class NameValueDto implements INameValueDto {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: INameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): NameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface INameValueDto {
    name: string | undefined;
    value: string | undefined;
}

export class TwitterGetAccessTokenResponse implements ITwitterGetAccessTokenResponse {
    accessToken!: string | undefined;
    accessTokenSecret!: string | undefined;
    userId!: string | undefined;
    userName!: string | undefined;

    constructor(data?: ITwitterGetAccessTokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.accessTokenSecret = _data["accessTokenSecret"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): TwitterGetAccessTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TwitterGetAccessTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["accessTokenSecret"] = this.accessTokenSecret;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        return data;
    }
}

export interface ITwitterGetAccessTokenResponse {
    accessToken: string | undefined;
    accessTokenSecret: string | undefined;
    userId: string | undefined;
    userName: string | undefined;
}

export class TwitterGetRequestTokenResponse implements ITwitterGetRequestTokenResponse {
    token!: string | undefined;
    secret!: string | undefined;
    confirmed!: boolean;
    redirectUrl!: string | undefined;

    constructor(data?: ITwitterGetRequestTokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.secret = _data["secret"];
            this.confirmed = _data["confirmed"];
            this.redirectUrl = _data["redirectUrl"];
        }
    }

    static fromJS(data: any): TwitterGetRequestTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TwitterGetRequestTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["secret"] = this.secret;
        data["confirmed"] = this.confirmed;
        data["redirectUrl"] = this.redirectUrl;
        return data;
    }
}

export interface ITwitterGetRequestTokenResponse {
    token: string | undefined;
    secret: string | undefined;
    confirmed: boolean;
    redirectUrl: string | undefined;
}

export enum AbpLoginResultType {
    Success = 1,
    InvalidUserNameOrEmailAddress = 2,
    InvalidPassword = 3,
    UserIsNotActive = 4,
    InvalidTenancyName = 5,
    TenantIsNotActive = 6,
    UserEmailIsNotConfirmed = 7,
    UnknownExternalLogin = 8,
    LockedOut = 9,
    UserPhoneNumberIsNotConfirmed = 10,
    FailedForOtherReason = 11,
}

export enum SettingScopes {
    Application = 1,
    Tenant = 2,
    User = 4,
    All = 7,
}

export enum EntityChangeType {
    Created = 0,
    Updated = 1,
    Deleted = 2,
}

export class NameValue implements INameValue {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: INameValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): NameValue {
        data = typeof data === 'object' ? data : {};
        let result = new NameValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface INameValue {
    name: string | undefined;
    value: string | undefined;
}

export class NotificationData implements INotificationData {
    readonly type!: string | undefined;
    properties!: { [key: string]: any; } | undefined;

    constructor(data?: INotificationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).type = _data["type"];
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key];
                }
            }
        }
    }

    static fromJS(data: any): NotificationData {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = (<any>this.properties)[key];
            }
        }
        return data;
    }
}

export interface INotificationData {
    type: string | undefined;
    properties: { [key: string]: any; } | undefined;
}

export enum NotificationSeverity {
    Info = 0,
    Success = 1,
    Warn = 2,
    Error = 3,
    Fatal = 4,
}

export class TenantNotification implements ITenantNotification {
    tenantId!: number | undefined;
    notificationName!: string | undefined;
    data!: NotificationData;
    entityType!: string | undefined;
    entityTypeName!: string | undefined;
    entityId!: any | undefined;
    severity!: NotificationSeverity;
    creationTime!: DateTime;
    id!: string;

    constructor(data?: ITenantNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.notificationName = _data["notificationName"];
            this.data = _data["data"] ? NotificationData.fromJS(_data["data"]) : <any>undefined;
            this.entityType = _data["entityType"];
            this.entityTypeName = _data["entityTypeName"];
            this.entityId = _data["entityId"];
            this.severity = _data["severity"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantNotification {
        data = typeof data === 'object' ? data : {};
        let result = new TenantNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["notificationName"] = this.notificationName;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["entityType"] = this.entityType;
        data["entityTypeName"] = this.entityTypeName;
        data["entityId"] = this.entityId;
        data["severity"] = this.severity;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantNotification {
    tenantId: number | undefined;
    notificationName: string | undefined;
    data: NotificationData;
    entityType: string | undefined;
    entityTypeName: string | undefined;
    entityId: any | undefined;
    severity: NotificationSeverity;
    creationTime: DateTime;
    id: string;
}

export class UserNotification implements IUserNotification {
    tenantId!: number | undefined;
    userId!: number;
    state!: UserNotificationState;
    notification!: TenantNotification;
    targetNotifiers!: string | undefined;
    readonly targetNotifiersList!: string[] | undefined;
    id!: string;

    constructor(data?: IUserNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.state = _data["state"];
            this.notification = _data["notification"] ? TenantNotification.fromJS(_data["notification"]) : <any>undefined;
            this.targetNotifiers = _data["targetNotifiers"];
            if (Array.isArray(_data["targetNotifiersList"])) {
                (<any>this).targetNotifiersList = [] as any;
                for (let item of _data["targetNotifiersList"])
                    (<any>this).targetNotifiersList!.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserNotification {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["state"] = this.state;
        data["notification"] = this.notification ? this.notification.toJSON() : <any>undefined;
        data["targetNotifiers"] = this.targetNotifiers;
        if (Array.isArray(this.targetNotifiersList)) {
            data["targetNotifiersList"] = [];
            for (let item of this.targetNotifiersList)
                data["targetNotifiersList"].push(item);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IUserNotification {
    tenantId: number | undefined;
    userId: number;
    state: UserNotificationState;
    notification: TenantNotification;
    targetNotifiers: string | undefined;
    targetNotifiersList: string[] | undefined;
    id: string;
}

export enum UserNotificationState {
    Unread = 0,
    Read = 1,
}

export class IValueValidator implements IIValueValidator {
    readonly name!: string | undefined;
    readonly attributes!: { [key: string]: any; } | undefined;

    constructor(data?: IIValueValidator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            if (_data["attributes"]) {
                (<any>this).attributes = {} as any;
                for (let key in _data["attributes"]) {
                    if (_data["attributes"].hasOwnProperty(key))
                        (<any>(<any>this).attributes)![key] = _data["attributes"][key];
                }
            }
        }
    }

    static fromJS(data: any): IValueValidator {
        data = typeof data === 'object' ? data : {};
        let result = new IValueValidator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    (<any>data["attributes"])[key] = (<any>this.attributes)[key];
            }
        }
        return data;
    }
}

export interface IIValueValidator {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
}

export class IInputType implements IIInputType {
    readonly name!: string | undefined;
    readonly attributes!: { [key: string]: any; } | undefined;
    validator!: IValueValidator;

    constructor(data?: IIInputType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            if (_data["attributes"]) {
                (<any>this).attributes = {} as any;
                for (let key in _data["attributes"]) {
                    if (_data["attributes"].hasOwnProperty(key))
                        (<any>(<any>this).attributes)![key] = _data["attributes"][key];
                }
            }
            this.validator = _data["validator"] ? IValueValidator.fromJS(_data["validator"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IInputType {
        data = typeof data === 'object' ? data : {};
        let result = new IInputType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    (<any>data["attributes"])[key] = (<any>this.attributes)[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIInputType {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
    validator: IValueValidator;
}

export enum ApplicationType {
    Lia = 0,
    LiaRen = 1,
    Ehc = 2,
    Lia90Days = 3,
    Ehc90Days = 4,
    Rla = 5,
    Alap = 6,
    Tla = 7,
    Slap = 8,
    SlapRen = 9,
    Cla = 11,
    ClaRen = 12,
    Ola = 13,
    OlaRen = 14,
    Slas = 15,
    SlasRen = 16,
    ClaEhc = 17,
    Alas = 18,
    Nla = 19,
    Abo = 20,
    Sub = 21,
    Mut = 22,
    EhcRen = 23,
    NlaRen = 32,
    Pdf = 45,
}

export enum DmsTemplateSelectableEntityType {
    PersonAddress = 0,
    PersonAcademicTitle = 1,
    PersonDiploma = 2,
    PersonPostgraduateTitle = 3,
    PersonLicence = 4,
    PersonLicenceRenewal = 5,
    PersonLicenceMutation = 6,
    PersonLicenceRestriction = 7,
    PersonLicenceAdditionalInformation = 8,
    PersonSensitiveDataRecord = 9,
    PersonCriminalPenaltyRecord = 10,
    PersonEmployment = 11,
    SponsorshipEmploymentSponsorshipResponsible = 100,
    SponsorshipEmploymentMedicalFieldResponsible = 101,
    SponsorshipEmploymentNursingDirector = 102,
    SponsorshipEmploymentMedicalDirector = 103,
    SponsorshipCorporateLicence = 104,
    SponsorshipCorporateLicenceRestriction = 105,
    SponsorshipCorporateLicenceRenewal = 106,
    SponsorshipCorporateLicenceMutation = 107,
    SponsorshipCorporateLicenceBusiness = 108,
    SponsorshipCorporateLicenceBusinessResponsible = 109,
    SponsorshipAdditionalInformation = 110,
    SponsorshipSensitiveDataRecord = 111,
    SponsorshipCriminalPenaltyRecord = 112,
    SponsorshipEmploymentsOther = 113,
    SponsorshipRangeOfServices = 114,
    SponsorshipBusinessesOther = 115,
    SponsorshipNursingInstitution = 116,
    AuthorityUser = 200,
    QrCodePerson = 300,
    QrCodeBusiness = 301,
    QrCodeSponsorship = 302,
}

export class EntityDtoOfGuid implements IEntityDtoOfGuid {
    id!: string;

    constructor(data?: IEntityDtoOfGuid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfGuid {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDtoOfGuid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityDtoOfGuid {
    id: string;
}

export class EntityDtoOfInt64 implements IEntityDtoOfInt64 {
    id!: number;

    constructor(data?: IEntityDtoOfInt64) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfInt64 {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDtoOfInt64();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityDtoOfInt64 {
    id: number;
}

export class EntityDtoOfString implements IEntityDtoOfString {
    id!: string | undefined;

    constructor(data?: IEntityDtoOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfString {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDtoOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityDtoOfString {
    id: string | undefined;
}

export enum ExternalSystemEnum {
    All = 0,
    MedReg = 1,
    Nareg = 2,
    PsyReg = 3,
    None = 4,
    BetReg = 5,
}

export class KeyValuePairOfStringString implements IKeyValuePairOfStringString {
    key!: string | undefined;
    value!: string | undefined;

    constructor(data?: IKeyValuePairOfStringString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): KeyValuePairOfStringString {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValuePairOfStringString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IKeyValuePairOfStringString {
    key: string | undefined;
    value: string | undefined;
}

export class ListResultDtoOfCacheDto implements IListResultDtoOfCacheDto {
    items!: CacheDto[] | undefined;

    constructor(data?: IListResultDtoOfCacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CacheDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCacheDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfCacheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfCacheDto {
    items: CacheDto[] | undefined;
}

export class ListResultDtoOfChatMessageDto implements IListResultDtoOfChatMessageDto {
    items!: ChatMessageDto[] | undefined;

    constructor(data?: IListResultDtoOfChatMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ChatMessageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfChatMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfChatMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfChatMessageDto {
    items: ChatMessageDto[] | undefined;
}

export class ListResultDtoOfEditionListDto implements IListResultDtoOfEditionListDto {
    items!: EditionListDto[] | undefined;

    constructor(data?: IListResultDtoOfEditionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EditionListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEditionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfEditionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfEditionListDto {
    items: EditionListDto[] | undefined;
}

export class ListResultDtoOfFlatPermissionWithLevelDto implements IListResultDtoOfFlatPermissionWithLevelDto {
    items!: FlatPermissionWithLevelDto[] | undefined;

    constructor(data?: IListResultDtoOfFlatPermissionWithLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FlatPermissionWithLevelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfFlatPermissionWithLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfFlatPermissionWithLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfFlatPermissionWithLevelDto {
    items: FlatPermissionWithLevelDto[] | undefined;
}

export class ListResultDtoOfLinkedUserDto implements IListResultDtoOfLinkedUserDto {
    items!: LinkedUserDto[] | undefined;

    constructor(data?: IListResultDtoOfLinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LinkedUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfLinkedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfLinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfLinkedUserDto {
    items: LinkedUserDto[] | undefined;
}

export class ListResultDtoOfMailDistributionListDto implements IListResultDtoOfMailDistributionListDto {
    items!: MailDistributionListDto[] | undefined;

    constructor(data?: IListResultDtoOfMailDistributionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MailDistributionListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfMailDistributionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfMailDistributionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfMailDistributionListDto {
    items: MailDistributionListDto[] | undefined;
}

export class ListResultDtoOfNameValueDto implements IListResultDtoOfNameValueDto {
    items!: NameValueDto[] | undefined;

    constructor(data?: IListResultDtoOfNameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfNameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfNameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfNameValueDto {
    items: NameValueDto[] | undefined;
}

export class ListResultDtoOfOrganizationUnitDto implements IListResultDtoOfOrganizationUnitDto {
    items!: OrganizationUnitDto[] | undefined;

    constructor(data?: IListResultDtoOfOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationUnitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfOrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfOrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfOrganizationUnitDto {
    items: OrganizationUnitDto[] | undefined;
}

export class ListResultDtoOfRoleListDto implements IListResultDtoOfRoleListDto {
    items!: RoleListDto[] | undefined;

    constructor(data?: IListResultDtoOfRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfRoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfRoleListDto {
    items: RoleListDto[] | undefined;
}

export class ListResultDtoOfSubscribableEditionComboboxItemDto implements IListResultDtoOfSubscribableEditionComboboxItemDto {
    items!: SubscribableEditionComboboxItemDto[] | undefined;

    constructor(data?: IListResultDtoOfSubscribableEditionComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SubscribableEditionComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfSubscribableEditionComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfSubscribableEditionComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfSubscribableEditionComboboxItemDto {
    items: SubscribableEditionComboboxItemDto[] | undefined;
}

export enum MigrationAdditionalStep {
    MedRegIdentification = 0,
    PsyRegIdentification = 1,
    NaregIdentification = 2,
    BetRegIdentification = 3,
}

export enum MigrationBinaryObjectId {
    CodeMappingMedDBZH = 0,
    CodeMappingZDBZH = 1,
    EvidenceZipFile = 2,
    DuplicateFile = 3,
    SensitiveDataFile = 4,
    BusinessGlnFile = 5,
    BusinessBurFile = 6,
    BusinessTypFile = 7,
    EvidenceBusinessDuplicateFile = 8,
}

export enum MigrationStep {
    Users = 0,
    People = 1,
    Sponsorships = 2,
    BusinessAddresses = 3,
    LinkedLicences = 4,
    Employments = 5,
    Documents = 6,
    Pendences = 7,
    MutationJournal = 8,
    SensitiveData = 9,
}

export class PagedResultDtoOfAuditLogListDto implements IPagedResultDtoOfAuditLogListDto {
    totalCount!: number;
    items!: AuditLogListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAuditLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AuditLogListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAuditLogListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAuditLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfAuditLogListDto {
    totalCount: number;
    items: AuditLogListDto[] | undefined;
}

export class PagedResultDtoOfCodeListDto implements IPagedResultDtoOfCodeListDto {
    totalCount!: number;
    items!: CodeListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCodeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CodeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCodeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCodeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfCodeListDto {
    totalCount: number;
    items: CodeListDto[] | undefined;
}

export class PagedResultDtoOfEntityChangeListDto implements IPagedResultDtoOfEntityChangeListDto {
    totalCount!: number;
    items!: EntityChangeListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfEntityChangeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EntityChangeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfEntityChangeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfEntityChangeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfEntityChangeListDto {
    totalCount: number;
    items: EntityChangeListDto[] | undefined;
}

export class PagedResultDtoOfGetExcelResultData implements IPagedResultDtoOfGetExcelResultData {
    totalCount!: number;
    items!: GetExcelResultData[] | undefined;

    constructor(data?: IPagedResultDtoOfGetExcelResultData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetExcelResultData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetExcelResultData {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetExcelResultData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetExcelResultData {
    totalCount: number;
    items: GetExcelResultData[] | undefined;
}

export class PagedResultDtoOfLanguageTextListDto implements IPagedResultDtoOfLanguageTextListDto {
    totalCount!: number;
    items!: LanguageTextListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfLanguageTextListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LanguageTextListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLanguageTextListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLanguageTextListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfLanguageTextListDto {
    totalCount: number;
    items: LanguageTextListDto[] | undefined;
}

export class PagedResultDtoOfLinkedUserDto implements IPagedResultDtoOfLinkedUserDto {
    totalCount!: number;
    items!: LinkedUserDto[] | undefined;

    constructor(data?: IPagedResultDtoOfLinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LinkedUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLinkedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfLinkedUserDto {
    totalCount: number;
    items: LinkedUserDto[] | undefined;
}

export class PagedResultDtoOfMailDistributionListEmailListDto implements IPagedResultDtoOfMailDistributionListEmailListDto {
    totalCount!: number;
    items!: MailDistributionListEmailListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfMailDistributionListEmailListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MailDistributionListEmailListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMailDistributionListEmailListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMailDistributionListEmailListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfMailDistributionListEmailListDto {
    totalCount: number;
    items: MailDistributionListEmailListDto[] | undefined;
}

export class PagedResultDtoOfMailDistributionListUserListDto implements IPagedResultDtoOfMailDistributionListUserListDto {
    totalCount!: number;
    items!: MailDistributionListUserListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfMailDistributionListUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MailDistributionListUserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMailDistributionListUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfMailDistributionListUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfMailDistributionListUserListDto {
    totalCount: number;
    items: MailDistributionListUserListDto[] | undefined;
}

export class PagedResultDtoOfNameValueDto implements IPagedResultDtoOfNameValueDto {
    totalCount!: number;
    items!: NameValueDto[] | undefined;

    constructor(data?: IPagedResultDtoOfNameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfNameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfNameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfNameValueDto {
    totalCount: number;
    items: NameValueDto[] | undefined;
}

export class PagedResultDtoOfOrganizationUnitProfessionListDto implements IPagedResultDtoOfOrganizationUnitProfessionListDto {
    totalCount!: number;
    items!: OrganizationUnitProfessionListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOrganizationUnitProfessionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationUnitProfessionListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrganizationUnitProfessionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrganizationUnitProfessionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfOrganizationUnitProfessionListDto {
    totalCount: number;
    items: OrganizationUnitProfessionListDto[] | undefined;
}

export class PagedResultDtoOfOrganizationUnitRoleListDto implements IPagedResultDtoOfOrganizationUnitRoleListDto {
    totalCount!: number;
    items!: OrganizationUnitRoleListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOrganizationUnitRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationUnitRoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrganizationUnitRoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrganizationUnitRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfOrganizationUnitRoleListDto {
    totalCount: number;
    items: OrganizationUnitRoleListDto[] | undefined;
}

export class PagedResultDtoOfOrganizationUnitUserListDto implements IPagedResultDtoOfOrganizationUnitUserListDto {
    totalCount!: number;
    items!: OrganizationUnitUserListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOrganizationUnitUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationUnitUserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrganizationUnitUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrganizationUnitUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfOrganizationUnitUserListDto {
    totalCount: number;
    items: OrganizationUnitUserListDto[] | undefined;
}

export class PagedResultDtoOfTenantListDto implements IPagedResultDtoOfTenantListDto {
    totalCount!: number;
    items!: TenantListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTenantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TenantListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTenantListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTenantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfTenantListDto {
    totalCount: number;
    items: TenantListDto[] | undefined;
}

export class PagedResultDtoOfUserDelegationDto implements IPagedResultDtoOfUserDelegationDto {
    totalCount!: number;
    items!: UserDelegationDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserDelegationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserDelegationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserDelegationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserDelegationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfUserDelegationDto {
    totalCount: number;
    items: UserDelegationDto[] | undefined;
}

export class PagedResultDtoOfUserListDto implements IPagedResultDtoOfUserListDto {
    totalCount!: number;
    items!: UserListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfUserListDto {
    totalCount: number;
    items: UserListDto[] | undefined;
}

export class PagedResultDtoOfUserLoginAttemptDto implements IPagedResultDtoOfUserLoginAttemptDto {
    totalCount!: number;
    items!: UserLoginAttemptDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserLoginAttemptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserLoginAttemptDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserLoginAttemptDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserLoginAttemptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfUserLoginAttemptDto {
    totalCount: number;
    items: UserLoginAttemptDto[] | undefined;
}

export enum PersonLicenceType {
    ProfessionalLicence = 0,
    ProfessionalNinetyDays = 1,
    ExpenceHealthCareLicence = 2,
    ExpenceHealthCareNinetyDays = 3,
    LocalSalesLicence = 4,
    AssistantLicence = 5,
    TraineeLicence = 6,
    SubstitutionSpecialLicence = 7,
    DelegatedLicencePerson = 8,
    Pensioner = 9,
    Instructor = 10,
    ReproductiveMedicineLicence = 11,
    ReproductiveMedicineAssistantLicence = 12,
    YellowFeverSpecialLicence = 13,
    TitleManagementPersonLicence = 14,
    RepresentationPersonLicence = 15,
}

export enum ProfessionRequirementType {
    ProfessionDiploma = 0,
    Degree = 1,
    PostgraduateTitle = 2,
    AtLeastOnePresent = 3,
    IssuedAfter = 4,
    LanguageSkill = 5,
    AtLeastOneLiaEmploymentDefined = 100,
    OnlyPrivateAddressAllowed = 200,
}

export class AcademicTitleDto implements IAcademicTitleDto {
    title!: string;
    titleVerified!: string | undefined;
    grantingAuthority!: string | undefined;
    placeOfIssue!: string | undefined;
    countryId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    remarks!: string | undefined;

    constructor(data?: IAcademicTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.titleVerified = _data["titleVerified"];
            this.grantingAuthority = _data["grantingAuthority"];
            this.placeOfIssue = _data["placeOfIssue"];
            this.countryId = _data["countryId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): AcademicTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new AcademicTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["titleVerified"] = this.titleVerified;
        data["grantingAuthority"] = this.grantingAuthority;
        data["placeOfIssue"] = this.placeOfIssue;
        data["countryId"] = this.countryId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["remarks"] = this.remarks;
        return data;
    }
}

export interface IAcademicTitleDto {
    title: string;
    titleVerified: string | undefined;
    grantingAuthority: string | undefined;
    placeOfIssue: string | undefined;
    countryId: string | undefined;
    dateOfIssue: DateTime | undefined;
    remarks: string | undefined;
}

export class AcademicTitleSearchResultDto implements IAcademicTitleSearchResultDto {
    id!: number;
    title!: string | undefined;
    grantingAuthority!: string | undefined;
    placeOfIssue!: string | undefined;
    countryId!: string | undefined;
    dateOfIssue!: DateTime | undefined;

    constructor(data?: IAcademicTitleSearchResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.grantingAuthority = _data["grantingAuthority"];
            this.placeOfIssue = _data["placeOfIssue"];
            this.countryId = _data["countryId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AcademicTitleSearchResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AcademicTitleSearchResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["grantingAuthority"] = this.grantingAuthority;
        data["placeOfIssue"] = this.placeOfIssue;
        data["countryId"] = this.countryId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        return data;
    }
}

export interface IAcademicTitleSearchResultDto {
    id: number;
    title: string | undefined;
    grantingAuthority: string | undefined;
    placeOfIssue: string | undefined;
    countryId: string | undefined;
    dateOfIssue: DateTime | undefined;
}

export class CreateAcademicTitleDto implements ICreateAcademicTitleDto {
    personId!: number;
    title!: string;
    titleVerified!: string | undefined;
    grantingAuthority!: string | undefined;
    placeOfIssue!: string | undefined;
    countryId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    remarks!: string | undefined;

    constructor(data?: ICreateAcademicTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.title = _data["title"];
            this.titleVerified = _data["titleVerified"];
            this.grantingAuthority = _data["grantingAuthority"];
            this.placeOfIssue = _data["placeOfIssue"];
            this.countryId = _data["countryId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): CreateAcademicTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAcademicTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["title"] = this.title;
        data["titleVerified"] = this.titleVerified;
        data["grantingAuthority"] = this.grantingAuthority;
        data["placeOfIssue"] = this.placeOfIssue;
        data["countryId"] = this.countryId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["remarks"] = this.remarks;
        return data;
    }
}

export interface ICreateAcademicTitleDto {
    personId: number;
    title: string;
    titleVerified: string | undefined;
    grantingAuthority: string | undefined;
    placeOfIssue: string | undefined;
    countryId: string | undefined;
    dateOfIssue: DateTime | undefined;
    remarks: string | undefined;
}

export class GetAcademicTitleSearchOutputDto implements IGetAcademicTitleSearchOutputDto {
    totalCount!: number;
    items!: AcademicTitleSearchResultDto[] | undefined;

    constructor(data?: IGetAcademicTitleSearchOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AcademicTitleSearchResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAcademicTitleSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAcademicTitleSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAcademicTitleSearchOutputDto {
    totalCount: number;
    items: AcademicTitleSearchResultDto[] | undefined;
}

export enum AdditionalInformationDiscriminator {
    Sponsorship = 1,
    PersonLicence = 3,
}

export class AdditionalInformationDto implements IAdditionalInformationDto {
    additionalInformationId!: string;
    date!: DateTime | undefined;
    furtherInformation!: string | undefined;

    constructor(data?: IAdditionalInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.additionalInformationId = _data["additionalInformationId"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.furtherInformation = _data["furtherInformation"];
        }
    }

    static fromJS(data: any): AdditionalInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additionalInformationId"] = this.additionalInformationId;
        data["date"] = this.date ? this.date.toFormat('yyyy-MM-dd') : <any>undefined;
        data["furtherInformation"] = this.furtherInformation;
        return data;
    }
}

export interface IAdditionalInformationDto {
    additionalInformationId: string;
    date: DateTime | undefined;
    furtherInformation: string | undefined;
}

export class GetAdditionalInformationDto implements IGetAdditionalInformationDto {
    id!: number;
    additionalInformationId!: string;
    date!: DateTime | undefined;
    furtherInformation!: string | undefined;

    constructor(data?: IGetAdditionalInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.additionalInformationId = _data["additionalInformationId"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.furtherInformation = _data["furtherInformation"];
        }
    }

    static fromJS(data: any): GetAdditionalInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAdditionalInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["additionalInformationId"] = this.additionalInformationId;
        data["date"] = this.date ? this.date.toFormat('yyyy-MM-dd') : <any>undefined;
        data["furtherInformation"] = this.furtherInformation;
        return data;
    }
}

export interface IGetAdditionalInformationDto {
    id: number;
    additionalInformationId: string;
    date: DateTime | undefined;
    furtherInformation: string | undefined;
}

export class AddressSearchDto implements IAddressSearchDto {
    businessId!: number | undefined;
    sponsorshipId!: number | undefined;
    sapId!: string | undefined;
    isInterCompany!: boolean | undefined;
    sponsorshipName!: string | undefined;
    addressTypeId!: string | undefined;
    legalFormId!: string | undefined;
    sponsorshipTypeId!: string | undefined;
    sponsorshipFieldId!: string | undefined;
    sponsorshipRangeOfServiceId!: string | undefined;
    name!: string | undefined;
    additionalName!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    gln!: string | undefined;
    bur!: string | undefined;
    uid!: string | undefined;
    email!: string | undefined;
    dateOfOpening!: DateTime | undefined;
    dateOfClosure!: DateTime | undefined;
    isArchived!: boolean;

    constructor(data?: IAddressSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.businessId = _data["businessId"];
            this.sponsorshipId = _data["sponsorshipId"];
            this.sapId = _data["sapId"];
            this.isInterCompany = _data["isInterCompany"];
            this.sponsorshipName = _data["sponsorshipName"];
            this.addressTypeId = _data["addressTypeId"];
            this.legalFormId = _data["legalFormId"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.sponsorshipFieldId = _data["sponsorshipFieldId"];
            this.sponsorshipRangeOfServiceId = _data["sponsorshipRangeOfServiceId"];
            this.name = _data["name"];
            this.additionalName = _data["additionalName"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.gln = _data["gln"];
            this.bur = _data["bur"];
            this.uid = _data["uid"];
            this.email = _data["email"];
            this.dateOfOpening = _data["dateOfOpening"] ? DateTime.fromISO(_data["dateOfOpening"].toString()) : <any>undefined;
            this.dateOfClosure = _data["dateOfClosure"] ? DateTime.fromISO(_data["dateOfClosure"].toString()) : <any>undefined;
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): AddressSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["businessId"] = this.businessId;
        data["sponsorshipId"] = this.sponsorshipId;
        data["sapId"] = this.sapId;
        data["isInterCompany"] = this.isInterCompany;
        data["sponsorshipName"] = this.sponsorshipName;
        data["addressTypeId"] = this.addressTypeId;
        data["legalFormId"] = this.legalFormId;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["sponsorshipFieldId"] = this.sponsorshipFieldId;
        data["sponsorshipRangeOfServiceId"] = this.sponsorshipRangeOfServiceId;
        data["name"] = this.name;
        data["additionalName"] = this.additionalName;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["gln"] = this.gln;
        data["bur"] = this.bur;
        data["uid"] = this.uid;
        data["email"] = this.email;
        data["dateOfOpening"] = this.dateOfOpening ? this.dateOfOpening.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfClosure"] = this.dateOfClosure ? this.dateOfClosure.toFormat('yyyy-MM-dd') : <any>undefined;
        data["isArchived"] = this.isArchived;
        return data;
    }
}

export interface IAddressSearchDto {
    businessId: number | undefined;
    sponsorshipId: number | undefined;
    sapId: string | undefined;
    isInterCompany: boolean | undefined;
    sponsorshipName: string | undefined;
    addressTypeId: string | undefined;
    legalFormId: string | undefined;
    sponsorshipTypeId: string | undefined;
    sponsorshipFieldId: string | undefined;
    sponsorshipRangeOfServiceId: string | undefined;
    name: string | undefined;
    additionalName: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    gln: string | undefined;
    bur: string | undefined;
    uid: string | undefined;
    email: string | undefined;
    dateOfOpening: DateTime | undefined;
    dateOfClosure: DateTime | undefined;
    isArchived: boolean;
}

export class AddressSearchInput implements IAddressSearchInput {
    isArchived!: boolean | undefined;
    filter!: string | undefined;
    sorting!: string | undefined;
    maxResultCount!: number;
    skipCount!: number;

    constructor(data?: IAddressSearchInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isArchived = _data["isArchived"];
            this.filter = _data["filter"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): AddressSearchInput {
        data = typeof data === 'object' ? data : {};
        let result = new AddressSearchInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isArchived"] = this.isArchived;
        data["filter"] = this.filter;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }
}

export interface IAddressSearchInput {
    isArchived: boolean | undefined;
    filter: string | undefined;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
}

export class AddressSearchOutput implements IAddressSearchOutput {
    totalCount!: number;
    items!: AddressSearchDto[] | undefined;

    constructor(data?: IAddressSearchOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AddressSearchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddressSearchOutput {
        data = typeof data === 'object' ? data : {};
        let result = new AddressSearchOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAddressSearchOutput {
    totalCount: number;
    items: AddressSearchDto[] | undefined;
}

export class FormAddressSearchInput implements IFormAddressSearchInput {
    businessId!: number | undefined;
    sponsorshipId!: number | undefined;
    name!: string | undefined;
    sponsorshipTypeId!: string | undefined;
    addressTypeId!: string | undefined;
    legalFormId!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    uid!: string | undefined;
    bur!: string | undefined;
    gln!: string | undefined;
    email!: string | undefined;
    sponsorshipFieldId!: string | undefined;
    sponsorshipRangeOfServiceId!: string | undefined;
    includeSponsorships!: boolean | undefined;
    includeBusinesses!: boolean | undefined;
    maxResultCount!: number | undefined;
    skipCount!: number | undefined;
    isArchived!: boolean | undefined;

    constructor(data?: IFormAddressSearchInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.businessId = _data["businessId"];
            this.sponsorshipId = _data["sponsorshipId"];
            this.name = _data["name"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.addressTypeId = _data["addressTypeId"];
            this.legalFormId = _data["legalFormId"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.uid = _data["uid"];
            this.bur = _data["bur"];
            this.gln = _data["gln"];
            this.email = _data["email"];
            this.sponsorshipFieldId = _data["sponsorshipFieldId"];
            this.sponsorshipRangeOfServiceId = _data["sponsorshipRangeOfServiceId"];
            this.includeSponsorships = _data["includeSponsorships"];
            this.includeBusinesses = _data["includeBusinesses"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): FormAddressSearchInput {
        data = typeof data === 'object' ? data : {};
        let result = new FormAddressSearchInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["businessId"] = this.businessId;
        data["sponsorshipId"] = this.sponsorshipId;
        data["name"] = this.name;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["addressTypeId"] = this.addressTypeId;
        data["legalFormId"] = this.legalFormId;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["uid"] = this.uid;
        data["bur"] = this.bur;
        data["gln"] = this.gln;
        data["email"] = this.email;
        data["sponsorshipFieldId"] = this.sponsorshipFieldId;
        data["sponsorshipRangeOfServiceId"] = this.sponsorshipRangeOfServiceId;
        data["includeSponsorships"] = this.includeSponsorships;
        data["includeBusinesses"] = this.includeBusinesses;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["isArchived"] = this.isArchived;
        return data;
    }
}

export interface IFormAddressSearchInput {
    businessId: number | undefined;
    sponsorshipId: number | undefined;
    name: string | undefined;
    sponsorshipTypeId: string | undefined;
    addressTypeId: string | undefined;
    legalFormId: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    uid: string | undefined;
    bur: string | undefined;
    gln: string | undefined;
    email: string | undefined;
    sponsorshipFieldId: string | undefined;
    sponsorshipRangeOfServiceId: string | undefined;
    includeSponsorships: boolean | undefined;
    includeBusinesses: boolean | undefined;
    maxResultCount: number | undefined;
    skipCount: number | undefined;
    isArchived: boolean | undefined;
}

export enum ApplicationStatus {
    UnderConstruction = 0,
    Submitted = 1,
    UnderEvaluation = 2,
    SupplementalClaim = 3,
    FormallyEvaluated = 4,
    Granted = 5,
    Withdrawn = 6,
    Denied = 7,
    Revoked = 8,
    UnderPreEvaluation = 9,
    NotConsidered = 11,
    Waitlist = 12,
}

export class ApplicationContextDto implements IApplicationContextDto {
    labelLanguageKey!: string | undefined;
    valueLanguageKey!: string | undefined;

    constructor(data?: IApplicationContextDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.labelLanguageKey = _data["labelLanguageKey"];
            this.valueLanguageKey = _data["valueLanguageKey"];
        }
    }

    static fromJS(data: any): ApplicationContextDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationContextDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["labelLanguageKey"] = this.labelLanguageKey;
        data["valueLanguageKey"] = this.valueLanguageKey;
        return data;
    }
}

export interface IApplicationContextDto {
    labelLanguageKey: string | undefined;
    valueLanguageKey: string | undefined;
}

export class ApplicationDto implements IApplicationDto {
    caseId!: string | undefined;
    title!: string | undefined;
    name!: string | undefined;
    username!: string | undefined;
    userEmail!: string | undefined;
    type!: ApplicationType;
    status!: ApplicationStatus;
    dateOfStatusChange!: DateTime;
    responsible!: string | undefined;
    amIResponsible!: boolean;
    applicantComment!: string | undefined;
    submittedCount!: number;
    applicationContext!: ApplicationContextDto[] | undefined;
    evaluations!: EvaluationDto[] | undefined;
    historyEntries!: ApplicationHistoryDto[] | undefined;
    supplementaryClaims!: ApplicationSupplementalClaimDto[] | undefined;
    emailTemplate!: EmailTemplateDto;
    canStartEvaluation!: boolean;
    authorityDocuments!: GeneralDocumentGroupDto[] | undefined;
    id!: number;

    constructor(data?: IApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.title = _data["title"];
            this.name = _data["name"];
            this.username = _data["username"];
            this.userEmail = _data["userEmail"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.dateOfStatusChange = _data["dateOfStatusChange"] ? DateTime.fromISO(_data["dateOfStatusChange"].toString()) : <any>undefined;
            this.responsible = _data["responsible"];
            this.amIResponsible = _data["amIResponsible"];
            this.applicantComment = _data["applicantComment"];
            this.submittedCount = _data["submittedCount"];
            if (Array.isArray(_data["applicationContext"])) {
                this.applicationContext = [] as any;
                for (let item of _data["applicationContext"])
                    this.applicationContext!.push(ApplicationContextDto.fromJS(item));
            }
            if (Array.isArray(_data["evaluations"])) {
                this.evaluations = [] as any;
                for (let item of _data["evaluations"])
                    this.evaluations!.push(EvaluationDto.fromJS(item));
            }
            if (Array.isArray(_data["historyEntries"])) {
                this.historyEntries = [] as any;
                for (let item of _data["historyEntries"])
                    this.historyEntries!.push(ApplicationHistoryDto.fromJS(item));
            }
            if (Array.isArray(_data["supplementaryClaims"])) {
                this.supplementaryClaims = [] as any;
                for (let item of _data["supplementaryClaims"])
                    this.supplementaryClaims!.push(ApplicationSupplementalClaimDto.fromJS(item));
            }
            this.emailTemplate = _data["emailTemplate"] ? EmailTemplateDto.fromJS(_data["emailTemplate"]) : <any>undefined;
            this.canStartEvaluation = _data["canStartEvaluation"];
            if (Array.isArray(_data["authorityDocuments"])) {
                this.authorityDocuments = [] as any;
                for (let item of _data["authorityDocuments"])
                    this.authorityDocuments!.push(GeneralDocumentGroupDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["title"] = this.title;
        data["name"] = this.name;
        data["username"] = this.username;
        data["userEmail"] = this.userEmail;
        data["type"] = this.type;
        data["status"] = this.status;
        data["dateOfStatusChange"] = this.dateOfStatusChange ? this.dateOfStatusChange.toString() : <any>undefined;
        data["responsible"] = this.responsible;
        data["amIResponsible"] = this.amIResponsible;
        data["applicantComment"] = this.applicantComment;
        data["submittedCount"] = this.submittedCount;
        if (Array.isArray(this.applicationContext)) {
            data["applicationContext"] = [];
            for (let item of this.applicationContext)
                data["applicationContext"].push(item.toJSON());
        }
        if (Array.isArray(this.evaluations)) {
            data["evaluations"] = [];
            for (let item of this.evaluations)
                data["evaluations"].push(item.toJSON());
        }
        if (Array.isArray(this.historyEntries)) {
            data["historyEntries"] = [];
            for (let item of this.historyEntries)
                data["historyEntries"].push(item.toJSON());
        }
        if (Array.isArray(this.supplementaryClaims)) {
            data["supplementaryClaims"] = [];
            for (let item of this.supplementaryClaims)
                data["supplementaryClaims"].push(item.toJSON());
        }
        data["emailTemplate"] = this.emailTemplate ? this.emailTemplate.toJSON() : <any>undefined;
        data["canStartEvaluation"] = this.canStartEvaluation;
        if (Array.isArray(this.authorityDocuments)) {
            data["authorityDocuments"] = [];
            for (let item of this.authorityDocuments)
                data["authorityDocuments"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IApplicationDto {
    caseId: string | undefined;
    title: string | undefined;
    name: string | undefined;
    username: string | undefined;
    userEmail: string | undefined;
    type: ApplicationType;
    status: ApplicationStatus;
    dateOfStatusChange: DateTime;
    responsible: string | undefined;
    amIResponsible: boolean;
    applicantComment: string | undefined;
    submittedCount: number;
    applicationContext: ApplicationContextDto[] | undefined;
    evaluations: EvaluationDto[] | undefined;
    historyEntries: ApplicationHistoryDto[] | undefined;
    supplementaryClaims: ApplicationSupplementalClaimDto[] | undefined;
    emailTemplate: EmailTemplateDto;
    canStartEvaluation: boolean;
    authorityDocuments: GeneralDocumentGroupDto[] | undefined;
    id: number;
}

export class ApplicationHistoryDto implements IApplicationHistoryDto {
    status!: ApplicationStatus;
    text!: string | undefined;
    message!: string | undefined;
    messageHeader!: string | undefined;
    date!: DateTime;
    isResponsibleChange!: boolean;
    documents!: GeneralFileInfoDto[] | undefined;
    applicationAuthorityHistoryDocuments!: GeneralFileInfoDto[] | undefined;
    id!: number;

    constructor(data?: IApplicationHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.text = _data["text"];
            this.message = _data["message"];
            this.messageHeader = _data["messageHeader"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.isResponsibleChange = _data["isResponsibleChange"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralFileInfoDto.fromJS(item));
            }
            if (Array.isArray(_data["applicationAuthorityHistoryDocuments"])) {
                this.applicationAuthorityHistoryDocuments = [] as any;
                for (let item of _data["applicationAuthorityHistoryDocuments"])
                    this.applicationAuthorityHistoryDocuments!.push(GeneralFileInfoDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ApplicationHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["text"] = this.text;
        data["message"] = this.message;
        data["messageHeader"] = this.messageHeader;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["isResponsibleChange"] = this.isResponsibleChange;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        if (Array.isArray(this.applicationAuthorityHistoryDocuments)) {
            data["applicationAuthorityHistoryDocuments"] = [];
            for (let item of this.applicationAuthorityHistoryDocuments)
                data["applicationAuthorityHistoryDocuments"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IApplicationHistoryDto {
    status: ApplicationStatus;
    text: string | undefined;
    message: string | undefined;
    messageHeader: string | undefined;
    date: DateTime;
    isResponsibleChange: boolean;
    documents: GeneralFileInfoDto[] | undefined;
    applicationAuthorityHistoryDocuments: GeneralFileInfoDto[] | undefined;
    id: number;
}

export class ApplicationJournalRecordDto implements IApplicationJournalRecordDto {
    applicationId!: number;
    message!: string | undefined;
    applicationStatus!: ApplicationStatus;
    wizardStep!: number;
    creationTime!: DateTime | undefined;
    user!: ApplicationJournalUserDto;
    id!: number;

    constructor(data?: IApplicationJournalRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.message = _data["message"];
            this.applicationStatus = _data["applicationStatus"];
            this.wizardStep = _data["wizardStep"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.user = _data["user"] ? ApplicationJournalUserDto.fromJS(_data["user"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ApplicationJournalRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationJournalRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["message"] = this.message;
        data["applicationStatus"] = this.applicationStatus;
        data["wizardStep"] = this.wizardStep;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IApplicationJournalRecordDto {
    applicationId: number;
    message: string | undefined;
    applicationStatus: ApplicationStatus;
    wizardStep: number;
    creationTime: DateTime | undefined;
    user: ApplicationJournalUserDto;
    id: number;
}

export class ApplicationJournalUserDto implements IApplicationJournalUserDto {
    id!: number;
    name!: string | undefined;
    surname!: string | undefined;

    constructor(data?: IApplicationJournalUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
        }
    }

    static fromJS(data: any): ApplicationJournalUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationJournalUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        return data;
    }
}

export interface IApplicationJournalUserDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
}

export class ApplicationSupplementalClaimDto implements IApplicationSupplementalClaimDto {
    applicationId!: number;
    applicationHistoryStatusId!: number | undefined;
    timeOfNotification!: DateTime | undefined;
    reminderDate!: DateTime | undefined;
    id!: number;

    constructor(data?: IApplicationSupplementalClaimDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.applicationHistoryStatusId = _data["applicationHistoryStatusId"];
            this.timeOfNotification = _data["timeOfNotification"] ? DateTime.fromISO(_data["timeOfNotification"].toString()) : <any>undefined;
            this.reminderDate = _data["reminderDate"] ? DateTime.fromISO(_data["reminderDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ApplicationSupplementalClaimDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationSupplementalClaimDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["applicationHistoryStatusId"] = this.applicationHistoryStatusId;
        data["timeOfNotification"] = this.timeOfNotification ? this.timeOfNotification.toString() : <any>undefined;
        data["reminderDate"] = this.reminderDate ? this.reminderDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IApplicationSupplementalClaimDto {
    applicationId: number;
    applicationHistoryStatusId: number | undefined;
    timeOfNotification: DateTime | undefined;
    reminderDate: DateTime | undefined;
    id: number;
}

export class AssignApplicationInput implements IAssignApplicationInput {
    caseId!: string;
    userId!: number;

    constructor(data?: IAssignApplicationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AssignApplicationInput {
        data = typeof data === 'object' ? data : {};
        let result = new AssignApplicationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IAssignApplicationInput {
    caseId: string;
    userId: number;
}

export class AssignApplicationOutput implements IAssignApplicationOutput {
    responsible!: string | undefined;
    userId!: number | undefined;

    constructor(data?: IAssignApplicationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responsible = _data["responsible"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AssignApplicationOutput {
        data = typeof data === 'object' ? data : {};
        let result = new AssignApplicationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responsible"] = this.responsible;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IAssignApplicationOutput {
    responsible: string | undefined;
    userId: number | undefined;
}

export enum CompletionStatus {
    Incomplete = 0,
    Complete = 1,
}

export class CreateApplicationJournalRecordInput implements ICreateApplicationJournalRecordInput {
    caseId!: string | undefined;
    message!: string | undefined;
    wizardStep!: number;

    constructor(data?: ICreateApplicationJournalRecordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.message = _data["message"];
            this.wizardStep = _data["wizardStep"];
        }
    }

    static fromJS(data: any): CreateApplicationJournalRecordInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateApplicationJournalRecordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["message"] = this.message;
        data["wizardStep"] = this.wizardStep;
        return data;
    }
}

export interface ICreateApplicationJournalRecordInput {
    caseId: string | undefined;
    message: string | undefined;
    wizardStep: number;
}

export class EmailTemplateDto implements IEmailTemplateDto {
    languageOfCorrespondenceId!: string | undefined;
    supplementalClaimTemplate!: string | undefined;
    rejectionTemplate!: string | undefined;

    constructor(data?: IEmailTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.supplementalClaimTemplate = _data["supplementalClaimTemplate"];
            this.rejectionTemplate = _data["rejectionTemplate"];
        }
    }

    static fromJS(data: any): EmailTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["supplementalClaimTemplate"] = this.supplementalClaimTemplate;
        data["rejectionTemplate"] = this.rejectionTemplate;
        return data;
    }
}

export interface IEmailTemplateDto {
    languageOfCorrespondenceId: string | undefined;
    supplementalClaimTemplate: string | undefined;
    rejectionTemplate: string | undefined;
}

export class EvaluationDto implements IEvaluationDto {
    step!: number;
    okayId!: string | undefined;
    order!: number;
    comment!: string | undefined;
    id!: number;

    constructor(data?: IEvaluationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.step = _data["step"];
            this.okayId = _data["okayId"];
            this.order = _data["order"];
            this.comment = _data["comment"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EvaluationDto {
        data = typeof data === 'object' ? data : {};
        let result = new EvaluationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["step"] = this.step;
        data["okayId"] = this.okayId;
        data["order"] = this.order;
        data["comment"] = this.comment;
        data["id"] = this.id;
        return data;
    }
}

export interface IEvaluationDto {
    step: number;
    okayId: string | undefined;
    order: number;
    comment: string | undefined;
    id: number;
}

export class EvaluationInput implements IEvaluationInput {
    caseId!: string;
    evaluation!: EvaluationDto;

    constructor(data?: IEvaluationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.evaluation = new EvaluationDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.evaluation = _data["evaluation"] ? EvaluationDto.fromJS(_data["evaluation"]) : new EvaluationDto();
        }
    }

    static fromJS(data: any): EvaluationInput {
        data = typeof data === 'object' ? data : {};
        let result = new EvaluationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["evaluation"] = this.evaluation ? this.evaluation.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEvaluationInput {
    caseId: string;
    evaluation: EvaluationDto;
}

export class GetEhcApplicationsOutput implements IGetEhcApplicationsOutput {
    totalCount!: number;
    items!: EhcSearchDto[] | undefined;

    constructor(data?: IGetEhcApplicationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EhcSearchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEhcApplicationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEhcApplicationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetEhcApplicationsOutput {
    totalCount: number;
    items: EhcSearchDto[] | undefined;
}

export class GetResultDocumentsOutput implements IGetResultDocumentsOutput {
    caseId!: string;
    resultDocuments!: GeneralFileInfoDto[];

    constructor(data?: IGetResultDocumentsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.resultDocuments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["resultDocuments"])) {
                this.resultDocuments = [] as any;
                for (let item of _data["resultDocuments"])
                    this.resultDocuments!.push(GeneralFileInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetResultDocumentsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetResultDocumentsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.resultDocuments)) {
            data["resultDocuments"] = [];
            for (let item of this.resultDocuments)
                data["resultDocuments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetResultDocumentsOutput {
    caseId: string;
    resultDocuments: GeneralFileInfoDto[];
}

export class NotConsiderApplicationInputDto implements INotConsiderApplicationInputDto {
    message!: string;
    documents!: GeneralFileDto[] | undefined;

    constructor(data?: INotConsiderApplicationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralFileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NotConsiderApplicationInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotConsiderApplicationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface INotConsiderApplicationInputDto {
    message: string;
    documents: GeneralFileDto[] | undefined;
}

export class RejectApplicationInputDto implements IRejectApplicationInputDto {
    message!: string;
    documents!: GeneralFileDto[] | undefined;

    constructor(data?: IRejectApplicationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralFileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RejectApplicationInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new RejectApplicationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRejectApplicationInputDto {
    message: string;
    documents: GeneralFileDto[] | undefined;
}

export class RequestForSupplementalInformationInput implements IRequestForSupplementalInformationInput {
    caseId!: string;
    message!: string | undefined;
    isReminder!: boolean;

    constructor(data?: IRequestForSupplementalInformationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.message = _data["message"];
            this.isReminder = _data["isReminder"];
        }
    }

    static fromJS(data: any): RequestForSupplementalInformationInput {
        data = typeof data === 'object' ? data : {};
        let result = new RequestForSupplementalInformationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["message"] = this.message;
        data["isReminder"] = this.isReminder;
        return data;
    }
}

export interface IRequestForSupplementalInformationInput {
    caseId: string;
    message: string | undefined;
    isReminder: boolean;
}

export class SetSupplementalInformationReminderDateInput implements ISetSupplementalInformationReminderDateInput {
    caseId!: string;
    reminderDate!: DateTime | undefined;

    constructor(data?: ISetSupplementalInformationReminderDateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.reminderDate = _data["reminderDate"] ? DateTime.fromISO(_data["reminderDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SetSupplementalInformationReminderDateInput {
        data = typeof data === 'object' ? data : {};
        let result = new SetSupplementalInformationReminderDateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["reminderDate"] = this.reminderDate ? this.reminderDate.toFormat('yyyy-MM-dd') : <any>undefined;
        return data;
    }
}

export interface ISetSupplementalInformationReminderDateInput {
    caseId: string;
    reminderDate: DateTime | undefined;
}

export class StatusVisibility implements IStatusVisibility {
    status!: number;
    visibility!: TabVisibility;

    constructor(data?: IStatusVisibility) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.visibility = _data["visibility"];
        }
    }

    static fromJS(data: any): StatusVisibility {
        data = typeof data === 'object' ? data : {};
        let result = new StatusVisibility();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["visibility"] = this.visibility;
        return data;
    }
}

export interface IStatusVisibility {
    status: number;
    visibility: TabVisibility;
}

export class WithdrawApplicationInputDto implements IWithdrawApplicationInputDto {
    message!: string | undefined;
    documents!: GeneralFileDto[] | undefined;

    constructor(data?: IWithdrawApplicationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralFileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WithdrawApplicationInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new WithdrawApplicationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWithdrawApplicationInputDto {
    message: string | undefined;
    documents: GeneralFileDto[] | undefined;
}

export class AssistantDto implements IAssistantDto {
    assistantPersonLicence!: ProfessionalLicenceDto;
    assistantPersonLicenceId!: number | undefined;
    corporateLicence!: CorporateLicenceDto;
    corporateLicenceId!: number | undefined;
    firstName!: string;
    lastName!: string;
    gln!: string | undefined;
    dateOfEmployment!: DateTime;
    dateOfEndOfEmployment!: DateTime | undefined;
    levelOfEmployment!: number;

    constructor(data?: IAssistantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assistantPersonLicence = _data["assistantPersonLicence"] ? ProfessionalLicenceDto.fromJS(_data["assistantPersonLicence"]) : <any>undefined;
            this.assistantPersonLicenceId = _data["assistantPersonLicenceId"];
            this.corporateLicence = _data["corporateLicence"] ? CorporateLicenceDto.fromJS(_data["corporateLicence"]) : <any>undefined;
            this.corporateLicenceId = _data["corporateLicenceId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.gln = _data["gln"];
            this.dateOfEmployment = _data["dateOfEmployment"] ? DateTime.fromISO(_data["dateOfEmployment"].toString()) : <any>undefined;
            this.dateOfEndOfEmployment = _data["dateOfEndOfEmployment"] ? DateTime.fromISO(_data["dateOfEndOfEmployment"].toString()) : <any>undefined;
            this.levelOfEmployment = _data["levelOfEmployment"];
        }
    }

    static fromJS(data: any): AssistantDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssistantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assistantPersonLicence"] = this.assistantPersonLicence ? this.assistantPersonLicence.toJSON() : <any>undefined;
        data["assistantPersonLicenceId"] = this.assistantPersonLicenceId;
        data["corporateLicence"] = this.corporateLicence ? this.corporateLicence.toJSON() : <any>undefined;
        data["corporateLicenceId"] = this.corporateLicenceId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["gln"] = this.gln;
        data["dateOfEmployment"] = this.dateOfEmployment ? this.dateOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEndOfEmployment"] = this.dateOfEndOfEmployment ? this.dateOfEndOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfEmployment"] = this.levelOfEmployment;
        return data;
    }
}

export interface IAssistantDto {
    assistantPersonLicence: ProfessionalLicenceDto;
    assistantPersonLicenceId: number | undefined;
    corporateLicence: CorporateLicenceDto;
    corporateLicenceId: number | undefined;
    firstName: string;
    lastName: string;
    gln: string | undefined;
    dateOfEmployment: DateTime;
    dateOfEndOfEmployment: DateTime | undefined;
    levelOfEmployment: number;
}

export class AssistantSearchResultDto implements IAssistantSearchResultDto {
    id!: number;
    firstName!: string | undefined;
    lastName!: string | undefined;
    gln!: string | undefined;
    dateOfEmployment!: DateTime;
    dateOfEndOfEmployment!: DateTime | undefined;
    levelOfEmployment!: number;

    constructor(data?: IAssistantSearchResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.gln = _data["gln"];
            this.dateOfEmployment = _data["dateOfEmployment"] ? DateTime.fromISO(_data["dateOfEmployment"].toString()) : <any>undefined;
            this.dateOfEndOfEmployment = _data["dateOfEndOfEmployment"] ? DateTime.fromISO(_data["dateOfEndOfEmployment"].toString()) : <any>undefined;
            this.levelOfEmployment = _data["levelOfEmployment"];
        }
    }

    static fromJS(data: any): AssistantSearchResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssistantSearchResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["gln"] = this.gln;
        data["dateOfEmployment"] = this.dateOfEmployment ? this.dateOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEndOfEmployment"] = this.dateOfEndOfEmployment ? this.dateOfEndOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfEmployment"] = this.levelOfEmployment;
        return data;
    }
}

export interface IAssistantSearchResultDto {
    id: number;
    firstName: string | undefined;
    lastName: string | undefined;
    gln: string | undefined;
    dateOfEmployment: DateTime;
    dateOfEndOfEmployment: DateTime | undefined;
    levelOfEmployment: number;
}

export class CreateAssistantDto implements ICreateAssistantDto {
    assistantPersonLicenceId!: number | undefined;
    corporateLicenceId!: number | undefined;
    firstName!: string;
    lastName!: string;
    gln!: string | undefined;
    dateOfEmployment!: DateTime;
    dateOfEndOfEmployment!: DateTime | undefined;
    levelOfEmployment!: number;

    constructor(data?: ICreateAssistantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assistantPersonLicenceId = _data["assistantPersonLicenceId"];
            this.corporateLicenceId = _data["corporateLicenceId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.gln = _data["gln"];
            this.dateOfEmployment = _data["dateOfEmployment"] ? DateTime.fromISO(_data["dateOfEmployment"].toString()) : <any>undefined;
            this.dateOfEndOfEmployment = _data["dateOfEndOfEmployment"] ? DateTime.fromISO(_data["dateOfEndOfEmployment"].toString()) : <any>undefined;
            this.levelOfEmployment = _data["levelOfEmployment"];
        }
    }

    static fromJS(data: any): CreateAssistantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAssistantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assistantPersonLicenceId"] = this.assistantPersonLicenceId;
        data["corporateLicenceId"] = this.corporateLicenceId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["gln"] = this.gln;
        data["dateOfEmployment"] = this.dateOfEmployment ? this.dateOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEndOfEmployment"] = this.dateOfEndOfEmployment ? this.dateOfEndOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfEmployment"] = this.levelOfEmployment;
        return data;
    }
}

export interface ICreateAssistantDto {
    assistantPersonLicenceId: number | undefined;
    corporateLicenceId: number | undefined;
    firstName: string;
    lastName: string;
    gln: string | undefined;
    dateOfEmployment: DateTime;
    dateOfEndOfEmployment: DateTime | undefined;
    levelOfEmployment: number;
}

export class GetAssistantSearchOutput implements IGetAssistantSearchOutput {
    totalCount!: number;
    items!: AssistantSearchResultDto[] | undefined;

    constructor(data?: IGetAssistantSearchOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AssistantSearchResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAssistantSearchOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssistantSearchOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAssistantSearchOutput {
    totalCount: number;
    items: AssistantSearchResultDto[] | undefined;
}

export class AlaAcademicTitleDto implements IAlaAcademicTitleDto {
    title!: string;
    bodyOfIssue!: string;
    placeOfIssue!: string;
    countryOfIssueId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfRecognition!: DateTime | undefined;
    id!: number;

    constructor(data?: IAlaAcademicTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.bodyOfIssue = _data["bodyOfIssue"];
            this.placeOfIssue = _data["placeOfIssue"];
            this.countryOfIssueId = _data["countryOfIssueId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfRecognition = _data["dateOfRecognition"] ? DateTime.fromISO(_data["dateOfRecognition"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AlaAcademicTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlaAcademicTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["bodyOfIssue"] = this.bodyOfIssue;
        data["placeOfIssue"] = this.placeOfIssue;
        data["countryOfIssueId"] = this.countryOfIssueId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfRecognition"] = this.dateOfRecognition ? this.dateOfRecognition.toFormat('yyyy-MM-dd') : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IAlaAcademicTitleDto {
    title: string;
    bodyOfIssue: string;
    placeOfIssue: string;
    countryOfIssueId: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfRecognition: DateTime | undefined;
    id: number;
}

export class AlaAcademicTitlesOutput implements IAlaAcademicTitlesOutput {
    titles!: AlaAcademicTitleDto[] | undefined;
    documents!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: IAlaAcademicTitlesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(AlaAcademicTitleDto.fromJS(item));
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AlaAcademicTitlesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new AlaAcademicTitlesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item.toJSON());
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAlaAcademicTitlesOutput {
    titles: AlaAcademicTitleDto[] | undefined;
    documents: GeneralDocumentGroupDto[] | undefined;
}

export class AlaApplicantPersonDto implements IAlaApplicantPersonDto {
    firstName!: string | undefined;
    lastName!: string | undefined;
    gln!: string | undefined;
    licenceTypeId!: string | undefined;
    licenceCantonId!: string | undefined;
    licenceStatusId!: string | undefined;
    activityStatusId!: string | undefined;

    constructor(data?: IAlaApplicantPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.gln = _data["gln"];
            this.licenceTypeId = _data["licenceTypeId"];
            this.licenceCantonId = _data["licenceCantonId"];
            this.licenceStatusId = _data["licenceStatusId"];
            this.activityStatusId = _data["activityStatusId"];
        }
    }

    static fromJS(data: any): AlaApplicantPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlaApplicantPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["gln"] = this.gln;
        data["licenceTypeId"] = this.licenceTypeId;
        data["licenceCantonId"] = this.licenceCantonId;
        data["licenceStatusId"] = this.licenceStatusId;
        data["activityStatusId"] = this.activityStatusId;
        return data;
    }
}

export interface IAlaApplicantPersonDto {
    firstName: string | undefined;
    lastName: string | undefined;
    gln: string | undefined;
    licenceTypeId: string | undefined;
    licenceCantonId: string | undefined;
    licenceStatusId: string | undefined;
    activityStatusId: string | undefined;
}

export class AlaApplicantSponsorshipDto implements IAlaApplicantSponsorshipDto {
    uid!: string;
    name!: string;
    additionalName!: string | undefined;
    legalFormId!: string;
    postCode!: string;
    city!: string;
    street!: string;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    invoiceEmail!: string | undefined;
    website!: string | undefined;
    documents!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: IAlaApplicantSponsorshipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uid = _data["uid"];
            this.name = _data["name"];
            this.additionalName = _data["additionalName"];
            this.legalFormId = _data["legalFormId"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.invoiceEmail = _data["invoiceEmail"];
            this.website = _data["website"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AlaApplicantSponsorshipDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlaApplicantSponsorshipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uid"] = this.uid;
        data["name"] = this.name;
        data["additionalName"] = this.additionalName;
        data["legalFormId"] = this.legalFormId;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["invoiceEmail"] = this.invoiceEmail;
        data["website"] = this.website;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAlaApplicantSponsorshipDto {
    uid: string;
    name: string;
    additionalName: string | undefined;
    legalFormId: string;
    postCode: string;
    city: string;
    street: string;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    invoiceEmail: string | undefined;
    website: string | undefined;
    documents: GeneralDocumentGroupDto[] | undefined;
}

export class AlaBusinessDto implements IAlaBusinessDto {
    name!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    id!: number;

    constructor(data?: IAlaBusinessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AlaBusinessDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlaBusinessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["id"] = this.id;
        return data;
    }
}

export interface IAlaBusinessDto {
    name: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    id: number;
}

export class AlaContactDto implements IAlaContactDto {
    street!: string;
    streetNr!: string | undefined;
    postCode!: string;
    city!: string;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string;
    hasImmigratedLastFiveYearsId!: string;

    constructor(data?: IAlaContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.hasImmigratedLastFiveYearsId = _data["hasImmigratedLastFiveYearsId"];
        }
    }

    static fromJS(data: any): AlaContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlaContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["hasImmigratedLastFiveYearsId"] = this.hasImmigratedLastFiveYearsId;
        return data;
    }
}

export interface IAlaContactDto {
    street: string;
    streetNr: string | undefined;
    postCode: string;
    city: string;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string;
    hasImmigratedLastFiveYearsId: string;
}

export class AlaCurrentAssistantDto implements IAlaCurrentAssistantDto {
    id!: number | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    gln!: string | undefined;
    levelOfEmployment!: number | undefined;
    dateOfEmployment!: DateTime | undefined;
    dateOfEndOfEmployment!: DateTime | undefined;

    constructor(data?: IAlaCurrentAssistantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.gln = _data["gln"];
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.dateOfEmployment = _data["dateOfEmployment"] ? DateTime.fromISO(_data["dateOfEmployment"].toString()) : <any>undefined;
            this.dateOfEndOfEmployment = _data["dateOfEndOfEmployment"] ? DateTime.fromISO(_data["dateOfEndOfEmployment"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AlaCurrentAssistantDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlaCurrentAssistantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["gln"] = this.gln;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["dateOfEmployment"] = this.dateOfEmployment ? this.dateOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEndOfEmployment"] = this.dateOfEndOfEmployment ? this.dateOfEndOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        return data;
    }
}

export interface IAlaCurrentAssistantDto {
    id: number | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    gln: string | undefined;
    levelOfEmployment: number | undefined;
    dateOfEmployment: DateTime | undefined;
    dateOfEndOfEmployment: DateTime | undefined;
}

export class AlaDiplomaDto implements IAlaDiplomaDto {
    professionId!: string | undefined;
    typeId!: string | undefined;
    placeOfIssue!: string | undefined;
    countryOfIssueId!: string | undefined;
    dateOfIssue!: DateTime;
    dateOfRecognition!: DateTime | undefined;

    constructor(data?: IAlaDiplomaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professionId = _data["professionId"];
            this.typeId = _data["typeId"];
            this.placeOfIssue = _data["placeOfIssue"];
            this.countryOfIssueId = _data["countryOfIssueId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfRecognition = _data["dateOfRecognition"] ? DateTime.fromISO(_data["dateOfRecognition"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AlaDiplomaDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlaDiplomaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professionId"] = this.professionId;
        data["typeId"] = this.typeId;
        data["placeOfIssue"] = this.placeOfIssue;
        data["countryOfIssueId"] = this.countryOfIssueId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfRecognition"] = this.dateOfRecognition ? this.dateOfRecognition.toFormat('yyyy-MM-dd') : <any>undefined;
        return data;
    }
}

export interface IAlaDiplomaDto {
    professionId: string | undefined;
    typeId: string | undefined;
    placeOfIssue: string | undefined;
    countryOfIssueId: string | undefined;
    dateOfIssue: DateTime;
    dateOfRecognition: DateTime | undefined;
}

export class AlaDocumentsOutput implements IAlaDocumentsOutput {
    caseId!: string;
    documents!: GeneralDocumentGroupDto[];

    constructor(data?: IAlaDocumentsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.documents = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AlaDocumentsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new AlaDocumentsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAlaDocumentsOutput {
    caseId: string;
    documents: GeneralDocumentGroupDto[];
}

export class AlaDto implements IAlaDto {
    application!: ApplicationDto;
    professionId!: string | undefined;
    sponsorshipTypeId!: string | undefined;
    currentStep!: AlaStatus;
    statusId!: AlaStatus;
    applicantPerson!: AlaApplicantPersonDto;
    applicantSponsorship!: AlaApplicantSponsorshipDto;
    medicalFieldDirector!: AlaMedicalFieldDirectorDto;
    person!: AlaPersonDto;
    contact!: AlaContactDto;
    diploma!: AlaDiplomaDto;
    currentAssistants!: AlaCurrentAssistantDto[] | undefined;
    academicTitles!: AlaAcademicTitlesOutput;
    previousEmployments!: AlaPreviousEmploymentDto[] | undefined;
    languageSkill!: AlaLanguageSkillDto;
    postgraduateTitles!: AlaPostgraduateTitleDto[] | undefined;
    business!: AlaBusinessDto;
    employment!: AlaEmploymentDto;
    invoiceAddress!: AlaInvoiceAddressDto;
    documents!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: IAlaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationDto.fromJS(_data["application"]) : <any>undefined;
            this.professionId = _data["professionId"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.currentStep = _data["currentStep"];
            this.statusId = _data["statusId"];
            this.applicantPerson = _data["applicantPerson"] ? AlaApplicantPersonDto.fromJS(_data["applicantPerson"]) : <any>undefined;
            this.applicantSponsorship = _data["applicantSponsorship"] ? AlaApplicantSponsorshipDto.fromJS(_data["applicantSponsorship"]) : <any>undefined;
            this.medicalFieldDirector = _data["medicalFieldDirector"] ? AlaMedicalFieldDirectorDto.fromJS(_data["medicalFieldDirector"]) : <any>undefined;
            this.person = _data["person"] ? AlaPersonDto.fromJS(_data["person"]) : <any>undefined;
            this.contact = _data["contact"] ? AlaContactDto.fromJS(_data["contact"]) : <any>undefined;
            this.diploma = _data["diploma"] ? AlaDiplomaDto.fromJS(_data["diploma"]) : <any>undefined;
            if (Array.isArray(_data["currentAssistants"])) {
                this.currentAssistants = [] as any;
                for (let item of _data["currentAssistants"])
                    this.currentAssistants!.push(AlaCurrentAssistantDto.fromJS(item));
            }
            this.academicTitles = _data["academicTitles"] ? AlaAcademicTitlesOutput.fromJS(_data["academicTitles"]) : <any>undefined;
            if (Array.isArray(_data["previousEmployments"])) {
                this.previousEmployments = [] as any;
                for (let item of _data["previousEmployments"])
                    this.previousEmployments!.push(AlaPreviousEmploymentDto.fromJS(item));
            }
            this.languageSkill = _data["languageSkill"] ? AlaLanguageSkillDto.fromJS(_data["languageSkill"]) : <any>undefined;
            if (Array.isArray(_data["postgraduateTitles"])) {
                this.postgraduateTitles = [] as any;
                for (let item of _data["postgraduateTitles"])
                    this.postgraduateTitles!.push(AlaPostgraduateTitleDto.fromJS(item));
            }
            this.business = _data["business"] ? AlaBusinessDto.fromJS(_data["business"]) : <any>undefined;
            this.employment = _data["employment"] ? AlaEmploymentDto.fromJS(_data["employment"]) : <any>undefined;
            this.invoiceAddress = _data["invoiceAddress"] ? AlaInvoiceAddressDto.fromJS(_data["invoiceAddress"]) : <any>undefined;
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AlaDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["professionId"] = this.professionId;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["currentStep"] = this.currentStep;
        data["statusId"] = this.statusId;
        data["applicantPerson"] = this.applicantPerson ? this.applicantPerson.toJSON() : <any>undefined;
        data["applicantSponsorship"] = this.applicantSponsorship ? this.applicantSponsorship.toJSON() : <any>undefined;
        data["medicalFieldDirector"] = this.medicalFieldDirector ? this.medicalFieldDirector.toJSON() : <any>undefined;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["diploma"] = this.diploma ? this.diploma.toJSON() : <any>undefined;
        if (Array.isArray(this.currentAssistants)) {
            data["currentAssistants"] = [];
            for (let item of this.currentAssistants)
                data["currentAssistants"].push(item.toJSON());
        }
        data["academicTitles"] = this.academicTitles ? this.academicTitles.toJSON() : <any>undefined;
        if (Array.isArray(this.previousEmployments)) {
            data["previousEmployments"] = [];
            for (let item of this.previousEmployments)
                data["previousEmployments"].push(item.toJSON());
        }
        data["languageSkill"] = this.languageSkill ? this.languageSkill.toJSON() : <any>undefined;
        if (Array.isArray(this.postgraduateTitles)) {
            data["postgraduateTitles"] = [];
            for (let item of this.postgraduateTitles)
                data["postgraduateTitles"].push(item.toJSON());
        }
        data["business"] = this.business ? this.business.toJSON() : <any>undefined;
        data["employment"] = this.employment ? this.employment.toJSON() : <any>undefined;
        data["invoiceAddress"] = this.invoiceAddress ? this.invoiceAddress.toJSON() : <any>undefined;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAlaDto {
    application: ApplicationDto;
    professionId: string | undefined;
    sponsorshipTypeId: string | undefined;
    currentStep: AlaStatus;
    statusId: AlaStatus;
    applicantPerson: AlaApplicantPersonDto;
    applicantSponsorship: AlaApplicantSponsorshipDto;
    medicalFieldDirector: AlaMedicalFieldDirectorDto;
    person: AlaPersonDto;
    contact: AlaContactDto;
    diploma: AlaDiplomaDto;
    currentAssistants: AlaCurrentAssistantDto[] | undefined;
    academicTitles: AlaAcademicTitlesOutput;
    previousEmployments: AlaPreviousEmploymentDto[] | undefined;
    languageSkill: AlaLanguageSkillDto;
    postgraduateTitles: AlaPostgraduateTitleDto[] | undefined;
    business: AlaBusinessDto;
    employment: AlaEmploymentDto;
    invoiceAddress: AlaInvoiceAddressDto;
    documents: GeneralDocumentGroupDto[] | undefined;
}

export class AlaEmploymentDto implements IAlaEmploymentDto {
    levelOfEmployment!: number | undefined;
    dateOfEmployment!: DateTime | undefined;
    dateOfEndOfEmployment!: DateTime | undefined;
    typeOfEmploymentId!: string | undefined;
    additionalEmployments!: string | undefined;
    performsVaccinationsId!: string | undefined;
    documents!: GeneralDocumentGroupDto[] | undefined;
    id!: number;

    constructor(data?: IAlaEmploymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.dateOfEmployment = _data["dateOfEmployment"] ? DateTime.fromISO(_data["dateOfEmployment"].toString()) : <any>undefined;
            this.dateOfEndOfEmployment = _data["dateOfEndOfEmployment"] ? DateTime.fromISO(_data["dateOfEndOfEmployment"].toString()) : <any>undefined;
            this.typeOfEmploymentId = _data["typeOfEmploymentId"];
            this.additionalEmployments = _data["additionalEmployments"];
            this.performsVaccinationsId = _data["performsVaccinationsId"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralDocumentGroupDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AlaEmploymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlaEmploymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["dateOfEmployment"] = this.dateOfEmployment ? this.dateOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEndOfEmployment"] = this.dateOfEndOfEmployment ? this.dateOfEndOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["typeOfEmploymentId"] = this.typeOfEmploymentId;
        data["additionalEmployments"] = this.additionalEmployments;
        data["performsVaccinationsId"] = this.performsVaccinationsId;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IAlaEmploymentDto {
    levelOfEmployment: number | undefined;
    dateOfEmployment: DateTime | undefined;
    dateOfEndOfEmployment: DateTime | undefined;
    typeOfEmploymentId: string | undefined;
    additionalEmployments: string | undefined;
    performsVaccinationsId: string | undefined;
    documents: GeneralDocumentGroupDto[] | undefined;
    id: number;
}

export class AlaInvoiceAddressDto implements IAlaInvoiceAddressDto {
    id!: number | undefined;
    name!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string | undefined;
    email!: string | undefined;

    constructor(data?: IAlaInvoiceAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): AlaInvoiceAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlaInvoiceAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["email"] = this.email;
        return data;
    }
}

export interface IAlaInvoiceAddressDto {
    id: number | undefined;
    name: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string | undefined;
    email: string | undefined;
}

export class AlaLanguageSkillDto implements IAlaLanguageSkillDto {
    hasLanguageSkillId!: string;
    documents!: GeneralDocumentGroupDto[] | undefined;
    hasLanguageRecordInExternalRegister!: boolean;

    constructor(data?: IAlaLanguageSkillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasLanguageSkillId = _data["hasLanguageSkillId"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralDocumentGroupDto.fromJS(item));
            }
            this.hasLanguageRecordInExternalRegister = _data["hasLanguageRecordInExternalRegister"];
        }
    }

    static fromJS(data: any): AlaLanguageSkillDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlaLanguageSkillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasLanguageSkillId"] = this.hasLanguageSkillId;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["hasLanguageRecordInExternalRegister"] = this.hasLanguageRecordInExternalRegister;
        return data;
    }
}

export interface IAlaLanguageSkillDto {
    hasLanguageSkillId: string;
    documents: GeneralDocumentGroupDto[] | undefined;
    hasLanguageRecordInExternalRegister: boolean;
}

export class AlaMedicalFieldDirectorDto implements IAlaMedicalFieldDirectorDto {
    firstName!: string;
    lastName!: string;
    gln!: string;
    licenceTypeId!: string | undefined;
    licenceCantonId!: string | undefined;
    licenceStatusId!: string | undefined;
    activityStatusId!: string | undefined;

    constructor(data?: IAlaMedicalFieldDirectorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.gln = _data["gln"];
            this.licenceTypeId = _data["licenceTypeId"];
            this.licenceCantonId = _data["licenceCantonId"];
            this.licenceStatusId = _data["licenceStatusId"];
            this.activityStatusId = _data["activityStatusId"];
        }
    }

    static fromJS(data: any): AlaMedicalFieldDirectorDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlaMedicalFieldDirectorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["gln"] = this.gln;
        data["licenceTypeId"] = this.licenceTypeId;
        data["licenceCantonId"] = this.licenceCantonId;
        data["licenceStatusId"] = this.licenceStatusId;
        data["activityStatusId"] = this.activityStatusId;
        return data;
    }
}

export interface IAlaMedicalFieldDirectorDto {
    firstName: string;
    lastName: string;
    gln: string;
    licenceTypeId: string | undefined;
    licenceCantonId: string | undefined;
    licenceStatusId: string | undefined;
    activityStatusId: string | undefined;
}

export class AlaPersonDto implements IAlaPersonDto {
    firstName!: string;
    lastName!: string;
    gln!: string | undefined;
    dateOfBirth!: DateTime;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    documents!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: IAlaPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.gln = _data["gln"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AlaPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlaPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["gln"] = this.gln;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAlaPersonDto {
    firstName: string;
    lastName: string;
    gln: string | undefined;
    dateOfBirth: DateTime;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    documents: GeneralDocumentGroupDto[] | undefined;
}

export class AlaPostgraduateTitleDto implements IAlaPostgraduateTitleDto {
    id!: number | undefined;
    isInEducationId!: string;
    postgraduateTitleId!: string | undefined;
    placeOfEducation!: string | undefined;
    medicalFieldDirectorName!: string | undefined;

    constructor(data?: IAlaPostgraduateTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isInEducationId = _data["isInEducationId"];
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.placeOfEducation = _data["placeOfEducation"];
            this.medicalFieldDirectorName = _data["medicalFieldDirectorName"];
        }
    }

    static fromJS(data: any): AlaPostgraduateTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlaPostgraduateTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isInEducationId"] = this.isInEducationId;
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["placeOfEducation"] = this.placeOfEducation;
        data["medicalFieldDirectorName"] = this.medicalFieldDirectorName;
        return data;
    }
}

export interface IAlaPostgraduateTitleDto {
    id: number | undefined;
    isInEducationId: string;
    postgraduateTitleId: string | undefined;
    placeOfEducation: string | undefined;
    medicalFieldDirectorName: string | undefined;
}

export class AlaPreviousEmploymentDto implements IAlaPreviousEmploymentDto {
    id!: number | undefined;
    businessName!: string | undefined;
    levelOfEmployment!: number | undefined;
    dateOfEmployment!: DateTime;
    dateOfEndOfEmployment!: DateTime | undefined;
    levelOfResponsibilityId!: string | undefined;
    role!: string | undefined;
    hasLicenceInAnotherCantonOrCountryId!: string | undefined;
    wasLicenceInAnotherPlaceRejectedId!: string | undefined;
    rejectionRemarks!: string | undefined;
    hasOpenProceedingsRelatedToProfessionalActivityId!: string | undefined;
    openProceedingsRemark!: string | undefined;

    constructor(data?: IAlaPreviousEmploymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.businessName = _data["businessName"];
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.dateOfEmployment = _data["dateOfEmployment"] ? DateTime.fromISO(_data["dateOfEmployment"].toString()) : <any>undefined;
            this.dateOfEndOfEmployment = _data["dateOfEndOfEmployment"] ? DateTime.fromISO(_data["dateOfEndOfEmployment"].toString()) : <any>undefined;
            this.levelOfResponsibilityId = _data["levelOfResponsibilityId"];
            this.role = _data["role"];
            this.hasLicenceInAnotherCantonOrCountryId = _data["hasLicenceInAnotherCantonOrCountryId"];
            this.wasLicenceInAnotherPlaceRejectedId = _data["wasLicenceInAnotherPlaceRejectedId"];
            this.rejectionRemarks = _data["rejectionRemarks"];
            this.hasOpenProceedingsRelatedToProfessionalActivityId = _data["hasOpenProceedingsRelatedToProfessionalActivityId"];
            this.openProceedingsRemark = _data["openProceedingsRemark"];
        }
    }

    static fromJS(data: any): AlaPreviousEmploymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlaPreviousEmploymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["businessName"] = this.businessName;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["dateOfEmployment"] = this.dateOfEmployment ? this.dateOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEndOfEmployment"] = this.dateOfEndOfEmployment ? this.dateOfEndOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfResponsibilityId"] = this.levelOfResponsibilityId;
        data["role"] = this.role;
        data["hasLicenceInAnotherCantonOrCountryId"] = this.hasLicenceInAnotherCantonOrCountryId;
        data["wasLicenceInAnotherPlaceRejectedId"] = this.wasLicenceInAnotherPlaceRejectedId;
        data["rejectionRemarks"] = this.rejectionRemarks;
        data["hasOpenProceedingsRelatedToProfessionalActivityId"] = this.hasOpenProceedingsRelatedToProfessionalActivityId;
        data["openProceedingsRemark"] = this.openProceedingsRemark;
        return data;
    }
}

export interface IAlaPreviousEmploymentDto {
    id: number | undefined;
    businessName: string | undefined;
    levelOfEmployment: number | undefined;
    dateOfEmployment: DateTime;
    dateOfEndOfEmployment: DateTime | undefined;
    levelOfResponsibilityId: string | undefined;
    role: string | undefined;
    hasLicenceInAnotherCantonOrCountryId: string | undefined;
    wasLicenceInAnotherPlaceRejectedId: string | undefined;
    rejectionRemarks: string | undefined;
    hasOpenProceedingsRelatedToProfessionalActivityId: string | undefined;
    openProceedingsRemark: string | undefined;
}

export enum AlaStatus {
    ApplicantPerson = 0,
    ApplicantSponsorship = 1,
    MedicalFieldDirector = 2,
    Person = 3,
    Contact = 4,
    Diploma = 5,
    AcademicTitle = 6,
    LanguageSkill = 7,
    PostgraduateTitle = 8,
    Business = 9,
    Employment = 10,
    PreviousEmployment = 11,
    Trustworthiness = 12,
    CurrentAssistants = 13,
    InvoiceAddress = 14,
    Release = 97,
    Released = 98,
    FinishReview = 99,
}

export class CreateAlaInput implements ICreateAlaInput {
    applicationTypeId!: ApplicationType;
    professionId!: string | undefined;
    sponsorshipTypeId!: string | undefined;

    constructor(data?: ICreateAlaInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationTypeId = _data["applicationTypeId"];
            this.professionId = _data["professionId"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
        }
    }

    static fromJS(data: any): CreateAlaInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAlaInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationTypeId"] = this.applicationTypeId;
        data["professionId"] = this.professionId;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        return data;
    }
}

export interface ICreateAlaInput {
    applicationTypeId: ApplicationType;
    professionId: string | undefined;
    sponsorshipTypeId: string | undefined;
}

export class CreateAlaOutput implements ICreateAlaOutput {
    caseId!: string | undefined;

    constructor(data?: ICreateAlaOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
        }
    }

    static fromJS(data: any): CreateAlaOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAlaOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        return data;
    }
}

export interface ICreateAlaOutput {
    caseId: string | undefined;
}

export class CreateOrUpdateAlaAcademicTitleInput implements ICreateOrUpdateAlaAcademicTitleInput {
    caseId!: string;
    academicTitles!: AlaAcademicTitleDto[];

    constructor(data?: ICreateOrUpdateAlaAcademicTitleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.academicTitles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["academicTitles"])) {
                this.academicTitles = [] as any;
                for (let item of _data["academicTitles"])
                    this.academicTitles!.push(AlaAcademicTitleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateAlaAcademicTitleInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAlaAcademicTitleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.academicTitles)) {
            data["academicTitles"] = [];
            for (let item of this.academicTitles)
                data["academicTitles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateAlaAcademicTitleInput {
    caseId: string;
    academicTitles: AlaAcademicTitleDto[];
}

export class CreateOrUpdateAlaAcademicTitleOutput implements ICreateOrUpdateAlaAcademicTitleOutput {
    status!: AlaStatus;
    academicTitles!: AlaAcademicTitleDto[] | undefined;

    constructor(data?: ICreateOrUpdateAlaAcademicTitleOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["academicTitles"])) {
                this.academicTitles = [] as any;
                for (let item of _data["academicTitles"])
                    this.academicTitles!.push(AlaAcademicTitleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateAlaAcademicTitleOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAlaAcademicTitleOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.academicTitles)) {
            data["academicTitles"] = [];
            for (let item of this.academicTitles)
                data["academicTitles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateAlaAcademicTitleOutput {
    status: AlaStatus;
    academicTitles: AlaAcademicTitleDto[] | undefined;
}

export class CreateOrUpdateAlaApplicantPerson implements ICreateOrUpdateAlaApplicantPerson {
    caseId!: string;
    applicantPerson!: AlaApplicantPersonDto;

    constructor(data?: ICreateOrUpdateAlaApplicantPerson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.applicantPerson = new AlaApplicantPersonDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.applicantPerson = _data["applicantPerson"] ? AlaApplicantPersonDto.fromJS(_data["applicantPerson"]) : new AlaApplicantPersonDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateAlaApplicantPerson {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAlaApplicantPerson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["applicantPerson"] = this.applicantPerson ? this.applicantPerson.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateAlaApplicantPerson {
    caseId: string;
    applicantPerson: AlaApplicantPersonDto;
}

export class CreateOrUpdateAlaApplicantSponsorship implements ICreateOrUpdateAlaApplicantSponsorship {
    caseId!: string;
    applicantSponsorship!: AlaApplicantSponsorshipDto;

    constructor(data?: ICreateOrUpdateAlaApplicantSponsorship) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.applicantSponsorship = new AlaApplicantSponsorshipDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.applicantSponsorship = _data["applicantSponsorship"] ? AlaApplicantSponsorshipDto.fromJS(_data["applicantSponsorship"]) : new AlaApplicantSponsorshipDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateAlaApplicantSponsorship {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAlaApplicantSponsorship();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["applicantSponsorship"] = this.applicantSponsorship ? this.applicantSponsorship.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateAlaApplicantSponsorship {
    caseId: string;
    applicantSponsorship: AlaApplicantSponsorshipDto;
}

export class CreateOrUpdateAlaContact implements ICreateOrUpdateAlaContact {
    caseId!: string;
    contact!: AlaContactDto;

    constructor(data?: ICreateOrUpdateAlaContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.contact = new AlaContactDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.contact = _data["contact"] ? AlaContactDto.fromJS(_data["contact"]) : new AlaContactDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateAlaContact {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAlaContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateAlaContact {
    caseId: string;
    contact: AlaContactDto;
}

export class CreateOrUpdateAlaCurrentAssistantsInput implements ICreateOrUpdateAlaCurrentAssistantsInput {
    currentAssistants!: AlaCurrentAssistantDto[] | undefined;

    constructor(data?: ICreateOrUpdateAlaCurrentAssistantsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["currentAssistants"])) {
                this.currentAssistants = [] as any;
                for (let item of _data["currentAssistants"])
                    this.currentAssistants!.push(AlaCurrentAssistantDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateAlaCurrentAssistantsInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAlaCurrentAssistantsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.currentAssistants)) {
            data["currentAssistants"] = [];
            for (let item of this.currentAssistants)
                data["currentAssistants"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateAlaCurrentAssistantsInput {
    currentAssistants: AlaCurrentAssistantDto[] | undefined;
}

export class CreateOrUpdateAlaDiploma implements ICreateOrUpdateAlaDiploma {
    caseId!: string;
    diploma!: AlaDiplomaDto;

    constructor(data?: ICreateOrUpdateAlaDiploma) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.diploma = new AlaDiplomaDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.diploma = _data["diploma"] ? AlaDiplomaDto.fromJS(_data["diploma"]) : new AlaDiplomaDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateAlaDiploma {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAlaDiploma();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["diploma"] = this.diploma ? this.diploma.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateAlaDiploma {
    caseId: string;
    diploma: AlaDiplomaDto;
}

export class CreateOrUpdateAlaLanguageSkillInput implements ICreateOrUpdateAlaLanguageSkillInput {
    caseId!: string;
    languageSkill!: AlaLanguageSkillDto;

    constructor(data?: ICreateOrUpdateAlaLanguageSkillInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.languageSkill = new AlaLanguageSkillDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.languageSkill = _data["languageSkill"] ? AlaLanguageSkillDto.fromJS(_data["languageSkill"]) : new AlaLanguageSkillDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateAlaLanguageSkillInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAlaLanguageSkillInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["languageSkill"] = this.languageSkill ? this.languageSkill.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateAlaLanguageSkillInput {
    caseId: string;
    languageSkill: AlaLanguageSkillDto;
}

export class CreateOrUpdateAlaMedicalFieldDirector implements ICreateOrUpdateAlaMedicalFieldDirector {
    caseId!: string;
    medicalFieldDirector!: AlaMedicalFieldDirectorDto;

    constructor(data?: ICreateOrUpdateAlaMedicalFieldDirector) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.medicalFieldDirector = new AlaMedicalFieldDirectorDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.medicalFieldDirector = _data["medicalFieldDirector"] ? AlaMedicalFieldDirectorDto.fromJS(_data["medicalFieldDirector"]) : new AlaMedicalFieldDirectorDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateAlaMedicalFieldDirector {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAlaMedicalFieldDirector();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["medicalFieldDirector"] = this.medicalFieldDirector ? this.medicalFieldDirector.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateAlaMedicalFieldDirector {
    caseId: string;
    medicalFieldDirector: AlaMedicalFieldDirectorDto;
}

export class CreateOrUpdateAlaPerson implements ICreateOrUpdateAlaPerson {
    caseId!: string;
    person!: AlaPersonDto;

    constructor(data?: ICreateOrUpdateAlaPerson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.person = new AlaPersonDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.person = _data["person"] ? AlaPersonDto.fromJS(_data["person"]) : new AlaPersonDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateAlaPerson {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAlaPerson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateAlaPerson {
    caseId: string;
    person: AlaPersonDto;
}

export class CreateOrUpdateAlaPostgraduateTitleInput implements ICreateOrUpdateAlaPostgraduateTitleInput {
    caseId!: string;
    postgraduateTitles!: AlaPostgraduateTitleDto[];

    constructor(data?: ICreateOrUpdateAlaPostgraduateTitleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.postgraduateTitles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["postgraduateTitles"])) {
                this.postgraduateTitles = [] as any;
                for (let item of _data["postgraduateTitles"])
                    this.postgraduateTitles!.push(AlaPostgraduateTitleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateAlaPostgraduateTitleInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAlaPostgraduateTitleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.postgraduateTitles)) {
            data["postgraduateTitles"] = [];
            for (let item of this.postgraduateTitles)
                data["postgraduateTitles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateAlaPostgraduateTitleInput {
    caseId: string;
    postgraduateTitles: AlaPostgraduateTitleDto[];
}

export class CreateOrUpdateAlaPostgraduateTitleOutput implements ICreateOrUpdateAlaPostgraduateTitleOutput {
    status!: AlaStatus;
    postgraduateTitles!: AlaPostgraduateTitleDto[] | undefined;

    constructor(data?: ICreateOrUpdateAlaPostgraduateTitleOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["postgraduateTitles"])) {
                this.postgraduateTitles = [] as any;
                for (let item of _data["postgraduateTitles"])
                    this.postgraduateTitles!.push(AlaPostgraduateTitleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateAlaPostgraduateTitleOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAlaPostgraduateTitleOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.postgraduateTitles)) {
            data["postgraduateTitles"] = [];
            for (let item of this.postgraduateTitles)
                data["postgraduateTitles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateAlaPostgraduateTitleOutput {
    status: AlaStatus;
    postgraduateTitles: AlaPostgraduateTitleDto[] | undefined;
}

export class CreateOrUpdateAlaPreviousEmploymentInput implements ICreateOrUpdateAlaPreviousEmploymentInput {
    previousEmployments!: AlaPreviousEmploymentDto[] | undefined;

    constructor(data?: ICreateOrUpdateAlaPreviousEmploymentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["previousEmployments"])) {
                this.previousEmployments = [] as any;
                for (let item of _data["previousEmployments"])
                    this.previousEmployments!.push(AlaPreviousEmploymentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateAlaPreviousEmploymentInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAlaPreviousEmploymentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.previousEmployments)) {
            data["previousEmployments"] = [];
            for (let item of this.previousEmployments)
                data["previousEmployments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateAlaPreviousEmploymentInput {
    previousEmployments: AlaPreviousEmploymentDto[] | undefined;
}

export class GetAlaDocumentsInput implements IGetAlaDocumentsInput {
    caseId!: string;
    step!: AlaStatus;

    constructor(data?: IGetAlaDocumentsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.step = _data["step"];
        }
    }

    static fromJS(data: any): GetAlaDocumentsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAlaDocumentsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["step"] = this.step;
        return data;
    }
}

export interface IGetAlaDocumentsInput {
    caseId: string;
    step: AlaStatus;
}

export class GetAlaFileInput implements IGetAlaFileInput {
    caseId!: string;
    step!: AlaStatus;
    id!: number;

    constructor(data?: IGetAlaFileInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.step = _data["step"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetAlaFileInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAlaFileInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["step"] = this.step;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetAlaFileInput {
    caseId: string;
    step: AlaStatus;
    id: number;
}

export class GetAlaOutput implements IGetAlaOutput {
    ala!: AlaDto;

    constructor(data?: IGetAlaOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ala = _data["ala"] ? AlaDto.fromJS(_data["ala"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAlaOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAlaOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ala"] = this.ala ? this.ala.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetAlaOutput {
    ala: AlaDto;
}

export class AuditLogListDto implements IAuditLogListDto {
    userId!: number | undefined;
    userName!: string | undefined;
    impersonatorTenantId!: number | undefined;
    impersonatorUserId!: number | undefined;
    serviceName!: string | undefined;
    methodName!: string | undefined;
    parameters!: string | undefined;
    executionTime!: DateTime;
    executionDuration!: number;
    clientIpAddress!: string | undefined;
    clientName!: string | undefined;
    browserInfo!: string | undefined;
    exception!: string | undefined;
    customData!: string | undefined;
    id!: number;

    constructor(data?: IAuditLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.impersonatorTenantId = _data["impersonatorTenantId"];
            this.impersonatorUserId = _data["impersonatorUserId"];
            this.serviceName = _data["serviceName"];
            this.methodName = _data["methodName"];
            this.parameters = _data["parameters"];
            this.executionTime = _data["executionTime"] ? DateTime.fromISO(_data["executionTime"].toString()) : <any>undefined;
            this.executionDuration = _data["executionDuration"];
            this.clientIpAddress = _data["clientIpAddress"];
            this.clientName = _data["clientName"];
            this.browserInfo = _data["browserInfo"];
            this.exception = _data["exception"];
            this.customData = _data["customData"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AuditLogListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["impersonatorTenantId"] = this.impersonatorTenantId;
        data["impersonatorUserId"] = this.impersonatorUserId;
        data["serviceName"] = this.serviceName;
        data["methodName"] = this.methodName;
        data["parameters"] = this.parameters;
        data["executionTime"] = this.executionTime ? this.executionTime.toString() : <any>undefined;
        data["executionDuration"] = this.executionDuration;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["exception"] = this.exception;
        data["customData"] = this.customData;
        data["id"] = this.id;
        return data;
    }
}

export interface IAuditLogListDto {
    userId: number | undefined;
    userName: string | undefined;
    impersonatorTenantId: number | undefined;
    impersonatorUserId: number | undefined;
    serviceName: string | undefined;
    methodName: string | undefined;
    parameters: string | undefined;
    executionTime: DateTime;
    executionDuration: number;
    clientIpAddress: string | undefined;
    clientName: string | undefined;
    browserInfo: string | undefined;
    exception: string | undefined;
    customData: string | undefined;
    id: number;
}

export class EntityChangeListDto implements IEntityChangeListDto {
    userId!: number | undefined;
    userName!: string | undefined;
    changeTime!: DateTime;
    entityTypeFullName!: string | undefined;
    entityId!: string | undefined;
    changeType!: EntityChangeType;
    readonly changeTypeName!: string | undefined;
    entityChangeSetId!: number;
    id!: number;

    constructor(data?: IEntityChangeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.changeTime = _data["changeTime"] ? DateTime.fromISO(_data["changeTime"].toString()) : <any>undefined;
            this.entityTypeFullName = _data["entityTypeFullName"];
            this.entityId = _data["entityId"];
            this.changeType = _data["changeType"];
            (<any>this).changeTypeName = _data["changeTypeName"];
            this.entityChangeSetId = _data["entityChangeSetId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityChangeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityChangeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["changeTime"] = this.changeTime ? this.changeTime.toString() : <any>undefined;
        data["entityTypeFullName"] = this.entityTypeFullName;
        data["entityId"] = this.entityId;
        data["changeType"] = this.changeType;
        data["changeTypeName"] = this.changeTypeName;
        data["entityChangeSetId"] = this.entityChangeSetId;
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityChangeListDto {
    userId: number | undefined;
    userName: string | undefined;
    changeTime: DateTime;
    entityTypeFullName: string | undefined;
    entityId: string | undefined;
    changeType: EntityChangeType;
    changeTypeName: string | undefined;
    entityChangeSetId: number;
    id: number;
}

export class EntityPropertyChangeDto implements IEntityPropertyChangeDto {
    entityChangeId!: number;
    newValue!: string | undefined;
    originalValue!: string | undefined;
    propertyName!: string | undefined;
    propertyTypeFullName!: string | undefined;
    tenantId!: number | undefined;
    id!: number;

    constructor(data?: IEntityPropertyChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityChangeId = _data["entityChangeId"];
            this.newValue = _data["newValue"];
            this.originalValue = _data["originalValue"];
            this.propertyName = _data["propertyName"];
            this.propertyTypeFullName = _data["propertyTypeFullName"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityPropertyChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityPropertyChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityChangeId"] = this.entityChangeId;
        data["newValue"] = this.newValue;
        data["originalValue"] = this.originalValue;
        data["propertyName"] = this.propertyName;
        data["propertyTypeFullName"] = this.propertyTypeFullName;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityPropertyChangeDto {
    entityChangeId: number;
    newValue: string | undefined;
    originalValue: string | undefined;
    propertyName: string | undefined;
    propertyTypeFullName: string | undefined;
    tenantId: number | undefined;
    id: number;
}

export class FacebookExternalLoginProviderSettings implements IFacebookExternalLoginProviderSettings {
    appId!: string | undefined;
    appSecret!: string | undefined;

    constructor(data?: IFacebookExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appId = _data["appId"];
            this.appSecret = _data["appSecret"];
        }
    }

    static fromJS(data: any): FacebookExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new FacebookExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appId"] = this.appId;
        data["appSecret"] = this.appSecret;
        return data;
    }
}

export interface IFacebookExternalLoginProviderSettings {
    appId: string | undefined;
    appSecret: string | undefined;
}

export class GoogleExternalLoginProviderSettings implements IGoogleExternalLoginProviderSettings {
    clientId!: string | undefined;
    clientSecret!: string | undefined;
    userInfoEndpoint!: string | undefined;

    constructor(data?: IGoogleExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
            this.userInfoEndpoint = _data["userInfoEndpoint"];
        }
    }

    static fromJS(data: any): GoogleExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new GoogleExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        data["userInfoEndpoint"] = this.userInfoEndpoint;
        return data;
    }
}

export interface IGoogleExternalLoginProviderSettings {
    clientId: string | undefined;
    clientSecret: string | undefined;
    userInfoEndpoint: string | undefined;
}

export class JsonAutoLoginInfoDto implements IJsonAutoLoginInfoDto {
    idpHint!: string | undefined;
    value!: string | undefined;

    constructor(data?: IJsonAutoLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idpHint = _data["idpHint"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): JsonAutoLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new JsonAutoLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idpHint"] = this.idpHint;
        data["value"] = this.value;
        return data;
    }
}

export interface IJsonAutoLoginInfoDto {
    idpHint: string | undefined;
    value: string | undefined;
}

export class JsonClaimMapDto implements IJsonClaimMapDto {
    claim!: string | undefined;
    key!: string | undefined;

    constructor(data?: IJsonClaimMapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.claim = _data["claim"];
            this.key = _data["key"];
        }
    }

    static fromJS(data: any): JsonClaimMapDto {
        data = typeof data === 'object' ? data : {};
        let result = new JsonClaimMapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["claim"] = this.claim;
        data["key"] = this.key;
        return data;
    }
}

export interface IJsonClaimMapDto {
    claim: string | undefined;
    key: string | undefined;
}

export class MicrosoftExternalLoginProviderSettings implements IMicrosoftExternalLoginProviderSettings {
    clientId!: string | undefined;
    clientSecret!: string | undefined;

    constructor(data?: IMicrosoftExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
        }
    }

    static fromJS(data: any): MicrosoftExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new MicrosoftExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        return data;
    }
}

export interface IMicrosoftExternalLoginProviderSettings {
    clientId: string | undefined;
    clientSecret: string | undefined;
}

export class OpenIdConnectExternalLoginProviderSettings implements IOpenIdConnectExternalLoginProviderSettings {
    clientId!: string | undefined;
    clientSecret!: string | undefined;
    authority!: string | undefined;
    tokenEndpoint!: string | undefined;
    loginUrl!: string | undefined;
    validateIssuer!: boolean;
    responseType!: string | undefined;
    useAccessTokenForClaims!: boolean;
    discoveryDocUrl!: string | undefined;
    providerKeyClaim!: string | undefined;
    audClaimForVerification!: string | undefined;
    issuerInDiscoveryDoc!: string | undefined;
    scopes!: string | undefined;

    constructor(data?: IOpenIdConnectExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
            this.authority = _data["authority"];
            this.tokenEndpoint = _data["tokenEndpoint"];
            this.loginUrl = _data["loginUrl"];
            this.validateIssuer = _data["validateIssuer"];
            this.responseType = _data["responseType"];
            this.useAccessTokenForClaims = _data["useAccessTokenForClaims"];
            this.discoveryDocUrl = _data["discoveryDocUrl"];
            this.providerKeyClaim = _data["providerKeyClaim"];
            this.audClaimForVerification = _data["audClaimForVerification"];
            this.issuerInDiscoveryDoc = _data["issuerInDiscoveryDoc"];
            this.scopes = _data["scopes"];
        }
    }

    static fromJS(data: any): OpenIdConnectExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new OpenIdConnectExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        data["authority"] = this.authority;
        data["tokenEndpoint"] = this.tokenEndpoint;
        data["loginUrl"] = this.loginUrl;
        data["validateIssuer"] = this.validateIssuer;
        data["responseType"] = this.responseType;
        data["useAccessTokenForClaims"] = this.useAccessTokenForClaims;
        data["discoveryDocUrl"] = this.discoveryDocUrl;
        data["providerKeyClaim"] = this.providerKeyClaim;
        data["audClaimForVerification"] = this.audClaimForVerification;
        data["issuerInDiscoveryDoc"] = this.issuerInDiscoveryDoc;
        data["scopes"] = this.scopes;
        return data;
    }
}

export interface IOpenIdConnectExternalLoginProviderSettings {
    clientId: string | undefined;
    clientSecret: string | undefined;
    authority: string | undefined;
    tokenEndpoint: string | undefined;
    loginUrl: string | undefined;
    validateIssuer: boolean;
    responseType: string | undefined;
    useAccessTokenForClaims: boolean;
    discoveryDocUrl: string | undefined;
    providerKeyClaim: string | undefined;
    audClaimForVerification: string | undefined;
    issuerInDiscoveryDoc: string | undefined;
    scopes: string | undefined;
}

export class TwitterExternalLoginProviderSettings implements ITwitterExternalLoginProviderSettings {
    consumerKey!: string | undefined;
    consumerSecret!: string | undefined;

    constructor(data?: ITwitterExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consumerKey = _data["consumerKey"];
            this.consumerSecret = _data["consumerSecret"];
        }
    }

    static fromJS(data: any): TwitterExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new TwitterExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consumerKey"] = this.consumerKey;
        data["consumerSecret"] = this.consumerSecret;
        return data;
    }
}

export interface ITwitterExternalLoginProviderSettings {
    consumerKey: string | undefined;
    consumerSecret: string | undefined;
}

export class WsFederationExternalLoginProviderSettings implements IWsFederationExternalLoginProviderSettings {
    clientId!: string | undefined;
    tenant!: string | undefined;
    metaDataAddress!: string | undefined;
    wtrealm!: string | undefined;
    authority!: string | undefined;

    constructor(data?: IWsFederationExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.tenant = _data["tenant"];
            this.metaDataAddress = _data["metaDataAddress"];
            this.wtrealm = _data["wtrealm"];
            this.authority = _data["authority"];
        }
    }

    static fromJS(data: any): WsFederationExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new WsFederationExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["tenant"] = this.tenant;
        data["metaDataAddress"] = this.metaDataAddress;
        data["wtrealm"] = this.wtrealm;
        data["authority"] = this.authority;
        return data;
    }
}

export interface IWsFederationExternalLoginProviderSettings {
    clientId: string | undefined;
    tenant: string | undefined;
    metaDataAddress: string | undefined;
    wtrealm: string | undefined;
    authority: string | undefined;
}

export class ActivateEmailInput implements IActivateEmailInput {
    userId!: number;
    confirmationCode!: string | undefined;
    c!: string | undefined;

    constructor(data?: IActivateEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.confirmationCode = _data["confirmationCode"];
            this.c = _data["c"];
        }
    }

    static fromJS(data: any): ActivateEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new ActivateEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["confirmationCode"] = this.confirmationCode;
        data["c"] = this.c;
        return data;
    }
}

export interface IActivateEmailInput {
    userId: number;
    confirmationCode: string | undefined;
    c: string | undefined;
}

export class DelegatedImpersonateInput implements IDelegatedImpersonateInput {
    userDelegationId!: number;

    constructor(data?: IDelegatedImpersonateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userDelegationId = _data["userDelegationId"];
        }
    }

    static fromJS(data: any): DelegatedImpersonateInput {
        data = typeof data === 'object' ? data : {};
        let result = new DelegatedImpersonateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDelegationId"] = this.userDelegationId;
        return data;
    }
}

export interface IDelegatedImpersonateInput {
    userDelegationId: number;
}

export class ImpersonateOutput implements IImpersonateOutput {
    impersonationToken!: string | undefined;
    tenancyName!: string | undefined;

    constructor(data?: IImpersonateOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.impersonationToken = _data["impersonationToken"];
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): ImpersonateOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonateOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["impersonationToken"] = this.impersonationToken;
        data["tenancyName"] = this.tenancyName;
        return data;
    }
}

export interface IImpersonateOutput {
    impersonationToken: string | undefined;
    tenancyName: string | undefined;
}

export class ImpersonateTenantInput implements IImpersonateTenantInput {
    tenantId!: number | undefined;
    userId!: number;

    constructor(data?: IImpersonateTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): ImpersonateTenantInput {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonateTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IImpersonateTenantInput {
    tenantId: number | undefined;
    userId: number;
}

export class ImpersonateUserInput implements IImpersonateUserInput {
    tenantId!: number | undefined;
    userId!: number;

    constructor(data?: IImpersonateUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): ImpersonateUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonateUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IImpersonateUserInput {
    tenantId: number | undefined;
    userId: number;
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName!: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data;
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string;
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state!: TenantAvailabilityState;
    tenantId!: number | undefined;
    serverRootAddress!: string | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.tenantId = _data["tenantId"];
            this.serverRootAddress = _data["serverRootAddress"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        data["serverRootAddress"] = this.serverRootAddress;
        return data;
    }
}

export interface IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;
    serverRootAddress: string | undefined;
}

export class RefreshTokenResult implements IRefreshTokenResult {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;

    constructor(data?: IRefreshTokenResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
        }
    }

    static fromJS(data: any): RefreshTokenResult {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data;
    }
}

export interface IRefreshTokenResult {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
}

export class RegisterInput implements IRegisterInput {
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string;
    password!: string;
    captchaResponse!: string | undefined;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): RegisterInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        return data;
    }
}

export interface IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin!: boolean;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
        }
    }

    static fromJS(data: any): RegisterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data;
    }
}

export interface IRegisterOutput {
    canLogin: boolean;
}

export class ResetPasswordInput implements IResetPasswordInput {
    userId!: number;
    resetCode!: string | undefined;
    expireDate!: DateTime;
    password!: string | undefined;
    returnUrl!: string | undefined;
    singleSignIn!: string | undefined;
    c!: string | undefined;

    constructor(data?: IResetPasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.resetCode = _data["resetCode"];
            this.expireDate = _data["expireDate"] ? DateTime.fromISO(_data["expireDate"].toString()) : <any>undefined;
            this.password = _data["password"];
            this.returnUrl = _data["returnUrl"];
            this.singleSignIn = _data["singleSignIn"];
            this.c = _data["c"];
        }
    }

    static fromJS(data: any): ResetPasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["resetCode"] = this.resetCode;
        data["expireDate"] = this.expireDate ? this.expireDate.toString() : <any>undefined;
        data["password"] = this.password;
        data["returnUrl"] = this.returnUrl;
        data["singleSignIn"] = this.singleSignIn;
        data["c"] = this.c;
        return data;
    }
}

export interface IResetPasswordInput {
    userId: number;
    resetCode: string | undefined;
    expireDate: DateTime;
    password: string | undefined;
    returnUrl: string | undefined;
    singleSignIn: string | undefined;
    c: string | undefined;
}

export class ResetPasswordOutput implements IResetPasswordOutput {
    canLogin!: boolean;
    userName!: string | undefined;

    constructor(data?: IResetPasswordOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): ResetPasswordOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        data["userName"] = this.userName;
        return data;
    }
}

export interface IResetPasswordOutput {
    canLogin: boolean;
    userName: string | undefined;
}

export class ResolveTenantIdInput implements IResolveTenantIdInput {
    c!: string | undefined;

    constructor(data?: IResolveTenantIdInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.c = _data["c"];
        }
    }

    static fromJS(data: any): ResolveTenantIdInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResolveTenantIdInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["c"] = this.c;
        return data;
    }
}

export interface IResolveTenantIdInput {
    c: string | undefined;
}

export class SendEmailActivationLinkInput implements ISendEmailActivationLinkInput {
    emailAddress!: string;

    constructor(data?: ISendEmailActivationLinkInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): SendEmailActivationLinkInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendEmailActivationLinkInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ISendEmailActivationLinkInput {
    emailAddress: string;
}

export class SendPasswordResetCodeInput implements ISendPasswordResetCodeInput {
    emailAddress!: string;

    constructor(data?: ISendPasswordResetCodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): SendPasswordResetCodeInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendPasswordResetCodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ISendPasswordResetCodeInput {
    emailAddress: string;
}

export class SwitchToLinkedAccountInput implements ISwitchToLinkedAccountInput {
    targetTenantId!: number | undefined;
    targetUserId!: number;

    constructor(data?: ISwitchToLinkedAccountInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetTenantId = _data["targetTenantId"];
            this.targetUserId = _data["targetUserId"];
        }
    }

    static fromJS(data: any): SwitchToLinkedAccountInput {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchToLinkedAccountInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetTenantId"] = this.targetTenantId;
        data["targetUserId"] = this.targetUserId;
        return data;
    }
}

export interface ISwitchToLinkedAccountInput {
    targetTenantId: number | undefined;
    targetUserId: number;
}

export class SwitchToLinkedAccountOutput implements ISwitchToLinkedAccountOutput {
    switchAccountToken!: string | undefined;
    tenancyName!: string | undefined;

    constructor(data?: ISwitchToLinkedAccountOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.switchAccountToken = _data["switchAccountToken"];
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): SwitchToLinkedAccountOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchToLinkedAccountOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["switchAccountToken"] = this.switchAccountToken;
        data["tenancyName"] = this.tenancyName;
        return data;
    }
}

export interface ISwitchToLinkedAccountOutput {
    switchAccountToken: string | undefined;
    tenancyName: string | undefined;
}

export enum TenantAvailabilityState {
    Available = 1,
    InActive = 2,
    NotFound = 3,
}

export class FlatPermissionDto implements IFlatPermissionDto {
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    isGrantedByDefault!: boolean;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isGrantedByDefault = _data["isGrantedByDefault"];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        return data;
    }
}

export interface IFlatPermissionDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean;
}

export class FlatPermissionWithLevelDto implements IFlatPermissionWithLevelDto {
    level!: number;
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    isGrantedByDefault!: boolean;

    constructor(data?: IFlatPermissionWithLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.level = _data["level"];
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isGrantedByDefault = _data["isGrantedByDefault"];
        }
    }

    static fromJS(data: any): FlatPermissionWithLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionWithLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level;
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        return data;
    }
}

export interface IFlatPermissionWithLevelDto {
    level: number;
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean;
}

export class CreateOrUpdateRoleInput implements ICreateOrUpdateRoleInput {
    role!: RoleEditDto;
    grantedPermissionNames!: string[];

    constructor(data?: ICreateOrUpdateRoleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.role = new RoleEditDto();
            this.grantedPermissionNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : new RoleEditDto();
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateRoleInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateRoleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface ICreateOrUpdateRoleInput {
    role: RoleEditDto;
    grantedPermissionNames: string[];
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role!: RoleEditDto;
    permissions!: FlatPermissionDto[] | undefined;
    grantedPermissionNames!: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : <any>undefined;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class GetRolesInput implements IGetRolesInput {
    permissions!: string[] | undefined;

    constructor(data?: IGetRolesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
        }
    }

    static fromJS(data: any): GetRolesInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRolesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data;
    }
}

export interface IGetRolesInput {
    permissions: string[] | undefined;
}

export class RoleEditDto implements IRoleEditDto {
    id!: number | undefined;
    displayName!: string;
    isDefault!: boolean;
    activeDirectoryGroups!: string | undefined;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.isDefault = _data["isDefault"];
            this.activeDirectoryGroups = _data["activeDirectoryGroups"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["isDefault"] = this.isDefault;
        data["activeDirectoryGroups"] = this.activeDirectoryGroups;
        return data;
    }
}

export interface IRoleEditDto {
    id: number | undefined;
    displayName: string;
    isDefault: boolean;
    activeDirectoryGroups: string | undefined;
}

export class RoleListDto implements IRoleListDto {
    name!: string | undefined;
    displayName!: string | undefined;
    isStatic!: boolean;
    isDefault!: boolean;
    creationTime!: DateTime;
    id!: number;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isStatic = _data["isStatic"];
            this.isDefault = _data["isDefault"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IRoleListDto {
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: DateTime;
    id: number;
}

export class CreateUserDelegationDto implements ICreateUserDelegationDto {
    targetUserId!: number;
    startTime!: DateTime;
    endTime!: DateTime;

    constructor(data?: ICreateUserDelegationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetUserId = _data["targetUserId"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? DateTime.fromISO(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateUserDelegationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDelegationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetUserId"] = this.targetUserId;
        data["startTime"] = this.startTime ? this.startTime.toString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toString() : <any>undefined;
        return data;
    }
}

export interface ICreateUserDelegationDto {
    targetUserId: number;
    startTime: DateTime;
    endTime: DateTime;
}

export class UserDelegationDto implements IUserDelegationDto {
    username!: string | undefined;
    startTime!: DateTime;
    endTime!: DateTime;
    id!: number;

    constructor(data?: IUserDelegationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? DateTime.fromISO(_data["endTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserDelegationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDelegationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["startTime"] = this.startTime ? this.startTime.toString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserDelegationDto {
    username: string | undefined;
    startTime: DateTime;
    endTime: DateTime;
    id: number;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName!: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class CreateOrUpdateUserInput implements ICreateOrUpdateUserInput {
    user!: UserEditDto;
    assignedRoleNames!: string[];
    sendActivationEmail!: boolean;
    setRandomPassword!: boolean;
    organizationUnits!: number[] | undefined;

    constructor(data?: ICreateOrUpdateUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.user = new UserEditDto();
            this.assignedRoleNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserEditDto.fromJS(_data["user"]) : new UserEditDto();
            if (Array.isArray(_data["assignedRoleNames"])) {
                this.assignedRoleNames = [] as any;
                for (let item of _data["assignedRoleNames"])
                    this.assignedRoleNames!.push(item);
            }
            this.sendActivationEmail = _data["sendActivationEmail"];
            this.setRandomPassword = _data["setRandomPassword"];
            if (Array.isArray(_data["organizationUnits"])) {
                this.organizationUnits = [] as any;
                for (let item of _data["organizationUnits"])
                    this.organizationUnits!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.assignedRoleNames)) {
            data["assignedRoleNames"] = [];
            for (let item of this.assignedRoleNames)
                data["assignedRoleNames"].push(item);
        }
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["setRandomPassword"] = this.setRandomPassword;
        if (Array.isArray(this.organizationUnits)) {
            data["organizationUnits"] = [];
            for (let item of this.organizationUnits)
                data["organizationUnits"].push(item);
        }
        return data;
    }
}

export interface ICreateOrUpdateUserInput {
    user: UserEditDto;
    assignedRoleNames: string[];
    sendActivationEmail: boolean;
    setRandomPassword: boolean;
    organizationUnits: number[] | undefined;
}

export class GetUserDto implements IGetUserDto {
    userId!: number;
    fullName!: string | undefined;

    constructor(data?: IGetUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): GetUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface IGetUserDto {
    userId: number;
    fullName: string | undefined;
}

export class GetUserForEditOutput implements IGetUserForEditOutput {
    profilePictureId!: string | undefined;
    user!: UserEditDto;
    roles!: UserRoleDto[] | undefined;
    allOrganizationUnits!: OrganizationUnitDto[] | undefined;
    memberedOrganizationUnits!: string[] | undefined;
    allowedUserNameCharacters!: string | undefined;
    isSMTPSettingsProvided!: boolean;

    constructor(data?: IGetUserForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profilePictureId = _data["profilePictureId"];
            this.user = _data["user"] ? UserEditDto.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserRoleDto.fromJS(item));
            }
            if (Array.isArray(_data["allOrganizationUnits"])) {
                this.allOrganizationUnits = [] as any;
                for (let item of _data["allOrganizationUnits"])
                    this.allOrganizationUnits!.push(OrganizationUnitDto.fromJS(item));
            }
            if (Array.isArray(_data["memberedOrganizationUnits"])) {
                this.memberedOrganizationUnits = [] as any;
                for (let item of _data["memberedOrganizationUnits"])
                    this.memberedOrganizationUnits!.push(item);
            }
            this.allowedUserNameCharacters = _data["allowedUserNameCharacters"];
            this.isSMTPSettingsProvided = _data["isSMTPSettingsProvided"];
        }
    }

    static fromJS(data: any): GetUserForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePictureId"] = this.profilePictureId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.allOrganizationUnits)) {
            data["allOrganizationUnits"] = [];
            for (let item of this.allOrganizationUnits)
                data["allOrganizationUnits"].push(item.toJSON());
        }
        if (Array.isArray(this.memberedOrganizationUnits)) {
            data["memberedOrganizationUnits"] = [];
            for (let item of this.memberedOrganizationUnits)
                data["memberedOrganizationUnits"].push(item);
        }
        data["allowedUserNameCharacters"] = this.allowedUserNameCharacters;
        data["isSMTPSettingsProvided"] = this.isSMTPSettingsProvided;
        return data;
    }
}

export interface IGetUserForEditOutput {
    profilePictureId: string | undefined;
    user: UserEditDto;
    roles: UserRoleDto[] | undefined;
    allOrganizationUnits: OrganizationUnitDto[] | undefined;
    memberedOrganizationUnits: string[] | undefined;
    allowedUserNameCharacters: string | undefined;
    isSMTPSettingsProvided: boolean;
}

export class GetUserForShowOutput implements IGetUserForShowOutput {
    user!: UserShowDto;
    roles!: UserRoleDto[] | undefined;

    constructor(data?: IGetUserForShowOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserShowDto.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserRoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserForShowOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserForShowOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUserForShowOutput {
    user: UserShowDto;
    roles: UserRoleDto[] | undefined;
}

export class GetUserPermissionsForEditOutput implements IGetUserPermissionsForEditOutput {
    permissions!: FlatPermissionDto[] | undefined;
    grantedPermissionNames!: string[] | undefined;

    constructor(data?: IGetUserPermissionsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): GetUserPermissionsForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserPermissionsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface IGetUserPermissionsForEditOutput {
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class GetUsersInput implements IGetUsersInput {
    filter!: string | undefined;
    permissions!: string[] | undefined;
    role!: number | undefined;
    onlyLockedUsers!: boolean;
    sorting!: string | undefined;
    maxResultCount!: number;
    skipCount!: number;

    constructor(data?: IGetUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            this.role = _data["role"];
            this.onlyLockedUsers = _data["onlyLockedUsers"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): GetUsersInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUsersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        data["role"] = this.role;
        data["onlyLockedUsers"] = this.onlyLockedUsers;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }
}

export interface IGetUsersInput {
    filter: string | undefined;
    permissions: string[] | undefined;
    role: number | undefined;
    onlyLockedUsers: boolean;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
}

export class LinkToUserInput implements ILinkToUserInput {
    tenancyName!: string | undefined;
    usernameOrEmailAddress!: string;
    password!: string;

    constructor(data?: ILinkToUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.usernameOrEmailAddress = _data["usernameOrEmailAddress"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LinkToUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new LinkToUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["usernameOrEmailAddress"] = this.usernameOrEmailAddress;
        data["password"] = this.password;
        return data;
    }
}

export interface ILinkToUserInput {
    tenancyName: string | undefined;
    usernameOrEmailAddress: string;
    password: string;
}

export class LinkedUserDto implements ILinkedUserDto {
    tenantId!: number | undefined;
    tenancyName!: string | undefined;
    username!: string | undefined;
    id!: number;

    constructor(data?: ILinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.tenancyName = _data["tenancyName"];
            this.username = _data["username"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LinkedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenancyName"] = this.tenancyName;
        data["username"] = this.username;
        data["id"] = this.id;
        return data;
    }
}

export interface ILinkedUserDto {
    tenantId: number | undefined;
    tenancyName: string | undefined;
    username: string | undefined;
    id: number;
}

export class UnlinkUserInput implements IUnlinkUserInput {
    tenantId!: number | undefined;
    userId!: number;

    constructor(data?: IUnlinkUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UnlinkUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new UnlinkUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IUnlinkUserInput {
    tenantId: number | undefined;
    userId: number;
}

export class UpdateUserPermissionsInput implements IUpdateUserPermissionsInput {
    id!: number;
    grantedPermissionNames!: string[];

    constructor(data?: IUpdateUserPermissionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.grantedPermissionNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateUserPermissionsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserPermissionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface IUpdateUserPermissionsInput {
    id: number;
    grantedPermissionNames: string[];
}

export class UserEditDto implements IUserEditDto {
    id!: number | undefined;
    titleId!: string | undefined;
    languageOfCorrespondenceId!: string | undefined;
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string;
    emailAddress2!: string | undefined;
    phoneNumber!: string | undefined;
    phoneNumber2!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    postOfficeBox!: string | undefined;
    ahv!: string | undefined;
    gln!: string | undefined;
    backendSystemId!: string | undefined;
    password!: string | undefined;
    isActive!: boolean;
    shouldChangePasswordOnNextLogin!: boolean;
    isTwoFactorEnabled!: boolean;
    isLockoutEnabled!: boolean;

    constructor(data?: IUserEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.titleId = _data["titleId"];
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.emailAddress2 = _data["emailAddress2"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumber2 = _data["phoneNumber2"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.ahv = _data["ahv"];
            this.gln = _data["gln"];
            this.backendSystemId = _data["backendSystemId"];
            this.password = _data["password"];
            this.isActive = _data["isActive"];
            this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"];
            this.isTwoFactorEnabled = _data["isTwoFactorEnabled"];
            this.isLockoutEnabled = _data["isLockoutEnabled"];
        }
    }

    static fromJS(data: any): UserEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["titleId"] = this.titleId;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["emailAddress2"] = this.emailAddress2;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumber2"] = this.phoneNumber2;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["postOfficeBox"] = this.postOfficeBox;
        data["ahv"] = this.ahv;
        data["gln"] = this.gln;
        data["backendSystemId"] = this.backendSystemId;
        data["password"] = this.password;
        data["isActive"] = this.isActive;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        return data;
    }
}

export interface IUserEditDto {
    id: number | undefined;
    titleId: string | undefined;
    languageOfCorrespondenceId: string | undefined;
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    emailAddress2: string | undefined;
    phoneNumber: string | undefined;
    phoneNumber2: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    postOfficeBox: string | undefined;
    ahv: string | undefined;
    gln: string | undefined;
    backendSystemId: string | undefined;
    password: string | undefined;
    isActive: boolean;
    shouldChangePasswordOnNextLogin: boolean;
    isTwoFactorEnabled: boolean;
    isLockoutEnabled: boolean;
}

export class UserListDto implements IUserListDto {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    lockoutEndDateUtc!: DateTime | undefined;
    phoneNumber!: string | undefined;
    profilePictureId!: string | undefined;
    isEmailConfirmed!: boolean;
    roles!: UserListRoleDto[] | undefined;
    isActive!: boolean;
    creationTime!: DateTime;
    id!: number;

    constructor(data?: IUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.lockoutEndDateUtc = _data["lockoutEndDateUtc"] ? DateTime.fromISO(_data["lockoutEndDateUtc"].toString()) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
            this.profilePictureId = _data["profilePictureId"];
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserListRoleDto.fromJS(item));
            }
            this.isActive = _data["isActive"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["lockoutEndDateUtc"] = this.lockoutEndDateUtc ? this.lockoutEndDateUtc.toString() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["profilePictureId"] = this.profilePictureId;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserListDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    lockoutEndDateUtc: DateTime | undefined;
    phoneNumber: string | undefined;
    profilePictureId: string | undefined;
    isEmailConfirmed: boolean;
    roles: UserListRoleDto[] | undefined;
    isActive: boolean;
    creationTime: DateTime;
    id: number;
}

export class UserListRoleDto implements IUserListRoleDto {
    roleId!: number;
    roleName!: string | undefined;

    constructor(data?: IUserListRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
        }
    }

    static fromJS(data: any): UserListRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserListRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        return data;
    }
}

export interface IUserListRoleDto {
    roleId: number;
    roleName: string | undefined;
}

export class UserLoginAttemptDto implements IUserLoginAttemptDto {
    tenancyName!: string | undefined;
    userNameOrEmail!: string | undefined;
    clientIpAddress!: string | undefined;
    clientName!: string | undefined;
    browserInfo!: string | undefined;
    result!: string | undefined;
    creationTime!: DateTime;

    constructor(data?: IUserLoginAttemptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.userNameOrEmail = _data["userNameOrEmail"];
            this.clientIpAddress = _data["clientIpAddress"];
            this.clientName = _data["clientName"];
            this.browserInfo = _data["browserInfo"];
            this.result = _data["result"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserLoginAttemptDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginAttemptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userNameOrEmail"] = this.userNameOrEmail;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["result"] = this.result;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface IUserLoginAttemptDto {
    tenancyName: string | undefined;
    userNameOrEmail: string | undefined;
    clientIpAddress: string | undefined;
    clientName: string | undefined;
    browserInfo: string | undefined;
    result: string | undefined;
    creationTime: DateTime;
}

export class UserRoleDto implements IUserRoleDto {
    roleId!: number;
    roleName!: string | undefined;
    roleDisplayName!: string | undefined;
    isAssigned!: boolean;
    inheritedFromOrganizationUnit!: boolean;

    constructor(data?: IUserRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.roleDisplayName = _data["roleDisplayName"];
            this.isAssigned = _data["isAssigned"];
            this.inheritedFromOrganizationUnit = _data["inheritedFromOrganizationUnit"];
        }
    }

    static fromJS(data: any): UserRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["roleDisplayName"] = this.roleDisplayName;
        data["isAssigned"] = this.isAssigned;
        data["inheritedFromOrganizationUnit"] = this.inheritedFromOrganizationUnit;
        return data;
    }
}

export interface IUserRoleDto {
    roleId: number;
    roleName: string | undefined;
    roleDisplayName: string | undefined;
    isAssigned: boolean;
    inheritedFromOrganizationUnit: boolean;
}

export class UserShowDto implements IUserShowDto {
    id!: number | undefined;
    titleId!: string | undefined;
    languageOfCorrespondenceId!: string | undefined;
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    emailAddress2!: string | undefined;
    phoneNumber!: string | undefined;
    phoneNumber2!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    postOfficeBox!: string | undefined;
    ahv!: string | undefined;
    gln!: string | undefined;
    backendSystemId!: string | undefined;
    isActive!: boolean;
    isTwoFactorEnabled!: boolean;
    isLockoutEnabled!: boolean;

    constructor(data?: IUserShowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.titleId = _data["titleId"];
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.emailAddress2 = _data["emailAddress2"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumber2 = _data["phoneNumber2"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.ahv = _data["ahv"];
            this.gln = _data["gln"];
            this.backendSystemId = _data["backendSystemId"];
            this.isActive = _data["isActive"];
            this.isTwoFactorEnabled = _data["isTwoFactorEnabled"];
            this.isLockoutEnabled = _data["isLockoutEnabled"];
        }
    }

    static fromJS(data: any): UserShowDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserShowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["titleId"] = this.titleId;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["emailAddress2"] = this.emailAddress2;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumber2"] = this.phoneNumber2;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["postOfficeBox"] = this.postOfficeBox;
        data["ahv"] = this.ahv;
        data["gln"] = this.gln;
        data["backendSystemId"] = this.backendSystemId;
        data["isActive"] = this.isActive;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        return data;
    }
}

export interface IUserShowDto {
    id: number | undefined;
    titleId: string | undefined;
    languageOfCorrespondenceId: string | undefined;
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    emailAddress2: string | undefined;
    phoneNumber: string | undefined;
    phoneNumber2: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    postOfficeBox: string | undefined;
    ahv: string | undefined;
    gln: string | undefined;
    backendSystemId: string | undefined;
    isActive: boolean;
    isTwoFactorEnabled: boolean;
    isLockoutEnabled: boolean;
}

export class ChangePasswordInput implements IChangePasswordInput {
    currentPassword!: string;
    newPassword!: string;

    constructor(data?: IChangePasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IChangePasswordInput {
    currentPassword: string;
    newPassword: string;
}

export class CurrentUserProfileEditDto implements ICurrentUserProfileEditDto {
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string;
    phoneNumber!: string | undefined;
    isPhoneNumberConfirmed!: boolean;
    timezone!: string | undefined;
    qrCodeSetupImageUrl!: string | undefined;
    isGoogleAuthenticatorEnabled!: boolean;

    constructor(data?: ICurrentUserProfileEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.isPhoneNumberConfirmed = _data["isPhoneNumberConfirmed"];
            this.timezone = _data["timezone"];
            this.qrCodeSetupImageUrl = _data["qrCodeSetupImageUrl"];
            this.isGoogleAuthenticatorEnabled = _data["isGoogleAuthenticatorEnabled"];
        }
    }

    static fromJS(data: any): CurrentUserProfileEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentUserProfileEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["timezone"] = this.timezone;
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        return data;
    }
}

export interface ICurrentUserProfileEditDto {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    timezone: string | undefined;
    qrCodeSetupImageUrl: string | undefined;
    isGoogleAuthenticatorEnabled: boolean;
}

export class GenerateGoogleAuthenticatorKeyOutput implements IGenerateGoogleAuthenticatorKeyOutput {
    qrCodeSetupImageUrl!: string | undefined;
    googleAuthenticatorKey!: string | undefined;

    constructor(data?: IGenerateGoogleAuthenticatorKeyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qrCodeSetupImageUrl = _data["qrCodeSetupImageUrl"];
            this.googleAuthenticatorKey = _data["googleAuthenticatorKey"];
        }
    }

    static fromJS(data: any): GenerateGoogleAuthenticatorKeyOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateGoogleAuthenticatorKeyOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        data["googleAuthenticatorKey"] = this.googleAuthenticatorKey;
        return data;
    }
}

export interface IGenerateGoogleAuthenticatorKeyOutput {
    qrCodeSetupImageUrl: string | undefined;
    googleAuthenticatorKey: string | undefined;
}

export class GetPasswordComplexitySettingOutput implements IGetPasswordComplexitySettingOutput {
    setting!: PasswordComplexitySetting;

    constructor(data?: IGetPasswordComplexitySettingOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.setting = _data["setting"] ? PasswordComplexitySetting.fromJS(_data["setting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPasswordComplexitySettingOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPasswordComplexitySettingOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["setting"] = this.setting ? this.setting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPasswordComplexitySettingOutput {
    setting: PasswordComplexitySetting;
}

export class GetProfilePictureOutput implements IGetProfilePictureOutput {
    profilePicture!: string | undefined;

    constructor(data?: IGetProfilePictureOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profilePicture = _data["profilePicture"];
        }
    }

    static fromJS(data: any): GetProfilePictureOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfilePictureOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePicture"] = this.profilePicture;
        return data;
    }
}

export interface IGetProfilePictureOutput {
    profilePicture: string | undefined;
}

export class SendVerificationSmsInputDto implements ISendVerificationSmsInputDto {
    phoneNumber!: string | undefined;

    constructor(data?: ISendVerificationSmsInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): SendVerificationSmsInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendVerificationSmsInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface ISendVerificationSmsInputDto {
    phoneNumber: string | undefined;
}

export class UpdateGoogleAuthenticatorKeyInput implements IUpdateGoogleAuthenticatorKeyInput {
    googleAuthenticatorKey!: string | undefined;
    authenticatorCode!: string | undefined;

    constructor(data?: IUpdateGoogleAuthenticatorKeyInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.googleAuthenticatorKey = _data["googleAuthenticatorKey"];
            this.authenticatorCode = _data["authenticatorCode"];
        }
    }

    static fromJS(data: any): UpdateGoogleAuthenticatorKeyInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGoogleAuthenticatorKeyInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["googleAuthenticatorKey"] = this.googleAuthenticatorKey;
        data["authenticatorCode"] = this.authenticatorCode;
        return data;
    }
}

export interface IUpdateGoogleAuthenticatorKeyInput {
    googleAuthenticatorKey: string | undefined;
    authenticatorCode: string | undefined;
}

export class UpdateGoogleAuthenticatorKeyOutput implements IUpdateGoogleAuthenticatorKeyOutput {
    recoveryCodes!: string[] | undefined;

    constructor(data?: IUpdateGoogleAuthenticatorKeyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["recoveryCodes"])) {
                this.recoveryCodes = [] as any;
                for (let item of _data["recoveryCodes"])
                    this.recoveryCodes!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateGoogleAuthenticatorKeyOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGoogleAuthenticatorKeyOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.recoveryCodes)) {
            data["recoveryCodes"] = [];
            for (let item of this.recoveryCodes)
                data["recoveryCodes"].push(item);
        }
        return data;
    }
}

export interface IUpdateGoogleAuthenticatorKeyOutput {
    recoveryCodes: string[] | undefined;
}

export class UpdateProfilePictureInput implements IUpdateProfilePictureInput {
    fileToken!: string | undefined;
    useGravatarProfilePicture!: boolean;
    userId!: number | undefined;

    constructor(data?: IUpdateProfilePictureInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileToken = _data["fileToken"];
            this.useGravatarProfilePicture = _data["useGravatarProfilePicture"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UpdateProfilePictureInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfilePictureInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileToken"] = this.fileToken;
        data["useGravatarProfilePicture"] = this.useGravatarProfilePicture;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IUpdateProfilePictureInput {
    fileToken: string | undefined;
    useGravatarProfilePicture: boolean;
    userId: number | undefined;
}

export class VerifyAuthenticatorCodeInput implements IVerifyAuthenticatorCodeInput {
    code!: string | undefined;
    googleAuthenticatorKey!: string | undefined;

    constructor(data?: IVerifyAuthenticatorCodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.googleAuthenticatorKey = _data["googleAuthenticatorKey"];
        }
    }

    static fromJS(data: any): VerifyAuthenticatorCodeInput {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyAuthenticatorCodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["googleAuthenticatorKey"] = this.googleAuthenticatorKey;
        return data;
    }
}

export interface IVerifyAuthenticatorCodeInput {
    code: string | undefined;
    googleAuthenticatorKey: string | undefined;
}

export class VerifySmsCodeInputDto implements IVerifySmsCodeInputDto {
    code!: string | undefined;
    phoneNumber!: string | undefined;

    constructor(data?: IVerifySmsCodeInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): VerifySmsCodeInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerifySmsCodeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IVerifySmsCodeInputDto {
    code: string | undefined;
    phoneNumber: string | undefined;
}

export class BusinessFormSearchDto implements IBusinessFormSearchDto {
    businessId!: number | undefined;
    sponsorshipTypeId!: string | undefined;
    businessTypeId!: string | undefined;
    legalFormId!: string | undefined;
    name!: string | undefined;
    additionalName!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    uid!: string | undefined;
    bur!: string | undefined;
    gln!: string | undefined;
    email!: string | undefined;

    constructor(data?: IBusinessFormSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.businessId = _data["businessId"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.businessTypeId = _data["businessTypeId"];
            this.legalFormId = _data["legalFormId"];
            this.name = _data["name"];
            this.additionalName = _data["additionalName"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.uid = _data["uid"];
            this.bur = _data["bur"];
            this.gln = _data["gln"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): BusinessFormSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new BusinessFormSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["businessId"] = this.businessId;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["businessTypeId"] = this.businessTypeId;
        data["legalFormId"] = this.legalFormId;
        data["name"] = this.name;
        data["additionalName"] = this.additionalName;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["uid"] = this.uid;
        data["bur"] = this.bur;
        data["gln"] = this.gln;
        data["email"] = this.email;
        return data;
    }
}

export interface IBusinessFormSearchDto {
    businessId: number | undefined;
    sponsorshipTypeId: string | undefined;
    businessTypeId: string | undefined;
    legalFormId: string | undefined;
    name: string | undefined;
    additionalName: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    uid: string | undefined;
    bur: string | undefined;
    gln: string | undefined;
    email: string | undefined;
}

export class BusinessFormSearchInput implements IBusinessFormSearchInput {
    businessId!: number | undefined;
    sponsorshipTypeId!: string | undefined;
    businessTypeId!: string | undefined;
    legalFormId!: string | undefined;
    name!: string | undefined;
    additionalName!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    uid!: string | undefined;
    bur!: string | undefined;
    gln!: string | undefined;
    email!: string | undefined;
    maxResultCount!: number | undefined;
    skipCount!: number | undefined;

    constructor(data?: IBusinessFormSearchInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.businessId = _data["businessId"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.businessTypeId = _data["businessTypeId"];
            this.legalFormId = _data["legalFormId"];
            this.name = _data["name"];
            this.additionalName = _data["additionalName"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.uid = _data["uid"];
            this.bur = _data["bur"];
            this.gln = _data["gln"];
            this.email = _data["email"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): BusinessFormSearchInput {
        data = typeof data === 'object' ? data : {};
        let result = new BusinessFormSearchInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["businessId"] = this.businessId;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["businessTypeId"] = this.businessTypeId;
        data["legalFormId"] = this.legalFormId;
        data["name"] = this.name;
        data["additionalName"] = this.additionalName;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["uid"] = this.uid;
        data["bur"] = this.bur;
        data["gln"] = this.gln;
        data["email"] = this.email;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }
}

export interface IBusinessFormSearchInput {
    businessId: number | undefined;
    sponsorshipTypeId: string | undefined;
    businessTypeId: string | undefined;
    legalFormId: string | undefined;
    name: string | undefined;
    additionalName: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    uid: string | undefined;
    bur: string | undefined;
    gln: string | undefined;
    email: string | undefined;
    maxResultCount: number | undefined;
    skipCount: number | undefined;
}

export class BusinessFormSearchOutput implements IBusinessFormSearchOutput {
    totalCount!: number;
    items!: BusinessFormSearchDto[] | undefined;

    constructor(data?: IBusinessFormSearchOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BusinessFormSearchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BusinessFormSearchOutput {
        data = typeof data === 'object' ? data : {};
        let result = new BusinessFormSearchOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBusinessFormSearchOutput {
    totalCount: number;
    items: BusinessFormSearchDto[] | undefined;
}

export class BusinessSearchDto implements IBusinessSearchDto {
    sponsorshipId!: number | undefined;
    statusId!: string | undefined;
    businessId!: number | undefined;
    employmentAddressId!: number | undefined;
    addressTypeId!: string | undefined;
    legalFormId!: string | undefined;
    name!: string | undefined;
    additionalName!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    gln!: string | undefined;
    bur!: string | undefined;
    dateOfOpening!: DateTime | undefined;
    dateOfClosure!: DateTime | undefined;
    id!: number;

    constructor(data?: IBusinessSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sponsorshipId = _data["sponsorshipId"];
            this.statusId = _data["statusId"];
            this.businessId = _data["businessId"];
            this.employmentAddressId = _data["employmentAddressId"];
            this.addressTypeId = _data["addressTypeId"];
            this.legalFormId = _data["legalFormId"];
            this.name = _data["name"];
            this.additionalName = _data["additionalName"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.gln = _data["gln"];
            this.bur = _data["bur"];
            this.dateOfOpening = _data["dateOfOpening"] ? DateTime.fromISO(_data["dateOfOpening"].toString()) : <any>undefined;
            this.dateOfClosure = _data["dateOfClosure"] ? DateTime.fromISO(_data["dateOfClosure"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BusinessSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new BusinessSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sponsorshipId"] = this.sponsorshipId;
        data["statusId"] = this.statusId;
        data["businessId"] = this.businessId;
        data["employmentAddressId"] = this.employmentAddressId;
        data["addressTypeId"] = this.addressTypeId;
        data["legalFormId"] = this.legalFormId;
        data["name"] = this.name;
        data["additionalName"] = this.additionalName;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["gln"] = this.gln;
        data["bur"] = this.bur;
        data["dateOfOpening"] = this.dateOfOpening ? this.dateOfOpening.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfClosure"] = this.dateOfClosure ? this.dateOfClosure.toFormat('yyyy-MM-dd') : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IBusinessSearchDto {
    sponsorshipId: number | undefined;
    statusId: string | undefined;
    businessId: number | undefined;
    employmentAddressId: number | undefined;
    addressTypeId: string | undefined;
    legalFormId: string | undefined;
    name: string | undefined;
    additionalName: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    gln: string | undefined;
    bur: string | undefined;
    dateOfOpening: DateTime | undefined;
    dateOfClosure: DateTime | undefined;
    id: number;
}

export class BusinessSearchInput implements IBusinessSearchInput {
    sponsorshipId!: number;
    filter!: string | undefined;
    sorting!: string | undefined;
    maxResultCount!: number;
    skipCount!: number;

    constructor(data?: IBusinessSearchInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sponsorshipId = _data["sponsorshipId"];
            this.filter = _data["filter"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): BusinessSearchInput {
        data = typeof data === 'object' ? data : {};
        let result = new BusinessSearchInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sponsorshipId"] = this.sponsorshipId;
        data["filter"] = this.filter;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }
}

export interface IBusinessSearchInput {
    sponsorshipId: number;
    filter: string | undefined;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
}

export class BusinessSearchOutput implements IBusinessSearchOutput {
    totalCount!: number;
    items!: BusinessSearchDto[] | undefined;

    constructor(data?: IBusinessSearchOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BusinessSearchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BusinessSearchOutput {
        data = typeof data === 'object' ? data : {};
        let result = new BusinessSearchOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBusinessSearchOutput {
    totalCount: number;
    items: BusinessSearchDto[] | undefined;
}

export class BusinessDto implements IBusinessDto {
    sponsorshipId!: number | undefined;
    sponsorshipName!: string | undefined;
    typeId!: string;
    statusId!: string;
    legalFormId!: string | undefined;
    name!: string;
    additionalName!: string | undefined;
    postCode!: string;
    city!: string;
    street!: string;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string;
    cantonId!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    fax!: string | undefined;
    website!: string | undefined;
    gln!: string | undefined;
    sapId!: string | undefined;
    bur!: string | undefined;
    uid!: string | undefined;
    comments!: string | undefined;
    dateOfOpening!: DateTime | undefined;
    dateOfClosure!: DateTime | undefined;
    businessHours!: string | undefined;
    isArchived!: boolean;
    district!: string | undefined;
    businessNursingInstitution!: BusinessNursingInstitutionDto;
    licences!: CorporateLicenceDto[] | undefined;
    employments!: GetEmploymentDto[] | undefined;
    id!: number;

    constructor(data?: IBusinessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sponsorshipId = _data["sponsorshipId"];
            this.sponsorshipName = _data["sponsorshipName"];
            this.typeId = _data["typeId"];
            this.statusId = _data["statusId"];
            this.legalFormId = _data["legalFormId"];
            this.name = _data["name"];
            this.additionalName = _data["additionalName"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.cantonId = _data["cantonId"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.fax = _data["fax"];
            this.website = _data["website"];
            this.gln = _data["gln"];
            this.sapId = _data["sapId"];
            this.bur = _data["bur"];
            this.uid = _data["uid"];
            this.comments = _data["comments"];
            this.dateOfOpening = _data["dateOfOpening"] ? DateTime.fromISO(_data["dateOfOpening"].toString()) : <any>undefined;
            this.dateOfClosure = _data["dateOfClosure"] ? DateTime.fromISO(_data["dateOfClosure"].toString()) : <any>undefined;
            this.businessHours = _data["businessHours"];
            this.isArchived = _data["isArchived"];
            this.district = _data["district"];
            this.businessNursingInstitution = _data["businessNursingInstitution"] ? BusinessNursingInstitutionDto.fromJS(_data["businessNursingInstitution"]) : <any>undefined;
            if (Array.isArray(_data["licences"])) {
                this.licences = [] as any;
                for (let item of _data["licences"])
                    this.licences!.push(CorporateLicenceDto.fromJS(item));
            }
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(GetEmploymentDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BusinessDto {
        data = typeof data === 'object' ? data : {};
        let result = new BusinessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sponsorshipId"] = this.sponsorshipId;
        data["sponsorshipName"] = this.sponsorshipName;
        data["typeId"] = this.typeId;
        data["statusId"] = this.statusId;
        data["legalFormId"] = this.legalFormId;
        data["name"] = this.name;
        data["additionalName"] = this.additionalName;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["cantonId"] = this.cantonId;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["fax"] = this.fax;
        data["website"] = this.website;
        data["gln"] = this.gln;
        data["sapId"] = this.sapId;
        data["bur"] = this.bur;
        data["uid"] = this.uid;
        data["comments"] = this.comments;
        data["dateOfOpening"] = this.dateOfOpening ? this.dateOfOpening.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfClosure"] = this.dateOfClosure ? this.dateOfClosure.toFormat('yyyy-MM-dd') : <any>undefined;
        data["businessHours"] = this.businessHours;
        data["isArchived"] = this.isArchived;
        data["district"] = this.district;
        data["businessNursingInstitution"] = this.businessNursingInstitution ? this.businessNursingInstitution.toJSON() : <any>undefined;
        if (Array.isArray(this.licences)) {
            data["licences"] = [];
            for (let item of this.licences)
                data["licences"].push(item.toJSON());
        }
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IBusinessDto {
    sponsorshipId: number | undefined;
    sponsorshipName: string | undefined;
    typeId: string;
    statusId: string;
    legalFormId: string | undefined;
    name: string;
    additionalName: string | undefined;
    postCode: string;
    city: string;
    street: string;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string;
    cantonId: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    fax: string | undefined;
    website: string | undefined;
    gln: string | undefined;
    sapId: string | undefined;
    bur: string | undefined;
    uid: string | undefined;
    comments: string | undefined;
    dateOfOpening: DateTime | undefined;
    dateOfClosure: DateTime | undefined;
    businessHours: string | undefined;
    isArchived: boolean;
    district: string | undefined;
    businessNursingInstitution: BusinessNursingInstitutionDto;
    licences: CorporateLicenceDto[] | undefined;
    employments: GetEmploymentDto[] | undefined;
    id: number;
}

export class BusinessNursingInstitutionDto implements IBusinessNursingInstitutionDto {
    allowedBedsCount!: number;

    constructor(data?: IBusinessNursingInstitutionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowedBedsCount = _data["allowedBedsCount"];
        }
    }

    static fromJS(data: any): BusinessNursingInstitutionDto {
        data = typeof data === 'object' ? data : {};
        let result = new BusinessNursingInstitutionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowedBedsCount"] = this.allowedBedsCount;
        return data;
    }
}

export interface IBusinessNursingInstitutionDto {
    allowedBedsCount: number;
}

export class CreateAndLinkBusinessInput implements ICreateAndLinkBusinessInput {
    employmentId!: number;
    employmentAddress!: EmploymentAddressDto;
    business!: BusinessDto;

    constructor(data?: ICreateAndLinkBusinessInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employmentId = _data["employmentId"];
            this.employmentAddress = _data["employmentAddress"] ? EmploymentAddressDto.fromJS(_data["employmentAddress"]) : <any>undefined;
            this.business = _data["business"] ? BusinessDto.fromJS(_data["business"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateAndLinkBusinessInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAndLinkBusinessInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employmentId"] = this.employmentId;
        data["employmentAddress"] = this.employmentAddress ? this.employmentAddress.toJSON() : <any>undefined;
        data["business"] = this.business ? this.business.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateAndLinkBusinessInput {
    employmentId: number;
    employmentAddress: EmploymentAddressDto;
    business: BusinessDto;
}

export class CreateBusinessDto implements ICreateBusinessDto {
    useSponsorshipAddress!: boolean;
    sponsorshipId!: number | undefined;
    typeId!: string | undefined;
    statusId!: string | undefined;
    legalFormId!: string | undefined;
    name!: string | undefined;
    additionalName!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string | undefined;
    cantonId!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    fax!: string | undefined;
    website!: string | undefined;
    gln!: string | undefined;
    sapId!: string | undefined;
    bur!: string | undefined;
    uid!: string | undefined;
    comments!: string | undefined;
    dateOfOpening!: DateTime | undefined;
    dateOfClosure!: DateTime | undefined;
    businessHours!: string | undefined;
    id!: number;

    constructor(data?: ICreateBusinessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.useSponsorshipAddress = _data["useSponsorshipAddress"];
            this.sponsorshipId = _data["sponsorshipId"];
            this.typeId = _data["typeId"];
            this.statusId = _data["statusId"];
            this.legalFormId = _data["legalFormId"];
            this.name = _data["name"];
            this.additionalName = _data["additionalName"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.cantonId = _data["cantonId"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.fax = _data["fax"];
            this.website = _data["website"];
            this.gln = _data["gln"];
            this.sapId = _data["sapId"];
            this.bur = _data["bur"];
            this.uid = _data["uid"];
            this.comments = _data["comments"];
            this.dateOfOpening = _data["dateOfOpening"] ? DateTime.fromISO(_data["dateOfOpening"].toString()) : <any>undefined;
            this.dateOfClosure = _data["dateOfClosure"] ? DateTime.fromISO(_data["dateOfClosure"].toString()) : <any>undefined;
            this.businessHours = _data["businessHours"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateBusinessDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBusinessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["useSponsorshipAddress"] = this.useSponsorshipAddress;
        data["sponsorshipId"] = this.sponsorshipId;
        data["typeId"] = this.typeId;
        data["statusId"] = this.statusId;
        data["legalFormId"] = this.legalFormId;
        data["name"] = this.name;
        data["additionalName"] = this.additionalName;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["cantonId"] = this.cantonId;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["fax"] = this.fax;
        data["website"] = this.website;
        data["gln"] = this.gln;
        data["sapId"] = this.sapId;
        data["bur"] = this.bur;
        data["uid"] = this.uid;
        data["comments"] = this.comments;
        data["dateOfOpening"] = this.dateOfOpening ? this.dateOfOpening.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfClosure"] = this.dateOfClosure ? this.dateOfClosure.toFormat('yyyy-MM-dd') : <any>undefined;
        data["businessHours"] = this.businessHours;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateBusinessDto {
    useSponsorshipAddress: boolean;
    sponsorshipId: number | undefined;
    typeId: string | undefined;
    statusId: string | undefined;
    legalFormId: string | undefined;
    name: string | undefined;
    additionalName: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string | undefined;
    cantonId: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    fax: string | undefined;
    website: string | undefined;
    gln: string | undefined;
    sapId: string | undefined;
    bur: string | undefined;
    uid: string | undefined;
    comments: string | undefined;
    dateOfOpening: DateTime | undefined;
    dateOfClosure: DateTime | undefined;
    businessHours: string | undefined;
    id: number;
}

export class CreateOrUpdateBusinessNursingInstitutionInput implements ICreateOrUpdateBusinessNursingInstitutionInput {
    businessNursingInstitution!: BusinessNursingInstitutionDto;
    businessId!: number;

    constructor(data?: ICreateOrUpdateBusinessNursingInstitutionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.businessNursingInstitution = _data["businessNursingInstitution"] ? BusinessNursingInstitutionDto.fromJS(_data["businessNursingInstitution"]) : <any>undefined;
            this.businessId = _data["businessId"];
        }
    }

    static fromJS(data: any): CreateOrUpdateBusinessNursingInstitutionInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateBusinessNursingInstitutionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["businessNursingInstitution"] = this.businessNursingInstitution ? this.businessNursingInstitution.toJSON() : <any>undefined;
        data["businessId"] = this.businessId;
        return data;
    }
}

export interface ICreateOrUpdateBusinessNursingInstitutionInput {
    businessNursingInstitution: BusinessNursingInstitutionDto;
    businessId: number;
}

export class GetBusinessDto implements IGetBusinessDto {
    typeId!: string | undefined;
    statusId!: string | undefined;
    name!: string | undefined;
    additionalName!: string | undefined;
    addressAddition!: string | undefined;
    uid!: string | undefined;
    gln!: string | undefined;
    bur!: string | undefined;
    sapId!: string | undefined;
    legalFormId!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    countryId!: string | undefined;
    cantonId!: string | undefined;
    postOfficeBox!: string | undefined;
    languageOfCorrespondenceId!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    fax!: string | undefined;
    website!: string | undefined;
    dateOfOpening!: DateTime | undefined;
    dateOfClosure!: DateTime | undefined;
    businessHours!: string | undefined;
    comments!: string | undefined;
    sapBusinessPartner!: SapBusinessPartnerDto;
    id!: number;

    constructor(data?: IGetBusinessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeId = _data["typeId"];
            this.statusId = _data["statusId"];
            this.name = _data["name"];
            this.additionalName = _data["additionalName"];
            this.addressAddition = _data["addressAddition"];
            this.uid = _data["uid"];
            this.gln = _data["gln"];
            this.bur = _data["bur"];
            this.sapId = _data["sapId"];
            this.legalFormId = _data["legalFormId"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.countryId = _data["countryId"];
            this.cantonId = _data["cantonId"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.fax = _data["fax"];
            this.website = _data["website"];
            this.dateOfOpening = _data["dateOfOpening"] ? DateTime.fromISO(_data["dateOfOpening"].toString()) : <any>undefined;
            this.dateOfClosure = _data["dateOfClosure"] ? DateTime.fromISO(_data["dateOfClosure"].toString()) : <any>undefined;
            this.businessHours = _data["businessHours"];
            this.comments = _data["comments"];
            this.sapBusinessPartner = _data["sapBusinessPartner"] ? SapBusinessPartnerDto.fromJS(_data["sapBusinessPartner"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetBusinessDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetBusinessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["statusId"] = this.statusId;
        data["name"] = this.name;
        data["additionalName"] = this.additionalName;
        data["addressAddition"] = this.addressAddition;
        data["uid"] = this.uid;
        data["gln"] = this.gln;
        data["bur"] = this.bur;
        data["sapId"] = this.sapId;
        data["legalFormId"] = this.legalFormId;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["countryId"] = this.countryId;
        data["cantonId"] = this.cantonId;
        data["postOfficeBox"] = this.postOfficeBox;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["fax"] = this.fax;
        data["website"] = this.website;
        data["dateOfOpening"] = this.dateOfOpening ? this.dateOfOpening.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfClosure"] = this.dateOfClosure ? this.dateOfClosure.toFormat('yyyy-MM-dd') : <any>undefined;
        data["businessHours"] = this.businessHours;
        data["comments"] = this.comments;
        data["sapBusinessPartner"] = this.sapBusinessPartner ? this.sapBusinessPartner.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetBusinessDto {
    typeId: string | undefined;
    statusId: string | undefined;
    name: string | undefined;
    additionalName: string | undefined;
    addressAddition: string | undefined;
    uid: string | undefined;
    gln: string | undefined;
    bur: string | undefined;
    sapId: string | undefined;
    legalFormId: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    countryId: string | undefined;
    cantonId: string | undefined;
    postOfficeBox: string | undefined;
    languageOfCorrespondenceId: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    fax: string | undefined;
    website: string | undefined;
    dateOfOpening: DateTime | undefined;
    dateOfClosure: DateTime | undefined;
    businessHours: string | undefined;
    comments: string | undefined;
    sapBusinessPartner: SapBusinessPartnerDto;
    id: number;
}

export class GetBusinessesOutput implements IGetBusinessesOutput {
    totalCount!: number;
    items!: BusinessDto[] | undefined;

    constructor(data?: IGetBusinessesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetBusinessesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetBusinessesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetBusinessesOutput {
    totalCount: number;
    items: BusinessDto[] | undefined;
}

export class UpdateBusinessInput implements IUpdateBusinessInput {
    business!: BusinessDto;

    constructor(data?: IUpdateBusinessInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.business = _data["business"] ? BusinessDto.fromJS(_data["business"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateBusinessInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBusinessInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["business"] = this.business ? this.business.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateBusinessInput {
    business: BusinessDto;
}

export class CacheDto implements ICacheDto {
    name!: string | undefined;

    constructor(data?: ICacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CacheDto {
        data = typeof data === 'object' ? data : {};
        let result = new CacheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICacheDto {
    name: string | undefined;
}

export class EmploymentChangeRequestDto implements IEmploymentChangeRequestDto {
    employmentId!: number | undefined;
    personLicenceId!: number | undefined;
    businessTypeId!: string | undefined;
    businessName!: string | undefined;
    businessName2!: string | undefined;
    addressAddition!: string | undefined;
    uid!: string | undefined;
    gln!: string | undefined;
    medRegId!: number | undefined;
    legalFormId!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    postOfficeBox!: string | undefined;
    languageOfCorrespondenceId!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email1!: string | undefined;
    email2!: string | undefined;
    mobile!: string | undefined;
    website!: string | undefined;
    dateOfEmployment!: DateTime | undefined;
    dateOfEndOfEmployment!: DateTime | undefined;
    dateOfStatusChange!: DateTime | undefined;
    statusId!: string | undefined;
    levelOfEmployment!: number | undefined;
    roleId!: string | undefined;
    remark!: string | undefined;
    isMobileEmployment!: boolean;

    constructor(data?: IEmploymentChangeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employmentId = _data["employmentId"];
            this.personLicenceId = _data["personLicenceId"];
            this.businessTypeId = _data["businessTypeId"];
            this.businessName = _data["businessName"];
            this.businessName2 = _data["businessName2"];
            this.addressAddition = _data["addressAddition"];
            this.uid = _data["uid"];
            this.gln = _data["gln"];
            this.medRegId = _data["medRegId"];
            this.legalFormId = _data["legalFormId"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email1 = _data["email1"];
            this.email2 = _data["email2"];
            this.mobile = _data["mobile"];
            this.website = _data["website"];
            this.dateOfEmployment = _data["dateOfEmployment"] ? DateTime.fromISO(_data["dateOfEmployment"].toString()) : <any>undefined;
            this.dateOfEndOfEmployment = _data["dateOfEndOfEmployment"] ? DateTime.fromISO(_data["dateOfEndOfEmployment"].toString()) : <any>undefined;
            this.dateOfStatusChange = _data["dateOfStatusChange"] ? DateTime.fromISO(_data["dateOfStatusChange"].toString()) : <any>undefined;
            this.statusId = _data["statusId"];
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.roleId = _data["roleId"];
            this.remark = _data["remark"];
            this.isMobileEmployment = _data["isMobileEmployment"];
        }
    }

    static fromJS(data: any): EmploymentChangeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmploymentChangeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employmentId"] = this.employmentId;
        data["personLicenceId"] = this.personLicenceId;
        data["businessTypeId"] = this.businessTypeId;
        data["businessName"] = this.businessName;
        data["businessName2"] = this.businessName2;
        data["addressAddition"] = this.addressAddition;
        data["uid"] = this.uid;
        data["gln"] = this.gln;
        data["medRegId"] = this.medRegId;
        data["legalFormId"] = this.legalFormId;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["postOfficeBox"] = this.postOfficeBox;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email1"] = this.email1;
        data["email2"] = this.email2;
        data["mobile"] = this.mobile;
        data["website"] = this.website;
        data["dateOfEmployment"] = this.dateOfEmployment ? this.dateOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEndOfEmployment"] = this.dateOfEndOfEmployment ? this.dateOfEndOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfStatusChange"] = this.dateOfStatusChange ? this.dateOfStatusChange.toFormat('yyyy-MM-dd') : <any>undefined;
        data["statusId"] = this.statusId;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["roleId"] = this.roleId;
        data["remark"] = this.remark;
        data["isMobileEmployment"] = this.isMobileEmployment;
        return data;
    }
}

export interface IEmploymentChangeRequestDto {
    employmentId: number | undefined;
    personLicenceId: number | undefined;
    businessTypeId: string | undefined;
    businessName: string | undefined;
    businessName2: string | undefined;
    addressAddition: string | undefined;
    uid: string | undefined;
    gln: string | undefined;
    medRegId: number | undefined;
    legalFormId: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    postOfficeBox: string | undefined;
    languageOfCorrespondenceId: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    email1: string | undefined;
    email2: string | undefined;
    mobile: string | undefined;
    website: string | undefined;
    dateOfEmployment: DateTime | undefined;
    dateOfEndOfEmployment: DateTime | undefined;
    dateOfStatusChange: DateTime | undefined;
    statusId: string | undefined;
    levelOfEmployment: number | undefined;
    roleId: string | undefined;
    remark: string | undefined;
    isMobileEmployment: boolean;
}

export enum ChatMessageReadState {
    Unread = 1,
    Read = 2,
}

export enum ChatSide {
    Sender = 1,
    Receiver = 2,
}

export class ChatMessageDto implements IChatMessageDto {
    userId!: number;
    tenantId!: number | undefined;
    targetUserId!: number;
    targetTenantId!: number | undefined;
    side!: ChatSide;
    readState!: ChatMessageReadState;
    receiverReadState!: ChatMessageReadState;
    message!: string | undefined;
    creationTime!: DateTime;
    sharedMessageId!: string | undefined;
    id!: number;

    constructor(data?: IChatMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.targetUserId = _data["targetUserId"];
            this.targetTenantId = _data["targetTenantId"];
            this.side = _data["side"];
            this.readState = _data["readState"];
            this.receiverReadState = _data["receiverReadState"];
            this.message = _data["message"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.sharedMessageId = _data["sharedMessageId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ChatMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChatMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["targetUserId"] = this.targetUserId;
        data["targetTenantId"] = this.targetTenantId;
        data["side"] = this.side;
        data["readState"] = this.readState;
        data["receiverReadState"] = this.receiverReadState;
        data["message"] = this.message;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["sharedMessageId"] = this.sharedMessageId;
        data["id"] = this.id;
        return data;
    }
}

export interface IChatMessageDto {
    userId: number;
    tenantId: number | undefined;
    targetUserId: number;
    targetTenantId: number | undefined;
    side: ChatSide;
    readState: ChatMessageReadState;
    receiverReadState: ChatMessageReadState;
    message: string | undefined;
    creationTime: DateTime;
    sharedMessageId: string | undefined;
    id: number;
}

export class GetUserChatFriendsWithSettingsOutput implements IGetUserChatFriendsWithSettingsOutput {
    serverTime!: DateTime;
    friends!: FriendDto[] | undefined;

    constructor(data?: IGetUserChatFriendsWithSettingsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serverTime = _data["serverTime"] ? DateTime.fromISO(_data["serverTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["friends"])) {
                this.friends = [] as any;
                for (let item of _data["friends"])
                    this.friends!.push(FriendDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserChatFriendsWithSettingsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserChatFriendsWithSettingsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serverTime"] = this.serverTime ? this.serverTime.toString() : <any>undefined;
        if (Array.isArray(this.friends)) {
            data["friends"] = [];
            for (let item of this.friends)
                data["friends"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUserChatFriendsWithSettingsOutput {
    serverTime: DateTime;
    friends: FriendDto[] | undefined;
}

export class MarkAllUnreadMessagesOfUserAsReadInput implements IMarkAllUnreadMessagesOfUserAsReadInput {
    tenantId!: number | undefined;
    userId!: number;

    constructor(data?: IMarkAllUnreadMessagesOfUserAsReadInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): MarkAllUnreadMessagesOfUserAsReadInput {
        data = typeof data === 'object' ? data : {};
        let result = new MarkAllUnreadMessagesOfUserAsReadInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IMarkAllUnreadMessagesOfUserAsReadInput {
    tenantId: number | undefined;
    userId: number;
}

export enum CodeCategory {
    None = 0,
    Profession = 1,
    Diploma = 2,
    Language = 3,
    PostgraduateTitle = 4,
    PgdType = 5,
    Title = 6,
    Document = 7,
    BusinessLegalForm = 8,
    Gender = 10,
    Address = 11,
    LanguageSkillLevel = 12,
    Canton = 13,
    Country = 14,
    ProfessionalLicenceStatus = 15,
    LanguageSkill = 16,
    YesNo = 17,
    IdentificationStatus = 18,
    IdentificationType = 19,
    ProfessionalLicenceType = 20,
    NotifyDaysBeforeEnd = 21,
    LegalBasis = 22,
    EmploymentRole = 23,
    NarcExtent = 24,
    ChangeRequestStatus = 25,
    ChangeRequestType = 26,
    BusinessType = 27,
    Degree = 33,
    EvaluationStatus = 34,
    EhcPracticeDescription = 35,
    ElectronicPatientRecord = 36,
    ApplicationReleaseAction = 37,
    DiplomaType = 38,
    EmploymentType = 39,
    SuccessfulLicenceApplication = 40,
    RestrictionType = 41,
    ProfessionalLicenceActivityStatus = 42,
    PostgraduateTitleType = 43,
    PendenceField = 44,
    PendenceStatus = 45,
    PendenceType = 46,
    SponsorshipType = 47,
    LegalBasisCorporateLicence = 48,
    DmsDocCategory = 49,
    DmsDocType = 50,
    OperatingTheatreType = 51,
    EmploymentStatus = 52,
    BusinessStatus = 53,
    ServiceArea = 54,
    DmsTemplateType = 55,
    PracticeType = 56,
    MutationType = 57,
    EmploymentContractType = 58,
    InvoiceStatus = 59,
    InvoiceDistributionMethod = 61,
    InvoiceContext = 62,
    SqlQueryCategory = 63,
    SensitiveDataDisciplinaryMeasureType = 64,
    InvoiceAddressType = 65,
    CantonalDepartment = 66,
    PreviousEmploymentType = 67,
    AdditionalLicenceInformationPerson = 68,
    AdditionalLicenceInformationSponsorship = 69,
    ProfessionalResponsibilityType = 70,
    EmploymentLocationType = 71,
    PersonLicenceMutationType = 72,
    CorporateLicenceMutationType = 73,
    District = 74,
    ReproductiveMedicineDetail = 75,
    RepresentationReason = 76,
    SponsorshipField = 94,
    SponsorshipRangeOfService = 95,
    ProductionLicenceStatus = 96,
    NursingHomeCategory = 97,
    PdfApplicationType = 98,
    SpecialCriminalRecord = 99,
}

export enum CodeSubcategory {
    None = 0,
    DaycareProfession = 1,
    PersonLicenceProfession = 2,
    EhcApplicationReleaseAction = 3,
    ExternalSystemMedReg = 4,
    ExternalSystemPsyReg = 5,
    ExternalSystemNareg = 6,
}

export class CodeEditDto implements ICodeEditDto {
    id!: string | undefined;
    codeCategory!: CodeCategory;
    codeSubcategory!: CodeSubcategory;
    isActive!: boolean;
    isSystem!: boolean;
    listIndex!: number | undefined;
    medRegId!: number | undefined;
    naregId!: number | undefined;
    psyRegId!: number | undefined;

    constructor(data?: ICodeEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.codeCategory = _data["codeCategory"];
            this.codeSubcategory = _data["codeSubcategory"];
            this.isActive = _data["isActive"];
            this.isSystem = _data["isSystem"];
            this.listIndex = _data["listIndex"];
            this.medRegId = _data["medRegId"];
            this.naregId = _data["naregId"];
            this.psyRegId = _data["psyRegId"];
        }
    }

    static fromJS(data: any): CodeEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CodeEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["codeCategory"] = this.codeCategory;
        data["codeSubcategory"] = this.codeSubcategory;
        data["isActive"] = this.isActive;
        data["isSystem"] = this.isSystem;
        data["listIndex"] = this.listIndex;
        data["medRegId"] = this.medRegId;
        data["naregId"] = this.naregId;
        data["psyRegId"] = this.psyRegId;
        return data;
    }
}

export interface ICodeEditDto {
    id: string | undefined;
    codeCategory: CodeCategory;
    codeSubcategory: CodeSubcategory;
    isActive: boolean;
    isSystem: boolean;
    listIndex: number | undefined;
    medRegId: number | undefined;
    naregId: number | undefined;
    psyRegId: number | undefined;
}

export class CodeListDto implements ICodeListDto {
    codeCategory!: CodeCategory;
    codeSubcategory!: CodeSubcategory;
    isActive!: boolean;
    isSystem!: boolean;
    listIndex!: number | undefined;
    medRegId!: number | undefined;
    naregId!: number | undefined;
    psyRegId!: number | undefined;
    creationTime!: DateTime;
    id!: string | undefined;

    constructor(data?: ICodeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeCategory = _data["codeCategory"];
            this.codeSubcategory = _data["codeSubcategory"];
            this.isActive = _data["isActive"];
            this.isSystem = _data["isSystem"];
            this.listIndex = _data["listIndex"];
            this.medRegId = _data["medRegId"];
            this.naregId = _data["naregId"];
            this.psyRegId = _data["psyRegId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CodeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CodeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeCategory"] = this.codeCategory;
        data["codeSubcategory"] = this.codeSubcategory;
        data["isActive"] = this.isActive;
        data["isSystem"] = this.isSystem;
        data["listIndex"] = this.listIndex;
        data["medRegId"] = this.medRegId;
        data["naregId"] = this.naregId;
        data["psyRegId"] = this.psyRegId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ICodeListDto {
    codeCategory: CodeCategory;
    codeSubcategory: CodeSubcategory;
    isActive: boolean;
    isSystem: boolean;
    listIndex: number | undefined;
    medRegId: number | undefined;
    naregId: number | undefined;
    psyRegId: number | undefined;
    creationTime: DateTime;
    id: string | undefined;
}

export class CreateOrUpdateCodeInput implements ICreateOrUpdateCodeInput {
    code!: CodeEditDto;
    edit!: boolean;

    constructor(data?: ICreateOrUpdateCodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.code = new CodeEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] ? CodeEditDto.fromJS(_data["code"]) : new CodeEditDto();
            this.edit = _data["edit"];
        }
    }

    static fromJS(data: any): CreateOrUpdateCodeInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateCodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code ? this.code.toJSON() : <any>undefined;
        data["edit"] = this.edit;
        return data;
    }
}

export interface ICreateOrUpdateCodeInput {
    code: CodeEditDto;
    edit: boolean;
}

export class GetCodeForEditOutput implements IGetCodeForEditOutput {
    code!: CodeEditDto;

    constructor(data?: IGetCodeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] ? CodeEditDto.fromJS(_data["code"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCodeForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCodeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code ? this.code.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCodeForEditOutput {
    code: CodeEditDto;
}

export class HealthRegisterCodeDto implements IHealthRegisterCodeDto {
    healthRegisterId!: number;
    healthRegisterDescription!: string | undefined;
    sironaId!: string | undefined;

    constructor(data?: IHealthRegisterCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthRegisterId = _data["healthRegisterId"];
            this.healthRegisterDescription = _data["healthRegisterDescription"];
            this.sironaId = _data["sironaId"];
        }
    }

    static fromJS(data: any): HealthRegisterCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthRegisterCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthRegisterId"] = this.healthRegisterId;
        data["healthRegisterDescription"] = this.healthRegisterDescription;
        data["sironaId"] = this.sironaId;
        return data;
    }
}

export interface IHealthRegisterCodeDto {
    healthRegisterId: number;
    healthRegisterDescription: string | undefined;
    sironaId: string | undefined;
}

export class HealthRegisterLabelDto implements IHealthRegisterLabelDto {
    labelDe!: string | undefined;
    labelFr!: string | undefined;
    labelIt!: string | undefined;
    labelEn!: string | undefined;

    constructor(data?: IHealthRegisterLabelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.labelDe = _data["labelDe"];
            this.labelFr = _data["labelFr"];
            this.labelIt = _data["labelIt"];
            this.labelEn = _data["labelEn"];
        }
    }

    static fromJS(data: any): HealthRegisterLabelDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthRegisterLabelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["labelDe"] = this.labelDe;
        data["labelFr"] = this.labelFr;
        data["labelIt"] = this.labelIt;
        data["labelEn"] = this.labelEn;
        return data;
    }
}

export interface IHealthRegisterLabelDto {
    labelDe: string | undefined;
    labelFr: string | undefined;
    labelIt: string | undefined;
    labelEn: string | undefined;
}

export class HealthRegisterCode implements IHealthRegisterCode {
    healthRegisterId!: number;
    healthRegisterDescription!: string | undefined;
    sironaId!: string | undefined;

    constructor(data?: IHealthRegisterCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthRegisterId = _data["healthRegisterId"];
            this.healthRegisterDescription = _data["healthRegisterDescription"];
            this.sironaId = _data["sironaId"];
        }
    }

    static fromJS(data: any): HealthRegisterCode {
        data = typeof data === 'object' ? data : {};
        let result = new HealthRegisterCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthRegisterId"] = this.healthRegisterId;
        data["healthRegisterDescription"] = this.healthRegisterDescription;
        data["sironaId"] = this.sironaId;
        return data;
    }
}

export interface IHealthRegisterCode {
    healthRegisterId: number;
    healthRegisterDescription: string | undefined;
    sironaId: string | undefined;
}

export class ApplicationUploadFilesInput implements IApplicationUploadFilesInput {
    caseId!: string;
    step!: number;
    typeId!: string;
    appendFiles!: boolean;
    files!: GeneralFileDto[];

    constructor(data?: IApplicationUploadFilesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.files = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.step = _data["step"];
            this.typeId = _data["typeId"];
            this.appendFiles = _data["appendFiles"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(GeneralFileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApplicationUploadFilesInput {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationUploadFilesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["step"] = this.step;
        data["typeId"] = this.typeId;
        data["appendFiles"] = this.appendFiles;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface IApplicationUploadFilesInput {
    caseId: string;
    step: number;
    typeId: string;
    appendFiles: boolean;
    files: GeneralFileDto[];
}

export class FindUsersInput implements IFindUsersInput {
    tenantId!: number | undefined;
    excludeCurrentUser!: boolean;
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | undefined;

    constructor(data?: IFindUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.excludeCurrentUser = _data["excludeCurrentUser"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): FindUsersInput {
        data = typeof data === 'object' ? data : {};
        let result = new FindUsersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["excludeCurrentUser"] = this.excludeCurrentUser;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data;
    }
}

export interface IFindUsersInput {
    tenantId: number | undefined;
    excludeCurrentUser: boolean;
    maxResultCount: number;
    skipCount: number;
    filter: string | undefined;
}

export class GeneralFileDto implements IGeneralFileDto {
    file!: string;
    name!: string | undefined;
    typeId!: string | undefined;
    isMandatory!: boolean | undefined;
    additionalProperties!: { [key: string]: string; } | undefined;
    id!: number;

    constructor(data?: IGeneralFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.file = _data["file"];
            this.name = _data["name"];
            this.typeId = _data["typeId"];
            this.isMandatory = _data["isMandatory"];
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GeneralFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["file"] = this.file;
        data["name"] = this.name;
        data["typeId"] = this.typeId;
        data["isMandatory"] = this.isMandatory;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IGeneralFileDto {
    file: string;
    name: string | undefined;
    typeId: string | undefined;
    isMandatory: boolean | undefined;
    additionalProperties: { [key: string]: string; } | undefined;
    id: number;
}

export class GeneralFileInfoDto implements IGeneralFileInfoDto {
    name!: string | undefined;
    typeId!: string | undefined;
    isMandatory!: boolean | undefined;
    additionalProperties!: { [key: string]: string; } | undefined;
    id!: number;

    constructor(data?: IGeneralFileInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.typeId = _data["typeId"];
            this.isMandatory = _data["isMandatory"];
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GeneralFileInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralFileInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["typeId"] = this.typeId;
        data["isMandatory"] = this.isMandatory;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IGeneralFileInfoDto {
    name: string | undefined;
    typeId: string | undefined;
    isMandatory: boolean | undefined;
    additionalProperties: { [key: string]: string; } | undefined;
    id: number;
}

export class GetDefaultEditionNameOutput implements IGetDefaultEditionNameOutput {
    name!: string | undefined;

    constructor(data?: IGetDefaultEditionNameOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetDefaultEditionNameOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDefaultEditionNameOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IGetDefaultEditionNameOutput {
    name: string | undefined;
}

export class GeneralFileInfo implements IGeneralFileInfo {
    id!: number;
    name!: string | undefined;
    typeId!: string | undefined;
    isMandatory!: boolean | undefined;
    additionalProperties!: { [key: string]: string; } | undefined;

    constructor(data?: IGeneralFileInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.typeId = _data["typeId"];
            this.isMandatory = _data["isMandatory"];
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): GeneralFileInfo {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralFileInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["typeId"] = this.typeId;
        data["isMandatory"] = this.isMandatory;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        return data;
    }
}

export interface IGeneralFileInfo {
    id: number;
    name: string | undefined;
    typeId: string | undefined;
    isMandatory: boolean | undefined;
    additionalProperties: { [key: string]: string; } | undefined;
}

export class ConfigDto implements IConfigDto {
    settings!: { [key: string]: string; } | undefined;

    constructor(data?: IConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["settings"]) {
                this.settings = {} as any;
                for (let key in _data["settings"]) {
                    if (_data["settings"].hasOwnProperty(key))
                        (<any>this.settings)![key] = _data["settings"][key];
                }
            }
        }
    }

    static fromJS(data: any): ConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.settings) {
            data["settings"] = {};
            for (let key in this.settings) {
                if (this.settings.hasOwnProperty(key))
                    (<any>data["settings"])[key] = (<any>this.settings)[key];
            }
        }
        return data;
    }
}

export interface IConfigDto {
    settings: { [key: string]: string; } | undefined;
}

export class CreateOrUpdateExternalSystemCertificateInput implements ICreateOrUpdateExternalSystemCertificateInput {
    certificate!: string;
    certificatePassword!: string;
    externalSystemId!: ExternalSystemEnum;

    constructor(data?: ICreateOrUpdateExternalSystemCertificateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.certificate = _data["certificate"];
            this.certificatePassword = _data["certificatePassword"];
            this.externalSystemId = _data["externalSystemId"];
        }
    }

    static fromJS(data: any): CreateOrUpdateExternalSystemCertificateInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateExternalSystemCertificateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["certificate"] = this.certificate;
        data["certificatePassword"] = this.certificatePassword;
        data["externalSystemId"] = this.externalSystemId;
        return data;
    }
}

export interface ICreateOrUpdateExternalSystemCertificateInput {
    certificate: string;
    certificatePassword: string;
    externalSystemId: ExternalSystemEnum;
}

export class CreateOrUpdateExternalSystemCredentialsInput implements ICreateOrUpdateExternalSystemCredentialsInput {
    externalSystemCredentialsList!: ExternalSystemCredentialsDto[] | undefined;

    constructor(data?: ICreateOrUpdateExternalSystemCredentialsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["externalSystemCredentialsList"])) {
                this.externalSystemCredentialsList = [] as any;
                for (let item of _data["externalSystemCredentialsList"])
                    this.externalSystemCredentialsList!.push(ExternalSystemCredentialsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateExternalSystemCredentialsInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateExternalSystemCredentialsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.externalSystemCredentialsList)) {
            data["externalSystemCredentialsList"] = [];
            for (let item of this.externalSystemCredentialsList)
                data["externalSystemCredentialsList"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateExternalSystemCredentialsInput {
    externalSystemCredentialsList: ExternalSystemCredentialsDto[] | undefined;
}

export class EnvironmentDto implements IEnvironmentDto {
    version!: string | undefined;
    environment!: string | undefined;
    lastCommitSha!: string | undefined;
    lastCommitShortSha!: string | undefined;
    fullSemVer!: string | undefined;
    releaseDate!: DateTime;
    showMaintenanceInfo!: boolean;

    constructor(data?: IEnvironmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.environment = _data["environment"];
            this.lastCommitSha = _data["lastCommitSha"];
            this.lastCommitShortSha = _data["lastCommitShortSha"];
            this.fullSemVer = _data["fullSemVer"];
            this.releaseDate = _data["releaseDate"] ? DateTime.fromISO(_data["releaseDate"].toString()) : <any>undefined;
            this.showMaintenanceInfo = _data["showMaintenanceInfo"];
        }
    }

    static fromJS(data: any): EnvironmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnvironmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["environment"] = this.environment;
        data["lastCommitSha"] = this.lastCommitSha;
        data["lastCommitShortSha"] = this.lastCommitShortSha;
        data["fullSemVer"] = this.fullSemVer;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toString() : <any>undefined;
        data["showMaintenanceInfo"] = this.showMaintenanceInfo;
        return data;
    }
}

export interface IEnvironmentDto {
    version: string | undefined;
    environment: string | undefined;
    lastCommitSha: string | undefined;
    lastCommitShortSha: string | undefined;
    fullSemVer: string | undefined;
    releaseDate: DateTime;
    showMaintenanceInfo: boolean;
}

export class ExternalSystemCredentialsDto implements IExternalSystemCredentialsDto {
    externalSystemId!: ExternalSystemEnum;
    userName!: string | undefined;
    password!: string | undefined;
    refreshToken!: string | undefined;

    constructor(data?: IExternalSystemCredentialsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalSystemId = _data["externalSystemId"];
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): ExternalSystemCredentialsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalSystemCredentialsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalSystemId"] = this.externalSystemId;
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface IExternalSystemCredentialsDto {
    externalSystemId: ExternalSystemEnum;
    userName: string | undefined;
    password: string | undefined;
    refreshToken: string | undefined;
}

export class ExternalSystemCredentialsOutput implements IExternalSystemCredentialsOutput {
    externalSystemId!: ExternalSystemEnum;
    userName!: string | undefined;
    password!: string | undefined;
    refreshToken!: string | undefined;
    certificate!: SslCertificateDto;

    constructor(data?: IExternalSystemCredentialsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalSystemId = _data["externalSystemId"];
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.refreshToken = _data["refreshToken"];
            this.certificate = _data["certificate"] ? SslCertificateDto.fromJS(_data["certificate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExternalSystemCredentialsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalSystemCredentialsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalSystemId"] = this.externalSystemId;
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["refreshToken"] = this.refreshToken;
        data["certificate"] = this.certificate ? this.certificate.toJSON() : <any>undefined;
        return data;
    }
}

export interface IExternalSystemCredentialsOutput {
    externalSystemId: ExternalSystemEnum;
    userName: string | undefined;
    password: string | undefined;
    refreshToken: string | undefined;
    certificate: SslCertificateDto;
}

export class GetExternalSystemCredentials implements IGetExternalSystemCredentials {
    externalSystemCredentials!: ExternalSystemCredentialsOutput[] | undefined;

    constructor(data?: IGetExternalSystemCredentials) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["externalSystemCredentials"])) {
                this.externalSystemCredentials = [] as any;
                for (let item of _data["externalSystemCredentials"])
                    this.externalSystemCredentials!.push(ExternalSystemCredentialsOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetExternalSystemCredentials {
        data = typeof data === 'object' ? data : {};
        let result = new GetExternalSystemCredentials();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.externalSystemCredentials)) {
            data["externalSystemCredentials"] = [];
            for (let item of this.externalSystemCredentials)
                data["externalSystemCredentials"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetExternalSystemCredentials {
    externalSystemCredentials: ExternalSystemCredentialsOutput[] | undefined;
}

export class MaintenanceConfigDto implements IMaintenanceConfigDto {
    isMaintenanceBannerEnabled!: boolean;
    disableLiaCreateUntil!: DateTime | undefined;
    disableLiaSubmissionUntil!: DateTime | undefined;
    disableLiaServiceUntil!: DateTime | undefined;
    disableLiaForAuthority!: boolean;
    disableClaCreateUntil!: DateTime | undefined;
    disableClaSubmissionUntil!: DateTime | undefined;
    disableClaServiceUntil!: DateTime | undefined;
    disableClaForAuthority!: boolean;

    constructor(data?: IMaintenanceConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isMaintenanceBannerEnabled = _data["isMaintenanceBannerEnabled"];
            this.disableLiaCreateUntil = _data["disableLiaCreateUntil"] ? DateTime.fromISO(_data["disableLiaCreateUntil"].toString()) : <any>undefined;
            this.disableLiaSubmissionUntil = _data["disableLiaSubmissionUntil"] ? DateTime.fromISO(_data["disableLiaSubmissionUntil"].toString()) : <any>undefined;
            this.disableLiaServiceUntil = _data["disableLiaServiceUntil"] ? DateTime.fromISO(_data["disableLiaServiceUntil"].toString()) : <any>undefined;
            this.disableLiaForAuthority = _data["disableLiaForAuthority"];
            this.disableClaCreateUntil = _data["disableClaCreateUntil"] ? DateTime.fromISO(_data["disableClaCreateUntil"].toString()) : <any>undefined;
            this.disableClaSubmissionUntil = _data["disableClaSubmissionUntil"] ? DateTime.fromISO(_data["disableClaSubmissionUntil"].toString()) : <any>undefined;
            this.disableClaServiceUntil = _data["disableClaServiceUntil"] ? DateTime.fromISO(_data["disableClaServiceUntil"].toString()) : <any>undefined;
            this.disableClaForAuthority = _data["disableClaForAuthority"];
        }
    }

    static fromJS(data: any): MaintenanceConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isMaintenanceBannerEnabled"] = this.isMaintenanceBannerEnabled;
        data["disableLiaCreateUntil"] = this.disableLiaCreateUntil ? this.disableLiaCreateUntil.toString() : <any>undefined;
        data["disableLiaSubmissionUntil"] = this.disableLiaSubmissionUntil ? this.disableLiaSubmissionUntil.toString() : <any>undefined;
        data["disableLiaServiceUntil"] = this.disableLiaServiceUntil ? this.disableLiaServiceUntil.toString() : <any>undefined;
        data["disableLiaForAuthority"] = this.disableLiaForAuthority;
        data["disableClaCreateUntil"] = this.disableClaCreateUntil ? this.disableClaCreateUntil.toString() : <any>undefined;
        data["disableClaSubmissionUntil"] = this.disableClaSubmissionUntil ? this.disableClaSubmissionUntil.toString() : <any>undefined;
        data["disableClaServiceUntil"] = this.disableClaServiceUntil ? this.disableClaServiceUntil.toString() : <any>undefined;
        data["disableClaForAuthority"] = this.disableClaForAuthority;
        return data;
    }
}

export interface IMaintenanceConfigDto {
    isMaintenanceBannerEnabled: boolean;
    disableLiaCreateUntil: DateTime | undefined;
    disableLiaSubmissionUntil: DateTime | undefined;
    disableLiaServiceUntil: DateTime | undefined;
    disableLiaForAuthority: boolean;
    disableClaCreateUntil: DateTime | undefined;
    disableClaSubmissionUntil: DateTime | undefined;
    disableClaServiceUntil: DateTime | undefined;
    disableClaForAuthority: boolean;
}

export class SironaSettingDto implements ISironaSettingDto {
    disableLanguageOfCorrespondence!: boolean;
    ignoreLanguageRequirementIfLicenceInAnotherCanton!: boolean;
    ignoreEmploymentAddressPostCodeHasToBeInCanton!: boolean;
    disableRejectLicenceAction!: boolean;
    disableApplicationReactivation!: boolean;
    allowedFileExtensionsForDocuments!: string | undefined;
    maxFileLengthForDocuments!: number;
    enableWindowsAuthentication!: boolean;
    sidapDefaultUserRoleId!: number;

    constructor(data?: ISironaSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.disableLanguageOfCorrespondence = _data["disableLanguageOfCorrespondence"];
            this.ignoreLanguageRequirementIfLicenceInAnotherCanton = _data["ignoreLanguageRequirementIfLicenceInAnotherCanton"];
            this.ignoreEmploymentAddressPostCodeHasToBeInCanton = _data["ignoreEmploymentAddressPostCodeHasToBeInCanton"];
            this.disableRejectLicenceAction = _data["disableRejectLicenceAction"];
            this.disableApplicationReactivation = _data["disableApplicationReactivation"];
            this.allowedFileExtensionsForDocuments = _data["allowedFileExtensionsForDocuments"];
            this.maxFileLengthForDocuments = _data["maxFileLengthForDocuments"];
            this.enableWindowsAuthentication = _data["enableWindowsAuthentication"];
            this.sidapDefaultUserRoleId = _data["sidapDefaultUserRoleId"];
        }
    }

    static fromJS(data: any): SironaSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new SironaSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["disableLanguageOfCorrespondence"] = this.disableLanguageOfCorrespondence;
        data["ignoreLanguageRequirementIfLicenceInAnotherCanton"] = this.ignoreLanguageRequirementIfLicenceInAnotherCanton;
        data["ignoreEmploymentAddressPostCodeHasToBeInCanton"] = this.ignoreEmploymentAddressPostCodeHasToBeInCanton;
        data["disableRejectLicenceAction"] = this.disableRejectLicenceAction;
        data["disableApplicationReactivation"] = this.disableApplicationReactivation;
        data["allowedFileExtensionsForDocuments"] = this.allowedFileExtensionsForDocuments;
        data["maxFileLengthForDocuments"] = this.maxFileLengthForDocuments;
        data["enableWindowsAuthentication"] = this.enableWindowsAuthentication;
        data["sidapDefaultUserRoleId"] = this.sidapDefaultUserRoleId;
        return data;
    }
}

export interface ISironaSettingDto {
    disableLanguageOfCorrespondence: boolean;
    ignoreLanguageRequirementIfLicenceInAnotherCanton: boolean;
    ignoreEmploymentAddressPostCodeHasToBeInCanton: boolean;
    disableRejectLicenceAction: boolean;
    disableApplicationReactivation: boolean;
    allowedFileExtensionsForDocuments: string | undefined;
    maxFileLengthForDocuments: number;
    enableWindowsAuthentication: boolean;
    sidapDefaultUserRoleId: number;
}

export class SslCertificateDto implements ISslCertificateDto {
    subject!: string | undefined;
    thumbprint!: string | undefined;
    validFrom!: DateTime;
    validTo!: DateTime;
    isValid!: boolean;

    constructor(data?: ISslCertificateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["subject"];
            this.thumbprint = _data["thumbprint"];
            this.validFrom = _data["validFrom"] ? DateTime.fromISO(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? DateTime.fromISO(_data["validTo"].toString()) : <any>undefined;
            this.isValid = _data["isValid"];
        }
    }

    static fromJS(data: any): SslCertificateDto {
        data = typeof data === 'object' ? data : {};
        let result = new SslCertificateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject;
        data["thumbprint"] = this.thumbprint;
        data["validFrom"] = this.validFrom ? this.validFrom.toString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toString() : <any>undefined;
        data["isValid"] = this.isValid;
        return data;
    }
}

export interface ISslCertificateDto {
    subject: string | undefined;
    thumbprint: string | undefined;
    validFrom: DateTime;
    validTo: DateTime;
    isValid: boolean;
}

export class UpdateCurrentUserSettingInput implements IUpdateCurrentUserSettingInput {
    name!: string;
    value!: string | undefined;

    constructor(data?: IUpdateCurrentUserSettingInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UpdateCurrentUserSettingInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCurrentUserSettingInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IUpdateCurrentUserSettingInput {
    name: string;
    value: string | undefined;
}

export class EmailSettingsEditDto implements IEmailSettingsEditDto {
    defaultFromAddress!: string | undefined;
    defaultFromDisplayName!: string | undefined;
    smtpHost!: string | undefined;
    smtpPort!: number;
    smtpUserName!: string | undefined;
    smtpPassword!: string | undefined;
    smtpDomain!: string | undefined;
    smtpEnableSsl!: boolean;
    smtpUseDefaultCredentials!: boolean;

    constructor(data?: IEmailSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultFromAddress = _data["defaultFromAddress"];
            this.defaultFromDisplayName = _data["defaultFromDisplayName"];
            this.smtpHost = _data["smtpHost"];
            this.smtpPort = _data["smtpPort"];
            this.smtpUserName = _data["smtpUserName"];
            this.smtpPassword = _data["smtpPassword"];
            this.smtpDomain = _data["smtpDomain"];
            this.smtpEnableSsl = _data["smtpEnableSsl"];
            this.smtpUseDefaultCredentials = _data["smtpUseDefaultCredentials"];
        }
    }

    static fromJS(data: any): EmailSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultFromAddress"] = this.defaultFromAddress;
        data["defaultFromDisplayName"] = this.defaultFromDisplayName;
        data["smtpHost"] = this.smtpHost;
        data["smtpPort"] = this.smtpPort;
        data["smtpUserName"] = this.smtpUserName;
        data["smtpPassword"] = this.smtpPassword;
        data["smtpDomain"] = this.smtpDomain;
        data["smtpEnableSsl"] = this.smtpEnableSsl;
        data["smtpUseDefaultCredentials"] = this.smtpUseDefaultCredentials;
        return data;
    }
}

export interface IEmailSettingsEditDto {
    defaultFromAddress: string | undefined;
    defaultFromDisplayName: string | undefined;
    smtpHost: string | undefined;
    smtpPort: number;
    smtpUserName: string | undefined;
    smtpPassword: string | undefined;
    smtpDomain: string | undefined;
    smtpEnableSsl: boolean;
    smtpUseDefaultCredentials: boolean;
}

export class ExternalLoginProviderSettingsEditDto implements IExternalLoginProviderSettingsEditDto {
    facebook_IsDeactivated!: boolean;
    facebook!: FacebookExternalLoginProviderSettings;
    google_IsDeactivated!: boolean;
    google!: GoogleExternalLoginProviderSettings;
    twitter_IsDeactivated!: boolean;
    twitter!: TwitterExternalLoginProviderSettings;
    microsoft_IsDeactivated!: boolean;
    microsoft!: MicrosoftExternalLoginProviderSettings;
    openIdConnect_IsDeactivated!: boolean;
    openIdConnect!: OpenIdConnectExternalLoginProviderSettings;
    openIdConnectClaimsMapping!: JsonClaimMapDto[] | undefined;
    beLogin_IsDeactivated!: boolean;
    beLogin!: OpenIdConnectExternalLoginProviderSettings;
    beLoginClaimsMapping!: JsonClaimMapDto[] | undefined;
    beLoginAutoLoginInfo!: JsonAutoLoginInfoDto[] | undefined;
    beLoginNoAutoLoginInfo!: JsonAutoLoginInfoDto[] | undefined;
    eKonto_IsDeactivated!: boolean;
    eKonto!: OpenIdConnectExternalLoginProviderSettings;
    eKontoClaimsMapping!: JsonClaimMapDto[] | undefined;
    eKontoAutoLoginInfo!: JsonAutoLoginInfoDto[] | undefined;
    eKontoNoAutoLoginInfo!: JsonAutoLoginInfoDto[] | undefined;
    wsFederation_IsDeactivated!: boolean;
    wsFederation!: WsFederationExternalLoginProviderSettings;
    wsFederationClaimsMapping!: JsonClaimMapDto[] | undefined;

    constructor(data?: IExternalLoginProviderSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facebook_IsDeactivated = _data["facebook_IsDeactivated"];
            this.facebook = _data["facebook"] ? FacebookExternalLoginProviderSettings.fromJS(_data["facebook"]) : <any>undefined;
            this.google_IsDeactivated = _data["google_IsDeactivated"];
            this.google = _data["google"] ? GoogleExternalLoginProviderSettings.fromJS(_data["google"]) : <any>undefined;
            this.twitter_IsDeactivated = _data["twitter_IsDeactivated"];
            this.twitter = _data["twitter"] ? TwitterExternalLoginProviderSettings.fromJS(_data["twitter"]) : <any>undefined;
            this.microsoft_IsDeactivated = _data["microsoft_IsDeactivated"];
            this.microsoft = _data["microsoft"] ? MicrosoftExternalLoginProviderSettings.fromJS(_data["microsoft"]) : <any>undefined;
            this.openIdConnect_IsDeactivated = _data["openIdConnect_IsDeactivated"];
            this.openIdConnect = _data["openIdConnect"] ? OpenIdConnectExternalLoginProviderSettings.fromJS(_data["openIdConnect"]) : <any>undefined;
            if (Array.isArray(_data["openIdConnectClaimsMapping"])) {
                this.openIdConnectClaimsMapping = [] as any;
                for (let item of _data["openIdConnectClaimsMapping"])
                    this.openIdConnectClaimsMapping!.push(JsonClaimMapDto.fromJS(item));
            }
            this.beLogin_IsDeactivated = _data["beLogin_IsDeactivated"];
            this.beLogin = _data["beLogin"] ? OpenIdConnectExternalLoginProviderSettings.fromJS(_data["beLogin"]) : <any>undefined;
            if (Array.isArray(_data["beLoginClaimsMapping"])) {
                this.beLoginClaimsMapping = [] as any;
                for (let item of _data["beLoginClaimsMapping"])
                    this.beLoginClaimsMapping!.push(JsonClaimMapDto.fromJS(item));
            }
            if (Array.isArray(_data["beLoginAutoLoginInfo"])) {
                this.beLoginAutoLoginInfo = [] as any;
                for (let item of _data["beLoginAutoLoginInfo"])
                    this.beLoginAutoLoginInfo!.push(JsonAutoLoginInfoDto.fromJS(item));
            }
            if (Array.isArray(_data["beLoginNoAutoLoginInfo"])) {
                this.beLoginNoAutoLoginInfo = [] as any;
                for (let item of _data["beLoginNoAutoLoginInfo"])
                    this.beLoginNoAutoLoginInfo!.push(JsonAutoLoginInfoDto.fromJS(item));
            }
            this.eKonto_IsDeactivated = _data["eKonto_IsDeactivated"];
            this.eKonto = _data["eKonto"] ? OpenIdConnectExternalLoginProviderSettings.fromJS(_data["eKonto"]) : <any>undefined;
            if (Array.isArray(_data["eKontoClaimsMapping"])) {
                this.eKontoClaimsMapping = [] as any;
                for (let item of _data["eKontoClaimsMapping"])
                    this.eKontoClaimsMapping!.push(JsonClaimMapDto.fromJS(item));
            }
            if (Array.isArray(_data["eKontoAutoLoginInfo"])) {
                this.eKontoAutoLoginInfo = [] as any;
                for (let item of _data["eKontoAutoLoginInfo"])
                    this.eKontoAutoLoginInfo!.push(JsonAutoLoginInfoDto.fromJS(item));
            }
            if (Array.isArray(_data["eKontoNoAutoLoginInfo"])) {
                this.eKontoNoAutoLoginInfo = [] as any;
                for (let item of _data["eKontoNoAutoLoginInfo"])
                    this.eKontoNoAutoLoginInfo!.push(JsonAutoLoginInfoDto.fromJS(item));
            }
            this.wsFederation_IsDeactivated = _data["wsFederation_IsDeactivated"];
            this.wsFederation = _data["wsFederation"] ? WsFederationExternalLoginProviderSettings.fromJS(_data["wsFederation"]) : <any>undefined;
            if (Array.isArray(_data["wsFederationClaimsMapping"])) {
                this.wsFederationClaimsMapping = [] as any;
                for (let item of _data["wsFederationClaimsMapping"])
                    this.wsFederationClaimsMapping!.push(JsonClaimMapDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExternalLoginProviderSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facebook_IsDeactivated"] = this.facebook_IsDeactivated;
        data["facebook"] = this.facebook ? this.facebook.toJSON() : <any>undefined;
        data["google_IsDeactivated"] = this.google_IsDeactivated;
        data["google"] = this.google ? this.google.toJSON() : <any>undefined;
        data["twitter_IsDeactivated"] = this.twitter_IsDeactivated;
        data["twitter"] = this.twitter ? this.twitter.toJSON() : <any>undefined;
        data["microsoft_IsDeactivated"] = this.microsoft_IsDeactivated;
        data["microsoft"] = this.microsoft ? this.microsoft.toJSON() : <any>undefined;
        data["openIdConnect_IsDeactivated"] = this.openIdConnect_IsDeactivated;
        data["openIdConnect"] = this.openIdConnect ? this.openIdConnect.toJSON() : <any>undefined;
        if (Array.isArray(this.openIdConnectClaimsMapping)) {
            data["openIdConnectClaimsMapping"] = [];
            for (let item of this.openIdConnectClaimsMapping)
                data["openIdConnectClaimsMapping"].push(item.toJSON());
        }
        data["beLogin_IsDeactivated"] = this.beLogin_IsDeactivated;
        data["beLogin"] = this.beLogin ? this.beLogin.toJSON() : <any>undefined;
        if (Array.isArray(this.beLoginClaimsMapping)) {
            data["beLoginClaimsMapping"] = [];
            for (let item of this.beLoginClaimsMapping)
                data["beLoginClaimsMapping"].push(item.toJSON());
        }
        if (Array.isArray(this.beLoginAutoLoginInfo)) {
            data["beLoginAutoLoginInfo"] = [];
            for (let item of this.beLoginAutoLoginInfo)
                data["beLoginAutoLoginInfo"].push(item.toJSON());
        }
        if (Array.isArray(this.beLoginNoAutoLoginInfo)) {
            data["beLoginNoAutoLoginInfo"] = [];
            for (let item of this.beLoginNoAutoLoginInfo)
                data["beLoginNoAutoLoginInfo"].push(item.toJSON());
        }
        data["eKonto_IsDeactivated"] = this.eKonto_IsDeactivated;
        data["eKonto"] = this.eKonto ? this.eKonto.toJSON() : <any>undefined;
        if (Array.isArray(this.eKontoClaimsMapping)) {
            data["eKontoClaimsMapping"] = [];
            for (let item of this.eKontoClaimsMapping)
                data["eKontoClaimsMapping"].push(item.toJSON());
        }
        if (Array.isArray(this.eKontoAutoLoginInfo)) {
            data["eKontoAutoLoginInfo"] = [];
            for (let item of this.eKontoAutoLoginInfo)
                data["eKontoAutoLoginInfo"].push(item.toJSON());
        }
        if (Array.isArray(this.eKontoNoAutoLoginInfo)) {
            data["eKontoNoAutoLoginInfo"] = [];
            for (let item of this.eKontoNoAutoLoginInfo)
                data["eKontoNoAutoLoginInfo"].push(item.toJSON());
        }
        data["wsFederation_IsDeactivated"] = this.wsFederation_IsDeactivated;
        data["wsFederation"] = this.wsFederation ? this.wsFederation.toJSON() : <any>undefined;
        if (Array.isArray(this.wsFederationClaimsMapping)) {
            data["wsFederationClaimsMapping"] = [];
            for (let item of this.wsFederationClaimsMapping)
                data["wsFederationClaimsMapping"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExternalLoginProviderSettingsEditDto {
    facebook_IsDeactivated: boolean;
    facebook: FacebookExternalLoginProviderSettings;
    google_IsDeactivated: boolean;
    google: GoogleExternalLoginProviderSettings;
    twitter_IsDeactivated: boolean;
    twitter: TwitterExternalLoginProviderSettings;
    microsoft_IsDeactivated: boolean;
    microsoft: MicrosoftExternalLoginProviderSettings;
    openIdConnect_IsDeactivated: boolean;
    openIdConnect: OpenIdConnectExternalLoginProviderSettings;
    openIdConnectClaimsMapping: JsonClaimMapDto[] | undefined;
    beLogin_IsDeactivated: boolean;
    beLogin: OpenIdConnectExternalLoginProviderSettings;
    beLoginClaimsMapping: JsonClaimMapDto[] | undefined;
    beLoginAutoLoginInfo: JsonAutoLoginInfoDto[] | undefined;
    beLoginNoAutoLoginInfo: JsonAutoLoginInfoDto[] | undefined;
    eKonto_IsDeactivated: boolean;
    eKonto: OpenIdConnectExternalLoginProviderSettings;
    eKontoClaimsMapping: JsonClaimMapDto[] | undefined;
    eKontoAutoLoginInfo: JsonAutoLoginInfoDto[] | undefined;
    eKontoNoAutoLoginInfo: JsonAutoLoginInfoDto[] | undefined;
    wsFederation_IsDeactivated: boolean;
    wsFederation: WsFederationExternalLoginProviderSettings;
    wsFederationClaimsMapping: JsonClaimMapDto[] | undefined;
}

export class ExternalLoginSettingsDto implements IExternalLoginSettingsDto {
    enabledSocialLoginSettings!: string[] | undefined;

    constructor(data?: IExternalLoginSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["enabledSocialLoginSettings"])) {
                this.enabledSocialLoginSettings = [] as any;
                for (let item of _data["enabledSocialLoginSettings"])
                    this.enabledSocialLoginSettings!.push(item);
            }
        }
    }

    static fromJS(data: any): ExternalLoginSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.enabledSocialLoginSettings)) {
            data["enabledSocialLoginSettings"] = [];
            for (let item of this.enabledSocialLoginSettings)
                data["enabledSocialLoginSettings"].push(item);
        }
        return data;
    }
}

export interface IExternalLoginSettingsDto {
    enabledSocialLoginSettings: string[] | undefined;
}

export class ThemeFooterSettingsDto implements IThemeFooterSettingsDto {
    fixedFooter!: boolean;

    constructor(data?: IThemeFooterSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fixedFooter = _data["fixedFooter"];
        }
    }

    static fromJS(data: any): ThemeFooterSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeFooterSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fixedFooter"] = this.fixedFooter;
        return data;
    }
}

export interface IThemeFooterSettingsDto {
    fixedFooter: boolean;
}

export class ThemeHeaderSettingsDto implements IThemeHeaderSettingsDto {
    desktopFixedHeader!: boolean;
    mobileFixedHeader!: boolean;
    headerSkin!: string | undefined;
    minimizeDesktopHeaderType!: string | undefined;

    constructor(data?: IThemeHeaderSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.desktopFixedHeader = _data["desktopFixedHeader"];
            this.mobileFixedHeader = _data["mobileFixedHeader"];
            this.headerSkin = _data["headerSkin"];
            this.minimizeDesktopHeaderType = _data["minimizeDesktopHeaderType"];
        }
    }

    static fromJS(data: any): ThemeHeaderSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeHeaderSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["desktopFixedHeader"] = this.desktopFixedHeader;
        data["mobileFixedHeader"] = this.mobileFixedHeader;
        data["headerSkin"] = this.headerSkin;
        data["minimizeDesktopHeaderType"] = this.minimizeDesktopHeaderType;
        return data;
    }
}

export interface IThemeHeaderSettingsDto {
    desktopFixedHeader: boolean;
    mobileFixedHeader: boolean;
    headerSkin: string | undefined;
    minimizeDesktopHeaderType: string | undefined;
}

export class ThemeLayoutSettingsDto implements IThemeLayoutSettingsDto {
    layoutType!: string | undefined;
    darkMode!: boolean;

    constructor(data?: IThemeLayoutSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.layoutType = _data["layoutType"];
            this.darkMode = _data["darkMode"];
        }
    }

    static fromJS(data: any): ThemeLayoutSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeLayoutSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["layoutType"] = this.layoutType;
        data["darkMode"] = this.darkMode;
        return data;
    }
}

export interface IThemeLayoutSettingsDto {
    layoutType: string | undefined;
    darkMode: boolean;
}

export class ThemeMenuSettingsDto implements IThemeMenuSettingsDto {
    position!: string | undefined;
    asideSkin!: string | undefined;
    fixedAside!: boolean;
    allowAsideMinimizing!: boolean;
    defaultMinimizedAside!: boolean;
    submenuToggle!: string | undefined;
    searchActive!: boolean;
    enableSecondary!: boolean;
    hoverableAside!: boolean;

    constructor(data?: IThemeMenuSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.position = _data["position"];
            this.asideSkin = _data["asideSkin"];
            this.fixedAside = _data["fixedAside"];
            this.allowAsideMinimizing = _data["allowAsideMinimizing"];
            this.defaultMinimizedAside = _data["defaultMinimizedAside"];
            this.submenuToggle = _data["submenuToggle"];
            this.searchActive = _data["searchActive"];
            this.enableSecondary = _data["enableSecondary"];
            this.hoverableAside = _data["hoverableAside"];
        }
    }

    static fromJS(data: any): ThemeMenuSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeMenuSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["position"] = this.position;
        data["asideSkin"] = this.asideSkin;
        data["fixedAside"] = this.fixedAside;
        data["allowAsideMinimizing"] = this.allowAsideMinimizing;
        data["defaultMinimizedAside"] = this.defaultMinimizedAside;
        data["submenuToggle"] = this.submenuToggle;
        data["searchActive"] = this.searchActive;
        data["enableSecondary"] = this.enableSecondary;
        data["hoverableAside"] = this.hoverableAside;
        return data;
    }
}

export interface IThemeMenuSettingsDto {
    position: string | undefined;
    asideSkin: string | undefined;
    fixedAside: boolean;
    allowAsideMinimizing: boolean;
    defaultMinimizedAside: boolean;
    submenuToggle: string | undefined;
    searchActive: boolean;
    enableSecondary: boolean;
    hoverableAside: boolean;
}

export class ThemeSettingsDto implements IThemeSettingsDto {
    theme!: string | undefined;
    layout!: ThemeLayoutSettingsDto;
    header!: ThemeHeaderSettingsDto;
    subHeader!: ThemeSubHeaderSettingsDto;
    menu!: ThemeMenuSettingsDto;
    footer!: ThemeFooterSettingsDto;

    constructor(data?: IThemeSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data["theme"];
            this.layout = _data["layout"] ? ThemeLayoutSettingsDto.fromJS(_data["layout"]) : <any>undefined;
            this.header = _data["header"] ? ThemeHeaderSettingsDto.fromJS(_data["header"]) : <any>undefined;
            this.subHeader = _data["subHeader"] ? ThemeSubHeaderSettingsDto.fromJS(_data["subHeader"]) : <any>undefined;
            this.menu = _data["menu"] ? ThemeMenuSettingsDto.fromJS(_data["menu"]) : <any>undefined;
            this.footer = _data["footer"] ? ThemeFooterSettingsDto.fromJS(_data["footer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ThemeSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        data["layout"] = this.layout ? this.layout.toJSON() : <any>undefined;
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        data["subHeader"] = this.subHeader ? this.subHeader.toJSON() : <any>undefined;
        data["menu"] = this.menu ? this.menu.toJSON() : <any>undefined;
        data["footer"] = this.footer ? this.footer.toJSON() : <any>undefined;
        return data;
    }
}

export interface IThemeSettingsDto {
    theme: string | undefined;
    layout: ThemeLayoutSettingsDto;
    header: ThemeHeaderSettingsDto;
    subHeader: ThemeSubHeaderSettingsDto;
    menu: ThemeMenuSettingsDto;
    footer: ThemeFooterSettingsDto;
}

export class ThemeSubHeaderSettingsDto implements IThemeSubHeaderSettingsDto {
    fixedSubHeader!: boolean;
    subheaderStyle!: string | undefined;
    subheaderSize!: number;
    titleStyle!: string | undefined;
    containerStyle!: string | undefined;
    subContainerStyle!: string | undefined;

    constructor(data?: IThemeSubHeaderSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fixedSubHeader = _data["fixedSubHeader"];
            this.subheaderStyle = _data["subheaderStyle"];
            this.subheaderSize = _data["subheaderSize"];
            this.titleStyle = _data["titleStyle"];
            this.containerStyle = _data["containerStyle"];
            this.subContainerStyle = _data["subContainerStyle"];
        }
    }

    static fromJS(data: any): ThemeSubHeaderSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeSubHeaderSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fixedSubHeader"] = this.fixedSubHeader;
        data["subheaderStyle"] = this.subheaderStyle;
        data["subheaderSize"] = this.subheaderSize;
        data["titleStyle"] = this.titleStyle;
        data["containerStyle"] = this.containerStyle;
        data["subContainerStyle"] = this.subContainerStyle;
        return data;
    }
}

export interface IThemeSubHeaderSettingsDto {
    fixedSubHeader: boolean;
    subheaderStyle: string | undefined;
    subheaderSize: number;
    titleStyle: string | undefined;
    containerStyle: string | undefined;
    subContainerStyle: string | undefined;
}

export class GeneralSettingsEditDto implements IGeneralSettingsEditDto {
    timezone!: string | undefined;
    timezoneForComparison!: string | undefined;

    constructor(data?: IGeneralSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timezone = _data["timezone"];
            this.timezoneForComparison = _data["timezoneForComparison"];
        }
    }

    static fromJS(data: any): GeneralSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timezone"] = this.timezone;
        data["timezoneForComparison"] = this.timezoneForComparison;
        return data;
    }
}

export interface IGeneralSettingsEditDto {
    timezone: string | undefined;
    timezoneForComparison: string | undefined;
}

export class HostBillingSettingsEditDto implements IHostBillingSettingsEditDto {
    legalName!: string | undefined;
    address!: string | undefined;

    constructor(data?: IHostBillingSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.legalName = _data["legalName"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): HostBillingSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostBillingSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["address"] = this.address;
        return data;
    }
}

export interface IHostBillingSettingsEditDto {
    legalName: string | undefined;
    address: string | undefined;
}

export class HostSettingsEditDto implements IHostSettingsEditDto {
    general!: GeneralSettingsEditDto;
    userManagement!: HostUserManagementSettingsEditDto;
    email!: EmailSettingsEditDto;
    tenantManagement!: TenantManagementSettingsEditDto;
    security!: SecuritySettingsEditDto;
    billing!: HostBillingSettingsEditDto;
    otherSettings!: OtherSettingsEditDto;
    externalLoginProviderSettings!: ExternalLoginProviderSettingsEditDto;

    constructor(data?: IHostSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.general = new GeneralSettingsEditDto();
            this.userManagement = new HostUserManagementSettingsEditDto();
            this.email = new EmailSettingsEditDto();
            this.tenantManagement = new TenantManagementSettingsEditDto();
            this.security = new SecuritySettingsEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.general = _data["general"] ? GeneralSettingsEditDto.fromJS(_data["general"]) : new GeneralSettingsEditDto();
            this.userManagement = _data["userManagement"] ? HostUserManagementSettingsEditDto.fromJS(_data["userManagement"]) : new HostUserManagementSettingsEditDto();
            this.email = _data["email"] ? EmailSettingsEditDto.fromJS(_data["email"]) : new EmailSettingsEditDto();
            this.tenantManagement = _data["tenantManagement"] ? TenantManagementSettingsEditDto.fromJS(_data["tenantManagement"]) : new TenantManagementSettingsEditDto();
            this.security = _data["security"] ? SecuritySettingsEditDto.fromJS(_data["security"]) : new SecuritySettingsEditDto();
            this.billing = _data["billing"] ? HostBillingSettingsEditDto.fromJS(_data["billing"]) : <any>undefined;
            this.otherSettings = _data["otherSettings"] ? OtherSettingsEditDto.fromJS(_data["otherSettings"]) : <any>undefined;
            this.externalLoginProviderSettings = _data["externalLoginProviderSettings"] ? ExternalLoginProviderSettingsEditDto.fromJS(_data["externalLoginProviderSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HostSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : <any>undefined;
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        data["tenantManagement"] = this.tenantManagement ? this.tenantManagement.toJSON() : <any>undefined;
        data["security"] = this.security ? this.security.toJSON() : <any>undefined;
        data["billing"] = this.billing ? this.billing.toJSON() : <any>undefined;
        data["otherSettings"] = this.otherSettings ? this.otherSettings.toJSON() : <any>undefined;
        data["externalLoginProviderSettings"] = this.externalLoginProviderSettings ? this.externalLoginProviderSettings.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHostSettingsEditDto {
    general: GeneralSettingsEditDto;
    userManagement: HostUserManagementSettingsEditDto;
    email: EmailSettingsEditDto;
    tenantManagement: TenantManagementSettingsEditDto;
    security: SecuritySettingsEditDto;
    billing: HostBillingSettingsEditDto;
    otherSettings: OtherSettingsEditDto;
    externalLoginProviderSettings: ExternalLoginProviderSettingsEditDto;
}

export class HostUserManagementSettingsEditDto implements IHostUserManagementSettingsEditDto {
    isEmailConfirmationRequiredForLogin!: boolean;
    smsVerificationEnabled!: boolean;
    isCookieConsentEnabled!: boolean;
    isQuickThemeSelectEnabled!: boolean;
    useCaptchaOnLogin!: boolean;
    allowUsingGravatarProfilePicture!: boolean;
    sessionTimeOutSettings!: SessionTimeOutSettingsEditDto;
    userPasswordSettings!: UserPasswordSettingsEditDto;

    constructor(data?: IHostUserManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEmailConfirmationRequiredForLogin = _data["isEmailConfirmationRequiredForLogin"];
            this.smsVerificationEnabled = _data["smsVerificationEnabled"];
            this.isCookieConsentEnabled = _data["isCookieConsentEnabled"];
            this.isQuickThemeSelectEnabled = _data["isQuickThemeSelectEnabled"];
            this.useCaptchaOnLogin = _data["useCaptchaOnLogin"];
            this.allowUsingGravatarProfilePicture = _data["allowUsingGravatarProfilePicture"];
            this.sessionTimeOutSettings = _data["sessionTimeOutSettings"] ? SessionTimeOutSettingsEditDto.fromJS(_data["sessionTimeOutSettings"]) : <any>undefined;
            this.userPasswordSettings = _data["userPasswordSettings"] ? UserPasswordSettingsEditDto.fromJS(_data["userPasswordSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HostUserManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostUserManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEmailConfirmationRequiredForLogin"] = this.isEmailConfirmationRequiredForLogin;
        data["smsVerificationEnabled"] = this.smsVerificationEnabled;
        data["isCookieConsentEnabled"] = this.isCookieConsentEnabled;
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        data["useCaptchaOnLogin"] = this.useCaptchaOnLogin;
        data["allowUsingGravatarProfilePicture"] = this.allowUsingGravatarProfilePicture;
        data["sessionTimeOutSettings"] = this.sessionTimeOutSettings ? this.sessionTimeOutSettings.toJSON() : <any>undefined;
        data["userPasswordSettings"] = this.userPasswordSettings ? this.userPasswordSettings.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHostUserManagementSettingsEditDto {
    isEmailConfirmationRequiredForLogin: boolean;
    smsVerificationEnabled: boolean;
    isCookieConsentEnabled: boolean;
    isQuickThemeSelectEnabled: boolean;
    useCaptchaOnLogin: boolean;
    allowUsingGravatarProfilePicture: boolean;
    sessionTimeOutSettings: SessionTimeOutSettingsEditDto;
    userPasswordSettings: UserPasswordSettingsEditDto;
}

export class OtherSettingsEditDto implements IOtherSettingsEditDto {
    isQuickThemeSelectEnabled!: boolean;

    constructor(data?: IOtherSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isQuickThemeSelectEnabled = _data["isQuickThemeSelectEnabled"];
        }
    }

    static fromJS(data: any): OtherSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new OtherSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        return data;
    }
}

export interface IOtherSettingsEditDto {
    isQuickThemeSelectEnabled: boolean;
}

export class SecuritySettingsEditDto implements ISecuritySettingsEditDto {
    allowOneConcurrentLoginPerUser!: boolean;
    useDefaultPasswordComplexitySettings!: boolean;
    passwordComplexity!: PasswordComplexitySetting;
    defaultPasswordComplexity!: PasswordComplexitySetting;
    userLockOut!: UserLockOutSettingsEditDto;
    twoFactorLogin!: TwoFactorLoginSettingsEditDto;

    constructor(data?: ISecuritySettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowOneConcurrentLoginPerUser = _data["allowOneConcurrentLoginPerUser"];
            this.useDefaultPasswordComplexitySettings = _data["useDefaultPasswordComplexitySettings"];
            this.passwordComplexity = _data["passwordComplexity"] ? PasswordComplexitySetting.fromJS(_data["passwordComplexity"]) : <any>undefined;
            this.defaultPasswordComplexity = _data["defaultPasswordComplexity"] ? PasswordComplexitySetting.fromJS(_data["defaultPasswordComplexity"]) : <any>undefined;
            this.userLockOut = _data["userLockOut"] ? UserLockOutSettingsEditDto.fromJS(_data["userLockOut"]) : <any>undefined;
            this.twoFactorLogin = _data["twoFactorLogin"] ? TwoFactorLoginSettingsEditDto.fromJS(_data["twoFactorLogin"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SecuritySettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecuritySettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowOneConcurrentLoginPerUser"] = this.allowOneConcurrentLoginPerUser;
        data["useDefaultPasswordComplexitySettings"] = this.useDefaultPasswordComplexitySettings;
        data["passwordComplexity"] = this.passwordComplexity ? this.passwordComplexity.toJSON() : <any>undefined;
        data["defaultPasswordComplexity"] = this.defaultPasswordComplexity ? this.defaultPasswordComplexity.toJSON() : <any>undefined;
        data["userLockOut"] = this.userLockOut ? this.userLockOut.toJSON() : <any>undefined;
        data["twoFactorLogin"] = this.twoFactorLogin ? this.twoFactorLogin.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISecuritySettingsEditDto {
    allowOneConcurrentLoginPerUser: boolean;
    useDefaultPasswordComplexitySettings: boolean;
    passwordComplexity: PasswordComplexitySetting;
    defaultPasswordComplexity: PasswordComplexitySetting;
    userLockOut: UserLockOutSettingsEditDto;
    twoFactorLogin: TwoFactorLoginSettingsEditDto;
}

export class SendTestEmailInput implements ISendTestEmailInput {
    emailAddress!: string;

    constructor(data?: ISendTestEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): SendTestEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendTestEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ISendTestEmailInput {
    emailAddress: string;
}

export class SessionTimeOutSettingsEditDto implements ISessionTimeOutSettingsEditDto {
    isEnabled!: boolean;
    timeOutSecond!: number;
    showTimeOutNotificationSecond!: number;
    showLockScreenWhenTimedOut!: boolean;

    constructor(data?: ISessionTimeOutSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
            this.timeOutSecond = _data["timeOutSecond"];
            this.showTimeOutNotificationSecond = _data["showTimeOutNotificationSecond"];
            this.showLockScreenWhenTimedOut = _data["showLockScreenWhenTimedOut"];
        }
    }

    static fromJS(data: any): SessionTimeOutSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SessionTimeOutSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["timeOutSecond"] = this.timeOutSecond;
        data["showTimeOutNotificationSecond"] = this.showTimeOutNotificationSecond;
        data["showLockScreenWhenTimedOut"] = this.showLockScreenWhenTimedOut;
        return data;
    }
}

export interface ISessionTimeOutSettingsEditDto {
    isEnabled: boolean;
    timeOutSecond: number;
    showTimeOutNotificationSecond: number;
    showLockScreenWhenTimedOut: boolean;
}

export class TenantManagementSettingsEditDto implements ITenantManagementSettingsEditDto {
    allowSelfRegistration!: boolean;
    isNewRegisteredTenantActiveByDefault!: boolean;
    useCaptchaOnRegistration!: boolean;
    defaultEditionId!: number | undefined;

    constructor(data?: ITenantManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowSelfRegistration = _data["allowSelfRegistration"];
            this.isNewRegisteredTenantActiveByDefault = _data["isNewRegisteredTenantActiveByDefault"];
            this.useCaptchaOnRegistration = _data["useCaptchaOnRegistration"];
            this.defaultEditionId = _data["defaultEditionId"];
        }
    }

    static fromJS(data: any): TenantManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredTenantActiveByDefault"] = this.isNewRegisteredTenantActiveByDefault;
        data["useCaptchaOnRegistration"] = this.useCaptchaOnRegistration;
        data["defaultEditionId"] = this.defaultEditionId;
        return data;
    }
}

export interface ITenantManagementSettingsEditDto {
    allowSelfRegistration: boolean;
    isNewRegisteredTenantActiveByDefault: boolean;
    useCaptchaOnRegistration: boolean;
    defaultEditionId: number | undefined;
}

export class TwoFactorLoginSettingsEditDto implements ITwoFactorLoginSettingsEditDto {
    isEnabledForApplication!: boolean;
    isEnabled!: boolean;
    isEmailProviderEnabled!: boolean;
    isSmsProviderEnabled!: boolean;
    isRememberBrowserEnabled!: boolean;
    isGoogleAuthenticatorEnabled!: boolean;

    constructor(data?: ITwoFactorLoginSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabledForApplication = _data["isEnabledForApplication"];
            this.isEnabled = _data["isEnabled"];
            this.isEmailProviderEnabled = _data["isEmailProviderEnabled"];
            this.isSmsProviderEnabled = _data["isSmsProviderEnabled"];
            this.isRememberBrowserEnabled = _data["isRememberBrowserEnabled"];
            this.isGoogleAuthenticatorEnabled = _data["isGoogleAuthenticatorEnabled"];
        }
    }

    static fromJS(data: any): TwoFactorLoginSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TwoFactorLoginSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabledForApplication"] = this.isEnabledForApplication;
        data["isEnabled"] = this.isEnabled;
        data["isEmailProviderEnabled"] = this.isEmailProviderEnabled;
        data["isSmsProviderEnabled"] = this.isSmsProviderEnabled;
        data["isRememberBrowserEnabled"] = this.isRememberBrowserEnabled;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        return data;
    }
}

export interface ITwoFactorLoginSettingsEditDto {
    isEnabledForApplication: boolean;
    isEnabled: boolean;
    isEmailProviderEnabled: boolean;
    isSmsProviderEnabled: boolean;
    isRememberBrowserEnabled: boolean;
    isGoogleAuthenticatorEnabled: boolean;
}

export class UserLockOutSettingsEditDto implements IUserLockOutSettingsEditDto {
    isEnabled!: boolean;
    maxFailedAccessAttemptsBeforeLockout!: number;
    defaultAccountLockoutSeconds!: number;

    constructor(data?: IUserLockOutSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
            this.maxFailedAccessAttemptsBeforeLockout = _data["maxFailedAccessAttemptsBeforeLockout"];
            this.defaultAccountLockoutSeconds = _data["defaultAccountLockoutSeconds"];
        }
    }

    static fromJS(data: any): UserLockOutSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLockOutSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["maxFailedAccessAttemptsBeforeLockout"] = this.maxFailedAccessAttemptsBeforeLockout;
        data["defaultAccountLockoutSeconds"] = this.defaultAccountLockoutSeconds;
        return data;
    }
}

export interface IUserLockOutSettingsEditDto {
    isEnabled: boolean;
    maxFailedAccessAttemptsBeforeLockout: number;
    defaultAccountLockoutSeconds: number;
}

export class UserPasswordSettingsEditDto implements IUserPasswordSettingsEditDto {
    enableCheckingLastXPasswordWhenPasswordChange!: boolean;
    checkingLastXPasswordCount!: number;
    enablePasswordExpiration!: boolean;
    passwordExpirationDayCount!: number;
    passwordResetCodeExpirationHours!: number;

    constructor(data?: IUserPasswordSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enableCheckingLastXPasswordWhenPasswordChange = _data["enableCheckingLastXPasswordWhenPasswordChange"];
            this.checkingLastXPasswordCount = _data["checkingLastXPasswordCount"];
            this.enablePasswordExpiration = _data["enablePasswordExpiration"];
            this.passwordExpirationDayCount = _data["passwordExpirationDayCount"];
            this.passwordResetCodeExpirationHours = _data["passwordResetCodeExpirationHours"];
        }
    }

    static fromJS(data: any): UserPasswordSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserPasswordSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enableCheckingLastXPasswordWhenPasswordChange"] = this.enableCheckingLastXPasswordWhenPasswordChange;
        data["checkingLastXPasswordCount"] = this.checkingLastXPasswordCount;
        data["enablePasswordExpiration"] = this.enablePasswordExpiration;
        data["passwordExpirationDayCount"] = this.passwordExpirationDayCount;
        data["passwordResetCodeExpirationHours"] = this.passwordResetCodeExpirationHours;
        return data;
    }
}

export interface IUserPasswordSettingsEditDto {
    enableCheckingLastXPasswordWhenPasswordChange: boolean;
    checkingLastXPasswordCount: number;
    enablePasswordExpiration: boolean;
    passwordExpirationDayCount: number;
    passwordResetCodeExpirationHours: number;
}

export class LdapSettingsEditDto implements ILdapSettingsEditDto {
    isModuleEnabled!: boolean;
    isEnabled!: boolean;
    domain!: string | undefined;
    userName!: string | undefined;
    password!: string | undefined;

    constructor(data?: ILdapSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isModuleEnabled = _data["isModuleEnabled"];
            this.isEnabled = _data["isEnabled"];
            this.domain = _data["domain"];
            this.userName = _data["userName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LdapSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new LdapSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isModuleEnabled"] = this.isModuleEnabled;
        data["isEnabled"] = this.isEnabled;
        data["domain"] = this.domain;
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data;
    }
}

export interface ILdapSettingsEditDto {
    isModuleEnabled: boolean;
    isEnabled: boolean;
    domain: string | undefined;
    userName: string | undefined;
    password: string | undefined;
}

export class TenantBillingSettingsEditDto implements ITenantBillingSettingsEditDto {
    legalName!: string | undefined;
    address!: string | undefined;
    taxVatNo!: string | undefined;

    constructor(data?: ITenantBillingSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.legalName = _data["legalName"];
            this.address = _data["address"];
            this.taxVatNo = _data["taxVatNo"];
        }
    }

    static fromJS(data: any): TenantBillingSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantBillingSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["address"] = this.address;
        data["taxVatNo"] = this.taxVatNo;
        return data;
    }
}

export interface ITenantBillingSettingsEditDto {
    legalName: string | undefined;
    address: string | undefined;
    taxVatNo: string | undefined;
}

export class TenantEmailSettingsEditDto implements ITenantEmailSettingsEditDto {
    useHostDefaultEmailSettings!: boolean;
    defaultFromAddress!: string | undefined;
    defaultFromDisplayName!: string | undefined;
    smtpHost!: string | undefined;
    smtpPort!: number;
    smtpUserName!: string | undefined;
    smtpPassword!: string | undefined;
    smtpDomain!: string | undefined;
    smtpEnableSsl!: boolean;
    smtpUseDefaultCredentials!: boolean;

    constructor(data?: ITenantEmailSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.useHostDefaultEmailSettings = _data["useHostDefaultEmailSettings"];
            this.defaultFromAddress = _data["defaultFromAddress"];
            this.defaultFromDisplayName = _data["defaultFromDisplayName"];
            this.smtpHost = _data["smtpHost"];
            this.smtpPort = _data["smtpPort"];
            this.smtpUserName = _data["smtpUserName"];
            this.smtpPassword = _data["smtpPassword"];
            this.smtpDomain = _data["smtpDomain"];
            this.smtpEnableSsl = _data["smtpEnableSsl"];
            this.smtpUseDefaultCredentials = _data["smtpUseDefaultCredentials"];
        }
    }

    static fromJS(data: any): TenantEmailSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEmailSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["useHostDefaultEmailSettings"] = this.useHostDefaultEmailSettings;
        data["defaultFromAddress"] = this.defaultFromAddress;
        data["defaultFromDisplayName"] = this.defaultFromDisplayName;
        data["smtpHost"] = this.smtpHost;
        data["smtpPort"] = this.smtpPort;
        data["smtpUserName"] = this.smtpUserName;
        data["smtpPassword"] = this.smtpPassword;
        data["smtpDomain"] = this.smtpDomain;
        data["smtpEnableSsl"] = this.smtpEnableSsl;
        data["smtpUseDefaultCredentials"] = this.smtpUseDefaultCredentials;
        return data;
    }
}

export interface ITenantEmailSettingsEditDto {
    useHostDefaultEmailSettings: boolean;
    defaultFromAddress: string | undefined;
    defaultFromDisplayName: string | undefined;
    smtpHost: string | undefined;
    smtpPort: number;
    smtpUserName: string | undefined;
    smtpPassword: string | undefined;
    smtpDomain: string | undefined;
    smtpEnableSsl: boolean;
    smtpUseDefaultCredentials: boolean;
}

export class TenantOtherSettingsEditDto implements ITenantOtherSettingsEditDto {
    isQuickThemeSelectEnabled!: boolean;
    isChatToggleButtonEnabled!: boolean;
    isHeaderNotificationsEnabled!: boolean;

    constructor(data?: ITenantOtherSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isQuickThemeSelectEnabled = _data["isQuickThemeSelectEnabled"];
            this.isChatToggleButtonEnabled = _data["isChatToggleButtonEnabled"];
            this.isHeaderNotificationsEnabled = _data["isHeaderNotificationsEnabled"];
        }
    }

    static fromJS(data: any): TenantOtherSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantOtherSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        data["isChatToggleButtonEnabled"] = this.isChatToggleButtonEnabled;
        data["isHeaderNotificationsEnabled"] = this.isHeaderNotificationsEnabled;
        return data;
    }
}

export interface ITenantOtherSettingsEditDto {
    isQuickThemeSelectEnabled: boolean;
    isChatToggleButtonEnabled: boolean;
    isHeaderNotificationsEnabled: boolean;
}

export class TenantSettingsEditDto implements ITenantSettingsEditDto {
    general!: GeneralSettingsEditDto;
    userManagement!: TenantUserManagementSettingsEditDto;
    email!: TenantEmailSettingsEditDto;
    ldap!: LdapSettingsEditDto;
    security!: SecuritySettingsEditDto;
    billing!: TenantBillingSettingsEditDto;
    otherSettings!: TenantOtherSettingsEditDto;
    externalLoginProviderSettings!: ExternalLoginProviderSettingsEditDto;

    constructor(data?: ITenantSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.userManagement = new TenantUserManagementSettingsEditDto();
            this.security = new SecuritySettingsEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.general = _data["general"] ? GeneralSettingsEditDto.fromJS(_data["general"]) : <any>undefined;
            this.userManagement = _data["userManagement"] ? TenantUserManagementSettingsEditDto.fromJS(_data["userManagement"]) : new TenantUserManagementSettingsEditDto();
            this.email = _data["email"] ? TenantEmailSettingsEditDto.fromJS(_data["email"]) : <any>undefined;
            this.ldap = _data["ldap"] ? LdapSettingsEditDto.fromJS(_data["ldap"]) : <any>undefined;
            this.security = _data["security"] ? SecuritySettingsEditDto.fromJS(_data["security"]) : new SecuritySettingsEditDto();
            this.billing = _data["billing"] ? TenantBillingSettingsEditDto.fromJS(_data["billing"]) : <any>undefined;
            this.otherSettings = _data["otherSettings"] ? TenantOtherSettingsEditDto.fromJS(_data["otherSettings"]) : <any>undefined;
            this.externalLoginProviderSettings = _data["externalLoginProviderSettings"] ? ExternalLoginProviderSettingsEditDto.fromJS(_data["externalLoginProviderSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TenantSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : <any>undefined;
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        data["ldap"] = this.ldap ? this.ldap.toJSON() : <any>undefined;
        data["security"] = this.security ? this.security.toJSON() : <any>undefined;
        data["billing"] = this.billing ? this.billing.toJSON() : <any>undefined;
        data["otherSettings"] = this.otherSettings ? this.otherSettings.toJSON() : <any>undefined;
        data["externalLoginProviderSettings"] = this.externalLoginProviderSettings ? this.externalLoginProviderSettings.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITenantSettingsEditDto {
    general: GeneralSettingsEditDto;
    userManagement: TenantUserManagementSettingsEditDto;
    email: TenantEmailSettingsEditDto;
    ldap: LdapSettingsEditDto;
    security: SecuritySettingsEditDto;
    billing: TenantBillingSettingsEditDto;
    otherSettings: TenantOtherSettingsEditDto;
    externalLoginProviderSettings: ExternalLoginProviderSettingsEditDto;
}

export class TenantUserManagementSettingsEditDto implements ITenantUserManagementSettingsEditDto {
    allowSelfRegistration!: boolean;
    isNewRegisteredUserActiveByDefault!: boolean;
    isEmailConfirmationRequiredForLogin!: boolean;
    useCaptchaOnRegistration!: boolean;
    useCaptchaOnLogin!: boolean;
    isCookieConsentEnabled!: boolean;
    isQuickThemeSelectEnabled!: boolean;
    allowUsingGravatarProfilePicture!: boolean;
    sessionTimeOutSettings!: SessionTimeOutSettingsEditDto;

    constructor(data?: ITenantUserManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowSelfRegistration = _data["allowSelfRegistration"];
            this.isNewRegisteredUserActiveByDefault = _data["isNewRegisteredUserActiveByDefault"];
            this.isEmailConfirmationRequiredForLogin = _data["isEmailConfirmationRequiredForLogin"];
            this.useCaptchaOnRegistration = _data["useCaptchaOnRegistration"];
            this.useCaptchaOnLogin = _data["useCaptchaOnLogin"];
            this.isCookieConsentEnabled = _data["isCookieConsentEnabled"];
            this.isQuickThemeSelectEnabled = _data["isQuickThemeSelectEnabled"];
            this.allowUsingGravatarProfilePicture = _data["allowUsingGravatarProfilePicture"];
            this.sessionTimeOutSettings = _data["sessionTimeOutSettings"] ? SessionTimeOutSettingsEditDto.fromJS(_data["sessionTimeOutSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TenantUserManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantUserManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredUserActiveByDefault"] = this.isNewRegisteredUserActiveByDefault;
        data["isEmailConfirmationRequiredForLogin"] = this.isEmailConfirmationRequiredForLogin;
        data["useCaptchaOnRegistration"] = this.useCaptchaOnRegistration;
        data["useCaptchaOnLogin"] = this.useCaptchaOnLogin;
        data["isCookieConsentEnabled"] = this.isCookieConsentEnabled;
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        data["allowUsingGravatarProfilePicture"] = this.allowUsingGravatarProfilePicture;
        data["sessionTimeOutSettings"] = this.sessionTimeOutSettings ? this.sessionTimeOutSettings.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITenantUserManagementSettingsEditDto {
    allowSelfRegistration: boolean;
    isNewRegisteredUserActiveByDefault: boolean;
    isEmailConfirmationRequiredForLogin: boolean;
    useCaptchaOnRegistration: boolean;
    useCaptchaOnLogin: boolean;
    isCookieConsentEnabled: boolean;
    isQuickThemeSelectEnabled: boolean;
    allowUsingGravatarProfilePicture: boolean;
    sessionTimeOutSettings: SessionTimeOutSettingsEditDto;
}

export class CorporateLicenceDto implements ICorporateLicenceDto {
    sponsorshipId!: number | undefined;
    sponsorshipName!: string | undefined;
    sponsorshipTypeId!: string | undefined;
    typeId!: CorporateLicenceType;
    statusId!: string | undefined;
    cantonId!: string | undefined;
    assistantPersonId!: number | undefined;
    assistantPersonName!: string | undefined;
    carePersonId!: number | undefined;
    carePersonName!: string | undefined;
    dateOfApplication!: DateTime | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfInspection!: DateTime | undefined;
    dateOfCancellation!: DateTime | undefined;
    legalBasisId!: string | undefined;
    legalBasisCantonId!: string | undefined;
    comments!: string | undefined;
    productionLicenceId!: string | undefined;
    healthRegisterTransfer!: boolean;
    healthRegisterId!: number | undefined;
    automaticNotificationAndStatusChange!: boolean;
    applicationId!: number | undefined;
    sapInvoiceStatusId!: string | undefined;
    dateOfSapInvoiceBilling!: DateTime | undefined;
    licenceName!: string | undefined;
    corporateLicenceRenewals!: CorporateLicenceRenewalDto[] | undefined;
    employments!: GetEmploymentDto[] | undefined;
    businessIds!: number[] | undefined;
    businesses!: GetBusinessDto[] | undefined;
    employmentIds!: number[] | undefined;
    medicalFieldDirectorId!: number | undefined;
    nursingDirectorEmploymentId!: number | undefined;
    nursingDirectorPersonName!: string | undefined;
    medicalDirectorEmploymentId!: number | undefined;
    medicalDirectorPersonName!: string | undefined;
    restrictions!: CorporateLicenceRestrictionDto[] | undefined;
    licenceDocuments!: GeneralFileInfoDto[] | undefined;
    corporateLicenceMutations!: GetCorporateLicenceMutationDto[] | undefined;
    corporateLicenceRangeOfServices!: CorporateLicenceRangeOfServiceDto[] | undefined;
    id!: number;

    constructor(data?: ICorporateLicenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sponsorshipId = _data["sponsorshipId"];
            this.sponsorshipName = _data["sponsorshipName"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.typeId = _data["typeId"];
            this.statusId = _data["statusId"];
            this.cantonId = _data["cantonId"];
            this.assistantPersonId = _data["assistantPersonId"];
            this.assistantPersonName = _data["assistantPersonName"];
            this.carePersonId = _data["carePersonId"];
            this.carePersonName = _data["carePersonName"];
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfInspection = _data["dateOfInspection"] ? DateTime.fromISO(_data["dateOfInspection"].toString()) : <any>undefined;
            this.dateOfCancellation = _data["dateOfCancellation"] ? DateTime.fromISO(_data["dateOfCancellation"].toString()) : <any>undefined;
            this.legalBasisId = _data["legalBasisId"];
            this.legalBasisCantonId = _data["legalBasisCantonId"];
            this.comments = _data["comments"];
            this.productionLicenceId = _data["productionLicenceId"];
            this.healthRegisterTransfer = _data["healthRegisterTransfer"];
            this.healthRegisterId = _data["healthRegisterId"];
            this.automaticNotificationAndStatusChange = _data["automaticNotificationAndStatusChange"];
            this.applicationId = _data["applicationId"];
            this.sapInvoiceStatusId = _data["sapInvoiceStatusId"];
            this.dateOfSapInvoiceBilling = _data["dateOfSapInvoiceBilling"] ? DateTime.fromISO(_data["dateOfSapInvoiceBilling"].toString()) : <any>undefined;
            this.licenceName = _data["licenceName"];
            if (Array.isArray(_data["corporateLicenceRenewals"])) {
                this.corporateLicenceRenewals = [] as any;
                for (let item of _data["corporateLicenceRenewals"])
                    this.corporateLicenceRenewals!.push(CorporateLicenceRenewalDto.fromJS(item));
            }
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(GetEmploymentDto.fromJS(item));
            }
            if (Array.isArray(_data["businessIds"])) {
                this.businessIds = [] as any;
                for (let item of _data["businessIds"])
                    this.businessIds!.push(item);
            }
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(GetBusinessDto.fromJS(item));
            }
            if (Array.isArray(_data["employmentIds"])) {
                this.employmentIds = [] as any;
                for (let item of _data["employmentIds"])
                    this.employmentIds!.push(item);
            }
            this.medicalFieldDirectorId = _data["medicalFieldDirectorId"];
            this.nursingDirectorEmploymentId = _data["nursingDirectorEmploymentId"];
            this.nursingDirectorPersonName = _data["nursingDirectorPersonName"];
            this.medicalDirectorEmploymentId = _data["medicalDirectorEmploymentId"];
            this.medicalDirectorPersonName = _data["medicalDirectorPersonName"];
            if (Array.isArray(_data["restrictions"])) {
                this.restrictions = [] as any;
                for (let item of _data["restrictions"])
                    this.restrictions!.push(CorporateLicenceRestrictionDto.fromJS(item));
            }
            if (Array.isArray(_data["licenceDocuments"])) {
                this.licenceDocuments = [] as any;
                for (let item of _data["licenceDocuments"])
                    this.licenceDocuments!.push(GeneralFileInfoDto.fromJS(item));
            }
            if (Array.isArray(_data["corporateLicenceMutations"])) {
                this.corporateLicenceMutations = [] as any;
                for (let item of _data["corporateLicenceMutations"])
                    this.corporateLicenceMutations!.push(GetCorporateLicenceMutationDto.fromJS(item));
            }
            if (Array.isArray(_data["corporateLicenceRangeOfServices"])) {
                this.corporateLicenceRangeOfServices = [] as any;
                for (let item of _data["corporateLicenceRangeOfServices"])
                    this.corporateLicenceRangeOfServices!.push(CorporateLicenceRangeOfServiceDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CorporateLicenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CorporateLicenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sponsorshipId"] = this.sponsorshipId;
        data["sponsorshipName"] = this.sponsorshipName;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["typeId"] = this.typeId;
        data["statusId"] = this.statusId;
        data["cantonId"] = this.cantonId;
        data["assistantPersonId"] = this.assistantPersonId;
        data["assistantPersonName"] = this.assistantPersonName;
        data["carePersonId"] = this.carePersonId;
        data["carePersonName"] = this.carePersonName;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfInspection"] = this.dateOfInspection ? this.dateOfInspection.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCancellation"] = this.dateOfCancellation ? this.dateOfCancellation.toFormat('yyyy-MM-dd') : <any>undefined;
        data["legalBasisId"] = this.legalBasisId;
        data["legalBasisCantonId"] = this.legalBasisCantonId;
        data["comments"] = this.comments;
        data["productionLicenceId"] = this.productionLicenceId;
        data["healthRegisterTransfer"] = this.healthRegisterTransfer;
        data["healthRegisterId"] = this.healthRegisterId;
        data["automaticNotificationAndStatusChange"] = this.automaticNotificationAndStatusChange;
        data["applicationId"] = this.applicationId;
        data["sapInvoiceStatusId"] = this.sapInvoiceStatusId;
        data["dateOfSapInvoiceBilling"] = this.dateOfSapInvoiceBilling ? this.dateOfSapInvoiceBilling.toFormat('yyyy-MM-dd') : <any>undefined;
        data["licenceName"] = this.licenceName;
        if (Array.isArray(this.corporateLicenceRenewals)) {
            data["corporateLicenceRenewals"] = [];
            for (let item of this.corporateLicenceRenewals)
                data["corporateLicenceRenewals"].push(item.toJSON());
        }
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item.toJSON());
        }
        if (Array.isArray(this.businessIds)) {
            data["businessIds"] = [];
            for (let item of this.businessIds)
                data["businessIds"].push(item);
        }
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        if (Array.isArray(this.employmentIds)) {
            data["employmentIds"] = [];
            for (let item of this.employmentIds)
                data["employmentIds"].push(item);
        }
        data["medicalFieldDirectorId"] = this.medicalFieldDirectorId;
        data["nursingDirectorEmploymentId"] = this.nursingDirectorEmploymentId;
        data["nursingDirectorPersonName"] = this.nursingDirectorPersonName;
        data["medicalDirectorEmploymentId"] = this.medicalDirectorEmploymentId;
        data["medicalDirectorPersonName"] = this.medicalDirectorPersonName;
        if (Array.isArray(this.restrictions)) {
            data["restrictions"] = [];
            for (let item of this.restrictions)
                data["restrictions"].push(item.toJSON());
        }
        if (Array.isArray(this.licenceDocuments)) {
            data["licenceDocuments"] = [];
            for (let item of this.licenceDocuments)
                data["licenceDocuments"].push(item.toJSON());
        }
        if (Array.isArray(this.corporateLicenceMutations)) {
            data["corporateLicenceMutations"] = [];
            for (let item of this.corporateLicenceMutations)
                data["corporateLicenceMutations"].push(item.toJSON());
        }
        if (Array.isArray(this.corporateLicenceRangeOfServices)) {
            data["corporateLicenceRangeOfServices"] = [];
            for (let item of this.corporateLicenceRangeOfServices)
                data["corporateLicenceRangeOfServices"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ICorporateLicenceDto {
    sponsorshipId: number | undefined;
    sponsorshipName: string | undefined;
    sponsorshipTypeId: string | undefined;
    typeId: CorporateLicenceType;
    statusId: string | undefined;
    cantonId: string | undefined;
    assistantPersonId: number | undefined;
    assistantPersonName: string | undefined;
    carePersonId: number | undefined;
    carePersonName: string | undefined;
    dateOfApplication: DateTime | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfInspection: DateTime | undefined;
    dateOfCancellation: DateTime | undefined;
    legalBasisId: string | undefined;
    legalBasisCantonId: string | undefined;
    comments: string | undefined;
    productionLicenceId: string | undefined;
    healthRegisterTransfer: boolean;
    healthRegisterId: number | undefined;
    automaticNotificationAndStatusChange: boolean;
    applicationId: number | undefined;
    sapInvoiceStatusId: string | undefined;
    dateOfSapInvoiceBilling: DateTime | undefined;
    licenceName: string | undefined;
    corporateLicenceRenewals: CorporateLicenceRenewalDto[] | undefined;
    employments: GetEmploymentDto[] | undefined;
    businessIds: number[] | undefined;
    businesses: GetBusinessDto[] | undefined;
    employmentIds: number[] | undefined;
    medicalFieldDirectorId: number | undefined;
    nursingDirectorEmploymentId: number | undefined;
    nursingDirectorPersonName: string | undefined;
    medicalDirectorEmploymentId: number | undefined;
    medicalDirectorPersonName: string | undefined;
    restrictions: CorporateLicenceRestrictionDto[] | undefined;
    licenceDocuments: GeneralFileInfoDto[] | undefined;
    corporateLicenceMutations: GetCorporateLicenceMutationDto[] | undefined;
    corporateLicenceRangeOfServices: CorporateLicenceRangeOfServiceDto[] | undefined;
    id: number;
}

export class CorporateLicenceMutationDto implements ICorporateLicenceMutationDto {
    dateOfApplication!: DateTime | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    comments!: string | undefined;
    types!: CorporateLicenceMutationTypeDto[] | undefined;

    constructor(data?: ICorporateLicenceMutationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.comments = _data["comments"];
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(CorporateLicenceMutationTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CorporateLicenceMutationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CorporateLicenceMutationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["comments"] = this.comments;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICorporateLicenceMutationDto {
    dateOfApplication: DateTime | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    comments: string | undefined;
    types: CorporateLicenceMutationTypeDto[] | undefined;
}

export class CorporateLicenceMutationTypeDto implements ICorporateLicenceMutationTypeDto {
    mutationTypeId!: string;

    constructor(data?: ICorporateLicenceMutationTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mutationTypeId = _data["mutationTypeId"];
        }
    }

    static fromJS(data: any): CorporateLicenceMutationTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CorporateLicenceMutationTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mutationTypeId"] = this.mutationTypeId;
        return data;
    }
}

export interface ICorporateLicenceMutationTypeDto {
    mutationTypeId: string;
}

export class CorporateLicenceRenewalDto implements ICorporateLicenceRenewalDto {
    corporateLicenceId!: number;
    dateOfApplication!: DateTime | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfInspection!: DateTime | undefined;
    comments!: string | undefined;
    sapInvoiceStatusId!: string | undefined;
    dateOfSapInvoiceBilling!: DateTime | undefined;
    claApplicationId!: number | undefined;
    id!: number;

    constructor(data?: ICorporateLicenceRenewalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.corporateLicenceId = _data["corporateLicenceId"];
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfInspection = _data["dateOfInspection"] ? DateTime.fromISO(_data["dateOfInspection"].toString()) : <any>undefined;
            this.comments = _data["comments"];
            this.sapInvoiceStatusId = _data["sapInvoiceStatusId"];
            this.dateOfSapInvoiceBilling = _data["dateOfSapInvoiceBilling"] ? DateTime.fromISO(_data["dateOfSapInvoiceBilling"].toString()) : <any>undefined;
            this.claApplicationId = _data["claApplicationId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CorporateLicenceRenewalDto {
        data = typeof data === 'object' ? data : {};
        let result = new CorporateLicenceRenewalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["corporateLicenceId"] = this.corporateLicenceId;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfInspection"] = this.dateOfInspection ? this.dateOfInspection.toFormat('yyyy-MM-dd') : <any>undefined;
        data["comments"] = this.comments;
        data["sapInvoiceStatusId"] = this.sapInvoiceStatusId;
        data["dateOfSapInvoiceBilling"] = this.dateOfSapInvoiceBilling ? this.dateOfSapInvoiceBilling.toFormat('yyyy-MM-dd') : <any>undefined;
        data["claApplicationId"] = this.claApplicationId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICorporateLicenceRenewalDto {
    corporateLicenceId: number;
    dateOfApplication: DateTime | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfInspection: DateTime | undefined;
    comments: string | undefined;
    sapInvoiceStatusId: string | undefined;
    dateOfSapInvoiceBilling: DateTime | undefined;
    claApplicationId: number | undefined;
    id: number;
}

export class CorporateLicenceRestrictionDto implements ICorporateLicenceRestrictionDto {
    typeId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfCompliance!: DateTime | undefined;
    remark!: string | undefined;
    id!: number;

    constructor(data?: ICorporateLicenceRestrictionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeId = _data["typeId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfCompliance = _data["dateOfCompliance"] ? DateTime.fromISO(_data["dateOfCompliance"].toString()) : <any>undefined;
            this.remark = _data["remark"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CorporateLicenceRestrictionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CorporateLicenceRestrictionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCompliance"] = this.dateOfCompliance ? this.dateOfCompliance.toFormat('yyyy-MM-dd') : <any>undefined;
        data["remark"] = this.remark;
        data["id"] = this.id;
        return data;
    }
}

export interface ICorporateLicenceRestrictionDto {
    typeId: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfCompliance: DateTime | undefined;
    remark: string | undefined;
    id: number;
}

export enum CorporateLicenceType {
    CorporateLicence = 0,
    LocalSalesLicence = 1,
    OnlineSalesLicence = 2,
    ExpenseHealthCareLicence = 3,
    AssistantLicence = 4,
    DelegatedLicence = 5,
    BloodstorageLicence = 6,
    NarcoticLicence = 7,
    ExpenseHealthCareLicenceProtectedOfVestedRights = 8,
}

export class CreateCorporateLicenceDto implements ICreateCorporateLicenceDto {
    sponsorshipId!: number;
    sponsorshipTypeId!: string;
    typeId!: CorporateLicenceType;
    cantonId!: string;
    legalBasisId!: string | undefined;
    legalBasisCantonId!: string | undefined;
    productionLicenceId!: string | undefined;
    licenceName!: string | undefined;

    constructor(data?: ICreateCorporateLicenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sponsorshipId = _data["sponsorshipId"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.typeId = _data["typeId"];
            this.cantonId = _data["cantonId"];
            this.legalBasisId = _data["legalBasisId"];
            this.legalBasisCantonId = _data["legalBasisCantonId"];
            this.productionLicenceId = _data["productionLicenceId"];
            this.licenceName = _data["licenceName"];
        }
    }

    static fromJS(data: any): CreateCorporateLicenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCorporateLicenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sponsorshipId"] = this.sponsorshipId;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["typeId"] = this.typeId;
        data["cantonId"] = this.cantonId;
        data["legalBasisId"] = this.legalBasisId;
        data["legalBasisCantonId"] = this.legalBasisCantonId;
        data["productionLicenceId"] = this.productionLicenceId;
        data["licenceName"] = this.licenceName;
        return data;
    }
}

export interface ICreateCorporateLicenceDto {
    sponsorshipId: number;
    sponsorshipTypeId: string;
    typeId: CorporateLicenceType;
    cantonId: string;
    legalBasisId: string | undefined;
    legalBasisCantonId: string | undefined;
    productionLicenceId: string | undefined;
    licenceName: string | undefined;
}

export class CreateCorporateLicenceRenewalDto implements ICreateCorporateLicenceRenewalDto {
    corporateLicenceId!: number;
    dateOfApplication!: DateTime | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfInspection!: DateTime | undefined;
    comments!: string | undefined;

    constructor(data?: ICreateCorporateLicenceRenewalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.corporateLicenceId = _data["corporateLicenceId"];
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfInspection = _data["dateOfInspection"] ? DateTime.fromISO(_data["dateOfInspection"].toString()) : <any>undefined;
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): CreateCorporateLicenceRenewalDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCorporateLicenceRenewalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["corporateLicenceId"] = this.corporateLicenceId;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfInspection"] = this.dateOfInspection ? this.dateOfInspection.toFormat('yyyy-MM-dd') : <any>undefined;
        data["comments"] = this.comments;
        return data;
    }
}

export interface ICreateCorporateLicenceRenewalDto {
    corporateLicenceId: number;
    dateOfApplication: DateTime | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfInspection: DateTime | undefined;
    comments: string | undefined;
}

export class GetCorporateLicenceDto implements IGetCorporateLicenceDto {
    sponsorshipId!: number | undefined;
    sponsorshipTypeId!: string | undefined;
    typeId!: CorporateLicenceType;
    statusId!: string | undefined;
    cantonId!: string | undefined;
    dateOfApplication!: DateTime | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfInspection!: DateTime | undefined;
    dateOfCancellation!: DateTime | undefined;
    legalBasisId!: string | undefined;
    legalBasisCantonId!: string | undefined;
    productionLicenceId!: string | undefined;
    comments!: string | undefined;
    id!: number;

    constructor(data?: IGetCorporateLicenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sponsorshipId = _data["sponsorshipId"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.typeId = _data["typeId"];
            this.statusId = _data["statusId"];
            this.cantonId = _data["cantonId"];
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfInspection = _data["dateOfInspection"] ? DateTime.fromISO(_data["dateOfInspection"].toString()) : <any>undefined;
            this.dateOfCancellation = _data["dateOfCancellation"] ? DateTime.fromISO(_data["dateOfCancellation"].toString()) : <any>undefined;
            this.legalBasisId = _data["legalBasisId"];
            this.legalBasisCantonId = _data["legalBasisCantonId"];
            this.productionLicenceId = _data["productionLicenceId"];
            this.comments = _data["comments"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetCorporateLicenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCorporateLicenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sponsorshipId"] = this.sponsorshipId;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["typeId"] = this.typeId;
        data["statusId"] = this.statusId;
        data["cantonId"] = this.cantonId;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfInspection"] = this.dateOfInspection ? this.dateOfInspection.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCancellation"] = this.dateOfCancellation ? this.dateOfCancellation.toFormat('yyyy-MM-dd') : <any>undefined;
        data["legalBasisId"] = this.legalBasisId;
        data["legalBasisCantonId"] = this.legalBasisCantonId;
        data["productionLicenceId"] = this.productionLicenceId;
        data["comments"] = this.comments;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetCorporateLicenceDto {
    sponsorshipId: number | undefined;
    sponsorshipTypeId: string | undefined;
    typeId: CorporateLicenceType;
    statusId: string | undefined;
    cantonId: string | undefined;
    dateOfApplication: DateTime | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfInspection: DateTime | undefined;
    dateOfCancellation: DateTime | undefined;
    legalBasisId: string | undefined;
    legalBasisCantonId: string | undefined;
    productionLicenceId: string | undefined;
    comments: string | undefined;
    id: number;
}

export class GetCorporateLicenceMutationDto implements IGetCorporateLicenceMutationDto {
    id!: number;
    dateOfApplication!: DateTime | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    comments!: string | undefined;
    types!: CorporateLicenceMutationTypeDto[] | undefined;

    constructor(data?: IGetCorporateLicenceMutationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.comments = _data["comments"];
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(CorporateLicenceMutationTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCorporateLicenceMutationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCorporateLicenceMutationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["comments"] = this.comments;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCorporateLicenceMutationDto {
    id: number;
    dateOfApplication: DateTime | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    comments: string | undefined;
    types: CorporateLicenceMutationTypeDto[] | undefined;
}

export class GetCorporateLicenceRestrictionDto implements IGetCorporateLicenceRestrictionDto {
    typeId!: string;
    dateOfIssue!: DateTime;
    dateOfEnd!: DateTime | undefined;
    dateOfCompliance!: DateTime | undefined;
    remark!: string | undefined;

    constructor(data?: IGetCorporateLicenceRestrictionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeId = _data["typeId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfCompliance = _data["dateOfCompliance"] ? DateTime.fromISO(_data["dateOfCompliance"].toString()) : <any>undefined;
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): GetCorporateLicenceRestrictionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCorporateLicenceRestrictionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCompliance"] = this.dateOfCompliance ? this.dateOfCompliance.toFormat('yyyy-MM-dd') : <any>undefined;
        data["remark"] = this.remark;
        return data;
    }
}

export interface IGetCorporateLicenceRestrictionDto {
    typeId: string;
    dateOfIssue: DateTime;
    dateOfEnd: DateTime | undefined;
    dateOfCompliance: DateTime | undefined;
    remark: string | undefined;
}

export class GetCorporateLicencesOutput implements IGetCorporateLicencesOutput {
    items!: CorporateLicenceDto[] | undefined;

    constructor(data?: IGetCorporateLicencesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CorporateLicenceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCorporateLicencesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCorporateLicencesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCorporateLicencesOutput {
    items: CorporateLicenceDto[] | undefined;
}

export class CorporateLicenceHistoryDto implements ICorporateLicenceHistoryDto {
    id!: number;
    time!: DateTime;
    reason!: string | undefined;
    userId!: number | undefined;
    entityChangeType!: EntityChangeType;
    propertyChanges!: { [key: string]: HistoryPropertyChange; } | undefined;
    statusId!: string | undefined;
    dateOfApplication!: DateTime | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    legalBasisId!: string | undefined;
    comments!: string | undefined;
    narcExtent!: string | undefined;

    constructor(data?: ICorporateLicenceHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.time = _data["time"] ? DateTime.fromISO(_data["time"].toString()) : <any>undefined;
            this.reason = _data["reason"];
            this.userId = _data["userId"];
            this.entityChangeType = _data["entityChangeType"];
            if (_data["propertyChanges"]) {
                this.propertyChanges = {} as any;
                for (let key in _data["propertyChanges"]) {
                    if (_data["propertyChanges"].hasOwnProperty(key))
                        (<any>this.propertyChanges)![key] = _data["propertyChanges"][key];
                }
            }
            this.statusId = _data["statusId"];
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.legalBasisId = _data["legalBasisId"];
            this.comments = _data["comments"];
            this.narcExtent = _data["narcExtent"];
        }
    }

    static fromJS(data: any): CorporateLicenceHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CorporateLicenceHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["time"] = this.time ? this.time.toString() : <any>undefined;
        data["reason"] = this.reason;
        data["userId"] = this.userId;
        data["entityChangeType"] = this.entityChangeType;
        if (this.propertyChanges) {
            data["propertyChanges"] = {};
            for (let key in this.propertyChanges) {
                if (this.propertyChanges.hasOwnProperty(key))
                    (<any>data["propertyChanges"])[key] = (<any>this.propertyChanges)[key];
            }
        }
        data["statusId"] = this.statusId;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["legalBasisId"] = this.legalBasisId;
        data["comments"] = this.comments;
        data["narcExtent"] = this.narcExtent;
        return data;
    }
}

export interface ICorporateLicenceHistoryDto {
    id: number;
    time: DateTime;
    reason: string | undefined;
    userId: number | undefined;
    entityChangeType: EntityChangeType;
    propertyChanges: { [key: string]: HistoryPropertyChange; } | undefined;
    statusId: string | undefined;
    dateOfApplication: DateTime | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    legalBasisId: string | undefined;
    comments: string | undefined;
    narcExtent: string | undefined;
}

export class SearchCorporateLicenceDto implements ISearchCorporateLicenceDto {
    sponsorshipId!: number | undefined;
    sponsorshipName!: string | undefined;
    sponsorshipTypeId!: string | undefined;
    typeId!: CorporateLicenceType;
    statusId!: string | undefined;
    cantonId!: string | undefined;
    assistantPersonId!: number | undefined;
    assistantPersonFirstName!: string | undefined;
    assistantPersonLastName!: string | undefined;
    carePersonName!: string | undefined;
    dateOfApplication!: DateTime | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfInspection!: DateTime | undefined;
    dateOfCancellation!: DateTime | undefined;
    legalBasisId!: string | undefined;
    legalBasisCantonId!: string | undefined;
    comments!: string | undefined;
    healthRegisterTransfer!: boolean;
    healthRegisterId!: number | undefined;
    automaticNotificationAndStatusChange!: boolean;
    licenceName!: string | undefined;
    id!: number;

    constructor(data?: ISearchCorporateLicenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sponsorshipId = _data["sponsorshipId"];
            this.sponsorshipName = _data["sponsorshipName"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.typeId = _data["typeId"];
            this.statusId = _data["statusId"];
            this.cantonId = _data["cantonId"];
            this.assistantPersonId = _data["assistantPersonId"];
            this.assistantPersonFirstName = _data["assistantPersonFirstName"];
            this.assistantPersonLastName = _data["assistantPersonLastName"];
            this.carePersonName = _data["carePersonName"];
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfInspection = _data["dateOfInspection"] ? DateTime.fromISO(_data["dateOfInspection"].toString()) : <any>undefined;
            this.dateOfCancellation = _data["dateOfCancellation"] ? DateTime.fromISO(_data["dateOfCancellation"].toString()) : <any>undefined;
            this.legalBasisId = _data["legalBasisId"];
            this.legalBasisCantonId = _data["legalBasisCantonId"];
            this.comments = _data["comments"];
            this.healthRegisterTransfer = _data["healthRegisterTransfer"];
            this.healthRegisterId = _data["healthRegisterId"];
            this.automaticNotificationAndStatusChange = _data["automaticNotificationAndStatusChange"];
            this.licenceName = _data["licenceName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SearchCorporateLicenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchCorporateLicenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sponsorshipId"] = this.sponsorshipId;
        data["sponsorshipName"] = this.sponsorshipName;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["typeId"] = this.typeId;
        data["statusId"] = this.statusId;
        data["cantonId"] = this.cantonId;
        data["assistantPersonId"] = this.assistantPersonId;
        data["assistantPersonFirstName"] = this.assistantPersonFirstName;
        data["assistantPersonLastName"] = this.assistantPersonLastName;
        data["carePersonName"] = this.carePersonName;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfInspection"] = this.dateOfInspection ? this.dateOfInspection.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCancellation"] = this.dateOfCancellation ? this.dateOfCancellation.toFormat('yyyy-MM-dd') : <any>undefined;
        data["legalBasisId"] = this.legalBasisId;
        data["legalBasisCantonId"] = this.legalBasisCantonId;
        data["comments"] = this.comments;
        data["healthRegisterTransfer"] = this.healthRegisterTransfer;
        data["healthRegisterId"] = this.healthRegisterId;
        data["automaticNotificationAndStatusChange"] = this.automaticNotificationAndStatusChange;
        data["licenceName"] = this.licenceName;
        data["id"] = this.id;
        return data;
    }
}

export interface ISearchCorporateLicenceDto {
    sponsorshipId: number | undefined;
    sponsorshipName: string | undefined;
    sponsorshipTypeId: string | undefined;
    typeId: CorporateLicenceType;
    statusId: string | undefined;
    cantonId: string | undefined;
    assistantPersonId: number | undefined;
    assistantPersonFirstName: string | undefined;
    assistantPersonLastName: string | undefined;
    carePersonName: string | undefined;
    dateOfApplication: DateTime | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfInspection: DateTime | undefined;
    dateOfCancellation: DateTime | undefined;
    legalBasisId: string | undefined;
    legalBasisCantonId: string | undefined;
    comments: string | undefined;
    healthRegisterTransfer: boolean;
    healthRegisterId: number | undefined;
    automaticNotificationAndStatusChange: boolean;
    licenceName: string | undefined;
    id: number;
}

export class SearchCorporateLicencesByUidAndTypeInputDto implements ISearchCorporateLicencesByUidAndTypeInputDto {
    uid!: string | undefined;
    licenceType!: CorporateLicenceType;
    sponsorshipType!: string | undefined;

    constructor(data?: ISearchCorporateLicencesByUidAndTypeInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uid = _data["uid"];
            this.licenceType = _data["licenceType"];
            this.sponsorshipType = _data["sponsorshipType"];
        }
    }

    static fromJS(data: any): SearchCorporateLicencesByUidAndTypeInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchCorporateLicencesByUidAndTypeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uid"] = this.uid;
        data["licenceType"] = this.licenceType;
        data["sponsorshipType"] = this.sponsorshipType;
        return data;
    }
}

export interface ISearchCorporateLicencesByUidAndTypeInputDto {
    uid: string | undefined;
    licenceType: CorporateLicenceType;
    sponsorshipType: string | undefined;
}

export class SearchCorporateLicencesInputDto implements ISearchCorporateLicencesInputDto {
    sponsorshipId!: number | undefined;
    personId!: number | undefined;
    types!: CorporateLicenceType[] | undefined;
    typesToIgnore!: CorporateLicenceType[] | undefined;
    filter!: string | undefined;
    sorting!: string | undefined;
    maxResultCount!: number;
    skipCount!: number;

    constructor(data?: ISearchCorporateLicencesInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sponsorshipId = _data["sponsorshipId"];
            this.personId = _data["personId"];
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(item);
            }
            if (Array.isArray(_data["typesToIgnore"])) {
                this.typesToIgnore = [] as any;
                for (let item of _data["typesToIgnore"])
                    this.typesToIgnore!.push(item);
            }
            this.filter = _data["filter"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): SearchCorporateLicencesInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchCorporateLicencesInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sponsorshipId"] = this.sponsorshipId;
        data["personId"] = this.personId;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item);
        }
        if (Array.isArray(this.typesToIgnore)) {
            data["typesToIgnore"] = [];
            for (let item of this.typesToIgnore)
                data["typesToIgnore"].push(item);
        }
        data["filter"] = this.filter;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }
}

export interface ISearchCorporateLicencesInputDto {
    sponsorshipId: number | undefined;
    personId: number | undefined;
    types: CorporateLicenceType[] | undefined;
    typesToIgnore: CorporateLicenceType[] | undefined;
    filter: string | undefined;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
}

export class SearchCorporateLicencesOutputDto implements ISearchCorporateLicencesOutputDto {
    totalCount!: number;
    items!: SearchCorporateLicenceDto[] | undefined;

    constructor(data?: ISearchCorporateLicencesOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SearchCorporateLicenceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchCorporateLicencesOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchCorporateLicencesOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchCorporateLicencesOutputDto {
    totalCount: number;
    items: SearchCorporateLicenceDto[] | undefined;
}

export class UpdateCorporateLicenceDto implements IUpdateCorporateLicenceDto {
    sponsorshipTypeId!: string;
    statusId!: string;
    cantonId!: string;
    assistantPersonId!: number | undefined;
    carePersonId!: number | undefined;
    dateOfApplication!: DateTime | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfInspection!: DateTime | undefined;
    dateOfCancellation!: DateTime | undefined;
    legalBasisId!: string | undefined;
    legalBasisCantonId!: string | undefined;
    comments!: string | undefined;
    businessIds!: number[] | undefined;
    employmentIds!: number[] | undefined;
    medicalFieldDirectorId!: number | undefined;
    medicalDirectorEmploymentId!: number | undefined;
    nursingDirectorEmploymentId!: number | undefined;
    corporateLicenceRangeOfServices!: CorporateLicenceRangeOfServiceDto[] | undefined;
    automaticNotificationAndStatusChange!: boolean;
    licenceName!: string | undefined;
    productionLicenceId!: string | undefined;

    constructor(data?: IUpdateCorporateLicenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.statusId = _data["statusId"];
            this.cantonId = _data["cantonId"];
            this.assistantPersonId = _data["assistantPersonId"];
            this.carePersonId = _data["carePersonId"];
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfInspection = _data["dateOfInspection"] ? DateTime.fromISO(_data["dateOfInspection"].toString()) : <any>undefined;
            this.dateOfCancellation = _data["dateOfCancellation"] ? DateTime.fromISO(_data["dateOfCancellation"].toString()) : <any>undefined;
            this.legalBasisId = _data["legalBasisId"];
            this.legalBasisCantonId = _data["legalBasisCantonId"];
            this.comments = _data["comments"];
            if (Array.isArray(_data["businessIds"])) {
                this.businessIds = [] as any;
                for (let item of _data["businessIds"])
                    this.businessIds!.push(item);
            }
            if (Array.isArray(_data["employmentIds"])) {
                this.employmentIds = [] as any;
                for (let item of _data["employmentIds"])
                    this.employmentIds!.push(item);
            }
            this.medicalFieldDirectorId = _data["medicalFieldDirectorId"];
            this.medicalDirectorEmploymentId = _data["medicalDirectorEmploymentId"];
            this.nursingDirectorEmploymentId = _data["nursingDirectorEmploymentId"];
            if (Array.isArray(_data["corporateLicenceRangeOfServices"])) {
                this.corporateLicenceRangeOfServices = [] as any;
                for (let item of _data["corporateLicenceRangeOfServices"])
                    this.corporateLicenceRangeOfServices!.push(CorporateLicenceRangeOfServiceDto.fromJS(item));
            }
            this.automaticNotificationAndStatusChange = _data["automaticNotificationAndStatusChange"];
            this.licenceName = _data["licenceName"];
            this.productionLicenceId = _data["productionLicenceId"];
        }
    }

    static fromJS(data: any): UpdateCorporateLicenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCorporateLicenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["statusId"] = this.statusId;
        data["cantonId"] = this.cantonId;
        data["assistantPersonId"] = this.assistantPersonId;
        data["carePersonId"] = this.carePersonId;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfInspection"] = this.dateOfInspection ? this.dateOfInspection.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCancellation"] = this.dateOfCancellation ? this.dateOfCancellation.toFormat('yyyy-MM-dd') : <any>undefined;
        data["legalBasisId"] = this.legalBasisId;
        data["legalBasisCantonId"] = this.legalBasisCantonId;
        data["comments"] = this.comments;
        if (Array.isArray(this.businessIds)) {
            data["businessIds"] = [];
            for (let item of this.businessIds)
                data["businessIds"].push(item);
        }
        if (Array.isArray(this.employmentIds)) {
            data["employmentIds"] = [];
            for (let item of this.employmentIds)
                data["employmentIds"].push(item);
        }
        data["medicalFieldDirectorId"] = this.medicalFieldDirectorId;
        data["medicalDirectorEmploymentId"] = this.medicalDirectorEmploymentId;
        data["nursingDirectorEmploymentId"] = this.nursingDirectorEmploymentId;
        if (Array.isArray(this.corporateLicenceRangeOfServices)) {
            data["corporateLicenceRangeOfServices"] = [];
            for (let item of this.corporateLicenceRangeOfServices)
                data["corporateLicenceRangeOfServices"].push(item.toJSON());
        }
        data["automaticNotificationAndStatusChange"] = this.automaticNotificationAndStatusChange;
        data["licenceName"] = this.licenceName;
        data["productionLicenceId"] = this.productionLicenceId;
        return data;
    }
}

export interface IUpdateCorporateLicenceDto {
    sponsorshipTypeId: string;
    statusId: string;
    cantonId: string;
    assistantPersonId: number | undefined;
    carePersonId: number | undefined;
    dateOfApplication: DateTime | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfInspection: DateTime | undefined;
    dateOfCancellation: DateTime | undefined;
    legalBasisId: string | undefined;
    legalBasisCantonId: string | undefined;
    comments: string | undefined;
    businessIds: number[] | undefined;
    employmentIds: number[] | undefined;
    medicalFieldDirectorId: number | undefined;
    medicalDirectorEmploymentId: number | undefined;
    nursingDirectorEmploymentId: number | undefined;
    corporateLicenceRangeOfServices: CorporateLicenceRangeOfServiceDto[] | undefined;
    automaticNotificationAndStatusChange: boolean;
    licenceName: string | undefined;
    productionLicenceId: string | undefined;
}

export class UpdateCorporateLicenceRenewalDto implements IUpdateCorporateLicenceRenewalDto {
    dateOfApplication!: DateTime | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfInspection!: DateTime | undefined;
    comments!: string | undefined;

    constructor(data?: IUpdateCorporateLicenceRenewalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfInspection = _data["dateOfInspection"] ? DateTime.fromISO(_data["dateOfInspection"].toString()) : <any>undefined;
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): UpdateCorporateLicenceRenewalDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCorporateLicenceRenewalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfInspection"] = this.dateOfInspection ? this.dateOfInspection.toFormat('yyyy-MM-dd') : <any>undefined;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IUpdateCorporateLicenceRenewalDto {
    dateOfApplication: DateTime | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfInspection: DateTime | undefined;
    comments: string | undefined;
}

export class UpdateCorporateLicenceRestrictionDto implements IUpdateCorporateLicenceRestrictionDto {
    typeId!: string;
    dateOfIssue!: DateTime;
    dateOfEnd!: DateTime | undefined;
    dateOfCompliance!: DateTime | undefined;
    remark!: string | undefined;

    constructor(data?: IUpdateCorporateLicenceRestrictionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeId = _data["typeId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfCompliance = _data["dateOfCompliance"] ? DateTime.fromISO(_data["dateOfCompliance"].toString()) : <any>undefined;
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): UpdateCorporateLicenceRestrictionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCorporateLicenceRestrictionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCompliance"] = this.dateOfCompliance ? this.dateOfCompliance.toFormat('yyyy-MM-dd') : <any>undefined;
        data["remark"] = this.remark;
        return data;
    }
}

export interface IUpdateCorporateLicenceRestrictionDto {
    typeId: string;
    dateOfIssue: DateTime;
    dateOfEnd: DateTime | undefined;
    dateOfCompliance: DateTime | undefined;
    remark: string | undefined;
}

export class ClaAidingResourcesDto implements IClaAidingResourcesDto {
    id!: number | undefined;
    claBusinessId!: number;
    whatAidingResources!: string | undefined;

    constructor(data?: IClaAidingResourcesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claBusinessId = _data["claBusinessId"];
            this.whatAidingResources = _data["whatAidingResources"];
        }
    }

    static fromJS(data: any): ClaAidingResourcesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaAidingResourcesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claBusinessId"] = this.claBusinessId;
        data["whatAidingResources"] = this.whatAidingResources;
        return data;
    }
}

export interface IClaAidingResourcesDto {
    id: number | undefined;
    claBusinessId: number;
    whatAidingResources: string | undefined;
}

export class ClaAssistantPhysicianDto implements IClaAssistantPhysicianDto {
    id!: number | undefined;
    hasAssistantLicenceId!: string;
    gln!: string;
    firstName!: string;
    lastName!: string;
    postgraduateTitleId!: string | undefined;
    dateOfStart!: DateTime;
    levelOfEmployment!: number;

    constructor(data?: IClaAssistantPhysicianDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.hasAssistantLicenceId = _data["hasAssistantLicenceId"];
            this.gln = _data["gln"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.dateOfStart = _data["dateOfStart"] ? DateTime.fromISO(_data["dateOfStart"].toString()) : <any>undefined;
            this.levelOfEmployment = _data["levelOfEmployment"];
        }
    }

    static fromJS(data: any): ClaAssistantPhysicianDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaAssistantPhysicianDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["hasAssistantLicenceId"] = this.hasAssistantLicenceId;
        data["gln"] = this.gln;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["dateOfStart"] = this.dateOfStart ? this.dateOfStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfEmployment"] = this.levelOfEmployment;
        return data;
    }
}

export interface IClaAssistantPhysicianDto {
    id: number | undefined;
    hasAssistantLicenceId: string;
    gln: string;
    firstName: string;
    lastName: string;
    postgraduateTitleId: string | undefined;
    dateOfStart: DateTime;
    levelOfEmployment: number;
}

export class ClaBusinessDirectorDto implements IClaBusinessDirectorDto {
    id!: number | undefined;
    claBusinessId!: number;
    gln!: string;
    firstName!: string;
    lastName!: string;
    isSameAsMedicalFieldManagementId!: string;
    levelOfEmployment!: number;
    professionalLicenceStatusId!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;

    constructor(data?: IClaBusinessDirectorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claBusinessId = _data["claBusinessId"];
            this.gln = _data["gln"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.isSameAsMedicalFieldManagementId = _data["isSameAsMedicalFieldManagementId"];
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.professionalLicenceStatusId = _data["professionalLicenceStatusId"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ClaBusinessDirectorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaBusinessDirectorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claBusinessId"] = this.claBusinessId;
        data["gln"] = this.gln;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["isSameAsMedicalFieldManagementId"] = this.isSameAsMedicalFieldManagementId;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["professionalLicenceStatusId"] = this.professionalLicenceStatusId;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        return data;
    }
}

export interface IClaBusinessDirectorDto {
    id: number | undefined;
    claBusinessId: number;
    gln: string;
    firstName: string;
    lastName: string;
    isSameAsMedicalFieldManagementId: string;
    levelOfEmployment: number;
    professionalLicenceStatusId: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
}

export class ClaBusinessDto implements IClaBusinessDto {
    id!: number | undefined;
    name!: string;
    additionalName!: string | undefined;
    postCode!: string;
    city!: string;
    street!: string;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    website!: string | undefined;
    gln!: string | undefined;
    bur!: string | undefined;
    dateOfOpening!: DateTime | undefined;
    dateOfClosure!: DateTime | undefined;
    businessHours!: string | undefined;
    hasLocalPharmacyId!: string | undefined;
    directors!: ClaBusinessDirectorDto[] | undefined;
    rangeOfServices!: ClaRangeOfServicesDto;
    readonly rangeOfServicesList!: ClaRangeOfServicesDto[] | undefined;
    treatmentItems!: ClaTreatmentDto[] | undefined;
    readonly treatmentsList!: ClaTreatmentDto[] | undefined;
    nursingBeds!: ClaNursingBedsDto;
    readonly nursingBedList!: ClaNursingBedsDto[] | undefined;
    floors!: ClaFloorsDto;
    readonly floorsList!: ClaFloorsDto[] | undefined;
    aidingResources!: ClaAidingResourcesDto;
    readonly aidingResourcesList!: ClaAidingResourcesDto[] | undefined;
    drugChambers!: ClaDrugChambersDto;
    readonly drugChambersList!: ClaDrugChambersDto[] | undefined;
    sanitaryFacilities!: ClaSanitaryFacilitiesDto;
    readonly sanitaryFacilitiesList!: ClaSanitaryFacilitiesDto[] | undefined;
    security!: ClaSecurityDto;
    readonly securityList!: ClaSecurityDto[] | undefined;
    wheelchairAccessibility!: ClaWheelchairAccessibilityDto;
    readonly wheelchairAccessibilityList!: ClaWheelchairAccessibilityDto[] | undefined;
    quality!: ClaQualityDto;
    readonly qualityList!: ClaQualityDto[] | undefined;
    serviceAreas!: ClaServiceAreasDto[] | undefined;
    readonly serviceAreasList!: ClaServiceAreasDto[] | undefined;
    personel!: ClaPersonelDto;
    readonly personelList!: ClaPersonelDto[] | undefined;
    infrastructure!: ClaInfrastructureDto;
    readonly infrastructureList!: ClaInfrastructureDto[] | undefined;
    rangeOfProducts!: SlasRangeOfProductsDto;
    readonly rangeOfProductsList!: SlasRangeOfProductsDto[] | undefined;
    productPreparation!: SlasProductPreparationDto;
    readonly productPreparationList!: SlasProductPreparationDto[] | undefined;
    localDrugSales!: SlasLocalDrugSalesDto;
    readonly localDrugSalesList!: SlasLocalDrugSalesDto[] | undefined;
    drugProduction!: SlasDrugProductionDto;
    readonly drugProductionList!: SlasDrugProductionDto[] | undefined;
    drugProductionThirdParty!: SlasDrugProductionThirdPartyDto;
    readonly drugProductionThirdPartyList!: SlasDrugProductionThirdPartyDto[] | undefined;

    constructor(data?: IClaBusinessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.additionalName = _data["additionalName"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.website = _data["website"];
            this.gln = _data["gln"];
            this.bur = _data["bur"];
            this.dateOfOpening = _data["dateOfOpening"] ? DateTime.fromISO(_data["dateOfOpening"].toString()) : <any>undefined;
            this.dateOfClosure = _data["dateOfClosure"] ? DateTime.fromISO(_data["dateOfClosure"].toString()) : <any>undefined;
            this.businessHours = _data["businessHours"];
            this.hasLocalPharmacyId = _data["hasLocalPharmacyId"];
            if (Array.isArray(_data["directors"])) {
                this.directors = [] as any;
                for (let item of _data["directors"])
                    this.directors!.push(ClaBusinessDirectorDto.fromJS(item));
            }
            this.rangeOfServices = _data["rangeOfServices"] ? ClaRangeOfServicesDto.fromJS(_data["rangeOfServices"]) : <any>undefined;
            if (Array.isArray(_data["rangeOfServicesList"])) {
                (<any>this).rangeOfServicesList = [] as any;
                for (let item of _data["rangeOfServicesList"])
                    (<any>this).rangeOfServicesList!.push(ClaRangeOfServicesDto.fromJS(item));
            }
            if (Array.isArray(_data["treatmentItems"])) {
                this.treatmentItems = [] as any;
                for (let item of _data["treatmentItems"])
                    this.treatmentItems!.push(ClaTreatmentDto.fromJS(item));
            }
            if (Array.isArray(_data["treatmentsList"])) {
                (<any>this).treatmentsList = [] as any;
                for (let item of _data["treatmentsList"])
                    (<any>this).treatmentsList!.push(ClaTreatmentDto.fromJS(item));
            }
            this.nursingBeds = _data["nursingBeds"] ? ClaNursingBedsDto.fromJS(_data["nursingBeds"]) : <any>undefined;
            if (Array.isArray(_data["nursingBedList"])) {
                (<any>this).nursingBedList = [] as any;
                for (let item of _data["nursingBedList"])
                    (<any>this).nursingBedList!.push(ClaNursingBedsDto.fromJS(item));
            }
            this.floors = _data["floors"] ? ClaFloorsDto.fromJS(_data["floors"]) : <any>undefined;
            if (Array.isArray(_data["floorsList"])) {
                (<any>this).floorsList = [] as any;
                for (let item of _data["floorsList"])
                    (<any>this).floorsList!.push(ClaFloorsDto.fromJS(item));
            }
            this.aidingResources = _data["aidingResources"] ? ClaAidingResourcesDto.fromJS(_data["aidingResources"]) : <any>undefined;
            if (Array.isArray(_data["aidingResourcesList"])) {
                (<any>this).aidingResourcesList = [] as any;
                for (let item of _data["aidingResourcesList"])
                    (<any>this).aidingResourcesList!.push(ClaAidingResourcesDto.fromJS(item));
            }
            this.drugChambers = _data["drugChambers"] ? ClaDrugChambersDto.fromJS(_data["drugChambers"]) : <any>undefined;
            if (Array.isArray(_data["drugChambersList"])) {
                (<any>this).drugChambersList = [] as any;
                for (let item of _data["drugChambersList"])
                    (<any>this).drugChambersList!.push(ClaDrugChambersDto.fromJS(item));
            }
            this.sanitaryFacilities = _data["sanitaryFacilities"] ? ClaSanitaryFacilitiesDto.fromJS(_data["sanitaryFacilities"]) : <any>undefined;
            if (Array.isArray(_data["sanitaryFacilitiesList"])) {
                (<any>this).sanitaryFacilitiesList = [] as any;
                for (let item of _data["sanitaryFacilitiesList"])
                    (<any>this).sanitaryFacilitiesList!.push(ClaSanitaryFacilitiesDto.fromJS(item));
            }
            this.security = _data["security"] ? ClaSecurityDto.fromJS(_data["security"]) : <any>undefined;
            if (Array.isArray(_data["securityList"])) {
                (<any>this).securityList = [] as any;
                for (let item of _data["securityList"])
                    (<any>this).securityList!.push(ClaSecurityDto.fromJS(item));
            }
            this.wheelchairAccessibility = _data["wheelchairAccessibility"] ? ClaWheelchairAccessibilityDto.fromJS(_data["wheelchairAccessibility"]) : <any>undefined;
            if (Array.isArray(_data["wheelchairAccessibilityList"])) {
                (<any>this).wheelchairAccessibilityList = [] as any;
                for (let item of _data["wheelchairAccessibilityList"])
                    (<any>this).wheelchairAccessibilityList!.push(ClaWheelchairAccessibilityDto.fromJS(item));
            }
            this.quality = _data["quality"] ? ClaQualityDto.fromJS(_data["quality"]) : <any>undefined;
            if (Array.isArray(_data["qualityList"])) {
                (<any>this).qualityList = [] as any;
                for (let item of _data["qualityList"])
                    (<any>this).qualityList!.push(ClaQualityDto.fromJS(item));
            }
            if (Array.isArray(_data["serviceAreas"])) {
                this.serviceAreas = [] as any;
                for (let item of _data["serviceAreas"])
                    this.serviceAreas!.push(ClaServiceAreasDto.fromJS(item));
            }
            if (Array.isArray(_data["serviceAreasList"])) {
                (<any>this).serviceAreasList = [] as any;
                for (let item of _data["serviceAreasList"])
                    (<any>this).serviceAreasList!.push(ClaServiceAreasDto.fromJS(item));
            }
            this.personel = _data["personel"] ? ClaPersonelDto.fromJS(_data["personel"]) : <any>undefined;
            if (Array.isArray(_data["personelList"])) {
                (<any>this).personelList = [] as any;
                for (let item of _data["personelList"])
                    (<any>this).personelList!.push(ClaPersonelDto.fromJS(item));
            }
            this.infrastructure = _data["infrastructure"] ? ClaInfrastructureDto.fromJS(_data["infrastructure"]) : <any>undefined;
            if (Array.isArray(_data["infrastructureList"])) {
                (<any>this).infrastructureList = [] as any;
                for (let item of _data["infrastructureList"])
                    (<any>this).infrastructureList!.push(ClaInfrastructureDto.fromJS(item));
            }
            this.rangeOfProducts = _data["rangeOfProducts"] ? SlasRangeOfProductsDto.fromJS(_data["rangeOfProducts"]) : <any>undefined;
            if (Array.isArray(_data["rangeOfProductsList"])) {
                (<any>this).rangeOfProductsList = [] as any;
                for (let item of _data["rangeOfProductsList"])
                    (<any>this).rangeOfProductsList!.push(SlasRangeOfProductsDto.fromJS(item));
            }
            this.productPreparation = _data["productPreparation"] ? SlasProductPreparationDto.fromJS(_data["productPreparation"]) : <any>undefined;
            if (Array.isArray(_data["productPreparationList"])) {
                (<any>this).productPreparationList = [] as any;
                for (let item of _data["productPreparationList"])
                    (<any>this).productPreparationList!.push(SlasProductPreparationDto.fromJS(item));
            }
            this.localDrugSales = _data["localDrugSales"] ? SlasLocalDrugSalesDto.fromJS(_data["localDrugSales"]) : <any>undefined;
            if (Array.isArray(_data["localDrugSalesList"])) {
                (<any>this).localDrugSalesList = [] as any;
                for (let item of _data["localDrugSalesList"])
                    (<any>this).localDrugSalesList!.push(SlasLocalDrugSalesDto.fromJS(item));
            }
            this.drugProduction = _data["drugProduction"] ? SlasDrugProductionDto.fromJS(_data["drugProduction"]) : <any>undefined;
            if (Array.isArray(_data["drugProductionList"])) {
                (<any>this).drugProductionList = [] as any;
                for (let item of _data["drugProductionList"])
                    (<any>this).drugProductionList!.push(SlasDrugProductionDto.fromJS(item));
            }
            this.drugProductionThirdParty = _data["drugProductionThirdParty"] ? SlasDrugProductionThirdPartyDto.fromJS(_data["drugProductionThirdParty"]) : <any>undefined;
            if (Array.isArray(_data["drugProductionThirdPartyList"])) {
                (<any>this).drugProductionThirdPartyList = [] as any;
                for (let item of _data["drugProductionThirdPartyList"])
                    (<any>this).drugProductionThirdPartyList!.push(SlasDrugProductionThirdPartyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClaBusinessDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaBusinessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["additionalName"] = this.additionalName;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["website"] = this.website;
        data["gln"] = this.gln;
        data["bur"] = this.bur;
        data["dateOfOpening"] = this.dateOfOpening ? this.dateOfOpening.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfClosure"] = this.dateOfClosure ? this.dateOfClosure.toFormat('yyyy-MM-dd') : <any>undefined;
        data["businessHours"] = this.businessHours;
        data["hasLocalPharmacyId"] = this.hasLocalPharmacyId;
        if (Array.isArray(this.directors)) {
            data["directors"] = [];
            for (let item of this.directors)
                data["directors"].push(item.toJSON());
        }
        data["rangeOfServices"] = this.rangeOfServices ? this.rangeOfServices.toJSON() : <any>undefined;
        if (Array.isArray(this.rangeOfServicesList)) {
            data["rangeOfServicesList"] = [];
            for (let item of this.rangeOfServicesList)
                data["rangeOfServicesList"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentItems)) {
            data["treatmentItems"] = [];
            for (let item of this.treatmentItems)
                data["treatmentItems"].push(item.toJSON());
        }
        if (Array.isArray(this.treatmentsList)) {
            data["treatmentsList"] = [];
            for (let item of this.treatmentsList)
                data["treatmentsList"].push(item.toJSON());
        }
        data["nursingBeds"] = this.nursingBeds ? this.nursingBeds.toJSON() : <any>undefined;
        if (Array.isArray(this.nursingBedList)) {
            data["nursingBedList"] = [];
            for (let item of this.nursingBedList)
                data["nursingBedList"].push(item.toJSON());
        }
        data["floors"] = this.floors ? this.floors.toJSON() : <any>undefined;
        if (Array.isArray(this.floorsList)) {
            data["floorsList"] = [];
            for (let item of this.floorsList)
                data["floorsList"].push(item.toJSON());
        }
        data["aidingResources"] = this.aidingResources ? this.aidingResources.toJSON() : <any>undefined;
        if (Array.isArray(this.aidingResourcesList)) {
            data["aidingResourcesList"] = [];
            for (let item of this.aidingResourcesList)
                data["aidingResourcesList"].push(item.toJSON());
        }
        data["drugChambers"] = this.drugChambers ? this.drugChambers.toJSON() : <any>undefined;
        if (Array.isArray(this.drugChambersList)) {
            data["drugChambersList"] = [];
            for (let item of this.drugChambersList)
                data["drugChambersList"].push(item.toJSON());
        }
        data["sanitaryFacilities"] = this.sanitaryFacilities ? this.sanitaryFacilities.toJSON() : <any>undefined;
        if (Array.isArray(this.sanitaryFacilitiesList)) {
            data["sanitaryFacilitiesList"] = [];
            for (let item of this.sanitaryFacilitiesList)
                data["sanitaryFacilitiesList"].push(item.toJSON());
        }
        data["security"] = this.security ? this.security.toJSON() : <any>undefined;
        if (Array.isArray(this.securityList)) {
            data["securityList"] = [];
            for (let item of this.securityList)
                data["securityList"].push(item.toJSON());
        }
        data["wheelchairAccessibility"] = this.wheelchairAccessibility ? this.wheelchairAccessibility.toJSON() : <any>undefined;
        if (Array.isArray(this.wheelchairAccessibilityList)) {
            data["wheelchairAccessibilityList"] = [];
            for (let item of this.wheelchairAccessibilityList)
                data["wheelchairAccessibilityList"].push(item.toJSON());
        }
        data["quality"] = this.quality ? this.quality.toJSON() : <any>undefined;
        if (Array.isArray(this.qualityList)) {
            data["qualityList"] = [];
            for (let item of this.qualityList)
                data["qualityList"].push(item.toJSON());
        }
        if (Array.isArray(this.serviceAreas)) {
            data["serviceAreas"] = [];
            for (let item of this.serviceAreas)
                data["serviceAreas"].push(item.toJSON());
        }
        if (Array.isArray(this.serviceAreasList)) {
            data["serviceAreasList"] = [];
            for (let item of this.serviceAreasList)
                data["serviceAreasList"].push(item.toJSON());
        }
        data["personel"] = this.personel ? this.personel.toJSON() : <any>undefined;
        if (Array.isArray(this.personelList)) {
            data["personelList"] = [];
            for (let item of this.personelList)
                data["personelList"].push(item.toJSON());
        }
        data["infrastructure"] = this.infrastructure ? this.infrastructure.toJSON() : <any>undefined;
        if (Array.isArray(this.infrastructureList)) {
            data["infrastructureList"] = [];
            for (let item of this.infrastructureList)
                data["infrastructureList"].push(item.toJSON());
        }
        data["rangeOfProducts"] = this.rangeOfProducts ? this.rangeOfProducts.toJSON() : <any>undefined;
        if (Array.isArray(this.rangeOfProductsList)) {
            data["rangeOfProductsList"] = [];
            for (let item of this.rangeOfProductsList)
                data["rangeOfProductsList"].push(item.toJSON());
        }
        data["productPreparation"] = this.productPreparation ? this.productPreparation.toJSON() : <any>undefined;
        if (Array.isArray(this.productPreparationList)) {
            data["productPreparationList"] = [];
            for (let item of this.productPreparationList)
                data["productPreparationList"].push(item.toJSON());
        }
        data["localDrugSales"] = this.localDrugSales ? this.localDrugSales.toJSON() : <any>undefined;
        if (Array.isArray(this.localDrugSalesList)) {
            data["localDrugSalesList"] = [];
            for (let item of this.localDrugSalesList)
                data["localDrugSalesList"].push(item.toJSON());
        }
        data["drugProduction"] = this.drugProduction ? this.drugProduction.toJSON() : <any>undefined;
        if (Array.isArray(this.drugProductionList)) {
            data["drugProductionList"] = [];
            for (let item of this.drugProductionList)
                data["drugProductionList"].push(item.toJSON());
        }
        data["drugProductionThirdParty"] = this.drugProductionThirdParty ? this.drugProductionThirdParty.toJSON() : <any>undefined;
        if (Array.isArray(this.drugProductionThirdPartyList)) {
            data["drugProductionThirdPartyList"] = [];
            for (let item of this.drugProductionThirdPartyList)
                data["drugProductionThirdPartyList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IClaBusinessDto {
    id: number | undefined;
    name: string;
    additionalName: string | undefined;
    postCode: string;
    city: string;
    street: string;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    website: string | undefined;
    gln: string | undefined;
    bur: string | undefined;
    dateOfOpening: DateTime | undefined;
    dateOfClosure: DateTime | undefined;
    businessHours: string | undefined;
    hasLocalPharmacyId: string | undefined;
    directors: ClaBusinessDirectorDto[] | undefined;
    rangeOfServices: ClaRangeOfServicesDto;
    rangeOfServicesList: ClaRangeOfServicesDto[] | undefined;
    treatmentItems: ClaTreatmentDto[] | undefined;
    treatmentsList: ClaTreatmentDto[] | undefined;
    nursingBeds: ClaNursingBedsDto;
    nursingBedList: ClaNursingBedsDto[] | undefined;
    floors: ClaFloorsDto;
    floorsList: ClaFloorsDto[] | undefined;
    aidingResources: ClaAidingResourcesDto;
    aidingResourcesList: ClaAidingResourcesDto[] | undefined;
    drugChambers: ClaDrugChambersDto;
    drugChambersList: ClaDrugChambersDto[] | undefined;
    sanitaryFacilities: ClaSanitaryFacilitiesDto;
    sanitaryFacilitiesList: ClaSanitaryFacilitiesDto[] | undefined;
    security: ClaSecurityDto;
    securityList: ClaSecurityDto[] | undefined;
    wheelchairAccessibility: ClaWheelchairAccessibilityDto;
    wheelchairAccessibilityList: ClaWheelchairAccessibilityDto[] | undefined;
    quality: ClaQualityDto;
    qualityList: ClaQualityDto[] | undefined;
    serviceAreas: ClaServiceAreasDto[] | undefined;
    serviceAreasList: ClaServiceAreasDto[] | undefined;
    personel: ClaPersonelDto;
    personelList: ClaPersonelDto[] | undefined;
    infrastructure: ClaInfrastructureDto;
    infrastructureList: ClaInfrastructureDto[] | undefined;
    rangeOfProducts: SlasRangeOfProductsDto;
    rangeOfProductsList: SlasRangeOfProductsDto[] | undefined;
    productPreparation: SlasProductPreparationDto;
    productPreparationList: SlasProductPreparationDto[] | undefined;
    localDrugSales: SlasLocalDrugSalesDto;
    localDrugSalesList: SlasLocalDrugSalesDto[] | undefined;
    drugProduction: SlasDrugProductionDto;
    drugProductionList: SlasDrugProductionDto[] | undefined;
    drugProductionThirdParty: SlasDrugProductionThirdPartyDto;
    drugProductionThirdPartyList: SlasDrugProductionThirdPartyDto[] | undefined;
}

export class ClaDocumentsOutput implements IClaDocumentsOutput {
    caseId!: string;
    documents!: GeneralDocumentGroupDto[];

    constructor(data?: IClaDocumentsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.documents = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClaDocumentsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ClaDocumentsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IClaDocumentsOutput {
    caseId: string;
    documents: GeneralDocumentGroupDto[];
}

export class ClaDrugChambersDto implements IClaDrugChambersDto {
    id!: number | undefined;
    claBusinessId!: number;
    hasDrugChamberInEverySectionId!: string | undefined;
    hasWashbasinInEveryDrugChamberId!: string | undefined;

    constructor(data?: IClaDrugChambersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claBusinessId = _data["claBusinessId"];
            this.hasDrugChamberInEverySectionId = _data["hasDrugChamberInEverySectionId"];
            this.hasWashbasinInEveryDrugChamberId = _data["hasWashbasinInEveryDrugChamberId"];
        }
    }

    static fromJS(data: any): ClaDrugChambersDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaDrugChambersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claBusinessId"] = this.claBusinessId;
        data["hasDrugChamberInEverySectionId"] = this.hasDrugChamberInEverySectionId;
        data["hasWashbasinInEveryDrugChamberId"] = this.hasWashbasinInEveryDrugChamberId;
        return data;
    }
}

export interface IClaDrugChambersDto {
    id: number | undefined;
    claBusinessId: number;
    hasDrugChamberInEverySectionId: string | undefined;
    hasWashbasinInEveryDrugChamberId: string | undefined;
}

export class ClaDto implements IClaDto {
    application!: ApplicationDto;
    sponsorshipTypeId!: string | undefined;
    statusId!: ClaStatus;
    sponsorship!: ClaSponsorshipDto;
    sponsorshipDirectors!: ClaSponsorshipDirectorDto[] | undefined;
    medicalFieldDirector!: ClaMedicalFieldDirectorDto;
    medicalFieldDirectorRepresentative!: ClaMedicalFieldDirectorRepresentativeDto;
    businesses!: ClaBusinessDto[] | undefined;
    medicalFieldPersons!: ClaMedicalFieldPersonDto[] | undefined;
    assistantPhysicians!: ClaAssistantPhysicianDto[] | undefined;
    invoiceAddress!: ClaInvoiceAddressDto;
    documents!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: IClaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationDto.fromJS(_data["application"]) : <any>undefined;
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.statusId = _data["statusId"];
            this.sponsorship = _data["sponsorship"] ? ClaSponsorshipDto.fromJS(_data["sponsorship"]) : <any>undefined;
            if (Array.isArray(_data["sponsorshipDirectors"])) {
                this.sponsorshipDirectors = [] as any;
                for (let item of _data["sponsorshipDirectors"])
                    this.sponsorshipDirectors!.push(ClaSponsorshipDirectorDto.fromJS(item));
            }
            this.medicalFieldDirector = _data["medicalFieldDirector"] ? ClaMedicalFieldDirectorDto.fromJS(_data["medicalFieldDirector"]) : <any>undefined;
            this.medicalFieldDirectorRepresentative = _data["medicalFieldDirectorRepresentative"] ? ClaMedicalFieldDirectorRepresentativeDto.fromJS(_data["medicalFieldDirectorRepresentative"]) : <any>undefined;
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
            if (Array.isArray(_data["medicalFieldPersons"])) {
                this.medicalFieldPersons = [] as any;
                for (let item of _data["medicalFieldPersons"])
                    this.medicalFieldPersons!.push(ClaMedicalFieldPersonDto.fromJS(item));
            }
            if (Array.isArray(_data["assistantPhysicians"])) {
                this.assistantPhysicians = [] as any;
                for (let item of _data["assistantPhysicians"])
                    this.assistantPhysicians!.push(ClaAssistantPhysicianDto.fromJS(item));
            }
            this.invoiceAddress = _data["invoiceAddress"] ? ClaInvoiceAddressDto.fromJS(_data["invoiceAddress"]) : <any>undefined;
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["statusId"] = this.statusId;
        data["sponsorship"] = this.sponsorship ? this.sponsorship.toJSON() : <any>undefined;
        if (Array.isArray(this.sponsorshipDirectors)) {
            data["sponsorshipDirectors"] = [];
            for (let item of this.sponsorshipDirectors)
                data["sponsorshipDirectors"].push(item.toJSON());
        }
        data["medicalFieldDirector"] = this.medicalFieldDirector ? this.medicalFieldDirector.toJSON() : <any>undefined;
        data["medicalFieldDirectorRepresentative"] = this.medicalFieldDirectorRepresentative ? this.medicalFieldDirectorRepresentative.toJSON() : <any>undefined;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        if (Array.isArray(this.medicalFieldPersons)) {
            data["medicalFieldPersons"] = [];
            for (let item of this.medicalFieldPersons)
                data["medicalFieldPersons"].push(item.toJSON());
        }
        if (Array.isArray(this.assistantPhysicians)) {
            data["assistantPhysicians"] = [];
            for (let item of this.assistantPhysicians)
                data["assistantPhysicians"].push(item.toJSON());
        }
        data["invoiceAddress"] = this.invoiceAddress ? this.invoiceAddress.toJSON() : <any>undefined;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IClaDto {
    application: ApplicationDto;
    sponsorshipTypeId: string | undefined;
    statusId: ClaStatus;
    sponsorship: ClaSponsorshipDto;
    sponsorshipDirectors: ClaSponsorshipDirectorDto[] | undefined;
    medicalFieldDirector: ClaMedicalFieldDirectorDto;
    medicalFieldDirectorRepresentative: ClaMedicalFieldDirectorRepresentativeDto;
    businesses: ClaBusinessDto[] | undefined;
    medicalFieldPersons: ClaMedicalFieldPersonDto[] | undefined;
    assistantPhysicians: ClaAssistantPhysicianDto[] | undefined;
    invoiceAddress: ClaInvoiceAddressDto;
    documents: GeneralDocumentGroupDto[] | undefined;
}

export class ClaFloorsDto implements IClaFloorsDto {
    id!: number | undefined;
    claBusinessId!: number;
    hasTreatmentUnitsOnMoreThanOneFloorId!: string | undefined;
    hasBedElevatorId!: string | undefined;
    hasPersonElevatorId!: string | undefined;
    personElevatorSize!: string | undefined;

    constructor(data?: IClaFloorsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claBusinessId = _data["claBusinessId"];
            this.hasTreatmentUnitsOnMoreThanOneFloorId = _data["hasTreatmentUnitsOnMoreThanOneFloorId"];
            this.hasBedElevatorId = _data["hasBedElevatorId"];
            this.hasPersonElevatorId = _data["hasPersonElevatorId"];
            this.personElevatorSize = _data["personElevatorSize"];
        }
    }

    static fromJS(data: any): ClaFloorsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaFloorsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claBusinessId"] = this.claBusinessId;
        data["hasTreatmentUnitsOnMoreThanOneFloorId"] = this.hasTreatmentUnitsOnMoreThanOneFloorId;
        data["hasBedElevatorId"] = this.hasBedElevatorId;
        data["hasPersonElevatorId"] = this.hasPersonElevatorId;
        data["personElevatorSize"] = this.personElevatorSize;
        return data;
    }
}

export interface IClaFloorsDto {
    id: number | undefined;
    claBusinessId: number;
    hasTreatmentUnitsOnMoreThanOneFloorId: string | undefined;
    hasBedElevatorId: string | undefined;
    hasPersonElevatorId: string | undefined;
    personElevatorSize: string | undefined;
}

export class ClaInfrastructureDto implements IClaInfrastructureDto {
    id!: number | undefined;
    claBusinessId!: number;
    hasConstructionalMeasuresId!: string | undefined;

    constructor(data?: IClaInfrastructureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claBusinessId = _data["claBusinessId"];
            this.hasConstructionalMeasuresId = _data["hasConstructionalMeasuresId"];
        }
    }

    static fromJS(data: any): ClaInfrastructureDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaInfrastructureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claBusinessId"] = this.claBusinessId;
        data["hasConstructionalMeasuresId"] = this.hasConstructionalMeasuresId;
        return data;
    }
}

export interface IClaInfrastructureDto {
    id: number | undefined;
    claBusinessId: number;
    hasConstructionalMeasuresId: string | undefined;
}

export class ClaInvoiceAddressDto implements IClaInvoiceAddressDto {
    businessName!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    countryId!: string | undefined;
    email!: string | undefined;
    completionStatus!: CompletionStatus;

    constructor(data?: IClaInvoiceAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.businessName = _data["businessName"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.countryId = _data["countryId"];
            this.email = _data["email"];
            this.completionStatus = _data["completionStatus"];
        }
    }

    static fromJS(data: any): ClaInvoiceAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaInvoiceAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["businessName"] = this.businessName;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["countryId"] = this.countryId;
        data["email"] = this.email;
        data["completionStatus"] = this.completionStatus;
        return data;
    }
}

export interface IClaInvoiceAddressDto {
    businessName: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    countryId: string | undefined;
    email: string | undefined;
    completionStatus: CompletionStatus;
}

export class ClaMedicalFieldDirectorDto implements IClaMedicalFieldDirectorDto {
    id!: number | undefined;
    gln!: string;
    firstName!: string;
    lastName!: string;
    professionalLicenceStatusId!: string | undefined;
    levelOfEmployment!: number;
    dateOfResponsibilityStart!: DateTime | undefined;
    hasAppliedForProfessionalLicenceId!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    role!: string | undefined;

    constructor(data?: IClaMedicalFieldDirectorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gln = _data["gln"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.professionalLicenceStatusId = _data["professionalLicenceStatusId"];
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.dateOfResponsibilityStart = _data["dateOfResponsibilityStart"] ? DateTime.fromISO(_data["dateOfResponsibilityStart"].toString()) : <any>undefined;
            this.hasAppliedForProfessionalLicenceId = _data["hasAppliedForProfessionalLicenceId"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): ClaMedicalFieldDirectorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaMedicalFieldDirectorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gln"] = this.gln;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["professionalLicenceStatusId"] = this.professionalLicenceStatusId;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["dateOfResponsibilityStart"] = this.dateOfResponsibilityStart ? this.dateOfResponsibilityStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["hasAppliedForProfessionalLicenceId"] = this.hasAppliedForProfessionalLicenceId;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["role"] = this.role;
        return data;
    }
}

export interface IClaMedicalFieldDirectorDto {
    id: number | undefined;
    gln: string;
    firstName: string;
    lastName: string;
    professionalLicenceStatusId: string | undefined;
    levelOfEmployment: number;
    dateOfResponsibilityStart: DateTime | undefined;
    hasAppliedForProfessionalLicenceId: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    role: string | undefined;
}

export class ClaMedicalFieldDirectorRepresentativeDto implements IClaMedicalFieldDirectorRepresentativeDto {
    id!: number | undefined;
    gln!: string;
    firstName!: string;
    lastName!: string;
    professionalLicenceStatusId!: string | undefined;
    levelOfEmployment!: number;
    dateOfResponsibilityStart!: DateTime | undefined;
    hasAppliedForProfessionalLicenceId!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;

    constructor(data?: IClaMedicalFieldDirectorRepresentativeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gln = _data["gln"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.professionalLicenceStatusId = _data["professionalLicenceStatusId"];
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.dateOfResponsibilityStart = _data["dateOfResponsibilityStart"] ? DateTime.fromISO(_data["dateOfResponsibilityStart"].toString()) : <any>undefined;
            this.hasAppliedForProfessionalLicenceId = _data["hasAppliedForProfessionalLicenceId"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ClaMedicalFieldDirectorRepresentativeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaMedicalFieldDirectorRepresentativeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gln"] = this.gln;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["professionalLicenceStatusId"] = this.professionalLicenceStatusId;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["dateOfResponsibilityStart"] = this.dateOfResponsibilityStart ? this.dateOfResponsibilityStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["hasAppliedForProfessionalLicenceId"] = this.hasAppliedForProfessionalLicenceId;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        return data;
    }
}

export interface IClaMedicalFieldDirectorRepresentativeDto {
    id: number | undefined;
    gln: string;
    firstName: string;
    lastName: string;
    professionalLicenceStatusId: string | undefined;
    levelOfEmployment: number;
    dateOfResponsibilityStart: DateTime | undefined;
    hasAppliedForProfessionalLicenceId: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
}

export class ClaMedicalFieldPersonDto implements IClaMedicalFieldPersonDto {
    id!: number | undefined;
    hasProfessionalLicenceId!: string;
    gln!: string;
    firstName!: string;
    lastName!: string;
    postgraduateTitleId!: string | undefined;
    dateOfStart!: DateTime;
    levelOfEmployment!: number;

    constructor(data?: IClaMedicalFieldPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.hasProfessionalLicenceId = _data["hasProfessionalLicenceId"];
            this.gln = _data["gln"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.dateOfStart = _data["dateOfStart"] ? DateTime.fromISO(_data["dateOfStart"].toString()) : <any>undefined;
            this.levelOfEmployment = _data["levelOfEmployment"];
        }
    }

    static fromJS(data: any): ClaMedicalFieldPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaMedicalFieldPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["hasProfessionalLicenceId"] = this.hasProfessionalLicenceId;
        data["gln"] = this.gln;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["dateOfStart"] = this.dateOfStart ? this.dateOfStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfEmployment"] = this.levelOfEmployment;
        return data;
    }
}

export interface IClaMedicalFieldPersonDto {
    id: number | undefined;
    hasProfessionalLicenceId: string;
    gln: string;
    firstName: string;
    lastName: string;
    postgraduateTitleId: string | undefined;
    dateOfStart: DateTime;
    levelOfEmployment: number;
}

export class ClaNursingBedsDto implements IClaNursingBedsDto {
    id!: number | undefined;
    claBusinessId!: number;
    totalNumberOfBeds!: number;
    totalNumberOfEmergencyBeds!: number;
    privateRoomsWithShowerAndToiletAndWashbasin!: number;
    privateRoomsWithToiletAndWashbasin!: number;
    privateRoomsWithWashbasin!: number;
    twinRoomsWithShowerAndToiletAndWashbasin!: number;
    twinRoomsWithToiletAndWashbasin!: number;
    twinRoomsWithWashbasin!: number;
    threeBedRoomsWithShowerAndToiletAndWashbasin!: number;
    threeBedRoomsWithToiletAndWashbasin!: number;
    threeBedRoomsWithWashbasin!: number;
    fourBedRoomsWithShowerAndToiletAndWashbasin!: number;
    fourBedRoomsWithToiletAndWashbasin!: number;
    fourBedRoomsWithWashbasin!: number;

    constructor(data?: IClaNursingBedsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claBusinessId = _data["claBusinessId"];
            this.totalNumberOfBeds = _data["totalNumberOfBeds"];
            this.totalNumberOfEmergencyBeds = _data["totalNumberOfEmergencyBeds"];
            this.privateRoomsWithShowerAndToiletAndWashbasin = _data["privateRoomsWithShowerAndToiletAndWashbasin"];
            this.privateRoomsWithToiletAndWashbasin = _data["privateRoomsWithToiletAndWashbasin"];
            this.privateRoomsWithWashbasin = _data["privateRoomsWithWashbasin"];
            this.twinRoomsWithShowerAndToiletAndWashbasin = _data["twinRoomsWithShowerAndToiletAndWashbasin"];
            this.twinRoomsWithToiletAndWashbasin = _data["twinRoomsWithToiletAndWashbasin"];
            this.twinRoomsWithWashbasin = _data["twinRoomsWithWashbasin"];
            this.threeBedRoomsWithShowerAndToiletAndWashbasin = _data["threeBedRoomsWithShowerAndToiletAndWashbasin"];
            this.threeBedRoomsWithToiletAndWashbasin = _data["threeBedRoomsWithToiletAndWashbasin"];
            this.threeBedRoomsWithWashbasin = _data["threeBedRoomsWithWashbasin"];
            this.fourBedRoomsWithShowerAndToiletAndWashbasin = _data["fourBedRoomsWithShowerAndToiletAndWashbasin"];
            this.fourBedRoomsWithToiletAndWashbasin = _data["fourBedRoomsWithToiletAndWashbasin"];
            this.fourBedRoomsWithWashbasin = _data["fourBedRoomsWithWashbasin"];
        }
    }

    static fromJS(data: any): ClaNursingBedsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaNursingBedsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claBusinessId"] = this.claBusinessId;
        data["totalNumberOfBeds"] = this.totalNumberOfBeds;
        data["totalNumberOfEmergencyBeds"] = this.totalNumberOfEmergencyBeds;
        data["privateRoomsWithShowerAndToiletAndWashbasin"] = this.privateRoomsWithShowerAndToiletAndWashbasin;
        data["privateRoomsWithToiletAndWashbasin"] = this.privateRoomsWithToiletAndWashbasin;
        data["privateRoomsWithWashbasin"] = this.privateRoomsWithWashbasin;
        data["twinRoomsWithShowerAndToiletAndWashbasin"] = this.twinRoomsWithShowerAndToiletAndWashbasin;
        data["twinRoomsWithToiletAndWashbasin"] = this.twinRoomsWithToiletAndWashbasin;
        data["twinRoomsWithWashbasin"] = this.twinRoomsWithWashbasin;
        data["threeBedRoomsWithShowerAndToiletAndWashbasin"] = this.threeBedRoomsWithShowerAndToiletAndWashbasin;
        data["threeBedRoomsWithToiletAndWashbasin"] = this.threeBedRoomsWithToiletAndWashbasin;
        data["threeBedRoomsWithWashbasin"] = this.threeBedRoomsWithWashbasin;
        data["fourBedRoomsWithShowerAndToiletAndWashbasin"] = this.fourBedRoomsWithShowerAndToiletAndWashbasin;
        data["fourBedRoomsWithToiletAndWashbasin"] = this.fourBedRoomsWithToiletAndWashbasin;
        data["fourBedRoomsWithWashbasin"] = this.fourBedRoomsWithWashbasin;
        return data;
    }
}

export interface IClaNursingBedsDto {
    id: number | undefined;
    claBusinessId: number;
    totalNumberOfBeds: number;
    totalNumberOfEmergencyBeds: number;
    privateRoomsWithShowerAndToiletAndWashbasin: number;
    privateRoomsWithToiletAndWashbasin: number;
    privateRoomsWithWashbasin: number;
    twinRoomsWithShowerAndToiletAndWashbasin: number;
    twinRoomsWithToiletAndWashbasin: number;
    twinRoomsWithWashbasin: number;
    threeBedRoomsWithShowerAndToiletAndWashbasin: number;
    threeBedRoomsWithToiletAndWashbasin: number;
    threeBedRoomsWithWashbasin: number;
    fourBedRoomsWithShowerAndToiletAndWashbasin: number;
    fourBedRoomsWithToiletAndWashbasin: number;
    fourBedRoomsWithWashbasin: number;
}

export class ClaPersonelDto implements IClaPersonelDto {
    id!: number | undefined;
    claBusinessId!: number;
    sponsorshipDirectorFullTimeEquivalent!: number | undefined;
    sponsorshipDirectorTotalNumberOfEmployees!: number | undefined;
    physicianDirectorFullTimeEquivalent!: number | undefined;
    physicianDirectorTotalNumberOfEmployees!: number | undefined;
    physicianFullTimeEquivalent!: number | undefined;
    physicianTotalNumberOfEmployees!: number | undefined;
    midwifeFullTimeEquivalent!: number | undefined;
    midwifeTotalNumberOfEmployees!: number | undefined;
    nursingCareWithDiplomaFullTimeEquivalent!: number | undefined;
    nursingCareWithDiplomaTotalNumberOfEmployees!: number | undefined;
    nursingCareFullTimeEquivalent!: number | undefined;
    nursingCareTotalNumberOfEmployees!: number | undefined;
    nursingCareAssistantFullTimeEquivalent!: number | undefined;
    nursingCareAssistantTotalNumberOfEmployees!: number | undefined;
    therapistFullTimeEquivalent!: number | undefined;
    therapistTotalNumberOfEmployees!: number | undefined;
    radiologyFullTimeEquivalent!: number | undefined;
    radiologyTotalNumberOfEmployees!: number | undefined;
    laboratoryFullTimeEquivalent!: number | undefined;
    laboratoryTotalNumberOfEmployees!: number | undefined;
    surgeryFullTimeEquivalent!: number | undefined;
    surgeryTotalNumberOfEmployees!: number | undefined;
    socialServicesFullTimeEquivalent!: number | undefined;
    socialServicesTotalNumberOfEmployees!: number | undefined;
    hotelAndGastronomyFullTimeEquivalent!: number | undefined;
    hotelAndGastronomyTotalNumberOfEmployees!: number | undefined;
    technicalServicesFullTimeEquivalent!: number | undefined;
    technicalServicesTotalNumberOfEmployees!: number | undefined;
    totalFullTimeEquivalent!: number | undefined;
    totalNumberOfEmployees!: number | undefined;

    constructor(data?: IClaPersonelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claBusinessId = _data["claBusinessId"];
            this.sponsorshipDirectorFullTimeEquivalent = _data["sponsorshipDirectorFullTimeEquivalent"];
            this.sponsorshipDirectorTotalNumberOfEmployees = _data["sponsorshipDirectorTotalNumberOfEmployees"];
            this.physicianDirectorFullTimeEquivalent = _data["physicianDirectorFullTimeEquivalent"];
            this.physicianDirectorTotalNumberOfEmployees = _data["physicianDirectorTotalNumberOfEmployees"];
            this.physicianFullTimeEquivalent = _data["physicianFullTimeEquivalent"];
            this.physicianTotalNumberOfEmployees = _data["physicianTotalNumberOfEmployees"];
            this.midwifeFullTimeEquivalent = _data["midwifeFullTimeEquivalent"];
            this.midwifeTotalNumberOfEmployees = _data["midwifeTotalNumberOfEmployees"];
            this.nursingCareWithDiplomaFullTimeEquivalent = _data["nursingCareWithDiplomaFullTimeEquivalent"];
            this.nursingCareWithDiplomaTotalNumberOfEmployees = _data["nursingCareWithDiplomaTotalNumberOfEmployees"];
            this.nursingCareFullTimeEquivalent = _data["nursingCareFullTimeEquivalent"];
            this.nursingCareTotalNumberOfEmployees = _data["nursingCareTotalNumberOfEmployees"];
            this.nursingCareAssistantFullTimeEquivalent = _data["nursingCareAssistantFullTimeEquivalent"];
            this.nursingCareAssistantTotalNumberOfEmployees = _data["nursingCareAssistantTotalNumberOfEmployees"];
            this.therapistFullTimeEquivalent = _data["therapistFullTimeEquivalent"];
            this.therapistTotalNumberOfEmployees = _data["therapistTotalNumberOfEmployees"];
            this.radiologyFullTimeEquivalent = _data["radiologyFullTimeEquivalent"];
            this.radiologyTotalNumberOfEmployees = _data["radiologyTotalNumberOfEmployees"];
            this.laboratoryFullTimeEquivalent = _data["laboratoryFullTimeEquivalent"];
            this.laboratoryTotalNumberOfEmployees = _data["laboratoryTotalNumberOfEmployees"];
            this.surgeryFullTimeEquivalent = _data["surgeryFullTimeEquivalent"];
            this.surgeryTotalNumberOfEmployees = _data["surgeryTotalNumberOfEmployees"];
            this.socialServicesFullTimeEquivalent = _data["socialServicesFullTimeEquivalent"];
            this.socialServicesTotalNumberOfEmployees = _data["socialServicesTotalNumberOfEmployees"];
            this.hotelAndGastronomyFullTimeEquivalent = _data["hotelAndGastronomyFullTimeEquivalent"];
            this.hotelAndGastronomyTotalNumberOfEmployees = _data["hotelAndGastronomyTotalNumberOfEmployees"];
            this.technicalServicesFullTimeEquivalent = _data["technicalServicesFullTimeEquivalent"];
            this.technicalServicesTotalNumberOfEmployees = _data["technicalServicesTotalNumberOfEmployees"];
            this.totalFullTimeEquivalent = _data["totalFullTimeEquivalent"];
            this.totalNumberOfEmployees = _data["totalNumberOfEmployees"];
        }
    }

    static fromJS(data: any): ClaPersonelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaPersonelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claBusinessId"] = this.claBusinessId;
        data["sponsorshipDirectorFullTimeEquivalent"] = this.sponsorshipDirectorFullTimeEquivalent;
        data["sponsorshipDirectorTotalNumberOfEmployees"] = this.sponsorshipDirectorTotalNumberOfEmployees;
        data["physicianDirectorFullTimeEquivalent"] = this.physicianDirectorFullTimeEquivalent;
        data["physicianDirectorTotalNumberOfEmployees"] = this.physicianDirectorTotalNumberOfEmployees;
        data["physicianFullTimeEquivalent"] = this.physicianFullTimeEquivalent;
        data["physicianTotalNumberOfEmployees"] = this.physicianTotalNumberOfEmployees;
        data["midwifeFullTimeEquivalent"] = this.midwifeFullTimeEquivalent;
        data["midwifeTotalNumberOfEmployees"] = this.midwifeTotalNumberOfEmployees;
        data["nursingCareWithDiplomaFullTimeEquivalent"] = this.nursingCareWithDiplomaFullTimeEquivalent;
        data["nursingCareWithDiplomaTotalNumberOfEmployees"] = this.nursingCareWithDiplomaTotalNumberOfEmployees;
        data["nursingCareFullTimeEquivalent"] = this.nursingCareFullTimeEquivalent;
        data["nursingCareTotalNumberOfEmployees"] = this.nursingCareTotalNumberOfEmployees;
        data["nursingCareAssistantFullTimeEquivalent"] = this.nursingCareAssistantFullTimeEquivalent;
        data["nursingCareAssistantTotalNumberOfEmployees"] = this.nursingCareAssistantTotalNumberOfEmployees;
        data["therapistFullTimeEquivalent"] = this.therapistFullTimeEquivalent;
        data["therapistTotalNumberOfEmployees"] = this.therapistTotalNumberOfEmployees;
        data["radiologyFullTimeEquivalent"] = this.radiologyFullTimeEquivalent;
        data["radiologyTotalNumberOfEmployees"] = this.radiologyTotalNumberOfEmployees;
        data["laboratoryFullTimeEquivalent"] = this.laboratoryFullTimeEquivalent;
        data["laboratoryTotalNumberOfEmployees"] = this.laboratoryTotalNumberOfEmployees;
        data["surgeryFullTimeEquivalent"] = this.surgeryFullTimeEquivalent;
        data["surgeryTotalNumberOfEmployees"] = this.surgeryTotalNumberOfEmployees;
        data["socialServicesFullTimeEquivalent"] = this.socialServicesFullTimeEquivalent;
        data["socialServicesTotalNumberOfEmployees"] = this.socialServicesTotalNumberOfEmployees;
        data["hotelAndGastronomyFullTimeEquivalent"] = this.hotelAndGastronomyFullTimeEquivalent;
        data["hotelAndGastronomyTotalNumberOfEmployees"] = this.hotelAndGastronomyTotalNumberOfEmployees;
        data["technicalServicesFullTimeEquivalent"] = this.technicalServicesFullTimeEquivalent;
        data["technicalServicesTotalNumberOfEmployees"] = this.technicalServicesTotalNumberOfEmployees;
        data["totalFullTimeEquivalent"] = this.totalFullTimeEquivalent;
        data["totalNumberOfEmployees"] = this.totalNumberOfEmployees;
        return data;
    }
}

export interface IClaPersonelDto {
    id: number | undefined;
    claBusinessId: number;
    sponsorshipDirectorFullTimeEquivalent: number | undefined;
    sponsorshipDirectorTotalNumberOfEmployees: number | undefined;
    physicianDirectorFullTimeEquivalent: number | undefined;
    physicianDirectorTotalNumberOfEmployees: number | undefined;
    physicianFullTimeEquivalent: number | undefined;
    physicianTotalNumberOfEmployees: number | undefined;
    midwifeFullTimeEquivalent: number | undefined;
    midwifeTotalNumberOfEmployees: number | undefined;
    nursingCareWithDiplomaFullTimeEquivalent: number | undefined;
    nursingCareWithDiplomaTotalNumberOfEmployees: number | undefined;
    nursingCareFullTimeEquivalent: number | undefined;
    nursingCareTotalNumberOfEmployees: number | undefined;
    nursingCareAssistantFullTimeEquivalent: number | undefined;
    nursingCareAssistantTotalNumberOfEmployees: number | undefined;
    therapistFullTimeEquivalent: number | undefined;
    therapistTotalNumberOfEmployees: number | undefined;
    radiologyFullTimeEquivalent: number | undefined;
    radiologyTotalNumberOfEmployees: number | undefined;
    laboratoryFullTimeEquivalent: number | undefined;
    laboratoryTotalNumberOfEmployees: number | undefined;
    surgeryFullTimeEquivalent: number | undefined;
    surgeryTotalNumberOfEmployees: number | undefined;
    socialServicesFullTimeEquivalent: number | undefined;
    socialServicesTotalNumberOfEmployees: number | undefined;
    hotelAndGastronomyFullTimeEquivalent: number | undefined;
    hotelAndGastronomyTotalNumberOfEmployees: number | undefined;
    technicalServicesFullTimeEquivalent: number | undefined;
    technicalServicesTotalNumberOfEmployees: number | undefined;
    totalFullTimeEquivalent: number | undefined;
    totalNumberOfEmployees: number | undefined;
}

export class ClaQualityDto implements IClaQualityDto {
    id!: number | undefined;
    claBusinessId!: number;
    isParticipantInQualityProgramId!: string | undefined;
    programName!: string | undefined;

    constructor(data?: IClaQualityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claBusinessId = _data["claBusinessId"];
            this.isParticipantInQualityProgramId = _data["isParticipantInQualityProgramId"];
            this.programName = _data["programName"];
        }
    }

    static fromJS(data: any): ClaQualityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaQualityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claBusinessId"] = this.claBusinessId;
        data["isParticipantInQualityProgramId"] = this.isParticipantInQualityProgramId;
        data["programName"] = this.programName;
        return data;
    }
}

export interface IClaQualityDto {
    id: number | undefined;
    claBusinessId: number;
    isParticipantInQualityProgramId: string | undefined;
    programName: string | undefined;
}

export class ClaRangeOfServicesDto implements IClaRangeOfServicesDto {
    id!: number | undefined;
    claBusinessId!: number;
    hasXRayMachineId!: string;
    hasOperatingTheatresId!: string;

    constructor(data?: IClaRangeOfServicesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claBusinessId = _data["claBusinessId"];
            this.hasXRayMachineId = _data["hasXRayMachineId"];
            this.hasOperatingTheatresId = _data["hasOperatingTheatresId"];
        }
    }

    static fromJS(data: any): ClaRangeOfServicesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaRangeOfServicesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claBusinessId"] = this.claBusinessId;
        data["hasXRayMachineId"] = this.hasXRayMachineId;
        data["hasOperatingTheatresId"] = this.hasOperatingTheatresId;
        return data;
    }
}

export interface IClaRangeOfServicesDto {
    id: number | undefined;
    claBusinessId: number;
    hasXRayMachineId: string;
    hasOperatingTheatresId: string;
}

export class ClaSanitaryFacilitiesDto implements IClaSanitaryFacilitiesDto {
    id!: number | undefined;
    claBusinessId!: number;
    totalNumberOfToilets!: number;
    numberOfToiletsForDisabled!: number;
    totalNumberOfShowers!: number;
    numberOfShowersForDisabled!: number;
    totalNumberOfTreatmentBaths!: number;
    numberOfTreatmentBathsForDisabled!: number;
    hasSinkRoomOnEveryFloorId!: string | undefined;

    constructor(data?: IClaSanitaryFacilitiesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claBusinessId = _data["claBusinessId"];
            this.totalNumberOfToilets = _data["totalNumberOfToilets"];
            this.numberOfToiletsForDisabled = _data["numberOfToiletsForDisabled"];
            this.totalNumberOfShowers = _data["totalNumberOfShowers"];
            this.numberOfShowersForDisabled = _data["numberOfShowersForDisabled"];
            this.totalNumberOfTreatmentBaths = _data["totalNumberOfTreatmentBaths"];
            this.numberOfTreatmentBathsForDisabled = _data["numberOfTreatmentBathsForDisabled"];
            this.hasSinkRoomOnEveryFloorId = _data["hasSinkRoomOnEveryFloorId"];
        }
    }

    static fromJS(data: any): ClaSanitaryFacilitiesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaSanitaryFacilitiesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claBusinessId"] = this.claBusinessId;
        data["totalNumberOfToilets"] = this.totalNumberOfToilets;
        data["numberOfToiletsForDisabled"] = this.numberOfToiletsForDisabled;
        data["totalNumberOfShowers"] = this.totalNumberOfShowers;
        data["numberOfShowersForDisabled"] = this.numberOfShowersForDisabled;
        data["totalNumberOfTreatmentBaths"] = this.totalNumberOfTreatmentBaths;
        data["numberOfTreatmentBathsForDisabled"] = this.numberOfTreatmentBathsForDisabled;
        data["hasSinkRoomOnEveryFloorId"] = this.hasSinkRoomOnEveryFloorId;
        return data;
    }
}

export interface IClaSanitaryFacilitiesDto {
    id: number | undefined;
    claBusinessId: number;
    totalNumberOfToilets: number;
    numberOfToiletsForDisabled: number;
    totalNumberOfShowers: number;
    numberOfShowersForDisabled: number;
    totalNumberOfTreatmentBaths: number;
    numberOfTreatmentBathsForDisabled: number;
    hasSinkRoomOnEveryFloorId: string | undefined;
}

export class ClaSecurityDto implements IClaSecurityDto {
    id!: number | undefined;
    claBusinessId!: number;
    hasFireAlarmId!: string | undefined;
    hasPatientCallSystemId!: string | undefined;
    hasPowerBackupSystemId!: string | undefined;
    hasClearEmergencyEntranceId!: string | undefined;

    constructor(data?: IClaSecurityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claBusinessId = _data["claBusinessId"];
            this.hasFireAlarmId = _data["hasFireAlarmId"];
            this.hasPatientCallSystemId = _data["hasPatientCallSystemId"];
            this.hasPowerBackupSystemId = _data["hasPowerBackupSystemId"];
            this.hasClearEmergencyEntranceId = _data["hasClearEmergencyEntranceId"];
        }
    }

    static fromJS(data: any): ClaSecurityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaSecurityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claBusinessId"] = this.claBusinessId;
        data["hasFireAlarmId"] = this.hasFireAlarmId;
        data["hasPatientCallSystemId"] = this.hasPatientCallSystemId;
        data["hasPowerBackupSystemId"] = this.hasPowerBackupSystemId;
        data["hasClearEmergencyEntranceId"] = this.hasClearEmergencyEntranceId;
        return data;
    }
}

export interface IClaSecurityDto {
    id: number | undefined;
    claBusinessId: number;
    hasFireAlarmId: string | undefined;
    hasPatientCallSystemId: string | undefined;
    hasPowerBackupSystemId: string | undefined;
    hasClearEmergencyEntranceId: string | undefined;
}

export class ClaServiceAreasDto implements IClaServiceAreasDto {
    id!: number | undefined;
    claBusinessId!: number;
    typeId!: string | undefined;

    constructor(data?: IClaServiceAreasDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claBusinessId = _data["claBusinessId"];
            this.typeId = _data["typeId"];
        }
    }

    static fromJS(data: any): ClaServiceAreasDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaServiceAreasDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claBusinessId"] = this.claBusinessId;
        data["typeId"] = this.typeId;
        return data;
    }
}

export interface IClaServiceAreasDto {
    id: number | undefined;
    claBusinessId: number;
    typeId: string | undefined;
}

export class ClaSponsorshipDirectorDto implements IClaSponsorshipDirectorDto {
    id!: number | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    postCode!: string;
    city!: string;
    street!: string;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;

    constructor(data?: IClaSponsorshipDirectorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ClaSponsorshipDirectorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaSponsorshipDirectorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        return data;
    }
}

export interface IClaSponsorshipDirectorDto {
    id: number | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    postCode: string;
    city: string;
    street: string;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
}

export class ClaSponsorshipDto implements IClaSponsorshipDto {
    uid!: string | undefined;
    name!: string;
    additionalName!: string | undefined;
    legalFormId!: string;
    postCode!: string;
    city!: string;
    street!: string;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    invoiceEmail!: string | undefined;
    website!: string | undefined;
    hasLicenceInAnotherCantonId!: string | undefined;
    completionStatus!: CompletionStatus;

    constructor(data?: IClaSponsorshipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uid = _data["uid"];
            this.name = _data["name"];
            this.additionalName = _data["additionalName"];
            this.legalFormId = _data["legalFormId"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.invoiceEmail = _data["invoiceEmail"];
            this.website = _data["website"];
            this.hasLicenceInAnotherCantonId = _data["hasLicenceInAnotherCantonId"];
            this.completionStatus = _data["completionStatus"];
        }
    }

    static fromJS(data: any): ClaSponsorshipDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaSponsorshipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uid"] = this.uid;
        data["name"] = this.name;
        data["additionalName"] = this.additionalName;
        data["legalFormId"] = this.legalFormId;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["invoiceEmail"] = this.invoiceEmail;
        data["website"] = this.website;
        data["hasLicenceInAnotherCantonId"] = this.hasLicenceInAnotherCantonId;
        data["completionStatus"] = this.completionStatus;
        return data;
    }
}

export interface IClaSponsorshipDto {
    uid: string | undefined;
    name: string;
    additionalName: string | undefined;
    legalFormId: string;
    postCode: string;
    city: string;
    street: string;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    invoiceEmail: string | undefined;
    website: string | undefined;
    hasLicenceInAnotherCantonId: string | undefined;
    completionStatus: CompletionStatus;
}

export enum ClaStatus {
    Sponsorship = 0,
    Business = 1,
    SponsorshipDirectors = 2,
    MedicalFieldDirector = 3,
    BusinessDirectors = 4,
    InvoiceAddress = 5,
    AssistantPhysicians = 6,
    MedicalFieldPerson = 7,
    Infrastructure = 9,
    Personel = 10,
    RangeOfServices = 11,
    MedicalFieldDirectorRepresentative = 14,
    ServiceArea = 15,
    Treatment = 16,
    NursingBeds = 17,
    Floors = 18,
    WheelchairAccessibility = 19,
    SanitaryFacilities = 20,
    DrugChambers = 21,
    Security = 22,
    AidingResources = 23,
    Quality = 25,
    RangeOfProducts = 26,
    ProductPreparation = 27,
    LocalDrugSales = 28,
    DrugProduction = 29,
    DrugProductionThirdParty = 30,
    OnlineDrugSales = 31,
    Release = 97,
    Released = 98,
    FinishReview = 99,
}

export class ClaTreatmentDto implements IClaTreatmentDto {
    id!: number | undefined;
    claBusinessId!: number;
    treatmentTypeId!: EnumTreatmentType;
    amount!: string;
    services!: string;

    constructor(data?: IClaTreatmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claBusinessId = _data["claBusinessId"];
            this.treatmentTypeId = _data["treatmentTypeId"];
            this.amount = _data["amount"];
            this.services = _data["services"];
        }
    }

    static fromJS(data: any): ClaTreatmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaTreatmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claBusinessId"] = this.claBusinessId;
        data["treatmentTypeId"] = this.treatmentTypeId;
        data["amount"] = this.amount;
        data["services"] = this.services;
        return data;
    }
}

export interface IClaTreatmentDto {
    id: number | undefined;
    claBusinessId: number;
    treatmentTypeId: EnumTreatmentType;
    amount: string;
    services: string;
}

export class ClaWheelchairAccessibilityDto implements IClaWheelchairAccessibilityDto {
    id!: number | undefined;
    claBusinessId!: number;
    hasWheelchairAccessibleBuildingEntrancesId!: string | undefined;
    hasWheelchairAccessiblePatientAreaId!: string | undefined;

    constructor(data?: IClaWheelchairAccessibilityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claBusinessId = _data["claBusinessId"];
            this.hasWheelchairAccessibleBuildingEntrancesId = _data["hasWheelchairAccessibleBuildingEntrancesId"];
            this.hasWheelchairAccessiblePatientAreaId = _data["hasWheelchairAccessiblePatientAreaId"];
        }
    }

    static fromJS(data: any): ClaWheelchairAccessibilityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaWheelchairAccessibilityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claBusinessId"] = this.claBusinessId;
        data["hasWheelchairAccessibleBuildingEntrancesId"] = this.hasWheelchairAccessibleBuildingEntrancesId;
        data["hasWheelchairAccessiblePatientAreaId"] = this.hasWheelchairAccessiblePatientAreaId;
        return data;
    }
}

export interface IClaWheelchairAccessibilityDto {
    id: number | undefined;
    claBusinessId: number;
    hasWheelchairAccessibleBuildingEntrancesId: string | undefined;
    hasWheelchairAccessiblePatientAreaId: string | undefined;
}

export class CreateClaInput implements ICreateClaInput {
    applicationTypeId!: ApplicationType;
    sponsorshipTypeId!: string;

    constructor(data?: ICreateClaInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationTypeId = _data["applicationTypeId"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
        }
    }

    static fromJS(data: any): CreateClaInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClaInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationTypeId"] = this.applicationTypeId;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        return data;
    }
}

export interface ICreateClaInput {
    applicationTypeId: ApplicationType;
    sponsorshipTypeId: string;
}

export class CreateClaOutput implements ICreateClaOutput {
    caseId!: string | undefined;

    constructor(data?: ICreateClaOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
        }
    }

    static fromJS(data: any): CreateClaOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClaOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        return data;
    }
}

export interface ICreateClaOutput {
    caseId: string | undefined;
}

export class CreateOrUpdateClaInvoiceAddressInput implements ICreateOrUpdateClaInvoiceAddressInput {
    caseId!: string;
    claInvoiceAddress!: ClaInvoiceAddressDto;

    constructor(data?: ICreateOrUpdateClaInvoiceAddressInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.claInvoiceAddress = new ClaInvoiceAddressDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.claInvoiceAddress = _data["claInvoiceAddress"] ? ClaInvoiceAddressDto.fromJS(_data["claInvoiceAddress"]) : new ClaInvoiceAddressDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateClaInvoiceAddressInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateClaInvoiceAddressInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["claInvoiceAddress"] = this.claInvoiceAddress ? this.claInvoiceAddress.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateClaInvoiceAddressInput {
    caseId: string;
    claInvoiceAddress: ClaInvoiceAddressDto;
}

export class CreateOrUpdateClaSponsorshipInput implements ICreateOrUpdateClaSponsorshipInput {
    caseId!: string;
    sponsorship!: ClaSponsorshipDto;

    constructor(data?: ICreateOrUpdateClaSponsorshipInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sponsorship = new ClaSponsorshipDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.sponsorship = _data["sponsorship"] ? ClaSponsorshipDto.fromJS(_data["sponsorship"]) : new ClaSponsorshipDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateClaSponsorshipInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateClaSponsorshipInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["sponsorship"] = this.sponsorship ? this.sponsorship.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateClaSponsorshipInput {
    caseId: string;
    sponsorship: ClaSponsorshipDto;
}

export enum EnumTreatmentType {
    EmergencyStations = 0,
    TreatmentUnits = 1,
    OutpatientClinics = 2,
    OP1 = 3,
    OP2 = 4,
    OP3 = 5,
    SterialisationUnits = 6,
    BirthgivingUnits = 7,
    IntensiveCareUnits = 8,
    IMCUnits = 9,
    RecoveryUnits = 10,
    LaboratoryUnits = 11,
    XRayUnits = 12,
    PharmacyUnits = 13,
    OtherUnit = 14,
}

export class GetClaCorporateLicenceDto implements IGetClaCorporateLicenceDto {
    licenceId!: number | undefined;
    sponsorshipId!: number | undefined;

    constructor(data?: IGetClaCorporateLicenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenceId = _data["licenceId"];
            this.sponsorshipId = _data["sponsorshipId"];
        }
    }

    static fromJS(data: any): GetClaCorporateLicenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetClaCorporateLicenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenceId"] = this.licenceId;
        data["sponsorshipId"] = this.sponsorshipId;
        return data;
    }
}

export interface IGetClaCorporateLicenceDto {
    licenceId: number | undefined;
    sponsorshipId: number | undefined;
}

export class GetClaDocumentsInput implements IGetClaDocumentsInput {
    caseId!: string;
    step!: ClaStatus;
    hasCorporateLicenceInAnotherCantonId!: string | undefined;
    hasProfessionalLicenceId!: string | undefined;
    hasAppliedForProfessionalLicenceId!: string | undefined;

    constructor(data?: IGetClaDocumentsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.step = _data["step"];
            this.hasCorporateLicenceInAnotherCantonId = _data["hasCorporateLicenceInAnotherCantonId"];
            this.hasProfessionalLicenceId = _data["hasProfessionalLicenceId"];
            this.hasAppliedForProfessionalLicenceId = _data["hasAppliedForProfessionalLicenceId"];
        }
    }

    static fromJS(data: any): GetClaDocumentsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetClaDocumentsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["step"] = this.step;
        data["hasCorporateLicenceInAnotherCantonId"] = this.hasCorporateLicenceInAnotherCantonId;
        data["hasProfessionalLicenceId"] = this.hasProfessionalLicenceId;
        data["hasAppliedForProfessionalLicenceId"] = this.hasAppliedForProfessionalLicenceId;
        return data;
    }
}

export interface IGetClaDocumentsInput {
    caseId: string;
    step: ClaStatus;
    hasCorporateLicenceInAnotherCantonId: string | undefined;
    hasProfessionalLicenceId: string | undefined;
    hasAppliedForProfessionalLicenceId: string | undefined;
}

export class GetClaFileInput implements IGetClaFileInput {
    caseId!: string;
    step!: ClaStatus;
    id!: number;

    constructor(data?: IGetClaFileInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.step = _data["step"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetClaFileInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetClaFileInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["step"] = this.step;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetClaFileInput {
    caseId: string;
    step: ClaStatus;
    id: number;
}

export class GetClaOutput implements IGetClaOutput {
    cla!: ClaDto;

    constructor(data?: IGetClaOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cla = _data["cla"] ? ClaDto.fromJS(_data["cla"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetClaOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetClaOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cla"] = this.cla ? this.cla.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetClaOutput {
    cla: ClaDto;
}

export class GetClaSubItemDocumentsInput implements IGetClaSubItemDocumentsInput {
    subItemId!: number;
    hasXRayMachineId!: string | undefined;
    hasOperatingTheatresId!: string | undefined;
    hasAssistantsLicenceId!: string | undefined;
    hasConstructionalMeasuresId!: string | undefined;
    caseId!: string;
    step!: ClaStatus;
    hasCorporateLicenceInAnotherCantonId!: string | undefined;
    hasProfessionalLicenceId!: string | undefined;
    hasAppliedForProfessionalLicenceId!: string | undefined;

    constructor(data?: IGetClaSubItemDocumentsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subItemId = _data["subItemId"];
            this.hasXRayMachineId = _data["hasXRayMachineId"];
            this.hasOperatingTheatresId = _data["hasOperatingTheatresId"];
            this.hasAssistantsLicenceId = _data["hasAssistantsLicenceId"];
            this.hasConstructionalMeasuresId = _data["hasConstructionalMeasuresId"];
            this.caseId = _data["caseId"];
            this.step = _data["step"];
            this.hasCorporateLicenceInAnotherCantonId = _data["hasCorporateLicenceInAnotherCantonId"];
            this.hasProfessionalLicenceId = _data["hasProfessionalLicenceId"];
            this.hasAppliedForProfessionalLicenceId = _data["hasAppliedForProfessionalLicenceId"];
        }
    }

    static fromJS(data: any): GetClaSubItemDocumentsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetClaSubItemDocumentsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subItemId"] = this.subItemId;
        data["hasXRayMachineId"] = this.hasXRayMachineId;
        data["hasOperatingTheatresId"] = this.hasOperatingTheatresId;
        data["hasAssistantsLicenceId"] = this.hasAssistantsLicenceId;
        data["hasConstructionalMeasuresId"] = this.hasConstructionalMeasuresId;
        data["caseId"] = this.caseId;
        data["step"] = this.step;
        data["hasCorporateLicenceInAnotherCantonId"] = this.hasCorporateLicenceInAnotherCantonId;
        data["hasProfessionalLicenceId"] = this.hasProfessionalLicenceId;
        data["hasAppliedForProfessionalLicenceId"] = this.hasAppliedForProfessionalLicenceId;
        return data;
    }
}

export interface IGetClaSubItemDocumentsInput {
    subItemId: number;
    hasXRayMachineId: string | undefined;
    hasOperatingTheatresId: string | undefined;
    hasAssistantsLicenceId: string | undefined;
    hasConstructionalMeasuresId: string | undefined;
    caseId: string;
    step: ClaStatus;
    hasCorporateLicenceInAnotherCantonId: string | undefined;
    hasProfessionalLicenceId: string | undefined;
    hasAppliedForProfessionalLicenceId: string | undefined;
}

export class SlasDrugProductionDto implements ISlasDrugProductionDto {
    id!: number | undefined;
    claBusinessId!: number;
    hasFormulaMagistralisDrugProductionId!: string;
    hasFormulaOfficinalisDrugProductionId!: string;
    hasOwnFormulaDrugProductionId!: string;
    hasFormulaHospitalisDrugProductionId!: string | undefined;

    constructor(data?: ISlasDrugProductionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claBusinessId = _data["claBusinessId"];
            this.hasFormulaMagistralisDrugProductionId = _data["hasFormulaMagistralisDrugProductionId"];
            this.hasFormulaOfficinalisDrugProductionId = _data["hasFormulaOfficinalisDrugProductionId"];
            this.hasOwnFormulaDrugProductionId = _data["hasOwnFormulaDrugProductionId"];
            this.hasFormulaHospitalisDrugProductionId = _data["hasFormulaHospitalisDrugProductionId"];
        }
    }

    static fromJS(data: any): SlasDrugProductionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlasDrugProductionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claBusinessId"] = this.claBusinessId;
        data["hasFormulaMagistralisDrugProductionId"] = this.hasFormulaMagistralisDrugProductionId;
        data["hasFormulaOfficinalisDrugProductionId"] = this.hasFormulaOfficinalisDrugProductionId;
        data["hasOwnFormulaDrugProductionId"] = this.hasOwnFormulaDrugProductionId;
        data["hasFormulaHospitalisDrugProductionId"] = this.hasFormulaHospitalisDrugProductionId;
        return data;
    }
}

export interface ISlasDrugProductionDto {
    id: number | undefined;
    claBusinessId: number;
    hasFormulaMagistralisDrugProductionId: string;
    hasFormulaOfficinalisDrugProductionId: string;
    hasOwnFormulaDrugProductionId: string;
    hasFormulaHospitalisDrugProductionId: string | undefined;
}

export class SlasDrugProductionThirdPartyDto implements ISlasDrugProductionThirdPartyDto {
    id!: number | undefined;
    claBusinessId!: number;
    hasOutsourcedDrugProductionId!: string;

    constructor(data?: ISlasDrugProductionThirdPartyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claBusinessId = _data["claBusinessId"];
            this.hasOutsourcedDrugProductionId = _data["hasOutsourcedDrugProductionId"];
        }
    }

    static fromJS(data: any): SlasDrugProductionThirdPartyDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlasDrugProductionThirdPartyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claBusinessId"] = this.claBusinessId;
        data["hasOutsourcedDrugProductionId"] = this.hasOutsourcedDrugProductionId;
        return data;
    }
}

export interface ISlasDrugProductionThirdPartyDto {
    id: number | undefined;
    claBusinessId: number;
    hasOutsourcedDrugProductionId: string;
}

export class SlasLocalDrugSalesDto implements ISlasLocalDrugSalesDto {
    id!: number | undefined;
    claBusinessId!: number;
    hasDrugSalesId!: string;

    constructor(data?: ISlasLocalDrugSalesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claBusinessId = _data["claBusinessId"];
            this.hasDrugSalesId = _data["hasDrugSalesId"];
        }
    }

    static fromJS(data: any): SlasLocalDrugSalesDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlasLocalDrugSalesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claBusinessId"] = this.claBusinessId;
        data["hasDrugSalesId"] = this.hasDrugSalesId;
        return data;
    }
}

export interface ISlasLocalDrugSalesDto {
    id: number | undefined;
    claBusinessId: number;
    hasDrugSalesId: string;
}

export class SlasProductPreparationDto implements ISlasProductPreparationDto {
    id!: number | undefined;
    claBusinessId!: number;
    hasLocalPreparationId!: string;
    hasExternalPreparationId!: string;
    hasUseOfDisposablesId!: string;

    constructor(data?: ISlasProductPreparationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claBusinessId = _data["claBusinessId"];
            this.hasLocalPreparationId = _data["hasLocalPreparationId"];
            this.hasExternalPreparationId = _data["hasExternalPreparationId"];
            this.hasUseOfDisposablesId = _data["hasUseOfDisposablesId"];
        }
    }

    static fromJS(data: any): SlasProductPreparationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlasProductPreparationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claBusinessId"] = this.claBusinessId;
        data["hasLocalPreparationId"] = this.hasLocalPreparationId;
        data["hasExternalPreparationId"] = this.hasExternalPreparationId;
        data["hasUseOfDisposablesId"] = this.hasUseOfDisposablesId;
        return data;
    }
}

export interface ISlasProductPreparationDto {
    id: number | undefined;
    claBusinessId: number;
    hasLocalPreparationId: string;
    hasExternalPreparationId: string;
    hasUseOfDisposablesId: string;
}

export class SlasRangeOfProductsDto implements ISlasRangeOfProductsDto {
    id!: number | undefined;
    claBusinessId!: number;
    hasOnlyLimitedId!: string;
    hasRefrigeratorRequiredId!: string;
    hasNarcoticsId!: string;
    hasPsychotropicsId!: string;

    constructor(data?: ISlasRangeOfProductsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.claBusinessId = _data["claBusinessId"];
            this.hasOnlyLimitedId = _data["hasOnlyLimitedId"];
            this.hasRefrigeratorRequiredId = _data["hasRefrigeratorRequiredId"];
            this.hasNarcoticsId = _data["hasNarcoticsId"];
            this.hasPsychotropicsId = _data["hasPsychotropicsId"];
        }
    }

    static fromJS(data: any): SlasRangeOfProductsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlasRangeOfProductsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["claBusinessId"] = this.claBusinessId;
        data["hasOnlyLimitedId"] = this.hasOnlyLimitedId;
        data["hasRefrigeratorRequiredId"] = this.hasRefrigeratorRequiredId;
        data["hasNarcoticsId"] = this.hasNarcoticsId;
        data["hasPsychotropicsId"] = this.hasPsychotropicsId;
        return data;
    }
}

export interface ISlasRangeOfProductsDto {
    id: number | undefined;
    claBusinessId: number;
    hasOnlyLimitedId: string;
    hasRefrigeratorRequiredId: string;
    hasNarcoticsId: string;
    hasPsychotropicsId: string;
}

export class UpdateClaAidingResourcesInput implements IUpdateClaAidingResourcesInput {
    caseId!: string;
    aidingResourcesList!: ClaAidingResourcesDto[];

    constructor(data?: IUpdateClaAidingResourcesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.aidingResourcesList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["aidingResourcesList"])) {
                this.aidingResourcesList = [] as any;
                for (let item of _data["aidingResourcesList"])
                    this.aidingResourcesList!.push(ClaAidingResourcesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaAidingResourcesInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaAidingResourcesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.aidingResourcesList)) {
            data["aidingResourcesList"] = [];
            for (let item of this.aidingResourcesList)
                data["aidingResourcesList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaAidingResourcesInput {
    caseId: string;
    aidingResourcesList: ClaAidingResourcesDto[];
}

export class UpdateClaAidingResourcesOutput implements IUpdateClaAidingResourcesOutput {
    status!: ClaStatus;
    businesses!: ClaBusinessDto[] | undefined;

    constructor(data?: IUpdateClaAidingResourcesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaAidingResourcesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaAidingResourcesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaAidingResourcesOutput {
    status: ClaStatus;
    businesses: ClaBusinessDto[] | undefined;
}

export class UpdateClaAssistantPhysiciansInput implements IUpdateClaAssistantPhysiciansInput {
    caseId!: string;
    assistantPhysicians!: ClaAssistantPhysicianDto[];

    constructor(data?: IUpdateClaAssistantPhysiciansInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.assistantPhysicians = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["assistantPhysicians"])) {
                this.assistantPhysicians = [] as any;
                for (let item of _data["assistantPhysicians"])
                    this.assistantPhysicians!.push(ClaAssistantPhysicianDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaAssistantPhysiciansInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaAssistantPhysiciansInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.assistantPhysicians)) {
            data["assistantPhysicians"] = [];
            for (let item of this.assistantPhysicians)
                data["assistantPhysicians"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaAssistantPhysiciansInput {
    caseId: string;
    assistantPhysicians: ClaAssistantPhysicianDto[];
}

export class UpdateClaAssistantPhysiciansOutput implements IUpdateClaAssistantPhysiciansOutput {
    status!: ClaStatus;
    assistantPhysicians!: ClaAssistantPhysicianDto[] | undefined;

    constructor(data?: IUpdateClaAssistantPhysiciansOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["assistantPhysicians"])) {
                this.assistantPhysicians = [] as any;
                for (let item of _data["assistantPhysicians"])
                    this.assistantPhysicians!.push(ClaAssistantPhysicianDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaAssistantPhysiciansOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaAssistantPhysiciansOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.assistantPhysicians)) {
            data["assistantPhysicians"] = [];
            for (let item of this.assistantPhysicians)
                data["assistantPhysicians"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaAssistantPhysiciansOutput {
    status: ClaStatus;
    assistantPhysicians: ClaAssistantPhysicianDto[] | undefined;
}

export class UpdateClaBusinessDirectorsInput implements IUpdateClaBusinessDirectorsInput {
    caseId!: string;
    directors!: ClaBusinessDirectorDto[];

    constructor(data?: IUpdateClaBusinessDirectorsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.directors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["directors"])) {
                this.directors = [] as any;
                for (let item of _data["directors"])
                    this.directors!.push(ClaBusinessDirectorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaBusinessDirectorsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaBusinessDirectorsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.directors)) {
            data["directors"] = [];
            for (let item of this.directors)
                data["directors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaBusinessDirectorsInput {
    caseId: string;
    directors: ClaBusinessDirectorDto[];
}

export class UpdateClaBusinessDirectorsOutput implements IUpdateClaBusinessDirectorsOutput {
    status!: ClaStatus;
    businesses!: ClaBusinessDto[] | undefined;

    constructor(data?: IUpdateClaBusinessDirectorsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaBusinessDirectorsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaBusinessDirectorsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaBusinessDirectorsOutput {
    status: ClaStatus;
    businesses: ClaBusinessDto[] | undefined;
}

export class UpdateClaBusinessesInput implements IUpdateClaBusinessesInput {
    caseId!: string;
    businesses!: ClaBusinessDto[];

    constructor(data?: IUpdateClaBusinessesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.businesses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaBusinessesInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaBusinessesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaBusinessesInput {
    caseId: string;
    businesses: ClaBusinessDto[];
}

export class UpdateClaBusinessesOutput implements IUpdateClaBusinessesOutput {
    status!: ClaStatus;
    businesses!: ClaBusinessDto[] | undefined;

    constructor(data?: IUpdateClaBusinessesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaBusinessesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaBusinessesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaBusinessesOutput {
    status: ClaStatus;
    businesses: ClaBusinessDto[] | undefined;
}

export class UpdateClaDrugChambersInput implements IUpdateClaDrugChambersInput {
    caseId!: string;
    drugChambersList!: ClaDrugChambersDto[];

    constructor(data?: IUpdateClaDrugChambersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.drugChambersList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["drugChambersList"])) {
                this.drugChambersList = [] as any;
                for (let item of _data["drugChambersList"])
                    this.drugChambersList!.push(ClaDrugChambersDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaDrugChambersInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaDrugChambersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.drugChambersList)) {
            data["drugChambersList"] = [];
            for (let item of this.drugChambersList)
                data["drugChambersList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaDrugChambersInput {
    caseId: string;
    drugChambersList: ClaDrugChambersDto[];
}

export class UpdateClaDrugChambersOutput implements IUpdateClaDrugChambersOutput {
    status!: ClaStatus;
    businesses!: ClaBusinessDto[] | undefined;

    constructor(data?: IUpdateClaDrugChambersOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaDrugChambersOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaDrugChambersOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaDrugChambersOutput {
    status: ClaStatus;
    businesses: ClaBusinessDto[] | undefined;
}

export class UpdateClaFloorsInput implements IUpdateClaFloorsInput {
    caseId!: string;
    floorsList!: ClaFloorsDto[];

    constructor(data?: IUpdateClaFloorsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.floorsList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["floorsList"])) {
                this.floorsList = [] as any;
                for (let item of _data["floorsList"])
                    this.floorsList!.push(ClaFloorsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaFloorsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaFloorsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.floorsList)) {
            data["floorsList"] = [];
            for (let item of this.floorsList)
                data["floorsList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaFloorsInput {
    caseId: string;
    floorsList: ClaFloorsDto[];
}

export class UpdateClaFloorsOutput implements IUpdateClaFloorsOutput {
    status!: ClaStatus;
    businesses!: ClaBusinessDto[] | undefined;

    constructor(data?: IUpdateClaFloorsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaFloorsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaFloorsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaFloorsOutput {
    status: ClaStatus;
    businesses: ClaBusinessDto[] | undefined;
}

export class UpdateClaInfrastructureInput implements IUpdateClaInfrastructureInput {
    caseId!: string;
    infrastructureList!: ClaInfrastructureDto[];

    constructor(data?: IUpdateClaInfrastructureInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.infrastructureList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["infrastructureList"])) {
                this.infrastructureList = [] as any;
                for (let item of _data["infrastructureList"])
                    this.infrastructureList!.push(ClaInfrastructureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaInfrastructureInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaInfrastructureInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.infrastructureList)) {
            data["infrastructureList"] = [];
            for (let item of this.infrastructureList)
                data["infrastructureList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaInfrastructureInput {
    caseId: string;
    infrastructureList: ClaInfrastructureDto[];
}

export class UpdateClaInfrastructureOutput implements IUpdateClaInfrastructureOutput {
    status!: ClaStatus;
    businesses!: ClaBusinessDto[] | undefined;

    constructor(data?: IUpdateClaInfrastructureOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaInfrastructureOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaInfrastructureOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaInfrastructureOutput {
    status: ClaStatus;
    businesses: ClaBusinessDto[] | undefined;
}

export class UpdateClaMedicalFieldDirectorInput implements IUpdateClaMedicalFieldDirectorInput {
    caseId!: string;
    medicalFieldDirector!: ClaMedicalFieldDirectorDto;

    constructor(data?: IUpdateClaMedicalFieldDirectorInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.medicalFieldDirector = new ClaMedicalFieldDirectorDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.medicalFieldDirector = _data["medicalFieldDirector"] ? ClaMedicalFieldDirectorDto.fromJS(_data["medicalFieldDirector"]) : new ClaMedicalFieldDirectorDto();
        }
    }

    static fromJS(data: any): UpdateClaMedicalFieldDirectorInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaMedicalFieldDirectorInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["medicalFieldDirector"] = this.medicalFieldDirector ? this.medicalFieldDirector.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateClaMedicalFieldDirectorInput {
    caseId: string;
    medicalFieldDirector: ClaMedicalFieldDirectorDto;
}

export class UpdateClaMedicalFieldDirectorOutput implements IUpdateClaMedicalFieldDirectorOutput {
    status!: ClaStatus;
    medicalFieldDirector!: ClaMedicalFieldDirectorDto;

    constructor(data?: IUpdateClaMedicalFieldDirectorOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.medicalFieldDirector = _data["medicalFieldDirector"] ? ClaMedicalFieldDirectorDto.fromJS(_data["medicalFieldDirector"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateClaMedicalFieldDirectorOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaMedicalFieldDirectorOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["medicalFieldDirector"] = this.medicalFieldDirector ? this.medicalFieldDirector.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateClaMedicalFieldDirectorOutput {
    status: ClaStatus;
    medicalFieldDirector: ClaMedicalFieldDirectorDto;
}

export class UpdateClaMedicalFieldDirectorRepresentativeInput implements IUpdateClaMedicalFieldDirectorRepresentativeInput {
    caseId!: string;
    medicalFieldDirectorRepresentative!: ClaMedicalFieldDirectorRepresentativeDto;

    constructor(data?: IUpdateClaMedicalFieldDirectorRepresentativeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.medicalFieldDirectorRepresentative = new ClaMedicalFieldDirectorRepresentativeDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.medicalFieldDirectorRepresentative = _data["medicalFieldDirectorRepresentative"] ? ClaMedicalFieldDirectorRepresentativeDto.fromJS(_data["medicalFieldDirectorRepresentative"]) : new ClaMedicalFieldDirectorRepresentativeDto();
        }
    }

    static fromJS(data: any): UpdateClaMedicalFieldDirectorRepresentativeInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaMedicalFieldDirectorRepresentativeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["medicalFieldDirectorRepresentative"] = this.medicalFieldDirectorRepresentative ? this.medicalFieldDirectorRepresentative.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateClaMedicalFieldDirectorRepresentativeInput {
    caseId: string;
    medicalFieldDirectorRepresentative: ClaMedicalFieldDirectorRepresentativeDto;
}

export class UpdateClaMedicalFieldDirectorRepresentativeOutput implements IUpdateClaMedicalFieldDirectorRepresentativeOutput {
    status!: ClaStatus;
    medicalFieldDirectorRepresentative!: ClaMedicalFieldDirectorRepresentativeDto;

    constructor(data?: IUpdateClaMedicalFieldDirectorRepresentativeOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.medicalFieldDirectorRepresentative = _data["medicalFieldDirectorRepresentative"] ? ClaMedicalFieldDirectorRepresentativeDto.fromJS(_data["medicalFieldDirectorRepresentative"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateClaMedicalFieldDirectorRepresentativeOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaMedicalFieldDirectorRepresentativeOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["medicalFieldDirectorRepresentative"] = this.medicalFieldDirectorRepresentative ? this.medicalFieldDirectorRepresentative.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateClaMedicalFieldDirectorRepresentativeOutput {
    status: ClaStatus;
    medicalFieldDirectorRepresentative: ClaMedicalFieldDirectorRepresentativeDto;
}

export class UpdateClaMedicalFieldPersonsInput implements IUpdateClaMedicalFieldPersonsInput {
    caseId!: string;
    medicalFieldPersons!: ClaMedicalFieldPersonDto[];

    constructor(data?: IUpdateClaMedicalFieldPersonsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.medicalFieldPersons = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["medicalFieldPersons"])) {
                this.medicalFieldPersons = [] as any;
                for (let item of _data["medicalFieldPersons"])
                    this.medicalFieldPersons!.push(ClaMedicalFieldPersonDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaMedicalFieldPersonsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaMedicalFieldPersonsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.medicalFieldPersons)) {
            data["medicalFieldPersons"] = [];
            for (let item of this.medicalFieldPersons)
                data["medicalFieldPersons"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaMedicalFieldPersonsInput {
    caseId: string;
    medicalFieldPersons: ClaMedicalFieldPersonDto[];
}

export class UpdateClaMedicalFieldPersonsOutput implements IUpdateClaMedicalFieldPersonsOutput {
    status!: ClaStatus;
    medicalFieldPersons!: ClaMedicalFieldPersonDto[] | undefined;

    constructor(data?: IUpdateClaMedicalFieldPersonsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["medicalFieldPersons"])) {
                this.medicalFieldPersons = [] as any;
                for (let item of _data["medicalFieldPersons"])
                    this.medicalFieldPersons!.push(ClaMedicalFieldPersonDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaMedicalFieldPersonsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaMedicalFieldPersonsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.medicalFieldPersons)) {
            data["medicalFieldPersons"] = [];
            for (let item of this.medicalFieldPersons)
                data["medicalFieldPersons"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaMedicalFieldPersonsOutput {
    status: ClaStatus;
    medicalFieldPersons: ClaMedicalFieldPersonDto[] | undefined;
}

export class UpdateClaNursingBedsInput implements IUpdateClaNursingBedsInput {
    caseId!: string;
    nursingBedsList!: ClaNursingBedsDto[];

    constructor(data?: IUpdateClaNursingBedsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.nursingBedsList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["nursingBedsList"])) {
                this.nursingBedsList = [] as any;
                for (let item of _data["nursingBedsList"])
                    this.nursingBedsList!.push(ClaNursingBedsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaNursingBedsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaNursingBedsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.nursingBedsList)) {
            data["nursingBedsList"] = [];
            for (let item of this.nursingBedsList)
                data["nursingBedsList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaNursingBedsInput {
    caseId: string;
    nursingBedsList: ClaNursingBedsDto[];
}

export class UpdateClaNursingBedsOutput implements IUpdateClaNursingBedsOutput {
    status!: ClaStatus;
    businesses!: ClaBusinessDto[] | undefined;

    constructor(data?: IUpdateClaNursingBedsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaNursingBedsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaNursingBedsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaNursingBedsOutput {
    status: ClaStatus;
    businesses: ClaBusinessDto[] | undefined;
}

export class UpdateClaPersonelInput implements IUpdateClaPersonelInput {
    caseId!: string;
    personelList!: ClaPersonelDto[];

    constructor(data?: IUpdateClaPersonelInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.personelList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["personelList"])) {
                this.personelList = [] as any;
                for (let item of _data["personelList"])
                    this.personelList!.push(ClaPersonelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaPersonelInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaPersonelInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.personelList)) {
            data["personelList"] = [];
            for (let item of this.personelList)
                data["personelList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaPersonelInput {
    caseId: string;
    personelList: ClaPersonelDto[];
}

export class UpdateClaPersonelOutput implements IUpdateClaPersonelOutput {
    status!: ClaStatus;
    businesses!: ClaBusinessDto[] | undefined;

    constructor(data?: IUpdateClaPersonelOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaPersonelOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaPersonelOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaPersonelOutput {
    status: ClaStatus;
    businesses: ClaBusinessDto[] | undefined;
}

export class UpdateClaQualityInput implements IUpdateClaQualityInput {
    caseId!: string;
    qualityList!: ClaQualityDto[];

    constructor(data?: IUpdateClaQualityInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.qualityList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["qualityList"])) {
                this.qualityList = [] as any;
                for (let item of _data["qualityList"])
                    this.qualityList!.push(ClaQualityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaQualityInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaQualityInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.qualityList)) {
            data["qualityList"] = [];
            for (let item of this.qualityList)
                data["qualityList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaQualityInput {
    caseId: string;
    qualityList: ClaQualityDto[];
}

export class UpdateClaQualityOutput implements IUpdateClaQualityOutput {
    status!: ClaStatus;
    businesses!: ClaBusinessDto[] | undefined;

    constructor(data?: IUpdateClaQualityOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaQualityOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaQualityOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaQualityOutput {
    status: ClaStatus;
    businesses: ClaBusinessDto[] | undefined;
}

export class UpdateClaRangeOfServicesInput implements IUpdateClaRangeOfServicesInput {
    caseId!: string;
    rangeOfServicesList!: ClaRangeOfServicesDto[];

    constructor(data?: IUpdateClaRangeOfServicesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.rangeOfServicesList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["rangeOfServicesList"])) {
                this.rangeOfServicesList = [] as any;
                for (let item of _data["rangeOfServicesList"])
                    this.rangeOfServicesList!.push(ClaRangeOfServicesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaRangeOfServicesInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaRangeOfServicesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.rangeOfServicesList)) {
            data["rangeOfServicesList"] = [];
            for (let item of this.rangeOfServicesList)
                data["rangeOfServicesList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaRangeOfServicesInput {
    caseId: string;
    rangeOfServicesList: ClaRangeOfServicesDto[];
}

export class UpdateClaRangeOfServicesOutput implements IUpdateClaRangeOfServicesOutput {
    status!: ClaStatus;
    businesses!: ClaBusinessDto[] | undefined;

    constructor(data?: IUpdateClaRangeOfServicesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaRangeOfServicesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaRangeOfServicesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaRangeOfServicesOutput {
    status: ClaStatus;
    businesses: ClaBusinessDto[] | undefined;
}

export class UpdateClaSanitaryFacilitiesInput implements IUpdateClaSanitaryFacilitiesInput {
    caseId!: string;
    sanitaryFacilitiesList!: ClaSanitaryFacilitiesDto[];

    constructor(data?: IUpdateClaSanitaryFacilitiesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sanitaryFacilitiesList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["sanitaryFacilitiesList"])) {
                this.sanitaryFacilitiesList = [] as any;
                for (let item of _data["sanitaryFacilitiesList"])
                    this.sanitaryFacilitiesList!.push(ClaSanitaryFacilitiesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaSanitaryFacilitiesInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaSanitaryFacilitiesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.sanitaryFacilitiesList)) {
            data["sanitaryFacilitiesList"] = [];
            for (let item of this.sanitaryFacilitiesList)
                data["sanitaryFacilitiesList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaSanitaryFacilitiesInput {
    caseId: string;
    sanitaryFacilitiesList: ClaSanitaryFacilitiesDto[];
}

export class UpdateClaSanitaryFacilitiesOutput implements IUpdateClaSanitaryFacilitiesOutput {
    status!: ClaStatus;
    businesses!: ClaBusinessDto[] | undefined;

    constructor(data?: IUpdateClaSanitaryFacilitiesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaSanitaryFacilitiesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaSanitaryFacilitiesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaSanitaryFacilitiesOutput {
    status: ClaStatus;
    businesses: ClaBusinessDto[] | undefined;
}

export class UpdateClaSecurityInput implements IUpdateClaSecurityInput {
    caseId!: string;
    securityList!: ClaSecurityDto[];

    constructor(data?: IUpdateClaSecurityInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.securityList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["securityList"])) {
                this.securityList = [] as any;
                for (let item of _data["securityList"])
                    this.securityList!.push(ClaSecurityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaSecurityInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaSecurityInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.securityList)) {
            data["securityList"] = [];
            for (let item of this.securityList)
                data["securityList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaSecurityInput {
    caseId: string;
    securityList: ClaSecurityDto[];
}

export class UpdateClaSecurityOutput implements IUpdateClaSecurityOutput {
    status!: ClaStatus;
    businesses!: ClaBusinessDto[] | undefined;

    constructor(data?: IUpdateClaSecurityOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaSecurityOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaSecurityOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaSecurityOutput {
    status: ClaStatus;
    businesses: ClaBusinessDto[] | undefined;
}

export class UpdateClaServiceAreasInput implements IUpdateClaServiceAreasInput {
    caseId!: string;
    serviceAreasList!: ClaServiceAreasDto[];

    constructor(data?: IUpdateClaServiceAreasInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.serviceAreasList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["serviceAreasList"])) {
                this.serviceAreasList = [] as any;
                for (let item of _data["serviceAreasList"])
                    this.serviceAreasList!.push(ClaServiceAreasDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaServiceAreasInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaServiceAreasInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.serviceAreasList)) {
            data["serviceAreasList"] = [];
            for (let item of this.serviceAreasList)
                data["serviceAreasList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaServiceAreasInput {
    caseId: string;
    serviceAreasList: ClaServiceAreasDto[];
}

export class UpdateClaServiceAreasOutput implements IUpdateClaServiceAreasOutput {
    status!: ClaStatus;
    businesses!: ClaBusinessDto[] | undefined;

    constructor(data?: IUpdateClaServiceAreasOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaServiceAreasOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaServiceAreasOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaServiceAreasOutput {
    status: ClaStatus;
    businesses: ClaBusinessDto[] | undefined;
}

export class UpdateClaSponsorshipDirectorsInput implements IUpdateClaSponsorshipDirectorsInput {
    caseId!: string;
    sponsorshipDirectors!: ClaSponsorshipDirectorDto[];

    constructor(data?: IUpdateClaSponsorshipDirectorsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sponsorshipDirectors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["sponsorshipDirectors"])) {
                this.sponsorshipDirectors = [] as any;
                for (let item of _data["sponsorshipDirectors"])
                    this.sponsorshipDirectors!.push(ClaSponsorshipDirectorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaSponsorshipDirectorsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaSponsorshipDirectorsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.sponsorshipDirectors)) {
            data["sponsorshipDirectors"] = [];
            for (let item of this.sponsorshipDirectors)
                data["sponsorshipDirectors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaSponsorshipDirectorsInput {
    caseId: string;
    sponsorshipDirectors: ClaSponsorshipDirectorDto[];
}

export class UpdateClaSponsorshipDirectorsOutput implements IUpdateClaSponsorshipDirectorsOutput {
    status!: ClaStatus;
    directors!: ClaSponsorshipDirectorDto[] | undefined;

    constructor(data?: IUpdateClaSponsorshipDirectorsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["directors"])) {
                this.directors = [] as any;
                for (let item of _data["directors"])
                    this.directors!.push(ClaSponsorshipDirectorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaSponsorshipDirectorsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaSponsorshipDirectorsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.directors)) {
            data["directors"] = [];
            for (let item of this.directors)
                data["directors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaSponsorshipDirectorsOutput {
    status: ClaStatus;
    directors: ClaSponsorshipDirectorDto[] | undefined;
}

export class UpdateClaTreatmentInput implements IUpdateClaTreatmentInput {
    caseId!: string;
    treatmentList!: ClaTreatmentDto[];

    constructor(data?: IUpdateClaTreatmentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.treatmentList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["treatmentList"])) {
                this.treatmentList = [] as any;
                for (let item of _data["treatmentList"])
                    this.treatmentList!.push(ClaTreatmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaTreatmentInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaTreatmentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.treatmentList)) {
            data["treatmentList"] = [];
            for (let item of this.treatmentList)
                data["treatmentList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaTreatmentInput {
    caseId: string;
    treatmentList: ClaTreatmentDto[];
}

export class UpdateClaTreatmentOutput implements IUpdateClaTreatmentOutput {
    status!: ClaStatus;
    businesses!: ClaBusinessDto[] | undefined;

    constructor(data?: IUpdateClaTreatmentOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaTreatmentOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaTreatmentOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaTreatmentOutput {
    status: ClaStatus;
    businesses: ClaBusinessDto[] | undefined;
}

export class UpdateClaWheelchairAccessibilityInput implements IUpdateClaWheelchairAccessibilityInput {
    caseId!: string;
    wheelchairAccessibilityList!: ClaWheelchairAccessibilityDto[];

    constructor(data?: IUpdateClaWheelchairAccessibilityInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.wheelchairAccessibilityList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["wheelchairAccessibilityList"])) {
                this.wheelchairAccessibilityList = [] as any;
                for (let item of _data["wheelchairAccessibilityList"])
                    this.wheelchairAccessibilityList!.push(ClaWheelchairAccessibilityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaWheelchairAccessibilityInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaWheelchairAccessibilityInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.wheelchairAccessibilityList)) {
            data["wheelchairAccessibilityList"] = [];
            for (let item of this.wheelchairAccessibilityList)
                data["wheelchairAccessibilityList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaWheelchairAccessibilityInput {
    caseId: string;
    wheelchairAccessibilityList: ClaWheelchairAccessibilityDto[];
}

export class UpdateClaWheelchairAccessibilityOutput implements IUpdateClaWheelchairAccessibilityOutput {
    status!: ClaStatus;
    businesses!: ClaBusinessDto[] | undefined;

    constructor(data?: IUpdateClaWheelchairAccessibilityOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClaWheelchairAccessibilityOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaWheelchairAccessibilityOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateClaWheelchairAccessibilityOutput {
    status: ClaStatus;
    businesses: ClaBusinessDto[] | undefined;
}

export class UpdateSlasDrugProductionInput implements IUpdateSlasDrugProductionInput {
    caseId!: string;
    drugProductionList!: SlasDrugProductionDto[];

    constructor(data?: IUpdateSlasDrugProductionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.drugProductionList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["drugProductionList"])) {
                this.drugProductionList = [] as any;
                for (let item of _data["drugProductionList"])
                    this.drugProductionList!.push(SlasDrugProductionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateSlasDrugProductionInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSlasDrugProductionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.drugProductionList)) {
            data["drugProductionList"] = [];
            for (let item of this.drugProductionList)
                data["drugProductionList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateSlasDrugProductionInput {
    caseId: string;
    drugProductionList: SlasDrugProductionDto[];
}

export class UpdateSlasDrugProductionOutput implements IUpdateSlasDrugProductionOutput {
    status!: ClaStatus;
    businesses!: ClaBusinessDto[] | undefined;

    constructor(data?: IUpdateSlasDrugProductionOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateSlasDrugProductionOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSlasDrugProductionOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateSlasDrugProductionOutput {
    status: ClaStatus;
    businesses: ClaBusinessDto[] | undefined;
}

export class UpdateSlasDrugProductionThirdPartyInput implements IUpdateSlasDrugProductionThirdPartyInput {
    caseId!: string;
    drugProductionThirdPartyList!: SlasDrugProductionThirdPartyDto[];

    constructor(data?: IUpdateSlasDrugProductionThirdPartyInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.drugProductionThirdPartyList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["drugProductionThirdPartyList"])) {
                this.drugProductionThirdPartyList = [] as any;
                for (let item of _data["drugProductionThirdPartyList"])
                    this.drugProductionThirdPartyList!.push(SlasDrugProductionThirdPartyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateSlasDrugProductionThirdPartyInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSlasDrugProductionThirdPartyInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.drugProductionThirdPartyList)) {
            data["drugProductionThirdPartyList"] = [];
            for (let item of this.drugProductionThirdPartyList)
                data["drugProductionThirdPartyList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateSlasDrugProductionThirdPartyInput {
    caseId: string;
    drugProductionThirdPartyList: SlasDrugProductionThirdPartyDto[];
}

export class UpdateSlasDrugProductionThirdPartyOutput implements IUpdateSlasDrugProductionThirdPartyOutput {
    status!: ClaStatus;
    businesses!: ClaBusinessDto[] | undefined;

    constructor(data?: IUpdateSlasDrugProductionThirdPartyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateSlasDrugProductionThirdPartyOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSlasDrugProductionThirdPartyOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateSlasDrugProductionThirdPartyOutput {
    status: ClaStatus;
    businesses: ClaBusinessDto[] | undefined;
}

export class UpdateSlasLocalDrugSalesInput implements IUpdateSlasLocalDrugSalesInput {
    caseId!: string;
    localDrugSalesList!: SlasLocalDrugSalesDto[];

    constructor(data?: IUpdateSlasLocalDrugSalesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.localDrugSalesList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["localDrugSalesList"])) {
                this.localDrugSalesList = [] as any;
                for (let item of _data["localDrugSalesList"])
                    this.localDrugSalesList!.push(SlasLocalDrugSalesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateSlasLocalDrugSalesInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSlasLocalDrugSalesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.localDrugSalesList)) {
            data["localDrugSalesList"] = [];
            for (let item of this.localDrugSalesList)
                data["localDrugSalesList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateSlasLocalDrugSalesInput {
    caseId: string;
    localDrugSalesList: SlasLocalDrugSalesDto[];
}

export class UpdateSlasLocalDrugSalesOutput implements IUpdateSlasLocalDrugSalesOutput {
    status!: ClaStatus;
    businesses!: ClaBusinessDto[] | undefined;

    constructor(data?: IUpdateSlasLocalDrugSalesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateSlasLocalDrugSalesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSlasLocalDrugSalesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateSlasLocalDrugSalesOutput {
    status: ClaStatus;
    businesses: ClaBusinessDto[] | undefined;
}

export class UpdateSlasProductPreparationInput implements IUpdateSlasProductPreparationInput {
    caseId!: string;
    productPreparationList!: SlasProductPreparationDto[];

    constructor(data?: IUpdateSlasProductPreparationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.productPreparationList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["productPreparationList"])) {
                this.productPreparationList = [] as any;
                for (let item of _data["productPreparationList"])
                    this.productPreparationList!.push(SlasProductPreparationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateSlasProductPreparationInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSlasProductPreparationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.productPreparationList)) {
            data["productPreparationList"] = [];
            for (let item of this.productPreparationList)
                data["productPreparationList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateSlasProductPreparationInput {
    caseId: string;
    productPreparationList: SlasProductPreparationDto[];
}

export class UpdateSlasProductPreparationOutput implements IUpdateSlasProductPreparationOutput {
    status!: ClaStatus;
    businesses!: ClaBusinessDto[] | undefined;

    constructor(data?: IUpdateSlasProductPreparationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateSlasProductPreparationOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSlasProductPreparationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateSlasProductPreparationOutput {
    status: ClaStatus;
    businesses: ClaBusinessDto[] | undefined;
}

export class UpdateSlasRangeOfProductsInput implements IUpdateSlasRangeOfProductsInput {
    caseId!: string;
    rangeOfProductsList!: SlasRangeOfProductsDto[];

    constructor(data?: IUpdateSlasRangeOfProductsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.rangeOfProductsList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["rangeOfProductsList"])) {
                this.rangeOfProductsList = [] as any;
                for (let item of _data["rangeOfProductsList"])
                    this.rangeOfProductsList!.push(SlasRangeOfProductsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateSlasRangeOfProductsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSlasRangeOfProductsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.rangeOfProductsList)) {
            data["rangeOfProductsList"] = [];
            for (let item of this.rangeOfProductsList)
                data["rangeOfProductsList"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateSlasRangeOfProductsInput {
    caseId: string;
    rangeOfProductsList: SlasRangeOfProductsDto[];
}

export class UpdateSlasRangeOfProductsOutput implements IUpdateSlasRangeOfProductsOutput {
    status!: ClaStatus;
    businesses!: ClaBusinessDto[] | undefined;

    constructor(data?: IUpdateSlasRangeOfProductsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(ClaBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateSlasRangeOfProductsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSlasRangeOfProductsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateSlasRangeOfProductsOutput {
    status: ClaStatus;
    businesses: ClaBusinessDto[] | undefined;
}

export enum CriminalPenaltyDiscriminator {
    Person = 0,
    Sponsorship = 1,
}

export enum CriminalPenaltyRecordDiscriminator {
    Person = 0,
    Sponsorship = 1,
}

export class GetCriminalPenaltyRecordSearchOutputDto implements IGetCriminalPenaltyRecordSearchOutputDto {
    totalCount!: number;
    items!: GetCriminalPenaltyRecordDto[] | undefined;

    constructor(data?: IGetCriminalPenaltyRecordSearchOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetCriminalPenaltyRecordDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCriminalPenaltyRecordSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCriminalPenaltyRecordSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCriminalPenaltyRecordSearchOutputDto {
    totalCount: number;
    items: GetCriminalPenaltyRecordDto[] | undefined;
}

export class CreateCriminalPenaltyRecordDto implements ICreateCriminalPenaltyRecordDto {
    discriminator!: CriminalPenaltyRecordDiscriminator;
    type!: string | undefined;
    relevantForLicenceId!: string | undefined;
    ongoingLegalProceeding!: boolean;
    dateOfCriminalPenalty!: DateTime | undefined;
    dateOfLegalForce!: DateTime | undefined;
    dateOfInformation!: DateTime | undefined;
    informationSource!: string | undefined;
    reason!: string | undefined;
    remark!: string | undefined;
    professionId!: string | undefined;
    dateOfDeletionFromTheCriminalRecord!: DateTime | undefined;
    corporateLicenceId!: number | undefined;
    sponsorshipTypeId!: string | undefined;

    constructor(data?: ICreateCriminalPenaltyRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discriminator = _data["discriminator"];
            this.type = _data["type"];
            this.relevantForLicenceId = _data["relevantForLicenceId"];
            this.ongoingLegalProceeding = _data["ongoingLegalProceeding"];
            this.dateOfCriminalPenalty = _data["dateOfCriminalPenalty"] ? DateTime.fromISO(_data["dateOfCriminalPenalty"].toString()) : <any>undefined;
            this.dateOfLegalForce = _data["dateOfLegalForce"] ? DateTime.fromISO(_data["dateOfLegalForce"].toString()) : <any>undefined;
            this.dateOfInformation = _data["dateOfInformation"] ? DateTime.fromISO(_data["dateOfInformation"].toString()) : <any>undefined;
            this.informationSource = _data["informationSource"];
            this.reason = _data["reason"];
            this.remark = _data["remark"];
            this.professionId = _data["professionId"];
            this.dateOfDeletionFromTheCriminalRecord = _data["dateOfDeletionFromTheCriminalRecord"] ? DateTime.fromISO(_data["dateOfDeletionFromTheCriminalRecord"].toString()) : <any>undefined;
            this.corporateLicenceId = _data["corporateLicenceId"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
        }
    }

    static fromJS(data: any): CreateCriminalPenaltyRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCriminalPenaltyRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this.discriminator;
        data["type"] = this.type;
        data["relevantForLicenceId"] = this.relevantForLicenceId;
        data["ongoingLegalProceeding"] = this.ongoingLegalProceeding;
        data["dateOfCriminalPenalty"] = this.dateOfCriminalPenalty ? this.dateOfCriminalPenalty.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfLegalForce"] = this.dateOfLegalForce ? this.dateOfLegalForce.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfInformation"] = this.dateOfInformation ? this.dateOfInformation.toFormat('yyyy-MM-dd') : <any>undefined;
        data["informationSource"] = this.informationSource;
        data["reason"] = this.reason;
        data["remark"] = this.remark;
        data["professionId"] = this.professionId;
        data["dateOfDeletionFromTheCriminalRecord"] = this.dateOfDeletionFromTheCriminalRecord ? this.dateOfDeletionFromTheCriminalRecord.toFormat('yyyy-MM-dd') : <any>undefined;
        data["corporateLicenceId"] = this.corporateLicenceId;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        return data;
    }
}

export interface ICreateCriminalPenaltyRecordDto {
    discriminator: CriminalPenaltyRecordDiscriminator;
    type: string | undefined;
    relevantForLicenceId: string | undefined;
    ongoingLegalProceeding: boolean;
    dateOfCriminalPenalty: DateTime | undefined;
    dateOfLegalForce: DateTime | undefined;
    dateOfInformation: DateTime | undefined;
    informationSource: string | undefined;
    reason: string | undefined;
    remark: string | undefined;
    professionId: string | undefined;
    dateOfDeletionFromTheCriminalRecord: DateTime | undefined;
    corporateLicenceId: number | undefined;
    sponsorshipTypeId: string | undefined;
}

export class GetCriminalPenaltyRecordDto implements IGetCriminalPenaltyRecordDto {
    id!: number;
    discriminator!: CriminalPenaltyRecordDiscriminator;
    type!: string | undefined;
    relevantForLicenceId!: string | undefined;
    ongoingLegalProceeding!: boolean;
    dateOfCriminalPenalty!: DateTime | undefined;
    dateOfLegalForce!: DateTime | undefined;
    dateOfInformation!: DateTime | undefined;
    informationSource!: string | undefined;
    reason!: string | undefined;
    remark!: string | undefined;
    professionId!: string | undefined;
    dateOfDeletionFromTheCriminalRecord!: DateTime | undefined;
    corporateLicenceId!: number | undefined;
    sponsorshipTypeId!: string | undefined;

    constructor(data?: IGetCriminalPenaltyRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.discriminator = _data["discriminator"];
            this.type = _data["type"];
            this.relevantForLicenceId = _data["relevantForLicenceId"];
            this.ongoingLegalProceeding = _data["ongoingLegalProceeding"];
            this.dateOfCriminalPenalty = _data["dateOfCriminalPenalty"] ? DateTime.fromISO(_data["dateOfCriminalPenalty"].toString()) : <any>undefined;
            this.dateOfLegalForce = _data["dateOfLegalForce"] ? DateTime.fromISO(_data["dateOfLegalForce"].toString()) : <any>undefined;
            this.dateOfInformation = _data["dateOfInformation"] ? DateTime.fromISO(_data["dateOfInformation"].toString()) : <any>undefined;
            this.informationSource = _data["informationSource"];
            this.reason = _data["reason"];
            this.remark = _data["remark"];
            this.professionId = _data["professionId"];
            this.dateOfDeletionFromTheCriminalRecord = _data["dateOfDeletionFromTheCriminalRecord"] ? DateTime.fromISO(_data["dateOfDeletionFromTheCriminalRecord"].toString()) : <any>undefined;
            this.corporateLicenceId = _data["corporateLicenceId"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
        }
    }

    static fromJS(data: any): GetCriminalPenaltyRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCriminalPenaltyRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["discriminator"] = this.discriminator;
        data["type"] = this.type;
        data["relevantForLicenceId"] = this.relevantForLicenceId;
        data["ongoingLegalProceeding"] = this.ongoingLegalProceeding;
        data["dateOfCriminalPenalty"] = this.dateOfCriminalPenalty ? this.dateOfCriminalPenalty.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfLegalForce"] = this.dateOfLegalForce ? this.dateOfLegalForce.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfInformation"] = this.dateOfInformation ? this.dateOfInformation.toFormat('yyyy-MM-dd') : <any>undefined;
        data["informationSource"] = this.informationSource;
        data["reason"] = this.reason;
        data["remark"] = this.remark;
        data["professionId"] = this.professionId;
        data["dateOfDeletionFromTheCriminalRecord"] = this.dateOfDeletionFromTheCriminalRecord ? this.dateOfDeletionFromTheCriminalRecord.toFormat('yyyy-MM-dd') : <any>undefined;
        data["corporateLicenceId"] = this.corporateLicenceId;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        return data;
    }
}

export interface IGetCriminalPenaltyRecordDto {
    id: number;
    discriminator: CriminalPenaltyRecordDiscriminator;
    type: string | undefined;
    relevantForLicenceId: string | undefined;
    ongoingLegalProceeding: boolean;
    dateOfCriminalPenalty: DateTime | undefined;
    dateOfLegalForce: DateTime | undefined;
    dateOfInformation: DateTime | undefined;
    informationSource: string | undefined;
    reason: string | undefined;
    remark: string | undefined;
    professionId: string | undefined;
    dateOfDeletionFromTheCriminalRecord: DateTime | undefined;
    corporateLicenceId: number | undefined;
    sponsorshipTypeId: string | undefined;
}

export class UpdateCriminalPenaltyRecordDto implements IUpdateCriminalPenaltyRecordDto {
    type!: string | undefined;
    relevantForLicenceId!: string | undefined;
    ongoingLegalProceeding!: boolean;
    dateOfCriminalPenalty!: DateTime | undefined;
    dateOfLegalForce!: DateTime | undefined;
    dateOfInformation!: DateTime | undefined;
    informationSource!: string | undefined;
    reason!: string | undefined;
    remark!: string | undefined;
    professionId!: string | undefined;
    dateOfDeletionFromTheCriminalRecord!: DateTime | undefined;
    corporateLicenceId!: number | undefined;
    sponsorshipTypeId!: string | undefined;

    constructor(data?: IUpdateCriminalPenaltyRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.relevantForLicenceId = _data["relevantForLicenceId"];
            this.ongoingLegalProceeding = _data["ongoingLegalProceeding"];
            this.dateOfCriminalPenalty = _data["dateOfCriminalPenalty"] ? DateTime.fromISO(_data["dateOfCriminalPenalty"].toString()) : <any>undefined;
            this.dateOfLegalForce = _data["dateOfLegalForce"] ? DateTime.fromISO(_data["dateOfLegalForce"].toString()) : <any>undefined;
            this.dateOfInformation = _data["dateOfInformation"] ? DateTime.fromISO(_data["dateOfInformation"].toString()) : <any>undefined;
            this.informationSource = _data["informationSource"];
            this.reason = _data["reason"];
            this.remark = _data["remark"];
            this.professionId = _data["professionId"];
            this.dateOfDeletionFromTheCriminalRecord = _data["dateOfDeletionFromTheCriminalRecord"] ? DateTime.fromISO(_data["dateOfDeletionFromTheCriminalRecord"].toString()) : <any>undefined;
            this.corporateLicenceId = _data["corporateLicenceId"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
        }
    }

    static fromJS(data: any): UpdateCriminalPenaltyRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCriminalPenaltyRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["relevantForLicenceId"] = this.relevantForLicenceId;
        data["ongoingLegalProceeding"] = this.ongoingLegalProceeding;
        data["dateOfCriminalPenalty"] = this.dateOfCriminalPenalty ? this.dateOfCriminalPenalty.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfLegalForce"] = this.dateOfLegalForce ? this.dateOfLegalForce.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfInformation"] = this.dateOfInformation ? this.dateOfInformation.toFormat('yyyy-MM-dd') : <any>undefined;
        data["informationSource"] = this.informationSource;
        data["reason"] = this.reason;
        data["remark"] = this.remark;
        data["professionId"] = this.professionId;
        data["dateOfDeletionFromTheCriminalRecord"] = this.dateOfDeletionFromTheCriminalRecord ? this.dateOfDeletionFromTheCriminalRecord.toFormat('yyyy-MM-dd') : <any>undefined;
        data["corporateLicenceId"] = this.corporateLicenceId;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        return data;
    }
}

export interface IUpdateCriminalPenaltyRecordDto {
    type: string | undefined;
    relevantForLicenceId: string | undefined;
    ongoingLegalProceeding: boolean;
    dateOfCriminalPenalty: DateTime | undefined;
    dateOfLegalForce: DateTime | undefined;
    dateOfInformation: DateTime | undefined;
    informationSource: string | undefined;
    reason: string | undefined;
    remark: string | undefined;
    professionId: string | undefined;
    dateOfDeletionFromTheCriminalRecord: DateTime | undefined;
    corporateLicenceId: number | undefined;
    sponsorshipTypeId: string | undefined;
}

export class LicenceApplicationFinishedStatisticDto implements ILicenceApplicationFinishedStatisticDto {
    granted!: number;
    denied!: number;

    constructor(data?: ILicenceApplicationFinishedStatisticDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.granted = _data["granted"];
            this.denied = _data["denied"];
        }
    }

    static fromJS(data: any): LicenceApplicationFinishedStatisticDto {
        data = typeof data === 'object' ? data : {};
        let result = new LicenceApplicationFinishedStatisticDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["granted"] = this.granted;
        data["denied"] = this.denied;
        return data;
    }
}

export interface ILicenceApplicationFinishedStatisticDto {
    granted: number;
    denied: number;
}

export class LicenceApplicationResponsibleStatisticDto implements ILicenceApplicationResponsibleStatisticDto {
    submitted!: number;
    underEvaluation!: number;
    formallyEvaluated!: number;
    underSupplementalClaim!: number;
    granted!: number;
    denied!: number;

    constructor(data?: ILicenceApplicationResponsibleStatisticDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submitted = _data["submitted"];
            this.underEvaluation = _data["underEvaluation"];
            this.formallyEvaluated = _data["formallyEvaluated"];
            this.underSupplementalClaim = _data["underSupplementalClaim"];
            this.granted = _data["granted"];
            this.denied = _data["denied"];
        }
    }

    static fromJS(data: any): LicenceApplicationResponsibleStatisticDto {
        data = typeof data === 'object' ? data : {};
        let result = new LicenceApplicationResponsibleStatisticDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submitted"] = this.submitted;
        data["underEvaluation"] = this.underEvaluation;
        data["formallyEvaluated"] = this.formallyEvaluated;
        data["underSupplementalClaim"] = this.underSupplementalClaim;
        data["granted"] = this.granted;
        data["denied"] = this.denied;
        return data;
    }
}

export interface ILicenceApplicationResponsibleStatisticDto {
    submitted: number;
    underEvaluation: number;
    formallyEvaluated: number;
    underSupplementalClaim: number;
    granted: number;
    denied: number;
}

export class LicenceApplicationStatisticDto implements ILicenceApplicationStatisticDto {
    date!: DateTime[] | undefined;
    submitted!: number[] | undefined;
    underEvaluation!: number[] | undefined;
    formallyEvaluated!: number[] | undefined;
    underSupplementalClaim!: number[] | undefined;
    granted!: number[] | undefined;
    denied!: number[] | undefined;

    constructor(data?: ILicenceApplicationStatisticDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["date"])) {
                this.date = [] as any;
                for (let item of _data["date"])
                    this.date!.push(DateTime.fromISO(item));
            }
            if (Array.isArray(_data["submitted"])) {
                this.submitted = [] as any;
                for (let item of _data["submitted"])
                    this.submitted!.push(item);
            }
            if (Array.isArray(_data["underEvaluation"])) {
                this.underEvaluation = [] as any;
                for (let item of _data["underEvaluation"])
                    this.underEvaluation!.push(item);
            }
            if (Array.isArray(_data["formallyEvaluated"])) {
                this.formallyEvaluated = [] as any;
                for (let item of _data["formallyEvaluated"])
                    this.formallyEvaluated!.push(item);
            }
            if (Array.isArray(_data["underSupplementalClaim"])) {
                this.underSupplementalClaim = [] as any;
                for (let item of _data["underSupplementalClaim"])
                    this.underSupplementalClaim!.push(item);
            }
            if (Array.isArray(_data["granted"])) {
                this.granted = [] as any;
                for (let item of _data["granted"])
                    this.granted!.push(item);
            }
            if (Array.isArray(_data["denied"])) {
                this.denied = [] as any;
                for (let item of _data["denied"])
                    this.denied!.push(item);
            }
        }
    }

    static fromJS(data: any): LicenceApplicationStatisticDto {
        data = typeof data === 'object' ? data : {};
        let result = new LicenceApplicationStatisticDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.date)) {
            data["date"] = [];
            for (let item of this.date)
                data["date"].push(item.toString());
        }
        if (Array.isArray(this.submitted)) {
            data["submitted"] = [];
            for (let item of this.submitted)
                data["submitted"].push(item);
        }
        if (Array.isArray(this.underEvaluation)) {
            data["underEvaluation"] = [];
            for (let item of this.underEvaluation)
                data["underEvaluation"].push(item);
        }
        if (Array.isArray(this.formallyEvaluated)) {
            data["formallyEvaluated"] = [];
            for (let item of this.formallyEvaluated)
                data["formallyEvaluated"].push(item);
        }
        if (Array.isArray(this.underSupplementalClaim)) {
            data["underSupplementalClaim"] = [];
            for (let item of this.underSupplementalClaim)
                data["underSupplementalClaim"].push(item);
        }
        if (Array.isArray(this.granted)) {
            data["granted"] = [];
            for (let item of this.granted)
                data["granted"].push(item);
        }
        if (Array.isArray(this.denied)) {
            data["denied"] = [];
            for (let item of this.denied)
                data["denied"].push(item);
        }
        return data;
    }
}

export interface ILicenceApplicationStatisticDto {
    date: DateTime[] | undefined;
    submitted: number[] | undefined;
    underEvaluation: number[] | undefined;
    formallyEvaluated: number[] | undefined;
    underSupplementalClaim: number[] | undefined;
    granted: number[] | undefined;
    denied: number[] | undefined;
}

export class OwnResponsobilityEntityDto implements IOwnResponsobilityEntityDto {
    id!: number;
    caseId!: string | undefined;
    type!: OwnResponsobilityEntityType;
    designator!: string | undefined;
    email!: string | undefined;
    additionalInformation!: string | undefined;
    applicationStatus!: ApplicationStatus;
    identificationStatus!: string | undefined;
    dateOfStatusChange!: DateTime;

    constructor(data?: IOwnResponsobilityEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.caseId = _data["caseId"];
            this.type = _data["type"];
            this.designator = _data["designator"];
            this.email = _data["email"];
            this.additionalInformation = _data["additionalInformation"];
            this.applicationStatus = _data["applicationStatus"];
            this.identificationStatus = _data["identificationStatus"];
            this.dateOfStatusChange = _data["dateOfStatusChange"] ? DateTime.fromISO(_data["dateOfStatusChange"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OwnResponsobilityEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new OwnResponsobilityEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["caseId"] = this.caseId;
        data["type"] = this.type;
        data["designator"] = this.designator;
        data["email"] = this.email;
        data["additionalInformation"] = this.additionalInformation;
        data["applicationStatus"] = this.applicationStatus;
        data["identificationStatus"] = this.identificationStatus;
        data["dateOfStatusChange"] = this.dateOfStatusChange ? this.dateOfStatusChange.toString() : <any>undefined;
        return data;
    }
}

export interface IOwnResponsobilityEntityDto {
    id: number;
    caseId: string | undefined;
    type: OwnResponsobilityEntityType;
    designator: string | undefined;
    email: string | undefined;
    additionalInformation: string | undefined;
    applicationStatus: ApplicationStatus;
    identificationStatus: string | undefined;
    dateOfStatusChange: DateTime;
}

export enum OwnResponsobilityEntityType {
    Lia = 0,
    Identification = 1,
}

export class DetailsDto implements IDetailsDto {
    detailId!: string | undefined;

    constructor(data?: IDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.detailId = _data["detailId"];
        }
    }

    static fromJS(data: any): DetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new DetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["detailId"] = this.detailId;
        return data;
    }
}

export interface IDetailsDto {
    detailId: string | undefined;
}

export class CreateDiplomaDto implements ICreateDiplomaDto {
    personId!: number;
    professionId!: string;
    nonHealthRegProfession!: string | undefined;
    typeId!: string;
    placeOfIssue!: string | undefined;
    countryId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfRecognition!: DateTime | undefined;
    placeOfRecognition!: string | undefined;
    recognitionAuthority!: string | undefined;
    dateOfRegistration!: DateTime | undefined;
    registerNumber!: string | undefined;
    dateOfEquivalence!: DateTime | undefined;
    overwriteWithHealthRegisterData!: boolean;

    constructor(data?: ICreateDiplomaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.professionId = _data["professionId"];
            this.nonHealthRegProfession = _data["nonHealthRegProfession"];
            this.typeId = _data["typeId"];
            this.placeOfIssue = _data["placeOfIssue"];
            this.countryId = _data["countryId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfRecognition = _data["dateOfRecognition"] ? DateTime.fromISO(_data["dateOfRecognition"].toString()) : <any>undefined;
            this.placeOfRecognition = _data["placeOfRecognition"];
            this.recognitionAuthority = _data["recognitionAuthority"];
            this.dateOfRegistration = _data["dateOfRegistration"] ? DateTime.fromISO(_data["dateOfRegistration"].toString()) : <any>undefined;
            this.registerNumber = _data["registerNumber"];
            this.dateOfEquivalence = _data["dateOfEquivalence"] ? DateTime.fromISO(_data["dateOfEquivalence"].toString()) : <any>undefined;
            this.overwriteWithHealthRegisterData = _data["overwriteWithHealthRegisterData"];
        }
    }

    static fromJS(data: any): CreateDiplomaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDiplomaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["professionId"] = this.professionId;
        data["nonHealthRegProfession"] = this.nonHealthRegProfession;
        data["typeId"] = this.typeId;
        data["placeOfIssue"] = this.placeOfIssue;
        data["countryId"] = this.countryId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfRecognition"] = this.dateOfRecognition ? this.dateOfRecognition.toFormat('yyyy-MM-dd') : <any>undefined;
        data["placeOfRecognition"] = this.placeOfRecognition;
        data["recognitionAuthority"] = this.recognitionAuthority;
        data["dateOfRegistration"] = this.dateOfRegistration ? this.dateOfRegistration.toFormat('yyyy-MM-dd') : <any>undefined;
        data["registerNumber"] = this.registerNumber;
        data["dateOfEquivalence"] = this.dateOfEquivalence ? this.dateOfEquivalence.toFormat('yyyy-MM-dd') : <any>undefined;
        data["overwriteWithHealthRegisterData"] = this.overwriteWithHealthRegisterData;
        return data;
    }
}

export interface ICreateDiplomaDto {
    personId: number;
    professionId: string;
    nonHealthRegProfession: string | undefined;
    typeId: string;
    placeOfIssue: string | undefined;
    countryId: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfRecognition: DateTime | undefined;
    placeOfRecognition: string | undefined;
    recognitionAuthority: string | undefined;
    dateOfRegistration: DateTime | undefined;
    registerNumber: string | undefined;
    dateOfEquivalence: DateTime | undefined;
    overwriteWithHealthRegisterData: boolean;
}

export class DiplomaDto implements IDiplomaDto {
    professionId!: string;
    nonHealthRegProfession!: string | undefined;
    typeId!: string;
    placeOfIssue!: string | undefined;
    countryId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfRecognition!: DateTime | undefined;
    placeOfRecognition!: string | undefined;
    recognitionAuthority!: string | undefined;
    dateOfRegistration!: DateTime | undefined;
    registerNumber!: string | undefined;
    dateOfEquivalence!: DateTime | undefined;
    overwriteWithHealthRegisterData!: boolean;

    constructor(data?: IDiplomaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professionId = _data["professionId"];
            this.nonHealthRegProfession = _data["nonHealthRegProfession"];
            this.typeId = _data["typeId"];
            this.placeOfIssue = _data["placeOfIssue"];
            this.countryId = _data["countryId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfRecognition = _data["dateOfRecognition"] ? DateTime.fromISO(_data["dateOfRecognition"].toString()) : <any>undefined;
            this.placeOfRecognition = _data["placeOfRecognition"];
            this.recognitionAuthority = _data["recognitionAuthority"];
            this.dateOfRegistration = _data["dateOfRegistration"] ? DateTime.fromISO(_data["dateOfRegistration"].toString()) : <any>undefined;
            this.registerNumber = _data["registerNumber"];
            this.dateOfEquivalence = _data["dateOfEquivalence"] ? DateTime.fromISO(_data["dateOfEquivalence"].toString()) : <any>undefined;
            this.overwriteWithHealthRegisterData = _data["overwriteWithHealthRegisterData"];
        }
    }

    static fromJS(data: any): DiplomaDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiplomaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professionId"] = this.professionId;
        data["nonHealthRegProfession"] = this.nonHealthRegProfession;
        data["typeId"] = this.typeId;
        data["placeOfIssue"] = this.placeOfIssue;
        data["countryId"] = this.countryId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfRecognition"] = this.dateOfRecognition ? this.dateOfRecognition.toFormat('yyyy-MM-dd') : <any>undefined;
        data["placeOfRecognition"] = this.placeOfRecognition;
        data["recognitionAuthority"] = this.recognitionAuthority;
        data["dateOfRegistration"] = this.dateOfRegistration ? this.dateOfRegistration.toFormat('yyyy-MM-dd') : <any>undefined;
        data["registerNumber"] = this.registerNumber;
        data["dateOfEquivalence"] = this.dateOfEquivalence ? this.dateOfEquivalence.toFormat('yyyy-MM-dd') : <any>undefined;
        data["overwriteWithHealthRegisterData"] = this.overwriteWithHealthRegisterData;
        return data;
    }
}

export interface IDiplomaDto {
    professionId: string;
    nonHealthRegProfession: string | undefined;
    typeId: string;
    placeOfIssue: string | undefined;
    countryId: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfRecognition: DateTime | undefined;
    placeOfRecognition: string | undefined;
    recognitionAuthority: string | undefined;
    dateOfRegistration: DateTime | undefined;
    registerNumber: string | undefined;
    dateOfEquivalence: DateTime | undefined;
    overwriteWithHealthRegisterData: boolean;
}

export class DiplomaSearchResultDto implements IDiplomaSearchResultDto {
    id!: number;
    professionId!: string | undefined;
    nonHealthRegProfession!: string | undefined;
    typeId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfRecognition!: DateTime | undefined;
    placeOfIssue!: string | undefined;
    countryId!: string | undefined;

    constructor(data?: IDiplomaSearchResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.professionId = _data["professionId"];
            this.nonHealthRegProfession = _data["nonHealthRegProfession"];
            this.typeId = _data["typeId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfRecognition = _data["dateOfRecognition"] ? DateTime.fromISO(_data["dateOfRecognition"].toString()) : <any>undefined;
            this.placeOfIssue = _data["placeOfIssue"];
            this.countryId = _data["countryId"];
        }
    }

    static fromJS(data: any): DiplomaSearchResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiplomaSearchResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["professionId"] = this.professionId;
        data["nonHealthRegProfession"] = this.nonHealthRegProfession;
        data["typeId"] = this.typeId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfRecognition"] = this.dateOfRecognition ? this.dateOfRecognition.toFormat('yyyy-MM-dd') : <any>undefined;
        data["placeOfIssue"] = this.placeOfIssue;
        data["countryId"] = this.countryId;
        return data;
    }
}

export interface IDiplomaSearchResultDto {
    id: number;
    professionId: string | undefined;
    nonHealthRegProfession: string | undefined;
    typeId: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfRecognition: DateTime | undefined;
    placeOfIssue: string | undefined;
    countryId: string | undefined;
}

export class GetDiplomaSearchOutput implements IGetDiplomaSearchOutput {
    totalCount!: number;
    items!: DiplomaSearchResultDto[] | undefined;

    constructor(data?: IGetDiplomaSearchOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DiplomaSearchResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDiplomaSearchOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDiplomaSearchOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDiplomaSearchOutput {
    totalCount: number;
    items: DiplomaSearchResultDto[] | undefined;
}

export class CreateDocumentDto implements ICreateDocumentDto {
    typeId!: string | undefined;
    categoryId!: string | undefined;
    name!: string;
    description!: string | undefined;
    dateOfReceipt!: DateTime;
    datedFrom!: DateTime | undefined;
    data!: string;
    links!: LinkDto[];

    constructor(data?: ICreateDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.links = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeId = _data["typeId"];
            this.categoryId = _data["categoryId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.dateOfReceipt = _data["dateOfReceipt"] ? DateTime.fromISO(_data["dateOfReceipt"].toString()) : <any>undefined;
            this.datedFrom = _data["datedFrom"] ? DateTime.fromISO(_data["datedFrom"].toString()) : <any>undefined;
            this.data = _data["data"];
            if (Array.isArray(_data["links"])) {
                this.links = [] as any;
                for (let item of _data["links"])
                    this.links!.push(LinkDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["categoryId"] = this.categoryId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["dateOfReceipt"] = this.dateOfReceipt ? this.dateOfReceipt.toFormat('yyyy-MM-dd') : <any>undefined;
        data["datedFrom"] = this.datedFrom ? this.datedFrom.toFormat('yyyy-MM-dd') : <any>undefined;
        data["data"] = this.data;
        if (Array.isArray(this.links)) {
            data["links"] = [];
            for (let item of this.links)
                data["links"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateDocumentDto {
    typeId: string | undefined;
    categoryId: string | undefined;
    name: string;
    description: string | undefined;
    dateOfReceipt: DateTime;
    datedFrom: DateTime | undefined;
    data: string;
    links: LinkDto[];
}

export class DmsLinkDescriptionDto implements IDmsLinkDescriptionDto {
    entityId!: number;
    discriminator!: string | undefined;
    description!: string | undefined;
    additionalData!: { [key: string]: any; } | undefined;

    constructor(data?: IDmsLinkDescriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            this.discriminator = _data["discriminator"];
            this.description = _data["description"];
            if (_data["additionalData"]) {
                this.additionalData = {} as any;
                for (let key in _data["additionalData"]) {
                    if (_data["additionalData"].hasOwnProperty(key))
                        (<any>this.additionalData)![key] = _data["additionalData"][key];
                }
            }
        }
    }

    static fromJS(data: any): DmsLinkDescriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new DmsLinkDescriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        data["discriminator"] = this.discriminator;
        data["description"] = this.description;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    (<any>data["additionalData"])[key] = (<any>this.additionalData)[key];
            }
        }
        return data;
    }
}

export interface IDmsLinkDescriptionDto {
    entityId: number;
    discriminator: string | undefined;
    description: string | undefined;
    additionalData: { [key: string]: any; } | undefined;
}

export class DmsSearchResultDto implements IDmsSearchResultDto {
    externalId!: string | undefined;
    typeId!: string | undefined;
    categoryId!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    context!: string | undefined;
    dateOfReceipt!: DateTime;
    datedFrom!: DateTime | undefined;
    mimeHeader!: string | undefined;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: DateTime;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    links!: DmsLinkDescriptionDto[] | undefined;
    id!: number;

    constructor(data?: IDmsSearchResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
            this.typeId = _data["typeId"];
            this.categoryId = _data["categoryId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.context = _data["context"];
            this.dateOfReceipt = _data["dateOfReceipt"] ? DateTime.fromISO(_data["dateOfReceipt"].toString()) : <any>undefined;
            this.datedFrom = _data["datedFrom"] ? DateTime.fromISO(_data["datedFrom"].toString()) : <any>undefined;
            this.mimeHeader = _data["mimeHeader"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["links"])) {
                this.links = [] as any;
                for (let item of _data["links"])
                    this.links!.push(DmsLinkDescriptionDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DmsSearchResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DmsSearchResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        data["typeId"] = this.typeId;
        data["categoryId"] = this.categoryId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["context"] = this.context;
        data["dateOfReceipt"] = this.dateOfReceipt ? this.dateOfReceipt.toFormat('yyyy-MM-dd') : <any>undefined;
        data["datedFrom"] = this.datedFrom ? this.datedFrom.toFormat('yyyy-MM-dd') : <any>undefined;
        data["mimeHeader"] = this.mimeHeader;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toFormat('yyyy-MM-dd') : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toFormat('yyyy-MM-dd') : <any>undefined;
        if (Array.isArray(this.links)) {
            data["links"] = [];
            for (let item of this.links)
                data["links"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IDmsSearchResultDto {
    externalId: string | undefined;
    typeId: string | undefined;
    categoryId: string | undefined;
    name: string | undefined;
    description: string | undefined;
    context: string | undefined;
    dateOfReceipt: DateTime;
    datedFrom: DateTime | undefined;
    mimeHeader: string | undefined;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: DateTime;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: DateTime | undefined;
    links: DmsLinkDescriptionDto[] | undefined;
    id: number;
}

export class DocumentDecreeDto implements IDocumentDecreeDto {
    dateOfSend!: DateTime | undefined;
    dateOfDeliveryReceipt!: DateTime | undefined;
    dateOfPickupReceipt!: DateTime | undefined;
    dateOfExpirationReceipt!: DateTime | undefined;

    constructor(data?: IDocumentDecreeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateOfSend = _data["dateOfSend"] ? DateTime.fromISO(_data["dateOfSend"].toString()) : <any>undefined;
            this.dateOfDeliveryReceipt = _data["dateOfDeliveryReceipt"] ? DateTime.fromISO(_data["dateOfDeliveryReceipt"].toString()) : <any>undefined;
            this.dateOfPickupReceipt = _data["dateOfPickupReceipt"] ? DateTime.fromISO(_data["dateOfPickupReceipt"].toString()) : <any>undefined;
            this.dateOfExpirationReceipt = _data["dateOfExpirationReceipt"] ? DateTime.fromISO(_data["dateOfExpirationReceipt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DocumentDecreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDecreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateOfSend"] = this.dateOfSend ? this.dateOfSend.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDeliveryReceipt"] = this.dateOfDeliveryReceipt ? this.dateOfDeliveryReceipt.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfPickupReceipt"] = this.dateOfPickupReceipt ? this.dateOfPickupReceipt.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfExpirationReceipt"] = this.dateOfExpirationReceipt ? this.dateOfExpirationReceipt.toFormat('yyyy-MM-dd') : <any>undefined;
        return data;
    }
}

export interface IDocumentDecreeDto {
    dateOfSend: DateTime | undefined;
    dateOfDeliveryReceipt: DateTime | undefined;
    dateOfPickupReceipt: DateTime | undefined;
    dateOfExpirationReceipt: DateTime | undefined;
}

export class GetDmsSearchInput implements IGetDmsSearchInput {
    fullTextSearch!: string | undefined;
    link!: LinkDto;
    mustContainReferenceLink!: boolean;
    documentIdsToExclude!: number[] | undefined;
    allowedTypeIds!: string[] | undefined;
    entitySearchDiscriminator!: string | undefined;
    entitySearchTerm!: string | undefined;
    filter!: string | undefined;
    sorting!: string | undefined;
    maxResultCount!: number;
    skipCount!: number;

    constructor(data?: IGetDmsSearchInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullTextSearch = _data["fullTextSearch"];
            this.link = _data["link"] ? LinkDto.fromJS(_data["link"]) : <any>undefined;
            this.mustContainReferenceLink = _data["mustContainReferenceLink"];
            if (Array.isArray(_data["documentIdsToExclude"])) {
                this.documentIdsToExclude = [] as any;
                for (let item of _data["documentIdsToExclude"])
                    this.documentIdsToExclude!.push(item);
            }
            if (Array.isArray(_data["allowedTypeIds"])) {
                this.allowedTypeIds = [] as any;
                for (let item of _data["allowedTypeIds"])
                    this.allowedTypeIds!.push(item);
            }
            this.entitySearchDiscriminator = _data["entitySearchDiscriminator"];
            this.entitySearchTerm = _data["entitySearchTerm"];
            this.filter = _data["filter"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): GetDmsSearchInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDmsSearchInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullTextSearch"] = this.fullTextSearch;
        data["link"] = this.link ? this.link.toJSON() : <any>undefined;
        data["mustContainReferenceLink"] = this.mustContainReferenceLink;
        if (Array.isArray(this.documentIdsToExclude)) {
            data["documentIdsToExclude"] = [];
            for (let item of this.documentIdsToExclude)
                data["documentIdsToExclude"].push(item);
        }
        if (Array.isArray(this.allowedTypeIds)) {
            data["allowedTypeIds"] = [];
            for (let item of this.allowedTypeIds)
                data["allowedTypeIds"].push(item);
        }
        data["entitySearchDiscriminator"] = this.entitySearchDiscriminator;
        data["entitySearchTerm"] = this.entitySearchTerm;
        data["filter"] = this.filter;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }
}

export interface IGetDmsSearchInput {
    fullTextSearch: string | undefined;
    link: LinkDto;
    mustContainReferenceLink: boolean;
    documentIdsToExclude: number[] | undefined;
    allowedTypeIds: string[] | undefined;
    entitySearchDiscriminator: string | undefined;
    entitySearchTerm: string | undefined;
    filter: string | undefined;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
}

export class GetDmsSearchOutput implements IGetDmsSearchOutput {
    totalCount!: number;
    items!: DmsSearchResultDto[] | undefined;

    constructor(data?: IGetDmsSearchOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DmsSearchResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDmsSearchOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDmsSearchOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDmsSearchOutput {
    totalCount: number;
    items: DmsSearchResultDto[] | undefined;
}

export class GetDocumentDto implements IGetDocumentDto {
    externalId!: string | undefined;
    typeId!: string | undefined;
    categoryId!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    context!: string | undefined;
    dateOfReceipt!: DateTime;
    datedFrom!: DateTime | undefined;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: DateTime;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    decree!: DocumentDecreeDto;
    mimeType!: string | undefined;
    lastWordVersionId!: number | undefined;
    links!: DmsLinkDescriptionDto[] | undefined;
    id!: number;

    constructor(data?: IGetDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
            this.typeId = _data["typeId"];
            this.categoryId = _data["categoryId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.context = _data["context"];
            this.dateOfReceipt = _data["dateOfReceipt"] ? DateTime.fromISO(_data["dateOfReceipt"].toString()) : <any>undefined;
            this.datedFrom = _data["datedFrom"] ? DateTime.fromISO(_data["datedFrom"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.decree = _data["decree"] ? DocumentDecreeDto.fromJS(_data["decree"]) : <any>undefined;
            this.mimeType = _data["mimeType"];
            this.lastWordVersionId = _data["lastWordVersionId"];
            if (Array.isArray(_data["links"])) {
                this.links = [] as any;
                for (let item of _data["links"])
                    this.links!.push(DmsLinkDescriptionDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        data["typeId"] = this.typeId;
        data["categoryId"] = this.categoryId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["context"] = this.context;
        data["dateOfReceipt"] = this.dateOfReceipt ? this.dateOfReceipt.toFormat('yyyy-MM-dd') : <any>undefined;
        data["datedFrom"] = this.datedFrom ? this.datedFrom.toFormat('yyyy-MM-dd') : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["decree"] = this.decree ? this.decree.toJSON() : <any>undefined;
        data["mimeType"] = this.mimeType;
        data["lastWordVersionId"] = this.lastWordVersionId;
        if (Array.isArray(this.links)) {
            data["links"] = [];
            for (let item of this.links)
                data["links"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IGetDocumentDto {
    externalId: string | undefined;
    typeId: string | undefined;
    categoryId: string | undefined;
    name: string | undefined;
    description: string | undefined;
    context: string | undefined;
    dateOfReceipt: DateTime;
    datedFrom: DateTime | undefined;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: DateTime;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: DateTime | undefined;
    decree: DocumentDecreeDto;
    mimeType: string | undefined;
    lastWordVersionId: number | undefined;
    links: DmsLinkDescriptionDto[] | undefined;
    id: number;
}

export class LinkDto implements ILinkDto {
    discriminator!: string;
    entityId!: number;

    constructor(data?: ILinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discriminator = _data["discriminator"];
            this.entityId = _data["entityId"];
        }
    }

    static fromJS(data: any): LinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new LinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this.discriminator;
        data["entityId"] = this.entityId;
        return data;
    }
}

export interface ILinkDto {
    discriminator: string;
    entityId: number;
}

export class ScanImportFileDto implements IScanImportFileDto {
    filename!: string;
    file!: string;

    constructor(data?: IScanImportFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filename = _data["filename"];
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): ScanImportFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScanImportFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filename"] = this.filename;
        data["file"] = this.file;
        return data;
    }
}

export interface IScanImportFileDto {
    filename: string;
    file: string;
}

export class CreateUpdateFileDto implements ICreateUpdateFileDto {
    filename!: string;
    file!: string;

    constructor(data?: ICreateUpdateFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filename = _data["filename"];
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): CreateUpdateFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filename"] = this.filename;
        data["file"] = this.file;
        return data;
    }
}

export interface ICreateUpdateFileDto {
    filename: string;
    file: string;
}

export class CreateUpdateTemplateDto implements ICreateUpdateTemplateDto {
    typeId!: string | undefined;
    designation!: string;
    professionId!: string | undefined;
    sponsorshipTypeId!: string | undefined;
    file!: CreateUpdateFileDto;

    constructor(data?: ICreateUpdateTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeId = _data["typeId"];
            this.designation = _data["designation"];
            this.professionId = _data["professionId"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.file = _data["file"] ? CreateUpdateFileDto.fromJS(_data["file"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateUpdateTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["designation"] = this.designation;
        data["professionId"] = this.professionId;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateUpdateTemplateDto {
    typeId: string | undefined;
    designation: string;
    professionId: string | undefined;
    sponsorshipTypeId: string | undefined;
    file: CreateUpdateFileDto;
}

export class DmsTemplateEntityDto implements IDmsTemplateEntityDto {
    id!: number;
    type!: string | undefined;
    selectableEntityType!: DmsTemplateSelectableEntityType;
    subEntities!: DmsTemplateEntityDto[] | undefined;

    constructor(data?: IDmsTemplateEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.selectableEntityType = _data["selectableEntityType"];
            if (Array.isArray(_data["subEntities"])) {
                this.subEntities = [] as any;
                for (let item of _data["subEntities"])
                    this.subEntities!.push(DmsTemplateEntityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DmsTemplateEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new DmsTemplateEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["selectableEntityType"] = this.selectableEntityType;
        if (Array.isArray(this.subEntities)) {
            data["subEntities"] = [];
            for (let item of this.subEntities)
                data["subEntities"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDmsTemplateEntityDto {
    id: number;
    type: string | undefined;
    selectableEntityType: DmsTemplateSelectableEntityType;
    subEntities: DmsTemplateEntityDto[] | undefined;
}

export class DmsTemplateSelectableEntityDto implements IDmsTemplateSelectableEntityDto {
    entity!: DmsTemplateEntityDto;
    description!: string | undefined;

    constructor(data?: IDmsTemplateSelectableEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entity = _data["entity"] ? DmsTemplateEntityDto.fromJS(_data["entity"]) : <any>undefined;
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): DmsTemplateSelectableEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new DmsTemplateSelectableEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        data["description"] = this.description;
        return data;
    }
}

export interface IDmsTemplateSelectableEntityDto {
    entity: DmsTemplateEntityDto;
    description: string | undefined;
}

export class GenerateDocumentFromTemplateInputDto implements IGenerateDocumentFromTemplateInputDto {
    documentTemplateId!: number;
    selectedEntities!: DmsTemplateEntityDto[];
    links!: LinkDto[];
    generatePreviewXml!: boolean;

    constructor(data?: IGenerateDocumentFromTemplateInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.selectedEntities = [];
            this.links = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentTemplateId = _data["documentTemplateId"];
            if (Array.isArray(_data["selectedEntities"])) {
                this.selectedEntities = [] as any;
                for (let item of _data["selectedEntities"])
                    this.selectedEntities!.push(DmsTemplateEntityDto.fromJS(item));
            }
            if (Array.isArray(_data["links"])) {
                this.links = [] as any;
                for (let item of _data["links"])
                    this.links!.push(LinkDto.fromJS(item));
            }
            this.generatePreviewXml = _data["generatePreviewXml"];
        }
    }

    static fromJS(data: any): GenerateDocumentFromTemplateInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateDocumentFromTemplateInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentTemplateId"] = this.documentTemplateId;
        if (Array.isArray(this.selectedEntities)) {
            data["selectedEntities"] = [];
            for (let item of this.selectedEntities)
                data["selectedEntities"].push(item.toJSON());
        }
        if (Array.isArray(this.links)) {
            data["links"] = [];
            for (let item of this.links)
                data["links"].push(item.toJSON());
        }
        data["generatePreviewXml"] = this.generatePreviewXml;
        return data;
    }
}

export interface IGenerateDocumentFromTemplateInputDto {
    documentTemplateId: number;
    selectedEntities: DmsTemplateEntityDto[];
    links: LinkDto[];
    generatePreviewXml: boolean;
}

export class GenerateDocumentFromTemplateResultDto implements IGenerateDocumentFromTemplateResultDto {
    documentId!: number;
    xmlData!: string | undefined;

    constructor(data?: IGenerateDocumentFromTemplateResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.xmlData = _data["xmlData"];
        }
    }

    static fromJS(data: any): GenerateDocumentFromTemplateResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateDocumentFromTemplateResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["xmlData"] = this.xmlData;
        return data;
    }
}

export interface IGenerateDocumentFromTemplateResultDto {
    documentId: number;
    xmlData: string | undefined;
}

export class GenerateFromTemplateDiscriminatorInputDto implements IGenerateFromTemplateDiscriminatorInputDto {
    documentTemplateDiscriminator!: string;
    selectedEntities!: DmsTemplateEntityDto[] | undefined;
    links!: LinkDto[];
    generatePreviewXml!: boolean;

    constructor(data?: IGenerateFromTemplateDiscriminatorInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.links = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentTemplateDiscriminator = _data["documentTemplateDiscriminator"];
            if (Array.isArray(_data["selectedEntities"])) {
                this.selectedEntities = [] as any;
                for (let item of _data["selectedEntities"])
                    this.selectedEntities!.push(DmsTemplateEntityDto.fromJS(item));
            }
            if (Array.isArray(_data["links"])) {
                this.links = [] as any;
                for (let item of _data["links"])
                    this.links!.push(LinkDto.fromJS(item));
            }
            this.generatePreviewXml = _data["generatePreviewXml"];
        }
    }

    static fromJS(data: any): GenerateFromTemplateDiscriminatorInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateFromTemplateDiscriminatorInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentTemplateDiscriminator"] = this.documentTemplateDiscriminator;
        if (Array.isArray(this.selectedEntities)) {
            data["selectedEntities"] = [];
            for (let item of this.selectedEntities)
                data["selectedEntities"].push(item.toJSON());
        }
        if (Array.isArray(this.links)) {
            data["links"] = [];
            for (let item of this.links)
                data["links"].push(item.toJSON());
        }
        data["generatePreviewXml"] = this.generatePreviewXml;
        return data;
    }
}

export interface IGenerateFromTemplateDiscriminatorInputDto {
    documentTemplateDiscriminator: string;
    selectedEntities: DmsTemplateEntityDto[] | undefined;
    links: LinkDto[];
    generatePreviewXml: boolean;
}

export class GetTemplateDto implements IGetTemplateDto {
    discriminator!: string | undefined;
    typeId!: string | undefined;
    designation!: string;
    name!: string | undefined;
    mimeHeader!: string | undefined;
    professionId!: string | undefined;
    sponsorshipTypeId!: string | undefined;
    creationTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    id!: number;

    constructor(data?: IGetTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discriminator = _data["discriminator"];
            this.typeId = _data["typeId"];
            this.designation = _data["designation"];
            this.name = _data["name"];
            this.mimeHeader = _data["mimeHeader"];
            this.professionId = _data["professionId"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this.discriminator;
        data["typeId"] = this.typeId;
        data["designation"] = this.designation;
        data["name"] = this.name;
        data["mimeHeader"] = this.mimeHeader;
        data["professionId"] = this.professionId;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetTemplateDto {
    discriminator: string | undefined;
    typeId: string | undefined;
    designation: string;
    name: string | undefined;
    mimeHeader: string | undefined;
    professionId: string | undefined;
    sponsorshipTypeId: string | undefined;
    creationTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    id: number;
}

export class SearchTemplateOutput implements ISearchTemplateOutput {
    totalCount!: number;
    items!: GetTemplateDto[] | undefined;

    constructor(data?: ISearchTemplateOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetTemplateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchTemplateOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SearchTemplateOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchTemplateOutput {
    totalCount: number;
    items: GetTemplateDto[] | undefined;
}

export class SearchTemplatesInput implements ISearchTemplatesInput {
    discriminator!: string;
    filter!: string | undefined;
    sorting!: string | undefined;
    maxResultCount!: number;
    skipCount!: number;

    constructor(data?: ISearchTemplatesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discriminator = _data["discriminator"];
            this.filter = _data["filter"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): SearchTemplatesInput {
        data = typeof data === 'object' ? data : {};
        let result = new SearchTemplatesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this.discriminator;
        data["filter"] = this.filter;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }
}

export interface ISearchTemplatesInput {
    discriminator: string;
    filter: string | undefined;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
}

export class UpdateDocumentDto implements IUpdateDocumentDto {
    typeId!: string | undefined;
    categoryId!: string | undefined;
    name!: string;
    description!: string | undefined;
    dateOfReceipt!: DateTime;
    datedFrom!: DateTime | undefined;

    constructor(data?: IUpdateDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeId = _data["typeId"];
            this.categoryId = _data["categoryId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.dateOfReceipt = _data["dateOfReceipt"] ? DateTime.fromISO(_data["dateOfReceipt"].toString()) : <any>undefined;
            this.datedFrom = _data["datedFrom"] ? DateTime.fromISO(_data["datedFrom"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["categoryId"] = this.categoryId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["dateOfReceipt"] = this.dateOfReceipt ? this.dateOfReceipt.toFormat('yyyy-MM-dd') : <any>undefined;
        data["datedFrom"] = this.datedFrom ? this.datedFrom.toFormat('yyyy-MM-dd') : <any>undefined;
        return data;
    }
}

export interface IUpdateDocumentDto {
    typeId: string | undefined;
    categoryId: string | undefined;
    name: string;
    description: string | undefined;
    dateOfReceipt: DateTime;
    datedFrom: DateTime | undefined;
}

export class GeneralDocumentsOutput implements IGeneralDocumentsOutput {
    caseId!: string;
    documents!: GeneralDocumentGroupDto[];

    constructor(data?: IGeneralDocumentsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.documents = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GeneralDocumentsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralDocumentsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGeneralDocumentsOutput {
    caseId: string;
    documents: GeneralDocumentGroupDto[];
}

export class FileDto implements IFileDto {
    fileName!: string;
    fileType!: string | undefined;
    fileToken!: string;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileToken = _data["fileToken"];
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface IFileDto {
    fileName: string;
    fileType: string | undefined;
    fileToken: string;
}

export class GeneralDocumentGroupDto implements IGeneralDocumentGroupDto {
    typeId!: string | undefined;
    isMandatory!: boolean | undefined;
    info!: string | undefined;
    files!: GeneralFileInfoDto[] | undefined;
    id!: number;

    constructor(data?: IGeneralDocumentGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeId = _data["typeId"];
            this.isMandatory = _data["isMandatory"];
            this.info = _data["info"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(GeneralFileInfoDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GeneralDocumentGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralDocumentGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["isMandatory"] = this.isMandatory;
        data["info"] = this.info;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IGeneralDocumentGroupDto {
    typeId: string | undefined;
    isMandatory: boolean | undefined;
    info: string | undefined;
    files: GeneralFileInfoDto[] | undefined;
    id: number;
}

export class GeneralResultDocumentInput implements IGeneralResultDocumentInput {
    caseId!: string;
    typeId!: string;
    document!: GeneralFileDto;

    constructor(data?: IGeneralResultDocumentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.document = new GeneralFileDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.typeId = _data["typeId"];
            this.document = _data["document"] ? GeneralFileDto.fromJS(_data["document"]) : new GeneralFileDto();
        }
    }

    static fromJS(data: any): GeneralResultDocumentInput {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralResultDocumentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["typeId"] = this.typeId;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGeneralResultDocumentInput {
    caseId: string;
    typeId: string;
    document: GeneralFileDto;
}

export class OndAddressCountryPoBoxDto implements IOndAddressCountryPoBoxDto {
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    countryId!: string | undefined;
    addressAddition!: string | undefined;
    postOfficeBox!: string | undefined;

    constructor(data?: IOndAddressCountryPoBoxDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.countryId = _data["countryId"];
            this.addressAddition = _data["addressAddition"];
            this.postOfficeBox = _data["postOfficeBox"];
        }
    }

    static fromJS(data: any): OndAddressCountryPoBoxDto {
        data = typeof data === 'object' ? data : {};
        let result = new OndAddressCountryPoBoxDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["countryId"] = this.countryId;
        data["addressAddition"] = this.addressAddition;
        data["postOfficeBox"] = this.postOfficeBox;
        return data;
    }
}

export interface IOndAddressCountryPoBoxDto {
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    countryId: string | undefined;
    addressAddition: string | undefined;
    postOfficeBox: string | undefined;
}

export class OndAddressTelWebDto implements IOndAddressTelWebDto {
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    countryId!: string | undefined;
    addressAddition!: string | undefined;
    postOfficeBox!: string | undefined;
    email!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    website!: string | undefined;

    constructor(data?: IOndAddressTelWebDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.countryId = _data["countryId"];
            this.addressAddition = _data["addressAddition"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.email = _data["email"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.website = _data["website"];
        }
    }

    static fromJS(data: any): OndAddressTelWebDto {
        data = typeof data === 'object' ? data : {};
        let result = new OndAddressTelWebDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["countryId"] = this.countryId;
        data["addressAddition"] = this.addressAddition;
        data["postOfficeBox"] = this.postOfficeBox;
        data["email"] = this.email;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["website"] = this.website;
        return data;
    }
}

export interface IOndAddressTelWebDto {
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    countryId: string | undefined;
    addressAddition: string | undefined;
    postOfficeBox: string | undefined;
    email: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    website: string | undefined;
}

export class OndBusinessDto implements IOndBusinessDto {
    businessName!: string | undefined;
    additionalName!: string | undefined;
    bur!: string | undefined;
    gln!: string | undefined;
    address!: OndAddressTelWebDto;
    dateOfOpening!: DateTime | undefined;
    dateOfClosure!: DateTime | undefined;
    businessHours!: string | undefined;

    constructor(data?: IOndBusinessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.businessName = _data["businessName"];
            this.additionalName = _data["additionalName"];
            this.bur = _data["bur"];
            this.gln = _data["gln"];
            this.address = _data["address"] ? OndAddressTelWebDto.fromJS(_data["address"]) : <any>undefined;
            this.dateOfOpening = _data["dateOfOpening"] ? DateTime.fromISO(_data["dateOfOpening"].toString()) : <any>undefined;
            this.dateOfClosure = _data["dateOfClosure"] ? DateTime.fromISO(_data["dateOfClosure"].toString()) : <any>undefined;
            this.businessHours = _data["businessHours"];
        }
    }

    static fromJS(data: any): OndBusinessDto {
        data = typeof data === 'object' ? data : {};
        let result = new OndBusinessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["businessName"] = this.businessName;
        data["additionalName"] = this.additionalName;
        data["bur"] = this.bur;
        data["gln"] = this.gln;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["dateOfOpening"] = this.dateOfOpening ? this.dateOfOpening.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfClosure"] = this.dateOfClosure ? this.dateOfClosure.toFormat('yyyy-MM-dd') : <any>undefined;
        data["businessHours"] = this.businessHours;
        return data;
    }
}

export interface IOndBusinessDto {
    businessName: string | undefined;
    additionalName: string | undefined;
    bur: string | undefined;
    gln: string | undefined;
    address: OndAddressTelWebDto;
    dateOfOpening: DateTime | undefined;
    dateOfClosure: DateTime | undefined;
    businessHours: string | undefined;
}

export class OndPersonWithContactInfoDto implements IOndPersonWithContactInfoDto {
    lastName!: string | undefined;
    firstName!: string | undefined;
    gln!: string | undefined;
    address!: OndAddressTelWebDto;

    constructor(data?: IOndPersonWithContactInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.gln = _data["gln"];
            this.address = _data["address"] ? OndAddressTelWebDto.fromJS(_data["address"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OndPersonWithContactInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new OndPersonWithContactInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["gln"] = this.gln;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOndPersonWithContactInfoDto {
    lastName: string | undefined;
    firstName: string | undefined;
    gln: string | undefined;
    address: OndAddressTelWebDto;
}

export class OndSponsorshipDto implements IOndSponsorshipDto {
    businessName!: string | undefined;
    additionalName!: string | undefined;
    uid!: string | undefined;
    legalFormId!: string | undefined;
    gln!: string | undefined;
    address!: OndAddressTelWebDto;
    invoiceEmail!: string | undefined;
    hasLicenceInAnotherCantonId!: string | undefined;

    constructor(data?: IOndSponsorshipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.businessName = _data["businessName"];
            this.additionalName = _data["additionalName"];
            this.uid = _data["uid"];
            this.legalFormId = _data["legalFormId"];
            this.gln = _data["gln"];
            this.address = _data["address"] ? OndAddressTelWebDto.fromJS(_data["address"]) : <any>undefined;
            this.invoiceEmail = _data["invoiceEmail"];
            this.hasLicenceInAnotherCantonId = _data["hasLicenceInAnotherCantonId"];
        }
    }

    static fromJS(data: any): OndSponsorshipDto {
        data = typeof data === 'object' ? data : {};
        let result = new OndSponsorshipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["businessName"] = this.businessName;
        data["additionalName"] = this.additionalName;
        data["uid"] = this.uid;
        data["legalFormId"] = this.legalFormId;
        data["gln"] = this.gln;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["invoiceEmail"] = this.invoiceEmail;
        data["hasLicenceInAnotherCantonId"] = this.hasLicenceInAnotherCantonId;
        return data;
    }
}

export interface IOndSponsorshipDto {
    businessName: string | undefined;
    additionalName: string | undefined;
    uid: string | undefined;
    legalFormId: string | undefined;
    gln: string | undefined;
    address: OndAddressTelWebDto;
    invoiceEmail: string | undefined;
    hasLicenceInAnotherCantonId: string | undefined;
}

export class CreateEditionDto implements ICreateEditionDto {
    edition!: EditionCreateDto;
    featureValues!: NameValueDto[];

    constructor(data?: ICreateEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.edition = new EditionCreateDto();
            this.featureValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionCreateDto.fromJS(_data["edition"]) : new EditionCreateDto();
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateEditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateEditionDto {
    edition: EditionCreateDto;
    featureValues: NameValueDto[];
}

export class EditionCreateDto implements IEditionCreateDto {
    id!: number | undefined;
    displayName!: string;
    dailyPrice!: number | undefined;
    weeklyPrice!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    trialDayCount!: number | undefined;
    waitingDayAfterExpire!: number | undefined;
    expiringEditionId!: number | undefined;

    constructor(data?: IEditionCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.dailyPrice = _data["dailyPrice"];
            this.weeklyPrice = _data["weeklyPrice"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.annualPrice = _data["annualPrice"];
            this.trialDayCount = _data["trialDayCount"];
            this.waitingDayAfterExpire = _data["waitingDayAfterExpire"];
            this.expiringEditionId = _data["expiringEditionId"];
        }
    }

    static fromJS(data: any): EditionCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["dailyPrice"] = this.dailyPrice;
        data["weeklyPrice"] = this.weeklyPrice;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["trialDayCount"] = this.trialDayCount;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["expiringEditionId"] = this.expiringEditionId;
        return data;
    }
}

export interface IEditionCreateDto {
    id: number | undefined;
    displayName: string;
    dailyPrice: number | undefined;
    weeklyPrice: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    trialDayCount: number | undefined;
    waitingDayAfterExpire: number | undefined;
    expiringEditionId: number | undefined;
}

export class EditionEditDto implements IEditionEditDto {
    id!: number | undefined;
    displayName!: string;
    expiringEditionId!: number | undefined;

    constructor(data?: IEditionEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.expiringEditionId = _data["expiringEditionId"];
        }
    }

    static fromJS(data: any): EditionEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["expiringEditionId"] = this.expiringEditionId;
        return data;
    }
}

export interface IEditionEditDto {
    id: number | undefined;
    displayName: string;
    expiringEditionId: number | undefined;
}

export class EditionListDto implements IEditionListDto {
    name!: string | undefined;
    displayName!: string | undefined;
    dailyPrice!: number | undefined;
    weeklyPrice!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    waitingDayAfterExpire!: number | undefined;
    trialDayCount!: number | undefined;
    expiringEditionDisplayName!: string | undefined;
    id!: number;

    constructor(data?: IEditionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.dailyPrice = _data["dailyPrice"];
            this.weeklyPrice = _data["weeklyPrice"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.annualPrice = _data["annualPrice"];
            this.waitingDayAfterExpire = _data["waitingDayAfterExpire"];
            this.trialDayCount = _data["trialDayCount"];
            this.expiringEditionDisplayName = _data["expiringEditionDisplayName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EditionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["dailyPrice"] = this.dailyPrice;
        data["weeklyPrice"] = this.weeklyPrice;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["trialDayCount"] = this.trialDayCount;
        data["expiringEditionDisplayName"] = this.expiringEditionDisplayName;
        data["id"] = this.id;
        return data;
    }
}

export interface IEditionListDto {
    name: string | undefined;
    displayName: string | undefined;
    dailyPrice: number | undefined;
    weeklyPrice: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    waitingDayAfterExpire: number | undefined;
    trialDayCount: number | undefined;
    expiringEditionDisplayName: string | undefined;
    id: number;
}

export class EditionSelectDto implements IEditionSelectDto {
    id!: number;
    name!: string | undefined;
    displayName!: string | undefined;
    expiringEditionId!: number | undefined;
    dailyPrice!: number | undefined;
    weeklyPrice!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    trialDayCount!: number | undefined;
    waitingDayAfterExpire!: number | undefined;
    isFree!: boolean;

    constructor(data?: IEditionSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.expiringEditionId = _data["expiringEditionId"];
            this.dailyPrice = _data["dailyPrice"];
            this.weeklyPrice = _data["weeklyPrice"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.annualPrice = _data["annualPrice"];
            this.trialDayCount = _data["trialDayCount"];
            this.waitingDayAfterExpire = _data["waitingDayAfterExpire"];
            this.isFree = _data["isFree"];
        }
    }

    static fromJS(data: any): EditionSelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["expiringEditionId"] = this.expiringEditionId;
        data["dailyPrice"] = this.dailyPrice;
        data["weeklyPrice"] = this.weeklyPrice;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["trialDayCount"] = this.trialDayCount;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["isFree"] = this.isFree;
        return data;
    }
}

export interface IEditionSelectDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    expiringEditionId: number | undefined;
    dailyPrice: number | undefined;
    weeklyPrice: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    trialDayCount: number | undefined;
    waitingDayAfterExpire: number | undefined;
    isFree: boolean;
}

export class EditionWithFeaturesDto implements IEditionWithFeaturesDto {
    edition!: EditionSelectDto;
    featureValues!: NameValueDto[] | undefined;

    constructor(data?: IEditionWithFeaturesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionSelectDto.fromJS(_data["edition"]) : <any>undefined;
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditionWithFeaturesDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionWithFeaturesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEditionWithFeaturesDto {
    edition: EditionSelectDto;
    featureValues: NameValueDto[] | undefined;
}

export class FeatureInputTypeDto implements IFeatureInputTypeDto {
    name!: string | undefined;
    attributes!: { [key: string]: any; } | undefined;
    validator!: IValueValidator;
    itemSource!: LocalizableComboboxItemSourceDto;

    constructor(data?: IFeatureInputTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (_data["attributes"]) {
                this.attributes = {} as any;
                for (let key in _data["attributes"]) {
                    if (_data["attributes"].hasOwnProperty(key))
                        (<any>this.attributes)![key] = _data["attributes"][key];
                }
            }
            this.validator = _data["validator"] ? IValueValidator.fromJS(_data["validator"]) : <any>undefined;
            this.itemSource = _data["itemSource"] ? LocalizableComboboxItemSourceDto.fromJS(_data["itemSource"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FeatureInputTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureInputTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    (<any>data["attributes"])[key] = (<any>this.attributes)[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : <any>undefined;
        data["itemSource"] = this.itemSource ? this.itemSource.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFeatureInputTypeDto {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
    validator: IValueValidator;
    itemSource: LocalizableComboboxItemSourceDto;
}

export class FlatFeatureDto implements IFlatFeatureDto {
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    defaultValue!: string | undefined;
    inputType!: FeatureInputTypeDto;

    constructor(data?: IFlatFeatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.defaultValue = _data["defaultValue"];
            this.inputType = _data["inputType"] ? FeatureInputTypeDto.fromJS(_data["inputType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FlatFeatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatFeatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFlatFeatureDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    defaultValue: string | undefined;
    inputType: FeatureInputTypeDto;
}

export class FlatFeatureSelectDto implements IFlatFeatureSelectDto {
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    defaultValue!: string | undefined;
    inputType!: IInputType;
    textHtmlColor!: string | undefined;

    constructor(data?: IFlatFeatureSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.defaultValue = _data["defaultValue"];
            this.inputType = _data["inputType"] ? IInputType.fromJS(_data["inputType"]) : <any>undefined;
            this.textHtmlColor = _data["textHtmlColor"];
        }
    }

    static fromJS(data: any): FlatFeatureSelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatFeatureSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : <any>undefined;
        data["textHtmlColor"] = this.textHtmlColor;
        return data;
    }
}

export interface IFlatFeatureSelectDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    defaultValue: string | undefined;
    inputType: IInputType;
    textHtmlColor: string | undefined;
}

export class GetEditionEditOutput implements IGetEditionEditOutput {
    edition!: EditionEditDto;
    featureValues!: NameValueDto[] | undefined;
    features!: FlatFeatureDto[] | undefined;

    constructor(data?: IGetEditionEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionEditDto.fromJS(_data["edition"]) : <any>undefined;
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(FlatFeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEditionEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEditionEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetEditionEditOutput {
    edition: EditionEditDto;
    featureValues: NameValueDto[] | undefined;
    features: FlatFeatureDto[] | undefined;
}

export class LocalizableComboboxItemDto implements ILocalizableComboboxItemDto {
    value!: string | undefined;
    displayText!: string | undefined;

    constructor(data?: ILocalizableComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.displayText = _data["displayText"];
        }
    }

    static fromJS(data: any): LocalizableComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizableComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        return data;
    }
}

export interface ILocalizableComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
}

export class LocalizableComboboxItemSourceDto implements ILocalizableComboboxItemSourceDto {
    items!: LocalizableComboboxItemDto[] | undefined;

    constructor(data?: ILocalizableComboboxItemSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LocalizableComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LocalizableComboboxItemSourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizableComboboxItemSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILocalizableComboboxItemSourceDto {
    items: LocalizableComboboxItemDto[] | undefined;
}

export class MoveTenantsToAnotherEditionDto implements IMoveTenantsToAnotherEditionDto {
    sourceEditionId!: number;
    targetEditionId!: number;

    constructor(data?: IMoveTenantsToAnotherEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceEditionId = _data["sourceEditionId"];
            this.targetEditionId = _data["targetEditionId"];
        }
    }

    static fromJS(data: any): MoveTenantsToAnotherEditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MoveTenantsToAnotherEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceEditionId"] = this.sourceEditionId;
        data["targetEditionId"] = this.targetEditionId;
        return data;
    }
}

export interface IMoveTenantsToAnotherEditionDto {
    sourceEditionId: number;
    targetEditionId: number;
}

export class SubscribableEditionComboboxItemDto implements ISubscribableEditionComboboxItemDto {
    isFree!: boolean | undefined;
    value!: string | undefined;
    displayText!: string | undefined;
    isSelected!: boolean;

    constructor(data?: ISubscribableEditionComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isFree = _data["isFree"];
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): SubscribableEditionComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscribableEditionComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFree"] = this.isFree;
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface ISubscribableEditionComboboxItemDto {
    isFree: boolean | undefined;
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean;
}

export class UpdateEditionDto implements IUpdateEditionDto {
    edition!: EditionEditDto;
    featureValues!: NameValueDto[];

    constructor(data?: IUpdateEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.edition = new EditionEditDto();
            this.featureValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionEditDto.fromJS(_data["edition"]) : new EditionEditDto();
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateEditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateEditionDto {
    edition: EditionEditDto;
    featureValues: NameValueDto[];
}

export class CreateEhcCapWaitListEntryDto implements ICreateEhcCapWaitListEntryDto {
    firstName!: string | undefined;
    lastName!: string | undefined;
    personId!: number | undefined;
    dateOfApplication!: DateTime | undefined;
    titles!: CreateEhcCapWaitListTitleDto[] | undefined;

    constructor(data?: ICreateEhcCapWaitListEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.personId = _data["personId"];
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(CreateEhcCapWaitListTitleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateEhcCapWaitListEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEhcCapWaitListEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["personId"] = this.personId;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateEhcCapWaitListEntryDto {
    firstName: string | undefined;
    lastName: string | undefined;
    personId: number | undefined;
    dateOfApplication: DateTime | undefined;
    titles: CreateEhcCapWaitListTitleDto[] | undefined;
}

export class CreateEhcCapWaitListEntryFromApplicationDto implements ICreateEhcCapWaitListEntryFromApplicationDto {
    caseId!: string | undefined;

    constructor(data?: ICreateEhcCapWaitListEntryFromApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
        }
    }

    static fromJS(data: any): CreateEhcCapWaitListEntryFromApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEhcCapWaitListEntryFromApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        return data;
    }
}

export interface ICreateEhcCapWaitListEntryFromApplicationDto {
    caseId: string | undefined;
}

export class CreateEhcCapWaitListTitleDto implements ICreateEhcCapWaitListTitleDto {
    postgraduateTitleId!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    districtId!: string | undefined;
    levelOfEmployment!: number | undefined;

    constructor(data?: ICreateEhcCapWaitListTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.districtId = _data["districtId"];
            this.levelOfEmployment = _data["levelOfEmployment"];
        }
    }

    static fromJS(data: any): CreateEhcCapWaitListTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEhcCapWaitListTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["districtId"] = this.districtId;
        data["levelOfEmployment"] = this.levelOfEmployment;
        return data;
    }
}

export interface ICreateEhcCapWaitListTitleDto {
    postgraduateTitleId: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    districtId: string | undefined;
    levelOfEmployment: number | undefined;
}

export class CreateOrUpdateEhcCapDto implements ICreateOrUpdateEhcCapDto {
    postgraduateTitleId!: string | undefined;
    maxFullTimeEquivalentCanton!: number | undefined;
    ehcCapDistricts!: EhcCapDistrictDto[] | undefined;

    constructor(data?: ICreateOrUpdateEhcCapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.maxFullTimeEquivalentCanton = _data["maxFullTimeEquivalentCanton"];
            if (Array.isArray(_data["ehcCapDistricts"])) {
                this.ehcCapDistricts = [] as any;
                for (let item of _data["ehcCapDistricts"])
                    this.ehcCapDistricts!.push(EhcCapDistrictDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateEhcCapDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEhcCapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["maxFullTimeEquivalentCanton"] = this.maxFullTimeEquivalentCanton;
        if (Array.isArray(this.ehcCapDistricts)) {
            data["ehcCapDistricts"] = [];
            for (let item of this.ehcCapDistricts)
                data["ehcCapDistricts"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateEhcCapDto {
    postgraduateTitleId: string | undefined;
    maxFullTimeEquivalentCanton: number | undefined;
    ehcCapDistricts: EhcCapDistrictDto[] | undefined;
}

export class DistrictDto implements IDistrictDto {
    districtCodeId!: string | undefined;
    plz!: DistrictPlzDto[] | undefined;

    constructor(data?: IDistrictDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.districtCodeId = _data["districtCodeId"];
            if (Array.isArray(_data["plz"])) {
                this.plz = [] as any;
                for (let item of _data["plz"])
                    this.plz!.push(DistrictPlzDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DistrictDto {
        data = typeof data === 'object' ? data : {};
        let result = new DistrictDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["districtCodeId"] = this.districtCodeId;
        if (Array.isArray(this.plz)) {
            data["plz"] = [];
            for (let item of this.plz)
                data["plz"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDistrictDto {
    districtCodeId: string | undefined;
    plz: DistrictPlzDto[] | undefined;
}

export class DistrictPlzDto implements IDistrictPlzDto {
    plz!: number;

    constructor(data?: IDistrictPlzDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plz = _data["plz"];
        }
    }

    static fromJS(data: any): DistrictPlzDto {
        data = typeof data === 'object' ? data : {};
        let result = new DistrictPlzDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plz"] = this.plz;
        return data;
    }
}

export interface IDistrictPlzDto {
    plz: number;
}

export class EhcCapDistrictDto implements IEhcCapDistrictDto {
    districtId!: string | undefined;
    maxFullTimeEquivalent!: number;

    constructor(data?: IEhcCapDistrictDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.districtId = _data["districtId"];
            this.maxFullTimeEquivalent = _data["maxFullTimeEquivalent"];
        }
    }

    static fromJS(data: any): EhcCapDistrictDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcCapDistrictDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["districtId"] = this.districtId;
        data["maxFullTimeEquivalent"] = this.maxFullTimeEquivalent;
        return data;
    }
}

export interface IEhcCapDistrictDto {
    districtId: string | undefined;
    maxFullTimeEquivalent: number;
}

export class EhcCapDto implements IEhcCapDto {
    postgraduateTitleId!: string | undefined;
    maxFullTimeEquivalentCanton!: number | undefined;
    ehcCapDistricts!: EhcCapDistrictDto[] | undefined;
    id!: number;

    constructor(data?: IEhcCapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.maxFullTimeEquivalentCanton = _data["maxFullTimeEquivalentCanton"];
            if (Array.isArray(_data["ehcCapDistricts"])) {
                this.ehcCapDistricts = [] as any;
                for (let item of _data["ehcCapDistricts"])
                    this.ehcCapDistricts!.push(EhcCapDistrictDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EhcCapDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcCapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["maxFullTimeEquivalentCanton"] = this.maxFullTimeEquivalentCanton;
        if (Array.isArray(this.ehcCapDistricts)) {
            data["ehcCapDistricts"] = [];
            for (let item of this.ehcCapDistricts)
                data["ehcCapDistricts"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IEhcCapDto {
    postgraduateTitleId: string | undefined;
    maxFullTimeEquivalentCanton: number | undefined;
    ehcCapDistricts: EhcCapDistrictDto[] | undefined;
    id: number;
}

export class EhcCapWaitListEntryDto implements IEhcCapWaitListEntryDto {
    firstName!: string | undefined;
    lastName!: string | undefined;
    caseId!: string | undefined;
    personId!: number | undefined;
    dateOfApplication!: DateTime | undefined;
    titles!: EhcCapWaitListTitleDto[] | undefined;
    id!: number;

    constructor(data?: IEhcCapWaitListEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.caseId = _data["caseId"];
            this.personId = _data["personId"];
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(EhcCapWaitListTitleDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EhcCapWaitListEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcCapWaitListEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["caseId"] = this.caseId;
        data["personId"] = this.personId;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IEhcCapWaitListEntryDto {
    firstName: string | undefined;
    lastName: string | undefined;
    caseId: string | undefined;
    personId: number | undefined;
    dateOfApplication: DateTime | undefined;
    titles: EhcCapWaitListTitleDto[] | undefined;
    id: number;
}

export class EhcCapWaitListTitleDto implements IEhcCapWaitListTitleDto {
    postgraduateTitleId!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    districtId!: string | undefined;
    levelOfEmployment!: number | undefined;
    id!: number;

    constructor(data?: IEhcCapWaitListTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.districtId = _data["districtId"];
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EhcCapWaitListTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcCapWaitListTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["districtId"] = this.districtId;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["id"] = this.id;
        return data;
    }
}

export interface IEhcCapWaitListTitleDto {
    postgraduateTitleId: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    districtId: string | undefined;
    levelOfEmployment: number | undefined;
    id: number;
}

export class GetDistrictPlzSearchOutput implements IGetDistrictPlzSearchOutput {
    totalCount!: number;
    items!: DistrictPlzDto[] | undefined;

    constructor(data?: IGetDistrictPlzSearchOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DistrictPlzDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDistrictPlzSearchOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDistrictPlzSearchOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDistrictPlzSearchOutput {
    totalCount: number;
    items: DistrictPlzDto[] | undefined;
}

export class GetEhcCapSearchInput implements IGetEhcCapSearchInput {
    postgraduateTitleId!: string | undefined;
    districtId!: string | undefined;
    filter!: string | undefined;
    sorting!: string | undefined;
    maxResultCount!: number;
    skipCount!: number;

    constructor(data?: IGetEhcCapSearchInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.districtId = _data["districtId"];
            this.filter = _data["filter"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): GetEhcCapSearchInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEhcCapSearchInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["districtId"] = this.districtId;
        data["filter"] = this.filter;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }
}

export interface IGetEhcCapSearchInput {
    postgraduateTitleId: string | undefined;
    districtId: string | undefined;
    filter: string | undefined;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
}

export class GetEhcCapSearchOutput implements IGetEhcCapSearchOutput {
    totalCount!: number;
    items!: EhcCapDto[] | undefined;

    constructor(data?: IGetEhcCapSearchOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EhcCapDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEhcCapSearchOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEhcCapSearchOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetEhcCapSearchOutput {
    totalCount: number;
    items: EhcCapDto[] | undefined;
}

export class GetEhcCapWaitListSearchInput implements IGetEhcCapWaitListSearchInput {
    nameFilter!: string | undefined;
    titleFilter!: string | undefined;
    filter!: string | undefined;
    sorting!: string | undefined;
    maxResultCount!: number;
    skipCount!: number;

    constructor(data?: IGetEhcCapWaitListSearchInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nameFilter = _data["nameFilter"];
            this.titleFilter = _data["titleFilter"];
            this.filter = _data["filter"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): GetEhcCapWaitListSearchInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEhcCapWaitListSearchInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nameFilter"] = this.nameFilter;
        data["titleFilter"] = this.titleFilter;
        data["filter"] = this.filter;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }
}

export interface IGetEhcCapWaitListSearchInput {
    nameFilter: string | undefined;
    titleFilter: string | undefined;
    filter: string | undefined;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
}

export class GetEhcCapWaitListSearchOutput implements IGetEhcCapWaitListSearchOutput {
    totalCount!: number;
    items!: EhcCapWaitListEntryDto[] | undefined;

    constructor(data?: IGetEhcCapWaitListSearchOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EhcCapWaitListEntryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEhcCapWaitListSearchOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEhcCapWaitListSearchOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetEhcCapWaitListSearchOutput {
    totalCount: number;
    items: EhcCapWaitListEntryDto[] | undefined;
}

export class GetOneOrMoreTitleStoppedDto implements IGetOneOrMoreTitleStoppedDto {
    postgraduateTitleId!: string | undefined;
    postCode!: number | undefined;

    constructor(data?: IGetOneOrMoreTitleStoppedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.postCode = _data["postCode"];
        }
    }

    static fromJS(data: any): GetOneOrMoreTitleStoppedDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOneOrMoreTitleStoppedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["postCode"] = this.postCode;
        return data;
    }
}

export interface IGetOneOrMoreTitleStoppedDto {
    postgraduateTitleId: string | undefined;
    postCode: number | undefined;
}

export class GetOneOrMoreTitleStoppedInputDto implements IGetOneOrMoreTitleStoppedInputDto {
    titles!: GetOneOrMoreTitleStoppedDto[] | undefined;

    constructor(data?: IGetOneOrMoreTitleStoppedInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(GetOneOrMoreTitleStoppedDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetOneOrMoreTitleStoppedInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOneOrMoreTitleStoppedInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetOneOrMoreTitleStoppedInputDto {
    titles: GetOneOrMoreTitleStoppedDto[] | undefined;
}

export class ImportEhcCapExcelFileDto implements IImportEhcCapExcelFileDto {
    filename!: string;
    file!: string;

    constructor(data?: IImportEhcCapExcelFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filename = _data["filename"];
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): ImportEhcCapExcelFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImportEhcCapExcelFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filename"] = this.filename;
        data["file"] = this.file;
        return data;
    }
}

export interface IImportEhcCapExcelFileDto {
    filename: string;
    file: string;
}

export class CreateEmploymentDto implements ICreateEmploymentDto {
    personId!: number | undefined;
    sponsorshipId!: number | undefined;
    businessId!: number | undefined;
    corporateLicenceId!: number | undefined;
    personLicenceId!: number | undefined;
    statusId!: string | undefined;
    locationTypeId!: string | undefined;
    roleId!: string | undefined;
    roleText!: string | undefined;
    dateOfEmployment!: DateTime | undefined;
    dateOfEndOfEmployment!: DateTime | undefined;
    levelOfEmployment!: number | undefined;
    narcExtentId!: string | undefined;
    narcExtentRemark!: string | undefined;
    remark!: string | undefined;
    selfEmploymentId!: string | undefined;
    isMobileEmployment!: boolean;
    healthRegisterTransfer!: boolean;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    employmentFieldId!: string | undefined;

    constructor(data?: ICreateEmploymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.sponsorshipId = _data["sponsorshipId"];
            this.businessId = _data["businessId"];
            this.corporateLicenceId = _data["corporateLicenceId"];
            this.personLicenceId = _data["personLicenceId"];
            this.statusId = _data["statusId"];
            this.locationTypeId = _data["locationTypeId"];
            this.roleId = _data["roleId"];
            this.roleText = _data["roleText"];
            this.dateOfEmployment = _data["dateOfEmployment"] ? DateTime.fromISO(_data["dateOfEmployment"].toString()) : <any>undefined;
            this.dateOfEndOfEmployment = _data["dateOfEndOfEmployment"] ? DateTime.fromISO(_data["dateOfEndOfEmployment"].toString()) : <any>undefined;
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.narcExtentId = _data["narcExtentId"];
            this.narcExtentRemark = _data["narcExtentRemark"];
            this.remark = _data["remark"];
            this.selfEmploymentId = _data["selfEmploymentId"];
            this.isMobileEmployment = _data["isMobileEmployment"];
            this.healthRegisterTransfer = _data["healthRegisterTransfer"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.employmentFieldId = _data["employmentFieldId"];
        }
    }

    static fromJS(data: any): CreateEmploymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmploymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["sponsorshipId"] = this.sponsorshipId;
        data["businessId"] = this.businessId;
        data["corporateLicenceId"] = this.corporateLicenceId;
        data["personLicenceId"] = this.personLicenceId;
        data["statusId"] = this.statusId;
        data["locationTypeId"] = this.locationTypeId;
        data["roleId"] = this.roleId;
        data["roleText"] = this.roleText;
        data["dateOfEmployment"] = this.dateOfEmployment ? this.dateOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEndOfEmployment"] = this.dateOfEndOfEmployment ? this.dateOfEndOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["narcExtentId"] = this.narcExtentId;
        data["narcExtentRemark"] = this.narcExtentRemark;
        data["remark"] = this.remark;
        data["selfEmploymentId"] = this.selfEmploymentId;
        data["isMobileEmployment"] = this.isMobileEmployment;
        data["healthRegisterTransfer"] = this.healthRegisterTransfer;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["employmentFieldId"] = this.employmentFieldId;
        return data;
    }
}

export interface ICreateEmploymentDto {
    personId: number | undefined;
    sponsorshipId: number | undefined;
    businessId: number | undefined;
    corporateLicenceId: number | undefined;
    personLicenceId: number | undefined;
    statusId: string | undefined;
    locationTypeId: string | undefined;
    roleId: string | undefined;
    roleText: string | undefined;
    dateOfEmployment: DateTime | undefined;
    dateOfEndOfEmployment: DateTime | undefined;
    levelOfEmployment: number | undefined;
    narcExtentId: string | undefined;
    narcExtentRemark: string | undefined;
    remark: string | undefined;
    selfEmploymentId: string | undefined;
    isMobileEmployment: boolean;
    healthRegisterTransfer: boolean;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    employmentFieldId: string | undefined;
}

export class EmploymentDto implements IEmploymentDto {
    id!: number;
    sponsorship!: GetSponsorshipDto;
    business!: GetBusinessDto;
    personId!: number | undefined;
    liaEmploymentBRecord!: LiaEmploymentBRecordDto;
    liaEmploymentBRecordId!: string | undefined;
    employmentAddress!: EmploymentAddressDto;
    employmentAddressId!: number | undefined;
    applicationEmploymentPerson!: ApplicationEmploymentPersonDto;
    applicationEmploymentPersonId!: number | undefined;
    sponsorshipId!: number | undefined;
    businessId!: number | undefined;
    corporateLicenceId!: number | undefined;
    personLicenceId!: number | undefined;
    statusId!: string | undefined;
    locationTypeId!: string | undefined;
    roleId!: string | undefined;
    roleText!: string | undefined;
    dateOfEmployment!: DateTime | undefined;
    dateOfEndOfEmployment!: DateTime | undefined;
    levelOfEmployment!: number | undefined;
    narcExtentId!: string | undefined;
    narcExtentRemark!: string | undefined;
    remark!: string | undefined;
    selfEmploymentId!: string | undefined;
    isMobileEmployment!: boolean;
    healthRegisterTransfer!: boolean;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    employmentFieldId!: string | undefined;

    constructor(data?: IEmploymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sponsorship = _data["sponsorship"] ? GetSponsorshipDto.fromJS(_data["sponsorship"]) : <any>undefined;
            this.business = _data["business"] ? GetBusinessDto.fromJS(_data["business"]) : <any>undefined;
            this.personId = _data["personId"];
            this.liaEmploymentBRecord = _data["liaEmploymentBRecord"] ? LiaEmploymentBRecordDto.fromJS(_data["liaEmploymentBRecord"]) : <any>undefined;
            this.liaEmploymentBRecordId = _data["liaEmploymentBRecordId"];
            this.employmentAddress = _data["employmentAddress"] ? EmploymentAddressDto.fromJS(_data["employmentAddress"]) : <any>undefined;
            this.employmentAddressId = _data["employmentAddressId"];
            this.applicationEmploymentPerson = _data["applicationEmploymentPerson"] ? ApplicationEmploymentPersonDto.fromJS(_data["applicationEmploymentPerson"]) : <any>undefined;
            this.applicationEmploymentPersonId = _data["applicationEmploymentPersonId"];
            this.sponsorshipId = _data["sponsorshipId"];
            this.businessId = _data["businessId"];
            this.corporateLicenceId = _data["corporateLicenceId"];
            this.personLicenceId = _data["personLicenceId"];
            this.statusId = _data["statusId"];
            this.locationTypeId = _data["locationTypeId"];
            this.roleId = _data["roleId"];
            this.roleText = _data["roleText"];
            this.dateOfEmployment = _data["dateOfEmployment"] ? DateTime.fromISO(_data["dateOfEmployment"].toString()) : <any>undefined;
            this.dateOfEndOfEmployment = _data["dateOfEndOfEmployment"] ? DateTime.fromISO(_data["dateOfEndOfEmployment"].toString()) : <any>undefined;
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.narcExtentId = _data["narcExtentId"];
            this.narcExtentRemark = _data["narcExtentRemark"];
            this.remark = _data["remark"];
            this.selfEmploymentId = _data["selfEmploymentId"];
            this.isMobileEmployment = _data["isMobileEmployment"];
            this.healthRegisterTransfer = _data["healthRegisterTransfer"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.employmentFieldId = _data["employmentFieldId"];
        }
    }

    static fromJS(data: any): EmploymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmploymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sponsorship"] = this.sponsorship ? this.sponsorship.toJSON() : <any>undefined;
        data["business"] = this.business ? this.business.toJSON() : <any>undefined;
        data["personId"] = this.personId;
        data["liaEmploymentBRecord"] = this.liaEmploymentBRecord ? this.liaEmploymentBRecord.toJSON() : <any>undefined;
        data["liaEmploymentBRecordId"] = this.liaEmploymentBRecordId;
        data["employmentAddress"] = this.employmentAddress ? this.employmentAddress.toJSON() : <any>undefined;
        data["employmentAddressId"] = this.employmentAddressId;
        data["applicationEmploymentPerson"] = this.applicationEmploymentPerson ? this.applicationEmploymentPerson.toJSON() : <any>undefined;
        data["applicationEmploymentPersonId"] = this.applicationEmploymentPersonId;
        data["sponsorshipId"] = this.sponsorshipId;
        data["businessId"] = this.businessId;
        data["corporateLicenceId"] = this.corporateLicenceId;
        data["personLicenceId"] = this.personLicenceId;
        data["statusId"] = this.statusId;
        data["locationTypeId"] = this.locationTypeId;
        data["roleId"] = this.roleId;
        data["roleText"] = this.roleText;
        data["dateOfEmployment"] = this.dateOfEmployment ? this.dateOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEndOfEmployment"] = this.dateOfEndOfEmployment ? this.dateOfEndOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["narcExtentId"] = this.narcExtentId;
        data["narcExtentRemark"] = this.narcExtentRemark;
        data["remark"] = this.remark;
        data["selfEmploymentId"] = this.selfEmploymentId;
        data["isMobileEmployment"] = this.isMobileEmployment;
        data["healthRegisterTransfer"] = this.healthRegisterTransfer;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["employmentFieldId"] = this.employmentFieldId;
        return data;
    }
}

export interface IEmploymentDto {
    id: number;
    sponsorship: GetSponsorshipDto;
    business: GetBusinessDto;
    personId: number | undefined;
    liaEmploymentBRecord: LiaEmploymentBRecordDto;
    liaEmploymentBRecordId: string | undefined;
    employmentAddress: EmploymentAddressDto;
    employmentAddressId: number | undefined;
    applicationEmploymentPerson: ApplicationEmploymentPersonDto;
    applicationEmploymentPersonId: number | undefined;
    sponsorshipId: number | undefined;
    businessId: number | undefined;
    corporateLicenceId: number | undefined;
    personLicenceId: number | undefined;
    statusId: string | undefined;
    locationTypeId: string | undefined;
    roleId: string | undefined;
    roleText: string | undefined;
    dateOfEmployment: DateTime | undefined;
    dateOfEndOfEmployment: DateTime | undefined;
    levelOfEmployment: number | undefined;
    narcExtentId: string | undefined;
    narcExtentRemark: string | undefined;
    remark: string | undefined;
    selfEmploymentId: string | undefined;
    isMobileEmployment: boolean;
    healthRegisterTransfer: boolean;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    employmentFieldId: string | undefined;
}

export class EmploymentSearchOutputDto implements IEmploymentSearchOutputDto {
    totalCount!: number;
    items!: EmploymentSearchResultDto[] | undefined;

    constructor(data?: IEmploymentSearchOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EmploymentSearchResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmploymentSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmploymentSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEmploymentSearchOutputDto {
    totalCount: number;
    items: EmploymentSearchResultDto[] | undefined;
}

export class EmploymentSearchResultDto implements IEmploymentSearchResultDto {
    personId!: number | undefined;
    businessId!: number | undefined;
    sponsorshipId!: number | undefined;
    personLicenceType!: PersonLicenceType;
    personLicenceId!: number | undefined;
    corporateLicenceId!: number | undefined;
    corporateLicenceTypeId!: CorporateLicenceType;
    corporateLicenceSponsorshipTypeId!: string | undefined;
    corporateLicenceStatusId!: string | undefined;
    corporateLicenceName!: string | undefined;
    statusId!: string | undefined;
    isMobileEmployment!: boolean;
    sponsorshipName!: string | undefined;
    businessName!: string | undefined;
    personName!: string | undefined;
    roleId!: string | undefined;
    dateOfEmployment!: DateTime | undefined;
    dateOfEndOfEmployment!: DateTime | undefined;
    levelOfEmployment!: number | undefined;
    isSameBusinessSponsorshipAddress!: boolean;
    id!: number;

    constructor(data?: IEmploymentSearchResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.businessId = _data["businessId"];
            this.sponsorshipId = _data["sponsorshipId"];
            this.personLicenceType = _data["personLicenceType"];
            this.personLicenceId = _data["personLicenceId"];
            this.corporateLicenceId = _data["corporateLicenceId"];
            this.corporateLicenceTypeId = _data["corporateLicenceTypeId"];
            this.corporateLicenceSponsorshipTypeId = _data["corporateLicenceSponsorshipTypeId"];
            this.corporateLicenceStatusId = _data["corporateLicenceStatusId"];
            this.corporateLicenceName = _data["corporateLicenceName"];
            this.statusId = _data["statusId"];
            this.isMobileEmployment = _data["isMobileEmployment"];
            this.sponsorshipName = _data["sponsorshipName"];
            this.businessName = _data["businessName"];
            this.personName = _data["personName"];
            this.roleId = _data["roleId"];
            this.dateOfEmployment = _data["dateOfEmployment"] ? DateTime.fromISO(_data["dateOfEmployment"].toString()) : <any>undefined;
            this.dateOfEndOfEmployment = _data["dateOfEndOfEmployment"] ? DateTime.fromISO(_data["dateOfEndOfEmployment"].toString()) : <any>undefined;
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.isSameBusinessSponsorshipAddress = _data["isSameBusinessSponsorshipAddress"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EmploymentSearchResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmploymentSearchResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["businessId"] = this.businessId;
        data["sponsorshipId"] = this.sponsorshipId;
        data["personLicenceType"] = this.personLicenceType;
        data["personLicenceId"] = this.personLicenceId;
        data["corporateLicenceId"] = this.corporateLicenceId;
        data["corporateLicenceTypeId"] = this.corporateLicenceTypeId;
        data["corporateLicenceSponsorshipTypeId"] = this.corporateLicenceSponsorshipTypeId;
        data["corporateLicenceStatusId"] = this.corporateLicenceStatusId;
        data["corporateLicenceName"] = this.corporateLicenceName;
        data["statusId"] = this.statusId;
        data["isMobileEmployment"] = this.isMobileEmployment;
        data["sponsorshipName"] = this.sponsorshipName;
        data["businessName"] = this.businessName;
        data["personName"] = this.personName;
        data["roleId"] = this.roleId;
        data["dateOfEmployment"] = this.dateOfEmployment ? this.dateOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEndOfEmployment"] = this.dateOfEndOfEmployment ? this.dateOfEndOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["isSameBusinessSponsorshipAddress"] = this.isSameBusinessSponsorshipAddress;
        data["id"] = this.id;
        return data;
    }
}

export interface IEmploymentSearchResultDto {
    personId: number | undefined;
    businessId: number | undefined;
    sponsorshipId: number | undefined;
    personLicenceType: PersonLicenceType;
    personLicenceId: number | undefined;
    corporateLicenceId: number | undefined;
    corporateLicenceTypeId: CorporateLicenceType;
    corporateLicenceSponsorshipTypeId: string | undefined;
    corporateLicenceStatusId: string | undefined;
    corporateLicenceName: string | undefined;
    statusId: string | undefined;
    isMobileEmployment: boolean;
    sponsorshipName: string | undefined;
    businessName: string | undefined;
    personName: string | undefined;
    roleId: string | undefined;
    dateOfEmployment: DateTime | undefined;
    dateOfEndOfEmployment: DateTime | undefined;
    levelOfEmployment: number | undefined;
    isSameBusinessSponsorshipAddress: boolean;
    id: number;
}

export class GetActiveMedicalFieldDirectorThatWillBeReplacedForLicenceInput implements IGetActiveMedicalFieldDirectorThatWillBeReplacedForLicenceInput {
    medicalFieldDirectorId!: number | undefined;
    medicalDirectorId!: number | undefined;
    nursingDirectorId!: number | undefined;
    corporateLicenceId!: number;

    constructor(data?: IGetActiveMedicalFieldDirectorThatWillBeReplacedForLicenceInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medicalFieldDirectorId = _data["medicalFieldDirectorId"];
            this.medicalDirectorId = _data["medicalDirectorId"];
            this.nursingDirectorId = _data["nursingDirectorId"];
            this.corporateLicenceId = _data["corporateLicenceId"];
        }
    }

    static fromJS(data: any): GetActiveMedicalFieldDirectorThatWillBeReplacedForLicenceInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetActiveMedicalFieldDirectorThatWillBeReplacedForLicenceInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicalFieldDirectorId"] = this.medicalFieldDirectorId;
        data["medicalDirectorId"] = this.medicalDirectorId;
        data["nursingDirectorId"] = this.nursingDirectorId;
        data["corporateLicenceId"] = this.corporateLicenceId;
        return data;
    }
}

export interface IGetActiveMedicalFieldDirectorThatWillBeReplacedForLicenceInput {
    medicalFieldDirectorId: number | undefined;
    medicalDirectorId: number | undefined;
    nursingDirectorId: number | undefined;
    corporateLicenceId: number;
}

export class GetActiveMedicalFieldDirectorThatWillBeReplacedInput implements IGetActiveMedicalFieldDirectorThatWillBeReplacedInput {
    id!: number;
    corporateLicenceId!: number;
    employmentFieldId!: string | undefined;
    dateOfEmployment!: DateTime | undefined;
    dateOfEndOfEmployment!: DateTime | undefined;

    constructor(data?: IGetActiveMedicalFieldDirectorThatWillBeReplacedInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.corporateLicenceId = _data["corporateLicenceId"];
            this.employmentFieldId = _data["employmentFieldId"];
            this.dateOfEmployment = _data["dateOfEmployment"] ? DateTime.fromISO(_data["dateOfEmployment"].toString()) : <any>undefined;
            this.dateOfEndOfEmployment = _data["dateOfEndOfEmployment"] ? DateTime.fromISO(_data["dateOfEndOfEmployment"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetActiveMedicalFieldDirectorThatWillBeReplacedInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetActiveMedicalFieldDirectorThatWillBeReplacedInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["corporateLicenceId"] = this.corporateLicenceId;
        data["employmentFieldId"] = this.employmentFieldId;
        data["dateOfEmployment"] = this.dateOfEmployment ? this.dateOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEndOfEmployment"] = this.dateOfEndOfEmployment ? this.dateOfEndOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        return data;
    }
}

export interface IGetActiveMedicalFieldDirectorThatWillBeReplacedInput {
    id: number;
    corporateLicenceId: number;
    employmentFieldId: string | undefined;
    dateOfEmployment: DateTime | undefined;
    dateOfEndOfEmployment: DateTime | undefined;
}

export class GetEmploymentDto implements IGetEmploymentDto {
    id!: number;
    sponsorship!: GetSponsorshipDto;
    business!: GetBusinessDto;
    corporateLicence!: GetCorporateLicenceDto;
    person!: EmploymentPersonDto;
    personId!: number | undefined;
    personLicence!: GetPersonLicenceDto;
    liaEmploymentBRecord!: LiaEmploymentBRecordDto;
    liaEmploymentBRecordId!: string | undefined;
    employmentAddress!: EmploymentAddressDto;
    employmentAddressId!: number | undefined;
    applicationEmploymentPerson!: ApplicationEmploymentPersonDto;
    applicationEmploymentPersonId!: number | undefined;
    healthRegisterSubmission!: DateTime | undefined;
    sponsorshipId!: number | undefined;
    businessId!: number | undefined;
    corporateLicenceId!: number | undefined;
    personLicenceId!: number | undefined;
    statusId!: string | undefined;
    locationTypeId!: string | undefined;
    roleId!: string | undefined;
    roleText!: string | undefined;
    dateOfEmployment!: DateTime | undefined;
    dateOfEndOfEmployment!: DateTime | undefined;
    levelOfEmployment!: number | undefined;
    narcExtentId!: string | undefined;
    narcExtentRemark!: string | undefined;
    remark!: string | undefined;
    selfEmploymentId!: string | undefined;
    isMobileEmployment!: boolean;
    healthRegisterTransfer!: boolean;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    employmentFieldId!: string | undefined;

    constructor(data?: IGetEmploymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sponsorship = _data["sponsorship"] ? GetSponsorshipDto.fromJS(_data["sponsorship"]) : <any>undefined;
            this.business = _data["business"] ? GetBusinessDto.fromJS(_data["business"]) : <any>undefined;
            this.corporateLicence = _data["corporateLicence"] ? GetCorporateLicenceDto.fromJS(_data["corporateLicence"]) : <any>undefined;
            this.person = _data["person"] ? EmploymentPersonDto.fromJS(_data["person"]) : <any>undefined;
            this.personId = _data["personId"];
            this.personLicence = _data["personLicence"] ? GetPersonLicenceDto.fromJS(_data["personLicence"]) : <any>undefined;
            this.liaEmploymentBRecord = _data["liaEmploymentBRecord"] ? LiaEmploymentBRecordDto.fromJS(_data["liaEmploymentBRecord"]) : <any>undefined;
            this.liaEmploymentBRecordId = _data["liaEmploymentBRecordId"];
            this.employmentAddress = _data["employmentAddress"] ? EmploymentAddressDto.fromJS(_data["employmentAddress"]) : <any>undefined;
            this.employmentAddressId = _data["employmentAddressId"];
            this.applicationEmploymentPerson = _data["applicationEmploymentPerson"] ? ApplicationEmploymentPersonDto.fromJS(_data["applicationEmploymentPerson"]) : <any>undefined;
            this.applicationEmploymentPersonId = _data["applicationEmploymentPersonId"];
            this.healthRegisterSubmission = _data["healthRegisterSubmission"] ? DateTime.fromISO(_data["healthRegisterSubmission"].toString()) : <any>undefined;
            this.sponsorshipId = _data["sponsorshipId"];
            this.businessId = _data["businessId"];
            this.corporateLicenceId = _data["corporateLicenceId"];
            this.personLicenceId = _data["personLicenceId"];
            this.statusId = _data["statusId"];
            this.locationTypeId = _data["locationTypeId"];
            this.roleId = _data["roleId"];
            this.roleText = _data["roleText"];
            this.dateOfEmployment = _data["dateOfEmployment"] ? DateTime.fromISO(_data["dateOfEmployment"].toString()) : <any>undefined;
            this.dateOfEndOfEmployment = _data["dateOfEndOfEmployment"] ? DateTime.fromISO(_data["dateOfEndOfEmployment"].toString()) : <any>undefined;
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.narcExtentId = _data["narcExtentId"];
            this.narcExtentRemark = _data["narcExtentRemark"];
            this.remark = _data["remark"];
            this.selfEmploymentId = _data["selfEmploymentId"];
            this.isMobileEmployment = _data["isMobileEmployment"];
            this.healthRegisterTransfer = _data["healthRegisterTransfer"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.employmentFieldId = _data["employmentFieldId"];
        }
    }

    static fromJS(data: any): GetEmploymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmploymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sponsorship"] = this.sponsorship ? this.sponsorship.toJSON() : <any>undefined;
        data["business"] = this.business ? this.business.toJSON() : <any>undefined;
        data["corporateLicence"] = this.corporateLicence ? this.corporateLicence.toJSON() : <any>undefined;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["personId"] = this.personId;
        data["personLicence"] = this.personLicence ? this.personLicence.toJSON() : <any>undefined;
        data["liaEmploymentBRecord"] = this.liaEmploymentBRecord ? this.liaEmploymentBRecord.toJSON() : <any>undefined;
        data["liaEmploymentBRecordId"] = this.liaEmploymentBRecordId;
        data["employmentAddress"] = this.employmentAddress ? this.employmentAddress.toJSON() : <any>undefined;
        data["employmentAddressId"] = this.employmentAddressId;
        data["applicationEmploymentPerson"] = this.applicationEmploymentPerson ? this.applicationEmploymentPerson.toJSON() : <any>undefined;
        data["applicationEmploymentPersonId"] = this.applicationEmploymentPersonId;
        data["healthRegisterSubmission"] = this.healthRegisterSubmission ? this.healthRegisterSubmission.toString() : <any>undefined;
        data["sponsorshipId"] = this.sponsorshipId;
        data["businessId"] = this.businessId;
        data["corporateLicenceId"] = this.corporateLicenceId;
        data["personLicenceId"] = this.personLicenceId;
        data["statusId"] = this.statusId;
        data["locationTypeId"] = this.locationTypeId;
        data["roleId"] = this.roleId;
        data["roleText"] = this.roleText;
        data["dateOfEmployment"] = this.dateOfEmployment ? this.dateOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEndOfEmployment"] = this.dateOfEndOfEmployment ? this.dateOfEndOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["narcExtentId"] = this.narcExtentId;
        data["narcExtentRemark"] = this.narcExtentRemark;
        data["remark"] = this.remark;
        data["selfEmploymentId"] = this.selfEmploymentId;
        data["isMobileEmployment"] = this.isMobileEmployment;
        data["healthRegisterTransfer"] = this.healthRegisterTransfer;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["employmentFieldId"] = this.employmentFieldId;
        return data;
    }
}

export interface IGetEmploymentDto {
    id: number;
    sponsorship: GetSponsorshipDto;
    business: GetBusinessDto;
    corporateLicence: GetCorporateLicenceDto;
    person: EmploymentPersonDto;
    personId: number | undefined;
    personLicence: GetPersonLicenceDto;
    liaEmploymentBRecord: LiaEmploymentBRecordDto;
    liaEmploymentBRecordId: string | undefined;
    employmentAddress: EmploymentAddressDto;
    employmentAddressId: number | undefined;
    applicationEmploymentPerson: ApplicationEmploymentPersonDto;
    applicationEmploymentPersonId: number | undefined;
    healthRegisterSubmission: DateTime | undefined;
    sponsorshipId: number | undefined;
    businessId: number | undefined;
    corporateLicenceId: number | undefined;
    personLicenceId: number | undefined;
    statusId: string | undefined;
    locationTypeId: string | undefined;
    roleId: string | undefined;
    roleText: string | undefined;
    dateOfEmployment: DateTime | undefined;
    dateOfEndOfEmployment: DateTime | undefined;
    levelOfEmployment: number | undefined;
    narcExtentId: string | undefined;
    narcExtentRemark: string | undefined;
    remark: string | undefined;
    selfEmploymentId: string | undefined;
    isMobileEmployment: boolean;
    healthRegisterTransfer: boolean;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    employmentFieldId: string | undefined;
}

export class UpdateEmploymentDto implements IUpdateEmploymentDto {
    sponsorshipId!: number | undefined;
    businessId!: number | undefined;
    corporateLicenceId!: number | undefined;
    personLicenceId!: number | undefined;
    statusId!: string | undefined;
    locationTypeId!: string | undefined;
    roleId!: string | undefined;
    roleText!: string | undefined;
    dateOfEmployment!: DateTime | undefined;
    dateOfEndOfEmployment!: DateTime | undefined;
    levelOfEmployment!: number | undefined;
    narcExtentId!: string | undefined;
    narcExtentRemark!: string | undefined;
    remark!: string | undefined;
    selfEmploymentId!: string | undefined;
    isMobileEmployment!: boolean;
    healthRegisterTransfer!: boolean;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    employmentFieldId!: string | undefined;

    constructor(data?: IUpdateEmploymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sponsorshipId = _data["sponsorshipId"];
            this.businessId = _data["businessId"];
            this.corporateLicenceId = _data["corporateLicenceId"];
            this.personLicenceId = _data["personLicenceId"];
            this.statusId = _data["statusId"];
            this.locationTypeId = _data["locationTypeId"];
            this.roleId = _data["roleId"];
            this.roleText = _data["roleText"];
            this.dateOfEmployment = _data["dateOfEmployment"] ? DateTime.fromISO(_data["dateOfEmployment"].toString()) : <any>undefined;
            this.dateOfEndOfEmployment = _data["dateOfEndOfEmployment"] ? DateTime.fromISO(_data["dateOfEndOfEmployment"].toString()) : <any>undefined;
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.narcExtentId = _data["narcExtentId"];
            this.narcExtentRemark = _data["narcExtentRemark"];
            this.remark = _data["remark"];
            this.selfEmploymentId = _data["selfEmploymentId"];
            this.isMobileEmployment = _data["isMobileEmployment"];
            this.healthRegisterTransfer = _data["healthRegisterTransfer"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.employmentFieldId = _data["employmentFieldId"];
        }
    }

    static fromJS(data: any): UpdateEmploymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEmploymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sponsorshipId"] = this.sponsorshipId;
        data["businessId"] = this.businessId;
        data["corporateLicenceId"] = this.corporateLicenceId;
        data["personLicenceId"] = this.personLicenceId;
        data["statusId"] = this.statusId;
        data["locationTypeId"] = this.locationTypeId;
        data["roleId"] = this.roleId;
        data["roleText"] = this.roleText;
        data["dateOfEmployment"] = this.dateOfEmployment ? this.dateOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEndOfEmployment"] = this.dateOfEndOfEmployment ? this.dateOfEndOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["narcExtentId"] = this.narcExtentId;
        data["narcExtentRemark"] = this.narcExtentRemark;
        data["remark"] = this.remark;
        data["selfEmploymentId"] = this.selfEmploymentId;
        data["isMobileEmployment"] = this.isMobileEmployment;
        data["healthRegisterTransfer"] = this.healthRegisterTransfer;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["employmentFieldId"] = this.employmentFieldId;
        return data;
    }
}

export interface IUpdateEmploymentDto {
    sponsorshipId: number | undefined;
    businessId: number | undefined;
    corporateLicenceId: number | undefined;
    personLicenceId: number | undefined;
    statusId: string | undefined;
    locationTypeId: string | undefined;
    roleId: string | undefined;
    roleText: string | undefined;
    dateOfEmployment: DateTime | undefined;
    dateOfEndOfEmployment: DateTime | undefined;
    levelOfEmployment: number | undefined;
    narcExtentId: string | undefined;
    narcExtentRemark: string | undefined;
    remark: string | undefined;
    selfEmploymentId: string | undefined;
    isMobileEmployment: boolean;
    healthRegisterTransfer: boolean;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    employmentFieldId: string | undefined;
}

export class UpdateEmploymentAddressInput implements IUpdateEmploymentAddressInput {
    employmentAddress!: EmploymentAddressDto;

    constructor(data?: IUpdateEmploymentAddressInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employmentAddress = _data["employmentAddress"] ? EmploymentAddressDto.fromJS(_data["employmentAddress"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateEmploymentAddressInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEmploymentAddressInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employmentAddress"] = this.employmentAddress ? this.employmentAddress.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateEmploymentAddressInput {
    employmentAddress: EmploymentAddressDto;
}

export class CreateOrUpdateEhcContactInput implements ICreateOrUpdateEhcContactInput {
    caseId!: string;
    ehcContact!: EhcContactDto;

    constructor(data?: ICreateOrUpdateEhcContactInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ehcContact = new EhcContactDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.ehcContact = _data["ehcContact"] ? EhcContactDto.fromJS(_data["ehcContact"]) : new EhcContactDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateEhcContactInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEhcContactInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["ehcContact"] = this.ehcContact ? this.ehcContact.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateEhcContactInput {
    caseId: string;
    ehcContact: EhcContactDto;
}

export class EhcContactDto implements IEhcContactDto {
    titleId!: string | undefined;
    street!: string;
    streetNr!: string | undefined;
    postCode!: string;
    city!: string;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    email!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    countryId!: string | undefined;
    titleAddressSwiss!: string | undefined;
    streetSwiss!: string | undefined;
    streetNrSwiss!: string | undefined;
    postCodeSwiss!: string | undefined;
    citySwiss!: string | undefined;
    postOfficeBoxSwiss!: string | undefined;
    addressSupplementSwiss!: string | undefined;

    constructor(data?: IEhcContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.email = _data["email"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.countryId = _data["countryId"];
            this.titleAddressSwiss = _data["titleAddressSwiss"];
            this.streetSwiss = _data["streetSwiss"];
            this.streetNrSwiss = _data["streetNrSwiss"];
            this.postCodeSwiss = _data["postCodeSwiss"];
            this.citySwiss = _data["citySwiss"];
            this.postOfficeBoxSwiss = _data["postOfficeBoxSwiss"];
            this.addressSupplementSwiss = _data["addressSupplementSwiss"];
        }
    }

    static fromJS(data: any): EhcContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["email"] = this.email;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["countryId"] = this.countryId;
        data["titleAddressSwiss"] = this.titleAddressSwiss;
        data["streetSwiss"] = this.streetSwiss;
        data["streetNrSwiss"] = this.streetNrSwiss;
        data["postCodeSwiss"] = this.postCodeSwiss;
        data["citySwiss"] = this.citySwiss;
        data["postOfficeBoxSwiss"] = this.postOfficeBoxSwiss;
        data["addressSupplementSwiss"] = this.addressSupplementSwiss;
        return data;
    }
}

export interface IEhcContactDto {
    titleId: string | undefined;
    street: string;
    streetNr: string | undefined;
    postCode: string;
    city: string;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    email: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    countryId: string | undefined;
    titleAddressSwiss: string | undefined;
    streetSwiss: string | undefined;
    streetNrSwiss: string | undefined;
    postCodeSwiss: string | undefined;
    citySwiss: string | undefined;
    postOfficeBoxSwiss: string | undefined;
    addressSupplementSwiss: string | undefined;
}

export class EhcDocumentsOutput implements IEhcDocumentsOutput {
    caseId!: string;
    ehcDocuments!: GeneralDocumentGroupDto[];

    constructor(data?: IEhcDocumentsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ehcDocuments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["ehcDocuments"])) {
                this.ehcDocuments = [] as any;
                for (let item of _data["ehcDocuments"])
                    this.ehcDocuments!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EhcDocumentsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new EhcDocumentsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.ehcDocuments)) {
            data["ehcDocuments"] = [];
            for (let item of this.ehcDocuments)
                data["ehcDocuments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEhcDocumentsOutput {
    caseId: string;
    ehcDocuments: GeneralDocumentGroupDto[];
}

export class EhcDto implements IEhcDto {
    application!: ApplicationDto;
    professionId!: string | undefined;
    personLicenceId!: number | undefined;
    liaApplicationId!: number | undefined;
    liaCaseId!: string | undefined;
    currentStep!: EhcStatus;
    ehcSelfEmployment!: EhcSelfEmploymentDto;
    ehcMedicalField!: EhcMedicalFieldDto;
    ehcLanguageSkill!: EhcLanguageSkillDto;
    ehcPractice!: EhcPracticeDto;
    ehcPostgraduateTitles!: EhcPostgraduateTitleDto[] | undefined;
    ehcElectronicPatientRecord!: EhcElectronicPatientRecordDto;
    ehcQualityMeasurement!: EhcQualityMeasurementDto;
    ehcStaff!: EhcStaffDto;
    ehcQualitySupportSystem!: EhcQualitySupportSystemDto;
    ehcPerson!: EhcPersonDto;
    ehcContact!: EhcContactDto;
    ehcEmployments!: EhcEmploymentOutput;
    ehcInvoiceAddress!: EhcInvoiceAddressDto;
    ehcDocuments!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: IEhcDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationDto.fromJS(_data["application"]) : <any>undefined;
            this.professionId = _data["professionId"];
            this.personLicenceId = _data["personLicenceId"];
            this.liaApplicationId = _data["liaApplicationId"];
            this.liaCaseId = _data["liaCaseId"];
            this.currentStep = _data["currentStep"];
            this.ehcSelfEmployment = _data["ehcSelfEmployment"] ? EhcSelfEmploymentDto.fromJS(_data["ehcSelfEmployment"]) : <any>undefined;
            this.ehcMedicalField = _data["ehcMedicalField"] ? EhcMedicalFieldDto.fromJS(_data["ehcMedicalField"]) : <any>undefined;
            this.ehcLanguageSkill = _data["ehcLanguageSkill"] ? EhcLanguageSkillDto.fromJS(_data["ehcLanguageSkill"]) : <any>undefined;
            this.ehcPractice = _data["ehcPractice"] ? EhcPracticeDto.fromJS(_data["ehcPractice"]) : <any>undefined;
            if (Array.isArray(_data["ehcPostgraduateTitles"])) {
                this.ehcPostgraduateTitles = [] as any;
                for (let item of _data["ehcPostgraduateTitles"])
                    this.ehcPostgraduateTitles!.push(EhcPostgraduateTitleDto.fromJS(item));
            }
            this.ehcElectronicPatientRecord = _data["ehcElectronicPatientRecord"] ? EhcElectronicPatientRecordDto.fromJS(_data["ehcElectronicPatientRecord"]) : <any>undefined;
            this.ehcQualityMeasurement = _data["ehcQualityMeasurement"] ? EhcQualityMeasurementDto.fromJS(_data["ehcQualityMeasurement"]) : <any>undefined;
            this.ehcStaff = _data["ehcStaff"] ? EhcStaffDto.fromJS(_data["ehcStaff"]) : <any>undefined;
            this.ehcQualitySupportSystem = _data["ehcQualitySupportSystem"] ? EhcQualitySupportSystemDto.fromJS(_data["ehcQualitySupportSystem"]) : <any>undefined;
            this.ehcPerson = _data["ehcPerson"] ? EhcPersonDto.fromJS(_data["ehcPerson"]) : <any>undefined;
            this.ehcContact = _data["ehcContact"] ? EhcContactDto.fromJS(_data["ehcContact"]) : <any>undefined;
            this.ehcEmployments = _data["ehcEmployments"] ? EhcEmploymentOutput.fromJS(_data["ehcEmployments"]) : <any>undefined;
            this.ehcInvoiceAddress = _data["ehcInvoiceAddress"] ? EhcInvoiceAddressDto.fromJS(_data["ehcInvoiceAddress"]) : <any>undefined;
            if (Array.isArray(_data["ehcDocuments"])) {
                this.ehcDocuments = [] as any;
                for (let item of _data["ehcDocuments"])
                    this.ehcDocuments!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EhcDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["professionId"] = this.professionId;
        data["personLicenceId"] = this.personLicenceId;
        data["liaApplicationId"] = this.liaApplicationId;
        data["liaCaseId"] = this.liaCaseId;
        data["currentStep"] = this.currentStep;
        data["ehcSelfEmployment"] = this.ehcSelfEmployment ? this.ehcSelfEmployment.toJSON() : <any>undefined;
        data["ehcMedicalField"] = this.ehcMedicalField ? this.ehcMedicalField.toJSON() : <any>undefined;
        data["ehcLanguageSkill"] = this.ehcLanguageSkill ? this.ehcLanguageSkill.toJSON() : <any>undefined;
        data["ehcPractice"] = this.ehcPractice ? this.ehcPractice.toJSON() : <any>undefined;
        if (Array.isArray(this.ehcPostgraduateTitles)) {
            data["ehcPostgraduateTitles"] = [];
            for (let item of this.ehcPostgraduateTitles)
                data["ehcPostgraduateTitles"].push(item.toJSON());
        }
        data["ehcElectronicPatientRecord"] = this.ehcElectronicPatientRecord ? this.ehcElectronicPatientRecord.toJSON() : <any>undefined;
        data["ehcQualityMeasurement"] = this.ehcQualityMeasurement ? this.ehcQualityMeasurement.toJSON() : <any>undefined;
        data["ehcStaff"] = this.ehcStaff ? this.ehcStaff.toJSON() : <any>undefined;
        data["ehcQualitySupportSystem"] = this.ehcQualitySupportSystem ? this.ehcQualitySupportSystem.toJSON() : <any>undefined;
        data["ehcPerson"] = this.ehcPerson ? this.ehcPerson.toJSON() : <any>undefined;
        data["ehcContact"] = this.ehcContact ? this.ehcContact.toJSON() : <any>undefined;
        data["ehcEmployments"] = this.ehcEmployments ? this.ehcEmployments.toJSON() : <any>undefined;
        data["ehcInvoiceAddress"] = this.ehcInvoiceAddress ? this.ehcInvoiceAddress.toJSON() : <any>undefined;
        if (Array.isArray(this.ehcDocuments)) {
            data["ehcDocuments"] = [];
            for (let item of this.ehcDocuments)
                data["ehcDocuments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEhcDto {
    application: ApplicationDto;
    professionId: string | undefined;
    personLicenceId: number | undefined;
    liaApplicationId: number | undefined;
    liaCaseId: string | undefined;
    currentStep: EhcStatus;
    ehcSelfEmployment: EhcSelfEmploymentDto;
    ehcMedicalField: EhcMedicalFieldDto;
    ehcLanguageSkill: EhcLanguageSkillDto;
    ehcPractice: EhcPracticeDto;
    ehcPostgraduateTitles: EhcPostgraduateTitleDto[] | undefined;
    ehcElectronicPatientRecord: EhcElectronicPatientRecordDto;
    ehcQualityMeasurement: EhcQualityMeasurementDto;
    ehcStaff: EhcStaffDto;
    ehcQualitySupportSystem: EhcQualitySupportSystemDto;
    ehcPerson: EhcPersonDto;
    ehcContact: EhcContactDto;
    ehcEmployments: EhcEmploymentOutput;
    ehcInvoiceAddress: EhcInvoiceAddressDto;
    ehcDocuments: GeneralDocumentGroupDto[] | undefined;
}

export class EhcSearchDto implements IEhcSearchDto {
    id!: number;
    caseId!: string | undefined;
    caseIdSearchable!: string | undefined;
    fullName!: string | undefined;
    userFullName!: string | undefined;
    userEmail!: string | undefined;
    professionId!: string | undefined;
    status!: ApplicationStatus;
    dateOfStatusChange!: DateTime;
    responsibleId!: number | undefined;
    responsibleFullName!: string | undefined;
    iAmResponsible!: boolean;

    constructor(data?: IEhcSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.caseId = _data["caseId"];
            this.caseIdSearchable = _data["caseIdSearchable"];
            this.fullName = _data["fullName"];
            this.userFullName = _data["userFullName"];
            this.userEmail = _data["userEmail"];
            this.professionId = _data["professionId"];
            this.status = _data["status"];
            this.dateOfStatusChange = _data["dateOfStatusChange"] ? DateTime.fromISO(_data["dateOfStatusChange"].toString()) : <any>undefined;
            this.responsibleId = _data["responsibleId"];
            this.responsibleFullName = _data["responsibleFullName"];
            this.iAmResponsible = _data["iAmResponsible"];
        }
    }

    static fromJS(data: any): EhcSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["caseId"] = this.caseId;
        data["caseIdSearchable"] = this.caseIdSearchable;
        data["fullName"] = this.fullName;
        data["userFullName"] = this.userFullName;
        data["userEmail"] = this.userEmail;
        data["professionId"] = this.professionId;
        data["status"] = this.status;
        data["dateOfStatusChange"] = this.dateOfStatusChange ? this.dateOfStatusChange.toFormat('yyyy-MM-dd') : <any>undefined;
        data["responsibleId"] = this.responsibleId;
        data["responsibleFullName"] = this.responsibleFullName;
        data["iAmResponsible"] = this.iAmResponsible;
        return data;
    }
}

export interface IEhcSearchDto {
    id: number;
    caseId: string | undefined;
    caseIdSearchable: string | undefined;
    fullName: string | undefined;
    userFullName: string | undefined;
    userEmail: string | undefined;
    professionId: string | undefined;
    status: ApplicationStatus;
    dateOfStatusChange: DateTime;
    responsibleId: number | undefined;
    responsibleFullName: string | undefined;
    iAmResponsible: boolean;
}

export enum EhcStatus {
    SelfEmployment = 0,
    Register = 1,
    MedicalField = 2,
    LanguageSkill = 3,
    Practice = 4,
    ElectronicPatientRecord = 5,
    QualityMeasurement = 6,
    Contact = 7,
    Employment = 8,
    InvoiceAddress = 9,
    Release = 10,
    Released = 11,
    FinishReview = 12,
    Person = 13,
    Staff = 14,
    QualitySupportSystem = 15,
    PostgraduateTitle = 16,
}

export class CreateOrUpdateEhcElectronicPatientRecordInput implements ICreateOrUpdateEhcElectronicPatientRecordInput {
    caseId!: string;
    ehcElectronicPatientRecord!: EhcElectronicPatientRecordDto;

    constructor(data?: ICreateOrUpdateEhcElectronicPatientRecordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ehcElectronicPatientRecord = new EhcElectronicPatientRecordDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.ehcElectronicPatientRecord = _data["ehcElectronicPatientRecord"] ? EhcElectronicPatientRecordDto.fromJS(_data["ehcElectronicPatientRecord"]) : new EhcElectronicPatientRecordDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateEhcElectronicPatientRecordInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEhcElectronicPatientRecordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["ehcElectronicPatientRecord"] = this.ehcElectronicPatientRecord ? this.ehcElectronicPatientRecord.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateEhcElectronicPatientRecordInput {
    caseId: string;
    ehcElectronicPatientRecord: EhcElectronicPatientRecordDto;
}

export class EhcElectronicPatientRecordDto implements IEhcElectronicPatientRecordDto {
    hasMembershipInCertifiedCommunityId!: string;
    membershipInCertifiedCommunityDetails!: string | undefined;
    noMembershipInCertifiedCommunityDetails!: string | undefined;
    dateOfMembershipPlannedId!: DateTime | undefined;

    constructor(data?: IEhcElectronicPatientRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasMembershipInCertifiedCommunityId = _data["hasMembershipInCertifiedCommunityId"];
            this.membershipInCertifiedCommunityDetails = _data["membershipInCertifiedCommunityDetails"];
            this.noMembershipInCertifiedCommunityDetails = _data["noMembershipInCertifiedCommunityDetails"];
            this.dateOfMembershipPlannedId = _data["dateOfMembershipPlannedId"] ? DateTime.fromISO(_data["dateOfMembershipPlannedId"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EhcElectronicPatientRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcElectronicPatientRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasMembershipInCertifiedCommunityId"] = this.hasMembershipInCertifiedCommunityId;
        data["membershipInCertifiedCommunityDetails"] = this.membershipInCertifiedCommunityDetails;
        data["noMembershipInCertifiedCommunityDetails"] = this.noMembershipInCertifiedCommunityDetails;
        data["dateOfMembershipPlannedId"] = this.dateOfMembershipPlannedId ? this.dateOfMembershipPlannedId.toString() : <any>undefined;
        return data;
    }
}

export interface IEhcElectronicPatientRecordDto {
    hasMembershipInCertifiedCommunityId: string;
    membershipInCertifiedCommunityDetails: string | undefined;
    noMembershipInCertifiedCommunityDetails: string | undefined;
    dateOfMembershipPlannedId: DateTime | undefined;
}

export class CreateOrUpdateEhcEmploymentsInput implements ICreateOrUpdateEhcEmploymentsInput {
    caseId!: string;
    employments!: EhcEmploymentsDto[] | undefined;
    mobileEmployment!: EhcMobileEmploymentBDto;

    constructor(data?: ICreateOrUpdateEhcEmploymentsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(EhcEmploymentsDto.fromJS(item));
            }
            this.mobileEmployment = _data["mobileEmployment"] ? EhcMobileEmploymentBDto.fromJS(_data["mobileEmployment"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrUpdateEhcEmploymentsInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEhcEmploymentsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item.toJSON());
        }
        data["mobileEmployment"] = this.mobileEmployment ? this.mobileEmployment.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateEhcEmploymentsInput {
    caseId: string;
    employments: EhcEmploymentsDto[] | undefined;
    mobileEmployment: EhcMobileEmploymentBDto;
}

export class CreateOrUpdateEhcEmploymentsOutput implements ICreateOrUpdateEhcEmploymentsOutput {
    status!: EhcStatus;
    ehcEmployments!: EhcEmploymentDto[] | undefined;

    constructor(data?: ICreateOrUpdateEhcEmploymentsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["ehcEmployments"])) {
                this.ehcEmployments = [] as any;
                for (let item of _data["ehcEmployments"])
                    this.ehcEmployments!.push(EhcEmploymentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateEhcEmploymentsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEhcEmploymentsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.ehcEmployments)) {
            data["ehcEmployments"] = [];
            for (let item of this.ehcEmployments)
                data["ehcEmployments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateEhcEmploymentsOutput {
    status: EhcStatus;
    ehcEmployments: EhcEmploymentDto[] | undefined;
}

export class EhcEmploymentDto implements IEhcEmploymentDto {
    id!: number | undefined;
    ehcApplicationId!: number | undefined;
    ehcPostgraduateTitleId!: number | undefined;
    startDateNotKnown!: boolean;
    startOfEmployment!: DateTime | undefined;
    endOfEmployment!: DateTime | undefined;
    levelOfEmployment!: number;
    isMobile!: boolean;
    businessName!: string | undefined;
    additionalName!: string | undefined;
    legalFormId!: string | undefined;
    street!: string;
    streetNr!: string | undefined;
    postCode!: string;
    city!: string;
    postOfficeBox!: string | undefined;
    addressSupplement!: string | undefined;
    phone!: string;
    phone2!: string | undefined;
    email!: string | undefined;
    website!: string | undefined;
    medicalPracticeTakeoverDetails!: string | undefined;
    medicalGroupPracticeDetails!: string | undefined;
    isMedicalFieldDirectorId!: string | undefined;

    constructor(data?: IEhcEmploymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ehcApplicationId = _data["ehcApplicationId"];
            this.ehcPostgraduateTitleId = _data["ehcPostgraduateTitleId"];
            this.startDateNotKnown = _data["startDateNotKnown"];
            this.startOfEmployment = _data["startOfEmployment"] ? DateTime.fromISO(_data["startOfEmployment"].toString()) : <any>undefined;
            this.endOfEmployment = _data["endOfEmployment"] ? DateTime.fromISO(_data["endOfEmployment"].toString()) : <any>undefined;
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.isMobile = _data["isMobile"];
            this.businessName = _data["businessName"];
            this.additionalName = _data["additionalName"];
            this.legalFormId = _data["legalFormId"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressSupplement = _data["addressSupplement"];
            this.phone = _data["phone"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.website = _data["website"];
            this.medicalPracticeTakeoverDetails = _data["medicalPracticeTakeoverDetails"];
            this.medicalGroupPracticeDetails = _data["medicalGroupPracticeDetails"];
            this.isMedicalFieldDirectorId = _data["isMedicalFieldDirectorId"];
        }
    }

    static fromJS(data: any): EhcEmploymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcEmploymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ehcApplicationId"] = this.ehcApplicationId;
        data["ehcPostgraduateTitleId"] = this.ehcPostgraduateTitleId;
        data["startDateNotKnown"] = this.startDateNotKnown;
        data["startOfEmployment"] = this.startOfEmployment ? this.startOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["endOfEmployment"] = this.endOfEmployment ? this.endOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["isMobile"] = this.isMobile;
        data["businessName"] = this.businessName;
        data["additionalName"] = this.additionalName;
        data["legalFormId"] = this.legalFormId;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressSupplement"] = this.addressSupplement;
        data["phone"] = this.phone;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["website"] = this.website;
        data["medicalPracticeTakeoverDetails"] = this.medicalPracticeTakeoverDetails;
        data["medicalGroupPracticeDetails"] = this.medicalGroupPracticeDetails;
        data["isMedicalFieldDirectorId"] = this.isMedicalFieldDirectorId;
        return data;
    }
}

export interface IEhcEmploymentDto {
    id: number | undefined;
    ehcApplicationId: number | undefined;
    ehcPostgraduateTitleId: number | undefined;
    startDateNotKnown: boolean;
    startOfEmployment: DateTime | undefined;
    endOfEmployment: DateTime | undefined;
    levelOfEmployment: number;
    isMobile: boolean;
    businessName: string | undefined;
    additionalName: string | undefined;
    legalFormId: string | undefined;
    street: string;
    streetNr: string | undefined;
    postCode: string;
    city: string;
    postOfficeBox: string | undefined;
    addressSupplement: string | undefined;
    phone: string;
    phone2: string | undefined;
    email: string | undefined;
    website: string | undefined;
    medicalPracticeTakeoverDetails: string | undefined;
    medicalGroupPracticeDetails: string | undefined;
    isMedicalFieldDirectorId: string | undefined;
}

export class EhcEmploymentOutput implements IEhcEmploymentOutput {
    employments!: EhcEmploymentDto[] | undefined;
    mobileEmployments!: EhcMobileEmploymentBDto[] | undefined;

    constructor(data?: IEhcEmploymentOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(EhcEmploymentDto.fromJS(item));
            }
            if (Array.isArray(_data["mobileEmployments"])) {
                this.mobileEmployments = [] as any;
                for (let item of _data["mobileEmployments"])
                    this.mobileEmployments!.push(EhcMobileEmploymentBDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EhcEmploymentOutput {
        data = typeof data === 'object' ? data : {};
        let result = new EhcEmploymentOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item.toJSON());
        }
        if (Array.isArray(this.mobileEmployments)) {
            data["mobileEmployments"] = [];
            for (let item of this.mobileEmployments)
                data["mobileEmployments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEhcEmploymentOutput {
    employments: EhcEmploymentDto[] | undefined;
    mobileEmployments: EhcMobileEmploymentBDto[] | undefined;
}

export class EhcEmploymentsDto implements IEhcEmploymentsDto {
    ehcApplicationId!: number | undefined;
    postgraduateTitleId!: number | undefined;
    mobileEmployment!: EhcMobileEmploymentBDto;
    employments!: EhcEmploymentDto[] | undefined;

    constructor(data?: IEhcEmploymentsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ehcApplicationId = _data["ehcApplicationId"];
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.mobileEmployment = _data["mobileEmployment"] ? EhcMobileEmploymentBDto.fromJS(_data["mobileEmployment"]) : <any>undefined;
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(EhcEmploymentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EhcEmploymentsDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcEmploymentsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ehcApplicationId"] = this.ehcApplicationId;
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["mobileEmployment"] = this.mobileEmployment ? this.mobileEmployment.toJSON() : <any>undefined;
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEhcEmploymentsDto {
    ehcApplicationId: number | undefined;
    postgraduateTitleId: number | undefined;
    mobileEmployment: EhcMobileEmploymentBDto;
    employments: EhcEmploymentDto[] | undefined;
}

export class EhcMobileEmploymentBDto implements IEhcMobileEmploymentBDto {
    id!: number | undefined;
    ehcApplicationId!: number | undefined;
    ehcPostgraduateTitleId!: number | undefined;
    startDateNotKnown!: boolean;
    startOfEmployment!: DateTime | undefined;
    endOfEmployment!: DateTime | undefined;
    levelOfEmployment!: number;

    constructor(data?: IEhcMobileEmploymentBDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ehcApplicationId = _data["ehcApplicationId"];
            this.ehcPostgraduateTitleId = _data["ehcPostgraduateTitleId"];
            this.startDateNotKnown = _data["startDateNotKnown"];
            this.startOfEmployment = _data["startOfEmployment"] ? DateTime.fromISO(_data["startOfEmployment"].toString()) : <any>undefined;
            this.endOfEmployment = _data["endOfEmployment"] ? DateTime.fromISO(_data["endOfEmployment"].toString()) : <any>undefined;
            this.levelOfEmployment = _data["levelOfEmployment"];
        }
    }

    static fromJS(data: any): EhcMobileEmploymentBDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcMobileEmploymentBDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ehcApplicationId"] = this.ehcApplicationId;
        data["ehcPostgraduateTitleId"] = this.ehcPostgraduateTitleId;
        data["startDateNotKnown"] = this.startDateNotKnown;
        data["startOfEmployment"] = this.startOfEmployment ? this.startOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["endOfEmployment"] = this.endOfEmployment ? this.endOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfEmployment"] = this.levelOfEmployment;
        return data;
    }
}

export interface IEhcMobileEmploymentBDto {
    id: number | undefined;
    ehcApplicationId: number | undefined;
    ehcPostgraduateTitleId: number | undefined;
    startDateNotKnown: boolean;
    startOfEmployment: DateTime | undefined;
    endOfEmployment: DateTime | undefined;
    levelOfEmployment: number;
}

export class GetEhcOutput implements IGetEhcOutput {
    ehc!: EhcDto;

    constructor(data?: IGetEhcOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ehc = _data["ehc"] ? EhcDto.fromJS(_data["ehc"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEhcOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEhcOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ehc"] = this.ehc ? this.ehc.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetEhcOutput {
    ehc: EhcDto;
}

export class CreateOrUpdateEhcInvoiceAddressInput implements ICreateOrUpdateEhcInvoiceAddressInput {
    caseId!: string;
    ehcInvoiceAddress!: EhcInvoiceAddressDto;

    constructor(data?: ICreateOrUpdateEhcInvoiceAddressInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ehcInvoiceAddress = new EhcInvoiceAddressDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.ehcInvoiceAddress = _data["ehcInvoiceAddress"] ? EhcInvoiceAddressDto.fromJS(_data["ehcInvoiceAddress"]) : new EhcInvoiceAddressDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateEhcInvoiceAddressInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEhcInvoiceAddressInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["ehcInvoiceAddress"] = this.ehcInvoiceAddress ? this.ehcInvoiceAddress.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateEhcInvoiceAddressInput {
    caseId: string;
    ehcInvoiceAddress: EhcInvoiceAddressDto;
}

export class EhcInvoiceAddressDto implements IEhcInvoiceAddressDto {
    typeOfAddressId!: string | undefined;
    ehcEmploymentId!: number | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    languageOfCorrespondenceId!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    countryId!: string | undefined;
    email!: string | undefined;
    completionStatus!: CompletionStatus;

    constructor(data?: IEhcInvoiceAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeOfAddressId = _data["typeOfAddressId"];
            this.ehcEmploymentId = _data["ehcEmploymentId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.countryId = _data["countryId"];
            this.email = _data["email"];
            this.completionStatus = _data["completionStatus"];
        }
    }

    static fromJS(data: any): EhcInvoiceAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcInvoiceAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeOfAddressId"] = this.typeOfAddressId;
        data["ehcEmploymentId"] = this.ehcEmploymentId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["countryId"] = this.countryId;
        data["email"] = this.email;
        data["completionStatus"] = this.completionStatus;
        return data;
    }
}

export interface IEhcInvoiceAddressDto {
    typeOfAddressId: string | undefined;
    ehcEmploymentId: number | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    languageOfCorrespondenceId: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    countryId: string | undefined;
    email: string | undefined;
    completionStatus: CompletionStatus;
}

export class CreateOrUpdateEhcLanguageSkillInput implements ICreateOrUpdateEhcLanguageSkillInput {
    caseId!: string;
    ehcLanguageSkill!: EhcLanguageSkillDto;

    constructor(data?: ICreateOrUpdateEhcLanguageSkillInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ehcLanguageSkill = new EhcLanguageSkillDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.ehcLanguageSkill = _data["ehcLanguageSkill"] ? EhcLanguageSkillDto.fromJS(_data["ehcLanguageSkill"]) : new EhcLanguageSkillDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateEhcLanguageSkillInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEhcLanguageSkillInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["ehcLanguageSkill"] = this.ehcLanguageSkill ? this.ehcLanguageSkill.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateEhcLanguageSkillInput {
    caseId: string;
    ehcLanguageSkill: EhcLanguageSkillDto;
}

export class EhcLanguageSkillDto implements IEhcLanguageSkillDto {
    hasHighSchoolDiplomaOfLanguageOfActivityRegionId!: string | undefined;
    hasPhysicianDiplomaOfLanguageOfActivityRegionId!: string | undefined;
    languageSkillLevelId!: string | undefined;
    languageSkillDocuments!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: IEhcLanguageSkillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasHighSchoolDiplomaOfLanguageOfActivityRegionId = _data["hasHighSchoolDiplomaOfLanguageOfActivityRegionId"];
            this.hasPhysicianDiplomaOfLanguageOfActivityRegionId = _data["hasPhysicianDiplomaOfLanguageOfActivityRegionId"];
            this.languageSkillLevelId = _data["languageSkillLevelId"];
            if (Array.isArray(_data["languageSkillDocuments"])) {
                this.languageSkillDocuments = [] as any;
                for (let item of _data["languageSkillDocuments"])
                    this.languageSkillDocuments!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EhcLanguageSkillDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcLanguageSkillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasHighSchoolDiplomaOfLanguageOfActivityRegionId"] = this.hasHighSchoolDiplomaOfLanguageOfActivityRegionId;
        data["hasPhysicianDiplomaOfLanguageOfActivityRegionId"] = this.hasPhysicianDiplomaOfLanguageOfActivityRegionId;
        data["languageSkillLevelId"] = this.languageSkillLevelId;
        if (Array.isArray(this.languageSkillDocuments)) {
            data["languageSkillDocuments"] = [];
            for (let item of this.languageSkillDocuments)
                data["languageSkillDocuments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEhcLanguageSkillDto {
    hasHighSchoolDiplomaOfLanguageOfActivityRegionId: string | undefined;
    hasPhysicianDiplomaOfLanguageOfActivityRegionId: string | undefined;
    languageSkillLevelId: string | undefined;
    languageSkillDocuments: GeneralDocumentGroupDto[] | undefined;
}

export class CreateOrUpdateEhcMedicalFieldInput implements ICreateOrUpdateEhcMedicalFieldInput {
    caseId!: string;
    ehcMedicalField!: EhcMedicalFieldDto;

    constructor(data?: ICreateOrUpdateEhcMedicalFieldInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ehcMedicalField = new EhcMedicalFieldDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.ehcMedicalField = _data["ehcMedicalField"] ? EhcMedicalFieldDto.fromJS(_data["ehcMedicalField"]) : new EhcMedicalFieldDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateEhcMedicalFieldInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEhcMedicalFieldInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["ehcMedicalField"] = this.ehcMedicalField ? this.ehcMedicalField.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateEhcMedicalFieldInput {
    caseId: string;
    ehcMedicalField: EhcMedicalFieldDto;
}

export class EhcMedicalFieldDto implements IEhcMedicalFieldDto {
    medicalFieldId!: string;

    constructor(data?: IEhcMedicalFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medicalFieldId = _data["medicalFieldId"];
        }
    }

    static fromJS(data: any): EhcMedicalFieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcMedicalFieldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicalFieldId"] = this.medicalFieldId;
        return data;
    }
}

export interface IEhcMedicalFieldDto {
    medicalFieldId: string;
}

export class CreateOrUpdateEhcPersonInput implements ICreateOrUpdateEhcPersonInput {
    caseId!: string;
    ehcPerson!: EhcPersonDto;

    constructor(data?: ICreateOrUpdateEhcPersonInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ehcPerson = new EhcPersonDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.ehcPerson = _data["ehcPerson"] ? EhcPersonDto.fromJS(_data["ehcPerson"]) : new EhcPersonDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateEhcPersonInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEhcPersonInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["ehcPerson"] = this.ehcPerson ? this.ehcPerson.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateEhcPersonInput {
    caseId: string;
    ehcPerson: EhcPersonDto;
}

export class EhcPersonDto implements IEhcPersonDto {
    firstName!: string;
    lastName!: string;
    birthName!: string | undefined;
    genderId!: string | undefined;
    dateOfBirth!: DateTime | undefined;
    nationality1Id!: string | undefined;
    nationality2Id!: string | undefined;
    placeOfOrigin!: string | undefined;
    gln!: string | undefined;
    ahv!: string | undefined;

    constructor(data?: IEhcPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.birthName = _data["birthName"];
            this.genderId = _data["genderId"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.nationality1Id = _data["nationality1Id"];
            this.nationality2Id = _data["nationality2Id"];
            this.placeOfOrigin = _data["placeOfOrigin"];
            this.gln = _data["gln"];
            this.ahv = _data["ahv"];
        }
    }

    static fromJS(data: any): EhcPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["birthName"] = this.birthName;
        data["genderId"] = this.genderId;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["nationality1Id"] = this.nationality1Id;
        data["nationality2Id"] = this.nationality2Id;
        data["placeOfOrigin"] = this.placeOfOrigin;
        data["gln"] = this.gln;
        data["ahv"] = this.ahv;
        return data;
    }
}

export interface IEhcPersonDto {
    firstName: string;
    lastName: string;
    birthName: string | undefined;
    genderId: string | undefined;
    dateOfBirth: DateTime | undefined;
    nationality1Id: string | undefined;
    nationality2Id: string | undefined;
    placeOfOrigin: string | undefined;
    gln: string | undefined;
    ahv: string | undefined;
}

export class CreateOrUpdateEhcPostgraduateTitlesInput implements ICreateOrUpdateEhcPostgraduateTitlesInput {
    caseId!: string;
    ehcPostgraduateTitles!: EhcPostgraduateTitleDto[] | undefined;

    constructor(data?: ICreateOrUpdateEhcPostgraduateTitlesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["ehcPostgraduateTitles"])) {
                this.ehcPostgraduateTitles = [] as any;
                for (let item of _data["ehcPostgraduateTitles"])
                    this.ehcPostgraduateTitles!.push(EhcPostgraduateTitleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateEhcPostgraduateTitlesInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEhcPostgraduateTitlesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.ehcPostgraduateTitles)) {
            data["ehcPostgraduateTitles"] = [];
            for (let item of this.ehcPostgraduateTitles)
                data["ehcPostgraduateTitles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateEhcPostgraduateTitlesInput {
    caseId: string;
    ehcPostgraduateTitles: EhcPostgraduateTitleDto[] | undefined;
}

export class CreateOrUpdateEhcPostgraduateTitlesOutput implements ICreateOrUpdateEhcPostgraduateTitlesOutput {
    status!: EhcStatus;
    ehcPostgraduateTitles!: EhcPostgraduateTitleDto[] | undefined;

    constructor(data?: ICreateOrUpdateEhcPostgraduateTitlesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["ehcPostgraduateTitles"])) {
                this.ehcPostgraduateTitles = [] as any;
                for (let item of _data["ehcPostgraduateTitles"])
                    this.ehcPostgraduateTitles!.push(EhcPostgraduateTitleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateEhcPostgraduateTitlesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEhcPostgraduateTitlesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.ehcPostgraduateTitles)) {
            data["ehcPostgraduateTitles"] = [];
            for (let item of this.ehcPostgraduateTitles)
                data["ehcPostgraduateTitles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateEhcPostgraduateTitlesOutput {
    status: EhcStatus;
    ehcPostgraduateTitles: EhcPostgraduateTitleDto[] | undefined;
}

export class EhcPostgraduateTitleDto implements IEhcPostgraduateTitleDto {
    id!: number | undefined;
    titleId!: string | undefined;
    typeId!: string | undefined;
    placeOfIssue!: string | undefined;
    countryId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfRecognition!: DateTime | undefined;
    comment!: string | undefined;
    ehcPostgraduateTitlePractice!: EhcPostgraduateTitlePracticeDto[] | undefined;
    ehcMobileEmployment!: EhcMobileEmploymentBDto;
    ehcEmployment!: EhcEmploymentDto[] | undefined;

    constructor(data?: IEhcPostgraduateTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.titleId = _data["titleId"];
            this.typeId = _data["typeId"];
            this.placeOfIssue = _data["placeOfIssue"];
            this.countryId = _data["countryId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfRecognition = _data["dateOfRecognition"] ? DateTime.fromISO(_data["dateOfRecognition"].toString()) : <any>undefined;
            this.comment = _data["comment"];
            if (Array.isArray(_data["ehcPostgraduateTitlePractice"])) {
                this.ehcPostgraduateTitlePractice = [] as any;
                for (let item of _data["ehcPostgraduateTitlePractice"])
                    this.ehcPostgraduateTitlePractice!.push(EhcPostgraduateTitlePracticeDto.fromJS(item));
            }
            this.ehcMobileEmployment = _data["ehcMobileEmployment"] ? EhcMobileEmploymentBDto.fromJS(_data["ehcMobileEmployment"]) : <any>undefined;
            if (Array.isArray(_data["ehcEmployment"])) {
                this.ehcEmployment = [] as any;
                for (let item of _data["ehcEmployment"])
                    this.ehcEmployment!.push(EhcEmploymentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EhcPostgraduateTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcPostgraduateTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["titleId"] = this.titleId;
        data["typeId"] = this.typeId;
        data["placeOfIssue"] = this.placeOfIssue;
        data["countryId"] = this.countryId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfRecognition"] = this.dateOfRecognition ? this.dateOfRecognition.toFormat('yyyy-MM-dd') : <any>undefined;
        data["comment"] = this.comment;
        if (Array.isArray(this.ehcPostgraduateTitlePractice)) {
            data["ehcPostgraduateTitlePractice"] = [];
            for (let item of this.ehcPostgraduateTitlePractice)
                data["ehcPostgraduateTitlePractice"].push(item.toJSON());
        }
        data["ehcMobileEmployment"] = this.ehcMobileEmployment ? this.ehcMobileEmployment.toJSON() : <any>undefined;
        if (Array.isArray(this.ehcEmployment)) {
            data["ehcEmployment"] = [];
            for (let item of this.ehcEmployment)
                data["ehcEmployment"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEhcPostgraduateTitleDto {
    id: number | undefined;
    titleId: string | undefined;
    typeId: string | undefined;
    placeOfIssue: string | undefined;
    countryId: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfRecognition: DateTime | undefined;
    comment: string | undefined;
    ehcPostgraduateTitlePractice: EhcPostgraduateTitlePracticeDto[] | undefined;
    ehcMobileEmployment: EhcMobileEmploymentBDto;
    ehcEmployment: EhcEmploymentDto[] | undefined;
}

export class CreateOrUpdateEhcPostgraduateTitlePracticeInput implements ICreateOrUpdateEhcPostgraduateTitlePracticeInput {
    caseId!: string;
    ehcPostgraduateTitlePractices!: EhcPostgraduateTitlePracticesDto[] | undefined;

    constructor(data?: ICreateOrUpdateEhcPostgraduateTitlePracticeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["ehcPostgraduateTitlePractices"])) {
                this.ehcPostgraduateTitlePractices = [] as any;
                for (let item of _data["ehcPostgraduateTitlePractices"])
                    this.ehcPostgraduateTitlePractices!.push(EhcPostgraduateTitlePracticesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateEhcPostgraduateTitlePracticeInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEhcPostgraduateTitlePracticeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.ehcPostgraduateTitlePractices)) {
            data["ehcPostgraduateTitlePractices"] = [];
            for (let item of this.ehcPostgraduateTitlePractices)
                data["ehcPostgraduateTitlePractices"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateEhcPostgraduateTitlePracticeInput {
    caseId: string;
    ehcPostgraduateTitlePractices: EhcPostgraduateTitlePracticesDto[] | undefined;
}

export class CreateOrUpdateEhcPracticesInput implements ICreateOrUpdateEhcPracticesInput {
    caseId!: string;
    ehcPractice!: EhcPracticeDto;

    constructor(data?: ICreateOrUpdateEhcPracticesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ehcPractice = new EhcPracticeDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.ehcPractice = _data["ehcPractice"] ? EhcPracticeDto.fromJS(_data["ehcPractice"]) : new EhcPracticeDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateEhcPracticesInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEhcPracticesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["ehcPractice"] = this.ehcPractice ? this.ehcPractice.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateEhcPracticesInput {
    caseId: string;
    ehcPractice: EhcPracticeDto;
}

export class CreateOrUpdateEhcPracticesOutput implements ICreateOrUpdateEhcPracticesOutput {
    status!: EhcStatus;
    ehcPractice!: EhcPracticeDto;

    constructor(data?: ICreateOrUpdateEhcPracticesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.ehcPractice = _data["ehcPractice"] ? EhcPracticeDto.fromJS(_data["ehcPractice"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrUpdateEhcPracticesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEhcPracticesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["ehcPractice"] = this.ehcPractice ? this.ehcPractice.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateEhcPracticesOutput {
    status: EhcStatus;
    ehcPractice: EhcPracticeDto;
}

export class EhcPostgraduateTitlePracticeDto implements IEhcPostgraduateTitlePracticeDto {
    id!: string;
    ehcPostgraduateTitleId!: number;
    businessName!: string;
    duration!: number;
    levelOfEmployment!: number;
    ehcPracticeRecordDocuments!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: IEhcPostgraduateTitlePracticeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ehcPostgraduateTitleId = _data["ehcPostgraduateTitleId"];
            this.businessName = _data["businessName"];
            this.duration = _data["duration"];
            this.levelOfEmployment = _data["levelOfEmployment"];
            if (Array.isArray(_data["ehcPracticeRecordDocuments"])) {
                this.ehcPracticeRecordDocuments = [] as any;
                for (let item of _data["ehcPracticeRecordDocuments"])
                    this.ehcPracticeRecordDocuments!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EhcPostgraduateTitlePracticeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcPostgraduateTitlePracticeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ehcPostgraduateTitleId"] = this.ehcPostgraduateTitleId;
        data["businessName"] = this.businessName;
        data["duration"] = this.duration;
        data["levelOfEmployment"] = this.levelOfEmployment;
        if (Array.isArray(this.ehcPracticeRecordDocuments)) {
            data["ehcPracticeRecordDocuments"] = [];
            for (let item of this.ehcPracticeRecordDocuments)
                data["ehcPracticeRecordDocuments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEhcPostgraduateTitlePracticeDto {
    id: string;
    ehcPostgraduateTitleId: number;
    businessName: string;
    duration: number;
    levelOfEmployment: number;
    ehcPracticeRecordDocuments: GeneralDocumentGroupDto[] | undefined;
}

export class EhcPostgraduateTitlePracticesDto implements IEhcPostgraduateTitlePracticesDto {
    postgraduateTitleId!: number;
    practices!: EhcPostgraduateTitlePracticeDto[] | undefined;

    constructor(data?: IEhcPostgraduateTitlePracticesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            if (Array.isArray(_data["practices"])) {
                this.practices = [] as any;
                for (let item of _data["practices"])
                    this.practices!.push(EhcPostgraduateTitlePracticeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EhcPostgraduateTitlePracticesDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcPostgraduateTitlePracticesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        if (Array.isArray(this.practices)) {
            data["practices"] = [];
            for (let item of this.practices)
                data["practices"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEhcPostgraduateTitlePracticesDto {
    postgraduateTitleId: number;
    practices: EhcPostgraduateTitlePracticeDto[] | undefined;
}

export class EhcPracticeConfigSnapshotDto implements IEhcPracticeConfigSnapshotDto {
    minimumDurationInDays!: number;
    ignoreMinimumDuration!: boolean;
    ehcPracticeDescriptionPreLabel1!: string | undefined;
    ehcPracticeDescription1Id!: string | undefined;
    ehcPracticeDescriptionPreLabel2!: string | undefined;
    ehcPracticeDescription2Id!: string | undefined;
    ehcPracticeDescriptionPreLabel3!: string | undefined;
    ehcPracticeDescription3Id!: string | undefined;
    ehcPracticeRecordDescriptionPreLabel1!: string | undefined;
    ehcPracticeRecordDescription1Id!: string | undefined;
    ehcPracticeRecordDescriptionPreLabel2!: string | undefined;
    ehcPracticeRecordDescription2Id!: string | undefined;
    ehcPracticeRecordDescriptionPreLabel3!: string | undefined;
    ehcPracticeRecordDescription3Id!: string | undefined;

    constructor(data?: IEhcPracticeConfigSnapshotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minimumDurationInDays = _data["minimumDurationInDays"];
            this.ignoreMinimumDuration = _data["ignoreMinimumDuration"];
            this.ehcPracticeDescriptionPreLabel1 = _data["ehcPracticeDescriptionPreLabel1"];
            this.ehcPracticeDescription1Id = _data["ehcPracticeDescription1Id"];
            this.ehcPracticeDescriptionPreLabel2 = _data["ehcPracticeDescriptionPreLabel2"];
            this.ehcPracticeDescription2Id = _data["ehcPracticeDescription2Id"];
            this.ehcPracticeDescriptionPreLabel3 = _data["ehcPracticeDescriptionPreLabel3"];
            this.ehcPracticeDescription3Id = _data["ehcPracticeDescription3Id"];
            this.ehcPracticeRecordDescriptionPreLabel1 = _data["ehcPracticeRecordDescriptionPreLabel1"];
            this.ehcPracticeRecordDescription1Id = _data["ehcPracticeRecordDescription1Id"];
            this.ehcPracticeRecordDescriptionPreLabel2 = _data["ehcPracticeRecordDescriptionPreLabel2"];
            this.ehcPracticeRecordDescription2Id = _data["ehcPracticeRecordDescription2Id"];
            this.ehcPracticeRecordDescriptionPreLabel3 = _data["ehcPracticeRecordDescriptionPreLabel3"];
            this.ehcPracticeRecordDescription3Id = _data["ehcPracticeRecordDescription3Id"];
        }
    }

    static fromJS(data: any): EhcPracticeConfigSnapshotDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcPracticeConfigSnapshotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minimumDurationInDays"] = this.minimumDurationInDays;
        data["ignoreMinimumDuration"] = this.ignoreMinimumDuration;
        data["ehcPracticeDescriptionPreLabel1"] = this.ehcPracticeDescriptionPreLabel1;
        data["ehcPracticeDescription1Id"] = this.ehcPracticeDescription1Id;
        data["ehcPracticeDescriptionPreLabel2"] = this.ehcPracticeDescriptionPreLabel2;
        data["ehcPracticeDescription2Id"] = this.ehcPracticeDescription2Id;
        data["ehcPracticeDescriptionPreLabel3"] = this.ehcPracticeDescriptionPreLabel3;
        data["ehcPracticeDescription3Id"] = this.ehcPracticeDescription3Id;
        data["ehcPracticeRecordDescriptionPreLabel1"] = this.ehcPracticeRecordDescriptionPreLabel1;
        data["ehcPracticeRecordDescription1Id"] = this.ehcPracticeRecordDescription1Id;
        data["ehcPracticeRecordDescriptionPreLabel2"] = this.ehcPracticeRecordDescriptionPreLabel2;
        data["ehcPracticeRecordDescription2Id"] = this.ehcPracticeRecordDescription2Id;
        data["ehcPracticeRecordDescriptionPreLabel3"] = this.ehcPracticeRecordDescriptionPreLabel3;
        data["ehcPracticeRecordDescription3Id"] = this.ehcPracticeRecordDescription3Id;
        return data;
    }
}

export interface IEhcPracticeConfigSnapshotDto {
    minimumDurationInDays: number;
    ignoreMinimumDuration: boolean;
    ehcPracticeDescriptionPreLabel1: string | undefined;
    ehcPracticeDescription1Id: string | undefined;
    ehcPracticeDescriptionPreLabel2: string | undefined;
    ehcPracticeDescription2Id: string | undefined;
    ehcPracticeDescriptionPreLabel3: string | undefined;
    ehcPracticeDescription3Id: string | undefined;
    ehcPracticeRecordDescriptionPreLabel1: string | undefined;
    ehcPracticeRecordDescription1Id: string | undefined;
    ehcPracticeRecordDescriptionPreLabel2: string | undefined;
    ehcPracticeRecordDescription2Id: string | undefined;
    ehcPracticeRecordDescriptionPreLabel3: string | undefined;
    ehcPracticeRecordDescription3Id: string | undefined;
}

export class EhcPracticeDto implements IEhcPracticeDto {
    ehcSelectedPracticeDescriptionId!: string | undefined;
    ehcPracticeRecords!: EhcPracticeRecordDto[] | undefined;
    ehcPracticeConfigSnapshot!: EhcPracticeConfigSnapshotDto;
    ehcPracticeRecordDocuments!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: IEhcPracticeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ehcSelectedPracticeDescriptionId = _data["ehcSelectedPracticeDescriptionId"];
            if (Array.isArray(_data["ehcPracticeRecords"])) {
                this.ehcPracticeRecords = [] as any;
                for (let item of _data["ehcPracticeRecords"])
                    this.ehcPracticeRecords!.push(EhcPracticeRecordDto.fromJS(item));
            }
            this.ehcPracticeConfigSnapshot = _data["ehcPracticeConfigSnapshot"] ? EhcPracticeConfigSnapshotDto.fromJS(_data["ehcPracticeConfigSnapshot"]) : <any>undefined;
            if (Array.isArray(_data["ehcPracticeRecordDocuments"])) {
                this.ehcPracticeRecordDocuments = [] as any;
                for (let item of _data["ehcPracticeRecordDocuments"])
                    this.ehcPracticeRecordDocuments!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EhcPracticeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcPracticeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ehcSelectedPracticeDescriptionId"] = this.ehcSelectedPracticeDescriptionId;
        if (Array.isArray(this.ehcPracticeRecords)) {
            data["ehcPracticeRecords"] = [];
            for (let item of this.ehcPracticeRecords)
                data["ehcPracticeRecords"].push(item.toJSON());
        }
        data["ehcPracticeConfigSnapshot"] = this.ehcPracticeConfigSnapshot ? this.ehcPracticeConfigSnapshot.toJSON() : <any>undefined;
        if (Array.isArray(this.ehcPracticeRecordDocuments)) {
            data["ehcPracticeRecordDocuments"] = [];
            for (let item of this.ehcPracticeRecordDocuments)
                data["ehcPracticeRecordDocuments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEhcPracticeDto {
    ehcSelectedPracticeDescriptionId: string | undefined;
    ehcPracticeRecords: EhcPracticeRecordDto[] | undefined;
    ehcPracticeConfigSnapshot: EhcPracticeConfigSnapshotDto;
    ehcPracticeRecordDocuments: GeneralDocumentGroupDto[] | undefined;
}

export class EhcPracticeRecordDto implements IEhcPracticeRecordDto {
    id!: string;
    businessName!: string;
    dateOfEmployment!: DateTime | undefined;
    dateOfEndOfEmployment!: DateTime | undefined;
    duration!: number | undefined;
    levelOfEmployment!: number;
    ehcSelectedPracticeDescriptionId!: string | undefined;

    constructor(data?: IEhcPracticeRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.businessName = _data["businessName"];
            this.dateOfEmployment = _data["dateOfEmployment"] ? DateTime.fromISO(_data["dateOfEmployment"].toString()) : <any>undefined;
            this.dateOfEndOfEmployment = _data["dateOfEndOfEmployment"] ? DateTime.fromISO(_data["dateOfEndOfEmployment"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.ehcSelectedPracticeDescriptionId = _data["ehcSelectedPracticeDescriptionId"];
        }
    }

    static fromJS(data: any): EhcPracticeRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcPracticeRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["businessName"] = this.businessName;
        data["dateOfEmployment"] = this.dateOfEmployment ? this.dateOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEndOfEmployment"] = this.dateOfEndOfEmployment ? this.dateOfEndOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["duration"] = this.duration;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["ehcSelectedPracticeDescriptionId"] = this.ehcSelectedPracticeDescriptionId;
        return data;
    }
}

export interface IEhcPracticeRecordDto {
    id: string;
    businessName: string;
    dateOfEmployment: DateTime | undefined;
    dateOfEndOfEmployment: DateTime | undefined;
    duration: number | undefined;
    levelOfEmployment: number;
    ehcSelectedPracticeDescriptionId: string | undefined;
}

export class CreateOrUpdateEhcQualityMeasurementInput implements ICreateOrUpdateEhcQualityMeasurementInput {
    caseId!: string;
    ehcQualityMeasurement!: EhcQualityMeasurementDto;

    constructor(data?: ICreateOrUpdateEhcQualityMeasurementInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ehcQualityMeasurement = new EhcQualityMeasurementDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.ehcQualityMeasurement = _data["ehcQualityMeasurement"] ? EhcQualityMeasurementDto.fromJS(_data["ehcQualityMeasurement"]) : new EhcQualityMeasurementDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateEhcQualityMeasurementInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEhcQualityMeasurementInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["ehcQualityMeasurement"] = this.ehcQualityMeasurement ? this.ehcQualityMeasurement.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateEhcQualityMeasurementInput {
    caseId: string;
    ehcQualityMeasurement: EhcQualityMeasurementDto;
}

export class EhcQualityMeasurementDto implements IEhcQualityMeasurementDto {
    hasMembershipInSwissNetworkId!: string;
    membershipInSwissNetworkDetails!: string | undefined;
    hasNecessaryEquipmentForQualityMeasurementId!: string;
    necessaryEquipmentForQualityMeasurementDetails!: string | undefined;

    constructor(data?: IEhcQualityMeasurementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasMembershipInSwissNetworkId = _data["hasMembershipInSwissNetworkId"];
            this.membershipInSwissNetworkDetails = _data["membershipInSwissNetworkDetails"];
            this.hasNecessaryEquipmentForQualityMeasurementId = _data["hasNecessaryEquipmentForQualityMeasurementId"];
            this.necessaryEquipmentForQualityMeasurementDetails = _data["necessaryEquipmentForQualityMeasurementDetails"];
        }
    }

    static fromJS(data: any): EhcQualityMeasurementDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcQualityMeasurementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasMembershipInSwissNetworkId"] = this.hasMembershipInSwissNetworkId;
        data["membershipInSwissNetworkDetails"] = this.membershipInSwissNetworkDetails;
        data["hasNecessaryEquipmentForQualityMeasurementId"] = this.hasNecessaryEquipmentForQualityMeasurementId;
        data["necessaryEquipmentForQualityMeasurementDetails"] = this.necessaryEquipmentForQualityMeasurementDetails;
        return data;
    }
}

export interface IEhcQualityMeasurementDto {
    hasMembershipInSwissNetworkId: string;
    membershipInSwissNetworkDetails: string | undefined;
    hasNecessaryEquipmentForQualityMeasurementId: string;
    necessaryEquipmentForQualityMeasurementDetails: string | undefined;
}

export class CreateOrUpdateEhcQualitySupportSystemInput implements ICreateOrUpdateEhcQualitySupportSystemInput {
    caseId!: string;
    ehcQualitySupportSystem!: EhcQualitySupportSystemDto;

    constructor(data?: ICreateOrUpdateEhcQualitySupportSystemInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ehcQualitySupportSystem = new EhcQualitySupportSystemDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.ehcQualitySupportSystem = _data["ehcQualitySupportSystem"] ? EhcQualitySupportSystemDto.fromJS(_data["ehcQualitySupportSystem"]) : new EhcQualitySupportSystemDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateEhcQualitySupportSystemInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEhcQualitySupportSystemInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["ehcQualitySupportSystem"] = this.ehcQualitySupportSystem ? this.ehcQualitySupportSystem.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateEhcQualitySupportSystemInput {
    caseId: string;
    ehcQualitySupportSystem: EhcQualitySupportSystemDto;
}

export class EhcQualitySupportSystemDto implements IEhcQualitySupportSystemDto {
    qualityManagementSystemDetails!: string | undefined;
    reportingAndLearningSystemDetails!: string | undefined;
    hasQualityManagementSystemInPlaceId!: string | undefined;
    qualityManagementSystemInPlaceDetails!: string | undefined;
    hasInternalReportingAndLearningSystemId!: string | undefined;
    internalReportingAndLearningSystemDetails!: string | undefined;

    constructor(data?: IEhcQualitySupportSystemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualityManagementSystemDetails = _data["qualityManagementSystemDetails"];
            this.reportingAndLearningSystemDetails = _data["reportingAndLearningSystemDetails"];
            this.hasQualityManagementSystemInPlaceId = _data["hasQualityManagementSystemInPlaceId"];
            this.qualityManagementSystemInPlaceDetails = _data["qualityManagementSystemInPlaceDetails"];
            this.hasInternalReportingAndLearningSystemId = _data["hasInternalReportingAndLearningSystemId"];
            this.internalReportingAndLearningSystemDetails = _data["internalReportingAndLearningSystemDetails"];
        }
    }

    static fromJS(data: any): EhcQualitySupportSystemDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcQualitySupportSystemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualityManagementSystemDetails"] = this.qualityManagementSystemDetails;
        data["reportingAndLearningSystemDetails"] = this.reportingAndLearningSystemDetails;
        data["hasQualityManagementSystemInPlaceId"] = this.hasQualityManagementSystemInPlaceId;
        data["qualityManagementSystemInPlaceDetails"] = this.qualityManagementSystemInPlaceDetails;
        data["hasInternalReportingAndLearningSystemId"] = this.hasInternalReportingAndLearningSystemId;
        data["internalReportingAndLearningSystemDetails"] = this.internalReportingAndLearningSystemDetails;
        return data;
    }
}

export interface IEhcQualitySupportSystemDto {
    qualityManagementSystemDetails: string | undefined;
    reportingAndLearningSystemDetails: string | undefined;
    hasQualityManagementSystemInPlaceId: string | undefined;
    qualityManagementSystemInPlaceDetails: string | undefined;
    hasInternalReportingAndLearningSystemId: string | undefined;
    internalReportingAndLearningSystemDetails: string | undefined;
}

export class CreateOrUpdateEhcSelfEmploymentInput implements ICreateOrUpdateEhcSelfEmploymentInput {
    caseId!: string;
    ehcSelfEmployment!: EhcSelfEmploymentDto;

    constructor(data?: ICreateOrUpdateEhcSelfEmploymentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ehcSelfEmployment = new EhcSelfEmploymentDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.ehcSelfEmployment = _data["ehcSelfEmployment"] ? EhcSelfEmploymentDto.fromJS(_data["ehcSelfEmployment"]) : new EhcSelfEmploymentDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateEhcSelfEmploymentInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEhcSelfEmploymentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["ehcSelfEmployment"] = this.ehcSelfEmployment ? this.ehcSelfEmployment.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateEhcSelfEmploymentInput {
    caseId: string;
    ehcSelfEmployment: EhcSelfEmploymentDto;
}

export class EhcSelfEmploymentDto implements IEhcSelfEmploymentDto {
    isSelfEmployedId!: string;

    constructor(data?: IEhcSelfEmploymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSelfEmployedId = _data["isSelfEmployedId"];
        }
    }

    static fromJS(data: any): EhcSelfEmploymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcSelfEmploymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSelfEmployedId"] = this.isSelfEmployedId;
        return data;
    }
}

export interface IEhcSelfEmploymentDto {
    isSelfEmployedId: string;
}

export class CreateOrUpdateEhcStaffInput implements ICreateOrUpdateEhcStaffInput {
    caseId!: string;
    ehcStaff!: EhcStaffDto;

    constructor(data?: ICreateOrUpdateEhcStaffInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ehcStaff = new EhcStaffDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.ehcStaff = _data["ehcStaff"] ? EhcStaffDto.fromJS(_data["ehcStaff"]) : new EhcStaffDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateEhcStaffInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEhcStaffInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["ehcStaff"] = this.ehcStaff ? this.ehcStaff.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateEhcStaffInput {
    caseId: string;
    ehcStaff: EhcStaffDto;
}

export class EhcStaffDto implements IEhcStaffDto {
    qualifiedStaffDetails!: string | undefined;
    hasQualifiedStaffId!: string | undefined;
    noQualifiedStaffDetails!: string | undefined;

    constructor(data?: IEhcStaffDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualifiedStaffDetails = _data["qualifiedStaffDetails"];
            this.hasQualifiedStaffId = _data["hasQualifiedStaffId"];
            this.noQualifiedStaffDetails = _data["noQualifiedStaffDetails"];
        }
    }

    static fromJS(data: any): EhcStaffDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcStaffDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualifiedStaffDetails"] = this.qualifiedStaffDetails;
        data["hasQualifiedStaffId"] = this.hasQualifiedStaffId;
        data["noQualifiedStaffDetails"] = this.noQualifiedStaffDetails;
        return data;
    }
}

export interface IEhcStaffDto {
    qualifiedStaffDetails: string | undefined;
    hasQualifiedStaffId: string | undefined;
    noQualifiedStaffDetails: string | undefined;
}

export class CreateOrUpdateFileDossierDto implements ICreateOrUpdateFileDossierDto {
    name!: string;
    items!: FileDossierItemDto[] | undefined;

    constructor(data?: ICreateOrUpdateFileDossierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FileDossierItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateFileDossierDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateFileDossierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateFileDossierDto {
    name: string;
    items: FileDossierItemDto[] | undefined;
}

export class FileDossierItemDto implements IFileDossierItemDto {
    order!: number;
    name!: string | undefined;
    datedFrom!: DateTime;
    isDatedFromSet!: boolean;
    documentId!: number | undefined;
    parentDocumentItemId!: number | undefined;
    subOrder!: number;
    actNumberDisplay!: string | undefined;
    readonly isPlaceholder!: boolean;
    readonly isAttachment!: boolean;
    id!: number | undefined;

    constructor(data?: IFileDossierItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
            this.name = _data["name"];
            this.datedFrom = _data["datedFrom"] ? DateTime.fromISO(_data["datedFrom"].toString()) : <any>undefined;
            this.isDatedFromSet = _data["isDatedFromSet"];
            this.documentId = _data["documentId"];
            this.parentDocumentItemId = _data["parentDocumentItemId"];
            this.subOrder = _data["subOrder"];
            this.actNumberDisplay = _data["actNumberDisplay"];
            (<any>this).isPlaceholder = _data["isPlaceholder"];
            (<any>this).isAttachment = _data["isAttachment"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FileDossierItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDossierItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["name"] = this.name;
        data["datedFrom"] = this.datedFrom ? this.datedFrom.toFormat('yyyy-MM-dd') : <any>undefined;
        data["isDatedFromSet"] = this.isDatedFromSet;
        data["documentId"] = this.documentId;
        data["parentDocumentItemId"] = this.parentDocumentItemId;
        data["subOrder"] = this.subOrder;
        data["actNumberDisplay"] = this.actNumberDisplay;
        data["isPlaceholder"] = this.isPlaceholder;
        data["isAttachment"] = this.isAttachment;
        data["id"] = this.id;
        return data;
    }
}

export interface IFileDossierItemDto {
    order: number;
    name: string | undefined;
    datedFrom: DateTime;
    isDatedFromSet: boolean;
    documentId: number | undefined;
    parentDocumentItemId: number | undefined;
    subOrder: number;
    actNumberDisplay: string | undefined;
    isPlaceholder: boolean;
    isAttachment: boolean;
    id: number | undefined;
}

export class FileDossierSearchResultDto implements IFileDossierSearchResultDto {
    id!: number;
    name!: string | undefined;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    creationTime!: DateTime;

    constructor(data?: IFileDossierSearchResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FileDossierSearchResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDossierSearchResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface IFileDossierSearchResultDto {
    id: number;
    name: string | undefined;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    creationTime: DateTime;
}

export class GenerateZipFileArchiveOutputDto implements IGenerateZipFileArchiveOutputDto {
    documentIdZipArchive!: number;
    documentIdFileDossier!: number;
    xmlData!: string | undefined;

    constructor(data?: IGenerateZipFileArchiveOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentIdZipArchive = _data["documentIdZipArchive"];
            this.documentIdFileDossier = _data["documentIdFileDossier"];
            this.xmlData = _data["xmlData"];
        }
    }

    static fromJS(data: any): GenerateZipFileArchiveOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateZipFileArchiveOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentIdZipArchive"] = this.documentIdZipArchive;
        data["documentIdFileDossier"] = this.documentIdFileDossier;
        data["xmlData"] = this.xmlData;
        return data;
    }
}

export interface IGenerateZipFileArchiveOutputDto {
    documentIdZipArchive: number;
    documentIdFileDossier: number;
    xmlData: string | undefined;
}

export class GetFileDossierDto implements IGetFileDossierDto {
    name!: string | undefined;
    items!: FileDossierItemDto[] | undefined;
    id!: number;

    constructor(data?: IGetFileDossierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FileDossierItemDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetFileDossierDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetFileDossierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IGetFileDossierDto {
    name: string | undefined;
    items: FileDossierItemDto[] | undefined;
    id: number;
}

export class GetFileDossierSearchInput implements IGetFileDossierSearchInput {
    personId!: number | undefined;
    sponsorshipId!: number | undefined;
    filter!: string | undefined;
    sorting!: string | undefined;
    maxResultCount!: number;
    skipCount!: number;

    constructor(data?: IGetFileDossierSearchInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.sponsorshipId = _data["sponsorshipId"];
            this.filter = _data["filter"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): GetFileDossierSearchInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetFileDossierSearchInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["sponsorshipId"] = this.sponsorshipId;
        data["filter"] = this.filter;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }
}

export interface IGetFileDossierSearchInput {
    personId: number | undefined;
    sponsorshipId: number | undefined;
    filter: string | undefined;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
}

export class GetFileDossierSearchOutput implements IGetFileDossierSearchOutput {
    totalCount!: number;
    items!: FileDossierSearchResultDto[] | undefined;

    constructor(data?: IGetFileDossierSearchOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FileDossierSearchResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFileDossierSearchOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetFileDossierSearchOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetFileDossierSearchOutput {
    totalCount: number;
    items: FileDossierSearchResultDto[] | undefined;
}

export enum SqlParameterType {
    Integer = 0,
    String = 1,
    Date = 2,
    Code = 3,
}

export class AcceptFriendshipRequestInput implements IAcceptFriendshipRequestInput {
    userId!: number;
    tenantId!: number | undefined;

    constructor(data?: IAcceptFriendshipRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): AcceptFriendshipRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptFriendshipRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IAcceptFriendshipRequestInput {
    userId: number;
    tenantId: number | undefined;
}

export class BlockUserInput implements IBlockUserInput {
    userId!: number;
    tenantId!: number | undefined;

    constructor(data?: IBlockUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): BlockUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new BlockUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IBlockUserInput {
    userId: number;
    tenantId: number | undefined;
}

export class CreateFriendshipRequestByUserNameInput implements ICreateFriendshipRequestByUserNameInput {
    tenancyName!: string;
    userName!: string | undefined;

    constructor(data?: ICreateFriendshipRequestByUserNameInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): CreateFriendshipRequestByUserNameInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFriendshipRequestByUserNameInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userName"] = this.userName;
        return data;
    }
}

export interface ICreateFriendshipRequestByUserNameInput {
    tenancyName: string;
    userName: string | undefined;
}

export class CreateFriendshipRequestInput implements ICreateFriendshipRequestInput {
    userId!: number;
    tenantId!: number | undefined;

    constructor(data?: ICreateFriendshipRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): CreateFriendshipRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFriendshipRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface ICreateFriendshipRequestInput {
    userId: number;
    tenantId: number | undefined;
}

export class FriendDto implements IFriendDto {
    friendUserId!: number;
    friendTenantId!: number | undefined;
    friendUserName!: string | undefined;
    friendTenancyName!: string | undefined;
    friendProfilePictureId!: string | undefined;
    unreadMessageCount!: number;
    isOnline!: boolean;
    state!: FriendshipState;

    constructor(data?: IFriendDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.friendUserId = _data["friendUserId"];
            this.friendTenantId = _data["friendTenantId"];
            this.friendUserName = _data["friendUserName"];
            this.friendTenancyName = _data["friendTenancyName"];
            this.friendProfilePictureId = _data["friendProfilePictureId"];
            this.unreadMessageCount = _data["unreadMessageCount"];
            this.isOnline = _data["isOnline"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): FriendDto {
        data = typeof data === 'object' ? data : {};
        let result = new FriendDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["friendUserId"] = this.friendUserId;
        data["friendTenantId"] = this.friendTenantId;
        data["friendUserName"] = this.friendUserName;
        data["friendTenancyName"] = this.friendTenancyName;
        data["friendProfilePictureId"] = this.friendProfilePictureId;
        data["unreadMessageCount"] = this.unreadMessageCount;
        data["isOnline"] = this.isOnline;
        data["state"] = this.state;
        return data;
    }
}

export interface IFriendDto {
    friendUserId: number;
    friendTenantId: number | undefined;
    friendUserName: string | undefined;
    friendTenancyName: string | undefined;
    friendProfilePictureId: string | undefined;
    unreadMessageCount: number;
    isOnline: boolean;
    state: FriendshipState;
}

export class UnblockUserInput implements IUnblockUserInput {
    userId!: number;
    tenantId!: number | undefined;

    constructor(data?: IUnblockUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): UnblockUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new UnblockUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IUnblockUserInput {
    userId: number;
    tenantId: number | undefined;
}

export enum FriendshipState {
    Accepted = 1,
    Blocked = 2,
}

export class HealthRegExportCacheInput implements IHealthRegExportCacheInput {
    externalSystem!: ExternalSystemEnum;
    file!: string;

    constructor(data?: IHealthRegExportCacheInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalSystem = _data["externalSystem"];
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): HealthRegExportCacheInput {
        data = typeof data === 'object' ? data : {};
        let result = new HealthRegExportCacheInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalSystem"] = this.externalSystem;
        data["file"] = this.file;
        return data;
    }
}

export interface IHealthRegExportCacheInput {
    externalSystem: ExternalSystemEnum;
    file: string;
}

export class HealthRegExportCacheOutput implements IHealthRegExportCacheOutput {
    file!: string | undefined;

    constructor(data?: IHealthRegExportCacheOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): HealthRegExportCacheOutput {
        data = typeof data === 'object' ? data : {};
        let result = new HealthRegExportCacheOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["file"] = this.file;
        return data;
    }
}

export interface IHealthRegExportCacheOutput {
    file: string | undefined;
}

export enum HistoryPropertyChange {
    NoChange = 0,
    Insert = 1,
    Change = 2,
    Delete = 3,
}

export enum IdentificationContext {
    General = 0,
    Sponsorship = 1,
}

export class AppSettingsJsonDto implements IAppSettingsJsonDto {
    webSiteUrl!: string | undefined;
    serverSiteUrl!: string | undefined;
    languages!: NameValue[] | undefined;

    constructor(data?: IAppSettingsJsonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.webSiteUrl = _data["webSiteUrl"];
            this.serverSiteUrl = _data["serverSiteUrl"];
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(NameValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppSettingsJsonDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppSettingsJsonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webSiteUrl"] = this.webSiteUrl;
        data["serverSiteUrl"] = this.serverSiteUrl;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAppSettingsJsonDto {
    webSiteUrl: string | undefined;
    serverSiteUrl: string | undefined;
    languages: NameValue[] | undefined;
}

export class CheckDatabaseOutput implements ICheckDatabaseOutput {
    isDatabaseExist!: boolean;

    constructor(data?: ICheckDatabaseOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isDatabaseExist = _data["isDatabaseExist"];
        }
    }

    static fromJS(data: any): CheckDatabaseOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CheckDatabaseOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDatabaseExist"] = this.isDatabaseExist;
        return data;
    }
}

export interface ICheckDatabaseOutput {
    isDatabaseExist: boolean;
}

export class InstallDto implements IInstallDto {
    connectionString!: string;
    adminPassword!: string;
    webSiteUrl!: string;
    serverUrl!: string | undefined;
    defaultLanguage!: string;
    smtpSettings!: EmailSettingsEditDto;
    billInfo!: HostBillingSettingsEditDto;

    constructor(data?: IInstallDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connectionString = _data["connectionString"];
            this.adminPassword = _data["adminPassword"];
            this.webSiteUrl = _data["webSiteUrl"];
            this.serverUrl = _data["serverUrl"];
            this.defaultLanguage = _data["defaultLanguage"];
            this.smtpSettings = _data["smtpSettings"] ? EmailSettingsEditDto.fromJS(_data["smtpSettings"]) : <any>undefined;
            this.billInfo = _data["billInfo"] ? HostBillingSettingsEditDto.fromJS(_data["billInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InstallDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstallDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectionString"] = this.connectionString;
        data["adminPassword"] = this.adminPassword;
        data["webSiteUrl"] = this.webSiteUrl;
        data["serverUrl"] = this.serverUrl;
        data["defaultLanguage"] = this.defaultLanguage;
        data["smtpSettings"] = this.smtpSettings ? this.smtpSettings.toJSON() : <any>undefined;
        data["billInfo"] = this.billInfo ? this.billInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IInstallDto {
    connectionString: string;
    adminPassword: string;
    webSiteUrl: string;
    serverUrl: string | undefined;
    defaultLanguage: string;
    smtpSettings: EmailSettingsEditDto;
    billInfo: HostBillingSettingsEditDto;
}

export class GetJobInfoListOutput implements IGetJobInfoListOutput {
    items!: JobInfoDto[] | undefined;

    constructor(data?: IGetJobInfoListOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(JobInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetJobInfoListOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetJobInfoListOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetJobInfoListOutput {
    items: JobInfoDto[] | undefined;
}

export class GetJobOutputFilesResult implements IGetJobOutputFilesResult {
    totalCount!: number;
    items!: JobOutputFileDto[] | undefined;

    constructor(data?: IGetJobOutputFilesResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(JobOutputFileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetJobOutputFilesResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetJobOutputFilesResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetJobOutputFilesResult {
    totalCount: number;
    items: JobOutputFileDto[] | undefined;
}

export class JobInfoDto implements IJobInfoDto {
    group!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    lastRun!: LastRunInfoDto;

    constructor(data?: IJobInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.group = _data["group"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.lastRun = _data["lastRun"] ? LastRunInfoDto.fromJS(_data["lastRun"]) : <any>undefined;
        }
    }

    static fromJS(data: any): JobInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["group"] = this.group;
        data["name"] = this.name;
        data["description"] = this.description;
        data["lastRun"] = this.lastRun ? this.lastRun.toJSON() : <any>undefined;
        return data;
    }
}

export interface IJobInfoDto {
    group: string | undefined;
    name: string | undefined;
    description: string | undefined;
    lastRun: LastRunInfoDto;
}

export class JobOutputFileDto implements IJobOutputFileDto {
    id!: number;
    creationTime!: DateTime;
    type!: JobOutputFileType;
    typeTranslated!: string | undefined;
    mimeHeader!: string | undefined;

    constructor(data?: IJobOutputFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.type = _data["type"];
            this.typeTranslated = _data["typeTranslated"];
            this.mimeHeader = _data["mimeHeader"];
        }
    }

    static fromJS(data: any): JobOutputFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobOutputFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["type"] = this.type;
        data["typeTranslated"] = this.typeTranslated;
        data["mimeHeader"] = this.mimeHeader;
        return data;
    }
}

export interface IJobOutputFileDto {
    id: number;
    creationTime: DateTime;
    type: JobOutputFileType;
    typeTranslated: string | undefined;
    mimeHeader: string | undefined;
}

export class LastRunInfoDto implements ILastRunInfoDto {
    fired!: DateTime;
    successful!: boolean;
    exception!: any | undefined;

    constructor(data?: ILastRunInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fired = _data["fired"] ? DateTime.fromISO(_data["fired"].toString()) : <any>undefined;
            this.successful = _data["successful"];
            this.exception = _data["exception"];
        }
    }

    static fromJS(data: any): LastRunInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new LastRunInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fired"] = this.fired ? this.fired.toString() : <any>undefined;
        data["successful"] = this.successful;
        data["exception"] = this.exception;
        return data;
    }
}

export interface ILastRunInfoDto {
    fired: DateTime;
    successful: boolean;
    exception: any | undefined;
}

export enum JobOutputFileType {
    MedRegTransmission = 0,
    PsyRegTransmission = 1,
    NaregTransmission = 2,
}

export class CreateOrUpdateLiaAcademicTitleInput implements ICreateOrUpdateLiaAcademicTitleInput {
    caseId!: string;
    liaAcademicTitles!: LiaAcademicTitleDto[];

    constructor(data?: ICreateOrUpdateLiaAcademicTitleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.liaAcademicTitles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["liaAcademicTitles"])) {
                this.liaAcademicTitles = [] as any;
                for (let item of _data["liaAcademicTitles"])
                    this.liaAcademicTitles!.push(LiaAcademicTitleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateLiaAcademicTitleInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLiaAcademicTitleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.liaAcademicTitles)) {
            data["liaAcademicTitles"] = [];
            for (let item of this.liaAcademicTitles)
                data["liaAcademicTitles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateLiaAcademicTitleInput {
    caseId: string;
    liaAcademicTitles: LiaAcademicTitleDto[];
}

export class CreateOrUpdateLiaAcademicTitleOutput implements ICreateOrUpdateLiaAcademicTitleOutput {
    status!: LiaStatus;
    liaAcademicTitles!: LiaAcademicTitleDto[] | undefined;

    constructor(data?: ICreateOrUpdateLiaAcademicTitleOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["liaAcademicTitles"])) {
                this.liaAcademicTitles = [] as any;
                for (let item of _data["liaAcademicTitles"])
                    this.liaAcademicTitles!.push(LiaAcademicTitleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateLiaAcademicTitleOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLiaAcademicTitleOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.liaAcademicTitles)) {
            data["liaAcademicTitles"] = [];
            for (let item of this.liaAcademicTitles)
                data["liaAcademicTitles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateLiaAcademicTitleOutput {
    status: LiaStatus;
    liaAcademicTitles: LiaAcademicTitleDto[] | undefined;
}

export class LiaAcademicTitleDto implements ILiaAcademicTitleDto {
    id!: string;
    liaApplicationId!: number;
    title!: string | undefined;
    bodyOfIssue!: string | undefined;
    placeOfIssue!: string | undefined;
    countryId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfRecognition!: DateTime | undefined;

    constructor(data?: ILiaAcademicTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.liaApplicationId = _data["liaApplicationId"];
            this.title = _data["title"];
            this.bodyOfIssue = _data["bodyOfIssue"];
            this.placeOfIssue = _data["placeOfIssue"];
            this.countryId = _data["countryId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfRecognition = _data["dateOfRecognition"] ? DateTime.fromISO(_data["dateOfRecognition"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): LiaAcademicTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiaAcademicTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["liaApplicationId"] = this.liaApplicationId;
        data["title"] = this.title;
        data["bodyOfIssue"] = this.bodyOfIssue;
        data["placeOfIssue"] = this.placeOfIssue;
        data["countryId"] = this.countryId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfRecognition"] = this.dateOfRecognition ? this.dateOfRecognition.toFormat('yyyy-MM-dd') : <any>undefined;
        return data;
    }
}

export interface ILiaAcademicTitleDto {
    id: string;
    liaApplicationId: number;
    title: string | undefined;
    bodyOfIssue: string | undefined;
    placeOfIssue: string | undefined;
    countryId: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfRecognition: DateTime | undefined;
}

export class LiaAcademicTitlesOutput implements ILiaAcademicTitlesOutput {
    titles!: LiaAcademicTitleDto[] | undefined;
    documents!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: ILiaAcademicTitlesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(LiaAcademicTitleDto.fromJS(item));
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LiaAcademicTitlesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new LiaAcademicTitlesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item.toJSON());
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILiaAcademicTitlesOutput {
    titles: LiaAcademicTitleDto[] | undefined;
    documents: GeneralDocumentGroupDto[] | undefined;
}

export class CreateOrUpdateLiaContactDuringEmploymentInput implements ICreateOrUpdateLiaContactDuringEmploymentInput {
    caseId!: string;
    liaContactDuringEmployment!: LiaContactDuringEmploymentDto;

    constructor(data?: ICreateOrUpdateLiaContactDuringEmploymentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.liaContactDuringEmployment = new LiaContactDuringEmploymentDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.liaContactDuringEmployment = _data["liaContactDuringEmployment"] ? LiaContactDuringEmploymentDto.fromJS(_data["liaContactDuringEmployment"]) : new LiaContactDuringEmploymentDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateLiaContactDuringEmploymentInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLiaContactDuringEmploymentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["liaContactDuringEmployment"] = this.liaContactDuringEmployment ? this.liaContactDuringEmployment.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateLiaContactDuringEmploymentInput {
    caseId: string;
    liaContactDuringEmployment: LiaContactDuringEmploymentDto;
}

export class CreateOrUpdateLiaContactInput implements ICreateOrUpdateLiaContactInput {
    caseId!: string;
    liaContact!: LiaContactDto;

    constructor(data?: ICreateOrUpdateLiaContactInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.liaContact = new LiaContactDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.liaContact = _data["liaContact"] ? LiaContactDto.fromJS(_data["liaContact"]) : new LiaContactDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateLiaContactInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLiaContactInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["liaContact"] = this.liaContact ? this.liaContact.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateLiaContactInput {
    caseId: string;
    liaContact: LiaContactDto;
}

export class LiaContactDto implements ILiaContactDto {
    titleId!: string | undefined;
    languageOfCorrespondenceId!: string | undefined;
    street!: string;
    streetNr!: string | undefined;
    postCode!: string;
    city!: string;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    email!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    countryId!: string | undefined;
    titleAddressSwiss!: string | undefined;
    streetSwiss!: string | undefined;
    streetNrSwiss!: string | undefined;
    postCodeSwiss!: string | undefined;
    citySwiss!: string | undefined;
    postOfficeBoxSwiss!: string | undefined;
    addressAdditionSwiss!: string | undefined;

    constructor(data?: ILiaContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.email = _data["email"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.countryId = _data["countryId"];
            this.titleAddressSwiss = _data["titleAddressSwiss"];
            this.streetSwiss = _data["streetSwiss"];
            this.streetNrSwiss = _data["streetNrSwiss"];
            this.postCodeSwiss = _data["postCodeSwiss"];
            this.citySwiss = _data["citySwiss"];
            this.postOfficeBoxSwiss = _data["postOfficeBoxSwiss"];
            this.addressAdditionSwiss = _data["addressAdditionSwiss"];
        }
    }

    static fromJS(data: any): LiaContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiaContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["email"] = this.email;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["countryId"] = this.countryId;
        data["titleAddressSwiss"] = this.titleAddressSwiss;
        data["streetSwiss"] = this.streetSwiss;
        data["streetNrSwiss"] = this.streetNrSwiss;
        data["postCodeSwiss"] = this.postCodeSwiss;
        data["citySwiss"] = this.citySwiss;
        data["postOfficeBoxSwiss"] = this.postOfficeBoxSwiss;
        data["addressAdditionSwiss"] = this.addressAdditionSwiss;
        return data;
    }
}

export interface ILiaContactDto {
    titleId: string | undefined;
    languageOfCorrespondenceId: string | undefined;
    street: string;
    streetNr: string | undefined;
    postCode: string;
    city: string;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    email: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    countryId: string | undefined;
    titleAddressSwiss: string | undefined;
    streetSwiss: string | undefined;
    streetNrSwiss: string | undefined;
    postCodeSwiss: string | undefined;
    citySwiss: string | undefined;
    postOfficeBoxSwiss: string | undefined;
    addressAdditionSwiss: string | undefined;
}

export class LiaContactDuringEmploymentDto implements ILiaContactDuringEmploymentDto {
    languageOfCorrespondenceId!: string | undefined;
    street!: string;
    streetNr!: string | undefined;
    postCode!: string;
    city!: string;
    postOfficeBox!: string | undefined;
    email!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    countryId!: string | undefined;

    constructor(data?: ILiaContactDuringEmploymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.email = _data["email"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.countryId = _data["countryId"];
        }
    }

    static fromJS(data: any): LiaContactDuringEmploymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiaContactDuringEmploymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["postOfficeBox"] = this.postOfficeBox;
        data["email"] = this.email;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["countryId"] = this.countryId;
        return data;
    }
}

export interface ILiaContactDuringEmploymentDto {
    languageOfCorrespondenceId: string | undefined;
    street: string;
    streetNr: string | undefined;
    postCode: string;
    city: string;
    postOfficeBox: string | undefined;
    email: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    countryId: string | undefined;
}

export class CreateOrUpdateLiaDiplomaInput implements ICreateOrUpdateLiaDiplomaInput {
    caseId!: string;
    liaDiploma!: LiaDiplomaDto;

    constructor(data?: ICreateOrUpdateLiaDiplomaInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.liaDiploma = new LiaDiplomaDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.liaDiploma = _data["liaDiploma"] ? LiaDiplomaDto.fromJS(_data["liaDiploma"]) : new LiaDiplomaDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateLiaDiplomaInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLiaDiplomaInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["liaDiploma"] = this.liaDiploma ? this.liaDiploma.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateLiaDiplomaInput {
    caseId: string;
    liaDiploma: LiaDiplomaDto;
}

export class LiaDiplomaDto implements ILiaDiplomaDto {
    professionId!: string;
    typeId!: string;
    placeOfIssue!: string | undefined;
    countryId!: string;
    dateOfIssue!: DateTime | undefined;
    dateOfRecognition!: DateTime | undefined;

    constructor(data?: ILiaDiplomaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professionId = _data["professionId"];
            this.typeId = _data["typeId"];
            this.placeOfIssue = _data["placeOfIssue"];
            this.countryId = _data["countryId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfRecognition = _data["dateOfRecognition"] ? DateTime.fromISO(_data["dateOfRecognition"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): LiaDiplomaDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiaDiplomaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professionId"] = this.professionId;
        data["typeId"] = this.typeId;
        data["placeOfIssue"] = this.placeOfIssue;
        data["countryId"] = this.countryId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfRecognition"] = this.dateOfRecognition ? this.dateOfRecognition.toFormat('yyyy-MM-dd') : <any>undefined;
        return data;
    }
}

export interface ILiaDiplomaDto {
    professionId: string;
    typeId: string;
    placeOfIssue: string | undefined;
    countryId: string;
    dateOfIssue: DateTime | undefined;
    dateOfRecognition: DateTime | undefined;
}

export class LiaDocumentsOutput implements ILiaDocumentsOutput {
    caseId!: string;
    liaDocuments!: GeneralDocumentGroupDto[];

    constructor(data?: ILiaDocumentsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.liaDocuments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["liaDocuments"])) {
                this.liaDocuments = [] as any;
                for (let item of _data["liaDocuments"])
                    this.liaDocuments!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LiaDocumentsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new LiaDocumentsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.liaDocuments)) {
            data["liaDocuments"] = [];
            for (let item of this.liaDocuments)
                data["liaDocuments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILiaDocumentsOutput {
    caseId: string;
    liaDocuments: GeneralDocumentGroupDto[];
}

export class GetLiaOutput implements IGetLiaOutput {
    lia!: LiaDto;

    constructor(data?: IGetLiaOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lia = _data["lia"] ? LiaDto.fromJS(_data["lia"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetLiaOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLiaOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lia"] = this.lia ? this.lia.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetLiaOutput {
    lia: LiaDto;
}

export class LiaDto implements ILiaDto {
    application!: ApplicationDto;
    professionId!: string | undefined;
    currentStep!: LiaStatus;
    liaPerson!: LiaPersonDto;
    liaContact!: LiaContactDto;
    liaLanguageSkill!: LiaLanguageSkillDto;
    liaDiploma!: LiaDiplomaDto;
    liaAcademicTitles!: LiaAcademicTitlesOutput;
    liaGuaranteeOutput!: LiaGuaranteeOutput;
    liaRestrictions!: LiaRestrictionOutput;
    liaRestrictionB!: LiaRestrictionBDto;
    liaEmploymentB!: LiaEmploymentBDto;
    liaInvoiceAddress!: LiaInvoiceAddressDto;
    liaPostgraduateTitleOutput!: LiaPostgraduateTitleOutput;
    liaPostgraduateTitlePrivateLawOutput!: LiaPostgraduateTitlePrivateLawOutput;
    liaPreviousEmployment!: LiaPreviousEmploymentDto;
    liaLanguageSkillB!: LiaLanguageSkillBDto;
    liaLicenceInAnotherCanton!: LiaLicenceInAnotherCantonDto;
    liaVaccination!: LiaVaccinationOutputDto;
    liaContactDuringEmployment!: LiaContactDuringEmploymentDto;
    liaProfessionalResponsibilityOutput!: LiaProfessionalResponsibilityOutput;
    liaDocuments!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: ILiaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationDto.fromJS(_data["application"]) : <any>undefined;
            this.professionId = _data["professionId"];
            this.currentStep = _data["currentStep"];
            this.liaPerson = _data["liaPerson"] ? LiaPersonDto.fromJS(_data["liaPerson"]) : <any>undefined;
            this.liaContact = _data["liaContact"] ? LiaContactDto.fromJS(_data["liaContact"]) : <any>undefined;
            this.liaLanguageSkill = _data["liaLanguageSkill"] ? LiaLanguageSkillDto.fromJS(_data["liaLanguageSkill"]) : <any>undefined;
            this.liaDiploma = _data["liaDiploma"] ? LiaDiplomaDto.fromJS(_data["liaDiploma"]) : <any>undefined;
            this.liaAcademicTitles = _data["liaAcademicTitles"] ? LiaAcademicTitlesOutput.fromJS(_data["liaAcademicTitles"]) : <any>undefined;
            this.liaGuaranteeOutput = _data["liaGuaranteeOutput"] ? LiaGuaranteeOutput.fromJS(_data["liaGuaranteeOutput"]) : <any>undefined;
            this.liaRestrictions = _data["liaRestrictions"] ? LiaRestrictionOutput.fromJS(_data["liaRestrictions"]) : <any>undefined;
            this.liaRestrictionB = _data["liaRestrictionB"] ? LiaRestrictionBDto.fromJS(_data["liaRestrictionB"]) : <any>undefined;
            this.liaEmploymentB = _data["liaEmploymentB"] ? LiaEmploymentBDto.fromJS(_data["liaEmploymentB"]) : <any>undefined;
            this.liaInvoiceAddress = _data["liaInvoiceAddress"] ? LiaInvoiceAddressDto.fromJS(_data["liaInvoiceAddress"]) : <any>undefined;
            this.liaPostgraduateTitleOutput = _data["liaPostgraduateTitleOutput"] ? LiaPostgraduateTitleOutput.fromJS(_data["liaPostgraduateTitleOutput"]) : <any>undefined;
            this.liaPostgraduateTitlePrivateLawOutput = _data["liaPostgraduateTitlePrivateLawOutput"] ? LiaPostgraduateTitlePrivateLawOutput.fromJS(_data["liaPostgraduateTitlePrivateLawOutput"]) : <any>undefined;
            this.liaPreviousEmployment = _data["liaPreviousEmployment"] ? LiaPreviousEmploymentDto.fromJS(_data["liaPreviousEmployment"]) : <any>undefined;
            this.liaLanguageSkillB = _data["liaLanguageSkillB"] ? LiaLanguageSkillBDto.fromJS(_data["liaLanguageSkillB"]) : <any>undefined;
            this.liaLicenceInAnotherCanton = _data["liaLicenceInAnotherCanton"] ? LiaLicenceInAnotherCantonDto.fromJS(_data["liaLicenceInAnotherCanton"]) : <any>undefined;
            this.liaVaccination = _data["liaVaccination"] ? LiaVaccinationOutputDto.fromJS(_data["liaVaccination"]) : <any>undefined;
            this.liaContactDuringEmployment = _data["liaContactDuringEmployment"] ? LiaContactDuringEmploymentDto.fromJS(_data["liaContactDuringEmployment"]) : <any>undefined;
            this.liaProfessionalResponsibilityOutput = _data["liaProfessionalResponsibilityOutput"] ? LiaProfessionalResponsibilityOutput.fromJS(_data["liaProfessionalResponsibilityOutput"]) : <any>undefined;
            if (Array.isArray(_data["liaDocuments"])) {
                this.liaDocuments = [] as any;
                for (let item of _data["liaDocuments"])
                    this.liaDocuments!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LiaDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["professionId"] = this.professionId;
        data["currentStep"] = this.currentStep;
        data["liaPerson"] = this.liaPerson ? this.liaPerson.toJSON() : <any>undefined;
        data["liaContact"] = this.liaContact ? this.liaContact.toJSON() : <any>undefined;
        data["liaLanguageSkill"] = this.liaLanguageSkill ? this.liaLanguageSkill.toJSON() : <any>undefined;
        data["liaDiploma"] = this.liaDiploma ? this.liaDiploma.toJSON() : <any>undefined;
        data["liaAcademicTitles"] = this.liaAcademicTitles ? this.liaAcademicTitles.toJSON() : <any>undefined;
        data["liaGuaranteeOutput"] = this.liaGuaranteeOutput ? this.liaGuaranteeOutput.toJSON() : <any>undefined;
        data["liaRestrictions"] = this.liaRestrictions ? this.liaRestrictions.toJSON() : <any>undefined;
        data["liaRestrictionB"] = this.liaRestrictionB ? this.liaRestrictionB.toJSON() : <any>undefined;
        data["liaEmploymentB"] = this.liaEmploymentB ? this.liaEmploymentB.toJSON() : <any>undefined;
        data["liaInvoiceAddress"] = this.liaInvoiceAddress ? this.liaInvoiceAddress.toJSON() : <any>undefined;
        data["liaPostgraduateTitleOutput"] = this.liaPostgraduateTitleOutput ? this.liaPostgraduateTitleOutput.toJSON() : <any>undefined;
        data["liaPostgraduateTitlePrivateLawOutput"] = this.liaPostgraduateTitlePrivateLawOutput ? this.liaPostgraduateTitlePrivateLawOutput.toJSON() : <any>undefined;
        data["liaPreviousEmployment"] = this.liaPreviousEmployment ? this.liaPreviousEmployment.toJSON() : <any>undefined;
        data["liaLanguageSkillB"] = this.liaLanguageSkillB ? this.liaLanguageSkillB.toJSON() : <any>undefined;
        data["liaLicenceInAnotherCanton"] = this.liaLicenceInAnotherCanton ? this.liaLicenceInAnotherCanton.toJSON() : <any>undefined;
        data["liaVaccination"] = this.liaVaccination ? this.liaVaccination.toJSON() : <any>undefined;
        data["liaContactDuringEmployment"] = this.liaContactDuringEmployment ? this.liaContactDuringEmployment.toJSON() : <any>undefined;
        data["liaProfessionalResponsibilityOutput"] = this.liaProfessionalResponsibilityOutput ? this.liaProfessionalResponsibilityOutput.toJSON() : <any>undefined;
        if (Array.isArray(this.liaDocuments)) {
            data["liaDocuments"] = [];
            for (let item of this.liaDocuments)
                data["liaDocuments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILiaDto {
    application: ApplicationDto;
    professionId: string | undefined;
    currentStep: LiaStatus;
    liaPerson: LiaPersonDto;
    liaContact: LiaContactDto;
    liaLanguageSkill: LiaLanguageSkillDto;
    liaDiploma: LiaDiplomaDto;
    liaAcademicTitles: LiaAcademicTitlesOutput;
    liaGuaranteeOutput: LiaGuaranteeOutput;
    liaRestrictions: LiaRestrictionOutput;
    liaRestrictionB: LiaRestrictionBDto;
    liaEmploymentB: LiaEmploymentBDto;
    liaInvoiceAddress: LiaInvoiceAddressDto;
    liaPostgraduateTitleOutput: LiaPostgraduateTitleOutput;
    liaPostgraduateTitlePrivateLawOutput: LiaPostgraduateTitlePrivateLawOutput;
    liaPreviousEmployment: LiaPreviousEmploymentDto;
    liaLanguageSkillB: LiaLanguageSkillBDto;
    liaLicenceInAnotherCanton: LiaLicenceInAnotherCantonDto;
    liaVaccination: LiaVaccinationOutputDto;
    liaContactDuringEmployment: LiaContactDuringEmploymentDto;
    liaProfessionalResponsibilityOutput: LiaProfessionalResponsibilityOutput;
    liaDocuments: GeneralDocumentGroupDto[] | undefined;
}

export class LiaSummaryDto implements ILiaSummaryDto {
    applicationType!: ApplicationType;
    applicationStatus!: ApplicationStatus;
    dateOfStatusChange!: DateTime;
    caseId!: string | undefined;
    professionId!: string | undefined;

    constructor(data?: ILiaSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationType = _data["applicationType"];
            this.applicationStatus = _data["applicationStatus"];
            this.dateOfStatusChange = _data["dateOfStatusChange"] ? DateTime.fromISO(_data["dateOfStatusChange"].toString()) : <any>undefined;
            this.caseId = _data["caseId"];
            this.professionId = _data["professionId"];
        }
    }

    static fromJS(data: any): LiaSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiaSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationType"] = this.applicationType;
        data["applicationStatus"] = this.applicationStatus;
        data["dateOfStatusChange"] = this.dateOfStatusChange ? this.dateOfStatusChange.toString() : <any>undefined;
        data["caseId"] = this.caseId;
        data["professionId"] = this.professionId;
        return data;
    }
}

export interface ILiaSummaryDto {
    applicationType: ApplicationType;
    applicationStatus: ApplicationStatus;
    dateOfStatusChange: DateTime;
    caseId: string | undefined;
    professionId: string | undefined;
}

export class ApplicationEmploymentPersonDto implements IApplicationEmploymentPersonDto {
    employmentId!: number | undefined;
    expenseHealthCareCorporateLicenceEmploymentId!: number | undefined;
    gln!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    id!: number;

    constructor(data?: IApplicationEmploymentPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employmentId = _data["employmentId"];
            this.expenseHealthCareCorporateLicenceEmploymentId = _data["expenseHealthCareCorporateLicenceEmploymentId"];
            this.gln = _data["gln"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ApplicationEmploymentPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationEmploymentPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employmentId"] = this.employmentId;
        data["expenseHealthCareCorporateLicenceEmploymentId"] = this.expenseHealthCareCorporateLicenceEmploymentId;
        data["gln"] = this.gln;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["id"] = this.id;
        return data;
    }
}

export interface IApplicationEmploymentPersonDto {
    employmentId: number | undefined;
    expenseHealthCareCorporateLicenceEmploymentId: number | undefined;
    gln: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    id: number;
}

export class CreateOrUpdateLiaEmploymentBInput implements ICreateOrUpdateLiaEmploymentBInput {
    caseId!: string;
    liaEmploymentB!: LiaEmploymentBDto;

    constructor(data?: ICreateOrUpdateLiaEmploymentBInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.liaEmploymentB = new LiaEmploymentBDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.liaEmploymentB = _data["liaEmploymentB"] ? LiaEmploymentBDto.fromJS(_data["liaEmploymentB"]) : new LiaEmploymentBDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateLiaEmploymentBInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLiaEmploymentBInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["liaEmploymentB"] = this.liaEmploymentB ? this.liaEmploymentB.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateLiaEmploymentBInput {
    caseId: string;
    liaEmploymentB: LiaEmploymentBDto;
}

export class LiaEmploymentBDto implements ILiaEmploymentBDto {
    isEmploymentAddressKnownId!: string | undefined;
    hasMobileEmployment!: boolean;
    employmentRecords!: LiaEmploymentBRecordDto[] | undefined;
    employmentDocuments!: GeneralDocumentGroupDto[] | undefined;
    employmentRecordDocuments!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: ILiaEmploymentBDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEmploymentAddressKnownId = _data["isEmploymentAddressKnownId"];
            this.hasMobileEmployment = _data["hasMobileEmployment"];
            if (Array.isArray(_data["employmentRecords"])) {
                this.employmentRecords = [] as any;
                for (let item of _data["employmentRecords"])
                    this.employmentRecords!.push(LiaEmploymentBRecordDto.fromJS(item));
            }
            if (Array.isArray(_data["employmentDocuments"])) {
                this.employmentDocuments = [] as any;
                for (let item of _data["employmentDocuments"])
                    this.employmentDocuments!.push(GeneralDocumentGroupDto.fromJS(item));
            }
            if (Array.isArray(_data["employmentRecordDocuments"])) {
                this.employmentRecordDocuments = [] as any;
                for (let item of _data["employmentRecordDocuments"])
                    this.employmentRecordDocuments!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LiaEmploymentBDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiaEmploymentBDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEmploymentAddressKnownId"] = this.isEmploymentAddressKnownId;
        data["hasMobileEmployment"] = this.hasMobileEmployment;
        if (Array.isArray(this.employmentRecords)) {
            data["employmentRecords"] = [];
            for (let item of this.employmentRecords)
                data["employmentRecords"].push(item.toJSON());
        }
        if (Array.isArray(this.employmentDocuments)) {
            data["employmentDocuments"] = [];
            for (let item of this.employmentDocuments)
                data["employmentDocuments"].push(item.toJSON());
        }
        if (Array.isArray(this.employmentRecordDocuments)) {
            data["employmentRecordDocuments"] = [];
            for (let item of this.employmentRecordDocuments)
                data["employmentRecordDocuments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILiaEmploymentBDto {
    isEmploymentAddressKnownId: string | undefined;
    hasMobileEmployment: boolean;
    employmentRecords: LiaEmploymentBRecordDto[] | undefined;
    employmentDocuments: GeneralDocumentGroupDto[] | undefined;
    employmentRecordDocuments: GeneralDocumentGroupDto[] | undefined;
}

export class LiaEmploymentBRecordDto implements ILiaEmploymentBRecordDto {
    liaApplicationId!: number;
    typeId!: string | undefined;
    businessName!: string | undefined;
    additionalName!: string | undefined;
    legalFormId!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    phone!: string | undefined;
    email!: string | undefined;
    website!: string | undefined;
    roleText!: string | undefined;
    dateOfEmployment!: DateTime | undefined;
    dateOfEndOfEmployment!: DateTime | undefined;
    isEmploymentStartUnknown!: boolean;
    levelOfEmployment!: number | undefined;
    medicalPracticeTakeoverDetails!: string | undefined;
    medicalGroupPracticeDetails!: string | undefined;
    requestVaccinationLicenceId!: string | undefined;
    hasPaediatricsAndAdolescentMedicine!: boolean | undefined;
    isMedicalFieldDirectorId!: string | undefined;
    id!: string;

    constructor(data?: ILiaEmploymentBRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.liaApplicationId = _data["liaApplicationId"];
            this.typeId = _data["typeId"];
            this.businessName = _data["businessName"];
            this.additionalName = _data["additionalName"];
            this.legalFormId = _data["legalFormId"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.website = _data["website"];
            this.roleText = _data["roleText"];
            this.dateOfEmployment = _data["dateOfEmployment"] ? DateTime.fromISO(_data["dateOfEmployment"].toString()) : <any>undefined;
            this.dateOfEndOfEmployment = _data["dateOfEndOfEmployment"] ? DateTime.fromISO(_data["dateOfEndOfEmployment"].toString()) : <any>undefined;
            this.isEmploymentStartUnknown = _data["isEmploymentStartUnknown"];
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.medicalPracticeTakeoverDetails = _data["medicalPracticeTakeoverDetails"];
            this.medicalGroupPracticeDetails = _data["medicalGroupPracticeDetails"];
            this.requestVaccinationLicenceId = _data["requestVaccinationLicenceId"];
            this.hasPaediatricsAndAdolescentMedicine = _data["hasPaediatricsAndAdolescentMedicine"];
            this.isMedicalFieldDirectorId = _data["isMedicalFieldDirectorId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LiaEmploymentBRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiaEmploymentBRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["liaApplicationId"] = this.liaApplicationId;
        data["typeId"] = this.typeId;
        data["businessName"] = this.businessName;
        data["additionalName"] = this.additionalName;
        data["legalFormId"] = this.legalFormId;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["website"] = this.website;
        data["roleText"] = this.roleText;
        data["dateOfEmployment"] = this.dateOfEmployment ? this.dateOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEndOfEmployment"] = this.dateOfEndOfEmployment ? this.dateOfEndOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["isEmploymentStartUnknown"] = this.isEmploymentStartUnknown;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["medicalPracticeTakeoverDetails"] = this.medicalPracticeTakeoverDetails;
        data["medicalGroupPracticeDetails"] = this.medicalGroupPracticeDetails;
        data["requestVaccinationLicenceId"] = this.requestVaccinationLicenceId;
        data["hasPaediatricsAndAdolescentMedicine"] = this.hasPaediatricsAndAdolescentMedicine;
        data["isMedicalFieldDirectorId"] = this.isMedicalFieldDirectorId;
        data["id"] = this.id;
        return data;
    }
}

export interface ILiaEmploymentBRecordDto {
    liaApplicationId: number;
    typeId: string | undefined;
    businessName: string | undefined;
    additionalName: string | undefined;
    legalFormId: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    phone: string | undefined;
    email: string | undefined;
    website: string | undefined;
    roleText: string | undefined;
    dateOfEmployment: DateTime | undefined;
    dateOfEndOfEmployment: DateTime | undefined;
    isEmploymentStartUnknown: boolean;
    levelOfEmployment: number | undefined;
    medicalPracticeTakeoverDetails: string | undefined;
    medicalGroupPracticeDetails: string | undefined;
    requestVaccinationLicenceId: string | undefined;
    hasPaediatricsAndAdolescentMedicine: boolean | undefined;
    isMedicalFieldDirectorId: string | undefined;
    id: string;
}

export class EmploymentAddressDto implements IEmploymentAddressDto {
    employmentId!: number | undefined;
    expenseHealthCarePersonalLicenceEmploymentId!: number | undefined;
    statusId!: string | undefined;
    typeId!: string | undefined;
    businessName!: string | undefined;
    gln!: string | undefined;
    bur!: string | undefined;
    additionalName!: string | undefined;
    legalFormId!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    postOfficeBox!: string | undefined;
    addressSupplement!: string | undefined;
    countryId!: string | undefined;
    phone!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    website!: string | undefined;
    dateOfOpening!: DateTime | undefined;
    dateOfClosure!: DateTime | undefined;
    businessHours!: string | undefined;
    medicalPracticeTakeoverDetails!: string | undefined;
    medicalGroupPracticeDetails!: string | undefined;
    comments!: string | undefined;
    id!: number;

    constructor(data?: IEmploymentAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employmentId = _data["employmentId"];
            this.expenseHealthCarePersonalLicenceEmploymentId = _data["expenseHealthCarePersonalLicenceEmploymentId"];
            this.statusId = _data["statusId"];
            this.typeId = _data["typeId"];
            this.businessName = _data["businessName"];
            this.gln = _data["gln"];
            this.bur = _data["bur"];
            this.additionalName = _data["additionalName"];
            this.legalFormId = _data["legalFormId"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressSupplement = _data["addressSupplement"];
            this.countryId = _data["countryId"];
            this.phone = _data["phone"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.website = _data["website"];
            this.dateOfOpening = _data["dateOfOpening"] ? DateTime.fromISO(_data["dateOfOpening"].toString()) : <any>undefined;
            this.dateOfClosure = _data["dateOfClosure"] ? DateTime.fromISO(_data["dateOfClosure"].toString()) : <any>undefined;
            this.businessHours = _data["businessHours"];
            this.medicalPracticeTakeoverDetails = _data["medicalPracticeTakeoverDetails"];
            this.medicalGroupPracticeDetails = _data["medicalGroupPracticeDetails"];
            this.comments = _data["comments"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EmploymentAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmploymentAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employmentId"] = this.employmentId;
        data["expenseHealthCarePersonalLicenceEmploymentId"] = this.expenseHealthCarePersonalLicenceEmploymentId;
        data["statusId"] = this.statusId;
        data["typeId"] = this.typeId;
        data["businessName"] = this.businessName;
        data["gln"] = this.gln;
        data["bur"] = this.bur;
        data["additionalName"] = this.additionalName;
        data["legalFormId"] = this.legalFormId;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressSupplement"] = this.addressSupplement;
        data["countryId"] = this.countryId;
        data["phone"] = this.phone;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["website"] = this.website;
        data["dateOfOpening"] = this.dateOfOpening ? this.dateOfOpening.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfClosure"] = this.dateOfClosure ? this.dateOfClosure.toFormat('yyyy-MM-dd') : <any>undefined;
        data["businessHours"] = this.businessHours;
        data["medicalPracticeTakeoverDetails"] = this.medicalPracticeTakeoverDetails;
        data["medicalGroupPracticeDetails"] = this.medicalGroupPracticeDetails;
        data["comments"] = this.comments;
        data["id"] = this.id;
        return data;
    }
}

export interface IEmploymentAddressDto {
    employmentId: number | undefined;
    expenseHealthCarePersonalLicenceEmploymentId: number | undefined;
    statusId: string | undefined;
    typeId: string | undefined;
    businessName: string | undefined;
    gln: string | undefined;
    bur: string | undefined;
    additionalName: string | undefined;
    legalFormId: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    postOfficeBox: string | undefined;
    addressSupplement: string | undefined;
    countryId: string | undefined;
    phone: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    website: string | undefined;
    dateOfOpening: DateTime | undefined;
    dateOfClosure: DateTime | undefined;
    businessHours: string | undefined;
    medicalPracticeTakeoverDetails: string | undefined;
    medicalGroupPracticeDetails: string | undefined;
    comments: string | undefined;
    id: number;
}

export class LiaGuaranteeOutput implements ILiaGuaranteeOutput {
    documents!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: ILiaGuaranteeOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LiaGuaranteeOutput {
        data = typeof data === 'object' ? data : {};
        let result = new LiaGuaranteeOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILiaGuaranteeOutput {
    documents: GeneralDocumentGroupDto[] | undefined;
}

export class LiaProfessionalResponsibilityOutput implements ILiaProfessionalResponsibilityOutput {
    documents!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: ILiaProfessionalResponsibilityOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LiaProfessionalResponsibilityOutput {
        data = typeof data === 'object' ? data : {};
        let result = new LiaProfessionalResponsibilityOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILiaProfessionalResponsibilityOutput {
    documents: GeneralDocumentGroupDto[] | undefined;
}

export enum HealthRegisterIdentificationStatus {
    None = 0,
    Ok = 1,
    NotFound = 2,
    NoDiploma = 4,
    HasLicenceInThisCanton = 8,
    HasLicenceInAnotherCanton = 16,
    HasNoLanguageSkill = 32,
    HasNoLicenceInThisCanton = 64,
    NoPostgraduateTitle = 128,
}

export class CreateOrUpdateLiaInvoiceAddressInput implements ICreateOrUpdateLiaInvoiceAddressInput {
    caseId!: string;
    liaInvoiceAddress!: LiaInvoiceAddressDto;

    constructor(data?: ICreateOrUpdateLiaInvoiceAddressInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.liaInvoiceAddress = new LiaInvoiceAddressDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.liaInvoiceAddress = _data["liaInvoiceAddress"] ? LiaInvoiceAddressDto.fromJS(_data["liaInvoiceAddress"]) : new LiaInvoiceAddressDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateLiaInvoiceAddressInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLiaInvoiceAddressInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["liaInvoiceAddress"] = this.liaInvoiceAddress ? this.liaInvoiceAddress.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateLiaInvoiceAddressInput {
    caseId: string;
    liaInvoiceAddress: LiaInvoiceAddressDto;
}

export class LiaInvoiceAddressDto implements ILiaInvoiceAddressDto {
    typeOfAddressId!: string | undefined;
    liaEmploymentBRecordId!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    languageOfCorrespondenceId!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    countryId!: string | undefined;
    email!: string | undefined;
    completionStatus!: CompletionStatus;

    constructor(data?: ILiaInvoiceAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeOfAddressId = _data["typeOfAddressId"];
            this.liaEmploymentBRecordId = _data["liaEmploymentBRecordId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.countryId = _data["countryId"];
            this.email = _data["email"];
            this.completionStatus = _data["completionStatus"];
        }
    }

    static fromJS(data: any): LiaInvoiceAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiaInvoiceAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeOfAddressId"] = this.typeOfAddressId;
        data["liaEmploymentBRecordId"] = this.liaEmploymentBRecordId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["countryId"] = this.countryId;
        data["email"] = this.email;
        data["completionStatus"] = this.completionStatus;
        return data;
    }
}

export interface ILiaInvoiceAddressDto {
    typeOfAddressId: string | undefined;
    liaEmploymentBRecordId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    languageOfCorrespondenceId: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    countryId: string | undefined;
    email: string | undefined;
    completionStatus: CompletionStatus;
}

export class CreateOrUpdateLiaLanguageSkillInput implements ICreateOrUpdateLiaLanguageSkillInput {
    caseId!: string | undefined;
    liaLanguageSkill!: LiaLanguageSkillDto;

    constructor(data?: ICreateOrUpdateLiaLanguageSkillInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.liaLanguageSkill = _data["liaLanguageSkill"] ? LiaLanguageSkillDto.fromJS(_data["liaLanguageSkill"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrUpdateLiaLanguageSkillInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLiaLanguageSkillInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["liaLanguageSkill"] = this.liaLanguageSkill ? this.liaLanguageSkill.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateLiaLanguageSkillInput {
    caseId: string | undefined;
    liaLanguageSkill: LiaLanguageSkillDto;
}

export class LiaLanguageSkillDto implements ILiaLanguageSkillDto {
    languageSkillId!: string;
    educationLanguageId!: string | undefined;
    comments!: string | undefined;
    languageSkillDocuments!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: ILiaLanguageSkillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageSkillId = _data["languageSkillId"];
            this.educationLanguageId = _data["educationLanguageId"];
            this.comments = _data["comments"];
            if (Array.isArray(_data["languageSkillDocuments"])) {
                this.languageSkillDocuments = [] as any;
                for (let item of _data["languageSkillDocuments"])
                    this.languageSkillDocuments!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LiaLanguageSkillDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiaLanguageSkillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageSkillId"] = this.languageSkillId;
        data["educationLanguageId"] = this.educationLanguageId;
        data["comments"] = this.comments;
        if (Array.isArray(this.languageSkillDocuments)) {
            data["languageSkillDocuments"] = [];
            for (let item of this.languageSkillDocuments)
                data["languageSkillDocuments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILiaLanguageSkillDto {
    languageSkillId: string;
    educationLanguageId: string | undefined;
    comments: string | undefined;
    languageSkillDocuments: GeneralDocumentGroupDto[] | undefined;
}

export class CreateOrUpdateLiaLanguageSkillBInput implements ICreateOrUpdateLiaLanguageSkillBInput {
    caseId!: string | undefined;
    liaLanguageSkillB!: LiaLanguageSkillBDto;

    constructor(data?: ICreateOrUpdateLiaLanguageSkillBInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.liaLanguageSkillB = _data["liaLanguageSkillB"] ? LiaLanguageSkillBDto.fromJS(_data["liaLanguageSkillB"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrUpdateLiaLanguageSkillBInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLiaLanguageSkillBInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["liaLanguageSkillB"] = this.liaLanguageSkillB ? this.liaLanguageSkillB.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateLiaLanguageSkillBInput {
    caseId: string | undefined;
    liaLanguageSkillB: LiaLanguageSkillBDto;
}

export class LiaLanguageSkillBDto implements ILiaLanguageSkillBDto {
    hasLanguageSkillId!: string;
    languageSkillBDocuments!: GeneralDocumentGroupDto[] | undefined;
    hasLanguageRecordInExternalRegister!: boolean;
    languageSkillLevelId!: string | undefined;

    constructor(data?: ILiaLanguageSkillBDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasLanguageSkillId = _data["hasLanguageSkillId"];
            if (Array.isArray(_data["languageSkillBDocuments"])) {
                this.languageSkillBDocuments = [] as any;
                for (let item of _data["languageSkillBDocuments"])
                    this.languageSkillBDocuments!.push(GeneralDocumentGroupDto.fromJS(item));
            }
            this.hasLanguageRecordInExternalRegister = _data["hasLanguageRecordInExternalRegister"];
            this.languageSkillLevelId = _data["languageSkillLevelId"];
        }
    }

    static fromJS(data: any): LiaLanguageSkillBDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiaLanguageSkillBDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasLanguageSkillId"] = this.hasLanguageSkillId;
        if (Array.isArray(this.languageSkillBDocuments)) {
            data["languageSkillBDocuments"] = [];
            for (let item of this.languageSkillBDocuments)
                data["languageSkillBDocuments"].push(item.toJSON());
        }
        data["hasLanguageRecordInExternalRegister"] = this.hasLanguageRecordInExternalRegister;
        data["languageSkillLevelId"] = this.languageSkillLevelId;
        return data;
    }
}

export interface ILiaLanguageSkillBDto {
    hasLanguageSkillId: string;
    languageSkillBDocuments: GeneralDocumentGroupDto[] | undefined;
    hasLanguageRecordInExternalRegister: boolean;
    languageSkillLevelId: string | undefined;
}

export enum LiaStatus {
    Person = 0,
    Contact = 2,
    Restriction = 3,
    InvoiceAddress = 6,
    Document = 7,
    LanguageSkill = 8,
    Diploma = 9,
    AcademicTitle = 10,
    EmploymentB = 11,
    Guarantee = 12,
    PostgraduateTitlePrivateLaw = 13,
    PostgraduateTitle = 14,
    RestrictionB = 15,
    PreviousEmployment = 16,
    LanguageSkillB = 17,
    LicenceInAnotherCanton = 18,
    ProfessionalResponsibility = 21,
    ContactDuringEmployment = 22,
    Release = 97,
    Released = 98,
    FinishReview = 99,
}

export class CreateOrUpdateLiaLicenceInAnotherCantonInput implements ICreateOrUpdateLiaLicenceInAnotherCantonInput {
    caseId!: string | undefined;
    liaLicenceInAnotherCanton!: LiaLicenceInAnotherCantonDto;

    constructor(data?: ICreateOrUpdateLiaLicenceInAnotherCantonInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.liaLicenceInAnotherCanton = _data["liaLicenceInAnotherCanton"] ? LiaLicenceInAnotherCantonDto.fromJS(_data["liaLicenceInAnotherCanton"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrUpdateLiaLicenceInAnotherCantonInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLiaLicenceInAnotherCantonInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["liaLicenceInAnotherCanton"] = this.liaLicenceInAnotherCanton ? this.liaLicenceInAnotherCanton.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateLiaLicenceInAnotherCantonInput {
    caseId: string | undefined;
    liaLicenceInAnotherCanton: LiaLicenceInAnotherCantonDto;
}

export class LiaLicenceInAnotherCantonDto implements ILiaLicenceInAnotherCantonDto {
    hasLicenceId!: string | undefined;
    hasAnyUnsuccessfulLicenceApplicationId!: string | undefined;
    unsuccessfulLicenceApplicationComment!: string | undefined;
    licenceInAnotherCantonRecords!: LiaLicenceInAnotherCantonRecordDto[] | undefined;

    constructor(data?: ILiaLicenceInAnotherCantonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasLicenceId = _data["hasLicenceId"];
            this.hasAnyUnsuccessfulLicenceApplicationId = _data["hasAnyUnsuccessfulLicenceApplicationId"];
            this.unsuccessfulLicenceApplicationComment = _data["unsuccessfulLicenceApplicationComment"];
            if (Array.isArray(_data["licenceInAnotherCantonRecords"])) {
                this.licenceInAnotherCantonRecords = [] as any;
                for (let item of _data["licenceInAnotherCantonRecords"])
                    this.licenceInAnotherCantonRecords!.push(LiaLicenceInAnotherCantonRecordDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LiaLicenceInAnotherCantonDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiaLicenceInAnotherCantonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasLicenceId"] = this.hasLicenceId;
        data["hasAnyUnsuccessfulLicenceApplicationId"] = this.hasAnyUnsuccessfulLicenceApplicationId;
        data["unsuccessfulLicenceApplicationComment"] = this.unsuccessfulLicenceApplicationComment;
        if (Array.isArray(this.licenceInAnotherCantonRecords)) {
            data["licenceInAnotherCantonRecords"] = [];
            for (let item of this.licenceInAnotherCantonRecords)
                data["licenceInAnotherCantonRecords"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILiaLicenceInAnotherCantonDto {
    hasLicenceId: string | undefined;
    hasAnyUnsuccessfulLicenceApplicationId: string | undefined;
    unsuccessfulLicenceApplicationComment: string | undefined;
    licenceInAnotherCantonRecords: LiaLicenceInAnotherCantonRecordDto[] | undefined;
}

export class LiaLicenceInAnotherCantonRecordDto implements ILiaLicenceInAnotherCantonRecordDto {
    cantonOrCountryId!: string | undefined;
    id!: number;

    constructor(data?: ILiaLicenceInAnotherCantonRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cantonOrCountryId = _data["cantonOrCountryId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LiaLicenceInAnotherCantonRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiaLicenceInAnotherCantonRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cantonOrCountryId"] = this.cantonOrCountryId;
        data["id"] = this.id;
        return data;
    }
}

export interface ILiaLicenceInAnotherCantonRecordDto {
    cantonOrCountryId: string | undefined;
    id: number;
}

export class CreateOrUpdateLiaPersonExtendedInput implements ICreateOrUpdateLiaPersonExtendedInput {
    caseId!: string;
    liaPerson!: LiaPersonDto;

    constructor(data?: ICreateOrUpdateLiaPersonExtendedInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.liaPerson = new LiaPersonDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.liaPerson = _data["liaPerson"] ? LiaPersonDto.fromJS(_data["liaPerson"]) : new LiaPersonDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateLiaPersonExtendedInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLiaPersonExtendedInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["liaPerson"] = this.liaPerson ? this.liaPerson.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateLiaPersonExtendedInput {
    caseId: string;
    liaPerson: LiaPersonDto;
}

export class CreateOrUpdateLiaPersonExtendedOutput implements ICreateOrUpdateLiaPersonExtendedOutput {
    liaPerson!: LiaPersonDto;
    status!: LiaStatus;

    constructor(data?: ICreateOrUpdateLiaPersonExtendedOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.liaPerson = _data["liaPerson"] ? LiaPersonDto.fromJS(_data["liaPerson"]) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CreateOrUpdateLiaPersonExtendedOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLiaPersonExtendedOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["liaPerson"] = this.liaPerson ? this.liaPerson.toJSON() : <any>undefined;
        data["status"] = this.status;
        return data;
    }
}

export interface ICreateOrUpdateLiaPersonExtendedOutput {
    liaPerson: LiaPersonDto;
    status: LiaStatus;
}

export class CreateOrUpdateLiaPersonOutputDto implements ICreateOrUpdateLiaPersonOutputDto {
    healthRegisterIdentificationStatus!: HealthRegisterIdentificationStatus;
    healthRegisterSystem!: ExternalSystemEnum;
    healthRegisterId!: number | undefined;
    liaPerson!: LiaPersonDto;

    constructor(data?: ICreateOrUpdateLiaPersonOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthRegisterIdentificationStatus = _data["healthRegisterIdentificationStatus"];
            this.healthRegisterSystem = _data["healthRegisterSystem"];
            this.healthRegisterId = _data["healthRegisterId"];
            this.liaPerson = _data["liaPerson"] ? LiaPersonDto.fromJS(_data["liaPerson"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrUpdateLiaPersonOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLiaPersonOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthRegisterIdentificationStatus"] = this.healthRegisterIdentificationStatus;
        data["healthRegisterSystem"] = this.healthRegisterSystem;
        data["healthRegisterId"] = this.healthRegisterId;
        data["liaPerson"] = this.liaPerson ? this.liaPerson.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateLiaPersonOutputDto {
    healthRegisterIdentificationStatus: HealthRegisterIdentificationStatus;
    healthRegisterSystem: ExternalSystemEnum;
    healthRegisterId: number | undefined;
    liaPerson: LiaPersonDto;
}

export class CreateOrUpdateLiaPersonWithRegisterCheckInput implements ICreateOrUpdateLiaPersonWithRegisterCheckInput {
    caseId!: string;
    gln!: string;

    constructor(data?: ICreateOrUpdateLiaPersonWithRegisterCheckInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.gln = _data["gln"];
        }
    }

    static fromJS(data: any): CreateOrUpdateLiaPersonWithRegisterCheckInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLiaPersonWithRegisterCheckInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["gln"] = this.gln;
        return data;
    }
}

export interface ICreateOrUpdateLiaPersonWithRegisterCheckInput {
    caseId: string;
    gln: string;
}

export class LiaPersonDto implements ILiaPersonDto {
    firstName!: string;
    lastName!: string;
    birthName!: string | undefined;
    genderId!: string | undefined;
    dateOfBirth!: DateTime | undefined;
    nationality1Id!: string | undefined;
    nationality2Id!: string | undefined;
    placeOfOrigin!: string | undefined;
    residencePermit!: boolean | undefined;
    dateOfResidencePermit!: DateTime | undefined;
    gln!: string | undefined;
    ahv!: string | undefined;
    zsr!: string | undefined;
    uid!: string | undefined;
    hasConfirmedData!: boolean | undefined;
    hasLicenceInAnotherCantonId!: string | undefined;
    medRegId!: number | undefined;
    psyRegId!: number | undefined;
    naregId!: number | undefined;
    healthRegisterResult!: HealthRegisterIdentificationStatus;
    personDocuments!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: ILiaPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.birthName = _data["birthName"];
            this.genderId = _data["genderId"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.nationality1Id = _data["nationality1Id"];
            this.nationality2Id = _data["nationality2Id"];
            this.placeOfOrigin = _data["placeOfOrigin"];
            this.residencePermit = _data["residencePermit"];
            this.dateOfResidencePermit = _data["dateOfResidencePermit"] ? DateTime.fromISO(_data["dateOfResidencePermit"].toString()) : <any>undefined;
            this.gln = _data["gln"];
            this.ahv = _data["ahv"];
            this.zsr = _data["zsr"];
            this.uid = _data["uid"];
            this.hasConfirmedData = _data["hasConfirmedData"];
            this.hasLicenceInAnotherCantonId = _data["hasLicenceInAnotherCantonId"];
            this.medRegId = _data["medRegId"];
            this.psyRegId = _data["psyRegId"];
            this.naregId = _data["naregId"];
            this.healthRegisterResult = _data["healthRegisterResult"];
            if (Array.isArray(_data["personDocuments"])) {
                this.personDocuments = [] as any;
                for (let item of _data["personDocuments"])
                    this.personDocuments!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LiaPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiaPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["birthName"] = this.birthName;
        data["genderId"] = this.genderId;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["nationality1Id"] = this.nationality1Id;
        data["nationality2Id"] = this.nationality2Id;
        data["placeOfOrigin"] = this.placeOfOrigin;
        data["residencePermit"] = this.residencePermit;
        data["dateOfResidencePermit"] = this.dateOfResidencePermit ? this.dateOfResidencePermit.toFormat('yyyy-MM-dd') : <any>undefined;
        data["gln"] = this.gln;
        data["ahv"] = this.ahv;
        data["zsr"] = this.zsr;
        data["uid"] = this.uid;
        data["hasConfirmedData"] = this.hasConfirmedData;
        data["hasLicenceInAnotherCantonId"] = this.hasLicenceInAnotherCantonId;
        data["medRegId"] = this.medRegId;
        data["psyRegId"] = this.psyRegId;
        data["naregId"] = this.naregId;
        data["healthRegisterResult"] = this.healthRegisterResult;
        if (Array.isArray(this.personDocuments)) {
            data["personDocuments"] = [];
            for (let item of this.personDocuments)
                data["personDocuments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILiaPersonDto {
    firstName: string;
    lastName: string;
    birthName: string | undefined;
    genderId: string | undefined;
    dateOfBirth: DateTime | undefined;
    nationality1Id: string | undefined;
    nationality2Id: string | undefined;
    placeOfOrigin: string | undefined;
    residencePermit: boolean | undefined;
    dateOfResidencePermit: DateTime | undefined;
    gln: string | undefined;
    ahv: string | undefined;
    zsr: string | undefined;
    uid: string | undefined;
    hasConfirmedData: boolean | undefined;
    hasLicenceInAnotherCantonId: string | undefined;
    medRegId: number | undefined;
    psyRegId: number | undefined;
    naregId: number | undefined;
    healthRegisterResult: HealthRegisterIdentificationStatus;
    personDocuments: GeneralDocumentGroupDto[] | undefined;
}

export class CreateOrUpdateLiaPostgraduateTitleInput implements ICreateOrUpdateLiaPostgraduateTitleInput {
    caseId!: string | undefined;
    liaPostgraduateTitles!: LiaPostgraduateTitleDto[] | undefined;

    constructor(data?: ICreateOrUpdateLiaPostgraduateTitleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["liaPostgraduateTitles"])) {
                this.liaPostgraduateTitles = [] as any;
                for (let item of _data["liaPostgraduateTitles"])
                    this.liaPostgraduateTitles!.push(LiaPostgraduateTitleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateLiaPostgraduateTitleInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLiaPostgraduateTitleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.liaPostgraduateTitles)) {
            data["liaPostgraduateTitles"] = [];
            for (let item of this.liaPostgraduateTitles)
                data["liaPostgraduateTitles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateLiaPostgraduateTitleInput {
    caseId: string | undefined;
    liaPostgraduateTitles: LiaPostgraduateTitleDto[] | undefined;
}

export class CreateOrUpdateLiaPostgraduateTitleOutput implements ICreateOrUpdateLiaPostgraduateTitleOutput {
    status!: LiaStatus;
    liaPostgraduateTitles!: LiaPostgraduateTitleDto[] | undefined;

    constructor(data?: ICreateOrUpdateLiaPostgraduateTitleOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["liaPostgraduateTitles"])) {
                this.liaPostgraduateTitles = [] as any;
                for (let item of _data["liaPostgraduateTitles"])
                    this.liaPostgraduateTitles!.push(LiaPostgraduateTitleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateLiaPostgraduateTitleOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLiaPostgraduateTitleOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.liaPostgraduateTitles)) {
            data["liaPostgraduateTitles"] = [];
            for (let item of this.liaPostgraduateTitles)
                data["liaPostgraduateTitles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateLiaPostgraduateTitleOutput {
    status: LiaStatus;
    liaPostgraduateTitles: LiaPostgraduateTitleDto[] | undefined;
}

export class LiaPostgraduateTitleDto implements ILiaPostgraduateTitleDto {
    id!: number | undefined;
    titleId!: string | undefined;
    typeId!: string | undefined;
    placeOfIssue!: string | undefined;
    countryId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfRecognition!: DateTime | undefined;

    constructor(data?: ILiaPostgraduateTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.titleId = _data["titleId"];
            this.typeId = _data["typeId"];
            this.placeOfIssue = _data["placeOfIssue"];
            this.countryId = _data["countryId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfRecognition = _data["dateOfRecognition"] ? DateTime.fromISO(_data["dateOfRecognition"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): LiaPostgraduateTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiaPostgraduateTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["titleId"] = this.titleId;
        data["typeId"] = this.typeId;
        data["placeOfIssue"] = this.placeOfIssue;
        data["countryId"] = this.countryId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfRecognition"] = this.dateOfRecognition ? this.dateOfRecognition.toFormat('yyyy-MM-dd') : <any>undefined;
        return data;
    }
}

export interface ILiaPostgraduateTitleDto {
    id: number | undefined;
    titleId: string | undefined;
    typeId: string | undefined;
    placeOfIssue: string | undefined;
    countryId: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfRecognition: DateTime | undefined;
}

export class LiaPostgraduateTitleOutput implements ILiaPostgraduateTitleOutput {
    liaPostgraduateTitles!: LiaPostgraduateTitleDto[] | undefined;

    constructor(data?: ILiaPostgraduateTitleOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["liaPostgraduateTitles"])) {
                this.liaPostgraduateTitles = [] as any;
                for (let item of _data["liaPostgraduateTitles"])
                    this.liaPostgraduateTitles!.push(LiaPostgraduateTitleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LiaPostgraduateTitleOutput {
        data = typeof data === 'object' ? data : {};
        let result = new LiaPostgraduateTitleOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.liaPostgraduateTitles)) {
            data["liaPostgraduateTitles"] = [];
            for (let item of this.liaPostgraduateTitles)
                data["liaPostgraduateTitles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILiaPostgraduateTitleOutput {
    liaPostgraduateTitles: LiaPostgraduateTitleDto[] | undefined;
}

export class CreateOrUpdateLiaPostgraduateTitlePrivateLawInput implements ICreateOrUpdateLiaPostgraduateTitlePrivateLawInput {
    caseId!: string | undefined;
    liaPostgraduateTitlePrivateLaws!: LiaPostgraduateTitlePrivateLawDto[] | undefined;

    constructor(data?: ICreateOrUpdateLiaPostgraduateTitlePrivateLawInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["liaPostgraduateTitlePrivateLaws"])) {
                this.liaPostgraduateTitlePrivateLaws = [] as any;
                for (let item of _data["liaPostgraduateTitlePrivateLaws"])
                    this.liaPostgraduateTitlePrivateLaws!.push(LiaPostgraduateTitlePrivateLawDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateLiaPostgraduateTitlePrivateLawInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLiaPostgraduateTitlePrivateLawInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.liaPostgraduateTitlePrivateLaws)) {
            data["liaPostgraduateTitlePrivateLaws"] = [];
            for (let item of this.liaPostgraduateTitlePrivateLaws)
                data["liaPostgraduateTitlePrivateLaws"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateLiaPostgraduateTitlePrivateLawInput {
    caseId: string | undefined;
    liaPostgraduateTitlePrivateLaws: LiaPostgraduateTitlePrivateLawDto[] | undefined;
}

export class CreateOrUpdateLiaPostgraduateTitlePrivateLawOutput implements ICreateOrUpdateLiaPostgraduateTitlePrivateLawOutput {
    status!: LiaStatus;
    liaPostgraduateTitlePrivateLaws!: LiaPostgraduateTitlePrivateLawDto[] | undefined;

    constructor(data?: ICreateOrUpdateLiaPostgraduateTitlePrivateLawOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["liaPostgraduateTitlePrivateLaws"])) {
                this.liaPostgraduateTitlePrivateLaws = [] as any;
                for (let item of _data["liaPostgraduateTitlePrivateLaws"])
                    this.liaPostgraduateTitlePrivateLaws!.push(LiaPostgraduateTitlePrivateLawDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateLiaPostgraduateTitlePrivateLawOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLiaPostgraduateTitlePrivateLawOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.liaPostgraduateTitlePrivateLaws)) {
            data["liaPostgraduateTitlePrivateLaws"] = [];
            for (let item of this.liaPostgraduateTitlePrivateLaws)
                data["liaPostgraduateTitlePrivateLaws"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateLiaPostgraduateTitlePrivateLawOutput {
    status: LiaStatus;
    liaPostgraduateTitlePrivateLaws: LiaPostgraduateTitlePrivateLawDto[] | undefined;
}

export class LiaPostgraduateTitlePrivateLawDto implements ILiaPostgraduateTitlePrivateLawDto {
    id!: string;
    name!: string | undefined;
    type!: string | undefined;
    placeOfIssue!: string | undefined;
    issuingAuthority!: string | undefined;
    certificateId!: string | undefined;
    countryId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    postgraduateTitlePrivateLawDocuments!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: ILiaPostgraduateTitlePrivateLawDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.placeOfIssue = _data["placeOfIssue"];
            this.issuingAuthority = _data["issuingAuthority"];
            this.certificateId = _data["certificateId"];
            this.countryId = _data["countryId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            if (Array.isArray(_data["postgraduateTitlePrivateLawDocuments"])) {
                this.postgraduateTitlePrivateLawDocuments = [] as any;
                for (let item of _data["postgraduateTitlePrivateLawDocuments"])
                    this.postgraduateTitlePrivateLawDocuments!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LiaPostgraduateTitlePrivateLawDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiaPostgraduateTitlePrivateLawDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["placeOfIssue"] = this.placeOfIssue;
        data["issuingAuthority"] = this.issuingAuthority;
        data["certificateId"] = this.certificateId;
        data["countryId"] = this.countryId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        if (Array.isArray(this.postgraduateTitlePrivateLawDocuments)) {
            data["postgraduateTitlePrivateLawDocuments"] = [];
            for (let item of this.postgraduateTitlePrivateLawDocuments)
                data["postgraduateTitlePrivateLawDocuments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILiaPostgraduateTitlePrivateLawDto {
    id: string;
    name: string | undefined;
    type: string | undefined;
    placeOfIssue: string | undefined;
    issuingAuthority: string | undefined;
    certificateId: string | undefined;
    countryId: string | undefined;
    dateOfIssue: DateTime | undefined;
    postgraduateTitlePrivateLawDocuments: GeneralDocumentGroupDto[] | undefined;
}

export class LiaPostgraduateTitlePrivateLawOutput implements ILiaPostgraduateTitlePrivateLawOutput {
    liaPostgraduateTitlePrivateLaws!: LiaPostgraduateTitlePrivateLawDto[] | undefined;
    postgraduateTitlePrivateLawDocuments!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: ILiaPostgraduateTitlePrivateLawOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["liaPostgraduateTitlePrivateLaws"])) {
                this.liaPostgraduateTitlePrivateLaws = [] as any;
                for (let item of _data["liaPostgraduateTitlePrivateLaws"])
                    this.liaPostgraduateTitlePrivateLaws!.push(LiaPostgraduateTitlePrivateLawDto.fromJS(item));
            }
            if (Array.isArray(_data["postgraduateTitlePrivateLawDocuments"])) {
                this.postgraduateTitlePrivateLawDocuments = [] as any;
                for (let item of _data["postgraduateTitlePrivateLawDocuments"])
                    this.postgraduateTitlePrivateLawDocuments!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LiaPostgraduateTitlePrivateLawOutput {
        data = typeof data === 'object' ? data : {};
        let result = new LiaPostgraduateTitlePrivateLawOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.liaPostgraduateTitlePrivateLaws)) {
            data["liaPostgraduateTitlePrivateLaws"] = [];
            for (let item of this.liaPostgraduateTitlePrivateLaws)
                data["liaPostgraduateTitlePrivateLaws"].push(item.toJSON());
        }
        if (Array.isArray(this.postgraduateTitlePrivateLawDocuments)) {
            data["postgraduateTitlePrivateLawDocuments"] = [];
            for (let item of this.postgraduateTitlePrivateLawDocuments)
                data["postgraduateTitlePrivateLawDocuments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILiaPostgraduateTitlePrivateLawOutput {
    liaPostgraduateTitlePrivateLaws: LiaPostgraduateTitlePrivateLawDto[] | undefined;
    postgraduateTitlePrivateLawDocuments: GeneralDocumentGroupDto[] | undefined;
}

export class CreateOrUpdateLiaPreviousEmploymentInput implements ICreateOrUpdateLiaPreviousEmploymentInput {
    caseId!: string | undefined;
    liaPreviousEmployment!: LiaPreviousEmploymentDto;

    constructor(data?: ICreateOrUpdateLiaPreviousEmploymentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.liaPreviousEmployment = _data["liaPreviousEmployment"] ? LiaPreviousEmploymentDto.fromJS(_data["liaPreviousEmployment"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrUpdateLiaPreviousEmploymentInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLiaPreviousEmploymentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["liaPreviousEmployment"] = this.liaPreviousEmployment ? this.liaPreviousEmployment.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateLiaPreviousEmploymentInput {
    caseId: string | undefined;
    liaPreviousEmployment: LiaPreviousEmploymentDto;
}

export class LiaPreviousEmploymentDto implements ILiaPreviousEmploymentDto {
    professionalExperienceId!: string | undefined;
    previousEmploymentRecords!: LiaPreviousEmploymentRecordDto[] | undefined;
    previousEmploymentRecordDocuments!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: ILiaPreviousEmploymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professionalExperienceId = _data["professionalExperienceId"];
            if (Array.isArray(_data["previousEmploymentRecords"])) {
                this.previousEmploymentRecords = [] as any;
                for (let item of _data["previousEmploymentRecords"])
                    this.previousEmploymentRecords!.push(LiaPreviousEmploymentRecordDto.fromJS(item));
            }
            if (Array.isArray(_data["previousEmploymentRecordDocuments"])) {
                this.previousEmploymentRecordDocuments = [] as any;
                for (let item of _data["previousEmploymentRecordDocuments"])
                    this.previousEmploymentRecordDocuments!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LiaPreviousEmploymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiaPreviousEmploymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professionalExperienceId"] = this.professionalExperienceId;
        if (Array.isArray(this.previousEmploymentRecords)) {
            data["previousEmploymentRecords"] = [];
            for (let item of this.previousEmploymentRecords)
                data["previousEmploymentRecords"].push(item.toJSON());
        }
        if (Array.isArray(this.previousEmploymentRecordDocuments)) {
            data["previousEmploymentRecordDocuments"] = [];
            for (let item of this.previousEmploymentRecordDocuments)
                data["previousEmploymentRecordDocuments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILiaPreviousEmploymentDto {
    professionalExperienceId: string | undefined;
    previousEmploymentRecords: LiaPreviousEmploymentRecordDto[] | undefined;
    previousEmploymentRecordDocuments: GeneralDocumentGroupDto[] | undefined;
}

export class LiaPreviousEmploymentRecordDto implements ILiaPreviousEmploymentRecordDto {
    liaPreviousEmploymentId!: number;
    businessName!: string | undefined;
    role!: string | undefined;
    previousEmploymentTypeId!: string | undefined;
    levelOfEmployment!: number;
    dateOfEmployment!: DateTime | undefined;
    dateOfEndOfEmployment!: DateTime | undefined;
    id!: string;

    constructor(data?: ILiaPreviousEmploymentRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.liaPreviousEmploymentId = _data["liaPreviousEmploymentId"];
            this.businessName = _data["businessName"];
            this.role = _data["role"];
            this.previousEmploymentTypeId = _data["previousEmploymentTypeId"];
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.dateOfEmployment = _data["dateOfEmployment"] ? DateTime.fromISO(_data["dateOfEmployment"].toString()) : <any>undefined;
            this.dateOfEndOfEmployment = _data["dateOfEndOfEmployment"] ? DateTime.fromISO(_data["dateOfEndOfEmployment"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LiaPreviousEmploymentRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiaPreviousEmploymentRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["liaPreviousEmploymentId"] = this.liaPreviousEmploymentId;
        data["businessName"] = this.businessName;
        data["role"] = this.role;
        data["previousEmploymentTypeId"] = this.previousEmploymentTypeId;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["dateOfEmployment"] = this.dateOfEmployment ? this.dateOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEndOfEmployment"] = this.dateOfEndOfEmployment ? this.dateOfEndOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ILiaPreviousEmploymentRecordDto {
    liaPreviousEmploymentId: number;
    businessName: string | undefined;
    role: string | undefined;
    previousEmploymentTypeId: string | undefined;
    levelOfEmployment: number;
    dateOfEmployment: DateTime | undefined;
    dateOfEndOfEmployment: DateTime | undefined;
    id: string;
}

export class CreateOrUpdateLiaRestrictionsInput implements ICreateOrUpdateLiaRestrictionsInput {
    caseId!: string;
    liaRestrictions!: LiaRestrictionDto[];

    constructor(data?: ICreateOrUpdateLiaRestrictionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.liaRestrictions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["liaRestrictions"])) {
                this.liaRestrictions = [] as any;
                for (let item of _data["liaRestrictions"])
                    this.liaRestrictions!.push(LiaRestrictionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateLiaRestrictionsInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLiaRestrictionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.liaRestrictions)) {
            data["liaRestrictions"] = [];
            for (let item of this.liaRestrictions)
                data["liaRestrictions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateLiaRestrictionsInput {
    caseId: string;
    liaRestrictions: LiaRestrictionDto[];
}

export class LiaRestrictionDto implements ILiaRestrictionDto {
    cantonId!: string;
    reason!: string | undefined;

    constructor(data?: ILiaRestrictionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cantonId = _data["cantonId"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): LiaRestrictionDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiaRestrictionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cantonId"] = this.cantonId;
        data["reason"] = this.reason;
        return data;
    }
}

export interface ILiaRestrictionDto {
    cantonId: string;
    reason: string | undefined;
}

export class LiaRestrictionOutput implements ILiaRestrictionOutput {
    hasAnyImpairmentRelatedToPracticeId!: string | undefined;
    restrictions!: LiaRestrictionDto[] | undefined;
    restrictionDocuments!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: ILiaRestrictionOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasAnyImpairmentRelatedToPracticeId = _data["hasAnyImpairmentRelatedToPracticeId"];
            if (Array.isArray(_data["restrictions"])) {
                this.restrictions = [] as any;
                for (let item of _data["restrictions"])
                    this.restrictions!.push(LiaRestrictionDto.fromJS(item));
            }
            if (Array.isArray(_data["restrictionDocuments"])) {
                this.restrictionDocuments = [] as any;
                for (let item of _data["restrictionDocuments"])
                    this.restrictionDocuments!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LiaRestrictionOutput {
        data = typeof data === 'object' ? data : {};
        let result = new LiaRestrictionOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasAnyImpairmentRelatedToPracticeId"] = this.hasAnyImpairmentRelatedToPracticeId;
        if (Array.isArray(this.restrictions)) {
            data["restrictions"] = [];
            for (let item of this.restrictions)
                data["restrictions"].push(item.toJSON());
        }
        if (Array.isArray(this.restrictionDocuments)) {
            data["restrictionDocuments"] = [];
            for (let item of this.restrictionDocuments)
                data["restrictionDocuments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILiaRestrictionOutput {
    hasAnyImpairmentRelatedToPracticeId: string | undefined;
    restrictions: LiaRestrictionDto[] | undefined;
    restrictionDocuments: GeneralDocumentGroupDto[] | undefined;
}

export class CreateOrUpdateLiaRestrictionBInput implements ICreateOrUpdateLiaRestrictionBInput {
    caseId!: string;
    liaRestrictionB!: LiaRestrictionBDto;

    constructor(data?: ICreateOrUpdateLiaRestrictionBInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.liaRestrictionB = new LiaRestrictionBDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.liaRestrictionB = _data["liaRestrictionB"] ? LiaRestrictionBDto.fromJS(_data["liaRestrictionB"]) : new LiaRestrictionBDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateLiaRestrictionBInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLiaRestrictionBInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["liaRestrictionB"] = this.liaRestrictionB ? this.liaRestrictionB.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateLiaRestrictionBInput {
    caseId: string;
    liaRestrictionB: LiaRestrictionBDto;
}

export class LiaLicenceInAnotherCantonCacheDto implements ILiaLicenceInAnotherCantonCacheDto {
    liaApplicationId!: number;
    cantonId!: string;
    licenceStatusId!: string;
    professionId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    activityId!: string | undefined;
    dateOfActivity!: DateTime | undefined;
    id!: number;

    constructor(data?: ILiaLicenceInAnotherCantonCacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.liaApplicationId = _data["liaApplicationId"];
            this.cantonId = _data["cantonId"];
            this.licenceStatusId = _data["licenceStatusId"];
            this.professionId = _data["professionId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.activityId = _data["activityId"];
            this.dateOfActivity = _data["dateOfActivity"] ? DateTime.fromISO(_data["dateOfActivity"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LiaLicenceInAnotherCantonCacheDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiaLicenceInAnotherCantonCacheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["liaApplicationId"] = this.liaApplicationId;
        data["cantonId"] = this.cantonId;
        data["licenceStatusId"] = this.licenceStatusId;
        data["professionId"] = this.professionId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["activityId"] = this.activityId;
        data["dateOfActivity"] = this.dateOfActivity ? this.dateOfActivity.toFormat('yyyy-MM-dd') : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ILiaLicenceInAnotherCantonCacheDto {
    liaApplicationId: number;
    cantonId: string;
    licenceStatusId: string;
    professionId: string | undefined;
    dateOfIssue: DateTime | undefined;
    activityId: string | undefined;
    dateOfActivity: DateTime | undefined;
    id: number;
}

export class LiaRestrictionBDto implements ILiaRestrictionBDto {
    hasDeniedProfessionalLicenceId!: string | undefined;
    hasDeniedProfessionalLicenceReason!: string | undefined;
    hasOpenProceedingsRelatedToProfessionalActivityId!: string | undefined;
    hasOpenProceedingsRelatedToProfessionalActivityReason!: string | undefined;
    hasSensitiveDataFederalLaw!: boolean;
    hasSensitiveDataCantonalLaw!: boolean;
    hasSpecialCriminalRecordId!: string | undefined;
    wasSelfEmployedInAnotherCantonId!: string | undefined;
    hasLicenceInAnotherCanton!: boolean | undefined;
    restrictionBDocuments!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: ILiaRestrictionBDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasDeniedProfessionalLicenceId = _data["hasDeniedProfessionalLicenceId"];
            this.hasDeniedProfessionalLicenceReason = _data["hasDeniedProfessionalLicenceReason"];
            this.hasOpenProceedingsRelatedToProfessionalActivityId = _data["hasOpenProceedingsRelatedToProfessionalActivityId"];
            this.hasOpenProceedingsRelatedToProfessionalActivityReason = _data["hasOpenProceedingsRelatedToProfessionalActivityReason"];
            this.hasSensitiveDataFederalLaw = _data["hasSensitiveDataFederalLaw"];
            this.hasSensitiveDataCantonalLaw = _data["hasSensitiveDataCantonalLaw"];
            this.hasSpecialCriminalRecordId = _data["hasSpecialCriminalRecordId"];
            this.wasSelfEmployedInAnotherCantonId = _data["wasSelfEmployedInAnotherCantonId"];
            this.hasLicenceInAnotherCanton = _data["hasLicenceInAnotherCanton"];
            if (Array.isArray(_data["restrictionBDocuments"])) {
                this.restrictionBDocuments = [] as any;
                for (let item of _data["restrictionBDocuments"])
                    this.restrictionBDocuments!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LiaRestrictionBDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiaRestrictionBDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasDeniedProfessionalLicenceId"] = this.hasDeniedProfessionalLicenceId;
        data["hasDeniedProfessionalLicenceReason"] = this.hasDeniedProfessionalLicenceReason;
        data["hasOpenProceedingsRelatedToProfessionalActivityId"] = this.hasOpenProceedingsRelatedToProfessionalActivityId;
        data["hasOpenProceedingsRelatedToProfessionalActivityReason"] = this.hasOpenProceedingsRelatedToProfessionalActivityReason;
        data["hasSensitiveDataFederalLaw"] = this.hasSensitiveDataFederalLaw;
        data["hasSensitiveDataCantonalLaw"] = this.hasSensitiveDataCantonalLaw;
        data["hasSpecialCriminalRecordId"] = this.hasSpecialCriminalRecordId;
        data["wasSelfEmployedInAnotherCantonId"] = this.wasSelfEmployedInAnotherCantonId;
        data["hasLicenceInAnotherCanton"] = this.hasLicenceInAnotherCanton;
        if (Array.isArray(this.restrictionBDocuments)) {
            data["restrictionBDocuments"] = [];
            for (let item of this.restrictionBDocuments)
                data["restrictionBDocuments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILiaRestrictionBDto {
    hasDeniedProfessionalLicenceId: string | undefined;
    hasDeniedProfessionalLicenceReason: string | undefined;
    hasOpenProceedingsRelatedToProfessionalActivityId: string | undefined;
    hasOpenProceedingsRelatedToProfessionalActivityReason: string | undefined;
    hasSensitiveDataFederalLaw: boolean;
    hasSensitiveDataCantonalLaw: boolean;
    hasSpecialCriminalRecordId: string | undefined;
    wasSelfEmployedInAnotherCantonId: string | undefined;
    hasLicenceInAnotherCanton: boolean | undefined;
    restrictionBDocuments: GeneralDocumentGroupDto[] | undefined;
}

export class CreateLiaTypeInput implements ICreateLiaTypeInput {
    applicationTypeId!: ApplicationType;
    professionId!: string;

    constructor(data?: ICreateLiaTypeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationTypeId = _data["applicationTypeId"];
            this.professionId = _data["professionId"];
        }
    }

    static fromJS(data: any): CreateLiaTypeInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLiaTypeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationTypeId"] = this.applicationTypeId;
        data["professionId"] = this.professionId;
        return data;
    }
}

export interface ICreateLiaTypeInput {
    applicationTypeId: ApplicationType;
    professionId: string;
}

export class CreateLiaTypeOutput implements ICreateLiaTypeOutput {
    caseId!: string | undefined;

    constructor(data?: ICreateLiaTypeOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
        }
    }

    static fromJS(data: any): CreateLiaTypeOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLiaTypeOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        return data;
    }
}

export interface ICreateLiaTypeOutput {
    caseId: string | undefined;
}

export class GetEhcPersonalLicenceDto implements IGetEhcPersonalLicenceDto {
    licenceId!: number | undefined;
    personId!: number | undefined;

    constructor(data?: IGetEhcPersonalLicenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenceId = _data["licenceId"];
            this.personId = _data["personId"];
        }
    }

    static fromJS(data: any): GetEhcPersonalLicenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEhcPersonalLicenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenceId"] = this.licenceId;
        data["personId"] = this.personId;
        return data;
    }
}

export interface IGetEhcPersonalLicenceDto {
    licenceId: number | undefined;
    personId: number | undefined;
}

export class LiaVaccinationDto implements ILiaVaccinationDto {
    requestVaccinationLicenceId!: string | undefined;

    constructor(data?: ILiaVaccinationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestVaccinationLicenceId = _data["requestVaccinationLicenceId"];
        }
    }

    static fromJS(data: any): LiaVaccinationDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiaVaccinationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestVaccinationLicenceId"] = this.requestVaccinationLicenceId;
        return data;
    }
}

export interface ILiaVaccinationDto {
    requestVaccinationLicenceId: string | undefined;
}

export class LiaVaccinationOutputDto implements ILiaVaccinationOutputDto {
    vaccination!: LiaVaccinationDto;
    vaccinationDocuments!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: ILiaVaccinationOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vaccination = _data["vaccination"] ? LiaVaccinationDto.fromJS(_data["vaccination"]) : <any>undefined;
            if (Array.isArray(_data["vaccinationDocuments"])) {
                this.vaccinationDocuments = [] as any;
                for (let item of _data["vaccinationDocuments"])
                    this.vaccinationDocuments!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LiaVaccinationOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiaVaccinationOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vaccination"] = this.vaccination ? this.vaccination.toJSON() : <any>undefined;
        if (Array.isArray(this.vaccinationDocuments)) {
            data["vaccinationDocuments"] = [];
            for (let item of this.vaccinationDocuments)
                data["vaccinationDocuments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILiaVaccinationOutputDto {
    vaccination: LiaVaccinationDto;
    vaccinationDocuments: GeneralDocumentGroupDto[] | undefined;
}

export class ApplicationLanguageEditDto implements IApplicationLanguageEditDto {
    id!: number | undefined;
    name!: string;
    icon!: string | undefined;
    isEnabled!: boolean;

    constructor(data?: IApplicationLanguageEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.icon = _data["icon"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): ApplicationLanguageEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationLanguageEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["icon"] = this.icon;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IApplicationLanguageEditDto {
    id: number | undefined;
    name: string;
    icon: string | undefined;
    isEnabled: boolean;
}

export class ApplicationLanguageListDto implements IApplicationLanguageListDto {
    tenantId!: number | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    icon!: string | undefined;
    isDisabled!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IApplicationLanguageListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.icon = _data["icon"];
            this.isDisabled = _data["isDisabled"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ApplicationLanguageListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationLanguageListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["icon"] = this.icon;
        data["isDisabled"] = this.isDisabled;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IApplicationLanguageListDto {
    tenantId: number | undefined;
    name: string | undefined;
    displayName: string | undefined;
    icon: string | undefined;
    isDisabled: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class CreateOrUpdateLanguageInput implements ICreateOrUpdateLanguageInput {
    language!: ApplicationLanguageEditDto;

    constructor(data?: ICreateOrUpdateLanguageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.language = new ApplicationLanguageEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"] ? ApplicationLanguageEditDto.fromJS(_data["language"]) : new ApplicationLanguageEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateLanguageInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLanguageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateLanguageInput {
    language: ApplicationLanguageEditDto;
}

export class GetLanguageForEditOutput implements IGetLanguageForEditOutput {
    language!: ApplicationLanguageEditDto;
    languageNames!: ComboboxItemDto[] | undefined;
    flags!: ComboboxItemDto[] | undefined;

    constructor(data?: IGetLanguageForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"] ? ApplicationLanguageEditDto.fromJS(_data["language"]) : <any>undefined;
            if (Array.isArray(_data["languageNames"])) {
                this.languageNames = [] as any;
                for (let item of _data["languageNames"])
                    this.languageNames!.push(ComboboxItemDto.fromJS(item));
            }
            if (Array.isArray(_data["flags"])) {
                this.flags = [] as any;
                for (let item of _data["flags"])
                    this.flags!.push(ComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLanguageForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLanguageForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        if (Array.isArray(this.languageNames)) {
            data["languageNames"] = [];
            for (let item of this.languageNames)
                data["languageNames"].push(item.toJSON());
        }
        if (Array.isArray(this.flags)) {
            data["flags"] = [];
            for (let item of this.flags)
                data["flags"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetLanguageForEditOutput {
    language: ApplicationLanguageEditDto;
    languageNames: ComboboxItemDto[] | undefined;
    flags: ComboboxItemDto[] | undefined;
}

export class GetLanguagesOutput implements IGetLanguagesOutput {
    defaultLanguageName!: string | undefined;
    items!: ApplicationLanguageListDto[] | undefined;

    constructor(data?: IGetLanguagesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultLanguageName = _data["defaultLanguageName"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApplicationLanguageListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLanguagesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLanguagesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultLanguageName"] = this.defaultLanguageName;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetLanguagesOutput {
    defaultLanguageName: string | undefined;
    items: ApplicationLanguageListDto[] | undefined;
}

export class LanguageTextListDto implements ILanguageTextListDto {
    key!: string | undefined;
    baseValue!: string | undefined;
    targetValue!: string | undefined;

    constructor(data?: ILanguageTextListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.baseValue = _data["baseValue"];
            this.targetValue = _data["targetValue"];
        }
    }

    static fromJS(data: any): LanguageTextListDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageTextListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["baseValue"] = this.baseValue;
        data["targetValue"] = this.targetValue;
        return data;
    }
}

export interface ILanguageTextListDto {
    key: string | undefined;
    baseValue: string | undefined;
    targetValue: string | undefined;
}

export class SetDefaultLanguageInput implements ISetDefaultLanguageInput {
    name!: string;

    constructor(data?: ISetDefaultLanguageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SetDefaultLanguageInput {
        data = typeof data === 'object' ? data : {};
        let result = new SetDefaultLanguageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ISetDefaultLanguageInput {
    name: string;
}

export class UpdateLanguageTextInput implements IUpdateLanguageTextInput {
    languageName!: string;
    sourceName!: string;
    key!: string;
    value!: string;

    constructor(data?: IUpdateLanguageTextInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
            this.sourceName = _data["sourceName"];
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UpdateLanguageTextInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLanguageTextInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        data["sourceName"] = this.sourceName;
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IUpdateLanguageTextInput {
    languageName: string;
    sourceName: string;
    key: string;
    value: string;
}

export class GetLatestWebLogsOutput implements IGetLatestWebLogsOutput {
    latestWebLogLines!: string[] | undefined;

    constructor(data?: IGetLatestWebLogsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["latestWebLogLines"])) {
                this.latestWebLogLines = [] as any;
                for (let item of _data["latestWebLogLines"])
                    this.latestWebLogLines!.push(item);
            }
        }
    }

    static fromJS(data: any): GetLatestWebLogsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLatestWebLogsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.latestWebLogLines)) {
            data["latestWebLogLines"] = [];
            for (let item of this.latestWebLogLines)
                data["latestWebLogLines"].push(item);
        }
        return data;
    }
}

export interface IGetLatestWebLogsOutput {
    latestWebLogLines: string[] | undefined;
}

export class AddEmailToMailDistributionListInput implements IAddEmailToMailDistributionListInput {
    mailDistributionListId!: number;
    name!: string | undefined;
    emailAddress!: string | undefined;

    constructor(data?: IAddEmailToMailDistributionListInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailDistributionListId = _data["mailDistributionListId"];
            this.name = _data["name"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): AddEmailToMailDistributionListInput {
        data = typeof data === 'object' ? data : {};
        let result = new AddEmailToMailDistributionListInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailDistributionListId"] = this.mailDistributionListId;
        data["name"] = this.name;
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface IAddEmailToMailDistributionListInput {
    mailDistributionListId: number;
    name: string | undefined;
    emailAddress: string | undefined;
}

export class AddUsersToMailDistributionListInput implements IAddUsersToMailDistributionListInput {
    userIds!: number[] | undefined;
    mailDistributionListId!: number;

    constructor(data?: IAddUsersToMailDistributionListInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            this.mailDistributionListId = _data["mailDistributionListId"];
        }
    }

    static fromJS(data: any): AddUsersToMailDistributionListInput {
        data = typeof data === 'object' ? data : {};
        let result = new AddUsersToMailDistributionListInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["mailDistributionListId"] = this.mailDistributionListId;
        return data;
    }
}

export interface IAddUsersToMailDistributionListInput {
    userIds: number[] | undefined;
    mailDistributionListId: number;
}

export class CreateMailDistributionListInput implements ICreateMailDistributionListInput {
    displayName!: string;

    constructor(data?: ICreateMailDistributionListInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): CreateMailDistributionListInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMailDistributionListInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ICreateMailDistributionListInput {
    displayName: string;
}

export class FindMailDistributionListDataInput implements IFindMailDistributionListDataInput {
    mailDistributionListId!: number;
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | undefined;

    constructor(data?: IFindMailDistributionListDataInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailDistributionListId = _data["mailDistributionListId"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): FindMailDistributionListDataInput {
        data = typeof data === 'object' ? data : {};
        let result = new FindMailDistributionListDataInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailDistributionListId"] = this.mailDistributionListId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data;
    }
}

export interface IFindMailDistributionListDataInput {
    mailDistributionListId: number;
    maxResultCount: number;
    skipCount: number;
    filter: string | undefined;
}

export class MailDistributionListConfigurationsDto implements IMailDistributionListConfigurationsDto {
    mailDistributionListId!: number;
    eventType!: MailDistributionEventType[] | undefined;

    constructor(data?: IMailDistributionListConfigurationsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailDistributionListId = _data["mailDistributionListId"];
            if (Array.isArray(_data["eventType"])) {
                this.eventType = [] as any;
                for (let item of _data["eventType"])
                    this.eventType!.push(item);
            }
        }
    }

    static fromJS(data: any): MailDistributionListConfigurationsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MailDistributionListConfigurationsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailDistributionListId"] = this.mailDistributionListId;
        if (Array.isArray(this.eventType)) {
            data["eventType"] = [];
            for (let item of this.eventType)
                data["eventType"].push(item);
        }
        return data;
    }
}

export interface IMailDistributionListConfigurationsDto {
    mailDistributionListId: number;
    eventType: MailDistributionEventType[] | undefined;
}

export class MailDistributionListDto implements IMailDistributionListDto {
    displayName!: string | undefined;
    memberCount!: number;
    emailCount!: number;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IMailDistributionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.memberCount = _data["memberCount"];
            this.emailCount = _data["emailCount"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MailDistributionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new MailDistributionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["memberCount"] = this.memberCount;
        data["emailCount"] = this.emailCount;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IMailDistributionListDto {
    displayName: string | undefined;
    memberCount: number;
    emailCount: number;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class MailDistributionListEmailListDto implements IMailDistributionListEmailListDto {
    name!: string | undefined;
    emailAddress!: string | undefined;
    id!: number;

    constructor(data?: IMailDistributionListEmailListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.emailAddress = _data["emailAddress"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MailDistributionListEmailListDto {
        data = typeof data === 'object' ? data : {};
        let result = new MailDistributionListEmailListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["emailAddress"] = this.emailAddress;
        data["id"] = this.id;
        return data;
    }
}

export interface IMailDistributionListEmailListDto {
    name: string | undefined;
    emailAddress: string | undefined;
    id: number;
}

export class MailDistributionListUserListDto implements IMailDistributionListUserListDto {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    profilePictureId!: string | undefined;
    id!: number;

    constructor(data?: IMailDistributionListUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.profilePictureId = _data["profilePictureId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MailDistributionListUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new MailDistributionListUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["id"] = this.id;
        return data;
    }
}

export interface IMailDistributionListUserListDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;
    id: number;
}

export class UpdateMailDistributionListInput implements IUpdateMailDistributionListInput {
    id!: number;
    displayName!: string;

    constructor(data?: IUpdateMailDistributionListInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): UpdateMailDistributionListInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMailDistributionListInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IUpdateMailDistributionListInput {
    id: number;
    displayName: string;
}

export enum MailDistributionEventType {
    DefaultPendenceReminder = 1,
}

export class GetMedRegPersonDetailedOutput implements IGetMedRegPersonDetailedOutput {
    medRegWholePerson!: MedRegWholePersonDetailedDto;

    constructor(data?: IGetMedRegPersonDetailedOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medRegWholePerson = _data["medRegWholePerson"] ? MedRegWholePersonDetailedDto.fromJS(_data["medRegWholePerson"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMedRegPersonDetailedOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMedRegPersonDetailedOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medRegWholePerson"] = this.medRegWholePerson ? this.medRegWholePerson.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMedRegPersonDetailedOutput {
    medRegWholePerson: MedRegWholePersonDetailedDto;
}

export class GetMedRegPersonOutput implements IGetMedRegPersonOutput {
    medRegWholePerson!: MedRegWholePersonDto;

    constructor(data?: IGetMedRegPersonOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medRegWholePerson = _data["medRegWholePerson"] ? MedRegWholePersonDto.fromJS(_data["medRegWholePerson"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMedRegPersonOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMedRegPersonOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medRegWholePerson"] = this.medRegWholePerson ? this.medRegWholePerson.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMedRegPersonOutput {
    medRegWholePerson: MedRegWholePersonDto;
}

export class MedRegAuflageEinschraenkungDto implements IMedRegAuflageEinschraenkungDto {
    typ!: HealthRegisterCodeDto;
    readonly datumEntscheid!: DateTime | undefined;
    readonly datumBefristung!: DateTime | undefined;
    readonly beschreibung!: string | undefined;
    readonly bezeichnung!: string | undefined;
    id!: number;

    constructor(data?: IMedRegAuflageEinschraenkungDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typ = _data["typ"] ? HealthRegisterCodeDto.fromJS(_data["typ"]) : <any>undefined;
            (<any>this).datumEntscheid = _data["datumEntscheid"] ? DateTime.fromISO(_data["datumEntscheid"].toString()) : <any>undefined;
            (<any>this).datumBefristung = _data["datumBefristung"] ? DateTime.fromISO(_data["datumBefristung"].toString()) : <any>undefined;
            (<any>this).beschreibung = _data["beschreibung"];
            (<any>this).bezeichnung = _data["bezeichnung"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedRegAuflageEinschraenkungDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedRegAuflageEinschraenkungDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typ"] = this.typ ? this.typ.toJSON() : <any>undefined;
        data["datumEntscheid"] = this.datumEntscheid ? this.datumEntscheid.toFormat('yyyy-MM-dd') : <any>undefined;
        data["datumBefristung"] = this.datumBefristung ? this.datumBefristung.toFormat('yyyy-MM-dd') : <any>undefined;
        data["beschreibung"] = this.beschreibung;
        data["bezeichnung"] = this.bezeichnung;
        data["id"] = this.id;
        return data;
    }
}

export interface IMedRegAuflageEinschraenkungDto {
    typ: HealthRegisterCodeDto;
    datumEntscheid: DateTime | undefined;
    datumBefristung: DateTime | undefined;
    beschreibung: string | undefined;
    bezeichnung: string | undefined;
    id: number;
}

export class MedRegBeschaeftigungDto implements IMedRegBeschaeftigungDto {
    typ!: HealthRegisterCodeDto;
    readonly betriebsname!: string | undefined;
    einzelunternehmerIn!: HealthRegisterCodeDto;
    rechtsformJuristischePerson!: HealthRegisterCodeDto;
    readonly uidNumberJuristischePerson!: string | undefined;
    readonly idRole!: string | undefined;
    readonly strasse!: string | undefined;
    readonly hausnummer!: string | undefined;
    readonly plz!: string | undefined;
    readonly ort!: string | undefined;
    readonly zusatz1!: string | undefined;
    readonly zusatz2!: string | undefined;
    readonly telefon!: string | undefined;
    readonly telefon2!: string | undefined;
    readonly mobil!: string | undefined;
    readonly fax!: string | undefined;
    readonly eMail!: string | undefined;
    readonly beschreibung!: string | undefined;
    readonly bemerkungen!: string | undefined;
    selbstdispensationsbewilligung!: HealthRegisterCodeDto;
    readonly selbstdispensationBemerkung!: string | undefined;
    id!: number;

    constructor(data?: IMedRegBeschaeftigungDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typ = _data["typ"] ? HealthRegisterCodeDto.fromJS(_data["typ"]) : <any>undefined;
            (<any>this).betriebsname = _data["betriebsname"];
            this.einzelunternehmerIn = _data["einzelunternehmerIn"] ? HealthRegisterCodeDto.fromJS(_data["einzelunternehmerIn"]) : <any>undefined;
            this.rechtsformJuristischePerson = _data["rechtsformJuristischePerson"] ? HealthRegisterCodeDto.fromJS(_data["rechtsformJuristischePerson"]) : <any>undefined;
            (<any>this).uidNumberJuristischePerson = _data["uidNumberJuristischePerson"];
            (<any>this).idRole = _data["idRole"];
            (<any>this).strasse = _data["strasse"];
            (<any>this).hausnummer = _data["hausnummer"];
            (<any>this).plz = _data["plz"];
            (<any>this).ort = _data["ort"];
            (<any>this).zusatz1 = _data["zusatz1"];
            (<any>this).zusatz2 = _data["zusatz2"];
            (<any>this).telefon = _data["telefon"];
            (<any>this).telefon2 = _data["telefon2"];
            (<any>this).mobil = _data["mobil"];
            (<any>this).fax = _data["fax"];
            (<any>this).eMail = _data["eMail"];
            (<any>this).beschreibung = _data["beschreibung"];
            (<any>this).bemerkungen = _data["bemerkungen"];
            this.selbstdispensationsbewilligung = _data["selbstdispensationsbewilligung"] ? HealthRegisterCodeDto.fromJS(_data["selbstdispensationsbewilligung"]) : <any>undefined;
            (<any>this).selbstdispensationBemerkung = _data["selbstdispensationBemerkung"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedRegBeschaeftigungDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedRegBeschaeftigungDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typ"] = this.typ ? this.typ.toJSON() : <any>undefined;
        data["betriebsname"] = this.betriebsname;
        data["einzelunternehmerIn"] = this.einzelunternehmerIn ? this.einzelunternehmerIn.toJSON() : <any>undefined;
        data["rechtsformJuristischePerson"] = this.rechtsformJuristischePerson ? this.rechtsformJuristischePerson.toJSON() : <any>undefined;
        data["uidNumberJuristischePerson"] = this.uidNumberJuristischePerson;
        data["idRole"] = this.idRole;
        data["strasse"] = this.strasse;
        data["hausnummer"] = this.hausnummer;
        data["plz"] = this.plz;
        data["ort"] = this.ort;
        data["zusatz1"] = this.zusatz1;
        data["zusatz2"] = this.zusatz2;
        data["telefon"] = this.telefon;
        data["telefon2"] = this.telefon2;
        data["mobil"] = this.mobil;
        data["fax"] = this.fax;
        data["eMail"] = this.eMail;
        data["beschreibung"] = this.beschreibung;
        data["bemerkungen"] = this.bemerkungen;
        data["selbstdispensationsbewilligung"] = this.selbstdispensationsbewilligung ? this.selbstdispensationsbewilligung.toJSON() : <any>undefined;
        data["selbstdispensationBemerkung"] = this.selbstdispensationBemerkung;
        data["id"] = this.id;
        return data;
    }
}

export interface IMedRegBeschaeftigungDto {
    typ: HealthRegisterCodeDto;
    betriebsname: string | undefined;
    einzelunternehmerIn: HealthRegisterCodeDto;
    rechtsformJuristischePerson: HealthRegisterCodeDto;
    uidNumberJuristischePerson: string | undefined;
    idRole: string | undefined;
    strasse: string | undefined;
    hausnummer: string | undefined;
    plz: string | undefined;
    ort: string | undefined;
    zusatz1: string | undefined;
    zusatz2: string | undefined;
    telefon: string | undefined;
    telefon2: string | undefined;
    mobil: string | undefined;
    fax: string | undefined;
    eMail: string | undefined;
    beschreibung: string | undefined;
    bemerkungen: string | undefined;
    selbstdispensationsbewilligung: HealthRegisterCodeDto;
    selbstdispensationBemerkung: string | undefined;
    id: number;
}

export class MedRegBewilligungDto implements IMedRegBewilligungDto {
    typ!: HealthRegisterCodeDto;
    diplomArt!: HealthRegisterCodeDto;
    kanton!: HealthRegisterCodeDto;
    status!: HealthRegisterCodeDto;
    dienstleistungserbringerStatus!: HealthRegisterCodeDto;
    readonly datumEntscheid!: DateTime | undefined;
    datumBefristung!: DateTime | undefined;
    readonly bewilligungBefristungBenachrichtigungId!: number | undefined;
    datumPraxiseroeffnung!: DateTime | undefined;
    readonly datumPraxisaufgabe!: DateTime | undefined;
    readonly beschreibung!: string | undefined;
    readonly bemerkung!: string | undefined;
    readonly kantBerechtigungKvgId!: number;
    btmUmfang!: HealthRegisterCodeDto;
    readonly btmBemerkung!: string | undefined;
    aktivitaet!: HealthRegisterCodeDto;
    aktivitaetLabel!: HealthRegisterLabelDto;
    readonly datumAktivitaet!: DateTime | undefined;
    medRegBeschaeftigungen!: MedRegBeschaeftigungDto[] | undefined;
    medRegAuflagenEinschraenkungen!: MedRegAuflageEinschraenkungDto[] | undefined;
    id!: number;

    constructor(data?: IMedRegBewilligungDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typ = _data["typ"] ? HealthRegisterCodeDto.fromJS(_data["typ"]) : <any>undefined;
            this.diplomArt = _data["diplomArt"] ? HealthRegisterCodeDto.fromJS(_data["diplomArt"]) : <any>undefined;
            this.kanton = _data["kanton"] ? HealthRegisterCodeDto.fromJS(_data["kanton"]) : <any>undefined;
            this.status = _data["status"] ? HealthRegisterCodeDto.fromJS(_data["status"]) : <any>undefined;
            this.dienstleistungserbringerStatus = _data["dienstleistungserbringerStatus"] ? HealthRegisterCodeDto.fromJS(_data["dienstleistungserbringerStatus"]) : <any>undefined;
            (<any>this).datumEntscheid = _data["datumEntscheid"] ? DateTime.fromISO(_data["datumEntscheid"].toString()) : <any>undefined;
            this.datumBefristung = _data["datumBefristung"] ? DateTime.fromISO(_data["datumBefristung"].toString()) : <any>undefined;
            (<any>this).bewilligungBefristungBenachrichtigungId = _data["bewilligungBefristungBenachrichtigungId"];
            this.datumPraxiseroeffnung = _data["datumPraxiseroeffnung"] ? DateTime.fromISO(_data["datumPraxiseroeffnung"].toString()) : <any>undefined;
            (<any>this).datumPraxisaufgabe = _data["datumPraxisaufgabe"] ? DateTime.fromISO(_data["datumPraxisaufgabe"].toString()) : <any>undefined;
            (<any>this).beschreibung = _data["beschreibung"];
            (<any>this).bemerkung = _data["bemerkung"];
            (<any>this).kantBerechtigungKvgId = _data["kantBerechtigungKvgId"];
            this.btmUmfang = _data["btmUmfang"] ? HealthRegisterCodeDto.fromJS(_data["btmUmfang"]) : <any>undefined;
            (<any>this).btmBemerkung = _data["btmBemerkung"];
            this.aktivitaet = _data["aktivitaet"] ? HealthRegisterCodeDto.fromJS(_data["aktivitaet"]) : <any>undefined;
            this.aktivitaetLabel = _data["aktivitaetLabel"] ? HealthRegisterLabelDto.fromJS(_data["aktivitaetLabel"]) : <any>undefined;
            (<any>this).datumAktivitaet = _data["datumAktivitaet"] ? DateTime.fromISO(_data["datumAktivitaet"].toString()) : <any>undefined;
            if (Array.isArray(_data["medRegBeschaeftigungen"])) {
                this.medRegBeschaeftigungen = [] as any;
                for (let item of _data["medRegBeschaeftigungen"])
                    this.medRegBeschaeftigungen!.push(MedRegBeschaeftigungDto.fromJS(item));
            }
            if (Array.isArray(_data["medRegAuflagenEinschraenkungen"])) {
                this.medRegAuflagenEinschraenkungen = [] as any;
                for (let item of _data["medRegAuflagenEinschraenkungen"])
                    this.medRegAuflagenEinschraenkungen!.push(MedRegAuflageEinschraenkungDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedRegBewilligungDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedRegBewilligungDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typ"] = this.typ ? this.typ.toJSON() : <any>undefined;
        data["diplomArt"] = this.diplomArt ? this.diplomArt.toJSON() : <any>undefined;
        data["kanton"] = this.kanton ? this.kanton.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["dienstleistungserbringerStatus"] = this.dienstleistungserbringerStatus ? this.dienstleistungserbringerStatus.toJSON() : <any>undefined;
        data["datumEntscheid"] = this.datumEntscheid ? this.datumEntscheid.toFormat('yyyy-MM-dd') : <any>undefined;
        data["datumBefristung"] = this.datumBefristung ? this.datumBefristung.toFormat('yyyy-MM-dd') : <any>undefined;
        data["bewilligungBefristungBenachrichtigungId"] = this.bewilligungBefristungBenachrichtigungId;
        data["datumPraxiseroeffnung"] = this.datumPraxiseroeffnung ? this.datumPraxiseroeffnung.toFormat('yyyy-MM-dd') : <any>undefined;
        data["datumPraxisaufgabe"] = this.datumPraxisaufgabe ? this.datumPraxisaufgabe.toFormat('yyyy-MM-dd') : <any>undefined;
        data["beschreibung"] = this.beschreibung;
        data["bemerkung"] = this.bemerkung;
        data["kantBerechtigungKvgId"] = this.kantBerechtigungKvgId;
        data["btmUmfang"] = this.btmUmfang ? this.btmUmfang.toJSON() : <any>undefined;
        data["btmBemerkung"] = this.btmBemerkung;
        data["aktivitaet"] = this.aktivitaet ? this.aktivitaet.toJSON() : <any>undefined;
        data["aktivitaetLabel"] = this.aktivitaetLabel ? this.aktivitaetLabel.toJSON() : <any>undefined;
        data["datumAktivitaet"] = this.datumAktivitaet ? this.datumAktivitaet.toFormat('yyyy-MM-dd') : <any>undefined;
        if (Array.isArray(this.medRegBeschaeftigungen)) {
            data["medRegBeschaeftigungen"] = [];
            for (let item of this.medRegBeschaeftigungen)
                data["medRegBeschaeftigungen"].push(item.toJSON());
        }
        if (Array.isArray(this.medRegAuflagenEinschraenkungen)) {
            data["medRegAuflagenEinschraenkungen"] = [];
            for (let item of this.medRegAuflagenEinschraenkungen)
                data["medRegAuflagenEinschraenkungen"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IMedRegBewilligungDto {
    typ: HealthRegisterCodeDto;
    diplomArt: HealthRegisterCodeDto;
    kanton: HealthRegisterCodeDto;
    status: HealthRegisterCodeDto;
    dienstleistungserbringerStatus: HealthRegisterCodeDto;
    datumEntscheid: DateTime | undefined;
    datumBefristung: DateTime | undefined;
    bewilligungBefristungBenachrichtigungId: number | undefined;
    datumPraxiseroeffnung: DateTime | undefined;
    datumPraxisaufgabe: DateTime | undefined;
    beschreibung: string | undefined;
    bemerkung: string | undefined;
    kantBerechtigungKvgId: number;
    btmUmfang: HealthRegisterCodeDto;
    btmBemerkung: string | undefined;
    aktivitaet: HealthRegisterCodeDto;
    aktivitaetLabel: HealthRegisterLabelDto;
    datumAktivitaet: DateTime | undefined;
    medRegBeschaeftigungen: MedRegBeschaeftigungDto[] | undefined;
    medRegAuflagenEinschraenkungen: MedRegAuflageEinschraenkungDto[] | undefined;
    id: number;
}

export class MedRegDiplomDto implements IMedRegDiplomDto {
    art!: HealthRegisterCodeDto;
    typ!: HealthRegisterCodeDto;
    readonly datumErteilung!: DateTime | undefined;
    readonly ortErteilung!: string | undefined;
    land!: HealthRegisterCodeDto;
    readonly datumAnerkennungCH!: DateTime | undefined;
    readonly datumGleichwertigkeit!: DateTime | undefined;
    readonly medizinalpersonId!: number | undefined;
    medRegBewilligungen!: MedRegBewilligungDto[] | undefined;
    id!: number;

    constructor(data?: IMedRegDiplomDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.art = _data["art"] ? HealthRegisterCodeDto.fromJS(_data["art"]) : <any>undefined;
            this.typ = _data["typ"] ? HealthRegisterCodeDto.fromJS(_data["typ"]) : <any>undefined;
            (<any>this).datumErteilung = _data["datumErteilung"] ? DateTime.fromISO(_data["datumErteilung"].toString()) : <any>undefined;
            (<any>this).ortErteilung = _data["ortErteilung"];
            this.land = _data["land"] ? HealthRegisterCodeDto.fromJS(_data["land"]) : <any>undefined;
            (<any>this).datumAnerkennungCH = _data["datumAnerkennungCH"] ? DateTime.fromISO(_data["datumAnerkennungCH"].toString()) : <any>undefined;
            (<any>this).datumGleichwertigkeit = _data["datumGleichwertigkeit"] ? DateTime.fromISO(_data["datumGleichwertigkeit"].toString()) : <any>undefined;
            (<any>this).medizinalpersonId = _data["medizinalpersonId"];
            if (Array.isArray(_data["medRegBewilligungen"])) {
                this.medRegBewilligungen = [] as any;
                for (let item of _data["medRegBewilligungen"])
                    this.medRegBewilligungen!.push(MedRegBewilligungDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedRegDiplomDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedRegDiplomDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["art"] = this.art ? this.art.toJSON() : <any>undefined;
        data["typ"] = this.typ ? this.typ.toJSON() : <any>undefined;
        data["datumErteilung"] = this.datumErteilung ? this.datumErteilung.toFormat('yyyy-MM-dd') : <any>undefined;
        data["ortErteilung"] = this.ortErteilung;
        data["land"] = this.land ? this.land.toJSON() : <any>undefined;
        data["datumAnerkennungCH"] = this.datumAnerkennungCH ? this.datumAnerkennungCH.toFormat('yyyy-MM-dd') : <any>undefined;
        data["datumGleichwertigkeit"] = this.datumGleichwertigkeit ? this.datumGleichwertigkeit.toFormat('yyyy-MM-dd') : <any>undefined;
        data["medizinalpersonId"] = this.medizinalpersonId;
        if (Array.isArray(this.medRegBewilligungen)) {
            data["medRegBewilligungen"] = [];
            for (let item of this.medRegBewilligungen)
                data["medRegBewilligungen"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IMedRegDiplomDto {
    art: HealthRegisterCodeDto;
    typ: HealthRegisterCodeDto;
    datumErteilung: DateTime | undefined;
    ortErteilung: string | undefined;
    land: HealthRegisterCodeDto;
    datumAnerkennungCH: DateTime | undefined;
    datumGleichwertigkeit: DateTime | undefined;
    medizinalpersonId: number | undefined;
    medRegBewilligungen: MedRegBewilligungDto[] | undefined;
    id: number;
}

export class MedRegPersonDetailedDto implements IMedRegPersonDetailedDto {
    geburtsdatum!: DateTime | undefined;
    sterbedatum!: DateTime | undefined;
    weitereInfoVorhanden!: boolean | undefined;
    schuetzenswertGemKantRecht!: boolean | undefined;
    loeschdatum!: DateTime | undefined;
    anonymisierungsdatum!: DateTime | undefined;
    cantonalLicenceRestrictions!: string[] | undefined;
    ahvNr!: string | undefined;
    gln!: string | undefined;
    nachname!: string | undefined;
    vorname!: string | undefined;
    ledigerName!: string | undefined;
    heimatort!: string | undefined;
    uidNumber!: string | undefined;
    geschlecht!: HealthRegisterCodeDto;
    uidStatus!: number | undefined;
    uidOrganisation!: number | undefined;
    uidAnfragedatum!: DateTime | undefined;
    geburtsjahr!: string | undefined;
    korrespondenzsprache!: HealthRegisterCodeDto;
    nationalitaet1!: HealthRegisterCodeDto;
    nationalitaet2!: HealthRegisterCodeDto;
    dataOwner!: number | undefined;
    sprachkompetenzen!: HealthRegisterCodeDto[] | undefined;
    id!: number;

    constructor(data?: IMedRegPersonDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.geburtsdatum = _data["geburtsdatum"] ? DateTime.fromISO(_data["geburtsdatum"].toString()) : <any>undefined;
            this.sterbedatum = _data["sterbedatum"] ? DateTime.fromISO(_data["sterbedatum"].toString()) : <any>undefined;
            this.weitereInfoVorhanden = _data["weitereInfoVorhanden"];
            this.schuetzenswertGemKantRecht = _data["schuetzenswertGemKantRecht"];
            this.loeschdatum = _data["loeschdatum"] ? DateTime.fromISO(_data["loeschdatum"].toString()) : <any>undefined;
            this.anonymisierungsdatum = _data["anonymisierungsdatum"] ? DateTime.fromISO(_data["anonymisierungsdatum"].toString()) : <any>undefined;
            if (Array.isArray(_data["cantonalLicenceRestrictions"])) {
                this.cantonalLicenceRestrictions = [] as any;
                for (let item of _data["cantonalLicenceRestrictions"])
                    this.cantonalLicenceRestrictions!.push(item);
            }
            this.ahvNr = _data["ahvNr"];
            this.gln = _data["gln"];
            this.nachname = _data["nachname"];
            this.vorname = _data["vorname"];
            this.ledigerName = _data["ledigerName"];
            this.heimatort = _data["heimatort"];
            this.uidNumber = _data["uidNumber"];
            this.geschlecht = _data["geschlecht"] ? HealthRegisterCodeDto.fromJS(_data["geschlecht"]) : <any>undefined;
            this.uidStatus = _data["uidStatus"];
            this.uidOrganisation = _data["uidOrganisation"];
            this.uidAnfragedatum = _data["uidAnfragedatum"] ? DateTime.fromISO(_data["uidAnfragedatum"].toString()) : <any>undefined;
            this.geburtsjahr = _data["geburtsjahr"];
            this.korrespondenzsprache = _data["korrespondenzsprache"] ? HealthRegisterCodeDto.fromJS(_data["korrespondenzsprache"]) : <any>undefined;
            this.nationalitaet1 = _data["nationalitaet1"] ? HealthRegisterCodeDto.fromJS(_data["nationalitaet1"]) : <any>undefined;
            this.nationalitaet2 = _data["nationalitaet2"] ? HealthRegisterCodeDto.fromJS(_data["nationalitaet2"]) : <any>undefined;
            this.dataOwner = _data["dataOwner"];
            if (Array.isArray(_data["sprachkompetenzen"])) {
                this.sprachkompetenzen = [] as any;
                for (let item of _data["sprachkompetenzen"])
                    this.sprachkompetenzen!.push(HealthRegisterCodeDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedRegPersonDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedRegPersonDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["geburtsdatum"] = this.geburtsdatum ? this.geburtsdatum.toFormat('yyyy-MM-dd') : <any>undefined;
        data["sterbedatum"] = this.sterbedatum ? this.sterbedatum.toFormat('yyyy-MM-dd') : <any>undefined;
        data["weitereInfoVorhanden"] = this.weitereInfoVorhanden;
        data["schuetzenswertGemKantRecht"] = this.schuetzenswertGemKantRecht;
        data["loeschdatum"] = this.loeschdatum ? this.loeschdatum.toFormat('yyyy-MM-dd') : <any>undefined;
        data["anonymisierungsdatum"] = this.anonymisierungsdatum ? this.anonymisierungsdatum.toFormat('yyyy-MM-dd') : <any>undefined;
        if (Array.isArray(this.cantonalLicenceRestrictions)) {
            data["cantonalLicenceRestrictions"] = [];
            for (let item of this.cantonalLicenceRestrictions)
                data["cantonalLicenceRestrictions"].push(item);
        }
        data["ahvNr"] = this.ahvNr;
        data["gln"] = this.gln;
        data["nachname"] = this.nachname;
        data["vorname"] = this.vorname;
        data["ledigerName"] = this.ledigerName;
        data["heimatort"] = this.heimatort;
        data["uidNumber"] = this.uidNumber;
        data["geschlecht"] = this.geschlecht ? this.geschlecht.toJSON() : <any>undefined;
        data["uidStatus"] = this.uidStatus;
        data["uidOrganisation"] = this.uidOrganisation;
        data["uidAnfragedatum"] = this.uidAnfragedatum ? this.uidAnfragedatum.toString() : <any>undefined;
        data["geburtsjahr"] = this.geburtsjahr;
        data["korrespondenzsprache"] = this.korrespondenzsprache ? this.korrespondenzsprache.toJSON() : <any>undefined;
        data["nationalitaet1"] = this.nationalitaet1 ? this.nationalitaet1.toJSON() : <any>undefined;
        data["nationalitaet2"] = this.nationalitaet2 ? this.nationalitaet2.toJSON() : <any>undefined;
        data["dataOwner"] = this.dataOwner;
        if (Array.isArray(this.sprachkompetenzen)) {
            data["sprachkompetenzen"] = [];
            for (let item of this.sprachkompetenzen)
                data["sprachkompetenzen"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IMedRegPersonDetailedDto {
    geburtsdatum: DateTime | undefined;
    sterbedatum: DateTime | undefined;
    weitereInfoVorhanden: boolean | undefined;
    schuetzenswertGemKantRecht: boolean | undefined;
    loeschdatum: DateTime | undefined;
    anonymisierungsdatum: DateTime | undefined;
    cantonalLicenceRestrictions: string[] | undefined;
    ahvNr: string | undefined;
    gln: string | undefined;
    nachname: string | undefined;
    vorname: string | undefined;
    ledigerName: string | undefined;
    heimatort: string | undefined;
    uidNumber: string | undefined;
    geschlecht: HealthRegisterCodeDto;
    uidStatus: number | undefined;
    uidOrganisation: number | undefined;
    uidAnfragedatum: DateTime | undefined;
    geburtsjahr: string | undefined;
    korrespondenzsprache: HealthRegisterCodeDto;
    nationalitaet1: HealthRegisterCodeDto;
    nationalitaet2: HealthRegisterCodeDto;
    dataOwner: number | undefined;
    sprachkompetenzen: HealthRegisterCodeDto[] | undefined;
    id: number;
}

export class MedRegPersonDto implements IMedRegPersonDto {
    ahvNr!: string | undefined;
    gln!: string | undefined;
    nachname!: string | undefined;
    vorname!: string | undefined;
    ledigerName!: string | undefined;
    heimatort!: string | undefined;
    uidNumber!: string | undefined;
    geschlecht!: HealthRegisterCodeDto;
    uidStatus!: number | undefined;
    uidOrganisation!: number | undefined;
    uidAnfragedatum!: DateTime | undefined;
    geburtsjahr!: string | undefined;
    korrespondenzsprache!: HealthRegisterCodeDto;
    nationalitaet1!: HealthRegisterCodeDto;
    nationalitaet2!: HealthRegisterCodeDto;
    dataOwner!: number | undefined;
    sprachkompetenzen!: HealthRegisterCodeDto[] | undefined;
    id!: number;

    constructor(data?: IMedRegPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ahvNr = _data["ahvNr"];
            this.gln = _data["gln"];
            this.nachname = _data["nachname"];
            this.vorname = _data["vorname"];
            this.ledigerName = _data["ledigerName"];
            this.heimatort = _data["heimatort"];
            this.uidNumber = _data["uidNumber"];
            this.geschlecht = _data["geschlecht"] ? HealthRegisterCodeDto.fromJS(_data["geschlecht"]) : <any>undefined;
            this.uidStatus = _data["uidStatus"];
            this.uidOrganisation = _data["uidOrganisation"];
            this.uidAnfragedatum = _data["uidAnfragedatum"] ? DateTime.fromISO(_data["uidAnfragedatum"].toString()) : <any>undefined;
            this.geburtsjahr = _data["geburtsjahr"];
            this.korrespondenzsprache = _data["korrespondenzsprache"] ? HealthRegisterCodeDto.fromJS(_data["korrespondenzsprache"]) : <any>undefined;
            this.nationalitaet1 = _data["nationalitaet1"] ? HealthRegisterCodeDto.fromJS(_data["nationalitaet1"]) : <any>undefined;
            this.nationalitaet2 = _data["nationalitaet2"] ? HealthRegisterCodeDto.fromJS(_data["nationalitaet2"]) : <any>undefined;
            this.dataOwner = _data["dataOwner"];
            if (Array.isArray(_data["sprachkompetenzen"])) {
                this.sprachkompetenzen = [] as any;
                for (let item of _data["sprachkompetenzen"])
                    this.sprachkompetenzen!.push(HealthRegisterCodeDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedRegPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedRegPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ahvNr"] = this.ahvNr;
        data["gln"] = this.gln;
        data["nachname"] = this.nachname;
        data["vorname"] = this.vorname;
        data["ledigerName"] = this.ledigerName;
        data["heimatort"] = this.heimatort;
        data["uidNumber"] = this.uidNumber;
        data["geschlecht"] = this.geschlecht ? this.geschlecht.toJSON() : <any>undefined;
        data["uidStatus"] = this.uidStatus;
        data["uidOrganisation"] = this.uidOrganisation;
        data["uidAnfragedatum"] = this.uidAnfragedatum ? this.uidAnfragedatum.toString() : <any>undefined;
        data["geburtsjahr"] = this.geburtsjahr;
        data["korrespondenzsprache"] = this.korrespondenzsprache ? this.korrespondenzsprache.toJSON() : <any>undefined;
        data["nationalitaet1"] = this.nationalitaet1 ? this.nationalitaet1.toJSON() : <any>undefined;
        data["nationalitaet2"] = this.nationalitaet2 ? this.nationalitaet2.toJSON() : <any>undefined;
        data["dataOwner"] = this.dataOwner;
        if (Array.isArray(this.sprachkompetenzen)) {
            data["sprachkompetenzen"] = [];
            for (let item of this.sprachkompetenzen)
                data["sprachkompetenzen"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IMedRegPersonDto {
    ahvNr: string | undefined;
    gln: string | undefined;
    nachname: string | undefined;
    vorname: string | undefined;
    ledigerName: string | undefined;
    heimatort: string | undefined;
    uidNumber: string | undefined;
    geschlecht: HealthRegisterCodeDto;
    uidStatus: number | undefined;
    uidOrganisation: number | undefined;
    uidAnfragedatum: DateTime | undefined;
    geburtsjahr: string | undefined;
    korrespondenzsprache: HealthRegisterCodeDto;
    nationalitaet1: HealthRegisterCodeDto;
    nationalitaet2: HealthRegisterCodeDto;
    dataOwner: number | undefined;
    sprachkompetenzen: HealthRegisterCodeDto[] | undefined;
    id: number;
}

export class MedRegPwbDto implements IMedRegPwbDto {
    art!: HealthRegisterCodeDto;
    typ!: HealthRegisterCodeDto;
    readonly datumErteilung!: DateTime | undefined;
    readonly medizinalpersonId!: number | undefined;
    id!: number;

    constructor(data?: IMedRegPwbDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.art = _data["art"] ? HealthRegisterCodeDto.fromJS(_data["art"]) : <any>undefined;
            this.typ = _data["typ"] ? HealthRegisterCodeDto.fromJS(_data["typ"]) : <any>undefined;
            (<any>this).datumErteilung = _data["datumErteilung"] ? DateTime.fromISO(_data["datumErteilung"].toString()) : <any>undefined;
            (<any>this).medizinalpersonId = _data["medizinalpersonId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedRegPwbDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedRegPwbDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["art"] = this.art ? this.art.toJSON() : <any>undefined;
        data["typ"] = this.typ ? this.typ.toJSON() : <any>undefined;
        data["datumErteilung"] = this.datumErteilung ? this.datumErteilung.toFormat('yyyy-MM-dd') : <any>undefined;
        data["medizinalpersonId"] = this.medizinalpersonId;
        data["id"] = this.id;
        return data;
    }
}

export interface IMedRegPwbDto {
    art: HealthRegisterCodeDto;
    typ: HealthRegisterCodeDto;
    datumErteilung: DateTime | undefined;
    medizinalpersonId: number | undefined;
    id: number;
}

export class MedRegSearchPersonDto implements IMedRegSearchPersonDto {
    profession!: HealthRegisterCodeDto;
    lastName!: string | undefined;
    birthName!: string | undefined;
    firstName!: string | undefined;
    dateOfBirth!: DateTime | undefined;
    dateOfDeath!: DateTime | undefined;
    placeOfOrigin!: string | undefined;
    gender!: HealthRegisterCodeDto;
    ahv!: string | undefined;
    gln!: string | undefined;
    nationality1!: HealthRegisterCodeDto;
    nationality2!: HealthRegisterCodeDto;
    languageOfCorrespondence!: HealthRegisterCodeDto;
    languageSkills!: HealthRegisterCodeDto[] | undefined;
    id!: number;

    constructor(data?: IMedRegSearchPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profession = _data["profession"] ? HealthRegisterCodeDto.fromJS(_data["profession"]) : <any>undefined;
            this.lastName = _data["lastName"];
            this.birthName = _data["birthName"];
            this.firstName = _data["firstName"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.dateOfDeath = _data["dateOfDeath"] ? DateTime.fromISO(_data["dateOfDeath"].toString()) : <any>undefined;
            this.placeOfOrigin = _data["placeOfOrigin"];
            this.gender = _data["gender"] ? HealthRegisterCodeDto.fromJS(_data["gender"]) : <any>undefined;
            this.ahv = _data["ahv"];
            this.gln = _data["gln"];
            this.nationality1 = _data["nationality1"] ? HealthRegisterCodeDto.fromJS(_data["nationality1"]) : <any>undefined;
            this.nationality2 = _data["nationality2"] ? HealthRegisterCodeDto.fromJS(_data["nationality2"]) : <any>undefined;
            this.languageOfCorrespondence = _data["languageOfCorrespondence"] ? HealthRegisterCodeDto.fromJS(_data["languageOfCorrespondence"]) : <any>undefined;
            if (Array.isArray(_data["languageSkills"])) {
                this.languageSkills = [] as any;
                for (let item of _data["languageSkills"])
                    this.languageSkills!.push(HealthRegisterCodeDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedRegSearchPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedRegSearchPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profession"] = this.profession ? this.profession.toJSON() : <any>undefined;
        data["lastName"] = this.lastName;
        data["birthName"] = this.birthName;
        data["firstName"] = this.firstName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDeath"] = this.dateOfDeath ? this.dateOfDeath.toFormat('yyyy-MM-dd') : <any>undefined;
        data["placeOfOrigin"] = this.placeOfOrigin;
        data["gender"] = this.gender ? this.gender.toJSON() : <any>undefined;
        data["ahv"] = this.ahv;
        data["gln"] = this.gln;
        data["nationality1"] = this.nationality1 ? this.nationality1.toJSON() : <any>undefined;
        data["nationality2"] = this.nationality2 ? this.nationality2.toJSON() : <any>undefined;
        data["languageOfCorrespondence"] = this.languageOfCorrespondence ? this.languageOfCorrespondence.toJSON() : <any>undefined;
        if (Array.isArray(this.languageSkills)) {
            data["languageSkills"] = [];
            for (let item of this.languageSkills)
                data["languageSkills"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IMedRegSearchPersonDto {
    profession: HealthRegisterCodeDto;
    lastName: string | undefined;
    birthName: string | undefined;
    firstName: string | undefined;
    dateOfBirth: DateTime | undefined;
    dateOfDeath: DateTime | undefined;
    placeOfOrigin: string | undefined;
    gender: HealthRegisterCodeDto;
    ahv: string | undefined;
    gln: string | undefined;
    nationality1: HealthRegisterCodeDto;
    nationality2: HealthRegisterCodeDto;
    languageOfCorrespondence: HealthRegisterCodeDto;
    languageSkills: HealthRegisterCodeDto[] | undefined;
    id: number;
}

export class MedRegWbtDto implements IMedRegWbtDto {
    art!: HealthRegisterCodeDto;
    typ!: HealthRegisterCodeDto;
    readonly datumErteilung!: DateTime | undefined;
    readonly ortErteilung!: string | undefined;
    land!: HealthRegisterCodeDto;
    readonly datumAnerkennungCH!: DateTime | undefined;
    readonly datumGleichwertigkeit!: DateTime | undefined;
    readonly medizinalpersonId!: number | undefined;
    weiterbildungsartLabel!: HealthRegisterLabelDto;
    weiterbildungstypLabel!: HealthRegisterLabelDto;
    id!: number;

    constructor(data?: IMedRegWbtDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.art = _data["art"] ? HealthRegisterCodeDto.fromJS(_data["art"]) : <any>undefined;
            this.typ = _data["typ"] ? HealthRegisterCodeDto.fromJS(_data["typ"]) : <any>undefined;
            (<any>this).datumErteilung = _data["datumErteilung"] ? DateTime.fromISO(_data["datumErteilung"].toString()) : <any>undefined;
            (<any>this).ortErteilung = _data["ortErteilung"];
            this.land = _data["land"] ? HealthRegisterCodeDto.fromJS(_data["land"]) : <any>undefined;
            (<any>this).datumAnerkennungCH = _data["datumAnerkennungCH"] ? DateTime.fromISO(_data["datumAnerkennungCH"].toString()) : <any>undefined;
            (<any>this).datumGleichwertigkeit = _data["datumGleichwertigkeit"] ? DateTime.fromISO(_data["datumGleichwertigkeit"].toString()) : <any>undefined;
            (<any>this).medizinalpersonId = _data["medizinalpersonId"];
            this.weiterbildungsartLabel = _data["weiterbildungsartLabel"] ? HealthRegisterLabelDto.fromJS(_data["weiterbildungsartLabel"]) : <any>undefined;
            this.weiterbildungstypLabel = _data["weiterbildungstypLabel"] ? HealthRegisterLabelDto.fromJS(_data["weiterbildungstypLabel"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MedRegWbtDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedRegWbtDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["art"] = this.art ? this.art.toJSON() : <any>undefined;
        data["typ"] = this.typ ? this.typ.toJSON() : <any>undefined;
        data["datumErteilung"] = this.datumErteilung ? this.datumErteilung.toFormat('yyyy-MM-dd') : <any>undefined;
        data["ortErteilung"] = this.ortErteilung;
        data["land"] = this.land ? this.land.toJSON() : <any>undefined;
        data["datumAnerkennungCH"] = this.datumAnerkennungCH ? this.datumAnerkennungCH.toFormat('yyyy-MM-dd') : <any>undefined;
        data["datumGleichwertigkeit"] = this.datumGleichwertigkeit ? this.datumGleichwertigkeit.toFormat('yyyy-MM-dd') : <any>undefined;
        data["medizinalpersonId"] = this.medizinalpersonId;
        data["weiterbildungsartLabel"] = this.weiterbildungsartLabel ? this.weiterbildungsartLabel.toJSON() : <any>undefined;
        data["weiterbildungstypLabel"] = this.weiterbildungstypLabel ? this.weiterbildungstypLabel.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IMedRegWbtDto {
    art: HealthRegisterCodeDto;
    typ: HealthRegisterCodeDto;
    datumErteilung: DateTime | undefined;
    ortErteilung: string | undefined;
    land: HealthRegisterCodeDto;
    datumAnerkennungCH: DateTime | undefined;
    datumGleichwertigkeit: DateTime | undefined;
    medizinalpersonId: number | undefined;
    weiterbildungsartLabel: HealthRegisterLabelDto;
    weiterbildungstypLabel: HealthRegisterLabelDto;
    id: number;
}

export class MedRegWholePersonDetailedDto implements IMedRegWholePersonDetailedDto {
    person!: MedRegPersonDetailedDto;
    medRegDiplome!: MedRegDiplomDto[] | undefined;
    medRegPwbs!: MedRegPwbDto[] | undefined;
    medRegWbts!: MedRegWbtDto[] | undefined;
    queryTime!: DateTime | undefined;

    constructor(data?: IMedRegWholePersonDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.person = _data["person"] ? MedRegPersonDetailedDto.fromJS(_data["person"]) : <any>undefined;
            if (Array.isArray(_data["medRegDiplome"])) {
                this.medRegDiplome = [] as any;
                for (let item of _data["medRegDiplome"])
                    this.medRegDiplome!.push(MedRegDiplomDto.fromJS(item));
            }
            if (Array.isArray(_data["medRegPwbs"])) {
                this.medRegPwbs = [] as any;
                for (let item of _data["medRegPwbs"])
                    this.medRegPwbs!.push(MedRegPwbDto.fromJS(item));
            }
            if (Array.isArray(_data["medRegWbts"])) {
                this.medRegWbts = [] as any;
                for (let item of _data["medRegWbts"])
                    this.medRegWbts!.push(MedRegWbtDto.fromJS(item));
            }
            this.queryTime = _data["queryTime"] ? DateTime.fromISO(_data["queryTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MedRegWholePersonDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedRegWholePersonDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        if (Array.isArray(this.medRegDiplome)) {
            data["medRegDiplome"] = [];
            for (let item of this.medRegDiplome)
                data["medRegDiplome"].push(item.toJSON());
        }
        if (Array.isArray(this.medRegPwbs)) {
            data["medRegPwbs"] = [];
            for (let item of this.medRegPwbs)
                data["medRegPwbs"].push(item.toJSON());
        }
        if (Array.isArray(this.medRegWbts)) {
            data["medRegWbts"] = [];
            for (let item of this.medRegWbts)
                data["medRegWbts"].push(item.toJSON());
        }
        data["queryTime"] = this.queryTime ? this.queryTime.toString() : <any>undefined;
        return data;
    }
}

export interface IMedRegWholePersonDetailedDto {
    person: MedRegPersonDetailedDto;
    medRegDiplome: MedRegDiplomDto[] | undefined;
    medRegPwbs: MedRegPwbDto[] | undefined;
    medRegWbts: MedRegWbtDto[] | undefined;
    queryTime: DateTime | undefined;
}

export class MedRegWholePersonDto implements IMedRegWholePersonDto {
    person!: MedRegPersonDto;
    medRegDiplome!: MedRegDiplomDto[] | undefined;
    medRegPwbs!: MedRegPwbDto[] | undefined;
    medRegWbts!: MedRegWbtDto[] | undefined;
    queryTime!: DateTime | undefined;

    constructor(data?: IMedRegWholePersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.person = _data["person"] ? MedRegPersonDto.fromJS(_data["person"]) : <any>undefined;
            if (Array.isArray(_data["medRegDiplome"])) {
                this.medRegDiplome = [] as any;
                for (let item of _data["medRegDiplome"])
                    this.medRegDiplome!.push(MedRegDiplomDto.fromJS(item));
            }
            if (Array.isArray(_data["medRegPwbs"])) {
                this.medRegPwbs = [] as any;
                for (let item of _data["medRegPwbs"])
                    this.medRegPwbs!.push(MedRegPwbDto.fromJS(item));
            }
            if (Array.isArray(_data["medRegWbts"])) {
                this.medRegWbts = [] as any;
                for (let item of _data["medRegWbts"])
                    this.medRegWbts!.push(MedRegWbtDto.fromJS(item));
            }
            this.queryTime = _data["queryTime"] ? DateTime.fromISO(_data["queryTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MedRegWholePersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new MedRegWholePersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        if (Array.isArray(this.medRegDiplome)) {
            data["medRegDiplome"] = [];
            for (let item of this.medRegDiplome)
                data["medRegDiplome"].push(item.toJSON());
        }
        if (Array.isArray(this.medRegPwbs)) {
            data["medRegPwbs"] = [];
            for (let item of this.medRegPwbs)
                data["medRegPwbs"].push(item.toJSON());
        }
        if (Array.isArray(this.medRegWbts)) {
            data["medRegWbts"] = [];
            for (let item of this.medRegWbts)
                data["medRegWbts"].push(item.toJSON());
        }
        data["queryTime"] = this.queryTime ? this.queryTime.toString() : <any>undefined;
        return data;
    }
}

export interface IMedRegWholePersonDto {
    person: MedRegPersonDto;
    medRegDiplome: MedRegDiplomDto[] | undefined;
    medRegPwbs: MedRegPwbDto[] | undefined;
    medRegWbts: MedRegWbtDto[] | undefined;
    queryTime: DateTime | undefined;
}

export class SearchMedRegPersonInput implements ISearchMedRegPersonInput {
    professionId!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    genderId!: string | undefined;
    dateOfBirth!: DateTime | undefined;
    nationality1Id!: string | undefined;
    nationality2Id!: string | undefined;
    placeOfOrigin!: string | undefined;
    gln!: string | undefined;

    constructor(data?: ISearchMedRegPersonInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professionId = _data["professionId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.genderId = _data["genderId"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.nationality1Id = _data["nationality1Id"];
            this.nationality2Id = _data["nationality2Id"];
            this.placeOfOrigin = _data["placeOfOrigin"];
            this.gln = _data["gln"];
        }
    }

    static fromJS(data: any): SearchMedRegPersonInput {
        data = typeof data === 'object' ? data : {};
        let result = new SearchMedRegPersonInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professionId"] = this.professionId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["genderId"] = this.genderId;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["nationality1Id"] = this.nationality1Id;
        data["nationality2Id"] = this.nationality2Id;
        data["placeOfOrigin"] = this.placeOfOrigin;
        data["gln"] = this.gln;
        return data;
    }
}

export interface ISearchMedRegPersonInput {
    professionId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    genderId: string | undefined;
    dateOfBirth: DateTime | undefined;
    nationality1Id: string | undefined;
    nationality2Id: string | undefined;
    placeOfOrigin: string | undefined;
    gln: string | undefined;
}

export class SearchMedRegPersonOutput implements ISearchMedRegPersonOutput {
    items!: MedRegSearchPersonDto[] | undefined;

    constructor(data?: ISearchMedRegPersonOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MedRegSearchPersonDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchMedRegPersonOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SearchMedRegPersonOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchMedRegPersonOutput {
    items: MedRegSearchPersonDto[] | undefined;
}

export class GetExcelResultData implements IGetExcelResultData {
    name!: string | undefined;
    creationTime!: DateTime;
    isForEvidence!: boolean | undefined;
    step!: MigrationStep;
    additionalStep!: MigrationAdditionalStep;
    id!: number;

    constructor(data?: IGetExcelResultData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.isForEvidence = _data["isForEvidence"];
            this.step = _data["step"];
            this.additionalStep = _data["additionalStep"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetExcelResultData {
        data = typeof data === 'object' ? data : {};
        let result = new GetExcelResultData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["isForEvidence"] = this.isForEvidence;
        data["step"] = this.step;
        data["additionalStep"] = this.additionalStep;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetExcelResultData {
    name: string | undefined;
    creationTime: DateTime;
    isForEvidence: boolean | undefined;
    step: MigrationStep;
    additionalStep: MigrationAdditionalStep;
    id: number;
}

export class MigrationBinaryDataInputDto implements IMigrationBinaryDataInputDto {
    id!: MigrationBinaryObjectId;
    file!: string;

    constructor(data?: IMigrationBinaryDataInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): MigrationBinaryDataInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MigrationBinaryDataInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["file"] = this.file;
        return data;
    }
}

export interface IMigrationBinaryDataInputDto {
    id: MigrationBinaryObjectId;
    file: string;
}

export class MigrationIsRunningOutputDto implements IMigrationIsRunningOutputDto {
    isRunning!: boolean;
    progress!: number | undefined;

    constructor(data?: IMigrationIsRunningOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isRunning = _data["isRunning"];
            this.progress = _data["progress"];
        }
    }

    static fromJS(data: any): MigrationIsRunningOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MigrationIsRunningOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isRunning"] = this.isRunning;
        data["progress"] = this.progress;
        return data;
    }
}

export interface IMigrationIsRunningOutputDto {
    isRunning: boolean;
    progress: number | undefined;
}

export class MigrationResultDto implements IMigrationResultDto {
    resultAvailable!: boolean;
    total!: number | undefined;
    numberOfSuccess!: number | undefined;
    numberOfErrors!: number | undefined;
    excelResultId!: number | undefined;
    hasException!: boolean;
    exceptionMessage!: string | undefined;

    constructor(data?: IMigrationResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultAvailable = _data["resultAvailable"];
            this.total = _data["total"];
            this.numberOfSuccess = _data["numberOfSuccess"];
            this.numberOfErrors = _data["numberOfErrors"];
            this.excelResultId = _data["excelResultId"];
            this.hasException = _data["hasException"];
            this.exceptionMessage = _data["exceptionMessage"];
        }
    }

    static fromJS(data: any): MigrationResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MigrationResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultAvailable"] = this.resultAvailable;
        data["total"] = this.total;
        data["numberOfSuccess"] = this.numberOfSuccess;
        data["numberOfErrors"] = this.numberOfErrors;
        data["excelResultId"] = this.excelResultId;
        data["hasException"] = this.hasException;
        data["exceptionMessage"] = this.exceptionMessage;
        return data;
    }
}

export interface IMigrationResultDto {
    resultAvailable: boolean;
    total: number | undefined;
    numberOfSuccess: number | undefined;
    numberOfErrors: number | undefined;
    excelResultId: number | undefined;
    hasException: boolean;
    exceptionMessage: string | undefined;
}

export class CreateInvoiceDto implements ICreateInvoiceDto {
    subscriptionPaymentId!: number;

    constructor(data?: ICreateInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionPaymentId = _data["subscriptionPaymentId"];
        }
    }

    static fromJS(data: any): CreateInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionPaymentId"] = this.subscriptionPaymentId;
        return data;
    }
}

export interface ICreateInvoiceDto {
    subscriptionPaymentId: number;
}

export class InvoiceDto implements IInvoiceDto {
    amount!: number;
    editionDisplayName!: string | undefined;
    invoiceNo!: string | undefined;
    invoiceDate!: DateTime;
    tenantLegalName!: string | undefined;
    tenantAddress!: string[] | undefined;
    tenantTaxNo!: string | undefined;
    hostLegalName!: string | undefined;
    hostAddress!: string[] | undefined;

    constructor(data?: IInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.editionDisplayName = _data["editionDisplayName"];
            this.invoiceNo = _data["invoiceNo"];
            this.invoiceDate = _data["invoiceDate"] ? DateTime.fromISO(_data["invoiceDate"].toString()) : <any>undefined;
            this.tenantLegalName = _data["tenantLegalName"];
            if (Array.isArray(_data["tenantAddress"])) {
                this.tenantAddress = [] as any;
                for (let item of _data["tenantAddress"])
                    this.tenantAddress!.push(item);
            }
            this.tenantTaxNo = _data["tenantTaxNo"];
            this.hostLegalName = _data["hostLegalName"];
            if (Array.isArray(_data["hostAddress"])) {
                this.hostAddress = [] as any;
                for (let item of _data["hostAddress"])
                    this.hostAddress!.push(item);
            }
        }
    }

    static fromJS(data: any): InvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["editionDisplayName"] = this.editionDisplayName;
        data["invoiceNo"] = this.invoiceNo;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toString() : <any>undefined;
        data["tenantLegalName"] = this.tenantLegalName;
        if (Array.isArray(this.tenantAddress)) {
            data["tenantAddress"] = [];
            for (let item of this.tenantAddress)
                data["tenantAddress"].push(item);
        }
        data["tenantTaxNo"] = this.tenantTaxNo;
        data["hostLegalName"] = this.hostLegalName;
        if (Array.isArray(this.hostAddress)) {
            data["hostAddress"] = [];
            for (let item of this.hostAddress)
                data["hostAddress"].push(item);
        }
        return data;
    }
}

export interface IInvoiceDto {
    amount: number;
    editionDisplayName: string | undefined;
    invoiceNo: string | undefined;
    invoiceDate: DateTime;
    tenantLegalName: string | undefined;
    tenantAddress: string[] | undefined;
    tenantTaxNo: string | undefined;
    hostLegalName: string | undefined;
    hostAddress: string[] | undefined;
}

export class CreateTenantInput implements ICreateTenantInput {
    tenancyName!: string;
    name!: string;
    adminEmailAddress!: string;
    adminName!: string | undefined;
    adminSurname!: string | undefined;
    adminPassword!: string | undefined;
    connectionString!: string | undefined;
    shouldChangePasswordOnNextLogin!: boolean;
    sendActivationEmail!: boolean;
    editionId!: number | undefined;
    isActive!: boolean;
    subscriptionEndDateUtc!: DateTime | undefined;
    isInTrialPeriod!: boolean;

    constructor(data?: ICreateTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.adminName = _data["adminName"];
            this.adminSurname = _data["adminSurname"];
            this.adminPassword = _data["adminPassword"];
            this.connectionString = _data["connectionString"];
            this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"];
            this.sendActivationEmail = _data["sendActivationEmail"];
            this.editionId = _data["editionId"];
            this.isActive = _data["isActive"];
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? DateTime.fromISO(_data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = _data["isInTrialPeriod"];
        }
    }

    static fromJS(data: any): CreateTenantInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminName"] = this.adminName;
        data["adminSurname"] = this.adminSurname;
        data["adminPassword"] = this.adminPassword;
        data["connectionString"] = this.connectionString;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        return data;
    }
}

export interface ICreateTenantInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminName: string | undefined;
    adminSurname: string | undefined;
    adminPassword: string | undefined;
    connectionString: string | undefined;
    shouldChangePasswordOnNextLogin: boolean;
    sendActivationEmail: boolean;
    editionId: number | undefined;
    isActive: boolean;
    subscriptionEndDateUtc: DateTime | undefined;
    isInTrialPeriod: boolean;
}

export class EditionsSelectOutput implements IEditionsSelectOutput {
    allFeatures!: FlatFeatureSelectDto[] | undefined;
    editionsWithFeatures!: EditionWithFeaturesDto[] | undefined;

    constructor(data?: IEditionsSelectOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["allFeatures"])) {
                this.allFeatures = [] as any;
                for (let item of _data["allFeatures"])
                    this.allFeatures!.push(FlatFeatureSelectDto.fromJS(item));
            }
            if (Array.isArray(_data["editionsWithFeatures"])) {
                this.editionsWithFeatures = [] as any;
                for (let item of _data["editionsWithFeatures"])
                    this.editionsWithFeatures!.push(EditionWithFeaturesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditionsSelectOutput {
        data = typeof data === 'object' ? data : {};
        let result = new EditionsSelectOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.allFeatures)) {
            data["allFeatures"] = [];
            for (let item of this.allFeatures)
                data["allFeatures"].push(item.toJSON());
        }
        if (Array.isArray(this.editionsWithFeatures)) {
            data["editionsWithFeatures"] = [];
            for (let item of this.editionsWithFeatures)
                data["editionsWithFeatures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEditionsSelectOutput {
    allFeatures: FlatFeatureSelectDto[] | undefined;
    editionsWithFeatures: EditionWithFeaturesDto[] | undefined;
}

export class GetTenantFeaturesEditOutput implements IGetTenantFeaturesEditOutput {
    featureValues!: NameValueDto[] | undefined;
    features!: FlatFeatureDto[] | undefined;

    constructor(data?: IGetTenantFeaturesEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(FlatFeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTenantFeaturesEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTenantFeaturesEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTenantFeaturesEditOutput {
    featureValues: NameValueDto[] | undefined;
    features: FlatFeatureDto[] | undefined;
}

export class RegisterTenantInput implements IRegisterTenantInput {
    tenancyName!: string;
    name!: string;
    adminEmailAddress!: string;
    adminName!: string | undefined;
    adminSurname!: string | undefined;
    adminPassword!: string | undefined;
    captchaResponse!: string | undefined;
    subscriptionStartType!: SubscriptionStartType;
    editionId!: number | undefined;

    constructor(data?: IRegisterTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.adminName = _data["adminName"];
            this.adminSurname = _data["adminSurname"];
            this.adminPassword = _data["adminPassword"];
            this.captchaResponse = _data["captchaResponse"];
            this.subscriptionStartType = _data["subscriptionStartType"];
            this.editionId = _data["editionId"];
        }
    }

    static fromJS(data: any): RegisterTenantInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminName"] = this.adminName;
        data["adminSurname"] = this.adminSurname;
        data["adminPassword"] = this.adminPassword;
        data["captchaResponse"] = this.captchaResponse;
        data["subscriptionStartType"] = this.subscriptionStartType;
        data["editionId"] = this.editionId;
        return data;
    }
}

export interface IRegisterTenantInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminName: string | undefined;
    adminSurname: string | undefined;
    adminPassword: string | undefined;
    captchaResponse: string | undefined;
    subscriptionStartType: SubscriptionStartType;
    editionId: number | undefined;
}

export class RegisterTenantOutput implements IRegisterTenantOutput {
    tenantId!: number;
    tenancyName!: string | undefined;
    name!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    isTenantActive!: boolean;
    isActive!: boolean;
    isEmailConfirmationRequired!: boolean;

    constructor(data?: IRegisterTenantOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.isTenantActive = _data["isTenantActive"];
            this.isActive = _data["isActive"];
            this.isEmailConfirmationRequired = _data["isEmailConfirmationRequired"];
        }
    }

    static fromJS(data: any): RegisterTenantOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterTenantOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["isTenantActive"] = this.isTenantActive;
        data["isActive"] = this.isActive;
        data["isEmailConfirmationRequired"] = this.isEmailConfirmationRequired;
        return data;
    }
}

export interface IRegisterTenantOutput {
    tenantId: number;
    tenancyName: string | undefined;
    name: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    isTenantActive: boolean;
    isActive: boolean;
    isEmailConfirmationRequired: boolean;
}

export class TenantEditDto implements ITenantEditDto {
    tenancyName!: string;
    name!: string;
    connectionString!: string | undefined;
    editionId!: number | undefined;
    isActive!: boolean;
    subscriptionEndDateUtc!: DateTime | undefined;
    isInTrialPeriod!: boolean;
    id!: number;

    constructor(data?: ITenantEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.connectionString = _data["connectionString"];
            this.editionId = _data["editionId"];
            this.isActive = _data["isActive"];
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? DateTime.fromISO(_data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["connectionString"] = this.connectionString;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantEditDto {
    tenancyName: string;
    name: string;
    connectionString: string | undefined;
    editionId: number | undefined;
    isActive: boolean;
    subscriptionEndDateUtc: DateTime | undefined;
    isInTrialPeriod: boolean;
    id: number;
}

export class TenantListDto implements ITenantListDto {
    tenancyName!: string | undefined;
    name!: string | undefined;
    editionDisplayName!: string | undefined;
    connectionString!: string | undefined;
    isActive!: boolean;
    creationTime!: DateTime;
    subscriptionEndDateUtc!: DateTime | undefined;
    editionId!: number | undefined;
    isInTrialPeriod!: boolean;
    id!: number;

    constructor(data?: ITenantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.editionDisplayName = _data["editionDisplayName"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? DateTime.fromISO(_data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.editionId = _data["editionId"];
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["editionDisplayName"] = this.editionDisplayName;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toString() : <any>undefined;
        data["editionId"] = this.editionId;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantListDto {
    tenancyName: string | undefined;
    name: string | undefined;
    editionDisplayName: string | undefined;
    connectionString: string | undefined;
    isActive: boolean;
    creationTime: DateTime;
    subscriptionEndDateUtc: DateTime | undefined;
    editionId: number | undefined;
    isInTrialPeriod: boolean;
    id: number;
}

export class UpdateTenantFeaturesInput implements IUpdateTenantFeaturesInput {
    id!: number;
    featureValues!: NameValueDto[];

    constructor(data?: IUpdateTenantFeaturesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.featureValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateTenantFeaturesInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTenantFeaturesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateTenantFeaturesInput {
    id: number;
    featureValues: NameValueDto[];
}

export enum ChartDateInterval {
    Daily = 1,
    Weekly = 2,
    Monthly = 3,
}

export class ExpiringTenant implements IExpiringTenant {
    tenantName!: string | undefined;
    remainingDayCount!: number;

    constructor(data?: IExpiringTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantName = _data["tenantName"];
            this.remainingDayCount = _data["remainingDayCount"];
        }
    }

    static fromJS(data: any): ExpiringTenant {
        data = typeof data === 'object' ? data : {};
        let result = new ExpiringTenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["remainingDayCount"] = this.remainingDayCount;
        return data;
    }
}

export interface IExpiringTenant {
    tenantName: string | undefined;
    remainingDayCount: number;
}

export class GetEditionTenantStatisticsOutput implements IGetEditionTenantStatisticsOutput {
    editionStatistics!: TenantEdition[] | undefined;

    constructor(data?: IGetEditionTenantStatisticsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["editionStatistics"])) {
                this.editionStatistics = [] as any;
                for (let item of _data["editionStatistics"])
                    this.editionStatistics!.push(TenantEdition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEditionTenantStatisticsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEditionTenantStatisticsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.editionStatistics)) {
            data["editionStatistics"] = [];
            for (let item of this.editionStatistics)
                data["editionStatistics"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetEditionTenantStatisticsOutput {
    editionStatistics: TenantEdition[] | undefined;
}

export class GetExpiringTenantsOutput implements IGetExpiringTenantsOutput {
    expiringTenants!: ExpiringTenant[] | undefined;
    subscriptionEndAlertDayCount!: number;
    maxExpiringTenantsShownCount!: number;
    subscriptionEndDateStart!: DateTime;
    subscriptionEndDateEnd!: DateTime;

    constructor(data?: IGetExpiringTenantsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["expiringTenants"])) {
                this.expiringTenants = [] as any;
                for (let item of _data["expiringTenants"])
                    this.expiringTenants!.push(ExpiringTenant.fromJS(item));
            }
            this.subscriptionEndAlertDayCount = _data["subscriptionEndAlertDayCount"];
            this.maxExpiringTenantsShownCount = _data["maxExpiringTenantsShownCount"];
            this.subscriptionEndDateStart = _data["subscriptionEndDateStart"] ? DateTime.fromISO(_data["subscriptionEndDateStart"].toString()) : <any>undefined;
            this.subscriptionEndDateEnd = _data["subscriptionEndDateEnd"] ? DateTime.fromISO(_data["subscriptionEndDateEnd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetExpiringTenantsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetExpiringTenantsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.expiringTenants)) {
            data["expiringTenants"] = [];
            for (let item of this.expiringTenants)
                data["expiringTenants"].push(item.toJSON());
        }
        data["subscriptionEndAlertDayCount"] = this.subscriptionEndAlertDayCount;
        data["maxExpiringTenantsShownCount"] = this.maxExpiringTenantsShownCount;
        data["subscriptionEndDateStart"] = this.subscriptionEndDateStart ? this.subscriptionEndDateStart.toString() : <any>undefined;
        data["subscriptionEndDateEnd"] = this.subscriptionEndDateEnd ? this.subscriptionEndDateEnd.toString() : <any>undefined;
        return data;
    }
}

export interface IGetExpiringTenantsOutput {
    expiringTenants: ExpiringTenant[] | undefined;
    subscriptionEndAlertDayCount: number;
    maxExpiringTenantsShownCount: number;
    subscriptionEndDateStart: DateTime;
    subscriptionEndDateEnd: DateTime;
}

export class GetIncomeStatisticsDataOutput implements IGetIncomeStatisticsDataOutput {
    incomeStatistics!: IncomeStastistic[] | undefined;

    constructor(data?: IGetIncomeStatisticsDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["incomeStatistics"])) {
                this.incomeStatistics = [] as any;
                for (let item of _data["incomeStatistics"])
                    this.incomeStatistics!.push(IncomeStastistic.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetIncomeStatisticsDataOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetIncomeStatisticsDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.incomeStatistics)) {
            data["incomeStatistics"] = [];
            for (let item of this.incomeStatistics)
                data["incomeStatistics"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetIncomeStatisticsDataOutput {
    incomeStatistics: IncomeStastistic[] | undefined;
}

export class GetRecentTenantsOutput implements IGetRecentTenantsOutput {
    recentTenantsDayCount!: number;
    maxRecentTenantsShownCount!: number;
    tenantCreationStartDate!: DateTime;
    recentTenants!: RecentTenant[] | undefined;

    constructor(data?: IGetRecentTenantsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recentTenantsDayCount = _data["recentTenantsDayCount"];
            this.maxRecentTenantsShownCount = _data["maxRecentTenantsShownCount"];
            this.tenantCreationStartDate = _data["tenantCreationStartDate"] ? DateTime.fromISO(_data["tenantCreationStartDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["recentTenants"])) {
                this.recentTenants = [] as any;
                for (let item of _data["recentTenants"])
                    this.recentTenants!.push(RecentTenant.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRecentTenantsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecentTenantsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recentTenantsDayCount"] = this.recentTenantsDayCount;
        data["maxRecentTenantsShownCount"] = this.maxRecentTenantsShownCount;
        data["tenantCreationStartDate"] = this.tenantCreationStartDate ? this.tenantCreationStartDate.toString() : <any>undefined;
        if (Array.isArray(this.recentTenants)) {
            data["recentTenants"] = [];
            for (let item of this.recentTenants)
                data["recentTenants"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetRecentTenantsOutput {
    recentTenantsDayCount: number;
    maxRecentTenantsShownCount: number;
    tenantCreationStartDate: DateTime;
    recentTenants: RecentTenant[] | undefined;
}

export class IncomeStastistic implements IIncomeStastistic {
    label!: string | undefined;
    date!: DateTime;
    amount!: number;

    constructor(data?: IIncomeStastistic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): IncomeStastistic {
        data = typeof data === 'object' ? data : {};
        let result = new IncomeStastistic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IIncomeStastistic {
    label: string | undefined;
    date: DateTime;
    amount: number;
}

export class RecentTenant implements IRecentTenant {
    id!: number;
    name!: string | undefined;
    creationTime!: DateTime;

    constructor(data?: IRecentTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RecentTenant {
        data = typeof data === 'object' ? data : {};
        let result = new RecentTenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface IRecentTenant {
    id: number;
    name: string | undefined;
    creationTime: DateTime;
}

export class TenantEdition implements ITenantEdition {
    label!: string | undefined;
    value!: number;

    constructor(data?: ITenantEdition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): TenantEdition {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEdition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        return data;
    }
}

export interface ITenantEdition {
    label: string | undefined;
    value: number;
}

export class TopStatsData implements ITopStatsData {
    newTenantsCount!: number;
    newSubscriptionAmount!: number;
    dashboardPlaceholder1!: number;
    dashboardPlaceholder2!: number;

    constructor(data?: ITopStatsData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newTenantsCount = _data["newTenantsCount"];
            this.newSubscriptionAmount = _data["newSubscriptionAmount"];
            this.dashboardPlaceholder1 = _data["dashboardPlaceholder1"];
            this.dashboardPlaceholder2 = _data["dashboardPlaceholder2"];
        }
    }

    static fromJS(data: any): TopStatsData {
        data = typeof data === 'object' ? data : {};
        let result = new TopStatsData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newTenantsCount"] = this.newTenantsCount;
        data["newSubscriptionAmount"] = this.newSubscriptionAmount;
        data["dashboardPlaceholder1"] = this.dashboardPlaceholder1;
        data["dashboardPlaceholder2"] = this.dashboardPlaceholder2;
        return data;
    }
}

export interface ITopStatsData {
    newTenantsCount: number;
    newSubscriptionAmount: number;
    dashboardPlaceholder1: number;
    dashboardPlaceholder2: number;
}

export enum PaymentPeriodType {
    Daily = 1,
    Weekly = 7,
    Monthly = 30,
    Annual = 365,
}

export enum SubscriptionPaymentType {
    Manual = 0,
    RecurringAutomatic = 1,
    RecurringManual = 2,
}

export enum SubscriptionStartType {
    Free = 1,
    Trial = 2,
    Paid = 3,
}

export class CreateMutInput implements ICreateMutInput {
    applicationTypeId!: ApplicationType;
    mutationTypeId!: string;

    constructor(data?: ICreateMutInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationTypeId = _data["applicationTypeId"];
            this.mutationTypeId = _data["mutationTypeId"];
        }
    }

    static fromJS(data: any): CreateMutInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMutInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationTypeId"] = this.applicationTypeId;
        data["mutationTypeId"] = this.mutationTypeId;
        return data;
    }
}

export interface ICreateMutInput {
    applicationTypeId: ApplicationType;
    mutationTypeId: string;
}

export class CreateMutOutput implements ICreateMutOutput {
    caseId!: string | undefined;

    constructor(data?: ICreateMutOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
        }
    }

    static fromJS(data: any): CreateMutOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMutOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        return data;
    }
}

export interface ICreateMutOutput {
    caseId: string | undefined;
}

export class CreateUpdateMutApplicantBusinessInput implements ICreateUpdateMutApplicantBusinessInput {
    caseId!: string;
    mutApplicantBusiness!: MutApplicantBusinessDto;

    constructor(data?: ICreateUpdateMutApplicantBusinessInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.mutApplicantBusiness = new MutApplicantBusinessDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.mutApplicantBusiness = _data["mutApplicantBusiness"] ? MutApplicantBusinessDto.fromJS(_data["mutApplicantBusiness"]) : new MutApplicantBusinessDto();
        }
    }

    static fromJS(data: any): CreateUpdateMutApplicantBusinessInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateMutApplicantBusinessInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["mutApplicantBusiness"] = this.mutApplicantBusiness ? this.mutApplicantBusiness.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateUpdateMutApplicantBusinessInput {
    caseId: string;
    mutApplicantBusiness: MutApplicantBusinessDto;
}

export class CreateUpdateMutBusinessDirectorsInput implements ICreateUpdateMutBusinessDirectorsInput {
    caseId!: string;
    businessDirectors!: MutBusinessDirectorDto[];

    constructor(data?: ICreateUpdateMutBusinessDirectorsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.businessDirectors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["businessDirectors"])) {
                this.businessDirectors = [] as any;
                for (let item of _data["businessDirectors"])
                    this.businessDirectors!.push(MutBusinessDirectorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateUpdateMutBusinessDirectorsInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateMutBusinessDirectorsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.businessDirectors)) {
            data["businessDirectors"] = [];
            for (let item of this.businessDirectors)
                data["businessDirectors"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateUpdateMutBusinessDirectorsInput {
    caseId: string;
    businessDirectors: MutBusinessDirectorDto[];
}

export class CreateUpdateMutSponsorshipDirectorsInput implements ICreateUpdateMutSponsorshipDirectorsInput {
    caseId!: string;
    sponsorshipDirectors!: MutSponsorshipDirectorDto[];

    constructor(data?: ICreateUpdateMutSponsorshipDirectorsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sponsorshipDirectors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["sponsorshipDirectors"])) {
                this.sponsorshipDirectors = [] as any;
                for (let item of _data["sponsorshipDirectors"])
                    this.sponsorshipDirectors!.push(MutSponsorshipDirectorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateUpdateMutSponsorshipDirectorsInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateMutSponsorshipDirectorsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.sponsorshipDirectors)) {
            data["sponsorshipDirectors"] = [];
            for (let item of this.sponsorshipDirectors)
                data["sponsorshipDirectors"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateUpdateMutSponsorshipDirectorsInput {
    caseId: string;
    sponsorshipDirectors: MutSponsorshipDirectorDto[];
}

export enum EnumEmploymentTerminationType {
    Retirement = 0,
    Termination = 1,
    Transfer = 2,
    Relocation = 3,
    Other = 4,
}

export class GetMutBusinessDirectorsOutput implements IGetMutBusinessDirectorsOutput {
    businessDirectors!: MutBusinessDirectorDto[] | undefined;

    constructor(data?: IGetMutBusinessDirectorsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["businessDirectors"])) {
                this.businessDirectors = [] as any;
                for (let item of _data["businessDirectors"])
                    this.businessDirectors!.push(MutBusinessDirectorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMutBusinessDirectorsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMutBusinessDirectorsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.businessDirectors)) {
            data["businessDirectors"] = [];
            for (let item of this.businessDirectors)
                data["businessDirectors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMutBusinessDirectorsOutput {
    businessDirectors: MutBusinessDirectorDto[] | undefined;
}

export class GetMutDocumentsInput implements IGetMutDocumentsInput {
    caseId!: string;
    step!: MutStatus;

    constructor(data?: IGetMutDocumentsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.step = _data["step"];
        }
    }

    static fromJS(data: any): GetMutDocumentsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMutDocumentsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["step"] = this.step;
        return data;
    }
}

export interface IGetMutDocumentsInput {
    caseId: string;
    step: MutStatus;
}

export class GetMutFileInput implements IGetMutFileInput {
    caseId!: string;
    step!: MutStatus;
    id!: number;

    constructor(data?: IGetMutFileInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.step = _data["step"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetMutFileInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMutFileInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["step"] = this.step;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetMutFileInput {
    caseId: string;
    step: MutStatus;
    id: number;
}

export class GetMutOutput implements IGetMutOutput {
    mut!: MutDto;

    constructor(data?: IGetMutOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mut = _data["mut"] ? MutDto.fromJS(_data["mut"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMutOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMutOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mut"] = this.mut ? this.mut.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMutOutput {
    mut: MutDto;
}

export class GetMutSponsorshipDirectorsOutput implements IGetMutSponsorshipDirectorsOutput {
    sponsorshipDirectors!: MutSponsorshipDirectorDto[] | undefined;

    constructor(data?: IGetMutSponsorshipDirectorsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sponsorshipDirectors"])) {
                this.sponsorshipDirectors = [] as any;
                for (let item of _data["sponsorshipDirectors"])
                    this.sponsorshipDirectors!.push(MutSponsorshipDirectorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMutSponsorshipDirectorsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMutSponsorshipDirectorsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sponsorshipDirectors)) {
            data["sponsorshipDirectors"] = [];
            for (let item of this.sponsorshipDirectors)
                data["sponsorshipDirectors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMutSponsorshipDirectorsOutput {
    sponsorshipDirectors: MutSponsorshipDirectorDto[] | undefined;
}

export class GetMutSubItemDocumentsInput implements IGetMutSubItemDocumentsInput {
    subItemId!: number;
    caseId!: string;
    step!: MutStatus;

    constructor(data?: IGetMutSubItemDocumentsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subItemId = _data["subItemId"];
            this.caseId = _data["caseId"];
            this.step = _data["step"];
        }
    }

    static fromJS(data: any): GetMutSubItemDocumentsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMutSubItemDocumentsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subItemId"] = this.subItemId;
        data["caseId"] = this.caseId;
        data["step"] = this.step;
        return data;
    }
}

export interface IGetMutSubItemDocumentsInput {
    subItemId: number;
    caseId: string;
    step: MutStatus;
}

export class GetMutationApplicationsOutput implements IGetMutationApplicationsOutput {
    totalCount!: number;
    items!: MutationApplicationSearchDto[] | undefined;

    constructor(data?: IGetMutationApplicationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MutationApplicationSearchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMutationApplicationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMutationApplicationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMutationApplicationsOutput {
    totalCount: number;
    items: MutationApplicationSearchDto[] | undefined;
}

export class MutAdditionalAcademicTitleDto implements IMutAdditionalAcademicTitleDto {
    id!: number | undefined;
    title!: string | undefined;
    bodyOfIssue!: string | undefined;
    placeOfIssue!: string | undefined;
    countryOfIssueId!: string | undefined;
    dateOfIssue!: DateTime;
    dateOfRecognition!: DateTime | undefined;

    constructor(data?: IMutAdditionalAcademicTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.bodyOfIssue = _data["bodyOfIssue"];
            this.placeOfIssue = _data["placeOfIssue"];
            this.countryOfIssueId = _data["countryOfIssueId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfRecognition = _data["dateOfRecognition"] ? DateTime.fromISO(_data["dateOfRecognition"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MutAdditionalAcademicTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutAdditionalAcademicTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["bodyOfIssue"] = this.bodyOfIssue;
        data["placeOfIssue"] = this.placeOfIssue;
        data["countryOfIssueId"] = this.countryOfIssueId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfRecognition"] = this.dateOfRecognition ? this.dateOfRecognition.toFormat('yyyy-MM-dd') : <any>undefined;
        return data;
    }
}

export interface IMutAdditionalAcademicTitleDto {
    id: number | undefined;
    title: string | undefined;
    bodyOfIssue: string | undefined;
    placeOfIssue: string | undefined;
    countryOfIssueId: string | undefined;
    dateOfIssue: DateTime;
    dateOfRecognition: DateTime | undefined;
}

export class MutAddressDto implements IMutAddressDto {
    id!: number | undefined;
    uid!: string | undefined;
    addressOld!: OndAddressCountryPoBoxDto;
    addressNew!: OndAddressCountryPoBoxDto;
    isAcquisition!: string | undefined;
    isCurrentStaffRetained!: string | undefined;
    acquisitionByFirstName!: string | undefined;
    acquisitionByLastName!: string | undefined;
    glnSoFar!: string | undefined;

    constructor(data?: IMutAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.uid = _data["uid"];
            this.addressOld = _data["addressOld"] ? OndAddressCountryPoBoxDto.fromJS(_data["addressOld"]) : <any>undefined;
            this.addressNew = _data["addressNew"] ? OndAddressCountryPoBoxDto.fromJS(_data["addressNew"]) : <any>undefined;
            this.isAcquisition = _data["isAcquisition"];
            this.isCurrentStaffRetained = _data["isCurrentStaffRetained"];
            this.acquisitionByFirstName = _data["acquisitionByFirstName"];
            this.acquisitionByLastName = _data["acquisitionByLastName"];
            this.glnSoFar = _data["glnSoFar"];
        }
    }

    static fromJS(data: any): MutAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["uid"] = this.uid;
        data["addressOld"] = this.addressOld ? this.addressOld.toJSON() : <any>undefined;
        data["addressNew"] = this.addressNew ? this.addressNew.toJSON() : <any>undefined;
        data["isAcquisition"] = this.isAcquisition;
        data["isCurrentStaffRetained"] = this.isCurrentStaffRetained;
        data["acquisitionByFirstName"] = this.acquisitionByFirstName;
        data["acquisitionByLastName"] = this.acquisitionByLastName;
        data["glnSoFar"] = this.glnSoFar;
        return data;
    }
}

export interface IMutAddressDto {
    id: number | undefined;
    uid: string | undefined;
    addressOld: OndAddressCountryPoBoxDto;
    addressNew: OndAddressCountryPoBoxDto;
    isAcquisition: string | undefined;
    isCurrentStaffRetained: string | undefined;
    acquisitionByFirstName: string | undefined;
    acquisitionByLastName: string | undefined;
    glnSoFar: string | undefined;
}

export class MutApplicantAdditionalCommentsDto implements IMutApplicantAdditionalCommentsDto {
    id!: number | undefined;
    additionalComments!: string | undefined;
    dateValidFrom!: DateTime | undefined;

    constructor(data?: IMutApplicantAdditionalCommentsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.additionalComments = _data["additionalComments"];
            this.dateValidFrom = _data["dateValidFrom"] ? DateTime.fromISO(_data["dateValidFrom"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MutApplicantAdditionalCommentsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutApplicantAdditionalCommentsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["additionalComments"] = this.additionalComments;
        data["dateValidFrom"] = this.dateValidFrom ? this.dateValidFrom.toFormat('yyyy-MM-dd') : <any>undefined;
        return data;
    }
}

export interface IMutApplicantAdditionalCommentsDto {
    id: number | undefined;
    additionalComments: string | undefined;
    dateValidFrom: DateTime | undefined;
}

export class MutApplicantBusinessDto implements IMutApplicantBusinessDto {
    id!: number | undefined;
    business!: OndBusinessDto;

    constructor(data?: IMutApplicantBusinessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.business = _data["business"] ? OndBusinessDto.fromJS(_data["business"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MutApplicantBusinessDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutApplicantBusinessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["business"] = this.business ? this.business.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMutApplicantBusinessDto {
    id: number | undefined;
    business: OndBusinessDto;
}

export class MutApplicantContactDto implements IMutApplicantContactDto {
    id!: number | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    email!: string | undefined;
    phone!: string | undefined;
    readonly fullName!: string | undefined;

    constructor(data?: IMutApplicantContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            (<any>this).fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): MutApplicantContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutApplicantContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface IMutApplicantContactDto {
    id: number | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    fullName: string | undefined;
}

export class MutApplicantPersonDto implements IMutApplicantPersonDto {
    id!: number | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    gln!: string | undefined;
    professionId!: string | undefined;
    readonly fullName!: string | undefined;

    constructor(data?: IMutApplicantPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.gln = _data["gln"];
            this.professionId = _data["professionId"];
            (<any>this).fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): MutApplicantPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutApplicantPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["gln"] = this.gln;
        data["professionId"] = this.professionId;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface IMutApplicantPersonDto {
    id: number | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    gln: string | undefined;
    professionId: string | undefined;
    fullName: string | undefined;
}

export class MutApplicantSponsorshipDto implements IMutApplicantSponsorshipDto {
    id!: number | undefined;
    uid!: string | undefined;
    name!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;

    constructor(data?: IMutApplicantSponsorshipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.uid = _data["uid"];
            this.name = _data["name"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
        }
    }

    static fromJS(data: any): MutApplicantSponsorshipDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutApplicantSponsorshipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["uid"] = this.uid;
        data["name"] = this.name;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        return data;
    }
}

export interface IMutApplicantSponsorshipDto {
    id: number | undefined;
    uid: string | undefined;
    name: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
}

export class MutBusinessChangeDto implements IMutBusinessChangeDto {
    id!: number | undefined;
    newBusiness!: OndBusinessDto;
    oldBusiness!: OndBusinessDto;

    constructor(data?: IMutBusinessChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.newBusiness = _data["newBusiness"] ? OndBusinessDto.fromJS(_data["newBusiness"]) : <any>undefined;
            this.oldBusiness = _data["oldBusiness"] ? OndBusinessDto.fromJS(_data["oldBusiness"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MutBusinessChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutBusinessChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["newBusiness"] = this.newBusiness ? this.newBusiness.toJSON() : <any>undefined;
        data["oldBusiness"] = this.oldBusiness ? this.oldBusiness.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMutBusinessChangeDto {
    id: number | undefined;
    newBusiness: OndBusinessDto;
    oldBusiness: OndBusinessDto;
}

export class MutBusinessDirectorDto implements IMutBusinessDirectorDto {
    id!: number | undefined;
    businessDirectorPerson!: OndPersonWithContactInfoDto;
    levelOfEmployment!: number;
    dateOfResponsibilityStart!: DateTime | undefined;
    postgraduateTitleId!: string | undefined;

    constructor(data?: IMutBusinessDirectorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.businessDirectorPerson = _data["businessDirectorPerson"] ? OndPersonWithContactInfoDto.fromJS(_data["businessDirectorPerson"]) : <any>undefined;
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.dateOfResponsibilityStart = _data["dateOfResponsibilityStart"] ? DateTime.fromISO(_data["dateOfResponsibilityStart"].toString()) : <any>undefined;
            this.postgraduateTitleId = _data["postgraduateTitleId"];
        }
    }

    static fromJS(data: any): MutBusinessDirectorDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutBusinessDirectorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["businessDirectorPerson"] = this.businessDirectorPerson ? this.businessDirectorPerson.toJSON() : <any>undefined;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["dateOfResponsibilityStart"] = this.dateOfResponsibilityStart ? this.dateOfResponsibilityStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        return data;
    }
}

export interface IMutBusinessDirectorDto {
    id: number | undefined;
    businessDirectorPerson: OndPersonWithContactInfoDto;
    levelOfEmployment: number;
    dateOfResponsibilityStart: DateTime | undefined;
    postgraduateTitleId: string | undefined;
}

export class MutBusinessDto implements IMutBusinessDto {
    id!: number | undefined;
    business!: OndBusinessDto;

    constructor(data?: IMutBusinessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.business = _data["business"] ? OndBusinessDto.fromJS(_data["business"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MutBusinessDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutBusinessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["business"] = this.business ? this.business.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMutBusinessDto {
    id: number | undefined;
    business: OndBusinessDto;
}

export class MutBusinessTerminationDto implements IMutBusinessTerminationDto {
    id!: number | undefined;
    endDate!: DateTime;

    constructor(data?: IMutBusinessTerminationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MutBusinessTerminationDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutBusinessTerminationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["endDate"] = this.endDate ? this.endDate.toFormat('yyyy-MM-dd') : <any>undefined;
        return data;
    }
}

export interface IMutBusinessTerminationDto {
    id: number | undefined;
    endDate: DateTime;
}

export class MutDocumentsOutput implements IMutDocumentsOutput {
    caseId!: string;
    documents!: GeneralDocumentGroupDto[];

    constructor(data?: IMutDocumentsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.documents = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MutDocumentsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new MutDocumentsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMutDocumentsOutput {
    caseId: string;
    documents: GeneralDocumentGroupDto[];
}

export class MutDrugProductionDto implements IMutDrugProductionDto {
    id!: number | undefined;
    hasFormulaMagistralisDrugProductionId!: string | undefined;
    hasFormulaOfficinalisDrugProductionId!: string | undefined;
    hasOwnFormulaDrugProductionId!: string | undefined;
    hasFormulaHospitalisDrugProductionId!: string | undefined;

    constructor(data?: IMutDrugProductionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.hasFormulaMagistralisDrugProductionId = _data["hasFormulaMagistralisDrugProductionId"];
            this.hasFormulaOfficinalisDrugProductionId = _data["hasFormulaOfficinalisDrugProductionId"];
            this.hasOwnFormulaDrugProductionId = _data["hasOwnFormulaDrugProductionId"];
            this.hasFormulaHospitalisDrugProductionId = _data["hasFormulaHospitalisDrugProductionId"];
        }
    }

    static fromJS(data: any): MutDrugProductionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutDrugProductionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["hasFormulaMagistralisDrugProductionId"] = this.hasFormulaMagistralisDrugProductionId;
        data["hasFormulaOfficinalisDrugProductionId"] = this.hasFormulaOfficinalisDrugProductionId;
        data["hasOwnFormulaDrugProductionId"] = this.hasOwnFormulaDrugProductionId;
        data["hasFormulaHospitalisDrugProductionId"] = this.hasFormulaHospitalisDrugProductionId;
        return data;
    }
}

export interface IMutDrugProductionDto {
    id: number | undefined;
    hasFormulaMagistralisDrugProductionId: string | undefined;
    hasFormulaOfficinalisDrugProductionId: string | undefined;
    hasOwnFormulaDrugProductionId: string | undefined;
    hasFormulaHospitalisDrugProductionId: string | undefined;
}

export class MutDto implements IMutDto {
    application!: ApplicationDto;
    mutationTypeId!: string | undefined;
    statusId!: MutStatus;
    firstStep!: MutStatus;
    applicantPerson!: MutApplicantPersonDto;
    applicantSponsorship!: MutApplicantSponsorshipDto;
    applicantBusiness!: MutApplicantBusinessDto;
    applicantContact!: MutApplicantContactDto;
    applicantAdditionalComments!: MutApplicantAdditionalCommentsDto;
    person!: MutPersonDto;
    rangeOfServices!: MutRangeOfServicesDto;
    business!: MutBusinessDto;
    businessChange!: MutBusinessChangeDto;
    businessTermination!: MutBusinessTerminationDto;
    postgraduateTitlePrivateLaw!: MutPostgraduateTitlePrivateLawDto;
    additionalAcademicTitle!: MutAdditionalAcademicTitleDto;
    address!: MutAddressDto;
    workPlace!: MutWorkPlaceDto;
    employment!: MutEmploymentDto;
    employmentTermination!: MutEmploymentTerminationDto;
    otherMutation!: MutOtherDto;
    sponsorship!: MutSponsorshipDto;
    terminationOfCla!: MutTerminationOfClaDto;
    transferOfCla!: MutTransferOfClaDto;
    drugProduction!: MutDrugProductionDto;
    medicalFieldDirector!: MutMedicalFieldDirectorDto;
    businessDirectors!: MutBusinessDirectorDto[] | undefined;
    sponsorshipDirectors!: MutSponsorshipDirectorDto[] | undefined;
    documents!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: IMutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationDto.fromJS(_data["application"]) : <any>undefined;
            this.mutationTypeId = _data["mutationTypeId"];
            this.statusId = _data["statusId"];
            this.firstStep = _data["firstStep"];
            this.applicantPerson = _data["applicantPerson"] ? MutApplicantPersonDto.fromJS(_data["applicantPerson"]) : <any>undefined;
            this.applicantSponsorship = _data["applicantSponsorship"] ? MutApplicantSponsorshipDto.fromJS(_data["applicantSponsorship"]) : <any>undefined;
            this.applicantBusiness = _data["applicantBusiness"] ? MutApplicantBusinessDto.fromJS(_data["applicantBusiness"]) : <any>undefined;
            this.applicantContact = _data["applicantContact"] ? MutApplicantContactDto.fromJS(_data["applicantContact"]) : <any>undefined;
            this.applicantAdditionalComments = _data["applicantAdditionalComments"] ? MutApplicantAdditionalCommentsDto.fromJS(_data["applicantAdditionalComments"]) : <any>undefined;
            this.person = _data["person"] ? MutPersonDto.fromJS(_data["person"]) : <any>undefined;
            this.rangeOfServices = _data["rangeOfServices"] ? MutRangeOfServicesDto.fromJS(_data["rangeOfServices"]) : <any>undefined;
            this.business = _data["business"] ? MutBusinessDto.fromJS(_data["business"]) : <any>undefined;
            this.businessChange = _data["businessChange"] ? MutBusinessChangeDto.fromJS(_data["businessChange"]) : <any>undefined;
            this.businessTermination = _data["businessTermination"] ? MutBusinessTerminationDto.fromJS(_data["businessTermination"]) : <any>undefined;
            this.postgraduateTitlePrivateLaw = _data["postgraduateTitlePrivateLaw"] ? MutPostgraduateTitlePrivateLawDto.fromJS(_data["postgraduateTitlePrivateLaw"]) : <any>undefined;
            this.additionalAcademicTitle = _data["additionalAcademicTitle"] ? MutAdditionalAcademicTitleDto.fromJS(_data["additionalAcademicTitle"]) : <any>undefined;
            this.address = _data["address"] ? MutAddressDto.fromJS(_data["address"]) : <any>undefined;
            this.workPlace = _data["workPlace"] ? MutWorkPlaceDto.fromJS(_data["workPlace"]) : <any>undefined;
            this.employment = _data["employment"] ? MutEmploymentDto.fromJS(_data["employment"]) : <any>undefined;
            this.employmentTermination = _data["employmentTermination"] ? MutEmploymentTerminationDto.fromJS(_data["employmentTermination"]) : <any>undefined;
            this.otherMutation = _data["otherMutation"] ? MutOtherDto.fromJS(_data["otherMutation"]) : <any>undefined;
            this.sponsorship = _data["sponsorship"] ? MutSponsorshipDto.fromJS(_data["sponsorship"]) : <any>undefined;
            this.terminationOfCla = _data["terminationOfCla"] ? MutTerminationOfClaDto.fromJS(_data["terminationOfCla"]) : <any>undefined;
            this.transferOfCla = _data["transferOfCla"] ? MutTransferOfClaDto.fromJS(_data["transferOfCla"]) : <any>undefined;
            this.drugProduction = _data["drugProduction"] ? MutDrugProductionDto.fromJS(_data["drugProduction"]) : <any>undefined;
            this.medicalFieldDirector = _data["medicalFieldDirector"] ? MutMedicalFieldDirectorDto.fromJS(_data["medicalFieldDirector"]) : <any>undefined;
            if (Array.isArray(_data["businessDirectors"])) {
                this.businessDirectors = [] as any;
                for (let item of _data["businessDirectors"])
                    this.businessDirectors!.push(MutBusinessDirectorDto.fromJS(item));
            }
            if (Array.isArray(_data["sponsorshipDirectors"])) {
                this.sponsorshipDirectors = [] as any;
                for (let item of _data["sponsorshipDirectors"])
                    this.sponsorshipDirectors!.push(MutSponsorshipDirectorDto.fromJS(item));
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MutDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["mutationTypeId"] = this.mutationTypeId;
        data["statusId"] = this.statusId;
        data["firstStep"] = this.firstStep;
        data["applicantPerson"] = this.applicantPerson ? this.applicantPerson.toJSON() : <any>undefined;
        data["applicantSponsorship"] = this.applicantSponsorship ? this.applicantSponsorship.toJSON() : <any>undefined;
        data["applicantBusiness"] = this.applicantBusiness ? this.applicantBusiness.toJSON() : <any>undefined;
        data["applicantContact"] = this.applicantContact ? this.applicantContact.toJSON() : <any>undefined;
        data["applicantAdditionalComments"] = this.applicantAdditionalComments ? this.applicantAdditionalComments.toJSON() : <any>undefined;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["rangeOfServices"] = this.rangeOfServices ? this.rangeOfServices.toJSON() : <any>undefined;
        data["business"] = this.business ? this.business.toJSON() : <any>undefined;
        data["businessChange"] = this.businessChange ? this.businessChange.toJSON() : <any>undefined;
        data["businessTermination"] = this.businessTermination ? this.businessTermination.toJSON() : <any>undefined;
        data["postgraduateTitlePrivateLaw"] = this.postgraduateTitlePrivateLaw ? this.postgraduateTitlePrivateLaw.toJSON() : <any>undefined;
        data["additionalAcademicTitle"] = this.additionalAcademicTitle ? this.additionalAcademicTitle.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["workPlace"] = this.workPlace ? this.workPlace.toJSON() : <any>undefined;
        data["employment"] = this.employment ? this.employment.toJSON() : <any>undefined;
        data["employmentTermination"] = this.employmentTermination ? this.employmentTermination.toJSON() : <any>undefined;
        data["otherMutation"] = this.otherMutation ? this.otherMutation.toJSON() : <any>undefined;
        data["sponsorship"] = this.sponsorship ? this.sponsorship.toJSON() : <any>undefined;
        data["terminationOfCla"] = this.terminationOfCla ? this.terminationOfCla.toJSON() : <any>undefined;
        data["transferOfCla"] = this.transferOfCla ? this.transferOfCla.toJSON() : <any>undefined;
        data["drugProduction"] = this.drugProduction ? this.drugProduction.toJSON() : <any>undefined;
        data["medicalFieldDirector"] = this.medicalFieldDirector ? this.medicalFieldDirector.toJSON() : <any>undefined;
        if (Array.isArray(this.businessDirectors)) {
            data["businessDirectors"] = [];
            for (let item of this.businessDirectors)
                data["businessDirectors"].push(item.toJSON());
        }
        if (Array.isArray(this.sponsorshipDirectors)) {
            data["sponsorshipDirectors"] = [];
            for (let item of this.sponsorshipDirectors)
                data["sponsorshipDirectors"].push(item.toJSON());
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMutDto {
    application: ApplicationDto;
    mutationTypeId: string | undefined;
    statusId: MutStatus;
    firstStep: MutStatus;
    applicantPerson: MutApplicantPersonDto;
    applicantSponsorship: MutApplicantSponsorshipDto;
    applicantBusiness: MutApplicantBusinessDto;
    applicantContact: MutApplicantContactDto;
    applicantAdditionalComments: MutApplicantAdditionalCommentsDto;
    person: MutPersonDto;
    rangeOfServices: MutRangeOfServicesDto;
    business: MutBusinessDto;
    businessChange: MutBusinessChangeDto;
    businessTermination: MutBusinessTerminationDto;
    postgraduateTitlePrivateLaw: MutPostgraduateTitlePrivateLawDto;
    additionalAcademicTitle: MutAdditionalAcademicTitleDto;
    address: MutAddressDto;
    workPlace: MutWorkPlaceDto;
    employment: MutEmploymentDto;
    employmentTermination: MutEmploymentTerminationDto;
    otherMutation: MutOtherDto;
    sponsorship: MutSponsorshipDto;
    terminationOfCla: MutTerminationOfClaDto;
    transferOfCla: MutTransferOfClaDto;
    drugProduction: MutDrugProductionDto;
    medicalFieldDirector: MutMedicalFieldDirectorDto;
    businessDirectors: MutBusinessDirectorDto[] | undefined;
    sponsorshipDirectors: MutSponsorshipDirectorDto[] | undefined;
    documents: GeneralDocumentGroupDto[] | undefined;
}

export class MutEmploymentDto implements IMutEmploymentDto {
    id!: number | undefined;
    businessName!: string | undefined;
    uid!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    countryId!: string | undefined;
    startDate!: DateTime | undefined;
    levelOfEmployment!: number | undefined;
    isAcquisition!: string | undefined;
    isCurrentStaffRetained!: string | undefined;
    acquisitionByFirstName!: string | undefined;
    acquisitionByLastName!: string | undefined;
    glnSoFar!: string | undefined;

    constructor(data?: IMutEmploymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.businessName = _data["businessName"];
            this.uid = _data["uid"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.countryId = _data["countryId"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.isAcquisition = _data["isAcquisition"];
            this.isCurrentStaffRetained = _data["isCurrentStaffRetained"];
            this.acquisitionByFirstName = _data["acquisitionByFirstName"];
            this.acquisitionByLastName = _data["acquisitionByLastName"];
            this.glnSoFar = _data["glnSoFar"];
        }
    }

    static fromJS(data: any): MutEmploymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutEmploymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["businessName"] = this.businessName;
        data["uid"] = this.uid;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["countryId"] = this.countryId;
        data["startDate"] = this.startDate ? this.startDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["isAcquisition"] = this.isAcquisition;
        data["isCurrentStaffRetained"] = this.isCurrentStaffRetained;
        data["acquisitionByFirstName"] = this.acquisitionByFirstName;
        data["acquisitionByLastName"] = this.acquisitionByLastName;
        data["glnSoFar"] = this.glnSoFar;
        return data;
    }
}

export interface IMutEmploymentDto {
    id: number | undefined;
    businessName: string | undefined;
    uid: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    countryId: string | undefined;
    startDate: DateTime | undefined;
    levelOfEmployment: number | undefined;
    isAcquisition: string | undefined;
    isCurrentStaffRetained: string | undefined;
    acquisitionByFirstName: string | undefined;
    acquisitionByLastName: string | undefined;
    glnSoFar: string | undefined;
}

export class MutEmploymentTerminationDto implements IMutEmploymentTerminationDto {
    id!: number | undefined;
    businessName!: string | undefined;
    uid!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    endDate!: DateTime | undefined;
    reasonId!: EnumEmploymentTerminationType;
    otherReason!: string | undefined;

    constructor(data?: IMutEmploymentTerminationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.businessName = _data["businessName"];
            this.uid = _data["uid"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
            this.reasonId = _data["reasonId"];
            this.otherReason = _data["otherReason"];
        }
    }

    static fromJS(data: any): MutEmploymentTerminationDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutEmploymentTerminationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["businessName"] = this.businessName;
        data["uid"] = this.uid;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["endDate"] = this.endDate ? this.endDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["reasonId"] = this.reasonId;
        data["otherReason"] = this.otherReason;
        return data;
    }
}

export interface IMutEmploymentTerminationDto {
    id: number | undefined;
    businessName: string | undefined;
    uid: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    endDate: DateTime | undefined;
    reasonId: EnumEmploymentTerminationType;
    otherReason: string | undefined;
}

export class MutMedicalFieldDirectorDto implements IMutMedicalFieldDirectorDto {
    id!: number | undefined;
    medicalFieldDirectorPerson!: OndPersonWithContactInfoDto;
    postgraduateTitleId!: string | undefined;
    levelOfEmployment!: number;
    dateOfResponsibilityStart!: DateTime | undefined;
    professionalLicenceStatusId!: string | undefined;
    hasAppliedForProfessionalLicenceId!: string | undefined;

    constructor(data?: IMutMedicalFieldDirectorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.medicalFieldDirectorPerson = _data["medicalFieldDirectorPerson"] ? OndPersonWithContactInfoDto.fromJS(_data["medicalFieldDirectorPerson"]) : <any>undefined;
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.dateOfResponsibilityStart = _data["dateOfResponsibilityStart"] ? DateTime.fromISO(_data["dateOfResponsibilityStart"].toString()) : <any>undefined;
            this.professionalLicenceStatusId = _data["professionalLicenceStatusId"];
            this.hasAppliedForProfessionalLicenceId = _data["hasAppliedForProfessionalLicenceId"];
        }
    }

    static fromJS(data: any): MutMedicalFieldDirectorDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutMedicalFieldDirectorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["medicalFieldDirectorPerson"] = this.medicalFieldDirectorPerson ? this.medicalFieldDirectorPerson.toJSON() : <any>undefined;
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["dateOfResponsibilityStart"] = this.dateOfResponsibilityStart ? this.dateOfResponsibilityStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["professionalLicenceStatusId"] = this.professionalLicenceStatusId;
        data["hasAppliedForProfessionalLicenceId"] = this.hasAppliedForProfessionalLicenceId;
        return data;
    }
}

export interface IMutMedicalFieldDirectorDto {
    id: number | undefined;
    medicalFieldDirectorPerson: OndPersonWithContactInfoDto;
    postgraduateTitleId: string | undefined;
    levelOfEmployment: number;
    dateOfResponsibilityStart: DateTime | undefined;
    professionalLicenceStatusId: string | undefined;
    hasAppliedForProfessionalLicenceId: string | undefined;
}

export class MutOtherDto implements IMutOtherDto {
    id!: number | undefined;
    description!: string | undefined;

    constructor(data?: IMutOtherDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): MutOtherDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutOtherDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }
}

export interface IMutOtherDto {
    id: number | undefined;
    description: string | undefined;
}

export class MutPersonDto implements IMutPersonDto {
    id!: number | undefined;
    firstNameNew!: string | undefined;
    lastNameNew!: string | undefined;
    nationalityOldId!: string | undefined;
    nationalityNewId!: string | undefined;
    placeOfOriginOld!: string | undefined;
    placeOfOriginNew!: string | undefined;
    readonly fullName!: string | undefined;

    constructor(data?: IMutPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstNameNew = _data["firstNameNew"];
            this.lastNameNew = _data["lastNameNew"];
            this.nationalityOldId = _data["nationalityOldId"];
            this.nationalityNewId = _data["nationalityNewId"];
            this.placeOfOriginOld = _data["placeOfOriginOld"];
            this.placeOfOriginNew = _data["placeOfOriginNew"];
            (<any>this).fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): MutPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstNameNew"] = this.firstNameNew;
        data["lastNameNew"] = this.lastNameNew;
        data["nationalityOldId"] = this.nationalityOldId;
        data["nationalityNewId"] = this.nationalityNewId;
        data["placeOfOriginOld"] = this.placeOfOriginOld;
        data["placeOfOriginNew"] = this.placeOfOriginNew;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface IMutPersonDto {
    id: number | undefined;
    firstNameNew: string | undefined;
    lastNameNew: string | undefined;
    nationalityOldId: string | undefined;
    nationalityNewId: string | undefined;
    placeOfOriginOld: string | undefined;
    placeOfOriginNew: string | undefined;
    fullName: string | undefined;
}

export class MutPostgraduateTitlePrivateLawDto implements IMutPostgraduateTitlePrivateLawDto {
    id!: number | undefined;
    name!: string | undefined;
    type!: string | undefined;
    placeOfIssue!: string | undefined;
    issuingOrganization!: string | undefined;
    countryId!: string | undefined;
    dateOfIssue!: DateTime | undefined;

    constructor(data?: IMutPostgraduateTitlePrivateLawDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.placeOfIssue = _data["placeOfIssue"];
            this.issuingOrganization = _data["issuingOrganization"];
            this.countryId = _data["countryId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MutPostgraduateTitlePrivateLawDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutPostgraduateTitlePrivateLawDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["placeOfIssue"] = this.placeOfIssue;
        data["issuingOrganization"] = this.issuingOrganization;
        data["countryId"] = this.countryId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        return data;
    }
}

export interface IMutPostgraduateTitlePrivateLawDto {
    id: number | undefined;
    name: string | undefined;
    type: string | undefined;
    placeOfIssue: string | undefined;
    issuingOrganization: string | undefined;
    countryId: string | undefined;
    dateOfIssue: DateTime | undefined;
}

export class MutRangeOfServicesDto implements IMutRangeOfServicesDto {
    id!: number | undefined;
    newServicesDescription!: string | undefined;

    constructor(data?: IMutRangeOfServicesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.newServicesDescription = _data["newServicesDescription"];
        }
    }

    static fromJS(data: any): MutRangeOfServicesDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutRangeOfServicesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["newServicesDescription"] = this.newServicesDescription;
        return data;
    }
}

export interface IMutRangeOfServicesDto {
    id: number | undefined;
    newServicesDescription: string | undefined;
}

export class MutSponsorshipDirectorDto implements IMutSponsorshipDirectorDto {
    id!: number | undefined;
    sponsorshipDirectorPerson!: OndPersonWithContactInfoDto;

    constructor(data?: IMutSponsorshipDirectorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sponsorshipDirectorPerson = _data["sponsorshipDirectorPerson"] ? OndPersonWithContactInfoDto.fromJS(_data["sponsorshipDirectorPerson"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MutSponsorshipDirectorDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutSponsorshipDirectorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sponsorshipDirectorPerson"] = this.sponsorshipDirectorPerson ? this.sponsorshipDirectorPerson.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMutSponsorshipDirectorDto {
    id: number | undefined;
    sponsorshipDirectorPerson: OndPersonWithContactInfoDto;
}

export class MutSponsorshipDto implements IMutSponsorshipDto {
    id!: number | undefined;
    sponsorshipOld!: OndSponsorshipDto;
    sponsorshipNew!: OndSponsorshipDto;

    constructor(data?: IMutSponsorshipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sponsorshipOld = _data["sponsorshipOld"] ? OndSponsorshipDto.fromJS(_data["sponsorshipOld"]) : <any>undefined;
            this.sponsorshipNew = _data["sponsorshipNew"] ? OndSponsorshipDto.fromJS(_data["sponsorshipNew"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MutSponsorshipDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutSponsorshipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sponsorshipOld"] = this.sponsorshipOld ? this.sponsorshipOld.toJSON() : <any>undefined;
        data["sponsorshipNew"] = this.sponsorshipNew ? this.sponsorshipNew.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMutSponsorshipDto {
    id: number | undefined;
    sponsorshipOld: OndSponsorshipDto;
    sponsorshipNew: OndSponsorshipDto;
}

export enum MutStatus {
    ApplicantPerson = 0,
    ApplicantSponsorship = 1,
    ApplicantBusiness = 2,
    PostgraduateTitlePrivateLaw = 3,
    Business = 4,
    BusinessTermination = 5,
    BusinessChange = 6,
    AdditionalAcademicTitle = 7,
    WorkPlace = 8,
    Employment = 9,
    EmploymentTermination = 10,
    Other = 11,
    Sponsorship = 12,
    DrugProduction = 13,
    TerminationOfCla = 14,
    TransferOfCla = 15,
    SponsorshipDirector = 16,
    MedicalFieldDirector = 17,
    BusinessDirectors = 18,
    RangeOfServices = 19,
    Address = 20,
    Person = 21,
    ApplicantAdditionalComments = 80,
    ApplicantContact = 81,
    Release = 97,
    Released = 98,
    FinishReview = 99,
}

export class MutTerminationOfClaDto implements IMutTerminationOfClaDto {
    id!: number | undefined;
    bankruptcyDate!: DateTime | undefined;
    endDate!: DateTime | undefined;
    businesses!: OndBusinessDto[] | undefined;

    constructor(data?: IMutTerminationOfClaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bankruptcyDate = _data["bankruptcyDate"] ? DateTime.fromISO(_data["bankruptcyDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(OndBusinessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MutTerminationOfClaDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutTerminationOfClaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankruptcyDate"] = this.bankruptcyDate ? this.bankruptcyDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toFormat('yyyy-MM-dd') : <any>undefined;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMutTerminationOfClaDto {
    id: number | undefined;
    bankruptcyDate: DateTime | undefined;
    endDate: DateTime | undefined;
    businesses: OndBusinessDto[] | undefined;
}

export class MutTransferOfClaDto implements IMutTransferOfClaDto {
    id!: number | undefined;
    dateOfTransfer!: DateTime;

    constructor(data?: IMutTransferOfClaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateOfTransfer = _data["dateOfTransfer"] ? DateTime.fromISO(_data["dateOfTransfer"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MutTransferOfClaDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutTransferOfClaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateOfTransfer"] = this.dateOfTransfer ? this.dateOfTransfer.toFormat('yyyy-MM-dd') : <any>undefined;
        return data;
    }
}

export interface IMutTransferOfClaDto {
    id: number | undefined;
    dateOfTransfer: DateTime;
}

export class MutWorkPlaceDto implements IMutWorkPlaceDto {
    id!: number | undefined;
    uidOld!: string | undefined;
    businessNameOld!: string | undefined;
    postCodeOld!: string;
    cityOld!: string;
    streetOld!: string;
    streetNrOld!: string | undefined;
    countryIdOld!: string;
    startDateOld!: DateTime;
    endDateOld!: DateTime;
    levelOfEmploymentOld!: number;
    uidNew!: string | undefined;
    businessNameNew!: string | undefined;
    postCodeNew!: string;
    cityNew!: string;
    streetNew!: string;
    streetNrNew!: string | undefined;
    countryIdNew!: string;
    email!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    startDateNew!: DateTime;
    levelOfEmploymentNew!: number;

    constructor(data?: IMutWorkPlaceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.uidOld = _data["uidOld"];
            this.businessNameOld = _data["businessNameOld"];
            this.postCodeOld = _data["postCodeOld"];
            this.cityOld = _data["cityOld"];
            this.streetOld = _data["streetOld"];
            this.streetNrOld = _data["streetNrOld"];
            this.countryIdOld = _data["countryIdOld"];
            this.startDateOld = _data["startDateOld"] ? DateTime.fromISO(_data["startDateOld"].toString()) : <any>undefined;
            this.endDateOld = _data["endDateOld"] ? DateTime.fromISO(_data["endDateOld"].toString()) : <any>undefined;
            this.levelOfEmploymentOld = _data["levelOfEmploymentOld"];
            this.uidNew = _data["uidNew"];
            this.businessNameNew = _data["businessNameNew"];
            this.postCodeNew = _data["postCodeNew"];
            this.cityNew = _data["cityNew"];
            this.streetNew = _data["streetNew"];
            this.streetNrNew = _data["streetNrNew"];
            this.countryIdNew = _data["countryIdNew"];
            this.email = _data["email"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.startDateNew = _data["startDateNew"] ? DateTime.fromISO(_data["startDateNew"].toString()) : <any>undefined;
            this.levelOfEmploymentNew = _data["levelOfEmploymentNew"];
        }
    }

    static fromJS(data: any): MutWorkPlaceDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutWorkPlaceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["uidOld"] = this.uidOld;
        data["businessNameOld"] = this.businessNameOld;
        data["postCodeOld"] = this.postCodeOld;
        data["cityOld"] = this.cityOld;
        data["streetOld"] = this.streetOld;
        data["streetNrOld"] = this.streetNrOld;
        data["countryIdOld"] = this.countryIdOld;
        data["startDateOld"] = this.startDateOld ? this.startDateOld.toFormat('yyyy-MM-dd') : <any>undefined;
        data["endDateOld"] = this.endDateOld ? this.endDateOld.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfEmploymentOld"] = this.levelOfEmploymentOld;
        data["uidNew"] = this.uidNew;
        data["businessNameNew"] = this.businessNameNew;
        data["postCodeNew"] = this.postCodeNew;
        data["cityNew"] = this.cityNew;
        data["streetNew"] = this.streetNew;
        data["streetNrNew"] = this.streetNrNew;
        data["countryIdNew"] = this.countryIdNew;
        data["email"] = this.email;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["startDateNew"] = this.startDateNew ? this.startDateNew.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfEmploymentNew"] = this.levelOfEmploymentNew;
        return data;
    }
}

export interface IMutWorkPlaceDto {
    id: number | undefined;
    uidOld: string | undefined;
    businessNameOld: string | undefined;
    postCodeOld: string;
    cityOld: string;
    streetOld: string;
    streetNrOld: string | undefined;
    countryIdOld: string;
    startDateOld: DateTime;
    endDateOld: DateTime;
    levelOfEmploymentOld: number;
    uidNew: string | undefined;
    businessNameNew: string | undefined;
    postCodeNew: string;
    cityNew: string;
    streetNew: string;
    streetNrNew: string | undefined;
    countryIdNew: string;
    email: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    startDateNew: DateTime;
    levelOfEmploymentNew: number;
}

export class MutationApplicationSearchDto implements IMutationApplicationSearchDto {
    id!: number;
    responsibleId!: number | undefined;
    responsibleFullName!: string | undefined;
    iAmResponsible!: boolean;
    caseId!: string | undefined;
    caseIdSearchable!: string | undefined;
    userFullName!: string | undefined;
    userEmail!: string | undefined;
    mutationName!: string | undefined;
    glnUid!: string | undefined;
    professionId!: string | undefined;
    mutationTypeId!: string | undefined;
    type!: number;
    status!: ApplicationStatus;
    dateOfStatusChange!: DateTime;
    submittedCount!: number;
    submittedDate!: DateTime | undefined;
    lastSubmittedDate!: DateTime | undefined;

    constructor(data?: IMutationApplicationSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.responsibleId = _data["responsibleId"];
            this.responsibleFullName = _data["responsibleFullName"];
            this.iAmResponsible = _data["iAmResponsible"];
            this.caseId = _data["caseId"];
            this.caseIdSearchable = _data["caseIdSearchable"];
            this.userFullName = _data["userFullName"];
            this.userEmail = _data["userEmail"];
            this.mutationName = _data["mutationName"];
            this.glnUid = _data["glnUid"];
            this.professionId = _data["professionId"];
            this.mutationTypeId = _data["mutationTypeId"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.dateOfStatusChange = _data["dateOfStatusChange"] ? DateTime.fromISO(_data["dateOfStatusChange"].toString()) : <any>undefined;
            this.submittedCount = _data["submittedCount"];
            this.submittedDate = _data["submittedDate"] ? DateTime.fromISO(_data["submittedDate"].toString()) : <any>undefined;
            this.lastSubmittedDate = _data["lastSubmittedDate"] ? DateTime.fromISO(_data["lastSubmittedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MutationApplicationSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new MutationApplicationSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["responsibleId"] = this.responsibleId;
        data["responsibleFullName"] = this.responsibleFullName;
        data["iAmResponsible"] = this.iAmResponsible;
        data["caseId"] = this.caseId;
        data["caseIdSearchable"] = this.caseIdSearchable;
        data["userFullName"] = this.userFullName;
        data["userEmail"] = this.userEmail;
        data["mutationName"] = this.mutationName;
        data["glnUid"] = this.glnUid;
        data["professionId"] = this.professionId;
        data["mutationTypeId"] = this.mutationTypeId;
        data["type"] = this.type;
        data["status"] = this.status;
        data["dateOfStatusChange"] = this.dateOfStatusChange ? this.dateOfStatusChange.toString() : <any>undefined;
        data["submittedCount"] = this.submittedCount;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toString() : <any>undefined;
        data["lastSubmittedDate"] = this.lastSubmittedDate ? this.lastSubmittedDate.toString() : <any>undefined;
        return data;
    }
}

export interface IMutationApplicationSearchDto {
    id: number;
    responsibleId: number | undefined;
    responsibleFullName: string | undefined;
    iAmResponsible: boolean;
    caseId: string | undefined;
    caseIdSearchable: string | undefined;
    userFullName: string | undefined;
    userEmail: string | undefined;
    mutationName: string | undefined;
    glnUid: string | undefined;
    professionId: string | undefined;
    mutationTypeId: string | undefined;
    type: number;
    status: ApplicationStatus;
    dateOfStatusChange: DateTime;
    submittedCount: number;
    submittedDate: DateTime | undefined;
    lastSubmittedDate: DateTime | undefined;
}

export class GetEmploymentsCountOutput implements IGetEmploymentsCountOutput {
    activeCount!: number;
    inactiveCount!: number;
    totalCount!: number;

    constructor(data?: IGetEmploymentsCountOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activeCount = _data["activeCount"];
            this.inactiveCount = _data["inactiveCount"];
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): GetEmploymentsCountOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmploymentsCountOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeCount"] = this.activeCount;
        data["inactiveCount"] = this.inactiveCount;
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IGetEmploymentsCountOutput {
    activeCount: number;
    inactiveCount: number;
    totalCount: number;
}

export class GetEmploymentsOutput implements IGetEmploymentsOutput {
    items!: UserEmploymentDto[] | undefined;

    constructor(data?: IGetEmploymentsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserEmploymentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEmploymentsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmploymentsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetEmploymentsOutput {
    items: UserEmploymentDto[] | undefined;
}

export class GetExistingEmploymentChangeRequestInfoOutput implements IGetExistingEmploymentChangeRequestInfoOutput {
    activeChangeRequests!: boolean;
    creationTime!: DateTime | undefined;

    constructor(data?: IGetExistingEmploymentChangeRequestInfoOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activeChangeRequests = _data["activeChangeRequests"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetExistingEmploymentChangeRequestInfoOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetExistingEmploymentChangeRequestInfoOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeChangeRequests"] = this.activeChangeRequests;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface IGetExistingEmploymentChangeRequestInfoOutput {
    activeChangeRequests: boolean;
    creationTime: DateTime | undefined;
}

export class GetExistingPersonChangeRequestInfoOutput implements IGetExistingPersonChangeRequestInfoOutput {
    activeChangeRequests!: boolean;
    creationTime!: DateTime | undefined;

    constructor(data?: IGetExistingPersonChangeRequestInfoOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activeChangeRequests = _data["activeChangeRequests"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetExistingPersonChangeRequestInfoOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetExistingPersonChangeRequestInfoOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeChangeRequests"] = this.activeChangeRequests;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface IGetExistingPersonChangeRequestInfoOutput {
    activeChangeRequests: boolean;
    creationTime: DateTime | undefined;
}

export class GetIdentificationStatusOutput implements IGetIdentificationStatusOutput {
    identificationStatus!: IdentificationStatusDto;

    constructor(data?: IGetIdentificationStatusOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identificationStatus = _data["identificationStatus"] ? IdentificationStatusDto.fromJS(_data["identificationStatus"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetIdentificationStatusOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetIdentificationStatusOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identificationStatus"] = this.identificationStatus ? this.identificationStatus.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetIdentificationStatusOutput {
    identificationStatus: IdentificationStatusDto;
}

export class GetProfessionalLicencesCountOutput implements IGetProfessionalLicencesCountOutput {
    activeCount!: number;
    inactiveCount!: number;
    totalCount!: number;

    constructor(data?: IGetProfessionalLicencesCountOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activeCount = _data["activeCount"];
            this.inactiveCount = _data["inactiveCount"];
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): GetProfessionalLicencesCountOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfessionalLicencesCountOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeCount"] = this.activeCount;
        data["inactiveCount"] = this.inactiveCount;
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IGetProfessionalLicencesCountOutput {
    activeCount: number;
    inactiveCount: number;
    totalCount: number;
}

export class GetSponsorshipCountOutput implements IGetSponsorshipCountOutput {
    totalCount!: number;

    constructor(data?: IGetSponsorshipCountOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): GetSponsorshipCountOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSponsorshipCountOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IGetSponsorshipCountOutput {
    totalCount: number;
}

export class GetUserProfessionalLicencesOutput implements IGetUserProfessionalLicencesOutput {
    items!: UserProfessionalLicenceDto[] | undefined;

    constructor(data?: IGetUserProfessionalLicencesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserProfessionalLicenceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserProfessionalLicencesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserProfessionalLicencesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUserProfessionalLicencesOutput {
    items: UserProfessionalLicenceDto[] | undefined;
}

export class IdentificationStatusDto implements IIdentificationStatusDto {
    liaCount!: number;
    submittedLiaCount!: number;
    identificationStatus!: string | undefined;
    identificationType!: string | undefined;
    identificationContext!: IdentificationContext;

    constructor(data?: IIdentificationStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.liaCount = _data["liaCount"];
            this.submittedLiaCount = _data["submittedLiaCount"];
            this.identificationStatus = _data["identificationStatus"];
            this.identificationType = _data["identificationType"];
            this.identificationContext = _data["identificationContext"];
        }
    }

    static fromJS(data: any): IdentificationStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new IdentificationStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["liaCount"] = this.liaCount;
        data["submittedLiaCount"] = this.submittedLiaCount;
        data["identificationStatus"] = this.identificationStatus;
        data["identificationType"] = this.identificationType;
        data["identificationContext"] = this.identificationContext;
        return data;
    }
}

export interface IIdentificationStatusDto {
    liaCount: number;
    submittedLiaCount: number;
    identificationStatus: string | undefined;
    identificationType: string | undefined;
    identificationContext: IdentificationContext;
}

export class UserContactDto implements IUserContactDto {
    backendSystemId!: string | undefined;
    titleId!: string | undefined;
    name!: string | undefined;
    surname!: string | undefined;
    ahv!: string | undefined;
    gln!: string | undefined;
    birthName!: string | undefined;
    dateOfBirth!: DateTime | undefined;
    placeOfOrigin!: string | undefined;
    countryId!: string | undefined;
    nationality1!: string | undefined;
    nationality2!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    postOfficeBox!: string | undefined;
    phoneNumber!: string | undefined;
    phoneNumber2!: string | undefined;
    emailAddress!: string | undefined;
    emailAddress2!: string | undefined;
    languageOfCorrespondenceId!: string | undefined;
    note!: string | undefined;
    isEmailConfirmed!: boolean;

    constructor(data?: IUserContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.backendSystemId = _data["backendSystemId"];
            this.titleId = _data["titleId"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.ahv = _data["ahv"];
            this.gln = _data["gln"];
            this.birthName = _data["birthName"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.placeOfOrigin = _data["placeOfOrigin"];
            this.countryId = _data["countryId"];
            this.nationality1 = _data["nationality1"];
            this.nationality2 = _data["nationality2"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumber2 = _data["phoneNumber2"];
            this.emailAddress = _data["emailAddress"];
            this.emailAddress2 = _data["emailAddress2"];
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.note = _data["note"];
            this.isEmailConfirmed = _data["isEmailConfirmed"];
        }
    }

    static fromJS(data: any): UserContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["backendSystemId"] = this.backendSystemId;
        data["titleId"] = this.titleId;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["ahv"] = this.ahv;
        data["gln"] = this.gln;
        data["birthName"] = this.birthName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["placeOfOrigin"] = this.placeOfOrigin;
        data["countryId"] = this.countryId;
        data["nationality1"] = this.nationality1;
        data["nationality2"] = this.nationality2;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["postOfficeBox"] = this.postOfficeBox;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumber2"] = this.phoneNumber2;
        data["emailAddress"] = this.emailAddress;
        data["emailAddress2"] = this.emailAddress2;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["note"] = this.note;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        return data;
    }
}

export interface IUserContactDto {
    backendSystemId: string | undefined;
    titleId: string | undefined;
    name: string | undefined;
    surname: string | undefined;
    ahv: string | undefined;
    gln: string | undefined;
    birthName: string | undefined;
    dateOfBirth: DateTime | undefined;
    placeOfOrigin: string | undefined;
    countryId: string | undefined;
    nationality1: string | undefined;
    nationality2: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    postOfficeBox: string | undefined;
    phoneNumber: string | undefined;
    phoneNumber2: string | undefined;
    emailAddress: string | undefined;
    emailAddress2: string | undefined;
    languageOfCorrespondenceId: string | undefined;
    note: string | undefined;
    isEmailConfirmed: boolean;
}

export class UserEmploymentDto implements IUserEmploymentDto {
    personLicenceId!: number | undefined;
    businessTypeId!: string | undefined;
    businessName!: string | undefined;
    businessName2!: string | undefined;
    addressAddition!: string | undefined;
    uid!: string | undefined;
    gln!: string | undefined;
    medRegId!: number | undefined;
    legalFormId!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    postOfficeBox!: string | undefined;
    languageOfCorrespondenceId!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email1!: string | undefined;
    email2!: string | undefined;
    mobile!: string | undefined;
    website!: string | undefined;
    dateOfEmployment!: DateTime | undefined;
    dateOfEndOfEmployment!: DateTime | undefined;
    levelOfEmployment!: number | undefined;
    roleId!: string | undefined;
    remark!: string | undefined;
    isMobileEmployment!: boolean;
    changeRequestTypeId!: string | undefined;
    changeRequestStatusId!: string | undefined;
    changeRequestDateOfStatusChange!: DateTime | undefined;
    id!: number;

    constructor(data?: IUserEmploymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personLicenceId = _data["personLicenceId"];
            this.businessTypeId = _data["businessTypeId"];
            this.businessName = _data["businessName"];
            this.businessName2 = _data["businessName2"];
            this.addressAddition = _data["addressAddition"];
            this.uid = _data["uid"];
            this.gln = _data["gln"];
            this.medRegId = _data["medRegId"];
            this.legalFormId = _data["legalFormId"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email1 = _data["email1"];
            this.email2 = _data["email2"];
            this.mobile = _data["mobile"];
            this.website = _data["website"];
            this.dateOfEmployment = _data["dateOfEmployment"] ? DateTime.fromISO(_data["dateOfEmployment"].toString()) : <any>undefined;
            this.dateOfEndOfEmployment = _data["dateOfEndOfEmployment"] ? DateTime.fromISO(_data["dateOfEndOfEmployment"].toString()) : <any>undefined;
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.roleId = _data["roleId"];
            this.remark = _data["remark"];
            this.isMobileEmployment = _data["isMobileEmployment"];
            this.changeRequestTypeId = _data["changeRequestTypeId"];
            this.changeRequestStatusId = _data["changeRequestStatusId"];
            this.changeRequestDateOfStatusChange = _data["changeRequestDateOfStatusChange"] ? DateTime.fromISO(_data["changeRequestDateOfStatusChange"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserEmploymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserEmploymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personLicenceId"] = this.personLicenceId;
        data["businessTypeId"] = this.businessTypeId;
        data["businessName"] = this.businessName;
        data["businessName2"] = this.businessName2;
        data["addressAddition"] = this.addressAddition;
        data["uid"] = this.uid;
        data["gln"] = this.gln;
        data["medRegId"] = this.medRegId;
        data["legalFormId"] = this.legalFormId;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["postOfficeBox"] = this.postOfficeBox;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email1"] = this.email1;
        data["email2"] = this.email2;
        data["mobile"] = this.mobile;
        data["website"] = this.website;
        data["dateOfEmployment"] = this.dateOfEmployment ? this.dateOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEndOfEmployment"] = this.dateOfEndOfEmployment ? this.dateOfEndOfEmployment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["roleId"] = this.roleId;
        data["remark"] = this.remark;
        data["isMobileEmployment"] = this.isMobileEmployment;
        data["changeRequestTypeId"] = this.changeRequestTypeId;
        data["changeRequestStatusId"] = this.changeRequestStatusId;
        data["changeRequestDateOfStatusChange"] = this.changeRequestDateOfStatusChange ? this.changeRequestDateOfStatusChange.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserEmploymentDto {
    personLicenceId: number | undefined;
    businessTypeId: string | undefined;
    businessName: string | undefined;
    businessName2: string | undefined;
    addressAddition: string | undefined;
    uid: string | undefined;
    gln: string | undefined;
    medRegId: number | undefined;
    legalFormId: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    postOfficeBox: string | undefined;
    languageOfCorrespondenceId: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    email1: string | undefined;
    email2: string | undefined;
    mobile: string | undefined;
    website: string | undefined;
    dateOfEmployment: DateTime | undefined;
    dateOfEndOfEmployment: DateTime | undefined;
    levelOfEmployment: number | undefined;
    roleId: string | undefined;
    remark: string | undefined;
    isMobileEmployment: boolean;
    changeRequestTypeId: string | undefined;
    changeRequestStatusId: string | undefined;
    changeRequestDateOfStatusChange: DateTime | undefined;
    id: number;
}

export class UserProfessionalLicenceDto implements IUserProfessionalLicenceDto {
    caseId!: string | undefined;
    userId!: number;
    discriminator!: PersonLicenceType;
    professionId!: string;
    statusId!: string;
    dateOfIssue!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    legalBasisId!: string | undefined;
    legalBasisCantonId!: string | undefined;
    remark!: string | undefined;
    employments!: UserEmploymentDto[] | undefined;
    professionalLicenceDocuments!: GeneralFileInfoDto[] | undefined;
    id!: number;

    constructor(data?: IUserProfessionalLicenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.userId = _data["userId"];
            this.discriminator = _data["discriminator"];
            this.professionId = _data["professionId"];
            this.statusId = _data["statusId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.legalBasisId = _data["legalBasisId"];
            this.legalBasisCantonId = _data["legalBasisCantonId"];
            this.remark = _data["remark"];
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(UserEmploymentDto.fromJS(item));
            }
            if (Array.isArray(_data["professionalLicenceDocuments"])) {
                this.professionalLicenceDocuments = [] as any;
                for (let item of _data["professionalLicenceDocuments"])
                    this.professionalLicenceDocuments!.push(GeneralFileInfoDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserProfessionalLicenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfessionalLicenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["userId"] = this.userId;
        data["discriminator"] = this.discriminator;
        data["professionId"] = this.professionId;
        data["statusId"] = this.statusId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["legalBasisId"] = this.legalBasisId;
        data["legalBasisCantonId"] = this.legalBasisCantonId;
        data["remark"] = this.remark;
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item.toJSON());
        }
        if (Array.isArray(this.professionalLicenceDocuments)) {
            data["professionalLicenceDocuments"] = [];
            for (let item of this.professionalLicenceDocuments)
                data["professionalLicenceDocuments"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IUserProfessionalLicenceDto {
    caseId: string | undefined;
    userId: number;
    discriminator: PersonLicenceType;
    professionId: string;
    statusId: string;
    dateOfIssue: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    legalBasisId: string | undefined;
    legalBasisCantonId: string | undefined;
    remark: string | undefined;
    employments: UserEmploymentDto[] | undefined;
    professionalLicenceDocuments: GeneralFileInfoDto[] | undefined;
    id: number;
}

export class GetNaregPersonDetailedOutput implements IGetNaregPersonDetailedOutput {
    naregPerson!: NaregPersonDetailedDto;

    constructor(data?: IGetNaregPersonDetailedOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.naregPerson = _data["naregPerson"] ? NaregPersonDetailedDto.fromJS(_data["naregPerson"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetNaregPersonDetailedOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNaregPersonDetailedOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naregPerson"] = this.naregPerson ? this.naregPerson.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetNaregPersonDetailedOutput {
    naregPerson: NaregPersonDetailedDto;
}

export class GetNaregPersonOutput implements IGetNaregPersonOutput {
    naregPerson!: NaregPersonDto;

    constructor(data?: IGetNaregPersonOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.naregPerson = _data["naregPerson"] ? NaregPersonDto.fromJS(_data["naregPerson"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetNaregPersonOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNaregPersonOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["naregPerson"] = this.naregPerson ? this.naregPerson.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetNaregPersonOutput {
    naregPerson: NaregPersonDto;
}

export class NaregAddressDto implements INaregAddressDto {
    id!: number;
    type!: HealthRegisterCodeDto;
    legalForm!: HealthRegisterCodeDto;
    register!: HealthRegisterCodeDto;
    correspondenceLanguage!: HealthRegisterCodeDto;
    soleProprietorship!: HealthRegisterCodeDto;
    licenceId!: number | undefined;
    uidEstablishment!: string | undefined;
    street!: string | undefined;
    zip!: string | undefined;
    place!: string | undefined;
    supplement1!: string | undefined;
    supplement2!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    mobile!: string | undefined;
    email!: string | undefined;
    dateOfCreation!: DateTime | undefined;
    dateOfMutation!: DateTime | undefined;

    constructor(data?: INaregAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"] ? HealthRegisterCodeDto.fromJS(_data["type"]) : <any>undefined;
            this.legalForm = _data["legalForm"] ? HealthRegisterCodeDto.fromJS(_data["legalForm"]) : <any>undefined;
            this.register = _data["register"] ? HealthRegisterCodeDto.fromJS(_data["register"]) : <any>undefined;
            this.correspondenceLanguage = _data["correspondenceLanguage"] ? HealthRegisterCodeDto.fromJS(_data["correspondenceLanguage"]) : <any>undefined;
            this.soleProprietorship = _data["soleProprietorship"] ? HealthRegisterCodeDto.fromJS(_data["soleProprietorship"]) : <any>undefined;
            this.licenceId = _data["licenceId"];
            this.uidEstablishment = _data["uidEstablishment"];
            this.street = _data["street"];
            this.zip = _data["zip"];
            this.place = _data["place"];
            this.supplement1 = _data["supplement1"];
            this.supplement2 = _data["supplement2"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.mobile = _data["mobile"];
            this.email = _data["email"];
            this.dateOfCreation = _data["dateOfCreation"] ? DateTime.fromISO(_data["dateOfCreation"].toString()) : <any>undefined;
            this.dateOfMutation = _data["dateOfMutation"] ? DateTime.fromISO(_data["dateOfMutation"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NaregAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new NaregAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["legalForm"] = this.legalForm ? this.legalForm.toJSON() : <any>undefined;
        data["register"] = this.register ? this.register.toJSON() : <any>undefined;
        data["correspondenceLanguage"] = this.correspondenceLanguage ? this.correspondenceLanguage.toJSON() : <any>undefined;
        data["soleProprietorship"] = this.soleProprietorship ? this.soleProprietorship.toJSON() : <any>undefined;
        data["licenceId"] = this.licenceId;
        data["uidEstablishment"] = this.uidEstablishment;
        data["street"] = this.street;
        data["zip"] = this.zip;
        data["place"] = this.place;
        data["supplement1"] = this.supplement1;
        data["supplement2"] = this.supplement2;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["mobile"] = this.mobile;
        data["email"] = this.email;
        data["dateOfCreation"] = this.dateOfCreation ? this.dateOfCreation.toString() : <any>undefined;
        data["dateOfMutation"] = this.dateOfMutation ? this.dateOfMutation.toString() : <any>undefined;
        return data;
    }
}

export interface INaregAddressDto {
    id: number;
    type: HealthRegisterCodeDto;
    legalForm: HealthRegisterCodeDto;
    register: HealthRegisterCodeDto;
    correspondenceLanguage: HealthRegisterCodeDto;
    soleProprietorship: HealthRegisterCodeDto;
    licenceId: number | undefined;
    uidEstablishment: string | undefined;
    street: string | undefined;
    zip: string | undefined;
    place: string | undefined;
    supplement1: string | undefined;
    supplement2: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    mobile: string | undefined;
    email: string | undefined;
    dateOfCreation: DateTime | undefined;
    dateOfMutation: DateTime | undefined;
}

export class NaregDiplomDto implements INaregDiplomDto {
    id!: number;
    srkRegisterId!: string | undefined;
    country!: HealthRegisterCodeDto;
    diplomaType!: HealthRegisterCodeDto;
    profession!: HealthRegisterCodeDto;
    register!: HealthRegisterCodeDto;
    dateOfCreation!: DateTime | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfRecognition!: DateTime | undefined;
    dateOfMutation!: DateTime | undefined;

    constructor(data?: INaregDiplomDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.srkRegisterId = _data["srkRegisterId"];
            this.country = _data["country"] ? HealthRegisterCodeDto.fromJS(_data["country"]) : <any>undefined;
            this.diplomaType = _data["diplomaType"] ? HealthRegisterCodeDto.fromJS(_data["diplomaType"]) : <any>undefined;
            this.profession = _data["profession"] ? HealthRegisterCodeDto.fromJS(_data["profession"]) : <any>undefined;
            this.register = _data["register"] ? HealthRegisterCodeDto.fromJS(_data["register"]) : <any>undefined;
            this.dateOfCreation = _data["dateOfCreation"] ? DateTime.fromISO(_data["dateOfCreation"].toString()) : <any>undefined;
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfRecognition = _data["dateOfRecognition"] ? DateTime.fromISO(_data["dateOfRecognition"].toString()) : <any>undefined;
            this.dateOfMutation = _data["dateOfMutation"] ? DateTime.fromISO(_data["dateOfMutation"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NaregDiplomDto {
        data = typeof data === 'object' ? data : {};
        let result = new NaregDiplomDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["srkRegisterId"] = this.srkRegisterId;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["diplomaType"] = this.diplomaType ? this.diplomaType.toJSON() : <any>undefined;
        data["profession"] = this.profession ? this.profession.toJSON() : <any>undefined;
        data["register"] = this.register ? this.register.toJSON() : <any>undefined;
        data["dateOfCreation"] = this.dateOfCreation ? this.dateOfCreation.toString() : <any>undefined;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfRecognition"] = this.dateOfRecognition ? this.dateOfRecognition.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfMutation"] = this.dateOfMutation ? this.dateOfMutation.toString() : <any>undefined;
        return data;
    }
}

export interface INaregDiplomDto {
    id: number;
    srkRegisterId: string | undefined;
    country: HealthRegisterCodeDto;
    diplomaType: HealthRegisterCodeDto;
    profession: HealthRegisterCodeDto;
    register: HealthRegisterCodeDto;
    dateOfCreation: DateTime | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfRecognition: DateTime | undefined;
    dateOfMutation: DateTime | undefined;
}

export class NaregLicenceDto implements INaregLicenceDto {
    id!: number;
    canton!: HealthRegisterCodeDto;
    status!: HealthRegisterCodeDto;
    licenceType!: HealthRegisterCodeDto;
    profession!: HealthRegisterCodeDto;
    legalBasisLicence!: HealthRegisterCodeDto;
    register!: HealthRegisterCodeDto;
    remark!: string | undefined;
    dateOfCreation!: DateTime | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfMutation!: DateTime | undefined;
    addresses!: NaregAddressDto[] | undefined;
    restrictions!: NaregRestrictionDto[] | undefined;
    description!: string | undefined;

    constructor(data?: INaregLicenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.canton = _data["canton"] ? HealthRegisterCodeDto.fromJS(_data["canton"]) : <any>undefined;
            this.status = _data["status"] ? HealthRegisterCodeDto.fromJS(_data["status"]) : <any>undefined;
            this.licenceType = _data["licenceType"] ? HealthRegisterCodeDto.fromJS(_data["licenceType"]) : <any>undefined;
            this.profession = _data["profession"] ? HealthRegisterCodeDto.fromJS(_data["profession"]) : <any>undefined;
            this.legalBasisLicence = _data["legalBasisLicence"] ? HealthRegisterCodeDto.fromJS(_data["legalBasisLicence"]) : <any>undefined;
            this.register = _data["register"] ? HealthRegisterCodeDto.fromJS(_data["register"]) : <any>undefined;
            this.remark = _data["remark"];
            this.dateOfCreation = _data["dateOfCreation"] ? DateTime.fromISO(_data["dateOfCreation"].toString()) : <any>undefined;
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfMutation = _data["dateOfMutation"] ? DateTime.fromISO(_data["dateOfMutation"].toString()) : <any>undefined;
            if (Array.isArray(_data["addresses"])) {
                this.addresses = [] as any;
                for (let item of _data["addresses"])
                    this.addresses!.push(NaregAddressDto.fromJS(item));
            }
            if (Array.isArray(_data["restrictions"])) {
                this.restrictions = [] as any;
                for (let item of _data["restrictions"])
                    this.restrictions!.push(NaregRestrictionDto.fromJS(item));
            }
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): NaregLicenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new NaregLicenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["canton"] = this.canton ? this.canton.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["licenceType"] = this.licenceType ? this.licenceType.toJSON() : <any>undefined;
        data["profession"] = this.profession ? this.profession.toJSON() : <any>undefined;
        data["legalBasisLicence"] = this.legalBasisLicence ? this.legalBasisLicence.toJSON() : <any>undefined;
        data["register"] = this.register ? this.register.toJSON() : <any>undefined;
        data["remark"] = this.remark;
        data["dateOfCreation"] = this.dateOfCreation ? this.dateOfCreation.toString() : <any>undefined;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfMutation"] = this.dateOfMutation ? this.dateOfMutation.toString() : <any>undefined;
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        if (Array.isArray(this.restrictions)) {
            data["restrictions"] = [];
            for (let item of this.restrictions)
                data["restrictions"].push(item.toJSON());
        }
        data["description"] = this.description;
        return data;
    }
}

export interface INaregLicenceDto {
    id: number;
    canton: HealthRegisterCodeDto;
    status: HealthRegisterCodeDto;
    licenceType: HealthRegisterCodeDto;
    profession: HealthRegisterCodeDto;
    legalBasisLicence: HealthRegisterCodeDto;
    register: HealthRegisterCodeDto;
    remark: string | undefined;
    dateOfCreation: DateTime | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfMutation: DateTime | undefined;
    addresses: NaregAddressDto[] | undefined;
    restrictions: NaregRestrictionDto[] | undefined;
    description: string | undefined;
}

export class NaregPersonDetailedDto implements INaregPersonDetailedDto {
    ahv!: string | undefined;
    uid!: string | undefined;
    sexId!: HealthRegisterCodeDto;
    dateOfDeath!: DateTime | undefined;
    naregSensitiveData!: NaregSensitiveDataDto[] | undefined;
    placeOfOrigin!: string | undefined;
    cantonalLicenceRestrictions!: string[] | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    originalName!: string | undefined;
    gln!: string | undefined;
    correspondenceLanguage!: HealthRegisterCodeDto;
    country1!: HealthRegisterCodeDto;
    country2!: HealthRegisterCodeDto;
    naregDiploms!: NaregDiplomDto[] | undefined;
    naregLicences!: NaregLicenceDto[] | undefined;
    birthYear!: string | undefined;
    dateOfBirth!: DateTime | undefined;
    queryTime!: DateTime | undefined;
    id!: number;

    constructor(data?: INaregPersonDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ahv = _data["ahv"];
            this.uid = _data["uid"];
            this.sexId = _data["sexId"] ? HealthRegisterCodeDto.fromJS(_data["sexId"]) : <any>undefined;
            this.dateOfDeath = _data["dateOfDeath"] ? DateTime.fromISO(_data["dateOfDeath"].toString()) : <any>undefined;
            if (Array.isArray(_data["naregSensitiveData"])) {
                this.naregSensitiveData = [] as any;
                for (let item of _data["naregSensitiveData"])
                    this.naregSensitiveData!.push(NaregSensitiveDataDto.fromJS(item));
            }
            this.placeOfOrigin = _data["placeOfOrigin"];
            if (Array.isArray(_data["cantonalLicenceRestrictions"])) {
                this.cantonalLicenceRestrictions = [] as any;
                for (let item of _data["cantonalLicenceRestrictions"])
                    this.cantonalLicenceRestrictions!.push(item);
            }
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.originalName = _data["originalName"];
            this.gln = _data["gln"];
            this.correspondenceLanguage = _data["correspondenceLanguage"] ? HealthRegisterCodeDto.fromJS(_data["correspondenceLanguage"]) : <any>undefined;
            this.country1 = _data["country1"] ? HealthRegisterCodeDto.fromJS(_data["country1"]) : <any>undefined;
            this.country2 = _data["country2"] ? HealthRegisterCodeDto.fromJS(_data["country2"]) : <any>undefined;
            if (Array.isArray(_data["naregDiploms"])) {
                this.naregDiploms = [] as any;
                for (let item of _data["naregDiploms"])
                    this.naregDiploms!.push(NaregDiplomDto.fromJS(item));
            }
            if (Array.isArray(_data["naregLicences"])) {
                this.naregLicences = [] as any;
                for (let item of _data["naregLicences"])
                    this.naregLicences!.push(NaregLicenceDto.fromJS(item));
            }
            this.birthYear = _data["birthYear"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.queryTime = _data["queryTime"] ? DateTime.fromISO(_data["queryTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): NaregPersonDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new NaregPersonDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ahv"] = this.ahv;
        data["uid"] = this.uid;
        data["sexId"] = this.sexId ? this.sexId.toJSON() : <any>undefined;
        data["dateOfDeath"] = this.dateOfDeath ? this.dateOfDeath.toFormat('yyyy-MM-dd') : <any>undefined;
        if (Array.isArray(this.naregSensitiveData)) {
            data["naregSensitiveData"] = [];
            for (let item of this.naregSensitiveData)
                data["naregSensitiveData"].push(item.toJSON());
        }
        data["placeOfOrigin"] = this.placeOfOrigin;
        if (Array.isArray(this.cantonalLicenceRestrictions)) {
            data["cantonalLicenceRestrictions"] = [];
            for (let item of this.cantonalLicenceRestrictions)
                data["cantonalLicenceRestrictions"].push(item);
        }
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["originalName"] = this.originalName;
        data["gln"] = this.gln;
        data["correspondenceLanguage"] = this.correspondenceLanguage ? this.correspondenceLanguage.toJSON() : <any>undefined;
        data["country1"] = this.country1 ? this.country1.toJSON() : <any>undefined;
        data["country2"] = this.country2 ? this.country2.toJSON() : <any>undefined;
        if (Array.isArray(this.naregDiploms)) {
            data["naregDiploms"] = [];
            for (let item of this.naregDiploms)
                data["naregDiploms"].push(item.toJSON());
        }
        if (Array.isArray(this.naregLicences)) {
            data["naregLicences"] = [];
            for (let item of this.naregLicences)
                data["naregLicences"].push(item.toJSON());
        }
        data["birthYear"] = this.birthYear;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["queryTime"] = this.queryTime ? this.queryTime.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface INaregPersonDetailedDto {
    ahv: string | undefined;
    uid: string | undefined;
    sexId: HealthRegisterCodeDto;
    dateOfDeath: DateTime | undefined;
    naregSensitiveData: NaregSensitiveDataDto[] | undefined;
    placeOfOrigin: string | undefined;
    cantonalLicenceRestrictions: string[] | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    originalName: string | undefined;
    gln: string | undefined;
    correspondenceLanguage: HealthRegisterCodeDto;
    country1: HealthRegisterCodeDto;
    country2: HealthRegisterCodeDto;
    naregDiploms: NaregDiplomDto[] | undefined;
    naregLicences: NaregLicenceDto[] | undefined;
    birthYear: string | undefined;
    dateOfBirth: DateTime | undefined;
    queryTime: DateTime | undefined;
    id: number;
}

export class NaregPersonDto implements INaregPersonDto {
    firstName!: string | undefined;
    lastName!: string | undefined;
    originalName!: string | undefined;
    gln!: string | undefined;
    correspondenceLanguage!: HealthRegisterCodeDto;
    country1!: HealthRegisterCodeDto;
    country2!: HealthRegisterCodeDto;
    naregDiploms!: NaregDiplomDto[] | undefined;
    naregLicences!: NaregLicenceDto[] | undefined;
    birthYear!: string | undefined;
    dateOfBirth!: DateTime | undefined;
    queryTime!: DateTime | undefined;
    id!: number;

    constructor(data?: INaregPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.originalName = _data["originalName"];
            this.gln = _data["gln"];
            this.correspondenceLanguage = _data["correspondenceLanguage"] ? HealthRegisterCodeDto.fromJS(_data["correspondenceLanguage"]) : <any>undefined;
            this.country1 = _data["country1"] ? HealthRegisterCodeDto.fromJS(_data["country1"]) : <any>undefined;
            this.country2 = _data["country2"] ? HealthRegisterCodeDto.fromJS(_data["country2"]) : <any>undefined;
            if (Array.isArray(_data["naregDiploms"])) {
                this.naregDiploms = [] as any;
                for (let item of _data["naregDiploms"])
                    this.naregDiploms!.push(NaregDiplomDto.fromJS(item));
            }
            if (Array.isArray(_data["naregLicences"])) {
                this.naregLicences = [] as any;
                for (let item of _data["naregLicences"])
                    this.naregLicences!.push(NaregLicenceDto.fromJS(item));
            }
            this.birthYear = _data["birthYear"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.queryTime = _data["queryTime"] ? DateTime.fromISO(_data["queryTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): NaregPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new NaregPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["originalName"] = this.originalName;
        data["gln"] = this.gln;
        data["correspondenceLanguage"] = this.correspondenceLanguage ? this.correspondenceLanguage.toJSON() : <any>undefined;
        data["country1"] = this.country1 ? this.country1.toJSON() : <any>undefined;
        data["country2"] = this.country2 ? this.country2.toJSON() : <any>undefined;
        if (Array.isArray(this.naregDiploms)) {
            data["naregDiploms"] = [];
            for (let item of this.naregDiploms)
                data["naregDiploms"].push(item.toJSON());
        }
        if (Array.isArray(this.naregLicences)) {
            data["naregLicences"] = [];
            for (let item of this.naregLicences)
                data["naregLicences"].push(item.toJSON());
        }
        data["birthYear"] = this.birthYear;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["queryTime"] = this.queryTime ? this.queryTime.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface INaregPersonDto {
    firstName: string | undefined;
    lastName: string | undefined;
    originalName: string | undefined;
    gln: string | undefined;
    correspondenceLanguage: HealthRegisterCodeDto;
    country1: HealthRegisterCodeDto;
    country2: HealthRegisterCodeDto;
    naregDiploms: NaregDiplomDto[] | undefined;
    naregLicences: NaregLicenceDto[] | undefined;
    birthYear: string | undefined;
    dateOfBirth: DateTime | undefined;
    queryTime: DateTime | undefined;
    id: number;
}

export class NaregRestrictionDto implements INaregRestrictionDto {
    id!: number;
    licenceId!: number;
    restrictionType!: HealthRegisterCodeDto;
    description!: string | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfDecision!: DateTime | undefined;

    constructor(data?: INaregRestrictionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.licenceId = _data["licenceId"];
            this.restrictionType = _data["restrictionType"] ? HealthRegisterCodeDto.fromJS(_data["restrictionType"]) : <any>undefined;
            this.description = _data["description"];
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfDecision = _data["dateOfDecision"] ? DateTime.fromISO(_data["dateOfDecision"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NaregRestrictionDto {
        data = typeof data === 'object' ? data : {};
        let result = new NaregRestrictionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["licenceId"] = this.licenceId;
        data["restrictionType"] = this.restrictionType ? this.restrictionType.toJSON() : <any>undefined;
        data["description"] = this.description;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecision"] = this.dateOfDecision ? this.dateOfDecision.toFormat('yyyy-MM-dd') : <any>undefined;
        return data;
    }
}

export interface INaregRestrictionDto {
    id: number;
    licenceId: number;
    restrictionType: HealthRegisterCodeDto;
    description: string | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfDecision: DateTime | undefined;
}

export class NaregSensitiveDataDto implements INaregSensitiveDataDto {
    id!: number;
    isDeleted!: boolean;
    deletionDate!: DateTime | undefined;
    code!: HealthRegisterCodeDto;
    legalBasis!: HealthRegisterCodeDto;

    constructor(data?: INaregSensitiveDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDeleted = _data["isDeleted"];
            this.deletionDate = _data["deletionDate"] ? DateTime.fromISO(_data["deletionDate"].toString()) : <any>undefined;
            this.code = _data["code"] ? HealthRegisterCodeDto.fromJS(_data["code"]) : <any>undefined;
            this.legalBasis = _data["legalBasis"] ? HealthRegisterCodeDto.fromJS(_data["legalBasis"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NaregSensitiveDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new NaregSensitiveDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["deletionDate"] = this.deletionDate ? this.deletionDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["code"] = this.code ? this.code.toJSON() : <any>undefined;
        data["legalBasis"] = this.legalBasis ? this.legalBasis.toJSON() : <any>undefined;
        return data;
    }
}

export interface INaregSensitiveDataDto {
    id: number;
    isDeleted: boolean;
    deletionDate: DateTime | undefined;
    code: HealthRegisterCodeDto;
    legalBasis: HealthRegisterCodeDto;
}

export class SearchNaregPersonInput implements ISearchNaregPersonInput {
    id!: number | undefined;
    vorname!: string | undefined;
    nachname!: string | undefined;
    gln!: string | undefined;
    diplomArtId!: number | undefined;
    geburtsdatum!: DateTime | undefined;
    geburtsjahr!: number | undefined;
    geschlechtId!: number | undefined;
    nationalitaet1Id!: number | undefined;
    nationalitaet2Id!: number | undefined;
    heimatort!: string | undefined;
    professionId!: string | undefined;

    constructor(data?: ISearchNaregPersonInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.vorname = _data["vorname"];
            this.nachname = _data["nachname"];
            this.gln = _data["gln"];
            this.diplomArtId = _data["diplomArtId"];
            this.geburtsdatum = _data["geburtsdatum"] ? DateTime.fromISO(_data["geburtsdatum"].toString()) : <any>undefined;
            this.geburtsjahr = _data["geburtsjahr"];
            this.geschlechtId = _data["geschlechtId"];
            this.nationalitaet1Id = _data["nationalitaet1Id"];
            this.nationalitaet2Id = _data["nationalitaet2Id"];
            this.heimatort = _data["heimatort"];
            this.professionId = _data["professionId"];
        }
    }

    static fromJS(data: any): SearchNaregPersonInput {
        data = typeof data === 'object' ? data : {};
        let result = new SearchNaregPersonInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vorname"] = this.vorname;
        data["nachname"] = this.nachname;
        data["gln"] = this.gln;
        data["diplomArtId"] = this.diplomArtId;
        data["geburtsdatum"] = this.geburtsdatum ? this.geburtsdatum.toFormat('yyyy-MM-dd') : <any>undefined;
        data["geburtsjahr"] = this.geburtsjahr;
        data["geschlechtId"] = this.geschlechtId;
        data["nationalitaet1Id"] = this.nationalitaet1Id;
        data["nationalitaet2Id"] = this.nationalitaet2Id;
        data["heimatort"] = this.heimatort;
        data["professionId"] = this.professionId;
        return data;
    }
}

export interface ISearchNaregPersonInput {
    id: number | undefined;
    vorname: string | undefined;
    nachname: string | undefined;
    gln: string | undefined;
    diplomArtId: number | undefined;
    geburtsdatum: DateTime | undefined;
    geburtsjahr: number | undefined;
    geschlechtId: number | undefined;
    nationalitaet1Id: number | undefined;
    nationalitaet2Id: number | undefined;
    heimatort: string | undefined;
    professionId: string | undefined;
}

export class SearchNaregPersonOutput implements ISearchNaregPersonOutput {
    items!: NaregPersonDto[] | undefined;

    constructor(data?: ISearchNaregPersonOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NaregPersonDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchNaregPersonOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SearchNaregPersonOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchNaregPersonOutput {
    items: NaregPersonDto[] | undefined;
}

export class GetNotificationSettingsOutput implements IGetNotificationSettingsOutput {
    receiveNotifications!: boolean;
    notifications!: NotificationSubscriptionWithDisplayNameDto[] | undefined;

    constructor(data?: IGetNotificationSettingsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiveNotifications = _data["receiveNotifications"];
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [] as any;
                for (let item of _data["notifications"])
                    this.notifications!.push(NotificationSubscriptionWithDisplayNameDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNotificationSettingsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationSettingsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiveNotifications"] = this.receiveNotifications;
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetNotificationSettingsOutput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionWithDisplayNameDto[] | undefined;
}

export class GetNotificationsOutput implements IGetNotificationsOutput {
    unreadCount!: number;
    totalCount!: number;
    items!: UserNotification[] | undefined;

    constructor(data?: IGetNotificationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unreadCount = _data["unreadCount"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserNotification.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNotificationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unreadCount"] = this.unreadCount;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetNotificationsOutput {
    unreadCount: number;
    totalCount: number;
    items: UserNotification[] | undefined;
}

export class NotificationSubscriptionDto implements INotificationSubscriptionDto {
    name!: string;
    isSubscribed!: boolean;

    constructor(data?: INotificationSubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isSubscribed = _data["isSubscribed"];
        }
    }

    static fromJS(data: any): NotificationSubscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isSubscribed"] = this.isSubscribed;
        return data;
    }
}

export interface INotificationSubscriptionDto {
    name: string;
    isSubscribed: boolean;
}

export class NotificationSubscriptionWithDisplayNameDto implements INotificationSubscriptionWithDisplayNameDto {
    displayName!: string | undefined;
    description!: string | undefined;
    name!: string;
    isSubscribed!: boolean;

    constructor(data?: INotificationSubscriptionWithDisplayNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.name = _data["name"];
            this.isSubscribed = _data["isSubscribed"];
        }
    }

    static fromJS(data: any): NotificationSubscriptionWithDisplayNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSubscriptionWithDisplayNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["name"] = this.name;
        data["isSubscribed"] = this.isSubscribed;
        return data;
    }
}

export interface INotificationSubscriptionWithDisplayNameDto {
    displayName: string | undefined;
    description: string | undefined;
    name: string;
    isSubscribed: boolean;
}

export class SetNotificationAsReadOutput implements ISetNotificationAsReadOutput {
    success!: boolean;

    constructor(data?: ISetNotificationAsReadOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): SetNotificationAsReadOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SetNotificationAsReadOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface ISetNotificationAsReadOutput {
    success: boolean;
}

export class UpdateNotificationSettingsInput implements IUpdateNotificationSettingsInput {
    receiveNotifications!: boolean;
    notifications!: NotificationSubscriptionDto[] | undefined;

    constructor(data?: IUpdateNotificationSettingsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiveNotifications = _data["receiveNotifications"];
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [] as any;
                for (let item of _data["notifications"])
                    this.notifications!.push(NotificationSubscriptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateNotificationSettingsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNotificationSettingsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiveNotifications"] = this.receiveNotifications;
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateNotificationSettingsInput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionDto[] | undefined;
}

export class CreateOrganizationUnitInput implements ICreateOrganizationUnitInput {
    parentId!: number | undefined;
    displayName!: string;

    constructor(data?: ICreateOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): CreateOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ICreateOrganizationUnitInput {
    parentId: number | undefined;
    displayName: string;
}

export class FindOrganizationUnitProfessionsInput implements IFindOrganizationUnitProfessionsInput {
    organizationUnitId!: number;
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | undefined;

    constructor(data?: IFindOrganizationUnitProfessionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationUnitId = _data["organizationUnitId"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): FindOrganizationUnitProfessionsInput {
        data = typeof data === 'object' ? data : {};
        let result = new FindOrganizationUnitProfessionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnitId"] = this.organizationUnitId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data;
    }
}

export interface IFindOrganizationUnitProfessionsInput {
    organizationUnitId: number;
    maxResultCount: number;
    skipCount: number;
    filter: string | undefined;
}

export class FindOrganizationUnitRolesInput implements IFindOrganizationUnitRolesInput {
    organizationUnitId!: number;
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | undefined;

    constructor(data?: IFindOrganizationUnitRolesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationUnitId = _data["organizationUnitId"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): FindOrganizationUnitRolesInput {
        data = typeof data === 'object' ? data : {};
        let result = new FindOrganizationUnitRolesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnitId"] = this.organizationUnitId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data;
    }
}

export interface IFindOrganizationUnitRolesInput {
    organizationUnitId: number;
    maxResultCount: number;
    skipCount: number;
    filter: string | undefined;
}

export class FindOrganizationUnitUsersInput implements IFindOrganizationUnitUsersInput {
    organizationUnitId!: number;
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | undefined;

    constructor(data?: IFindOrganizationUnitUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationUnitId = _data["organizationUnitId"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): FindOrganizationUnitUsersInput {
        data = typeof data === 'object' ? data : {};
        let result = new FindOrganizationUnitUsersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnitId"] = this.organizationUnitId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data;
    }
}

export interface IFindOrganizationUnitUsersInput {
    organizationUnitId: number;
    maxResultCount: number;
    skipCount: number;
    filter: string | undefined;
}

export class MoveOrganizationUnitInput implements IMoveOrganizationUnitInput {
    id!: number;
    newParentId!: number | undefined;

    constructor(data?: IMoveOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.newParentId = _data["newParentId"];
        }
    }

    static fromJS(data: any): MoveOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new MoveOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["newParentId"] = this.newParentId;
        return data;
    }
}

export interface IMoveOrganizationUnitInput {
    id: number;
    newParentId: number | undefined;
}

export class OrganizationUnitDto implements IOrganizationUnitDto {
    parentId!: number | undefined;
    code!: string | undefined;
    displayName!: string | undefined;
    memberCount!: number;
    roleCount!: number;
    professionCount!: number;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.code = _data["code"];
            this.displayName = _data["displayName"];
            this.memberCount = _data["memberCount"];
            this.roleCount = _data["roleCount"];
            this.professionCount = _data["professionCount"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        data["memberCount"] = this.memberCount;
        data["roleCount"] = this.roleCount;
        data["professionCount"] = this.professionCount;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IOrganizationUnitDto {
    parentId: number | undefined;
    code: string | undefined;
    displayName: string | undefined;
    memberCount: number;
    roleCount: number;
    professionCount: number;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class OrganizationUnitProfessionListDto implements IOrganizationUnitProfessionListDto {
    displayName!: string | undefined;
    name!: string | undefined;
    addedTime!: DateTime;
    id!: number;

    constructor(data?: IOrganizationUnitProfessionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.name = _data["name"];
            this.addedTime = _data["addedTime"] ? DateTime.fromISO(_data["addedTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitProfessionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitProfessionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["name"] = this.name;
        data["addedTime"] = this.addedTime ? this.addedTime.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IOrganizationUnitProfessionListDto {
    displayName: string | undefined;
    name: string | undefined;
    addedTime: DateTime;
    id: number;
}

export class OrganizationUnitRoleListDto implements IOrganizationUnitRoleListDto {
    displayName!: string | undefined;
    name!: string | undefined;
    addedTime!: DateTime;
    id!: number;

    constructor(data?: IOrganizationUnitRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.name = _data["name"];
            this.addedTime = _data["addedTime"] ? DateTime.fromISO(_data["addedTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitRoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["name"] = this.name;
        data["addedTime"] = this.addedTime ? this.addedTime.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IOrganizationUnitRoleListDto {
    displayName: string | undefined;
    name: string | undefined;
    addedTime: DateTime;
    id: number;
}

export class OrganizationUnitUserListDto implements IOrganizationUnitUserListDto {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    profilePictureId!: string | undefined;
    addedTime!: DateTime;
    id!: number;

    constructor(data?: IOrganizationUnitUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.profilePictureId = _data["profilePictureId"];
            this.addedTime = _data["addedTime"] ? DateTime.fromISO(_data["addedTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["addedTime"] = this.addedTime ? this.addedTime.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IOrganizationUnitUserListDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;
    addedTime: DateTime;
    id: number;
}

export class ProfessionsToOrganizationUnitInput implements IProfessionsToOrganizationUnitInput {
    professionIds!: string[] | undefined;
    organizationUnitId!: number;

    constructor(data?: IProfessionsToOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["professionIds"])) {
                this.professionIds = [] as any;
                for (let item of _data["professionIds"])
                    this.professionIds!.push(item);
            }
            this.organizationUnitId = _data["organizationUnitId"];
        }
    }

    static fromJS(data: any): ProfessionsToOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessionsToOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.professionIds)) {
            data["professionIds"] = [];
            for (let item of this.professionIds)
                data["professionIds"].push(item);
        }
        data["organizationUnitId"] = this.organizationUnitId;
        return data;
    }
}

export interface IProfessionsToOrganizationUnitInput {
    professionIds: string[] | undefined;
    organizationUnitId: number;
}

export class RolesToOrganizationUnitInput implements IRolesToOrganizationUnitInput {
    roleIds!: number[] | undefined;
    organizationUnitId!: number;

    constructor(data?: IRolesToOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
            this.organizationUnitId = _data["organizationUnitId"];
        }
    }

    static fromJS(data: any): RolesToOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new RolesToOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        data["organizationUnitId"] = this.organizationUnitId;
        return data;
    }
}

export interface IRolesToOrganizationUnitInput {
    roleIds: number[] | undefined;
    organizationUnitId: number;
}

export class UpdateOrganizationUnitInput implements IUpdateOrganizationUnitInput {
    id!: number;
    displayName!: string;

    constructor(data?: IUpdateOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): UpdateOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IUpdateOrganizationUnitInput {
    id: number;
    displayName: string;
}

export class UsersToOrganizationUnitInput implements IUsersToOrganizationUnitInput {
    userIds!: number[] | undefined;
    organizationUnitId!: number;

    constructor(data?: IUsersToOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            this.organizationUnitId = _data["organizationUnitId"];
        }
    }

    static fromJS(data: any): UsersToOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new UsersToOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["organizationUnitId"] = this.organizationUnitId;
        return data;
    }
}

export interface IUsersToOrganizationUnitInput {
    userIds: number[] | undefined;
    organizationUnitId: number;
}

export class CreateOrUpdatePdfPersonInput implements ICreateOrUpdatePdfPersonInput {
    caseId!: string;
    person!: PdfPersonDto;

    constructor(data?: ICreateOrUpdatePdfPersonInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.person = _data["person"] ? PdfPersonDto.fromJS(_data["person"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrUpdatePdfPersonInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdatePdfPersonInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdatePdfPersonInput {
    caseId: string;
    person: PdfPersonDto;
}

export class CreateOrUpdatePdfPersonOutput implements ICreateOrUpdatePdfPersonOutput {
    healthRegisterIdentificationStatus!: HealthRegisterIdentificationStatus;
    healthRegisterSystem!: ExternalSystemEnum;
    healthRegisterId!: number | undefined;
    pdfPerson!: PdfPersonDto;
    status!: PdfStatus;

    constructor(data?: ICreateOrUpdatePdfPersonOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthRegisterIdentificationStatus = _data["healthRegisterIdentificationStatus"];
            this.healthRegisterSystem = _data["healthRegisterSystem"];
            this.healthRegisterId = _data["healthRegisterId"];
            this.pdfPerson = _data["pdfPerson"] ? PdfPersonDto.fromJS(_data["pdfPerson"]) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CreateOrUpdatePdfPersonOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdatePdfPersonOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthRegisterIdentificationStatus"] = this.healthRegisterIdentificationStatus;
        data["healthRegisterSystem"] = this.healthRegisterSystem;
        data["healthRegisterId"] = this.healthRegisterId;
        data["pdfPerson"] = this.pdfPerson ? this.pdfPerson.toJSON() : <any>undefined;
        data["status"] = this.status;
        return data;
    }
}

export interface ICreateOrUpdatePdfPersonOutput {
    healthRegisterIdentificationStatus: HealthRegisterIdentificationStatus;
    healthRegisterSystem: ExternalSystemEnum;
    healthRegisterId: number | undefined;
    pdfPerson: PdfPersonDto;
    status: PdfStatus;
}

export class CreateOrUpdatePdfSponsorshipInput implements ICreateOrUpdatePdfSponsorshipInput {
    caseId!: string;
    sponsorship!: PdfSponsorshipDto;

    constructor(data?: ICreateOrUpdatePdfSponsorshipInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sponsorship = new PdfSponsorshipDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.sponsorship = _data["sponsorship"] ? PdfSponsorshipDto.fromJS(_data["sponsorship"]) : new PdfSponsorshipDto();
        }
    }

    static fromJS(data: any): CreateOrUpdatePdfSponsorshipInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdatePdfSponsorshipInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["sponsorship"] = this.sponsorship ? this.sponsorship.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdatePdfSponsorshipInput {
    caseId: string;
    sponsorship: PdfSponsorshipDto;
}

export class CreateOrUpdatePdfSponsorshipOutput implements ICreateOrUpdatePdfSponsorshipOutput {
    sponsorship!: PdfSponsorshipDto;
    status!: PdfStatus;

    constructor(data?: ICreateOrUpdatePdfSponsorshipOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sponsorship = _data["sponsorship"] ? PdfSponsorshipDto.fromJS(_data["sponsorship"]) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CreateOrUpdatePdfSponsorshipOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdatePdfSponsorshipOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sponsorship"] = this.sponsorship ? this.sponsorship.toJSON() : <any>undefined;
        data["status"] = this.status;
        return data;
    }
}

export interface ICreateOrUpdatePdfSponsorshipOutput {
    sponsorship: PdfSponsorshipDto;
    status: PdfStatus;
}

export class CreatePdfInput implements ICreatePdfInput {
    pdfApplicationTypeId!: string | undefined;
    professionId!: string | undefined;
    sponsorshipTypeId!: string | undefined;

    constructor(data?: ICreatePdfInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pdfApplicationTypeId = _data["pdfApplicationTypeId"];
            this.professionId = _data["professionId"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
        }
    }

    static fromJS(data: any): CreatePdfInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePdfInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pdfApplicationTypeId"] = this.pdfApplicationTypeId;
        data["professionId"] = this.professionId;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        return data;
    }
}

export interface ICreatePdfInput {
    pdfApplicationTypeId: string | undefined;
    professionId: string | undefined;
    sponsorshipTypeId: string | undefined;
}

export class CreatePdfOutput implements ICreatePdfOutput {
    caseId!: string | undefined;

    constructor(data?: ICreatePdfOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
        }
    }

    static fromJS(data: any): CreatePdfOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePdfOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        return data;
    }
}

export interface ICreatePdfOutput {
    caseId: string | undefined;
}

export class GetPdfApplicationsOutput implements IGetPdfApplicationsOutput {
    totalCount!: number;
    items!: PdfApplicationSearchDto[] | undefined;

    constructor(data?: IGetPdfApplicationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PdfApplicationSearchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPdfApplicationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPdfApplicationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPdfApplicationsOutput {
    totalCount: number;
    items: PdfApplicationSearchDto[] | undefined;
}

export class GetPdfOutput implements IGetPdfOutput {
    pdfApplication!: PdfApplicationDto;

    constructor(data?: IGetPdfOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pdfApplication = _data["pdfApplication"] ? PdfApplicationDto.fromJS(_data["pdfApplication"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPdfOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPdfOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pdfApplication"] = this.pdfApplication ? this.pdfApplication.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPdfOutput {
    pdfApplication: PdfApplicationDto;
}

export class PdfApplicationDto implements IPdfApplicationDto {
    application!: ApplicationDto;
    pdfApplicationTypeId!: string | undefined;
    professionId!: string | undefined;
    sponsorshipTypeId!: string | undefined;
    pdfPerson!: PdfPersonDto;
    pdfSponsorship!: PdfSponsorshipDto;
    pdfDocuments!: GeneralDocumentGroupDto[] | undefined;
    currentStep!: PdfStatus;

    constructor(data?: IPdfApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationDto.fromJS(_data["application"]) : <any>undefined;
            this.pdfApplicationTypeId = _data["pdfApplicationTypeId"];
            this.professionId = _data["professionId"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.pdfPerson = _data["pdfPerson"] ? PdfPersonDto.fromJS(_data["pdfPerson"]) : <any>undefined;
            this.pdfSponsorship = _data["pdfSponsorship"] ? PdfSponsorshipDto.fromJS(_data["pdfSponsorship"]) : <any>undefined;
            if (Array.isArray(_data["pdfDocuments"])) {
                this.pdfDocuments = [] as any;
                for (let item of _data["pdfDocuments"])
                    this.pdfDocuments!.push(GeneralDocumentGroupDto.fromJS(item));
            }
            this.currentStep = _data["currentStep"];
        }
    }

    static fromJS(data: any): PdfApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PdfApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["pdfApplicationTypeId"] = this.pdfApplicationTypeId;
        data["professionId"] = this.professionId;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["pdfPerson"] = this.pdfPerson ? this.pdfPerson.toJSON() : <any>undefined;
        data["pdfSponsorship"] = this.pdfSponsorship ? this.pdfSponsorship.toJSON() : <any>undefined;
        if (Array.isArray(this.pdfDocuments)) {
            data["pdfDocuments"] = [];
            for (let item of this.pdfDocuments)
                data["pdfDocuments"].push(item.toJSON());
        }
        data["currentStep"] = this.currentStep;
        return data;
    }
}

export interface IPdfApplicationDto {
    application: ApplicationDto;
    pdfApplicationTypeId: string | undefined;
    professionId: string | undefined;
    sponsorshipTypeId: string | undefined;
    pdfPerson: PdfPersonDto;
    pdfSponsorship: PdfSponsorshipDto;
    pdfDocuments: GeneralDocumentGroupDto[] | undefined;
    currentStep: PdfStatus;
}

export class PdfApplicationSearchDto implements IPdfApplicationSearchDto {
    id!: number;
    responsibleId!: number | undefined;
    responsibleFullName!: string | undefined;
    iAmResponsible!: boolean;
    caseId!: string | undefined;
    caseIdSearchable!: string | undefined;
    userFullName!: string | undefined;
    userEmail!: string | undefined;
    entityName!: string | undefined;
    glnUid!: string | undefined;
    professionId!: string | undefined;
    sponsorshipTypeId!: string | undefined;
    pdfApplicationTypeId!: string | undefined;
    status!: ApplicationStatus;
    dateOfStatusChange!: DateTime;
    submittedCount!: number;
    submittedDate!: DateTime | undefined;
    lastSubmittedDate!: DateTime | undefined;

    constructor(data?: IPdfApplicationSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.responsibleId = _data["responsibleId"];
            this.responsibleFullName = _data["responsibleFullName"];
            this.iAmResponsible = _data["iAmResponsible"];
            this.caseId = _data["caseId"];
            this.caseIdSearchable = _data["caseIdSearchable"];
            this.userFullName = _data["userFullName"];
            this.userEmail = _data["userEmail"];
            this.entityName = _data["entityName"];
            this.glnUid = _data["glnUid"];
            this.professionId = _data["professionId"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.pdfApplicationTypeId = _data["pdfApplicationTypeId"];
            this.status = _data["status"];
            this.dateOfStatusChange = _data["dateOfStatusChange"] ? DateTime.fromISO(_data["dateOfStatusChange"].toString()) : <any>undefined;
            this.submittedCount = _data["submittedCount"];
            this.submittedDate = _data["submittedDate"] ? DateTime.fromISO(_data["submittedDate"].toString()) : <any>undefined;
            this.lastSubmittedDate = _data["lastSubmittedDate"] ? DateTime.fromISO(_data["lastSubmittedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PdfApplicationSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new PdfApplicationSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["responsibleId"] = this.responsibleId;
        data["responsibleFullName"] = this.responsibleFullName;
        data["iAmResponsible"] = this.iAmResponsible;
        data["caseId"] = this.caseId;
        data["caseIdSearchable"] = this.caseIdSearchable;
        data["userFullName"] = this.userFullName;
        data["userEmail"] = this.userEmail;
        data["entityName"] = this.entityName;
        data["glnUid"] = this.glnUid;
        data["professionId"] = this.professionId;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["pdfApplicationTypeId"] = this.pdfApplicationTypeId;
        data["status"] = this.status;
        data["dateOfStatusChange"] = this.dateOfStatusChange ? this.dateOfStatusChange.toString() : <any>undefined;
        data["submittedCount"] = this.submittedCount;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toString() : <any>undefined;
        data["lastSubmittedDate"] = this.lastSubmittedDate ? this.lastSubmittedDate.toString() : <any>undefined;
        return data;
    }
}

export interface IPdfApplicationSearchDto {
    id: number;
    responsibleId: number | undefined;
    responsibleFullName: string | undefined;
    iAmResponsible: boolean;
    caseId: string | undefined;
    caseIdSearchable: string | undefined;
    userFullName: string | undefined;
    userEmail: string | undefined;
    entityName: string | undefined;
    glnUid: string | undefined;
    professionId: string | undefined;
    sponsorshipTypeId: string | undefined;
    pdfApplicationTypeId: string | undefined;
    status: ApplicationStatus;
    dateOfStatusChange: DateTime;
    submittedCount: number;
    submittedDate: DateTime | undefined;
    lastSubmittedDate: DateTime | undefined;
}

export class PdfDocumentsOutput implements IPdfDocumentsOutput {
    caseId!: string;
    pdfDocuments!: GeneralDocumentGroupDto[];

    constructor(data?: IPdfDocumentsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pdfDocuments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["pdfDocuments"])) {
                this.pdfDocuments = [] as any;
                for (let item of _data["pdfDocuments"])
                    this.pdfDocuments!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PdfDocumentsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PdfDocumentsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.pdfDocuments)) {
            data["pdfDocuments"] = [];
            for (let item of this.pdfDocuments)
                data["pdfDocuments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPdfDocumentsOutput {
    caseId: string;
    pdfDocuments: GeneralDocumentGroupDto[];
}

export class PdfPersonDto implements IPdfPersonDto {
    firstName!: string | undefined;
    lastName!: string | undefined;
    birthName!: string | undefined;
    genderId!: string | undefined;
    dateOfBirth!: DateTime | undefined;
    nationality1Id!: string | undefined;
    nationality2Id!: string | undefined;
    placeOfOrigin!: string | undefined;
    residencePermit!: boolean | undefined;
    hasLicenceInAnotherCantonId!: string | undefined;
    hasConfirmedData!: boolean | undefined;
    dateOfResidencePermit!: DateTime | undefined;
    gln!: string | undefined;
    ahv!: string | undefined;
    zsr!: string | undefined;
    uid!: string | undefined;
    medRegId!: number | undefined;
    psyRegId!: number | undefined;
    naregId!: number | undefined;
    healthRegisterResult!: HealthRegisterIdentificationStatus;
    personId!: number | undefined;

    constructor(data?: IPdfPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.birthName = _data["birthName"];
            this.genderId = _data["genderId"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.nationality1Id = _data["nationality1Id"];
            this.nationality2Id = _data["nationality2Id"];
            this.placeOfOrigin = _data["placeOfOrigin"];
            this.residencePermit = _data["residencePermit"];
            this.hasLicenceInAnotherCantonId = _data["hasLicenceInAnotherCantonId"];
            this.hasConfirmedData = _data["hasConfirmedData"];
            this.dateOfResidencePermit = _data["dateOfResidencePermit"] ? DateTime.fromISO(_data["dateOfResidencePermit"].toString()) : <any>undefined;
            this.gln = _data["gln"];
            this.ahv = _data["ahv"];
            this.zsr = _data["zsr"];
            this.uid = _data["uid"];
            this.medRegId = _data["medRegId"];
            this.psyRegId = _data["psyRegId"];
            this.naregId = _data["naregId"];
            this.healthRegisterResult = _data["healthRegisterResult"];
            this.personId = _data["personId"];
        }
    }

    static fromJS(data: any): PdfPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new PdfPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["birthName"] = this.birthName;
        data["genderId"] = this.genderId;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["nationality1Id"] = this.nationality1Id;
        data["nationality2Id"] = this.nationality2Id;
        data["placeOfOrigin"] = this.placeOfOrigin;
        data["residencePermit"] = this.residencePermit;
        data["hasLicenceInAnotherCantonId"] = this.hasLicenceInAnotherCantonId;
        data["hasConfirmedData"] = this.hasConfirmedData;
        data["dateOfResidencePermit"] = this.dateOfResidencePermit ? this.dateOfResidencePermit.toFormat('yyyy-MM-dd') : <any>undefined;
        data["gln"] = this.gln;
        data["ahv"] = this.ahv;
        data["zsr"] = this.zsr;
        data["uid"] = this.uid;
        data["medRegId"] = this.medRegId;
        data["psyRegId"] = this.psyRegId;
        data["naregId"] = this.naregId;
        data["healthRegisterResult"] = this.healthRegisterResult;
        data["personId"] = this.personId;
        return data;
    }
}

export interface IPdfPersonDto {
    firstName: string | undefined;
    lastName: string | undefined;
    birthName: string | undefined;
    genderId: string | undefined;
    dateOfBirth: DateTime | undefined;
    nationality1Id: string | undefined;
    nationality2Id: string | undefined;
    placeOfOrigin: string | undefined;
    residencePermit: boolean | undefined;
    hasLicenceInAnotherCantonId: string | undefined;
    hasConfirmedData: boolean | undefined;
    dateOfResidencePermit: DateTime | undefined;
    gln: string | undefined;
    ahv: string | undefined;
    zsr: string | undefined;
    uid: string | undefined;
    medRegId: number | undefined;
    psyRegId: number | undefined;
    naregId: number | undefined;
    healthRegisterResult: HealthRegisterIdentificationStatus;
    personId: number | undefined;
}

export class PdfSponsorshipDto implements IPdfSponsorshipDto {
    uid!: string | undefined;
    name!: string;
    additionalName!: string | undefined;
    legalFormId!: string | undefined;
    postCode!: string;
    city!: string;
    street!: string;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    invoiceEmail!: string | undefined;
    website!: string | undefined;
    hasLicenceInAnotherCantonId!: string | undefined;

    constructor(data?: IPdfSponsorshipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uid = _data["uid"];
            this.name = _data["name"];
            this.additionalName = _data["additionalName"];
            this.legalFormId = _data["legalFormId"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.invoiceEmail = _data["invoiceEmail"];
            this.website = _data["website"];
            this.hasLicenceInAnotherCantonId = _data["hasLicenceInAnotherCantonId"];
        }
    }

    static fromJS(data: any): PdfSponsorshipDto {
        data = typeof data === 'object' ? data : {};
        let result = new PdfSponsorshipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uid"] = this.uid;
        data["name"] = this.name;
        data["additionalName"] = this.additionalName;
        data["legalFormId"] = this.legalFormId;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["invoiceEmail"] = this.invoiceEmail;
        data["website"] = this.website;
        data["hasLicenceInAnotherCantonId"] = this.hasLicenceInAnotherCantonId;
        return data;
    }
}

export interface IPdfSponsorshipDto {
    uid: string | undefined;
    name: string;
    additionalName: string | undefined;
    legalFormId: string | undefined;
    postCode: string;
    city: string;
    street: string;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    invoiceEmail: string | undefined;
    website: string | undefined;
    hasLicenceInAnotherCantonId: string | undefined;
}

export enum PdfStatus {
    Person = 0,
    Sponsorship = 1,
    Release = 97,
    Released = 98,
    FinishReview = 99,
}

export class PdfSummaryDto implements IPdfSummaryDto {
    pdfApplicationTypeId!: string | undefined;
    applicationStatus!: ApplicationStatus;
    dateOfStatusChange!: DateTime;
    caseId!: string | undefined;
    professionId!: string | undefined;
    sponsorshipTypeId!: string | undefined;

    constructor(data?: IPdfSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pdfApplicationTypeId = _data["pdfApplicationTypeId"];
            this.applicationStatus = _data["applicationStatus"];
            this.dateOfStatusChange = _data["dateOfStatusChange"] ? DateTime.fromISO(_data["dateOfStatusChange"].toString()) : <any>undefined;
            this.caseId = _data["caseId"];
            this.professionId = _data["professionId"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
        }
    }

    static fromJS(data: any): PdfSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PdfSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pdfApplicationTypeId"] = this.pdfApplicationTypeId;
        data["applicationStatus"] = this.applicationStatus;
        data["dateOfStatusChange"] = this.dateOfStatusChange ? this.dateOfStatusChange.toString() : <any>undefined;
        data["caseId"] = this.caseId;
        data["professionId"] = this.professionId;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        return data;
    }
}

export interface IPdfSummaryDto {
    pdfApplicationTypeId: string | undefined;
    applicationStatus: ApplicationStatus;
    dateOfStatusChange: DateTime;
    caseId: string | undefined;
    professionId: string | undefined;
    sponsorshipTypeId: string | undefined;
}

export class AssignPendenceInput implements IAssignPendenceInput {
    pendenceId!: number;
    userId!: number;

    constructor(data?: IAssignPendenceInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pendenceId = _data["pendenceId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AssignPendenceInput {
        data = typeof data === 'object' ? data : {};
        let result = new AssignPendenceInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pendenceId"] = this.pendenceId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IAssignPendenceInput {
    pendenceId: number;
    userId: number;
}

export class AssignPendenceOutput implements IAssignPendenceOutput {
    responsible!: string | undefined;
    userId!: number | undefined;

    constructor(data?: IAssignPendenceOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responsible = _data["responsible"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AssignPendenceOutput {
        data = typeof data === 'object' ? data : {};
        let result = new AssignPendenceOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responsible"] = this.responsible;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IAssignPendenceOutput {
    responsible: string | undefined;
    userId: number | undefined;
}

export class CompletePendencesInput implements ICompletePendencesInput {
    pendenceIds!: number[];

    constructor(data?: ICompletePendencesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pendenceIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pendenceIds"])) {
                this.pendenceIds = [] as any;
                for (let item of _data["pendenceIds"])
                    this.pendenceIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CompletePendencesInput {
        data = typeof data === 'object' ? data : {};
        let result = new CompletePendencesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pendenceIds)) {
            data["pendenceIds"] = [];
            for (let item of this.pendenceIds)
                data["pendenceIds"].push(item);
        }
        return data;
    }
}

export interface ICompletePendencesInput {
    pendenceIds: number[];
}

export class CreatePendenceDto implements ICreatePendenceDto {
    links!: PendenceLinkDto[];
    fieldId!: string;
    creationDate!: DateTime;
    responsibleId!: number | undefined;
    creatorUserId!: number | undefined;
    completorId!: number | undefined;
    statusId!: string;
    dueDate!: DateTime | undefined;
    rememberDate!: DateTime | undefined;
    completeDate!: DateTime | undefined;
    typeId!: string;
    sendReminderEmailToResponsible!: boolean;
    reminderMailDistributionListIds!: number[];
    description!: string | undefined;

    constructor(data?: ICreatePendenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.links = [];
            this.reminderMailDistributionListIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["links"])) {
                this.links = [] as any;
                for (let item of _data["links"])
                    this.links!.push(PendenceLinkDto.fromJS(item));
            }
            this.fieldId = _data["fieldId"];
            this.creationDate = _data["creationDate"] ? DateTime.fromISO(_data["creationDate"].toString()) : <any>undefined;
            this.responsibleId = _data["responsibleId"];
            this.creatorUserId = _data["creatorUserId"];
            this.completorId = _data["completorId"];
            this.statusId = _data["statusId"];
            this.dueDate = _data["dueDate"] ? DateTime.fromISO(_data["dueDate"].toString()) : <any>undefined;
            this.rememberDate = _data["rememberDate"] ? DateTime.fromISO(_data["rememberDate"].toString()) : <any>undefined;
            this.completeDate = _data["completeDate"] ? DateTime.fromISO(_data["completeDate"].toString()) : <any>undefined;
            this.typeId = _data["typeId"];
            this.sendReminderEmailToResponsible = _data["sendReminderEmailToResponsible"];
            if (Array.isArray(_data["reminderMailDistributionListIds"])) {
                this.reminderMailDistributionListIds = [] as any;
                for (let item of _data["reminderMailDistributionListIds"])
                    this.reminderMailDistributionListIds!.push(item);
            }
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreatePendenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePendenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.links)) {
            data["links"] = [];
            for (let item of this.links)
                data["links"].push(item.toJSON());
        }
        data["fieldId"] = this.fieldId;
        data["creationDate"] = this.creationDate ? this.creationDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["responsibleId"] = this.responsibleId;
        data["creatorUserId"] = this.creatorUserId;
        data["completorId"] = this.completorId;
        data["statusId"] = this.statusId;
        data["dueDate"] = this.dueDate ? this.dueDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["rememberDate"] = this.rememberDate ? this.rememberDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["completeDate"] = this.completeDate ? this.completeDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["typeId"] = this.typeId;
        data["sendReminderEmailToResponsible"] = this.sendReminderEmailToResponsible;
        if (Array.isArray(this.reminderMailDistributionListIds)) {
            data["reminderMailDistributionListIds"] = [];
            for (let item of this.reminderMailDistributionListIds)
                data["reminderMailDistributionListIds"].push(item);
        }
        data["description"] = this.description;
        return data;
    }
}

export interface ICreatePendenceDto {
    links: PendenceLinkDto[];
    fieldId: string;
    creationDate: DateTime;
    responsibleId: number | undefined;
    creatorUserId: number | undefined;
    completorId: number | undefined;
    statusId: string;
    dueDate: DateTime | undefined;
    rememberDate: DateTime | undefined;
    completeDate: DateTime | undefined;
    typeId: string;
    sendReminderEmailToResponsible: boolean;
    reminderMailDistributionListIds: number[];
    description: string | undefined;
}

export class GetPendencesSearchOutput implements IGetPendencesSearchOutput {
    totalCount!: number;
    items!: PendencesSearchResultDto[] | undefined;

    constructor(data?: IGetPendencesSearchOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PendencesSearchResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPendencesSearchOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPendencesSearchOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPendencesSearchOutput {
    totalCount: number;
    items: PendencesSearchResultDto[] | undefined;
}

export class PendenceDto implements IPendenceDto {
    fieldId!: string;
    creationDate!: DateTime;
    responsibleId!: number | undefined;
    creatorUserId!: number | undefined;
    completorId!: number | undefined;
    statusId!: string;
    dueDate!: DateTime | undefined;
    rememberDate!: DateTime | undefined;
    completeDate!: DateTime | undefined;
    typeId!: string;
    sendReminderEmailToResponsible!: boolean;
    reminderMailDistributionListIds!: number[];
    description!: string | undefined;

    constructor(data?: IPendenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.reminderMailDistributionListIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldId = _data["fieldId"];
            this.creationDate = _data["creationDate"] ? DateTime.fromISO(_data["creationDate"].toString()) : <any>undefined;
            this.responsibleId = _data["responsibleId"];
            this.creatorUserId = _data["creatorUserId"];
            this.completorId = _data["completorId"];
            this.statusId = _data["statusId"];
            this.dueDate = _data["dueDate"] ? DateTime.fromISO(_data["dueDate"].toString()) : <any>undefined;
            this.rememberDate = _data["rememberDate"] ? DateTime.fromISO(_data["rememberDate"].toString()) : <any>undefined;
            this.completeDate = _data["completeDate"] ? DateTime.fromISO(_data["completeDate"].toString()) : <any>undefined;
            this.typeId = _data["typeId"];
            this.sendReminderEmailToResponsible = _data["sendReminderEmailToResponsible"];
            if (Array.isArray(_data["reminderMailDistributionListIds"])) {
                this.reminderMailDistributionListIds = [] as any;
                for (let item of _data["reminderMailDistributionListIds"])
                    this.reminderMailDistributionListIds!.push(item);
            }
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PendenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PendenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldId"] = this.fieldId;
        data["creationDate"] = this.creationDate ? this.creationDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["responsibleId"] = this.responsibleId;
        data["creatorUserId"] = this.creatorUserId;
        data["completorId"] = this.completorId;
        data["statusId"] = this.statusId;
        data["dueDate"] = this.dueDate ? this.dueDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["rememberDate"] = this.rememberDate ? this.rememberDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["completeDate"] = this.completeDate ? this.completeDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["typeId"] = this.typeId;
        data["sendReminderEmailToResponsible"] = this.sendReminderEmailToResponsible;
        if (Array.isArray(this.reminderMailDistributionListIds)) {
            data["reminderMailDistributionListIds"] = [];
            for (let item of this.reminderMailDistributionListIds)
                data["reminderMailDistributionListIds"].push(item);
        }
        data["description"] = this.description;
        return data;
    }
}

export interface IPendenceDto {
    fieldId: string;
    creationDate: DateTime;
    responsibleId: number | undefined;
    creatorUserId: number | undefined;
    completorId: number | undefined;
    statusId: string;
    dueDate: DateTime | undefined;
    rememberDate: DateTime | undefined;
    completeDate: DateTime | undefined;
    typeId: string;
    sendReminderEmailToResponsible: boolean;
    reminderMailDistributionListIds: number[];
    description: string | undefined;
}

export class PendenceIncludingLinksDto implements IPendenceIncludingLinksDto {
    links!: PendenceLinkDescriptionDto[] | undefined;
    fieldId!: string;
    creationDate!: DateTime;
    responsibleId!: number | undefined;
    creatorUserId!: number | undefined;
    completorId!: number | undefined;
    statusId!: string;
    dueDate!: DateTime | undefined;
    rememberDate!: DateTime | undefined;
    completeDate!: DateTime | undefined;
    typeId!: string;
    sendReminderEmailToResponsible!: boolean;
    reminderMailDistributionListIds!: number[];
    description!: string | undefined;

    constructor(data?: IPendenceIncludingLinksDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.reminderMailDistributionListIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["links"])) {
                this.links = [] as any;
                for (let item of _data["links"])
                    this.links!.push(PendenceLinkDescriptionDto.fromJS(item));
            }
            this.fieldId = _data["fieldId"];
            this.creationDate = _data["creationDate"] ? DateTime.fromISO(_data["creationDate"].toString()) : <any>undefined;
            this.responsibleId = _data["responsibleId"];
            this.creatorUserId = _data["creatorUserId"];
            this.completorId = _data["completorId"];
            this.statusId = _data["statusId"];
            this.dueDate = _data["dueDate"] ? DateTime.fromISO(_data["dueDate"].toString()) : <any>undefined;
            this.rememberDate = _data["rememberDate"] ? DateTime.fromISO(_data["rememberDate"].toString()) : <any>undefined;
            this.completeDate = _data["completeDate"] ? DateTime.fromISO(_data["completeDate"].toString()) : <any>undefined;
            this.typeId = _data["typeId"];
            this.sendReminderEmailToResponsible = _data["sendReminderEmailToResponsible"];
            if (Array.isArray(_data["reminderMailDistributionListIds"])) {
                this.reminderMailDistributionListIds = [] as any;
                for (let item of _data["reminderMailDistributionListIds"])
                    this.reminderMailDistributionListIds!.push(item);
            }
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PendenceIncludingLinksDto {
        data = typeof data === 'object' ? data : {};
        let result = new PendenceIncludingLinksDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.links)) {
            data["links"] = [];
            for (let item of this.links)
                data["links"].push(item.toJSON());
        }
        data["fieldId"] = this.fieldId;
        data["creationDate"] = this.creationDate ? this.creationDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["responsibleId"] = this.responsibleId;
        data["creatorUserId"] = this.creatorUserId;
        data["completorId"] = this.completorId;
        data["statusId"] = this.statusId;
        data["dueDate"] = this.dueDate ? this.dueDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["rememberDate"] = this.rememberDate ? this.rememberDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["completeDate"] = this.completeDate ? this.completeDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["typeId"] = this.typeId;
        data["sendReminderEmailToResponsible"] = this.sendReminderEmailToResponsible;
        if (Array.isArray(this.reminderMailDistributionListIds)) {
            data["reminderMailDistributionListIds"] = [];
            for (let item of this.reminderMailDistributionListIds)
                data["reminderMailDistributionListIds"].push(item);
        }
        data["description"] = this.description;
        return data;
    }
}

export interface IPendenceIncludingLinksDto {
    links: PendenceLinkDescriptionDto[] | undefined;
    fieldId: string;
    creationDate: DateTime;
    responsibleId: number | undefined;
    creatorUserId: number | undefined;
    completorId: number | undefined;
    statusId: string;
    dueDate: DateTime | undefined;
    rememberDate: DateTime | undefined;
    completeDate: DateTime | undefined;
    typeId: string;
    sendReminderEmailToResponsible: boolean;
    reminderMailDistributionListIds: number[];
    description: string | undefined;
}

export class PendenceLinkDescriptionDto implements IPendenceLinkDescriptionDto {
    discriminator!: string | undefined;
    entityId!: number;
    description!: string | undefined;
    additionalData!: { [key: string]: any; } | undefined;

    constructor(data?: IPendenceLinkDescriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discriminator = _data["discriminator"];
            this.entityId = _data["entityId"];
            this.description = _data["description"];
            if (_data["additionalData"]) {
                this.additionalData = {} as any;
                for (let key in _data["additionalData"]) {
                    if (_data["additionalData"].hasOwnProperty(key))
                        (<any>this.additionalData)![key] = _data["additionalData"][key];
                }
            }
        }
    }

    static fromJS(data: any): PendenceLinkDescriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PendenceLinkDescriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this.discriminator;
        data["entityId"] = this.entityId;
        data["description"] = this.description;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    (<any>data["additionalData"])[key] = (<any>this.additionalData)[key];
            }
        }
        return data;
    }
}

export interface IPendenceLinkDescriptionDto {
    discriminator: string | undefined;
    entityId: number;
    description: string | undefined;
    additionalData: { [key: string]: any; } | undefined;
}

export class PendenceLinkDto implements IPendenceLinkDto {
    discriminator!: string | undefined;
    entityId!: number;

    constructor(data?: IPendenceLinkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discriminator = _data["discriminator"];
            this.entityId = _data["entityId"];
        }
    }

    static fromJS(data: any): PendenceLinkDto {
        data = typeof data === 'object' ? data : {};
        let result = new PendenceLinkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this.discriminator;
        data["entityId"] = this.entityId;
        return data;
    }
}

export interface IPendenceLinkDto {
    discriminator: string | undefined;
    entityId: number;
}

export class PendencesSearchResultDto implements IPendencesSearchResultDto {
    id!: number;
    responsibleId!: number | undefined;
    responsibleFullName!: string | undefined;
    description!: string | undefined;
    fieldId!: string | undefined;
    statusId!: string | undefined;
    typeId!: string | undefined;
    responsibleCheck!: boolean;
    creatorUserId!: number | undefined;
    completorId!: number | undefined;
    creationDate!: DateTime;
    dueDate!: DateTime | undefined;
    rememberDate!: DateTime | undefined;
    completeDate!: DateTime | undefined;
    links!: PendenceLinkDescriptionDto[] | undefined;

    constructor(data?: IPendencesSearchResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.responsibleId = _data["responsibleId"];
            this.responsibleFullName = _data["responsibleFullName"];
            this.description = _data["description"];
            this.fieldId = _data["fieldId"];
            this.statusId = _data["statusId"];
            this.typeId = _data["typeId"];
            this.responsibleCheck = _data["responsibleCheck"];
            this.creatorUserId = _data["creatorUserId"];
            this.completorId = _data["completorId"];
            this.creationDate = _data["creationDate"] ? DateTime.fromISO(_data["creationDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? DateTime.fromISO(_data["dueDate"].toString()) : <any>undefined;
            this.rememberDate = _data["rememberDate"] ? DateTime.fromISO(_data["rememberDate"].toString()) : <any>undefined;
            this.completeDate = _data["completeDate"] ? DateTime.fromISO(_data["completeDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["links"])) {
                this.links = [] as any;
                for (let item of _data["links"])
                    this.links!.push(PendenceLinkDescriptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PendencesSearchResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PendencesSearchResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["responsibleId"] = this.responsibleId;
        data["responsibleFullName"] = this.responsibleFullName;
        data["description"] = this.description;
        data["fieldId"] = this.fieldId;
        data["statusId"] = this.statusId;
        data["typeId"] = this.typeId;
        data["responsibleCheck"] = this.responsibleCheck;
        data["creatorUserId"] = this.creatorUserId;
        data["completorId"] = this.completorId;
        data["creationDate"] = this.creationDate ? this.creationDate.toString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toString() : <any>undefined;
        data["rememberDate"] = this.rememberDate ? this.rememberDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["completeDate"] = this.completeDate ? this.completeDate.toFormat('yyyy-MM-dd') : <any>undefined;
        if (Array.isArray(this.links)) {
            data["links"] = [];
            for (let item of this.links)
                data["links"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPendencesSearchResultDto {
    id: number;
    responsibleId: number | undefined;
    responsibleFullName: string | undefined;
    description: string | undefined;
    fieldId: string | undefined;
    statusId: string | undefined;
    typeId: string | undefined;
    responsibleCheck: boolean;
    creatorUserId: number | undefined;
    completorId: number | undefined;
    creationDate: DateTime;
    dueDate: DateTime | undefined;
    rememberDate: DateTime | undefined;
    completeDate: DateTime | undefined;
    links: PendenceLinkDescriptionDto[] | undefined;
}

export class GetPeopleApplicationsOutput implements IGetPeopleApplicationsOutput {
    totalCount!: number;
    items!: PersonApplicationSearchDto[] | undefined;

    constructor(data?: IGetPeopleApplicationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PersonApplicationSearchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPeopleApplicationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPeopleApplicationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPeopleApplicationsOutput {
    totalCount: number;
    items: PersonApplicationSearchDto[] | undefined;
}

export class PersonApplicationSearchDto implements IPersonApplicationSearchDto {
    id!: number;
    type!: number;
    caseId!: string | undefined;
    caseIdSearchable!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    fullName!: string | undefined;
    userFullName!: string | undefined;
    userEmail!: string | undefined;
    dateOfBirth!: DateTime | undefined;
    professionId!: string | undefined;
    status!: ApplicationStatus;
    dateOfStatusChange!: DateTime;
    responsibleId!: number | undefined;
    responsibleFullName!: string | undefined;
    iAmResponsible!: boolean;
    submittedCount!: number;
    submittedDate!: DateTime | undefined;
    lastSubmittedDate!: DateTime | undefined;
    requestedOrGrantedLicenceId!: number | undefined;

    constructor(data?: IPersonApplicationSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.caseId = _data["caseId"];
            this.caseIdSearchable = _data["caseIdSearchable"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.userFullName = _data["userFullName"];
            this.userEmail = _data["userEmail"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.professionId = _data["professionId"];
            this.status = _data["status"];
            this.dateOfStatusChange = _data["dateOfStatusChange"] ? DateTime.fromISO(_data["dateOfStatusChange"].toString()) : <any>undefined;
            this.responsibleId = _data["responsibleId"];
            this.responsibleFullName = _data["responsibleFullName"];
            this.iAmResponsible = _data["iAmResponsible"];
            this.submittedCount = _data["submittedCount"];
            this.submittedDate = _data["submittedDate"] ? DateTime.fromISO(_data["submittedDate"].toString()) : <any>undefined;
            this.lastSubmittedDate = _data["lastSubmittedDate"] ? DateTime.fromISO(_data["lastSubmittedDate"].toString()) : <any>undefined;
            this.requestedOrGrantedLicenceId = _data["requestedOrGrantedLicenceId"];
        }
    }

    static fromJS(data: any): PersonApplicationSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonApplicationSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["caseId"] = this.caseId;
        data["caseIdSearchable"] = this.caseIdSearchable;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["userFullName"] = this.userFullName;
        data["userEmail"] = this.userEmail;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["professionId"] = this.professionId;
        data["status"] = this.status;
        data["dateOfStatusChange"] = this.dateOfStatusChange ? this.dateOfStatusChange.toString() : <any>undefined;
        data["responsibleId"] = this.responsibleId;
        data["responsibleFullName"] = this.responsibleFullName;
        data["iAmResponsible"] = this.iAmResponsible;
        data["submittedCount"] = this.submittedCount;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toString() : <any>undefined;
        data["lastSubmittedDate"] = this.lastSubmittedDate ? this.lastSubmittedDate.toString() : <any>undefined;
        data["requestedOrGrantedLicenceId"] = this.requestedOrGrantedLicenceId;
        return data;
    }
}

export interface IPersonApplicationSearchDto {
    id: number;
    type: number;
    caseId: string | undefined;
    caseIdSearchable: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    fullName: string | undefined;
    userFullName: string | undefined;
    userEmail: string | undefined;
    dateOfBirth: DateTime | undefined;
    professionId: string | undefined;
    status: ApplicationStatus;
    dateOfStatusChange: DateTime;
    responsibleId: number | undefined;
    responsibleFullName: string | undefined;
    iAmResponsible: boolean;
    submittedCount: number;
    submittedDate: DateTime | undefined;
    lastSubmittedDate: DateTime | undefined;
    requestedOrGrantedLicenceId: number | undefined;
}

export class ContactDto implements IContactDto {
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    countryId!: string | undefined;
    titleId!: string | undefined;
    addressAddition!: string | undefined;
    email!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;

    constructor(data?: IContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.countryId = _data["countryId"];
            this.titleId = _data["titleId"];
            this.addressAddition = _data["addressAddition"];
            this.email = _data["email"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
        }
    }

    static fromJS(data: any): ContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["countryId"] = this.countryId;
        data["titleId"] = this.titleId;
        data["addressAddition"] = this.addressAddition;
        data["email"] = this.email;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        return data;
    }
}

export interface IContactDto {
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    countryId: string | undefined;
    titleId: string | undefined;
    addressAddition: string | undefined;
    email: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
}

export class CreateOrUpdatePersonDto implements ICreateOrUpdatePersonDto {
    id!: number;
    firstName!: string;
    lastName!: string;
    birthName!: string | undefined;
    genderId!: string;
    dateOfBirth!: DateTime;
    dateOfDeath!: DateTime | undefined;
    nationality1Id!: string | undefined;
    nationality2Id!: string | undefined;
    placeOfOrigin!: string | undefined;
    gln!: string | undefined;
    ahv!: string | undefined;
    uid!: string | undefined;
    comments!: string | undefined;
    sapId!: string | undefined;
    languageSkillCodeIds!: string[] | undefined;

    constructor(data?: ICreateOrUpdatePersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.birthName = _data["birthName"];
            this.genderId = _data["genderId"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.dateOfDeath = _data["dateOfDeath"] ? DateTime.fromISO(_data["dateOfDeath"].toString()) : <any>undefined;
            this.nationality1Id = _data["nationality1Id"];
            this.nationality2Id = _data["nationality2Id"];
            this.placeOfOrigin = _data["placeOfOrigin"];
            this.gln = _data["gln"];
            this.ahv = _data["ahv"];
            this.uid = _data["uid"];
            this.comments = _data["comments"];
            this.sapId = _data["sapId"];
            if (Array.isArray(_data["languageSkillCodeIds"])) {
                this.languageSkillCodeIds = [] as any;
                for (let item of _data["languageSkillCodeIds"])
                    this.languageSkillCodeIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOrUpdatePersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdatePersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["birthName"] = this.birthName;
        data["genderId"] = this.genderId;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDeath"] = this.dateOfDeath ? this.dateOfDeath.toFormat('yyyy-MM-dd') : <any>undefined;
        data["nationality1Id"] = this.nationality1Id;
        data["nationality2Id"] = this.nationality2Id;
        data["placeOfOrigin"] = this.placeOfOrigin;
        data["gln"] = this.gln;
        data["ahv"] = this.ahv;
        data["uid"] = this.uid;
        data["comments"] = this.comments;
        data["sapId"] = this.sapId;
        if (Array.isArray(this.languageSkillCodeIds)) {
            data["languageSkillCodeIds"] = [];
            for (let item of this.languageSkillCodeIds)
                data["languageSkillCodeIds"].push(item);
        }
        return data;
    }
}

export interface ICreateOrUpdatePersonDto {
    id: number;
    firstName: string;
    lastName: string;
    birthName: string | undefined;
    genderId: string;
    dateOfBirth: DateTime;
    dateOfDeath: DateTime | undefined;
    nationality1Id: string | undefined;
    nationality2Id: string | undefined;
    placeOfOrigin: string | undefined;
    gln: string | undefined;
    ahv: string | undefined;
    uid: string | undefined;
    comments: string | undefined;
    sapId: string | undefined;
    languageSkillCodeIds: string[] | undefined;
}

export class CreatePersonAndLinkToEmploymentInput implements ICreatePersonAndLinkToEmploymentInput {
    employmentId!: number;
    person!: EmploymentPersonDto;

    constructor(data?: ICreatePersonAndLinkToEmploymentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employmentId = _data["employmentId"];
            this.person = _data["person"] ? EmploymentPersonDto.fromJS(_data["person"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreatePersonAndLinkToEmploymentInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePersonAndLinkToEmploymentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employmentId"] = this.employmentId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreatePersonAndLinkToEmploymentInput {
    employmentId: number;
    person: EmploymentPersonDto;
}

export class CreatePersonFromEmploymentInfoDto implements ICreatePersonFromEmploymentInfoDto {
    gln!: string | undefined;
    professionId!: string | undefined;
    firstName!: string;
    lastName!: string;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string | undefined;
    email!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;

    constructor(data?: ICreatePersonFromEmploymentInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gln = _data["gln"];
            this.professionId = _data["professionId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.email = _data["email"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
        }
    }

    static fromJS(data: any): CreatePersonFromEmploymentInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePersonFromEmploymentInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gln"] = this.gln;
        data["professionId"] = this.professionId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["email"] = this.email;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        return data;
    }
}

export interface ICreatePersonFromEmploymentInfoDto {
    gln: string | undefined;
    professionId: string | undefined;
    firstName: string;
    lastName: string;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string | undefined;
    email: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
}

export class CreatePersonFromHealthRegisterInfoDto implements ICreatePersonFromHealthRegisterInfoDto {
    professionId!: string;
    gln!: string;

    constructor(data?: ICreatePersonFromHealthRegisterInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professionId = _data["professionId"];
            this.gln = _data["gln"];
        }
    }

    static fromJS(data: any): CreatePersonFromHealthRegisterInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePersonFromHealthRegisterInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professionId"] = this.professionId;
        data["gln"] = this.gln;
        return data;
    }
}

export interface ICreatePersonFromHealthRegisterInfoDto {
    professionId: string;
    gln: string;
}

export class EmploymentPersonDto implements IEmploymentPersonDto {
    id!: number;
    firstName!: string | undefined;
    lastName!: string | undefined;
    gln!: string | undefined;
    email!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;

    constructor(data?: IEmploymentPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.gln = _data["gln"];
            this.email = _data["email"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
        }
    }

    static fromJS(data: any): EmploymentPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmploymentPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["gln"] = this.gln;
        data["email"] = this.email;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        return data;
    }
}

export interface IEmploymentPersonDto {
    id: number;
    firstName: string | undefined;
    lastName: string | undefined;
    gln: string | undefined;
    email: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
}

export class GetPersonDto implements IGetPersonDto {
    medRegId!: number | undefined;
    naregId!: number | undefined;
    psyRegId!: number | undefined;
    id!: number;
    firstName!: string;
    lastName!: string;
    birthName!: string | undefined;
    genderId!: string;
    dateOfBirth!: DateTime;
    dateOfDeath!: DateTime | undefined;
    nationality1Id!: string | undefined;
    nationality2Id!: string | undefined;
    placeOfOrigin!: string | undefined;
    gln!: string | undefined;
    ahv!: string | undefined;
    uid!: string | undefined;
    comments!: string | undefined;
    sapId!: string | undefined;
    languageSkillCodeIds!: string[] | undefined;

    constructor(data?: IGetPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medRegId = _data["medRegId"];
            this.naregId = _data["naregId"];
            this.psyRegId = _data["psyRegId"];
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.birthName = _data["birthName"];
            this.genderId = _data["genderId"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.dateOfDeath = _data["dateOfDeath"] ? DateTime.fromISO(_data["dateOfDeath"].toString()) : <any>undefined;
            this.nationality1Id = _data["nationality1Id"];
            this.nationality2Id = _data["nationality2Id"];
            this.placeOfOrigin = _data["placeOfOrigin"];
            this.gln = _data["gln"];
            this.ahv = _data["ahv"];
            this.uid = _data["uid"];
            this.comments = _data["comments"];
            this.sapId = _data["sapId"];
            if (Array.isArray(_data["languageSkillCodeIds"])) {
                this.languageSkillCodeIds = [] as any;
                for (let item of _data["languageSkillCodeIds"])
                    this.languageSkillCodeIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GetPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medRegId"] = this.medRegId;
        data["naregId"] = this.naregId;
        data["psyRegId"] = this.psyRegId;
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["birthName"] = this.birthName;
        data["genderId"] = this.genderId;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDeath"] = this.dateOfDeath ? this.dateOfDeath.toFormat('yyyy-MM-dd') : <any>undefined;
        data["nationality1Id"] = this.nationality1Id;
        data["nationality2Id"] = this.nationality2Id;
        data["placeOfOrigin"] = this.placeOfOrigin;
        data["gln"] = this.gln;
        data["ahv"] = this.ahv;
        data["uid"] = this.uid;
        data["comments"] = this.comments;
        data["sapId"] = this.sapId;
        if (Array.isArray(this.languageSkillCodeIds)) {
            data["languageSkillCodeIds"] = [];
            for (let item of this.languageSkillCodeIds)
                data["languageSkillCodeIds"].push(item);
        }
        return data;
    }
}

export interface IGetPersonDto {
    medRegId: number | undefined;
    naregId: number | undefined;
    psyRegId: number | undefined;
    id: number;
    firstName: string;
    lastName: string;
    birthName: string | undefined;
    genderId: string;
    dateOfBirth: DateTime;
    dateOfDeath: DateTime | undefined;
    nationality1Id: string | undefined;
    nationality2Id: string | undefined;
    placeOfOrigin: string | undefined;
    gln: string | undefined;
    ahv: string | undefined;
    uid: string | undefined;
    comments: string | undefined;
    sapId: string | undefined;
    languageSkillCodeIds: string[] | undefined;
}

export class InvoiceAddressDto implements IInvoiceAddressDto {
    titleId!: string | undefined;
    name!: string | undefined;
    additionalName!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBoxNumber!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    countryId!: string | undefined;
    email!: string | undefined;
    sapId!: string | undefined;

    constructor(data?: IInvoiceAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.name = _data["name"];
            this.additionalName = _data["additionalName"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBoxNumber = _data["postOfficeBoxNumber"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.countryId = _data["countryId"];
            this.email = _data["email"];
            this.sapId = _data["sapId"];
        }
    }

    static fromJS(data: any): InvoiceAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["name"] = this.name;
        data["additionalName"] = this.additionalName;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBoxNumber"] = this.postOfficeBoxNumber;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["countryId"] = this.countryId;
        data["email"] = this.email;
        data["sapId"] = this.sapId;
        return data;
    }
}

export interface IInvoiceAddressDto {
    titleId: string | undefined;
    name: string | undefined;
    additionalName: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBoxNumber: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    countryId: string | undefined;
    email: string | undefined;
    sapId: string | undefined;
}

export class PersonSearchDto implements IPersonSearchDto {
    id!: number | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    birthName!: string | undefined;
    dateOfBirth!: DateTime | undefined;
    gln!: string | undefined;
    email!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    cantonId!: string | undefined;
    countryId!: string | undefined;
    isArchived!: boolean | undefined;
    professionIds!: string[] | undefined;
    filter!: string | undefined;
    sorting!: string | undefined;
    maxResultCount!: number;
    skipCount!: number;

    constructor(data?: IPersonSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.birthName = _data["birthName"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.gln = _data["gln"];
            this.email = _data["email"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.cantonId = _data["cantonId"];
            this.countryId = _data["countryId"];
            this.isArchived = _data["isArchived"];
            if (Array.isArray(_data["professionIds"])) {
                this.professionIds = [] as any;
                for (let item of _data["professionIds"])
                    this.professionIds!.push(item);
            }
            this.filter = _data["filter"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): PersonSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["birthName"] = this.birthName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["gln"] = this.gln;
        data["email"] = this.email;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["cantonId"] = this.cantonId;
        data["countryId"] = this.countryId;
        data["isArchived"] = this.isArchived;
        if (Array.isArray(this.professionIds)) {
            data["professionIds"] = [];
            for (let item of this.professionIds)
                data["professionIds"].push(item);
        }
        data["filter"] = this.filter;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }
}

export interface IPersonSearchDto {
    id: number | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    birthName: string | undefined;
    dateOfBirth: DateTime | undefined;
    gln: string | undefined;
    email: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    cantonId: string | undefined;
    countryId: string | undefined;
    isArchived: boolean | undefined;
    professionIds: string[] | undefined;
    filter: string | undefined;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
}

export class ProfessionalLicenceDto implements IProfessionalLicenceDto {
    caseId!: string | undefined;
    userId!: number;
    professionId!: string;
    statusId!: string;
    dateOfIssue!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfNinetyDaysStart!: DateTime | undefined;
    dateOfNinetyDaysEnd!: DateTime | undefined;
    legalBasisId!: string | undefined;
    legalBasisCantonId!: string | undefined;
    remark!: string | undefined;
    personId!: number;
    person!: EmploymentPersonDto;
    documents!: DocumentDto[] | undefined;
    id!: number;

    constructor(data?: IProfessionalLicenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.userId = _data["userId"];
            this.professionId = _data["professionId"];
            this.statusId = _data["statusId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfNinetyDaysStart = _data["dateOfNinetyDaysStart"] ? DateTime.fromISO(_data["dateOfNinetyDaysStart"].toString()) : <any>undefined;
            this.dateOfNinetyDaysEnd = _data["dateOfNinetyDaysEnd"] ? DateTime.fromISO(_data["dateOfNinetyDaysEnd"].toString()) : <any>undefined;
            this.legalBasisId = _data["legalBasisId"];
            this.legalBasisCantonId = _data["legalBasisCantonId"];
            this.remark = _data["remark"];
            this.personId = _data["personId"];
            this.person = _data["person"] ? EmploymentPersonDto.fromJS(_data["person"]) : <any>undefined;
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProfessionalLicenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessionalLicenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["userId"] = this.userId;
        data["professionId"] = this.professionId;
        data["statusId"] = this.statusId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfNinetyDaysStart"] = this.dateOfNinetyDaysStart ? this.dateOfNinetyDaysStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfNinetyDaysEnd"] = this.dateOfNinetyDaysEnd ? this.dateOfNinetyDaysEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["legalBasisId"] = this.legalBasisId;
        data["legalBasisCantonId"] = this.legalBasisCantonId;
        data["remark"] = this.remark;
        data["personId"] = this.personId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IProfessionalLicenceDto {
    caseId: string | undefined;
    userId: number;
    professionId: string;
    statusId: string;
    dateOfIssue: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfNinetyDaysStart: DateTime | undefined;
    dateOfNinetyDaysEnd: DateTime | undefined;
    legalBasisId: string | undefined;
    legalBasisCantonId: string | undefined;
    remark: string | undefined;
    personId: number;
    person: EmploymentPersonDto;
    documents: DocumentDto[] | undefined;
    id: number;
}

export class SponsorshipInvoiceAddressDto implements ISponsorshipInvoiceAddressDto {
    name!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBoxNumber!: string | undefined;
    additionalName!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    countryId!: string | undefined;
    email!: string | undefined;
    contactPerson!: string | undefined;
    sapId!: string | undefined;

    constructor(data?: ISponsorshipInvoiceAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBoxNumber = _data["postOfficeBoxNumber"];
            this.additionalName = _data["additionalName"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.countryId = _data["countryId"];
            this.email = _data["email"];
            this.contactPerson = _data["contactPerson"];
            this.sapId = _data["sapId"];
        }
    }

    static fromJS(data: any): SponsorshipInvoiceAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new SponsorshipInvoiceAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBoxNumber"] = this.postOfficeBoxNumber;
        data["additionalName"] = this.additionalName;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["countryId"] = this.countryId;
        data["email"] = this.email;
        data["contactPerson"] = this.contactPerson;
        data["sapId"] = this.sapId;
        return data;
    }
}

export interface ISponsorshipInvoiceAddressDto {
    name: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBoxNumber: string | undefined;
    additionalName: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    countryId: string | undefined;
    email: string | undefined;
    contactPerson: string | undefined;
    sapId: string | undefined;
}

export class GetPersonDossierSearchOutput implements IGetPersonDossierSearchOutput {
    totalCount!: number;
    items!: PersonDossierSearchDto[] | undefined;

    constructor(data?: IGetPersonDossierSearchOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PersonDossierSearchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPersonDossierSearchOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPersonDossierSearchOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPersonDossierSearchOutput {
    totalCount: number;
    items: PersonDossierSearchDto[] | undefined;
}

export class PersonDossierSearchDto implements IPersonDossierSearchDto {
    userId!: number | undefined;
    sapId!: string | undefined;
    isInterCompany!: boolean | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    fullName!: string | undefined;
    birthName!: string | undefined;
    dateOfBirth!: DateTime | undefined;
    genderId!: string | undefined;
    gln!: string | undefined;
    ahv!: string | undefined;
    email!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    countryId!: string | undefined;
    professionIds!: string | undefined;
    isArchived!: boolean;
    id!: number;

    constructor(data?: IPersonDossierSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.sapId = _data["sapId"];
            this.isInterCompany = _data["isInterCompany"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.birthName = _data["birthName"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.genderId = _data["genderId"];
            this.gln = _data["gln"];
            this.ahv = _data["ahv"];
            this.email = _data["email"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.countryId = _data["countryId"];
            this.professionIds = _data["professionIds"];
            this.isArchived = _data["isArchived"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PersonDossierSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonDossierSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["sapId"] = this.sapId;
        data["isInterCompany"] = this.isInterCompany;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["birthName"] = this.birthName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["genderId"] = this.genderId;
        data["gln"] = this.gln;
        data["ahv"] = this.ahv;
        data["email"] = this.email;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["countryId"] = this.countryId;
        data["professionIds"] = this.professionIds;
        data["isArchived"] = this.isArchived;
        data["id"] = this.id;
        return data;
    }
}

export interface IPersonDossierSearchDto {
    userId: number | undefined;
    sapId: string | undefined;
    isInterCompany: boolean | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    fullName: string | undefined;
    birthName: string | undefined;
    dateOfBirth: DateTime | undefined;
    genderId: string | undefined;
    gln: string | undefined;
    ahv: string | undefined;
    email: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    countryId: string | undefined;
    professionIds: string | undefined;
    isArchived: boolean;
    id: number;
}

export class PersonDossierSummaryDto implements IPersonDossierSummaryDto {
    id!: number;
    userId!: number;
    medRegId!: number | undefined;
    naregId!: number | undefined;
    psyRegId!: number | undefined;
    backendSystemId!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    birthName!: string | undefined;
    genderId!: string | undefined;
    dateOfBirth!: DateTime | undefined;
    dateOfDeath!: DateTime | undefined;
    nationality1Id!: string | undefined;
    nationality2Id!: string | undefined;
    placeOfOrigin!: string | undefined;
    gln!: string | undefined;
    ahv!: string | undefined;
    uid!: string | undefined;
    isArchived!: boolean;
    contactStreet!: string | undefined;
    contactStreetNr!: string | undefined;
    contactPostOfficeBox!: string | undefined;
    contactPostCode!: string | undefined;
    contactCity!: string | undefined;
    contactCountryId!: string | undefined;
    contactEmail!: string | undefined;
    contactPhone1!: string | undefined;
    contactPhone2!: string | undefined;
    invoiceAddressFullName!: string | undefined;
    invoiceAddressStreet!: string | undefined;
    invoiceAddressStreetNr!: string | undefined;
    invoiceAddressPostOfficeBox!: string | undefined;
    invoiceAddressPostCode!: string | undefined;
    invoiceAddressCity!: string | undefined;
    invoiceAddressCountryId!: string | undefined;
    invoiceAddressEmail!: string | undefined;

    constructor(data?: IPersonDossierSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.medRegId = _data["medRegId"];
            this.naregId = _data["naregId"];
            this.psyRegId = _data["psyRegId"];
            this.backendSystemId = _data["backendSystemId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.birthName = _data["birthName"];
            this.genderId = _data["genderId"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.dateOfDeath = _data["dateOfDeath"] ? DateTime.fromISO(_data["dateOfDeath"].toString()) : <any>undefined;
            this.nationality1Id = _data["nationality1Id"];
            this.nationality2Id = _data["nationality2Id"];
            this.placeOfOrigin = _data["placeOfOrigin"];
            this.gln = _data["gln"];
            this.ahv = _data["ahv"];
            this.uid = _data["uid"];
            this.isArchived = _data["isArchived"];
            this.contactStreet = _data["contactStreet"];
            this.contactStreetNr = _data["contactStreetNr"];
            this.contactPostOfficeBox = _data["contactPostOfficeBox"];
            this.contactPostCode = _data["contactPostCode"];
            this.contactCity = _data["contactCity"];
            this.contactCountryId = _data["contactCountryId"];
            this.contactEmail = _data["contactEmail"];
            this.contactPhone1 = _data["contactPhone1"];
            this.contactPhone2 = _data["contactPhone2"];
            this.invoiceAddressFullName = _data["invoiceAddressFullName"];
            this.invoiceAddressStreet = _data["invoiceAddressStreet"];
            this.invoiceAddressStreetNr = _data["invoiceAddressStreetNr"];
            this.invoiceAddressPostOfficeBox = _data["invoiceAddressPostOfficeBox"];
            this.invoiceAddressPostCode = _data["invoiceAddressPostCode"];
            this.invoiceAddressCity = _data["invoiceAddressCity"];
            this.invoiceAddressCountryId = _data["invoiceAddressCountryId"];
            this.invoiceAddressEmail = _data["invoiceAddressEmail"];
        }
    }

    static fromJS(data: any): PersonDossierSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonDossierSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["medRegId"] = this.medRegId;
        data["naregId"] = this.naregId;
        data["psyRegId"] = this.psyRegId;
        data["backendSystemId"] = this.backendSystemId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["birthName"] = this.birthName;
        data["genderId"] = this.genderId;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDeath"] = this.dateOfDeath ? this.dateOfDeath.toFormat('yyyy-MM-dd') : <any>undefined;
        data["nationality1Id"] = this.nationality1Id;
        data["nationality2Id"] = this.nationality2Id;
        data["placeOfOrigin"] = this.placeOfOrigin;
        data["gln"] = this.gln;
        data["ahv"] = this.ahv;
        data["uid"] = this.uid;
        data["isArchived"] = this.isArchived;
        data["contactStreet"] = this.contactStreet;
        data["contactStreetNr"] = this.contactStreetNr;
        data["contactPostOfficeBox"] = this.contactPostOfficeBox;
        data["contactPostCode"] = this.contactPostCode;
        data["contactCity"] = this.contactCity;
        data["contactCountryId"] = this.contactCountryId;
        data["contactEmail"] = this.contactEmail;
        data["contactPhone1"] = this.contactPhone1;
        data["contactPhone2"] = this.contactPhone2;
        data["invoiceAddressFullName"] = this.invoiceAddressFullName;
        data["invoiceAddressStreet"] = this.invoiceAddressStreet;
        data["invoiceAddressStreetNr"] = this.invoiceAddressStreetNr;
        data["invoiceAddressPostOfficeBox"] = this.invoiceAddressPostOfficeBox;
        data["invoiceAddressPostCode"] = this.invoiceAddressPostCode;
        data["invoiceAddressCity"] = this.invoiceAddressCity;
        data["invoiceAddressCountryId"] = this.invoiceAddressCountryId;
        data["invoiceAddressEmail"] = this.invoiceAddressEmail;
        return data;
    }
}

export interface IPersonDossierSummaryDto {
    id: number;
    userId: number;
    medRegId: number | undefined;
    naregId: number | undefined;
    psyRegId: number | undefined;
    backendSystemId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    birthName: string | undefined;
    genderId: string | undefined;
    dateOfBirth: DateTime | undefined;
    dateOfDeath: DateTime | undefined;
    nationality1Id: string | undefined;
    nationality2Id: string | undefined;
    placeOfOrigin: string | undefined;
    gln: string | undefined;
    ahv: string | undefined;
    uid: string | undefined;
    isArchived: boolean;
    contactStreet: string | undefined;
    contactStreetNr: string | undefined;
    contactPostOfficeBox: string | undefined;
    contactPostCode: string | undefined;
    contactCity: string | undefined;
    contactCountryId: string | undefined;
    contactEmail: string | undefined;
    contactPhone1: string | undefined;
    contactPhone2: string | undefined;
    invoiceAddressFullName: string | undefined;
    invoiceAddressStreet: string | undefined;
    invoiceAddressStreetNr: string | undefined;
    invoiceAddressPostOfficeBox: string | undefined;
    invoiceAddressPostCode: string | undefined;
    invoiceAddressCity: string | undefined;
    invoiceAddressCountryId: string | undefined;
    invoiceAddressEmail: string | undefined;
}

export class CreatePersonLicenceDto implements ICreatePersonLicenceDto {
    personId!: number;
    discriminator!: PersonLicenceType;
    professionId!: string | undefined;
    postgraduateTitleId!: string | undefined;

    constructor(data?: ICreatePersonLicenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.discriminator = _data["discriminator"];
            this.professionId = _data["professionId"];
            this.postgraduateTitleId = _data["postgraduateTitleId"];
        }
    }

    static fromJS(data: any): CreatePersonLicenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePersonLicenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["discriminator"] = this.discriminator;
        data["professionId"] = this.professionId;
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        return data;
    }
}

export interface ICreatePersonLicenceDto {
    personId: number;
    discriminator: PersonLicenceType;
    professionId: string | undefined;
    postgraduateTitleId: string | undefined;
}

export class CreatePersonLicenceRenewalDto implements ICreatePersonLicenceRenewalDto {
    personLicenceId!: number;
    dateOfApplication!: DateTime | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfInspection!: DateTime | undefined;
    remark!: string | undefined;

    constructor(data?: ICreatePersonLicenceRenewalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personLicenceId = _data["personLicenceId"];
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfInspection = _data["dateOfInspection"] ? DateTime.fromISO(_data["dateOfInspection"].toString()) : <any>undefined;
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): CreatePersonLicenceRenewalDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePersonLicenceRenewalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personLicenceId"] = this.personLicenceId;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfInspection"] = this.dateOfInspection ? this.dateOfInspection.toFormat('yyyy-MM-dd') : <any>undefined;
        data["remark"] = this.remark;
        return data;
    }
}

export interface ICreatePersonLicenceRenewalDto {
    personLicenceId: number;
    dateOfApplication: DateTime | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfInspection: DateTime | undefined;
    remark: string | undefined;
}

export class GetPersonLicenceDto implements IGetPersonLicenceDto {
    discriminator!: PersonLicenceType;
    personId!: number;
    person!: EmploymentPersonDto;
    personFirstName!: string | undefined;
    personLastName!: string | undefined;
    assistantPersonFirstName!: string | undefined;
    assistantPersonLastName!: string | undefined;
    representationPersonFirstName!: string | undefined;
    representationPersonLastName!: string | undefined;
    professionId!: string | undefined;
    postgraduateTitleId!: string | undefined;
    statusId!: string;
    legalBasisId!: string | undefined;
    legalBasisCantonId!: string | undefined;
    licencedBusinessId!: number | undefined;
    assistantPersonId!: number | undefined;
    parentLicenceId!: number | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfApplication!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfCancellation!: DateTime | undefined;
    dateOfInspection!: DateTime | undefined;
    dateOfNinetyDaysStart!: DateTime | undefined;
    dateOfNinetyDaysEnd!: DateTime | undefined;
    authorisationNarcoticId!: string | undefined;
    authorisationNarcoticRemarks!: string | undefined;
    remark!: string | undefined;
    doesVaccinesId!: string | undefined;
    doesVaccinesRemark!: string | undefined;
    details!: DetailsDto[] | undefined;
    healthRegisterTransfer!: boolean;
    automaticNotificationAndStatusChange!: boolean;
    dateOfRepresentationStart!: DateTime | undefined;
    dateOfProvisoryRepresentationEnd!: DateTime | undefined;
    levelOfWork!: number | undefined;
    representationBusinessId!: number | undefined;
    representationPersonId!: number | undefined;
    representationReasonId!: string | undefined;
    representationAdditionalReason!: string | undefined;

    constructor(data?: IGetPersonLicenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discriminator = _data["discriminator"];
            this.personId = _data["personId"];
            this.person = _data["person"] ? EmploymentPersonDto.fromJS(_data["person"]) : <any>undefined;
            this.personFirstName = _data["personFirstName"];
            this.personLastName = _data["personLastName"];
            this.assistantPersonFirstName = _data["assistantPersonFirstName"];
            this.assistantPersonLastName = _data["assistantPersonLastName"];
            this.representationPersonFirstName = _data["representationPersonFirstName"];
            this.representationPersonLastName = _data["representationPersonLastName"];
            this.professionId = _data["professionId"];
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.statusId = _data["statusId"];
            this.legalBasisId = _data["legalBasisId"];
            this.legalBasisCantonId = _data["legalBasisCantonId"];
            this.licencedBusinessId = _data["licencedBusinessId"];
            this.assistantPersonId = _data["assistantPersonId"];
            this.parentLicenceId = _data["parentLicenceId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfCancellation = _data["dateOfCancellation"] ? DateTime.fromISO(_data["dateOfCancellation"].toString()) : <any>undefined;
            this.dateOfInspection = _data["dateOfInspection"] ? DateTime.fromISO(_data["dateOfInspection"].toString()) : <any>undefined;
            this.dateOfNinetyDaysStart = _data["dateOfNinetyDaysStart"] ? DateTime.fromISO(_data["dateOfNinetyDaysStart"].toString()) : <any>undefined;
            this.dateOfNinetyDaysEnd = _data["dateOfNinetyDaysEnd"] ? DateTime.fromISO(_data["dateOfNinetyDaysEnd"].toString()) : <any>undefined;
            this.authorisationNarcoticId = _data["authorisationNarcoticId"];
            this.authorisationNarcoticRemarks = _data["authorisationNarcoticRemarks"];
            this.remark = _data["remark"];
            this.doesVaccinesId = _data["doesVaccinesId"];
            this.doesVaccinesRemark = _data["doesVaccinesRemark"];
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(DetailsDto.fromJS(item));
            }
            this.healthRegisterTransfer = _data["healthRegisterTransfer"];
            this.automaticNotificationAndStatusChange = _data["automaticNotificationAndStatusChange"];
            this.dateOfRepresentationStart = _data["dateOfRepresentationStart"] ? DateTime.fromISO(_data["dateOfRepresentationStart"].toString()) : <any>undefined;
            this.dateOfProvisoryRepresentationEnd = _data["dateOfProvisoryRepresentationEnd"] ? DateTime.fromISO(_data["dateOfProvisoryRepresentationEnd"].toString()) : <any>undefined;
            this.levelOfWork = _data["levelOfWork"];
            this.representationBusinessId = _data["representationBusinessId"];
            this.representationPersonId = _data["representationPersonId"];
            this.representationReasonId = _data["representationReasonId"];
            this.representationAdditionalReason = _data["representationAdditionalReason"];
        }
    }

    static fromJS(data: any): GetPersonLicenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPersonLicenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this.discriminator;
        data["personId"] = this.personId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["personFirstName"] = this.personFirstName;
        data["personLastName"] = this.personLastName;
        data["assistantPersonFirstName"] = this.assistantPersonFirstName;
        data["assistantPersonLastName"] = this.assistantPersonLastName;
        data["representationPersonFirstName"] = this.representationPersonFirstName;
        data["representationPersonLastName"] = this.representationPersonLastName;
        data["professionId"] = this.professionId;
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["statusId"] = this.statusId;
        data["legalBasisId"] = this.legalBasisId;
        data["legalBasisCantonId"] = this.legalBasisCantonId;
        data["licencedBusinessId"] = this.licencedBusinessId;
        data["assistantPersonId"] = this.assistantPersonId;
        data["parentLicenceId"] = this.parentLicenceId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCancellation"] = this.dateOfCancellation ? this.dateOfCancellation.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfInspection"] = this.dateOfInspection ? this.dateOfInspection.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfNinetyDaysStart"] = this.dateOfNinetyDaysStart ? this.dateOfNinetyDaysStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfNinetyDaysEnd"] = this.dateOfNinetyDaysEnd ? this.dateOfNinetyDaysEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["authorisationNarcoticId"] = this.authorisationNarcoticId;
        data["authorisationNarcoticRemarks"] = this.authorisationNarcoticRemarks;
        data["remark"] = this.remark;
        data["doesVaccinesId"] = this.doesVaccinesId;
        data["doesVaccinesRemark"] = this.doesVaccinesRemark;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["healthRegisterTransfer"] = this.healthRegisterTransfer;
        data["automaticNotificationAndStatusChange"] = this.automaticNotificationAndStatusChange;
        data["dateOfRepresentationStart"] = this.dateOfRepresentationStart ? this.dateOfRepresentationStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfProvisoryRepresentationEnd"] = this.dateOfProvisoryRepresentationEnd ? this.dateOfProvisoryRepresentationEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfWork"] = this.levelOfWork;
        data["representationBusinessId"] = this.representationBusinessId;
        data["representationPersonId"] = this.representationPersonId;
        data["representationReasonId"] = this.representationReasonId;
        data["representationAdditionalReason"] = this.representationAdditionalReason;
        return data;
    }
}

export interface IGetPersonLicenceDto {
    discriminator: PersonLicenceType;
    personId: number;
    person: EmploymentPersonDto;
    personFirstName: string | undefined;
    personLastName: string | undefined;
    assistantPersonFirstName: string | undefined;
    assistantPersonLastName: string | undefined;
    representationPersonFirstName: string | undefined;
    representationPersonLastName: string | undefined;
    professionId: string | undefined;
    postgraduateTitleId: string | undefined;
    statusId: string;
    legalBasisId: string | undefined;
    legalBasisCantonId: string | undefined;
    licencedBusinessId: number | undefined;
    assistantPersonId: number | undefined;
    parentLicenceId: number | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfApplication: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfCancellation: DateTime | undefined;
    dateOfInspection: DateTime | undefined;
    dateOfNinetyDaysStart: DateTime | undefined;
    dateOfNinetyDaysEnd: DateTime | undefined;
    authorisationNarcoticId: string | undefined;
    authorisationNarcoticRemarks: string | undefined;
    remark: string | undefined;
    doesVaccinesId: string | undefined;
    doesVaccinesRemark: string | undefined;
    details: DetailsDto[] | undefined;
    healthRegisterTransfer: boolean;
    automaticNotificationAndStatusChange: boolean;
    dateOfRepresentationStart: DateTime | undefined;
    dateOfProvisoryRepresentationEnd: DateTime | undefined;
    levelOfWork: number | undefined;
    representationBusinessId: number | undefined;
    representationPersonId: number | undefined;
    representationReasonId: string | undefined;
    representationAdditionalReason: string | undefined;
}

export class GetPersonLicenceMutationDto implements IGetPersonLicenceMutationDto {
    id!: number;
    dateOfApplication!: DateTime | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    remark!: string | undefined;
    types!: PersonLicenceMutationTypeDto[] | undefined;

    constructor(data?: IGetPersonLicenceMutationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.remark = _data["remark"];
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(PersonLicenceMutationTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPersonLicenceMutationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPersonLicenceMutationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["remark"] = this.remark;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPersonLicenceMutationDto {
    id: number;
    dateOfApplication: DateTime | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    remark: string | undefined;
    types: PersonLicenceMutationTypeDto[] | undefined;
}

export class GetPersonLicencesOutput implements IGetPersonLicencesOutput {
    items!: PersonLicenceDto[] | undefined;

    constructor(data?: IGetPersonLicencesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PersonLicenceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPersonLicencesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPersonLicencesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPersonLicencesOutput {
    items: PersonLicenceDto[] | undefined;
}

export class PersonLicenceHistoryDto implements IPersonLicenceHistoryDto {
    id!: number;
    time!: DateTime;
    reason!: string | undefined;
    userId!: number | undefined;
    entityChangeType!: EntityChangeType;
    propertyChanges!: { [key: string]: HistoryPropertyChange; } | undefined;
    statusId!: string | undefined;
    dateOfApplication!: DateTime | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    legalBasisId!: string | undefined;
    remark!: string | undefined;
    authorisationNarcoticId!: string | undefined;
    authorisationNarcoticRemarks!: string | undefined;

    constructor(data?: IPersonLicenceHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.time = _data["time"] ? DateTime.fromISO(_data["time"].toString()) : <any>undefined;
            this.reason = _data["reason"];
            this.userId = _data["userId"];
            this.entityChangeType = _data["entityChangeType"];
            if (_data["propertyChanges"]) {
                this.propertyChanges = {} as any;
                for (let key in _data["propertyChanges"]) {
                    if (_data["propertyChanges"].hasOwnProperty(key))
                        (<any>this.propertyChanges)![key] = _data["propertyChanges"][key];
                }
            }
            this.statusId = _data["statusId"];
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.legalBasisId = _data["legalBasisId"];
            this.remark = _data["remark"];
            this.authorisationNarcoticId = _data["authorisationNarcoticId"];
            this.authorisationNarcoticRemarks = _data["authorisationNarcoticRemarks"];
        }
    }

    static fromJS(data: any): PersonLicenceHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonLicenceHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["time"] = this.time ? this.time.toString() : <any>undefined;
        data["reason"] = this.reason;
        data["userId"] = this.userId;
        data["entityChangeType"] = this.entityChangeType;
        if (this.propertyChanges) {
            data["propertyChanges"] = {};
            for (let key in this.propertyChanges) {
                if (this.propertyChanges.hasOwnProperty(key))
                    (<any>data["propertyChanges"])[key] = (<any>this.propertyChanges)[key];
            }
        }
        data["statusId"] = this.statusId;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["legalBasisId"] = this.legalBasisId;
        data["remark"] = this.remark;
        data["authorisationNarcoticId"] = this.authorisationNarcoticId;
        data["authorisationNarcoticRemarks"] = this.authorisationNarcoticRemarks;
        return data;
    }
}

export interface IPersonLicenceHistoryDto {
    id: number;
    time: DateTime;
    reason: string | undefined;
    userId: number | undefined;
    entityChangeType: EntityChangeType;
    propertyChanges: { [key: string]: HistoryPropertyChange; } | undefined;
    statusId: string | undefined;
    dateOfApplication: DateTime | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    legalBasisId: string | undefined;
    remark: string | undefined;
    authorisationNarcoticId: string | undefined;
    authorisationNarcoticRemarks: string | undefined;
}

export class PersonLicenceDto implements IPersonLicenceDto {
    personId!: number;
    person!: EmploymentPersonDto;
    personFirstName!: string | undefined;
    personLastName!: string | undefined;
    discriminator!: PersonLicenceType;
    professionId!: string;
    postgraduateTitleId!: string | undefined;
    statusId!: string;
    legalBasisId!: string | undefined;
    legalBasisCantonId!: string | undefined;
    business!: GetBusinessDto;
    licencedBusinessId!: number | undefined;
    assistantPersonId!: number | undefined;
    assistantPersonFirstName!: string | undefined;
    assistantPersonLastName!: string | undefined;
    delegatedPersonId!: number | undefined;
    delegatedPersonFirstName!: string | undefined;
    delegatedPersonLastName!: string | undefined;
    parentLicenceId!: number | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfApplication!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfCancellation!: DateTime | undefined;
    dateOfInspection!: DateTime | undefined;
    dateOfNinetyDaysStart!: DateTime | undefined;
    dateOfNinetyDaysEnd!: DateTime | undefined;
    details!: DetailsDto[] | undefined;
    authorisationNarcoticId!: string | undefined;
    authorisationNarcoticRemarks!: string | undefined;
    remark!: string | undefined;
    doesVaccinesId!: string | undefined;
    doesVaccinesRemark!: string | undefined;
    healthRegisterTransfer!: boolean;
    healthRegisterSubmission!: DateTime | undefined;
    automaticNotificationAndStatusChange!: boolean;
    sapInvoiceStatusId!: string | undefined;
    dateOfSapInvoiceBilling!: DateTime | undefined;
    dateOfRepresentationStart!: DateTime | undefined;
    dateOfProvisoryRepresentationEnd!: DateTime | undefined;
    levelOfWork!: number | undefined;
    representationBusinessId!: number | undefined;
    representationPersonId!: number | undefined;
    representationPersonFirstName!: string | undefined;
    representationPersonLastName!: string | undefined;
    representationReasonId!: string | undefined;
    representationAdditionalReason!: string | undefined;
    renewals!: PersonLicenceRenewalDto[] | undefined;
    mutations!: GetPersonLicenceMutationDto[] | undefined;
    professionalResponsibilities!: PersonLicenceProfessionalResponsibilityDto[] | undefined;
    employments!: EmploymentDto[] | undefined;
    restrictions!: ProfessionalLicenceRestrictionDto[] | undefined;
    id!: number;

    constructor(data?: IPersonLicenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.person = _data["person"] ? EmploymentPersonDto.fromJS(_data["person"]) : <any>undefined;
            this.personFirstName = _data["personFirstName"];
            this.personLastName = _data["personLastName"];
            this.discriminator = _data["discriminator"];
            this.professionId = _data["professionId"];
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.statusId = _data["statusId"];
            this.legalBasisId = _data["legalBasisId"];
            this.legalBasisCantonId = _data["legalBasisCantonId"];
            this.business = _data["business"] ? GetBusinessDto.fromJS(_data["business"]) : <any>undefined;
            this.licencedBusinessId = _data["licencedBusinessId"];
            this.assistantPersonId = _data["assistantPersonId"];
            this.assistantPersonFirstName = _data["assistantPersonFirstName"];
            this.assistantPersonLastName = _data["assistantPersonLastName"];
            this.delegatedPersonId = _data["delegatedPersonId"];
            this.delegatedPersonFirstName = _data["delegatedPersonFirstName"];
            this.delegatedPersonLastName = _data["delegatedPersonLastName"];
            this.parentLicenceId = _data["parentLicenceId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfCancellation = _data["dateOfCancellation"] ? DateTime.fromISO(_data["dateOfCancellation"].toString()) : <any>undefined;
            this.dateOfInspection = _data["dateOfInspection"] ? DateTime.fromISO(_data["dateOfInspection"].toString()) : <any>undefined;
            this.dateOfNinetyDaysStart = _data["dateOfNinetyDaysStart"] ? DateTime.fromISO(_data["dateOfNinetyDaysStart"].toString()) : <any>undefined;
            this.dateOfNinetyDaysEnd = _data["dateOfNinetyDaysEnd"] ? DateTime.fromISO(_data["dateOfNinetyDaysEnd"].toString()) : <any>undefined;
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(DetailsDto.fromJS(item));
            }
            this.authorisationNarcoticId = _data["authorisationNarcoticId"];
            this.authorisationNarcoticRemarks = _data["authorisationNarcoticRemarks"];
            this.remark = _data["remark"];
            this.doesVaccinesId = _data["doesVaccinesId"];
            this.doesVaccinesRemark = _data["doesVaccinesRemark"];
            this.healthRegisterTransfer = _data["healthRegisterTransfer"];
            this.healthRegisterSubmission = _data["healthRegisterSubmission"] ? DateTime.fromISO(_data["healthRegisterSubmission"].toString()) : <any>undefined;
            this.automaticNotificationAndStatusChange = _data["automaticNotificationAndStatusChange"];
            this.sapInvoiceStatusId = _data["sapInvoiceStatusId"];
            this.dateOfSapInvoiceBilling = _data["dateOfSapInvoiceBilling"] ? DateTime.fromISO(_data["dateOfSapInvoiceBilling"].toString()) : <any>undefined;
            this.dateOfRepresentationStart = _data["dateOfRepresentationStart"] ? DateTime.fromISO(_data["dateOfRepresentationStart"].toString()) : <any>undefined;
            this.dateOfProvisoryRepresentationEnd = _data["dateOfProvisoryRepresentationEnd"] ? DateTime.fromISO(_data["dateOfProvisoryRepresentationEnd"].toString()) : <any>undefined;
            this.levelOfWork = _data["levelOfWork"];
            this.representationBusinessId = _data["representationBusinessId"];
            this.representationPersonId = _data["representationPersonId"];
            this.representationPersonFirstName = _data["representationPersonFirstName"];
            this.representationPersonLastName = _data["representationPersonLastName"];
            this.representationReasonId = _data["representationReasonId"];
            this.representationAdditionalReason = _data["representationAdditionalReason"];
            if (Array.isArray(_data["renewals"])) {
                this.renewals = [] as any;
                for (let item of _data["renewals"])
                    this.renewals!.push(PersonLicenceRenewalDto.fromJS(item));
            }
            if (Array.isArray(_data["mutations"])) {
                this.mutations = [] as any;
                for (let item of _data["mutations"])
                    this.mutations!.push(GetPersonLicenceMutationDto.fromJS(item));
            }
            if (Array.isArray(_data["professionalResponsibilities"])) {
                this.professionalResponsibilities = [] as any;
                for (let item of _data["professionalResponsibilities"])
                    this.professionalResponsibilities!.push(PersonLicenceProfessionalResponsibilityDto.fromJS(item));
            }
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(EmploymentDto.fromJS(item));
            }
            if (Array.isArray(_data["restrictions"])) {
                this.restrictions = [] as any;
                for (let item of _data["restrictions"])
                    this.restrictions!.push(ProfessionalLicenceRestrictionDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PersonLicenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonLicenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["personFirstName"] = this.personFirstName;
        data["personLastName"] = this.personLastName;
        data["discriminator"] = this.discriminator;
        data["professionId"] = this.professionId;
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["statusId"] = this.statusId;
        data["legalBasisId"] = this.legalBasisId;
        data["legalBasisCantonId"] = this.legalBasisCantonId;
        data["business"] = this.business ? this.business.toJSON() : <any>undefined;
        data["licencedBusinessId"] = this.licencedBusinessId;
        data["assistantPersonId"] = this.assistantPersonId;
        data["assistantPersonFirstName"] = this.assistantPersonFirstName;
        data["assistantPersonLastName"] = this.assistantPersonLastName;
        data["delegatedPersonId"] = this.delegatedPersonId;
        data["delegatedPersonFirstName"] = this.delegatedPersonFirstName;
        data["delegatedPersonLastName"] = this.delegatedPersonLastName;
        data["parentLicenceId"] = this.parentLicenceId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCancellation"] = this.dateOfCancellation ? this.dateOfCancellation.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfInspection"] = this.dateOfInspection ? this.dateOfInspection.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfNinetyDaysStart"] = this.dateOfNinetyDaysStart ? this.dateOfNinetyDaysStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfNinetyDaysEnd"] = this.dateOfNinetyDaysEnd ? this.dateOfNinetyDaysEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["authorisationNarcoticId"] = this.authorisationNarcoticId;
        data["authorisationNarcoticRemarks"] = this.authorisationNarcoticRemarks;
        data["remark"] = this.remark;
        data["doesVaccinesId"] = this.doesVaccinesId;
        data["doesVaccinesRemark"] = this.doesVaccinesRemark;
        data["healthRegisterTransfer"] = this.healthRegisterTransfer;
        data["healthRegisterSubmission"] = this.healthRegisterSubmission ? this.healthRegisterSubmission.toString() : <any>undefined;
        data["automaticNotificationAndStatusChange"] = this.automaticNotificationAndStatusChange;
        data["sapInvoiceStatusId"] = this.sapInvoiceStatusId;
        data["dateOfSapInvoiceBilling"] = this.dateOfSapInvoiceBilling ? this.dateOfSapInvoiceBilling.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfRepresentationStart"] = this.dateOfRepresentationStart ? this.dateOfRepresentationStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfProvisoryRepresentationEnd"] = this.dateOfProvisoryRepresentationEnd ? this.dateOfProvisoryRepresentationEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfWork"] = this.levelOfWork;
        data["representationBusinessId"] = this.representationBusinessId;
        data["representationPersonId"] = this.representationPersonId;
        data["representationPersonFirstName"] = this.representationPersonFirstName;
        data["representationPersonLastName"] = this.representationPersonLastName;
        data["representationReasonId"] = this.representationReasonId;
        data["representationAdditionalReason"] = this.representationAdditionalReason;
        if (Array.isArray(this.renewals)) {
            data["renewals"] = [];
            for (let item of this.renewals)
                data["renewals"].push(item.toJSON());
        }
        if (Array.isArray(this.mutations)) {
            data["mutations"] = [];
            for (let item of this.mutations)
                data["mutations"].push(item.toJSON());
        }
        if (Array.isArray(this.professionalResponsibilities)) {
            data["professionalResponsibilities"] = [];
            for (let item of this.professionalResponsibilities)
                data["professionalResponsibilities"].push(item.toJSON());
        }
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item.toJSON());
        }
        if (Array.isArray(this.restrictions)) {
            data["restrictions"] = [];
            for (let item of this.restrictions)
                data["restrictions"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IPersonLicenceDto {
    personId: number;
    person: EmploymentPersonDto;
    personFirstName: string | undefined;
    personLastName: string | undefined;
    discriminator: PersonLicenceType;
    professionId: string;
    postgraduateTitleId: string | undefined;
    statusId: string;
    legalBasisId: string | undefined;
    legalBasisCantonId: string | undefined;
    business: GetBusinessDto;
    licencedBusinessId: number | undefined;
    assistantPersonId: number | undefined;
    assistantPersonFirstName: string | undefined;
    assistantPersonLastName: string | undefined;
    delegatedPersonId: number | undefined;
    delegatedPersonFirstName: string | undefined;
    delegatedPersonLastName: string | undefined;
    parentLicenceId: number | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfApplication: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfCancellation: DateTime | undefined;
    dateOfInspection: DateTime | undefined;
    dateOfNinetyDaysStart: DateTime | undefined;
    dateOfNinetyDaysEnd: DateTime | undefined;
    details: DetailsDto[] | undefined;
    authorisationNarcoticId: string | undefined;
    authorisationNarcoticRemarks: string | undefined;
    remark: string | undefined;
    doesVaccinesId: string | undefined;
    doesVaccinesRemark: string | undefined;
    healthRegisterTransfer: boolean;
    healthRegisterSubmission: DateTime | undefined;
    automaticNotificationAndStatusChange: boolean;
    sapInvoiceStatusId: string | undefined;
    dateOfSapInvoiceBilling: DateTime | undefined;
    dateOfRepresentationStart: DateTime | undefined;
    dateOfProvisoryRepresentationEnd: DateTime | undefined;
    levelOfWork: number | undefined;
    representationBusinessId: number | undefined;
    representationPersonId: number | undefined;
    representationPersonFirstName: string | undefined;
    representationPersonLastName: string | undefined;
    representationReasonId: string | undefined;
    representationAdditionalReason: string | undefined;
    renewals: PersonLicenceRenewalDto[] | undefined;
    mutations: GetPersonLicenceMutationDto[] | undefined;
    professionalResponsibilities: PersonLicenceProfessionalResponsibilityDto[] | undefined;
    employments: EmploymentDto[] | undefined;
    restrictions: ProfessionalLicenceRestrictionDto[] | undefined;
    id: number;
}

export class PersonLicenceProfessionalResponsibilityDto implements IPersonLicenceProfessionalResponsibilityDto {
    personLicenceId!: number;
    typeId!: string | undefined;
    dateOfApplication!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    id!: number;

    constructor(data?: IPersonLicenceProfessionalResponsibilityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personLicenceId = _data["personLicenceId"];
            this.typeId = _data["typeId"];
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PersonLicenceProfessionalResponsibilityDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonLicenceProfessionalResponsibilityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personLicenceId"] = this.personLicenceId;
        data["typeId"] = this.typeId;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IPersonLicenceProfessionalResponsibilityDto {
    personLicenceId: number;
    typeId: string | undefined;
    dateOfApplication: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    id: number;
}

export class PersonLicenceRenewalDto implements IPersonLicenceRenewalDto {
    personLicenceId!: number;
    dateOfApplication!: DateTime | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfInspection!: DateTime | undefined;
    remark!: string | undefined;
    sapInvoiceStatusId!: string | undefined;
    dateOfSapInvoiceBilling!: DateTime | undefined;
    applicationId!: number | undefined;
    id!: number;

    constructor(data?: IPersonLicenceRenewalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personLicenceId = _data["personLicenceId"];
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfInspection = _data["dateOfInspection"] ? DateTime.fromISO(_data["dateOfInspection"].toString()) : <any>undefined;
            this.remark = _data["remark"];
            this.sapInvoiceStatusId = _data["sapInvoiceStatusId"];
            this.dateOfSapInvoiceBilling = _data["dateOfSapInvoiceBilling"] ? DateTime.fromISO(_data["dateOfSapInvoiceBilling"].toString()) : <any>undefined;
            this.applicationId = _data["applicationId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PersonLicenceRenewalDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonLicenceRenewalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personLicenceId"] = this.personLicenceId;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfInspection"] = this.dateOfInspection ? this.dateOfInspection.toFormat('yyyy-MM-dd') : <any>undefined;
        data["remark"] = this.remark;
        data["sapInvoiceStatusId"] = this.sapInvoiceStatusId;
        data["dateOfSapInvoiceBilling"] = this.dateOfSapInvoiceBilling ? this.dateOfSapInvoiceBilling.toFormat('yyyy-MM-dd') : <any>undefined;
        data["applicationId"] = this.applicationId;
        data["id"] = this.id;
        return data;
    }
}

export interface IPersonLicenceRenewalDto {
    personLicenceId: number;
    dateOfApplication: DateTime | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfInspection: DateTime | undefined;
    remark: string | undefined;
    sapInvoiceStatusId: string | undefined;
    dateOfSapInvoiceBilling: DateTime | undefined;
    applicationId: number | undefined;
    id: number;
}

export class PersonLicenceSchoolVaccineDto implements IPersonLicenceSchoolVaccineDto {
    doesSchoolVaccinesId!: string;
    remark!: string | undefined;

    constructor(data?: IPersonLicenceSchoolVaccineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.doesSchoolVaccinesId = _data["doesSchoolVaccinesId"];
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): PersonLicenceSchoolVaccineDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonLicenceSchoolVaccineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["doesSchoolVaccinesId"] = this.doesSchoolVaccinesId;
        data["remark"] = this.remark;
        return data;
    }
}

export interface IPersonLicenceSchoolVaccineDto {
    doesSchoolVaccinesId: string;
    remark: string | undefined;
}

export class SearchPersonLicenceDto implements ISearchPersonLicenceDto {
    personId!: number;
    personFirstName!: string | undefined;
    personLastName!: string | undefined;
    personGln!: string | undefined;
    discriminator!: PersonLicenceType;
    professionId!: string | undefined;
    postgraduateTitleId!: string | undefined;
    statusId!: string | undefined;
    legalBasisId!: string | undefined;
    legalBasisCantonId!: string | undefined;
    assistantPersonId!: number | undefined;
    assistantPersonFirstName!: string | undefined;
    assistantPersonLastName!: string | undefined;
    assistantPersonGln!: string | undefined;
    delegatedPersonId!: number | undefined;
    delegatedPersonFirstName!: string | undefined;
    delegatedPersonLastName!: string | undefined;
    delegatedPersonGln!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfApplication!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfCancellation!: DateTime | undefined;
    dateOfInspection!: DateTime | undefined;
    dateOfNinetyDaysStart!: DateTime | undefined;
    dateOfNinetyDaysEnd!: DateTime | undefined;
    authorisationNarcoticId!: string | undefined;
    authorisationNarcoticRemarks!: string | undefined;
    remark!: string | undefined;
    healthRegisterTransfer!: boolean;
    healthRegisterSubmission!: DateTime | undefined;
    automaticNotificationAndStatusChange!: boolean;
    id!: number;

    constructor(data?: ISearchPersonLicenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.personFirstName = _data["personFirstName"];
            this.personLastName = _data["personLastName"];
            this.personGln = _data["personGln"];
            this.discriminator = _data["discriminator"];
            this.professionId = _data["professionId"];
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.statusId = _data["statusId"];
            this.legalBasisId = _data["legalBasisId"];
            this.legalBasisCantonId = _data["legalBasisCantonId"];
            this.assistantPersonId = _data["assistantPersonId"];
            this.assistantPersonFirstName = _data["assistantPersonFirstName"];
            this.assistantPersonLastName = _data["assistantPersonLastName"];
            this.assistantPersonGln = _data["assistantPersonGln"];
            this.delegatedPersonId = _data["delegatedPersonId"];
            this.delegatedPersonFirstName = _data["delegatedPersonFirstName"];
            this.delegatedPersonLastName = _data["delegatedPersonLastName"];
            this.delegatedPersonGln = _data["delegatedPersonGln"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfCancellation = _data["dateOfCancellation"] ? DateTime.fromISO(_data["dateOfCancellation"].toString()) : <any>undefined;
            this.dateOfInspection = _data["dateOfInspection"] ? DateTime.fromISO(_data["dateOfInspection"].toString()) : <any>undefined;
            this.dateOfNinetyDaysStart = _data["dateOfNinetyDaysStart"] ? DateTime.fromISO(_data["dateOfNinetyDaysStart"].toString()) : <any>undefined;
            this.dateOfNinetyDaysEnd = _data["dateOfNinetyDaysEnd"] ? DateTime.fromISO(_data["dateOfNinetyDaysEnd"].toString()) : <any>undefined;
            this.authorisationNarcoticId = _data["authorisationNarcoticId"];
            this.authorisationNarcoticRemarks = _data["authorisationNarcoticRemarks"];
            this.remark = _data["remark"];
            this.healthRegisterTransfer = _data["healthRegisterTransfer"];
            this.healthRegisterSubmission = _data["healthRegisterSubmission"] ? DateTime.fromISO(_data["healthRegisterSubmission"].toString()) : <any>undefined;
            this.automaticNotificationAndStatusChange = _data["automaticNotificationAndStatusChange"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SearchPersonLicenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchPersonLicenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["personFirstName"] = this.personFirstName;
        data["personLastName"] = this.personLastName;
        data["personGln"] = this.personGln;
        data["discriminator"] = this.discriminator;
        data["professionId"] = this.professionId;
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["statusId"] = this.statusId;
        data["legalBasisId"] = this.legalBasisId;
        data["legalBasisCantonId"] = this.legalBasisCantonId;
        data["assistantPersonId"] = this.assistantPersonId;
        data["assistantPersonFirstName"] = this.assistantPersonFirstName;
        data["assistantPersonLastName"] = this.assistantPersonLastName;
        data["assistantPersonGln"] = this.assistantPersonGln;
        data["delegatedPersonId"] = this.delegatedPersonId;
        data["delegatedPersonFirstName"] = this.delegatedPersonFirstName;
        data["delegatedPersonLastName"] = this.delegatedPersonLastName;
        data["delegatedPersonGln"] = this.delegatedPersonGln;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCancellation"] = this.dateOfCancellation ? this.dateOfCancellation.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfInspection"] = this.dateOfInspection ? this.dateOfInspection.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfNinetyDaysStart"] = this.dateOfNinetyDaysStart ? this.dateOfNinetyDaysStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfNinetyDaysEnd"] = this.dateOfNinetyDaysEnd ? this.dateOfNinetyDaysEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["authorisationNarcoticId"] = this.authorisationNarcoticId;
        data["authorisationNarcoticRemarks"] = this.authorisationNarcoticRemarks;
        data["remark"] = this.remark;
        data["healthRegisterTransfer"] = this.healthRegisterTransfer;
        data["healthRegisterSubmission"] = this.healthRegisterSubmission ? this.healthRegisterSubmission.toString() : <any>undefined;
        data["automaticNotificationAndStatusChange"] = this.automaticNotificationAndStatusChange;
        data["id"] = this.id;
        return data;
    }
}

export interface ISearchPersonLicenceDto {
    personId: number;
    personFirstName: string | undefined;
    personLastName: string | undefined;
    personGln: string | undefined;
    discriminator: PersonLicenceType;
    professionId: string | undefined;
    postgraduateTitleId: string | undefined;
    statusId: string | undefined;
    legalBasisId: string | undefined;
    legalBasisCantonId: string | undefined;
    assistantPersonId: number | undefined;
    assistantPersonFirstName: string | undefined;
    assistantPersonLastName: string | undefined;
    assistantPersonGln: string | undefined;
    delegatedPersonId: number | undefined;
    delegatedPersonFirstName: string | undefined;
    delegatedPersonLastName: string | undefined;
    delegatedPersonGln: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfApplication: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfCancellation: DateTime | undefined;
    dateOfInspection: DateTime | undefined;
    dateOfNinetyDaysStart: DateTime | undefined;
    dateOfNinetyDaysEnd: DateTime | undefined;
    authorisationNarcoticId: string | undefined;
    authorisationNarcoticRemarks: string | undefined;
    remark: string | undefined;
    healthRegisterTransfer: boolean;
    healthRegisterSubmission: DateTime | undefined;
    automaticNotificationAndStatusChange: boolean;
    id: number;
}

export class SearchPersonLicencesInputDto implements ISearchPersonLicencesInputDto {
    personId!: number;
    types!: PersonLicenceType[];
    isOwner!: boolean;
    filter!: string | undefined;
    sorting!: string | undefined;
    maxResultCount!: number;
    skipCount!: number;

    constructor(data?: ISearchPersonLicencesInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.types = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(item);
            }
            this.isOwner = _data["isOwner"];
            this.filter = _data["filter"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): SearchPersonLicencesInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchPersonLicencesInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item);
        }
        data["isOwner"] = this.isOwner;
        data["filter"] = this.filter;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }
}

export interface ISearchPersonLicencesInputDto {
    personId: number;
    types: PersonLicenceType[];
    isOwner: boolean;
    filter: string | undefined;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
}

export class SearchPersonLicencesOutputDto implements ISearchPersonLicencesOutputDto {
    totalCount!: number;
    items!: SearchPersonLicenceDto[] | undefined;

    constructor(data?: ISearchPersonLicencesOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SearchPersonLicenceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchPersonLicencesOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchPersonLicencesOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchPersonLicencesOutputDto {
    totalCount: number;
    items: SearchPersonLicenceDto[] | undefined;
}

export class UpdatePersonLicenceDto implements IUpdatePersonLicenceDto {
    professionId!: string | undefined;
    postgraduateTitleId!: string | undefined;
    statusId!: string;
    legalBasisId!: string | undefined;
    legalBasisCantonId!: string | undefined;
    licencedBusinessId!: number | undefined;
    assistantPersonId!: number | undefined;
    parentLicenceId!: number | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfApplication!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfCancellation!: DateTime | undefined;
    dateOfInspection!: DateTime | undefined;
    dateOfNinetyDaysStart!: DateTime | undefined;
    dateOfNinetyDaysEnd!: DateTime | undefined;
    authorisationNarcoticId!: string | undefined;
    authorisationNarcoticRemarks!: string | undefined;
    remark!: string | undefined;
    doesVaccinesId!: string | undefined;
    doesVaccinesRemark!: string | undefined;
    details!: DetailsDto[] | undefined;
    healthRegisterTransfer!: boolean;
    automaticNotificationAndStatusChange!: boolean;
    dateOfRepresentationStart!: DateTime | undefined;
    dateOfProvisoryRepresentationEnd!: DateTime | undefined;
    levelOfWork!: number | undefined;
    representationBusinessId!: number | undefined;
    representationPersonId!: number | undefined;
    representationReasonId!: string | undefined;
    representationAdditionalReason!: string | undefined;

    constructor(data?: IUpdatePersonLicenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professionId = _data["professionId"];
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.statusId = _data["statusId"];
            this.legalBasisId = _data["legalBasisId"];
            this.legalBasisCantonId = _data["legalBasisCantonId"];
            this.licencedBusinessId = _data["licencedBusinessId"];
            this.assistantPersonId = _data["assistantPersonId"];
            this.parentLicenceId = _data["parentLicenceId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfCancellation = _data["dateOfCancellation"] ? DateTime.fromISO(_data["dateOfCancellation"].toString()) : <any>undefined;
            this.dateOfInspection = _data["dateOfInspection"] ? DateTime.fromISO(_data["dateOfInspection"].toString()) : <any>undefined;
            this.dateOfNinetyDaysStart = _data["dateOfNinetyDaysStart"] ? DateTime.fromISO(_data["dateOfNinetyDaysStart"].toString()) : <any>undefined;
            this.dateOfNinetyDaysEnd = _data["dateOfNinetyDaysEnd"] ? DateTime.fromISO(_data["dateOfNinetyDaysEnd"].toString()) : <any>undefined;
            this.authorisationNarcoticId = _data["authorisationNarcoticId"];
            this.authorisationNarcoticRemarks = _data["authorisationNarcoticRemarks"];
            this.remark = _data["remark"];
            this.doesVaccinesId = _data["doesVaccinesId"];
            this.doesVaccinesRemark = _data["doesVaccinesRemark"];
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(DetailsDto.fromJS(item));
            }
            this.healthRegisterTransfer = _data["healthRegisterTransfer"];
            this.automaticNotificationAndStatusChange = _data["automaticNotificationAndStatusChange"];
            this.dateOfRepresentationStart = _data["dateOfRepresentationStart"] ? DateTime.fromISO(_data["dateOfRepresentationStart"].toString()) : <any>undefined;
            this.dateOfProvisoryRepresentationEnd = _data["dateOfProvisoryRepresentationEnd"] ? DateTime.fromISO(_data["dateOfProvisoryRepresentationEnd"].toString()) : <any>undefined;
            this.levelOfWork = _data["levelOfWork"];
            this.representationBusinessId = _data["representationBusinessId"];
            this.representationPersonId = _data["representationPersonId"];
            this.representationReasonId = _data["representationReasonId"];
            this.representationAdditionalReason = _data["representationAdditionalReason"];
        }
    }

    static fromJS(data: any): UpdatePersonLicenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePersonLicenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professionId"] = this.professionId;
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["statusId"] = this.statusId;
        data["legalBasisId"] = this.legalBasisId;
        data["legalBasisCantonId"] = this.legalBasisCantonId;
        data["licencedBusinessId"] = this.licencedBusinessId;
        data["assistantPersonId"] = this.assistantPersonId;
        data["parentLicenceId"] = this.parentLicenceId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCancellation"] = this.dateOfCancellation ? this.dateOfCancellation.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfInspection"] = this.dateOfInspection ? this.dateOfInspection.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfNinetyDaysStart"] = this.dateOfNinetyDaysStart ? this.dateOfNinetyDaysStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfNinetyDaysEnd"] = this.dateOfNinetyDaysEnd ? this.dateOfNinetyDaysEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["authorisationNarcoticId"] = this.authorisationNarcoticId;
        data["authorisationNarcoticRemarks"] = this.authorisationNarcoticRemarks;
        data["remark"] = this.remark;
        data["doesVaccinesId"] = this.doesVaccinesId;
        data["doesVaccinesRemark"] = this.doesVaccinesRemark;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["healthRegisterTransfer"] = this.healthRegisterTransfer;
        data["automaticNotificationAndStatusChange"] = this.automaticNotificationAndStatusChange;
        data["dateOfRepresentationStart"] = this.dateOfRepresentationStart ? this.dateOfRepresentationStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfProvisoryRepresentationEnd"] = this.dateOfProvisoryRepresentationEnd ? this.dateOfProvisoryRepresentationEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfWork"] = this.levelOfWork;
        data["representationBusinessId"] = this.representationBusinessId;
        data["representationPersonId"] = this.representationPersonId;
        data["representationReasonId"] = this.representationReasonId;
        data["representationAdditionalReason"] = this.representationAdditionalReason;
        return data;
    }
}

export interface IUpdatePersonLicenceDto {
    professionId: string | undefined;
    postgraduateTitleId: string | undefined;
    statusId: string;
    legalBasisId: string | undefined;
    legalBasisCantonId: string | undefined;
    licencedBusinessId: number | undefined;
    assistantPersonId: number | undefined;
    parentLicenceId: number | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfApplication: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfCancellation: DateTime | undefined;
    dateOfInspection: DateTime | undefined;
    dateOfNinetyDaysStart: DateTime | undefined;
    dateOfNinetyDaysEnd: DateTime | undefined;
    authorisationNarcoticId: string | undefined;
    authorisationNarcoticRemarks: string | undefined;
    remark: string | undefined;
    doesVaccinesId: string | undefined;
    doesVaccinesRemark: string | undefined;
    details: DetailsDto[] | undefined;
    healthRegisterTransfer: boolean;
    automaticNotificationAndStatusChange: boolean;
    dateOfRepresentationStart: DateTime | undefined;
    dateOfProvisoryRepresentationEnd: DateTime | undefined;
    levelOfWork: number | undefined;
    representationBusinessId: number | undefined;
    representationPersonId: number | undefined;
    representationReasonId: string | undefined;
    representationAdditionalReason: string | undefined;
}

export class UpdatePersonLicenceRenewalDto implements IUpdatePersonLicenceRenewalDto {
    dateOfApplication!: DateTime | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfInspection!: DateTime | undefined;
    remark!: string | undefined;

    constructor(data?: IUpdatePersonLicenceRenewalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfInspection = _data["dateOfInspection"] ? DateTime.fromISO(_data["dateOfInspection"].toString()) : <any>undefined;
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): UpdatePersonLicenceRenewalDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePersonLicenceRenewalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfInspection"] = this.dateOfInspection ? this.dateOfInspection.toFormat('yyyy-MM-dd') : <any>undefined;
        data["remark"] = this.remark;
        return data;
    }
}

export interface IUpdatePersonLicenceRenewalDto {
    dateOfApplication: DateTime | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfInspection: DateTime | undefined;
    remark: string | undefined;
}

export class PersonLicenceMutationDto implements IPersonLicenceMutationDto {
    dateOfApplication!: DateTime | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfDecree!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    remark!: string | undefined;
    types!: PersonLicenceMutationTypeDto[] | undefined;

    constructor(data?: IPersonLicenceMutationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfDecree = _data["dateOfDecree"] ? DateTime.fromISO(_data["dateOfDecree"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.remark = _data["remark"];
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(PersonLicenceMutationTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PersonLicenceMutationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonLicenceMutationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDecree"] = this.dateOfDecree ? this.dateOfDecree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["remark"] = this.remark;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPersonLicenceMutationDto {
    dateOfApplication: DateTime | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfDecree: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    remark: string | undefined;
    types: PersonLicenceMutationTypeDto[] | undefined;
}

export class PersonLicenceMutationTypeDto implements IPersonLicenceMutationTypeDto {
    mutationTypeId!: string;

    constructor(data?: IPersonLicenceMutationTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mutationTypeId = _data["mutationTypeId"];
        }
    }

    static fromJS(data: any): PersonLicenceMutationTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonLicenceMutationTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mutationTypeId"] = this.mutationTypeId;
        return data;
    }
}

export interface IPersonLicenceMutationTypeDto {
    mutationTypeId: string;
}

export class TraineePersonLicenceDto implements ITraineePersonLicenceDto {
    firstName!: string | undefined;
    lastName!: string | undefined;
    birthName!: string | undefined;
    dateOfBirth!: DateTime | undefined;
    genderId!: string | undefined;
    nationalityId!: string | undefined;
    email!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    bachelorNameOfUniversity!: string | undefined;
    bachelorPlaceOfIssue!: string | undefined;
    bachelorCountryId!: string | undefined;
    bachelorDateOfDegree!: DateTime | undefined;
    bachelorEnrolledForMasterDegreeSince!: DateTime | undefined;
    bachelorNumberOfCreditPointsMasterDegree!: string | undefined;

    constructor(data?: ITraineePersonLicenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.birthName = _data["birthName"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.genderId = _data["genderId"];
            this.nationalityId = _data["nationalityId"];
            this.email = _data["email"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.bachelorNameOfUniversity = _data["bachelorNameOfUniversity"];
            this.bachelorPlaceOfIssue = _data["bachelorPlaceOfIssue"];
            this.bachelorCountryId = _data["bachelorCountryId"];
            this.bachelorDateOfDegree = _data["bachelorDateOfDegree"] ? DateTime.fromISO(_data["bachelorDateOfDegree"].toString()) : <any>undefined;
            this.bachelorEnrolledForMasterDegreeSince = _data["bachelorEnrolledForMasterDegreeSince"] ? DateTime.fromISO(_data["bachelorEnrolledForMasterDegreeSince"].toString()) : <any>undefined;
            this.bachelorNumberOfCreditPointsMasterDegree = _data["bachelorNumberOfCreditPointsMasterDegree"];
        }
    }

    static fromJS(data: any): TraineePersonLicenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new TraineePersonLicenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["birthName"] = this.birthName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["genderId"] = this.genderId;
        data["nationalityId"] = this.nationalityId;
        data["email"] = this.email;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["bachelorNameOfUniversity"] = this.bachelorNameOfUniversity;
        data["bachelorPlaceOfIssue"] = this.bachelorPlaceOfIssue;
        data["bachelorCountryId"] = this.bachelorCountryId;
        data["bachelorDateOfDegree"] = this.bachelorDateOfDegree ? this.bachelorDateOfDegree.toFormat('yyyy-MM-dd') : <any>undefined;
        data["bachelorEnrolledForMasterDegreeSince"] = this.bachelorEnrolledForMasterDegreeSince ? this.bachelorEnrolledForMasterDegreeSince.toFormat('yyyy-MM-dd') : <any>undefined;
        data["bachelorNumberOfCreditPointsMasterDegree"] = this.bachelorNumberOfCreditPointsMasterDegree;
        return data;
    }
}

export interface ITraineePersonLicenceDto {
    firstName: string | undefined;
    lastName: string | undefined;
    birthName: string | undefined;
    dateOfBirth: DateTime | undefined;
    genderId: string | undefined;
    nationalityId: string | undefined;
    email: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    bachelorNameOfUniversity: string | undefined;
    bachelorPlaceOfIssue: string | undefined;
    bachelorCountryId: string | undefined;
    bachelorDateOfDegree: DateTime | undefined;
    bachelorEnrolledForMasterDegreeSince: DateTime | undefined;
    bachelorNumberOfCreditPointsMasterDegree: string | undefined;
}

export class CreatePostgraduateTitleDto implements ICreatePostgraduateTitleDto {
    personId!: number;
    titleId!: string;
    typeId!: string | undefined;
    organisation!: string | undefined;
    placeOfIssue!: string | undefined;
    countryId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    issuingAuthority!: string | undefined;
    dateOfRecognition!: DateTime | undefined;
    placeOfRecognition!: string | undefined;
    recognitionAuthority!: string | undefined;
    dateOfEquivalence!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    verifiedBy!: string | undefined;
    specialKnowledgeBasis!: string | undefined;
    remarks!: string | undefined;
    overwriteWithHealthRegisterData!: boolean;

    constructor(data?: ICreatePostgraduateTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.titleId = _data["titleId"];
            this.typeId = _data["typeId"];
            this.organisation = _data["organisation"];
            this.placeOfIssue = _data["placeOfIssue"];
            this.countryId = _data["countryId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.issuingAuthority = _data["issuingAuthority"];
            this.dateOfRecognition = _data["dateOfRecognition"] ? DateTime.fromISO(_data["dateOfRecognition"].toString()) : <any>undefined;
            this.placeOfRecognition = _data["placeOfRecognition"];
            this.recognitionAuthority = _data["recognitionAuthority"];
            this.dateOfEquivalence = _data["dateOfEquivalence"] ? DateTime.fromISO(_data["dateOfEquivalence"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.verifiedBy = _data["verifiedBy"];
            this.specialKnowledgeBasis = _data["specialKnowledgeBasis"];
            this.remarks = _data["remarks"];
            this.overwriteWithHealthRegisterData = _data["overwriteWithHealthRegisterData"];
        }
    }

    static fromJS(data: any): CreatePostgraduateTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePostgraduateTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["titleId"] = this.titleId;
        data["typeId"] = this.typeId;
        data["organisation"] = this.organisation;
        data["placeOfIssue"] = this.placeOfIssue;
        data["countryId"] = this.countryId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["issuingAuthority"] = this.issuingAuthority;
        data["dateOfRecognition"] = this.dateOfRecognition ? this.dateOfRecognition.toFormat('yyyy-MM-dd') : <any>undefined;
        data["placeOfRecognition"] = this.placeOfRecognition;
        data["recognitionAuthority"] = this.recognitionAuthority;
        data["dateOfEquivalence"] = this.dateOfEquivalence ? this.dateOfEquivalence.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["verifiedBy"] = this.verifiedBy;
        data["specialKnowledgeBasis"] = this.specialKnowledgeBasis;
        data["remarks"] = this.remarks;
        data["overwriteWithHealthRegisterData"] = this.overwriteWithHealthRegisterData;
        return data;
    }
}

export interface ICreatePostgraduateTitleDto {
    personId: number;
    titleId: string;
    typeId: string | undefined;
    organisation: string | undefined;
    placeOfIssue: string | undefined;
    countryId: string | undefined;
    dateOfIssue: DateTime | undefined;
    issuingAuthority: string | undefined;
    dateOfRecognition: DateTime | undefined;
    placeOfRecognition: string | undefined;
    recognitionAuthority: string | undefined;
    dateOfEquivalence: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    verifiedBy: string | undefined;
    specialKnowledgeBasis: string | undefined;
    remarks: string | undefined;
    overwriteWithHealthRegisterData: boolean;
}

export class GetPostgraduateTitleSearchOutput implements IGetPostgraduateTitleSearchOutput {
    totalCount!: number;
    items!: PostgraduateTitleSearchResultDto[] | undefined;

    constructor(data?: IGetPostgraduateTitleSearchOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PostgraduateTitleSearchResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPostgraduateTitleSearchOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPostgraduateTitleSearchOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPostgraduateTitleSearchOutput {
    totalCount: number;
    items: PostgraduateTitleSearchResultDto[] | undefined;
}

export class PostgraduateTitleDto implements IPostgraduateTitleDto {
    titleId!: string;
    typeId!: string | undefined;
    organisation!: string | undefined;
    placeOfIssue!: string | undefined;
    countryId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    issuingAuthority!: string | undefined;
    dateOfRecognition!: DateTime | undefined;
    placeOfRecognition!: string | undefined;
    recognitionAuthority!: string | undefined;
    dateOfEquivalence!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    verifiedBy!: string | undefined;
    specialKnowledgeBasis!: string | undefined;
    remarks!: string | undefined;
    overwriteWithHealthRegisterData!: boolean;

    constructor(data?: IPostgraduateTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.typeId = _data["typeId"];
            this.organisation = _data["organisation"];
            this.placeOfIssue = _data["placeOfIssue"];
            this.countryId = _data["countryId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.issuingAuthority = _data["issuingAuthority"];
            this.dateOfRecognition = _data["dateOfRecognition"] ? DateTime.fromISO(_data["dateOfRecognition"].toString()) : <any>undefined;
            this.placeOfRecognition = _data["placeOfRecognition"];
            this.recognitionAuthority = _data["recognitionAuthority"];
            this.dateOfEquivalence = _data["dateOfEquivalence"] ? DateTime.fromISO(_data["dateOfEquivalence"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.verifiedBy = _data["verifiedBy"];
            this.specialKnowledgeBasis = _data["specialKnowledgeBasis"];
            this.remarks = _data["remarks"];
            this.overwriteWithHealthRegisterData = _data["overwriteWithHealthRegisterData"];
        }
    }

    static fromJS(data: any): PostgraduateTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new PostgraduateTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["typeId"] = this.typeId;
        data["organisation"] = this.organisation;
        data["placeOfIssue"] = this.placeOfIssue;
        data["countryId"] = this.countryId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["issuingAuthority"] = this.issuingAuthority;
        data["dateOfRecognition"] = this.dateOfRecognition ? this.dateOfRecognition.toFormat('yyyy-MM-dd') : <any>undefined;
        data["placeOfRecognition"] = this.placeOfRecognition;
        data["recognitionAuthority"] = this.recognitionAuthority;
        data["dateOfEquivalence"] = this.dateOfEquivalence ? this.dateOfEquivalence.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["verifiedBy"] = this.verifiedBy;
        data["specialKnowledgeBasis"] = this.specialKnowledgeBasis;
        data["remarks"] = this.remarks;
        data["overwriteWithHealthRegisterData"] = this.overwriteWithHealthRegisterData;
        return data;
    }
}

export interface IPostgraduateTitleDto {
    titleId: string;
    typeId: string | undefined;
    organisation: string | undefined;
    placeOfIssue: string | undefined;
    countryId: string | undefined;
    dateOfIssue: DateTime | undefined;
    issuingAuthority: string | undefined;
    dateOfRecognition: DateTime | undefined;
    placeOfRecognition: string | undefined;
    recognitionAuthority: string | undefined;
    dateOfEquivalence: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    verifiedBy: string | undefined;
    specialKnowledgeBasis: string | undefined;
    remarks: string | undefined;
    overwriteWithHealthRegisterData: boolean;
}

export class PostgraduateTitleSearchResultDto implements IPostgraduateTitleSearchResultDto {
    id!: number;
    titleId!: string | undefined;
    typeId!: string | undefined;
    organisation!: string | undefined;
    placeOfIssue!: string | undefined;
    issuingAuthority!: string | undefined;
    countryId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfRecognition!: DateTime | undefined;
    placeOfRecognition!: string | undefined;
    recognitionAuthority!: string | undefined;
    dateOfEquivalence!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;

    constructor(data?: IPostgraduateTitleSearchResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.titleId = _data["titleId"];
            this.typeId = _data["typeId"];
            this.organisation = _data["organisation"];
            this.placeOfIssue = _data["placeOfIssue"];
            this.issuingAuthority = _data["issuingAuthority"];
            this.countryId = _data["countryId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfRecognition = _data["dateOfRecognition"] ? DateTime.fromISO(_data["dateOfRecognition"].toString()) : <any>undefined;
            this.placeOfRecognition = _data["placeOfRecognition"];
            this.recognitionAuthority = _data["recognitionAuthority"];
            this.dateOfEquivalence = _data["dateOfEquivalence"] ? DateTime.fromISO(_data["dateOfEquivalence"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PostgraduateTitleSearchResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PostgraduateTitleSearchResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["titleId"] = this.titleId;
        data["typeId"] = this.typeId;
        data["organisation"] = this.organisation;
        data["placeOfIssue"] = this.placeOfIssue;
        data["issuingAuthority"] = this.issuingAuthority;
        data["countryId"] = this.countryId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfRecognition"] = this.dateOfRecognition ? this.dateOfRecognition.toFormat('yyyy-MM-dd') : <any>undefined;
        data["placeOfRecognition"] = this.placeOfRecognition;
        data["recognitionAuthority"] = this.recognitionAuthority;
        data["dateOfEquivalence"] = this.dateOfEquivalence ? this.dateOfEquivalence.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        return data;
    }
}

export interface IPostgraduateTitleSearchResultDto {
    id: number;
    titleId: string | undefined;
    typeId: string | undefined;
    organisation: string | undefined;
    placeOfIssue: string | undefined;
    issuingAuthority: string | undefined;
    countryId: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfRecognition: DateTime | undefined;
    placeOfRecognition: string | undefined;
    recognitionAuthority: string | undefined;
    dateOfEquivalence: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
}

export class CreateSlapInput implements ICreateSlapInput {
    applicationTypeId!: ApplicationType;
    professionId!: string;

    constructor(data?: ICreateSlapInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationTypeId = _data["applicationTypeId"];
            this.professionId = _data["professionId"];
        }
    }

    static fromJS(data: any): CreateSlapInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSlapInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationTypeId"] = this.applicationTypeId;
        data["professionId"] = this.professionId;
        return data;
    }
}

export interface ICreateSlapInput {
    applicationTypeId: ApplicationType;
    professionId: string;
}

export class CreateSlapOutput implements ICreateSlapOutput {
    caseId!: string | undefined;

    constructor(data?: ICreateSlapOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
        }
    }

    static fromJS(data: any): CreateSlapOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSlapOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        return data;
    }
}

export interface ICreateSlapOutput {
    caseId: string | undefined;
}

export class GetSlapDocumentsInput implements IGetSlapDocumentsInput {
    caseId!: string;
    step!: SlapStatus;

    constructor(data?: IGetSlapDocumentsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.step = _data["step"];
        }
    }

    static fromJS(data: any): GetSlapDocumentsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSlapDocumentsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["step"] = this.step;
        return data;
    }
}

export interface IGetSlapDocumentsInput {
    caseId: string;
    step: SlapStatus;
}

export class GetSlapFileInput implements IGetSlapFileInput {
    caseId!: string;
    step!: SlapStatus;
    id!: number;

    constructor(data?: IGetSlapFileInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.step = _data["step"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetSlapFileInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSlapFileInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["step"] = this.step;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetSlapFileInput {
    caseId: string;
    step: SlapStatus;
    id: number;
}

export class GetSlapOutput implements IGetSlapOutput {
    slap!: SlapDto;

    constructor(data?: IGetSlapOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.slap = _data["slap"] ? SlapDto.fromJS(_data["slap"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSlapOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSlapOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["slap"] = this.slap ? this.slap.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSlapOutput {
    slap: SlapDto;
}

export class SlapBusinessDto implements ISlapBusinessDto {
    id!: number | undefined;
    name!: string;
    additionalName!: string | undefined;
    postCode!: string;
    city!: string;
    street!: string;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    website!: string | undefined;
    gln!: string | undefined;
    bur!: string | undefined;
    dateOfOpening!: DateTime | undefined;
    dateOfClosure!: DateTime | undefined;
    businessHours!: string | undefined;

    constructor(data?: ISlapBusinessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.additionalName = _data["additionalName"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.website = _data["website"];
            this.gln = _data["gln"];
            this.bur = _data["bur"];
            this.dateOfOpening = _data["dateOfOpening"] ? DateTime.fromISO(_data["dateOfOpening"].toString()) : <any>undefined;
            this.dateOfClosure = _data["dateOfClosure"] ? DateTime.fromISO(_data["dateOfClosure"].toString()) : <any>undefined;
            this.businessHours = _data["businessHours"];
        }
    }

    static fromJS(data: any): SlapBusinessDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlapBusinessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["additionalName"] = this.additionalName;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["website"] = this.website;
        data["gln"] = this.gln;
        data["bur"] = this.bur;
        data["dateOfOpening"] = this.dateOfOpening ? this.dateOfOpening.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfClosure"] = this.dateOfClosure ? this.dateOfClosure.toFormat('yyyy-MM-dd') : <any>undefined;
        data["businessHours"] = this.businessHours;
        return data;
    }
}

export interface ISlapBusinessDto {
    id: number | undefined;
    name: string;
    additionalName: string | undefined;
    postCode: string;
    city: string;
    street: string;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    website: string | undefined;
    gln: string | undefined;
    bur: string | undefined;
    dateOfOpening: DateTime | undefined;
    dateOfClosure: DateTime | undefined;
    businessHours: string | undefined;
}

export class SlapDocumentsOutput implements ISlapDocumentsOutput {
    caseId!: string;
    documents!: GeneralDocumentGroupDto[];

    constructor(data?: ISlapDocumentsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.documents = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SlapDocumentsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SlapDocumentsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISlapDocumentsOutput {
    caseId: string;
    documents: GeneralDocumentGroupDto[];
}

export class SlapDto implements ISlapDto {
    application!: ApplicationDto;
    professionId!: string | undefined;
    statusId!: SlapStatus;
    person!: SlapPersonDto;
    business!: SlapBusinessDto;
    practice!: SlapPracticeDto;
    rangeOfProducts!: SlapRangeOfProductsDto;
    productPreparation!: SlapProductPreparationDto;
    invoiceAddress!: SlapInvoiceAddressDto;
    documents!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: ISlapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationDto.fromJS(_data["application"]) : <any>undefined;
            this.professionId = _data["professionId"];
            this.statusId = _data["statusId"];
            this.person = _data["person"] ? SlapPersonDto.fromJS(_data["person"]) : <any>undefined;
            this.business = _data["business"] ? SlapBusinessDto.fromJS(_data["business"]) : <any>undefined;
            this.practice = _data["practice"] ? SlapPracticeDto.fromJS(_data["practice"]) : <any>undefined;
            this.rangeOfProducts = _data["rangeOfProducts"] ? SlapRangeOfProductsDto.fromJS(_data["rangeOfProducts"]) : <any>undefined;
            this.productPreparation = _data["productPreparation"] ? SlapProductPreparationDto.fromJS(_data["productPreparation"]) : <any>undefined;
            this.invoiceAddress = _data["invoiceAddress"] ? SlapInvoiceAddressDto.fromJS(_data["invoiceAddress"]) : <any>undefined;
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SlapDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["professionId"] = this.professionId;
        data["statusId"] = this.statusId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["business"] = this.business ? this.business.toJSON() : <any>undefined;
        data["practice"] = this.practice ? this.practice.toJSON() : <any>undefined;
        data["rangeOfProducts"] = this.rangeOfProducts ? this.rangeOfProducts.toJSON() : <any>undefined;
        data["productPreparation"] = this.productPreparation ? this.productPreparation.toJSON() : <any>undefined;
        data["invoiceAddress"] = this.invoiceAddress ? this.invoiceAddress.toJSON() : <any>undefined;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISlapDto {
    application: ApplicationDto;
    professionId: string | undefined;
    statusId: SlapStatus;
    person: SlapPersonDto;
    business: SlapBusinessDto;
    practice: SlapPracticeDto;
    rangeOfProducts: SlapRangeOfProductsDto;
    productPreparation: SlapProductPreparationDto;
    invoiceAddress: SlapInvoiceAddressDto;
    documents: GeneralDocumentGroupDto[] | undefined;
}

export class SlapInvoiceAddressDto implements ISlapInvoiceAddressDto {
    id!: number | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string | undefined;
    email!: string | undefined;

    constructor(data?: ISlapInvoiceAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): SlapInvoiceAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlapInvoiceAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["email"] = this.email;
        return data;
    }
}

export interface ISlapInvoiceAddressDto {
    id: number | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string | undefined;
    email: string | undefined;
}

export class SlapPersonDto implements ISlapPersonDto {
    id!: number | undefined;
    firstName!: string;
    lastName!: string;
    gln!: string;
    professionId!: string;
    postgraduateTitleId!: string | undefined;
    postgraduateTitlePrivateLaw!: string | undefined;

    constructor(data?: ISlapPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.gln = _data["gln"];
            this.professionId = _data["professionId"];
            this.postgraduateTitleId = _data["postgraduateTitleId"];
            this.postgraduateTitlePrivateLaw = _data["postgraduateTitlePrivateLaw"];
        }
    }

    static fromJS(data: any): SlapPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlapPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["gln"] = this.gln;
        data["professionId"] = this.professionId;
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        data["postgraduateTitlePrivateLaw"] = this.postgraduateTitlePrivateLaw;
        return data;
    }
}

export interface ISlapPersonDto {
    id: number | undefined;
    firstName: string;
    lastName: string;
    gln: string;
    professionId: string;
    postgraduateTitleId: string | undefined;
    postgraduateTitlePrivateLaw: string | undefined;
}

export class SlapPracticeDto implements ISlapPracticeDto {
    id!: number | undefined;
    typeId!: string;
    hasPartnershipAgreementId!: string | undefined;
    hasInfrastructureUsageAgreementId!: string | undefined;
    legalFormId!: string;
    otherLegalForm!: string | undefined;
    partners!: SlapPracticePartnerDto[];

    constructor(data?: ISlapPracticeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.partners = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.typeId = _data["typeId"];
            this.hasPartnershipAgreementId = _data["hasPartnershipAgreementId"];
            this.hasInfrastructureUsageAgreementId = _data["hasInfrastructureUsageAgreementId"];
            this.legalFormId = _data["legalFormId"];
            this.otherLegalForm = _data["otherLegalForm"];
            if (Array.isArray(_data["partners"])) {
                this.partners = [] as any;
                for (let item of _data["partners"])
                    this.partners!.push(SlapPracticePartnerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SlapPracticeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlapPracticeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["typeId"] = this.typeId;
        data["hasPartnershipAgreementId"] = this.hasPartnershipAgreementId;
        data["hasInfrastructureUsageAgreementId"] = this.hasInfrastructureUsageAgreementId;
        data["legalFormId"] = this.legalFormId;
        data["otherLegalForm"] = this.otherLegalForm;
        if (Array.isArray(this.partners)) {
            data["partners"] = [];
            for (let item of this.partners)
                data["partners"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISlapPracticeDto {
    id: number | undefined;
    typeId: string;
    hasPartnershipAgreementId: string | undefined;
    hasInfrastructureUsageAgreementId: string | undefined;
    legalFormId: string;
    otherLegalForm: string | undefined;
    partners: SlapPracticePartnerDto[];
}

export class SlapPracticePartnerDto implements ISlapPracticePartnerDto {
    id!: number | undefined;
    practiceId!: number | undefined;
    firstName!: string;
    lastName!: string;
    gln!: string | undefined;
    postgraduateTitleId!: string | undefined;

    constructor(data?: ISlapPracticePartnerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.practiceId = _data["practiceId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.gln = _data["gln"];
            this.postgraduateTitleId = _data["postgraduateTitleId"];
        }
    }

    static fromJS(data: any): SlapPracticePartnerDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlapPracticePartnerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["practiceId"] = this.practiceId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["gln"] = this.gln;
        data["postgraduateTitleId"] = this.postgraduateTitleId;
        return data;
    }
}

export interface ISlapPracticePartnerDto {
    id: number | undefined;
    practiceId: number | undefined;
    firstName: string;
    lastName: string;
    gln: string | undefined;
    postgraduateTitleId: string | undefined;
}

export class SlapProductPreparationDto implements ISlapProductPreparationDto {
    id!: number | undefined;
    hasLocalPreparationId!: string;
    hasExternalPreparationId!: string;
    hasUseOfDisposablesId!: string;

    constructor(data?: ISlapProductPreparationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.hasLocalPreparationId = _data["hasLocalPreparationId"];
            this.hasExternalPreparationId = _data["hasExternalPreparationId"];
            this.hasUseOfDisposablesId = _data["hasUseOfDisposablesId"];
        }
    }

    static fromJS(data: any): SlapProductPreparationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlapProductPreparationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["hasLocalPreparationId"] = this.hasLocalPreparationId;
        data["hasExternalPreparationId"] = this.hasExternalPreparationId;
        data["hasUseOfDisposablesId"] = this.hasUseOfDisposablesId;
        return data;
    }
}

export interface ISlapProductPreparationDto {
    id: number | undefined;
    hasLocalPreparationId: string;
    hasExternalPreparationId: string;
    hasUseOfDisposablesId: string;
}

export class SlapRangeOfProductsDto implements ISlapRangeOfProductsDto {
    id!: number | undefined;
    hasOnlyLimitedId!: string | undefined;
    hasRefrigeratorRequiredId!: string | undefined;
    hasNarcoticsId!: string | undefined;
    hasPsychotropicsId!: string | undefined;

    constructor(data?: ISlapRangeOfProductsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.hasOnlyLimitedId = _data["hasOnlyLimitedId"];
            this.hasRefrigeratorRequiredId = _data["hasRefrigeratorRequiredId"];
            this.hasNarcoticsId = _data["hasNarcoticsId"];
            this.hasPsychotropicsId = _data["hasPsychotropicsId"];
        }
    }

    static fromJS(data: any): SlapRangeOfProductsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlapRangeOfProductsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["hasOnlyLimitedId"] = this.hasOnlyLimitedId;
        data["hasRefrigeratorRequiredId"] = this.hasRefrigeratorRequiredId;
        data["hasNarcoticsId"] = this.hasNarcoticsId;
        data["hasPsychotropicsId"] = this.hasPsychotropicsId;
        return data;
    }
}

export interface ISlapRangeOfProductsDto {
    id: number | undefined;
    hasOnlyLimitedId: string | undefined;
    hasRefrigeratorRequiredId: string | undefined;
    hasNarcoticsId: string | undefined;
    hasPsychotropicsId: string | undefined;
}

export enum SlapStatus {
    Person = 0,
    Business = 1,
    Practice = 2,
    RangeOfProducts = 3,
    ProductPreparation = 4,
    InvoiceAddress = 5,
    Release = 97,
    Released = 98,
    FinishReview = 99,
}

export class ProfessionalLicenceRestrictionDto implements IProfessionalLicenceRestrictionDto {
    typeId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    id!: number;

    constructor(data?: IProfessionalLicenceRestrictionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeId = _data["typeId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProfessionalLicenceRestrictionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessionalLicenceRestrictionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IProfessionalLicenceRestrictionDto {
    typeId: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    id: number;
}

export class GetPsyRegPersonDetailedOutput implements IGetPsyRegPersonDetailedOutput {
    psyRegPerson!: PsyRegPersonDetailedDto;

    constructor(data?: IGetPsyRegPersonDetailedOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.psyRegPerson = _data["psyRegPerson"] ? PsyRegPersonDetailedDto.fromJS(_data["psyRegPerson"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPsyRegPersonDetailedOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPsyRegPersonDetailedOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["psyRegPerson"] = this.psyRegPerson ? this.psyRegPerson.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPsyRegPersonDetailedOutput {
    psyRegPerson: PsyRegPersonDetailedDto;
}

export class GetPsyRegPersonOutput implements IGetPsyRegPersonOutput {
    psyRegPerson!: PsyRegPersonDto;

    constructor(data?: IGetPsyRegPersonOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.psyRegPerson = _data["psyRegPerson"] ? PsyRegPersonDto.fromJS(_data["psyRegPerson"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPsyRegPersonOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPsyRegPersonOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["psyRegPerson"] = this.psyRegPerson ? this.psyRegPerson.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPsyRegPersonOutput {
    psyRegPerson: PsyRegPersonDto;
}

export class PsyRegAuthorisationDto implements IPsyRegAuthorisationDto {
    id!: number;
    personId!: number;
    profession!: string | undefined;
    licenceType!: PersonLicenceType;
    licenceStatus!: HealthRegisterCodeDto;
    canton!: HealthRegisterCodeDto;
    decisionDate!: DateTime | undefined;
    limitationDate!: DateTime | undefined;
    rechtsgrundlage!: HealthRegisterCodeDto;
    comment!: string | undefined;
    languageCompetences!: string | undefined;
    languageSkills!: HealthRegisterCode[] | undefined;

    constructor(data?: IPsyRegAuthorisationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.profession = _data["profession"];
            this.licenceType = _data["licenceType"];
            this.licenceStatus = _data["licenceStatus"] ? HealthRegisterCodeDto.fromJS(_data["licenceStatus"]) : <any>undefined;
            this.canton = _data["canton"] ? HealthRegisterCodeDto.fromJS(_data["canton"]) : <any>undefined;
            this.decisionDate = _data["decisionDate"] ? DateTime.fromISO(_data["decisionDate"].toString()) : <any>undefined;
            this.limitationDate = _data["limitationDate"] ? DateTime.fromISO(_data["limitationDate"].toString()) : <any>undefined;
            this.rechtsgrundlage = _data["rechtsgrundlage"] ? HealthRegisterCodeDto.fromJS(_data["rechtsgrundlage"]) : <any>undefined;
            this.comment = _data["comment"];
            this.languageCompetences = _data["languageCompetences"];
            if (Array.isArray(_data["languageSkills"])) {
                this.languageSkills = [] as any;
                for (let item of _data["languageSkills"])
                    this.languageSkills!.push(HealthRegisterCode.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PsyRegAuthorisationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PsyRegAuthorisationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["profession"] = this.profession;
        data["licenceType"] = this.licenceType;
        data["licenceStatus"] = this.licenceStatus ? this.licenceStatus.toJSON() : <any>undefined;
        data["canton"] = this.canton ? this.canton.toJSON() : <any>undefined;
        data["decisionDate"] = this.decisionDate ? this.decisionDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["limitationDate"] = this.limitationDate ? this.limitationDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["rechtsgrundlage"] = this.rechtsgrundlage ? this.rechtsgrundlage.toJSON() : <any>undefined;
        data["comment"] = this.comment;
        data["languageCompetences"] = this.languageCompetences;
        if (Array.isArray(this.languageSkills)) {
            data["languageSkills"] = [];
            for (let item of this.languageSkills)
                data["languageSkills"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPsyRegAuthorisationDto {
    id: number;
    personId: number;
    profession: string | undefined;
    licenceType: PersonLicenceType;
    licenceStatus: HealthRegisterCodeDto;
    canton: HealthRegisterCodeDto;
    decisionDate: DateTime | undefined;
    limitationDate: DateTime | undefined;
    rechtsgrundlage: HealthRegisterCodeDto;
    comment: string | undefined;
    languageCompetences: string | undefined;
    languageSkills: HealthRegisterCode[] | undefined;
}

export class PsyRegEducationDto implements IPsyRegEducationDto {
    id!: number;
    personId!: number;
    name!: string | undefined;
    firstname!: string | undefined;
    typeId!: string | undefined;
    profession!: HealthRegisterCodeDto;
    issuingPlace!: string | undefined;
    issuingCountry!: HealthRegisterCodeDto;
    postgraduateKindLabel!: HealthRegisterLabelDto;
    issuingDate!: DateTime | undefined;
    recognitionDate!: DateTime | undefined;
    kind!: HealthRegisterCode;
    courseOfEducationId!: number | undefined;
    organizationOfIssuance!: string | undefined;
    isPostgraduateTitle!: boolean;

    constructor(data?: IPsyRegEducationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.name = _data["name"];
            this.firstname = _data["firstname"];
            this.typeId = _data["typeId"];
            this.profession = _data["profession"] ? HealthRegisterCodeDto.fromJS(_data["profession"]) : <any>undefined;
            this.issuingPlace = _data["issuingPlace"];
            this.issuingCountry = _data["issuingCountry"] ? HealthRegisterCodeDto.fromJS(_data["issuingCountry"]) : <any>undefined;
            this.postgraduateKindLabel = _data["postgraduateKindLabel"] ? HealthRegisterLabelDto.fromJS(_data["postgraduateKindLabel"]) : <any>undefined;
            this.issuingDate = _data["issuingDate"] ? DateTime.fromISO(_data["issuingDate"].toString()) : <any>undefined;
            this.recognitionDate = _data["recognitionDate"] ? DateTime.fromISO(_data["recognitionDate"].toString()) : <any>undefined;
            this.kind = _data["kind"] ? HealthRegisterCode.fromJS(_data["kind"]) : <any>undefined;
            this.courseOfEducationId = _data["courseOfEducationId"];
            this.organizationOfIssuance = _data["organizationOfIssuance"];
            this.isPostgraduateTitle = _data["isPostgraduateTitle"];
        }
    }

    static fromJS(data: any): PsyRegEducationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PsyRegEducationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["name"] = this.name;
        data["firstname"] = this.firstname;
        data["typeId"] = this.typeId;
        data["profession"] = this.profession ? this.profession.toJSON() : <any>undefined;
        data["issuingPlace"] = this.issuingPlace;
        data["issuingCountry"] = this.issuingCountry ? this.issuingCountry.toJSON() : <any>undefined;
        data["postgraduateKindLabel"] = this.postgraduateKindLabel ? this.postgraduateKindLabel.toJSON() : <any>undefined;
        data["issuingDate"] = this.issuingDate ? this.issuingDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["recognitionDate"] = this.recognitionDate ? this.recognitionDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["kind"] = this.kind ? this.kind.toJSON() : <any>undefined;
        data["courseOfEducationId"] = this.courseOfEducationId;
        data["organizationOfIssuance"] = this.organizationOfIssuance;
        data["isPostgraduateTitle"] = this.isPostgraduateTitle;
        return data;
    }
}

export interface IPsyRegEducationDto {
    id: number;
    personId: number;
    name: string | undefined;
    firstname: string | undefined;
    typeId: string | undefined;
    profession: HealthRegisterCodeDto;
    issuingPlace: string | undefined;
    issuingCountry: HealthRegisterCodeDto;
    postgraduateKindLabel: HealthRegisterLabelDto;
    issuingDate: DateTime | undefined;
    recognitionDate: DateTime | undefined;
    kind: HealthRegisterCode;
    courseOfEducationId: number | undefined;
    organizationOfIssuance: string | undefined;
    isPostgraduateTitle: boolean;
}

export class PsyRegPersonDetailedDto implements IPsyRegPersonDetailedDto {
    gender!: HealthRegisterCodeDto;
    birthdate!: DateTime | undefined;
    dateOfDeath!: DateTime | undefined;
    dataDeservingProtection!: boolean | undefined;
    cantonalLicenceRestrictions!: string[] | undefined;
    name!: string | undefined;
    firstName!: string | undefined;
    gln!: string | undefined;
    birthYear!: string | undefined;
    dateOfBirth!: DateTime | undefined;
    languageOfCorrespondence!: HealthRegisterCodeDto;
    psyRegAuthorisations!: PsyRegAuthorisationDto[] | undefined;
    psyRegEducations!: PsyRegEducationDto[] | undefined;
    nationality1!: HealthRegisterCodeDto;
    nationality2!: HealthRegisterCodeDto;
    queryTime!: DateTime | undefined;
    languageSkills!: HealthRegisterCode[] | undefined;
    id!: number;

    constructor(data?: IPsyRegPersonDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gender = _data["gender"] ? HealthRegisterCodeDto.fromJS(_data["gender"]) : <any>undefined;
            this.birthdate = _data["birthdate"] ? DateTime.fromISO(_data["birthdate"].toString()) : <any>undefined;
            this.dateOfDeath = _data["dateOfDeath"] ? DateTime.fromISO(_data["dateOfDeath"].toString()) : <any>undefined;
            this.dataDeservingProtection = _data["dataDeservingProtection"];
            if (Array.isArray(_data["cantonalLicenceRestrictions"])) {
                this.cantonalLicenceRestrictions = [] as any;
                for (let item of _data["cantonalLicenceRestrictions"])
                    this.cantonalLicenceRestrictions!.push(item);
            }
            this.name = _data["name"];
            this.firstName = _data["firstName"];
            this.gln = _data["gln"];
            this.birthYear = _data["birthYear"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.languageOfCorrespondence = _data["languageOfCorrespondence"] ? HealthRegisterCodeDto.fromJS(_data["languageOfCorrespondence"]) : <any>undefined;
            if (Array.isArray(_data["psyRegAuthorisations"])) {
                this.psyRegAuthorisations = [] as any;
                for (let item of _data["psyRegAuthorisations"])
                    this.psyRegAuthorisations!.push(PsyRegAuthorisationDto.fromJS(item));
            }
            if (Array.isArray(_data["psyRegEducations"])) {
                this.psyRegEducations = [] as any;
                for (let item of _data["psyRegEducations"])
                    this.psyRegEducations!.push(PsyRegEducationDto.fromJS(item));
            }
            this.nationality1 = _data["nationality1"] ? HealthRegisterCodeDto.fromJS(_data["nationality1"]) : <any>undefined;
            this.nationality2 = _data["nationality2"] ? HealthRegisterCodeDto.fromJS(_data["nationality2"]) : <any>undefined;
            this.queryTime = _data["queryTime"] ? DateTime.fromISO(_data["queryTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["languageSkills"])) {
                this.languageSkills = [] as any;
                for (let item of _data["languageSkills"])
                    this.languageSkills!.push(HealthRegisterCode.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PsyRegPersonDetailedDto {
        data = typeof data === 'object' ? data : {};
        let result = new PsyRegPersonDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gender"] = this.gender ? this.gender.toJSON() : <any>undefined;
        data["birthdate"] = this.birthdate ? this.birthdate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfDeath"] = this.dateOfDeath ? this.dateOfDeath.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dataDeservingProtection"] = this.dataDeservingProtection;
        if (Array.isArray(this.cantonalLicenceRestrictions)) {
            data["cantonalLicenceRestrictions"] = [];
            for (let item of this.cantonalLicenceRestrictions)
                data["cantonalLicenceRestrictions"].push(item);
        }
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["gln"] = this.gln;
        data["birthYear"] = this.birthYear;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["languageOfCorrespondence"] = this.languageOfCorrespondence ? this.languageOfCorrespondence.toJSON() : <any>undefined;
        if (Array.isArray(this.psyRegAuthorisations)) {
            data["psyRegAuthorisations"] = [];
            for (let item of this.psyRegAuthorisations)
                data["psyRegAuthorisations"].push(item.toJSON());
        }
        if (Array.isArray(this.psyRegEducations)) {
            data["psyRegEducations"] = [];
            for (let item of this.psyRegEducations)
                data["psyRegEducations"].push(item.toJSON());
        }
        data["nationality1"] = this.nationality1 ? this.nationality1.toJSON() : <any>undefined;
        data["nationality2"] = this.nationality2 ? this.nationality2.toJSON() : <any>undefined;
        data["queryTime"] = this.queryTime ? this.queryTime.toString() : <any>undefined;
        if (Array.isArray(this.languageSkills)) {
            data["languageSkills"] = [];
            for (let item of this.languageSkills)
                data["languageSkills"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IPsyRegPersonDetailedDto {
    gender: HealthRegisterCodeDto;
    birthdate: DateTime | undefined;
    dateOfDeath: DateTime | undefined;
    dataDeservingProtection: boolean | undefined;
    cantonalLicenceRestrictions: string[] | undefined;
    name: string | undefined;
    firstName: string | undefined;
    gln: string | undefined;
    birthYear: string | undefined;
    dateOfBirth: DateTime | undefined;
    languageOfCorrespondence: HealthRegisterCodeDto;
    psyRegAuthorisations: PsyRegAuthorisationDto[] | undefined;
    psyRegEducations: PsyRegEducationDto[] | undefined;
    nationality1: HealthRegisterCodeDto;
    nationality2: HealthRegisterCodeDto;
    queryTime: DateTime | undefined;
    languageSkills: HealthRegisterCode[] | undefined;
    id: number;
}

export class PsyRegPersonDto implements IPsyRegPersonDto {
    name!: string | undefined;
    firstName!: string | undefined;
    gln!: string | undefined;
    birthYear!: string | undefined;
    dateOfBirth!: DateTime | undefined;
    languageOfCorrespondence!: HealthRegisterCodeDto;
    psyRegAuthorisations!: PsyRegAuthorisationDto[] | undefined;
    psyRegEducations!: PsyRegEducationDto[] | undefined;
    nationality1!: HealthRegisterCodeDto;
    nationality2!: HealthRegisterCodeDto;
    queryTime!: DateTime | undefined;
    languageSkills!: HealthRegisterCode[] | undefined;
    id!: number;

    constructor(data?: IPsyRegPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.firstName = _data["firstName"];
            this.gln = _data["gln"];
            this.birthYear = _data["birthYear"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.languageOfCorrespondence = _data["languageOfCorrespondence"] ? HealthRegisterCodeDto.fromJS(_data["languageOfCorrespondence"]) : <any>undefined;
            if (Array.isArray(_data["psyRegAuthorisations"])) {
                this.psyRegAuthorisations = [] as any;
                for (let item of _data["psyRegAuthorisations"])
                    this.psyRegAuthorisations!.push(PsyRegAuthorisationDto.fromJS(item));
            }
            if (Array.isArray(_data["psyRegEducations"])) {
                this.psyRegEducations = [] as any;
                for (let item of _data["psyRegEducations"])
                    this.psyRegEducations!.push(PsyRegEducationDto.fromJS(item));
            }
            this.nationality1 = _data["nationality1"] ? HealthRegisterCodeDto.fromJS(_data["nationality1"]) : <any>undefined;
            this.nationality2 = _data["nationality2"] ? HealthRegisterCodeDto.fromJS(_data["nationality2"]) : <any>undefined;
            this.queryTime = _data["queryTime"] ? DateTime.fromISO(_data["queryTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["languageSkills"])) {
                this.languageSkills = [] as any;
                for (let item of _data["languageSkills"])
                    this.languageSkills!.push(HealthRegisterCode.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PsyRegPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new PsyRegPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["gln"] = this.gln;
        data["birthYear"] = this.birthYear;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["languageOfCorrespondence"] = this.languageOfCorrespondence ? this.languageOfCorrespondence.toJSON() : <any>undefined;
        if (Array.isArray(this.psyRegAuthorisations)) {
            data["psyRegAuthorisations"] = [];
            for (let item of this.psyRegAuthorisations)
                data["psyRegAuthorisations"].push(item.toJSON());
        }
        if (Array.isArray(this.psyRegEducations)) {
            data["psyRegEducations"] = [];
            for (let item of this.psyRegEducations)
                data["psyRegEducations"].push(item.toJSON());
        }
        data["nationality1"] = this.nationality1 ? this.nationality1.toJSON() : <any>undefined;
        data["nationality2"] = this.nationality2 ? this.nationality2.toJSON() : <any>undefined;
        data["queryTime"] = this.queryTime ? this.queryTime.toString() : <any>undefined;
        if (Array.isArray(this.languageSkills)) {
            data["languageSkills"] = [];
            for (let item of this.languageSkills)
                data["languageSkills"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IPsyRegPersonDto {
    name: string | undefined;
    firstName: string | undefined;
    gln: string | undefined;
    birthYear: string | undefined;
    dateOfBirth: DateTime | undefined;
    languageOfCorrespondence: HealthRegisterCodeDto;
    psyRegAuthorisations: PsyRegAuthorisationDto[] | undefined;
    psyRegEducations: PsyRegEducationDto[] | undefined;
    nationality1: HealthRegisterCodeDto;
    nationality2: HealthRegisterCodeDto;
    queryTime: DateTime | undefined;
    languageSkills: HealthRegisterCode[] | undefined;
    id: number;
}

export class SearchPsyRegPersonInput implements ISearchPsyRegPersonInput {
    id!: number | undefined;
    firstname!: string | undefined;
    name!: string | undefined;
    gln!: string | undefined;
    dateOfBirth!: DateTime | undefined;
    professionId!: string | undefined;

    constructor(data?: ISearchPsyRegPersonInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstname = _data["firstname"];
            this.name = _data["name"];
            this.gln = _data["gln"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.professionId = _data["professionId"];
        }
    }

    static fromJS(data: any): SearchPsyRegPersonInput {
        data = typeof data === 'object' ? data : {};
        let result = new SearchPsyRegPersonInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstname"] = this.firstname;
        data["name"] = this.name;
        data["gln"] = this.gln;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["professionId"] = this.professionId;
        return data;
    }
}

export interface ISearchPsyRegPersonInput {
    id: number | undefined;
    firstname: string | undefined;
    name: string | undefined;
    gln: string | undefined;
    dateOfBirth: DateTime | undefined;
    professionId: string | undefined;
}

export class SearchPsyRegPersonOutput implements ISearchPsyRegPersonOutput {
    items!: PsyRegPersonDto[] | undefined;

    constructor(data?: ISearchPsyRegPersonOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PsyRegPersonDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchPsyRegPersonOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SearchPsyRegPersonOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchPsyRegPersonOutput {
    items: PsyRegPersonDto[] | undefined;
}

export class CorporateLicenceRangeOfServiceDto implements ICorporateLicenceRangeOfServiceDto {
    serviceId!: string | undefined;

    constructor(data?: ICorporateLicenceRangeOfServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"];
        }
    }

    static fromJS(data: any): CorporateLicenceRangeOfServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CorporateLicenceRangeOfServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId;
        return data;
    }
}

export interface ICorporateLicenceRangeOfServiceDto {
    serviceId: string | undefined;
}

export class SponsorshipRangeOfServiceDto implements ISponsorshipRangeOfServiceDto {
    serviceId!: string | undefined;

    constructor(data?: ISponsorshipRangeOfServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"];
        }
    }

    static fromJS(data: any): SponsorshipRangeOfServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new SponsorshipRangeOfServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId;
        return data;
    }
}

export interface ISponsorshipRangeOfServiceDto {
    serviceId: string | undefined;
}

export class CreateOrUpdateRlaAcademicTitleInput implements ICreateOrUpdateRlaAcademicTitleInput {
    caseId!: string;
    academicTitles!: RlaAcademicTitleDto[];

    constructor(data?: ICreateOrUpdateRlaAcademicTitleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.academicTitles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["academicTitles"])) {
                this.academicTitles = [] as any;
                for (let item of _data["academicTitles"])
                    this.academicTitles!.push(RlaAcademicTitleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateRlaAcademicTitleInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateRlaAcademicTitleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.academicTitles)) {
            data["academicTitles"] = [];
            for (let item of this.academicTitles)
                data["academicTitles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateRlaAcademicTitleInput {
    caseId: string;
    academicTitles: RlaAcademicTitleDto[];
}

export class CreateOrUpdateRlaAcademicTitleOutput implements ICreateOrUpdateRlaAcademicTitleOutput {
    status!: RlaStatus;
    academicTitles!: RlaAcademicTitleDto[] | undefined;

    constructor(data?: ICreateOrUpdateRlaAcademicTitleOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["academicTitles"])) {
                this.academicTitles = [] as any;
                for (let item of _data["academicTitles"])
                    this.academicTitles!.push(RlaAcademicTitleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateRlaAcademicTitleOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateRlaAcademicTitleOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.academicTitles)) {
            data["academicTitles"] = [];
            for (let item of this.academicTitles)
                data["academicTitles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateRlaAcademicTitleOutput {
    status: RlaStatus;
    academicTitles: RlaAcademicTitleDto[] | undefined;
}

export class CreateOrUpdateRlaApplicantPersonInput implements ICreateOrUpdateRlaApplicantPersonInput {
    caseId!: string;
    applicantPerson!: RlaApplicantPersonDto;

    constructor(data?: ICreateOrUpdateRlaApplicantPersonInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.applicantPerson = new RlaApplicantPersonDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.applicantPerson = _data["applicantPerson"] ? RlaApplicantPersonDto.fromJS(_data["applicantPerson"]) : new RlaApplicantPersonDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateRlaApplicantPersonInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateRlaApplicantPersonInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["applicantPerson"] = this.applicantPerson ? this.applicantPerson.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateRlaApplicantPersonInput {
    caseId: string;
    applicantPerson: RlaApplicantPersonDto;
}

export class CreateOrUpdateRlaBusinessInput implements ICreateOrUpdateRlaBusinessInput {
    caseId!: string;
    business!: RlaBusinessDto;

    constructor(data?: ICreateOrUpdateRlaBusinessInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.business = new RlaBusinessDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.business = _data["business"] ? RlaBusinessDto.fromJS(_data["business"]) : new RlaBusinessDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateRlaBusinessInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateRlaBusinessInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["business"] = this.business ? this.business.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateRlaBusinessInput {
    caseId: string;
    business: RlaBusinessDto;
}

export class CreateOrUpdateRlaContactInput implements ICreateOrUpdateRlaContactInput {
    caseId!: string;
    contact!: RlaContactDto;

    constructor(data?: ICreateOrUpdateRlaContactInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.contact = new RlaContactDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.contact = _data["contact"] ? RlaContactDto.fromJS(_data["contact"]) : new RlaContactDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateRlaContactInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateRlaContactInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateRlaContactInput {
    caseId: string;
    contact: RlaContactDto;
}

export class CreateOrUpdateRlaInvoiceAddressInput implements ICreateOrUpdateRlaInvoiceAddressInput {
    caseId!: string;
    invoiceAddress!: RlaInvoiceAddressDto;

    constructor(data?: ICreateOrUpdateRlaInvoiceAddressInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.invoiceAddress = new RlaInvoiceAddressDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.invoiceAddress = _data["invoiceAddress"] ? RlaInvoiceAddressDto.fromJS(_data["invoiceAddress"]) : new RlaInvoiceAddressDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateRlaInvoiceAddressInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateRlaInvoiceAddressInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["invoiceAddress"] = this.invoiceAddress ? this.invoiceAddress.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateRlaInvoiceAddressInput {
    caseId: string;
    invoiceAddress: RlaInvoiceAddressDto;
}

export class CreateOrUpdateRlaPersonInput implements ICreateOrUpdateRlaPersonInput {
    caseId!: string;
    person!: RlaPersonDto;

    constructor(data?: ICreateOrUpdateRlaPersonInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.person = new RlaPersonDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.person = _data["person"] ? RlaPersonDto.fromJS(_data["person"]) : new RlaPersonDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateRlaPersonInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateRlaPersonInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateRlaPersonInput {
    caseId: string;
    person: RlaPersonDto;
}

export class CreateOrUpdateRlaReplacementInput implements ICreateOrUpdateRlaReplacementInput {
    caseId!: string;
    replacement!: RlaReplacementDto;

    constructor(data?: ICreateOrUpdateRlaReplacementInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.replacement = new RlaReplacementDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.replacement = _data["replacement"] ? RlaReplacementDto.fromJS(_data["replacement"]) : new RlaReplacementDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateRlaReplacementInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateRlaReplacementInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["replacement"] = this.replacement ? this.replacement.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateRlaReplacementInput {
    caseId: string;
    replacement: RlaReplacementDto;
}

export class CreateRlaInput implements ICreateRlaInput {
    applicationTypeId!: ApplicationType;
    professionId!: string;

    constructor(data?: ICreateRlaInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationTypeId = _data["applicationTypeId"];
            this.professionId = _data["professionId"];
        }
    }

    static fromJS(data: any): CreateRlaInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRlaInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationTypeId"] = this.applicationTypeId;
        data["professionId"] = this.professionId;
        return data;
    }
}

export interface ICreateRlaInput {
    applicationTypeId: ApplicationType;
    professionId: string;
}

export class CreateRlaOutput implements ICreateRlaOutput {
    caseId!: string | undefined;

    constructor(data?: ICreateRlaOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
        }
    }

    static fromJS(data: any): CreateRlaOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRlaOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        return data;
    }
}

export interface ICreateRlaOutput {
    caseId: string | undefined;
}

export class GetRlaOutput implements IGetRlaOutput {
    rla!: RlaDto;

    constructor(data?: IGetRlaOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rla = _data["rla"] ? RlaDto.fromJS(_data["rla"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRlaOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRlaOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rla"] = this.rla ? this.rla.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetRlaOutput {
    rla: RlaDto;
}

export class RlaAcademicTitleDto implements IRlaAcademicTitleDto {
    id!: string;
    title!: string | undefined;
    bodyOfIssue!: string | undefined;
    placeOfIssue!: string | undefined;
    countryId!: string | undefined;
    dateOfIssue!: DateTime | undefined;

    constructor(data?: IRlaAcademicTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.bodyOfIssue = _data["bodyOfIssue"];
            this.placeOfIssue = _data["placeOfIssue"];
            this.countryId = _data["countryId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RlaAcademicTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RlaAcademicTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["bodyOfIssue"] = this.bodyOfIssue;
        data["placeOfIssue"] = this.placeOfIssue;
        data["countryId"] = this.countryId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        return data;
    }
}

export interface IRlaAcademicTitleDto {
    id: string;
    title: string | undefined;
    bodyOfIssue: string | undefined;
    placeOfIssue: string | undefined;
    countryId: string | undefined;
    dateOfIssue: DateTime | undefined;
}

export class RlaApplicantPersonDto implements IRlaApplicantPersonDto {
    gln!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    licenceTypeId!: string | undefined;
    licenceCantonId!: string | undefined;
    licenceStatusId!: string | undefined;
    activityStatusId!: string | undefined;

    constructor(data?: IRlaApplicantPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gln = _data["gln"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.licenceTypeId = _data["licenceTypeId"];
            this.licenceCantonId = _data["licenceCantonId"];
            this.licenceStatusId = _data["licenceStatusId"];
            this.activityStatusId = _data["activityStatusId"];
        }
    }

    static fromJS(data: any): RlaApplicantPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new RlaApplicantPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gln"] = this.gln;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["licenceTypeId"] = this.licenceTypeId;
        data["licenceCantonId"] = this.licenceCantonId;
        data["licenceStatusId"] = this.licenceStatusId;
        data["activityStatusId"] = this.activityStatusId;
        return data;
    }
}

export interface IRlaApplicantPersonDto {
    gln: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    licenceTypeId: string | undefined;
    licenceCantonId: string | undefined;
    licenceStatusId: string | undefined;
    activityStatusId: string | undefined;
}

export class RlaBusinessDto implements IRlaBusinessDto {
    name!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    email!: string | undefined;

    constructor(data?: IRlaBusinessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): RlaBusinessDto {
        data = typeof data === 'object' ? data : {};
        let result = new RlaBusinessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["email"] = this.email;
        return data;
    }
}

export interface IRlaBusinessDto {
    name: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    email: string | undefined;
}

export class RlaContactDto implements IRlaContactDto {
    titleId!: string | undefined;
    countryId!: string | undefined;
    street!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    email!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    addressAddition!: string | undefined;

    constructor(data?: IRlaContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"];
            this.countryId = _data["countryId"];
            this.street = _data["street"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.email = _data["email"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.addressAddition = _data["addressAddition"];
        }
    }

    static fromJS(data: any): RlaContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new RlaContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId;
        data["countryId"] = this.countryId;
        data["street"] = this.street;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["email"] = this.email;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["addressAddition"] = this.addressAddition;
        return data;
    }
}

export interface IRlaContactDto {
    titleId: string | undefined;
    countryId: string | undefined;
    street: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    email: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    addressAddition: string | undefined;
}

export class RlaDocumentGroup implements IRlaDocumentGroup {
    id!: number;
    typeId!: string | undefined;
    isMandatory!: boolean | undefined;
    info!: string | undefined;
    files!: GeneralFileInfo[] | undefined;

    constructor(data?: IRlaDocumentGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.typeId = _data["typeId"];
            this.isMandatory = _data["isMandatory"];
            this.info = _data["info"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(GeneralFileInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RlaDocumentGroup {
        data = typeof data === 'object' ? data : {};
        let result = new RlaDocumentGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["typeId"] = this.typeId;
        data["isMandatory"] = this.isMandatory;
        data["info"] = this.info;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRlaDocumentGroup {
    id: number;
    typeId: string | undefined;
    isMandatory: boolean | undefined;
    info: string | undefined;
    files: GeneralFileInfo[] | undefined;
}

export class RlaDto implements IRlaDto {
    application!: ApplicationDto;
    professionId!: string | undefined;
    status!: RlaStatus;
    applicantPerson!: RlaApplicantPersonDto;
    person!: RlaPersonDto;
    contact!: RlaContactDto;
    academicTitles!: RlaAcademicTitleDto[] | undefined;
    replacement!: RlaReplacementDto;
    business!: RlaBusinessDto;
    invoiceAddress!: RlaInvoiceAddressDto;

    constructor(data?: IRlaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationDto.fromJS(_data["application"]) : <any>undefined;
            this.professionId = _data["professionId"];
            this.status = _data["status"];
            this.applicantPerson = _data["applicantPerson"] ? RlaApplicantPersonDto.fromJS(_data["applicantPerson"]) : <any>undefined;
            this.person = _data["person"] ? RlaPersonDto.fromJS(_data["person"]) : <any>undefined;
            this.contact = _data["contact"] ? RlaContactDto.fromJS(_data["contact"]) : <any>undefined;
            if (Array.isArray(_data["academicTitles"])) {
                this.academicTitles = [] as any;
                for (let item of _data["academicTitles"])
                    this.academicTitles!.push(RlaAcademicTitleDto.fromJS(item));
            }
            this.replacement = _data["replacement"] ? RlaReplacementDto.fromJS(_data["replacement"]) : <any>undefined;
            this.business = _data["business"] ? RlaBusinessDto.fromJS(_data["business"]) : <any>undefined;
            this.invoiceAddress = _data["invoiceAddress"] ? RlaInvoiceAddressDto.fromJS(_data["invoiceAddress"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RlaDto {
        data = typeof data === 'object' ? data : {};
        let result = new RlaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["professionId"] = this.professionId;
        data["status"] = this.status;
        data["applicantPerson"] = this.applicantPerson ? this.applicantPerson.toJSON() : <any>undefined;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        if (Array.isArray(this.academicTitles)) {
            data["academicTitles"] = [];
            for (let item of this.academicTitles)
                data["academicTitles"].push(item.toJSON());
        }
        data["replacement"] = this.replacement ? this.replacement.toJSON() : <any>undefined;
        data["business"] = this.business ? this.business.toJSON() : <any>undefined;
        data["invoiceAddress"] = this.invoiceAddress ? this.invoiceAddress.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRlaDto {
    application: ApplicationDto;
    professionId: string | undefined;
    status: RlaStatus;
    applicantPerson: RlaApplicantPersonDto;
    person: RlaPersonDto;
    contact: RlaContactDto;
    academicTitles: RlaAcademicTitleDto[] | undefined;
    replacement: RlaReplacementDto;
    business: RlaBusinessDto;
    invoiceAddress: RlaInvoiceAddressDto;
}

export class RlaInvoiceAddressDto implements IRlaInvoiceAddressDto {
    typeOfAddressId!: string | undefined;
    rlaBusinessId!: number | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    languageOfCorrespondenceId!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    countryId!: string | undefined;
    email!: string | undefined;

    constructor(data?: IRlaInvoiceAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeOfAddressId = _data["typeOfAddressId"];
            this.rlaBusinessId = _data["rlaBusinessId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.languageOfCorrespondenceId = _data["languageOfCorrespondenceId"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.countryId = _data["countryId"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): RlaInvoiceAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new RlaInvoiceAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeOfAddressId"] = this.typeOfAddressId;
        data["rlaBusinessId"] = this.rlaBusinessId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["languageOfCorrespondenceId"] = this.languageOfCorrespondenceId;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["countryId"] = this.countryId;
        data["email"] = this.email;
        return data;
    }
}

export interface IRlaInvoiceAddressDto {
    typeOfAddressId: string | undefined;
    rlaBusinessId: number | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    languageOfCorrespondenceId: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    countryId: string | undefined;
    email: string | undefined;
}

export class RlaPersonDto implements IRlaPersonDto {
    gln!: string | undefined;
    lastName!: string | undefined;
    firstName!: string | undefined;
    birthName!: string | undefined;
    genderId!: string | undefined;
    dateOfBirth!: DateTime | undefined;
    language!: string | undefined;
    placeOfOrigin!: string | undefined;
    nationality1Id!: string | undefined;
    nationality2Id!: string | undefined;
    ahv!: string | undefined;

    constructor(data?: IRlaPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gln = _data["gln"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.birthName = _data["birthName"];
            this.genderId = _data["genderId"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.language = _data["language"];
            this.placeOfOrigin = _data["placeOfOrigin"];
            this.nationality1Id = _data["nationality1Id"];
            this.nationality2Id = _data["nationality2Id"];
            this.ahv = _data["ahv"];
        }
    }

    static fromJS(data: any): RlaPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new RlaPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gln"] = this.gln;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["birthName"] = this.birthName;
        data["genderId"] = this.genderId;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["language"] = this.language;
        data["placeOfOrigin"] = this.placeOfOrigin;
        data["nationality1Id"] = this.nationality1Id;
        data["nationality2Id"] = this.nationality2Id;
        data["ahv"] = this.ahv;
        return data;
    }
}

export interface IRlaPersonDto {
    gln: string | undefined;
    lastName: string | undefined;
    firstName: string | undefined;
    birthName: string | undefined;
    genderId: string | undefined;
    dateOfBirth: DateTime | undefined;
    language: string | undefined;
    placeOfOrigin: string | undefined;
    nationality1Id: string | undefined;
    nationality2Id: string | undefined;
    ahv: string | undefined;
}

export class RlaReplacementDto implements IRlaReplacementDto {
    dateOfStart!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    levelOfEmployment!: number | undefined;
    reasonId!: string | undefined;

    constructor(data?: IRlaReplacementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateOfStart = _data["dateOfStart"] ? DateTime.fromISO(_data["dateOfStart"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.levelOfEmployment = _data["levelOfEmployment"];
            this.reasonId = _data["reasonId"];
        }
    }

    static fromJS(data: any): RlaReplacementDto {
        data = typeof data === 'object' ? data : {};
        let result = new RlaReplacementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateOfStart"] = this.dateOfStart ? this.dateOfStart.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["levelOfEmployment"] = this.levelOfEmployment;
        data["reasonId"] = this.reasonId;
        return data;
    }
}

export interface IRlaReplacementDto {
    dateOfStart: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    levelOfEmployment: number | undefined;
    reasonId: string | undefined;
}

export enum RlaStatus {
    ApplicantPerson = 0,
    Person = 1,
    Contact = 2,
    AcademicTitle = 3,
    Replacement = 4,
    Business = 5,
    InvoiceAddress = 6,
    Release = 97,
    Released = 98,
    FinishReview = 99,
}

export enum AtLeastOneEmploymentDefined {
    MobileEmployment = 0,
    StationaryEmployment = 1,
    MobileOrStationaryEmployment = 2,
}

export enum AtLeastOnePresent {
    ProfessionalLicence = 0,
    PostgraduateTitle = 1,
}

export class ClaStatusWizardStepDto implements IClaStatusWizardStepDto {
    order!: number;
    step!: ClaStatus;
    id!: string | undefined;

    constructor(data?: IClaStatusWizardStepDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
            this.step = _data["step"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ClaStatusWizardStepDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClaStatusWizardStepDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["step"] = this.step;
        data["id"] = this.id;
        return data;
    }
}

export interface IClaStatusWizardStepDto {
    order: number;
    step: ClaStatus;
    id: string | undefined;
}

export class CreateClaStatusWizardStepInput implements ICreateClaStatusWizardStepInput {
    step!: ClaStatus;
    sponsorshipTypeId!: string;
    applicationType!: ApplicationType;

    constructor(data?: ICreateClaStatusWizardStepInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.step = _data["step"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.applicationType = _data["applicationType"];
        }
    }

    static fromJS(data: any): CreateClaStatusWizardStepInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClaStatusWizardStepInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["step"] = this.step;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["applicationType"] = this.applicationType;
        return data;
    }
}

export interface ICreateClaStatusWizardStepInput {
    step: ClaStatus;
    sponsorshipTypeId: string;
    applicationType: ApplicationType;
}

export class CreateEhcStatusWizardStepInput implements ICreateEhcStatusWizardStepInput {
    step!: EhcStatus;
    professionId!: string;
    applicationType!: ApplicationType;

    constructor(data?: ICreateEhcStatusWizardStepInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.step = _data["step"];
            this.professionId = _data["professionId"];
            this.applicationType = _data["applicationType"];
        }
    }

    static fromJS(data: any): CreateEhcStatusWizardStepInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEhcStatusWizardStepInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["step"] = this.step;
        data["professionId"] = this.professionId;
        data["applicationType"] = this.applicationType;
        return data;
    }
}

export interface ICreateEhcStatusWizardStepInput {
    step: EhcStatus;
    professionId: string;
    applicationType: ApplicationType;
}

export class CreateLiaStatusWizardStepInput implements ICreateLiaStatusWizardStepInput {
    step!: LiaStatus;
    professionId!: string;
    applicationType!: ApplicationType;

    constructor(data?: ICreateLiaStatusWizardStepInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.step = _data["step"];
            this.professionId = _data["professionId"];
            this.applicationType = _data["applicationType"];
        }
    }

    static fromJS(data: any): CreateLiaStatusWizardStepInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLiaStatusWizardStepInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["step"] = this.step;
        data["professionId"] = this.professionId;
        data["applicationType"] = this.applicationType;
        return data;
    }
}

export interface ICreateLiaStatusWizardStepInput {
    step: LiaStatus;
    professionId: string;
    applicationType: ApplicationType;
}

export class CreateOrUpdateEhcPracticeConfigurationInput implements ICreateOrUpdateEhcPracticeConfigurationInput {
    ehcPracticeConfiguration!: EhcPracticeConfigurationDto;

    constructor(data?: ICreateOrUpdateEhcPracticeConfigurationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ehcPracticeConfiguration = _data["ehcPracticeConfiguration"] ? EhcPracticeConfigurationDto.fromJS(_data["ehcPracticeConfiguration"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrUpdateEhcPracticeConfigurationInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEhcPracticeConfigurationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ehcPracticeConfiguration"] = this.ehcPracticeConfiguration ? this.ehcPracticeConfiguration.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateEhcPracticeConfigurationInput {
    ehcPracticeConfiguration: EhcPracticeConfigurationDto;
}

export class CreateOrUpdateProfessionRequirementInput implements ICreateOrUpdateProfessionRequirementInput {
    requirementType!: ProfessionRequirementType;
    value!: string | undefined;
    parentId!: number | undefined;
    requirementAlternativeId!: number;
    id!: number;

    constructor(data?: ICreateOrUpdateProfessionRequirementInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requirementType = _data["requirementType"];
            this.value = _data["value"];
            this.parentId = _data["parentId"];
            this.requirementAlternativeId = _data["requirementAlternativeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrUpdateProfessionRequirementInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateProfessionRequirementInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requirementType"] = this.requirementType;
        data["value"] = this.value;
        data["parentId"] = this.parentId;
        data["requirementAlternativeId"] = this.requirementAlternativeId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrUpdateProfessionRequirementInput {
    requirementType: ProfessionRequirementType;
    value: string | undefined;
    parentId: number | undefined;
    requirementAlternativeId: number;
    id: number;
}

export class CreateProfessionRequirementGroupInput implements ICreateProfessionRequirementGroupInput {
    professionId!: string;
    description!: string;
    step!: LiaStatus;

    constructor(data?: ICreateProfessionRequirementGroupInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professionId = _data["professionId"];
            this.description = _data["description"];
            this.step = _data["step"];
        }
    }

    static fromJS(data: any): CreateProfessionRequirementGroupInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProfessionRequirementGroupInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professionId"] = this.professionId;
        data["description"] = this.description;
        data["step"] = this.step;
        return data;
    }
}

export interface ICreateProfessionRequirementGroupInput {
    professionId: string;
    description: string;
    step: LiaStatus;
}

export class CreateSlapStatusWizardStepInput implements ICreateSlapStatusWizardStepInput {
    step!: SlapStatus;
    professionId!: string;
    applicationType!: ApplicationType;

    constructor(data?: ICreateSlapStatusWizardStepInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.step = _data["step"];
            this.professionId = _data["professionId"];
            this.applicationType = _data["applicationType"];
        }
    }

    static fromJS(data: any): CreateSlapStatusWizardStepInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSlapStatusWizardStepInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["step"] = this.step;
        data["professionId"] = this.professionId;
        data["applicationType"] = this.applicationType;
        return data;
    }
}

export interface ICreateSlapStatusWizardStepInput {
    step: SlapStatus;
    professionId: string;
    applicationType: ApplicationType;
}

export class EhcPracticeConfigurationDto implements IEhcPracticeConfigurationDto {
    professionId!: string;
    minimumDurationInDays!: number;
    ignoreMinimumDurationInDays!: boolean;
    ehcPracticeDescriptionPreLabel1!: string | undefined;
    ehcPracticeDescription1Id!: string | undefined;
    ehcPracticeDescriptionPreLabel2!: string | undefined;
    ehcPracticeDescription2Id!: string | undefined;
    ehcPracticeDescriptionPreLabel3!: string | undefined;
    ehcPracticeDescription3Id!: string | undefined;
    ehcPracticeRecordDescriptionPreLabel1!: string | undefined;
    ehcPracticeRecordDescription1Id!: string | undefined;
    ehcPracticeRecordDescriptionPreLabel2!: string | undefined;
    ehcPracticeRecordDescription2Id!: string | undefined;
    ehcPracticeRecordDescriptionPreLabel3!: string | undefined;
    ehcPracticeRecordDescription3Id!: string | undefined;

    constructor(data?: IEhcPracticeConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.professionId = _data["professionId"];
            this.minimumDurationInDays = _data["minimumDurationInDays"];
            this.ignoreMinimumDurationInDays = _data["ignoreMinimumDurationInDays"];
            this.ehcPracticeDescriptionPreLabel1 = _data["ehcPracticeDescriptionPreLabel1"];
            this.ehcPracticeDescription1Id = _data["ehcPracticeDescription1Id"];
            this.ehcPracticeDescriptionPreLabel2 = _data["ehcPracticeDescriptionPreLabel2"];
            this.ehcPracticeDescription2Id = _data["ehcPracticeDescription2Id"];
            this.ehcPracticeDescriptionPreLabel3 = _data["ehcPracticeDescriptionPreLabel3"];
            this.ehcPracticeDescription3Id = _data["ehcPracticeDescription3Id"];
            this.ehcPracticeRecordDescriptionPreLabel1 = _data["ehcPracticeRecordDescriptionPreLabel1"];
            this.ehcPracticeRecordDescription1Id = _data["ehcPracticeRecordDescription1Id"];
            this.ehcPracticeRecordDescriptionPreLabel2 = _data["ehcPracticeRecordDescriptionPreLabel2"];
            this.ehcPracticeRecordDescription2Id = _data["ehcPracticeRecordDescription2Id"];
            this.ehcPracticeRecordDescriptionPreLabel3 = _data["ehcPracticeRecordDescriptionPreLabel3"];
            this.ehcPracticeRecordDescription3Id = _data["ehcPracticeRecordDescription3Id"];
        }
    }

    static fromJS(data: any): EhcPracticeConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcPracticeConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professionId"] = this.professionId;
        data["minimumDurationInDays"] = this.minimumDurationInDays;
        data["ignoreMinimumDurationInDays"] = this.ignoreMinimumDurationInDays;
        data["ehcPracticeDescriptionPreLabel1"] = this.ehcPracticeDescriptionPreLabel1;
        data["ehcPracticeDescription1Id"] = this.ehcPracticeDescription1Id;
        data["ehcPracticeDescriptionPreLabel2"] = this.ehcPracticeDescriptionPreLabel2;
        data["ehcPracticeDescription2Id"] = this.ehcPracticeDescription2Id;
        data["ehcPracticeDescriptionPreLabel3"] = this.ehcPracticeDescriptionPreLabel3;
        data["ehcPracticeDescription3Id"] = this.ehcPracticeDescription3Id;
        data["ehcPracticeRecordDescriptionPreLabel1"] = this.ehcPracticeRecordDescriptionPreLabel1;
        data["ehcPracticeRecordDescription1Id"] = this.ehcPracticeRecordDescription1Id;
        data["ehcPracticeRecordDescriptionPreLabel2"] = this.ehcPracticeRecordDescriptionPreLabel2;
        data["ehcPracticeRecordDescription2Id"] = this.ehcPracticeRecordDescription2Id;
        data["ehcPracticeRecordDescriptionPreLabel3"] = this.ehcPracticeRecordDescriptionPreLabel3;
        data["ehcPracticeRecordDescription3Id"] = this.ehcPracticeRecordDescription3Id;
        return data;
    }
}

export interface IEhcPracticeConfigurationDto {
    professionId: string;
    minimumDurationInDays: number;
    ignoreMinimumDurationInDays: boolean;
    ehcPracticeDescriptionPreLabel1: string | undefined;
    ehcPracticeDescription1Id: string | undefined;
    ehcPracticeDescriptionPreLabel2: string | undefined;
    ehcPracticeDescription2Id: string | undefined;
    ehcPracticeDescriptionPreLabel3: string | undefined;
    ehcPracticeDescription3Id: string | undefined;
    ehcPracticeRecordDescriptionPreLabel1: string | undefined;
    ehcPracticeRecordDescription1Id: string | undefined;
    ehcPracticeRecordDescriptionPreLabel2: string | undefined;
    ehcPracticeRecordDescription2Id: string | undefined;
    ehcPracticeRecordDescriptionPreLabel3: string | undefined;
    ehcPracticeRecordDescription3Id: string | undefined;
}

export class EhcStatusWizardStepDto implements IEhcStatusWizardStepDto {
    order!: number;
    step!: EhcStatus;
    id!: string | undefined;

    constructor(data?: IEhcStatusWizardStepDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
            this.step = _data["step"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EhcStatusWizardStepDto {
        data = typeof data === 'object' ? data : {};
        let result = new EhcStatusWizardStepDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["step"] = this.step;
        data["id"] = this.id;
        return data;
    }
}

export interface IEhcStatusWizardStepDto {
    order: number;
    step: EhcStatus;
    id: string | undefined;
}

export class LiaStatusWizardStepDto implements ILiaStatusWizardStepDto {
    order!: number;
    step!: LiaStatus;
    id!: string | undefined;

    constructor(data?: ILiaStatusWizardStepDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
            this.step = _data["step"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LiaStatusWizardStepDto {
        data = typeof data === 'object' ? data : {};
        let result = new LiaStatusWizardStepDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["step"] = this.step;
        data["id"] = this.id;
        return data;
    }
}

export interface ILiaStatusWizardStepDto {
    order: number;
    step: LiaStatus;
    id: string | undefined;
}

export enum ProfessionLiaEmploymentRequirementType {
    AtLeastOneLiaEmploymentDefined = 100,
}

export enum ProfessionLiaInvoiceAddressRequirementType {
    OnlyPrivateAddressAllowed = 200,
}

export class ProfessionRegisterAffiliationDto implements IProfessionRegisterAffiliationDto {
    id!: string;
    externalSystem!: ExternalSystemEnum;
    eligibleForLiaId!: string;
    eligibleForEhcId!: string;
    useExtendedLiaPersonId!: string;
    professionRequirementGroups!: ProfessionRequirementGroupDto[] | undefined;

    constructor(data?: IProfessionRegisterAffiliationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalSystem = _data["externalSystem"];
            this.eligibleForLiaId = _data["eligibleForLiaId"];
            this.eligibleForEhcId = _data["eligibleForEhcId"];
            this.useExtendedLiaPersonId = _data["useExtendedLiaPersonId"];
            if (Array.isArray(_data["professionRequirementGroups"])) {
                this.professionRequirementGroups = [] as any;
                for (let item of _data["professionRequirementGroups"])
                    this.professionRequirementGroups!.push(ProfessionRequirementGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProfessionRegisterAffiliationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessionRegisterAffiliationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalSystem"] = this.externalSystem;
        data["eligibleForLiaId"] = this.eligibleForLiaId;
        data["eligibleForEhcId"] = this.eligibleForEhcId;
        data["useExtendedLiaPersonId"] = this.useExtendedLiaPersonId;
        if (Array.isArray(this.professionRequirementGroups)) {
            data["professionRequirementGroups"] = [];
            for (let item of this.professionRequirementGroups)
                data["professionRequirementGroups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProfessionRegisterAffiliationDto {
    id: string;
    externalSystem: ExternalSystemEnum;
    eligibleForLiaId: string;
    eligibleForEhcId: string;
    useExtendedLiaPersonId: string;
    professionRequirementGroups: ProfessionRequirementGroupDto[] | undefined;
}

export class ProfessionRequirementAlternativeDto implements IProfessionRequirementAlternativeDto {
    requirements!: ProfessionRequirementDto[] | undefined;
    id!: number;

    constructor(data?: IProfessionRequirementAlternativeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["requirements"])) {
                this.requirements = [] as any;
                for (let item of _data["requirements"])
                    this.requirements!.push(ProfessionRequirementDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProfessionRequirementAlternativeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessionRequirementAlternativeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.requirements)) {
            data["requirements"] = [];
            for (let item of this.requirements)
                data["requirements"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IProfessionRequirementAlternativeDto {
    requirements: ProfessionRequirementDto[] | undefined;
    id: number;
}

export class ProfessionRequirementDto implements IProfessionRequirementDto {
    requirementType!: ProfessionRequirementType;
    value!: any | undefined;
    requirementAlternativeId!: number;
    id!: number;

    constructor(data?: IProfessionRequirementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requirementType = _data["requirementType"];
            this.value = _data["value"];
            this.requirementAlternativeId = _data["requirementAlternativeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProfessionRequirementDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessionRequirementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requirementType"] = this.requirementType;
        data["value"] = this.value;
        data["requirementAlternativeId"] = this.requirementAlternativeId;
        data["id"] = this.id;
        return data;
    }
}

export interface IProfessionRequirementDto {
    requirementType: ProfessionRequirementType;
    value: any | undefined;
    requirementAlternativeId: number;
    id: number;
}

export class ProfessionRequirementGroupDto implements IProfessionRequirementGroupDto {
    description!: string | undefined;
    step!: LiaStatus;
    requirementAlternatives!: ProfessionRequirementAlternativeDto[] | undefined;
    id!: number;

    constructor(data?: IProfessionRequirementGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.step = _data["step"];
            if (Array.isArray(_data["requirementAlternatives"])) {
                this.requirementAlternatives = [] as any;
                for (let item of _data["requirementAlternatives"])
                    this.requirementAlternatives!.push(ProfessionRequirementAlternativeDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProfessionRequirementGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessionRequirementGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["step"] = this.step;
        if (Array.isArray(this.requirementAlternatives)) {
            data["requirementAlternatives"] = [];
            for (let item of this.requirementAlternatives)
                data["requirementAlternatives"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IProfessionRequirementGroupDto {
    description: string | undefined;
    step: LiaStatus;
    requirementAlternatives: ProfessionRequirementAlternativeDto[] | undefined;
    id: number;
}

export class SlapStatusWizardStepDto implements ISlapStatusWizardStepDto {
    order!: number;
    step!: SlapStatus;
    id!: string | undefined;

    constructor(data?: ISlapStatusWizardStepDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
            this.step = _data["step"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SlapStatusWizardStepDto {
        data = typeof data === 'object' ? data : {};
        let result = new SlapStatusWizardStepDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["step"] = this.step;
        data["id"] = this.id;
        return data;
    }
}

export interface ISlapStatusWizardStepDto {
    order: number;
    step: SlapStatus;
    id: string | undefined;
}

export class SponsorshipTypeRegisterAffiliationDto implements ISponsorshipTypeRegisterAffiliationDto {
    id!: string;
    externalSystem!: ExternalSystemEnum;
    eligibleForClaId!: string;
    eligibleForOlaId!: string;
    eligibleForSlasId!: string;
    eligibleForNlaId!: string;

    constructor(data?: ISponsorshipTypeRegisterAffiliationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalSystem = _data["externalSystem"];
            this.eligibleForClaId = _data["eligibleForClaId"];
            this.eligibleForOlaId = _data["eligibleForOlaId"];
            this.eligibleForSlasId = _data["eligibleForSlasId"];
            this.eligibleForNlaId = _data["eligibleForNlaId"];
        }
    }

    static fromJS(data: any): SponsorshipTypeRegisterAffiliationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SponsorshipTypeRegisterAffiliationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalSystem"] = this.externalSystem;
        data["eligibleForClaId"] = this.eligibleForClaId;
        data["eligibleForOlaId"] = this.eligibleForOlaId;
        data["eligibleForSlasId"] = this.eligibleForSlasId;
        data["eligibleForNlaId"] = this.eligibleForNlaId;
        return data;
    }
}

export interface ISponsorshipTypeRegisterAffiliationDto {
    id: string;
    externalSystem: ExternalSystemEnum;
    eligibleForClaId: string;
    eligibleForOlaId: string;
    eligibleForSlasId: string;
    eligibleForNlaId: string;
}

export class UpdateClaStatusWizardStepsInput implements IUpdateClaStatusWizardStepsInput {
    claWizardSteps!: ClaStatusWizardStepDto[];
    sponsorshipTypeId!: string;
    applicationType!: ApplicationType;

    constructor(data?: IUpdateClaStatusWizardStepsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.claWizardSteps = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["claWizardSteps"])) {
                this.claWizardSteps = [] as any;
                for (let item of _data["claWizardSteps"])
                    this.claWizardSteps!.push(ClaStatusWizardStepDto.fromJS(item));
            }
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.applicationType = _data["applicationType"];
        }
    }

    static fromJS(data: any): UpdateClaStatusWizardStepsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClaStatusWizardStepsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.claWizardSteps)) {
            data["claWizardSteps"] = [];
            for (let item of this.claWizardSteps)
                data["claWizardSteps"].push(item.toJSON());
        }
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["applicationType"] = this.applicationType;
        return data;
    }
}

export interface IUpdateClaStatusWizardStepsInput {
    claWizardSteps: ClaStatusWizardStepDto[];
    sponsorshipTypeId: string;
    applicationType: ApplicationType;
}

export class UpdateEhcStatusWizardStepsInput implements IUpdateEhcStatusWizardStepsInput {
    ehcWizardSteps!: EhcStatusWizardStepDto[];
    professionId!: string;
    applicationType!: ApplicationType;

    constructor(data?: IUpdateEhcStatusWizardStepsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ehcWizardSteps = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ehcWizardSteps"])) {
                this.ehcWizardSteps = [] as any;
                for (let item of _data["ehcWizardSteps"])
                    this.ehcWizardSteps!.push(EhcStatusWizardStepDto.fromJS(item));
            }
            this.professionId = _data["professionId"];
            this.applicationType = _data["applicationType"];
        }
    }

    static fromJS(data: any): UpdateEhcStatusWizardStepsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEhcStatusWizardStepsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ehcWizardSteps)) {
            data["ehcWizardSteps"] = [];
            for (let item of this.ehcWizardSteps)
                data["ehcWizardSteps"].push(item.toJSON());
        }
        data["professionId"] = this.professionId;
        data["applicationType"] = this.applicationType;
        return data;
    }
}

export interface IUpdateEhcStatusWizardStepsInput {
    ehcWizardSteps: EhcStatusWizardStepDto[];
    professionId: string;
    applicationType: ApplicationType;
}

export class UpdateLiaStatusWizardStepsInput implements IUpdateLiaStatusWizardStepsInput {
    liaWizardSteps!: LiaStatusWizardStepDto[];
    professionId!: string;
    applicationType!: ApplicationType;

    constructor(data?: IUpdateLiaStatusWizardStepsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.liaWizardSteps = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["liaWizardSteps"])) {
                this.liaWizardSteps = [] as any;
                for (let item of _data["liaWizardSteps"])
                    this.liaWizardSteps!.push(LiaStatusWizardStepDto.fromJS(item));
            }
            this.professionId = _data["professionId"];
            this.applicationType = _data["applicationType"];
        }
    }

    static fromJS(data: any): UpdateLiaStatusWizardStepsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLiaStatusWizardStepsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.liaWizardSteps)) {
            data["liaWizardSteps"] = [];
            for (let item of this.liaWizardSteps)
                data["liaWizardSteps"].push(item.toJSON());
        }
        data["professionId"] = this.professionId;
        data["applicationType"] = this.applicationType;
        return data;
    }
}

export interface IUpdateLiaStatusWizardStepsInput {
    liaWizardSteps: LiaStatusWizardStepDto[];
    professionId: string;
    applicationType: ApplicationType;
}

export class UpdateSlapStatusWizardStepsInput implements IUpdateSlapStatusWizardStepsInput {
    slapWizardSteps!: SlapStatusWizardStepDto[];
    professionId!: string;
    applicationType!: ApplicationType;

    constructor(data?: IUpdateSlapStatusWizardStepsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.slapWizardSteps = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["slapWizardSteps"])) {
                this.slapWizardSteps = [] as any;
                for (let item of _data["slapWizardSteps"])
                    this.slapWizardSteps!.push(SlapStatusWizardStepDto.fromJS(item));
            }
            this.professionId = _data["professionId"];
            this.applicationType = _data["applicationType"];
        }
    }

    static fromJS(data: any): UpdateSlapStatusWizardStepsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSlapStatusWizardStepsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.slapWizardSteps)) {
            data["slapWizardSteps"] = [];
            for (let item of this.slapWizardSteps)
                data["slapWizardSteps"].push(item.toJSON());
        }
        data["professionId"] = this.professionId;
        data["applicationType"] = this.applicationType;
        return data;
    }
}

export interface IUpdateSlapStatusWizardStepsInput {
    slapWizardSteps: SlapStatusWizardStepDto[];
    professionId: string;
    applicationType: ApplicationType;
}

export class CreateCorporateLicenceRestrictionDto implements ICreateCorporateLicenceRestrictionDto {
    licenceId!: number;
    typeId!: string;
    dateOfIssue!: DateTime;
    dateOfEnd!: DateTime | undefined;
    dateOfCompliance!: DateTime | undefined;
    remark!: string | undefined;

    constructor(data?: ICreateCorporateLicenceRestrictionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenceId = _data["licenceId"];
            this.typeId = _data["typeId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfCompliance = _data["dateOfCompliance"] ? DateTime.fromISO(_data["dateOfCompliance"].toString()) : <any>undefined;
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): CreateCorporateLicenceRestrictionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCorporateLicenceRestrictionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenceId"] = this.licenceId;
        data["typeId"] = this.typeId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCompliance"] = this.dateOfCompliance ? this.dateOfCompliance.toFormat('yyyy-MM-dd') : <any>undefined;
        data["remark"] = this.remark;
        return data;
    }
}

export interface ICreateCorporateLicenceRestrictionDto {
    licenceId: number;
    typeId: string;
    dateOfIssue: DateTime;
    dateOfEnd: DateTime | undefined;
    dateOfCompliance: DateTime | undefined;
    remark: string | undefined;
}

export class CreateRestrictionDto implements ICreateRestrictionDto {
    personLicenceId!: number | undefined;
    typeId!: string;
    dateOfIssue!: DateTime;
    dateOfEnd!: DateTime | undefined;
    dateOfCompliance!: DateTime | undefined;
    remark!: string | undefined;
    healthRegisterTransfer!: boolean;

    constructor(data?: ICreateRestrictionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personLicenceId = _data["personLicenceId"];
            this.typeId = _data["typeId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfCompliance = _data["dateOfCompliance"] ? DateTime.fromISO(_data["dateOfCompliance"].toString()) : <any>undefined;
            this.remark = _data["remark"];
            this.healthRegisterTransfer = _data["healthRegisterTransfer"];
        }
    }

    static fromJS(data: any): CreateRestrictionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRestrictionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personLicenceId"] = this.personLicenceId;
        data["typeId"] = this.typeId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCompliance"] = this.dateOfCompliance ? this.dateOfCompliance.toFormat('yyyy-MM-dd') : <any>undefined;
        data["remark"] = this.remark;
        data["healthRegisterTransfer"] = this.healthRegisterTransfer;
        return data;
    }
}

export interface ICreateRestrictionDto {
    personLicenceId: number | undefined;
    typeId: string;
    dateOfIssue: DateTime;
    dateOfEnd: DateTime | undefined;
    dateOfCompliance: DateTime | undefined;
    remark: string | undefined;
    healthRegisterTransfer: boolean;
}

export class GetRestrictionDto implements IGetRestrictionDto {
    healthRegisterSubmission!: DateTime | undefined;
    typeId!: string;
    dateOfIssue!: DateTime;
    dateOfEnd!: DateTime | undefined;
    dateOfCompliance!: DateTime | undefined;
    remark!: string | undefined;
    healthRegisterTransfer!: boolean;

    constructor(data?: IGetRestrictionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthRegisterSubmission = _data["healthRegisterSubmission"] ? DateTime.fromISO(_data["healthRegisterSubmission"].toString()) : <any>undefined;
            this.typeId = _data["typeId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfCompliance = _data["dateOfCompliance"] ? DateTime.fromISO(_data["dateOfCompliance"].toString()) : <any>undefined;
            this.remark = _data["remark"];
            this.healthRegisterTransfer = _data["healthRegisterTransfer"];
        }
    }

    static fromJS(data: any): GetRestrictionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetRestrictionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthRegisterSubmission"] = this.healthRegisterSubmission ? this.healthRegisterSubmission.toString() : <any>undefined;
        data["typeId"] = this.typeId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCompliance"] = this.dateOfCompliance ? this.dateOfCompliance.toFormat('yyyy-MM-dd') : <any>undefined;
        data["remark"] = this.remark;
        data["healthRegisterTransfer"] = this.healthRegisterTransfer;
        return data;
    }
}

export interface IGetRestrictionDto {
    healthRegisterSubmission: DateTime | undefined;
    typeId: string;
    dateOfIssue: DateTime;
    dateOfEnd: DateTime | undefined;
    dateOfCompliance: DateTime | undefined;
    remark: string | undefined;
    healthRegisterTransfer: boolean;
}

export class UpdateRestrictionDto implements IUpdateRestrictionDto {
    typeId!: string;
    dateOfIssue!: DateTime;
    dateOfEnd!: DateTime | undefined;
    dateOfCompliance!: DateTime | undefined;
    remark!: string | undefined;
    healthRegisterTransfer!: boolean;

    constructor(data?: IUpdateRestrictionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeId = _data["typeId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfCompliance = _data["dateOfCompliance"] ? DateTime.fromISO(_data["dateOfCompliance"].toString()) : <any>undefined;
            this.remark = _data["remark"];
            this.healthRegisterTransfer = _data["healthRegisterTransfer"];
        }
    }

    static fromJS(data: any): UpdateRestrictionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRestrictionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCompliance"] = this.dateOfCompliance ? this.dateOfCompliance.toFormat('yyyy-MM-dd') : <any>undefined;
        data["remark"] = this.remark;
        data["healthRegisterTransfer"] = this.healthRegisterTransfer;
        return data;
    }
}

export interface IUpdateRestrictionDto {
    typeId: string;
    dateOfIssue: DateTime;
    dateOfEnd: DateTime | undefined;
    dateOfCompliance: DateTime | undefined;
    remark: string | undefined;
    healthRegisterTransfer: boolean;
}

export class CreateOrUpdateSapInvoiceDto implements ICreateOrUpdateSapInvoiceDto {
    orderingPersonId!: number | undefined;
    orderingSponsorshipId!: number | undefined;
    debitorPersonId!: number | undefined;
    debitorSponsorshipId!: number | undefined;
    debitorBusinessId!: number | undefined;
    addressTypeId!: string;
    headerInformation!: string | undefined;
    footerInformation!: string | undefined;
    cantonalDepartmentId!: string;
    distributionMethodId!: string;
    dateOfBilling!: DateTime | undefined;
    dateOfOrdering!: DateTime | undefined;
    invoiceItems!: SapInvoiceItemDto[] | undefined;

    constructor(data?: ICreateOrUpdateSapInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderingPersonId = _data["orderingPersonId"];
            this.orderingSponsorshipId = _data["orderingSponsorshipId"];
            this.debitorPersonId = _data["debitorPersonId"];
            this.debitorSponsorshipId = _data["debitorSponsorshipId"];
            this.debitorBusinessId = _data["debitorBusinessId"];
            this.addressTypeId = _data["addressTypeId"];
            this.headerInformation = _data["headerInformation"];
            this.footerInformation = _data["footerInformation"];
            this.cantonalDepartmentId = _data["cantonalDepartmentId"];
            this.distributionMethodId = _data["distributionMethodId"];
            this.dateOfBilling = _data["dateOfBilling"] ? DateTime.fromISO(_data["dateOfBilling"].toString()) : <any>undefined;
            this.dateOfOrdering = _data["dateOfOrdering"] ? DateTime.fromISO(_data["dateOfOrdering"].toString()) : <any>undefined;
            if (Array.isArray(_data["invoiceItems"])) {
                this.invoiceItems = [] as any;
                for (let item of _data["invoiceItems"])
                    this.invoiceItems!.push(SapInvoiceItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateSapInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateSapInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderingPersonId"] = this.orderingPersonId;
        data["orderingSponsorshipId"] = this.orderingSponsorshipId;
        data["debitorPersonId"] = this.debitorPersonId;
        data["debitorSponsorshipId"] = this.debitorSponsorshipId;
        data["debitorBusinessId"] = this.debitorBusinessId;
        data["addressTypeId"] = this.addressTypeId;
        data["headerInformation"] = this.headerInformation;
        data["footerInformation"] = this.footerInformation;
        data["cantonalDepartmentId"] = this.cantonalDepartmentId;
        data["distributionMethodId"] = this.distributionMethodId;
        data["dateOfBilling"] = this.dateOfBilling ? this.dateOfBilling.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfOrdering"] = this.dateOfOrdering ? this.dateOfOrdering.toFormat('yyyy-MM-dd') : <any>undefined;
        if (Array.isArray(this.invoiceItems)) {
            data["invoiceItems"] = [];
            for (let item of this.invoiceItems)
                data["invoiceItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateSapInvoiceDto {
    orderingPersonId: number | undefined;
    orderingSponsorshipId: number | undefined;
    debitorPersonId: number | undefined;
    debitorSponsorshipId: number | undefined;
    debitorBusinessId: number | undefined;
    addressTypeId: string;
    headerInformation: string | undefined;
    footerInformation: string | undefined;
    cantonalDepartmentId: string;
    distributionMethodId: string;
    dateOfBilling: DateTime | undefined;
    dateOfOrdering: DateTime | undefined;
    invoiceItems: SapInvoiceItemDto[] | undefined;
}

export class SapBusinessDto implements ISapBusinessDto {
    sapId!: string | undefined;
    isInterCompany!: boolean | undefined;
    legalFormId!: string | undefined;
    name!: string | undefined;
    additionalName!: string | undefined;
    gln!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    countryId!: string | undefined;
    email!: string | undefined;
    id!: number;

    constructor(data?: ISapBusinessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sapId = _data["sapId"];
            this.isInterCompany = _data["isInterCompany"];
            this.legalFormId = _data["legalFormId"];
            this.name = _data["name"];
            this.additionalName = _data["additionalName"];
            this.gln = _data["gln"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.countryId = _data["countryId"];
            this.email = _data["email"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SapBusinessDto {
        data = typeof data === 'object' ? data : {};
        let result = new SapBusinessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sapId"] = this.sapId;
        data["isInterCompany"] = this.isInterCompany;
        data["legalFormId"] = this.legalFormId;
        data["name"] = this.name;
        data["additionalName"] = this.additionalName;
        data["gln"] = this.gln;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["countryId"] = this.countryId;
        data["email"] = this.email;
        data["id"] = this.id;
        return data;
    }
}

export interface ISapBusinessDto {
    sapId: string | undefined;
    isInterCompany: boolean | undefined;
    legalFormId: string | undefined;
    name: string | undefined;
    additionalName: string | undefined;
    gln: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    countryId: string | undefined;
    email: string | undefined;
    id: number;
}

export class SapBusinessPartnerDto implements ISapBusinessPartnerDto {
    cantonalDepartmentId!: string | undefined;
    sapId!: string | undefined;
    isInterCompany!: boolean | undefined;
    sironaId!: string | undefined;
    status!: string | undefined;
    billerId!: string | undefined;
    taxCode!: string | undefined;
    name1!: string | undefined;
    name2!: string | undefined;
    name3!: string | undefined;
    ahv!: string | undefined;
    title!: string | undefined;
    birthDate!: DateTime | undefined;
    uid!: string | undefined;
    language!: string | undefined;
    communityNumber!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    countryId!: string | undefined;

    constructor(data?: ISapBusinessPartnerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cantonalDepartmentId = _data["cantonalDepartmentId"];
            this.sapId = _data["sapId"];
            this.isInterCompany = _data["isInterCompany"];
            this.sironaId = _data["sironaId"];
            this.status = _data["status"];
            this.billerId = _data["billerId"];
            this.taxCode = _data["taxCode"];
            this.name1 = _data["name1"];
            this.name2 = _data["name2"];
            this.name3 = _data["name3"];
            this.ahv = _data["ahv"];
            this.title = _data["title"];
            this.birthDate = _data["birthDate"] ? DateTime.fromISO(_data["birthDate"].toString()) : <any>undefined;
            this.uid = _data["uid"];
            this.language = _data["language"];
            this.communityNumber = _data["communityNumber"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.countryId = _data["countryId"];
        }
    }

    static fromJS(data: any): SapBusinessPartnerDto {
        data = typeof data === 'object' ? data : {};
        let result = new SapBusinessPartnerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cantonalDepartmentId"] = this.cantonalDepartmentId;
        data["sapId"] = this.sapId;
        data["isInterCompany"] = this.isInterCompany;
        data["sironaId"] = this.sironaId;
        data["status"] = this.status;
        data["billerId"] = this.billerId;
        data["taxCode"] = this.taxCode;
        data["name1"] = this.name1;
        data["name2"] = this.name2;
        data["name3"] = this.name3;
        data["ahv"] = this.ahv;
        data["title"] = this.title;
        data["birthDate"] = this.birthDate ? this.birthDate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["uid"] = this.uid;
        data["language"] = this.language;
        data["communityNumber"] = this.communityNumber;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["countryId"] = this.countryId;
        return data;
    }
}

export interface ISapBusinessPartnerDto {
    cantonalDepartmentId: string | undefined;
    sapId: string | undefined;
    isInterCompany: boolean | undefined;
    sironaId: string | undefined;
    status: string | undefined;
    billerId: string | undefined;
    taxCode: string | undefined;
    name1: string | undefined;
    name2: string | undefined;
    name3: string | undefined;
    ahv: string | undefined;
    title: string | undefined;
    birthDate: DateTime | undefined;
    uid: string | undefined;
    language: string | undefined;
    communityNumber: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    countryId: string | undefined;
}

export class SapBusinessPartnerSearchQueryDto implements ISapBusinessPartnerSearchQueryDto {
    cantonalDepartmentId!: string | undefined;
    sapId!: string | undefined;
    ahv!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    dateOfBirth!: DateTime | undefined;
    uid!: string | undefined;
    organisationName!: string | undefined;
    additionalName!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    countryId!: string | undefined;

    constructor(data?: ISapBusinessPartnerSearchQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cantonalDepartmentId = _data["cantonalDepartmentId"];
            this.sapId = _data["sapId"];
            this.ahv = _data["ahv"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.uid = _data["uid"];
            this.organisationName = _data["organisationName"];
            this.additionalName = _data["additionalName"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.countryId = _data["countryId"];
        }
    }

    static fromJS(data: any): SapBusinessPartnerSearchQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new SapBusinessPartnerSearchQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cantonalDepartmentId"] = this.cantonalDepartmentId;
        data["sapId"] = this.sapId;
        data["ahv"] = this.ahv;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["uid"] = this.uid;
        data["organisationName"] = this.organisationName;
        data["additionalName"] = this.additionalName;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["countryId"] = this.countryId;
        return data;
    }
}

export interface ISapBusinessPartnerSearchQueryDto {
    cantonalDepartmentId: string | undefined;
    sapId: string | undefined;
    ahv: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    dateOfBirth: DateTime | undefined;
    uid: string | undefined;
    organisationName: string | undefined;
    additionalName: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    countryId: string | undefined;
}

export class SapCancellationReasonDto implements ISapCancellationReasonDto {
    sapId!: string;
    sapDescription!: string;
    id!: number;

    constructor(data?: ISapCancellationReasonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sapId = _data["sapId"];
            this.sapDescription = _data["sapDescription"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SapCancellationReasonDto {
        data = typeof data === 'object' ? data : {};
        let result = new SapCancellationReasonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sapId"] = this.sapId;
        data["sapDescription"] = this.sapDescription;
        data["id"] = this.id;
        return data;
    }
}

export interface ISapCancellationReasonDto {
    sapId: string;
    sapDescription: string;
    id: number;
}

export class SapInvoiceDto implements ISapInvoiceDto {
    sironaId!: string | undefined;
    sapId!: string | undefined;
    sapBillNumber!: string | undefined;
    orderingPerson!: SapPersonDto;
    orderingPersonId!: number | undefined;
    orderingSponsorship!: SapSponsorshipDto;
    orderingSponsorshipId!: number | undefined;
    ordererDescription!: string | undefined;
    orderingBusinessPartnerSapId!: string | undefined;
    debitorPerson!: SapPersonDto;
    debitorPersonId!: number | undefined;
    debitorSponsorship!: SapSponsorshipDto;
    debitorSponsorshipId!: number | undefined;
    debitorBusiness!: SapBusinessDto;
    debitorBusinessId!: number | undefined;
    debitorBusinessPartnerSapId!: string | undefined;
    addressTypeId!: string | undefined;
    statusId!: string | undefined;
    headerInformation!: string | undefined;
    footerInformation!: string | undefined;
    cantonalDepartmentId!: string | undefined;
    distributionMethodId!: string | undefined;
    dateOfBilling!: DateTime | undefined;
    dateOfOrdering!: DateTime | undefined;
    dunningLevel!: string | undefined;
    dateOfDunning!: DateTime | undefined;
    dateOfPayment!: DateTime | undefined;
    dateOfLastSapUpdate!: DateTime | undefined;
    dateOfCancellation!: DateTime | undefined;
    cancellationReasonId!: number | undefined;
    cancellationSapId!: string | undefined;
    sapCancellationBillNumber!: string | undefined;
    sapErrorMessage!: string | undefined;
    invoiceItems!: SapInvoiceItemDto[] | undefined;
    id!: number;

    constructor(data?: ISapInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sironaId = _data["sironaId"];
            this.sapId = _data["sapId"];
            this.sapBillNumber = _data["sapBillNumber"];
            this.orderingPerson = _data["orderingPerson"] ? SapPersonDto.fromJS(_data["orderingPerson"]) : <any>undefined;
            this.orderingPersonId = _data["orderingPersonId"];
            this.orderingSponsorship = _data["orderingSponsorship"] ? SapSponsorshipDto.fromJS(_data["orderingSponsorship"]) : <any>undefined;
            this.orderingSponsorshipId = _data["orderingSponsorshipId"];
            this.ordererDescription = _data["ordererDescription"];
            this.orderingBusinessPartnerSapId = _data["orderingBusinessPartnerSapId"];
            this.debitorPerson = _data["debitorPerson"] ? SapPersonDto.fromJS(_data["debitorPerson"]) : <any>undefined;
            this.debitorPersonId = _data["debitorPersonId"];
            this.debitorSponsorship = _data["debitorSponsorship"] ? SapSponsorshipDto.fromJS(_data["debitorSponsorship"]) : <any>undefined;
            this.debitorSponsorshipId = _data["debitorSponsorshipId"];
            this.debitorBusiness = _data["debitorBusiness"] ? SapBusinessDto.fromJS(_data["debitorBusiness"]) : <any>undefined;
            this.debitorBusinessId = _data["debitorBusinessId"];
            this.debitorBusinessPartnerSapId = _data["debitorBusinessPartnerSapId"];
            this.addressTypeId = _data["addressTypeId"];
            this.statusId = _data["statusId"];
            this.headerInformation = _data["headerInformation"];
            this.footerInformation = _data["footerInformation"];
            this.cantonalDepartmentId = _data["cantonalDepartmentId"];
            this.distributionMethodId = _data["distributionMethodId"];
            this.dateOfBilling = _data["dateOfBilling"] ? DateTime.fromISO(_data["dateOfBilling"].toString()) : <any>undefined;
            this.dateOfOrdering = _data["dateOfOrdering"] ? DateTime.fromISO(_data["dateOfOrdering"].toString()) : <any>undefined;
            this.dunningLevel = _data["dunningLevel"];
            this.dateOfDunning = _data["dateOfDunning"] ? DateTime.fromISO(_data["dateOfDunning"].toString()) : <any>undefined;
            this.dateOfPayment = _data["dateOfPayment"] ? DateTime.fromISO(_data["dateOfPayment"].toString()) : <any>undefined;
            this.dateOfLastSapUpdate = _data["dateOfLastSapUpdate"] ? DateTime.fromISO(_data["dateOfLastSapUpdate"].toString()) : <any>undefined;
            this.dateOfCancellation = _data["dateOfCancellation"] ? DateTime.fromISO(_data["dateOfCancellation"].toString()) : <any>undefined;
            this.cancellationReasonId = _data["cancellationReasonId"];
            this.cancellationSapId = _data["cancellationSapId"];
            this.sapCancellationBillNumber = _data["sapCancellationBillNumber"];
            this.sapErrorMessage = _data["sapErrorMessage"];
            if (Array.isArray(_data["invoiceItems"])) {
                this.invoiceItems = [] as any;
                for (let item of _data["invoiceItems"])
                    this.invoiceItems!.push(SapInvoiceItemDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SapInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new SapInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sironaId"] = this.sironaId;
        data["sapId"] = this.sapId;
        data["sapBillNumber"] = this.sapBillNumber;
        data["orderingPerson"] = this.orderingPerson ? this.orderingPerson.toJSON() : <any>undefined;
        data["orderingPersonId"] = this.orderingPersonId;
        data["orderingSponsorship"] = this.orderingSponsorship ? this.orderingSponsorship.toJSON() : <any>undefined;
        data["orderingSponsorshipId"] = this.orderingSponsorshipId;
        data["ordererDescription"] = this.ordererDescription;
        data["orderingBusinessPartnerSapId"] = this.orderingBusinessPartnerSapId;
        data["debitorPerson"] = this.debitorPerson ? this.debitorPerson.toJSON() : <any>undefined;
        data["debitorPersonId"] = this.debitorPersonId;
        data["debitorSponsorship"] = this.debitorSponsorship ? this.debitorSponsorship.toJSON() : <any>undefined;
        data["debitorSponsorshipId"] = this.debitorSponsorshipId;
        data["debitorBusiness"] = this.debitorBusiness ? this.debitorBusiness.toJSON() : <any>undefined;
        data["debitorBusinessId"] = this.debitorBusinessId;
        data["debitorBusinessPartnerSapId"] = this.debitorBusinessPartnerSapId;
        data["addressTypeId"] = this.addressTypeId;
        data["statusId"] = this.statusId;
        data["headerInformation"] = this.headerInformation;
        data["footerInformation"] = this.footerInformation;
        data["cantonalDepartmentId"] = this.cantonalDepartmentId;
        data["distributionMethodId"] = this.distributionMethodId;
        data["dateOfBilling"] = this.dateOfBilling ? this.dateOfBilling.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfOrdering"] = this.dateOfOrdering ? this.dateOfOrdering.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dunningLevel"] = this.dunningLevel;
        data["dateOfDunning"] = this.dateOfDunning ? this.dateOfDunning.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfPayment"] = this.dateOfPayment ? this.dateOfPayment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfLastSapUpdate"] = this.dateOfLastSapUpdate ? this.dateOfLastSapUpdate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCancellation"] = this.dateOfCancellation ? this.dateOfCancellation.toFormat('yyyy-MM-dd') : <any>undefined;
        data["cancellationReasonId"] = this.cancellationReasonId;
        data["cancellationSapId"] = this.cancellationSapId;
        data["sapCancellationBillNumber"] = this.sapCancellationBillNumber;
        data["sapErrorMessage"] = this.sapErrorMessage;
        if (Array.isArray(this.invoiceItems)) {
            data["invoiceItems"] = [];
            for (let item of this.invoiceItems)
                data["invoiceItems"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ISapInvoiceDto {
    sironaId: string | undefined;
    sapId: string | undefined;
    sapBillNumber: string | undefined;
    orderingPerson: SapPersonDto;
    orderingPersonId: number | undefined;
    orderingSponsorship: SapSponsorshipDto;
    orderingSponsorshipId: number | undefined;
    ordererDescription: string | undefined;
    orderingBusinessPartnerSapId: string | undefined;
    debitorPerson: SapPersonDto;
    debitorPersonId: number | undefined;
    debitorSponsorship: SapSponsorshipDto;
    debitorSponsorshipId: number | undefined;
    debitorBusiness: SapBusinessDto;
    debitorBusinessId: number | undefined;
    debitorBusinessPartnerSapId: string | undefined;
    addressTypeId: string | undefined;
    statusId: string | undefined;
    headerInformation: string | undefined;
    footerInformation: string | undefined;
    cantonalDepartmentId: string | undefined;
    distributionMethodId: string | undefined;
    dateOfBilling: DateTime | undefined;
    dateOfOrdering: DateTime | undefined;
    dunningLevel: string | undefined;
    dateOfDunning: DateTime | undefined;
    dateOfPayment: DateTime | undefined;
    dateOfLastSapUpdate: DateTime | undefined;
    dateOfCancellation: DateTime | undefined;
    cancellationReasonId: number | undefined;
    cancellationSapId: string | undefined;
    sapCancellationBillNumber: string | undefined;
    sapErrorMessage: string | undefined;
    invoiceItems: SapInvoiceItemDto[] | undefined;
    id: number;
}

export class SapInvoiceItemDto implements ISapInvoiceItemDto {
    productId!: number;
    sapDescription!: string;
    detailedDescription!: string | undefined;
    additionalInformation!: string | undefined;
    quantity!: number;
    pricePerUnit!: number;
    id!: number;

    constructor(data?: ISapInvoiceItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.sapDescription = _data["sapDescription"];
            this.detailedDescription = _data["detailedDescription"];
            this.additionalInformation = _data["additionalInformation"];
            this.quantity = _data["quantity"];
            this.pricePerUnit = _data["pricePerUnit"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SapInvoiceItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SapInvoiceItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["sapDescription"] = this.sapDescription;
        data["detailedDescription"] = this.detailedDescription;
        data["additionalInformation"] = this.additionalInformation;
        data["quantity"] = this.quantity;
        data["pricePerUnit"] = this.pricePerUnit;
        data["id"] = this.id;
        return data;
    }
}

export interface ISapInvoiceItemDto {
    productId: number;
    sapDescription: string;
    detailedDescription: string | undefined;
    additionalInformation: string | undefined;
    quantity: number;
    pricePerUnit: number;
    id: number;
}

export class SapInvoiceSearchDto implements ISapInvoiceSearchDto {
    sapId!: string | undefined;
    sapBillNumber!: string | undefined;
    sapErrorMessage!: string | undefined;
    orderingPersonId!: number | undefined;
    orderingSponsorshipId!: number | undefined;
    ordererSapId!: string | undefined;
    orderer!: string | undefined;
    debitorPersonId!: number | undefined;
    debitorSponsorshipId!: number | undefined;
    debitorSapId!: string | undefined;
    debitor!: string | undefined;
    statusId!: string | undefined;
    amount!: number;
    headerInformation!: string | undefined;
    cantonalDepartmentId!: string | undefined;
    distributionMethodId!: string | undefined;
    dateOfBilling!: DateTime | undefined;
    dateOfCancellation!: DateTime | undefined;
    cancellationReasonId!: number | undefined;
    cancellationSapId!: string | undefined;
    sapCancellationBillNumber!: string | undefined;
    dateOfPayment!: DateTime | undefined;
    dunningLevel!: string | undefined;
    dateOfDunning!: DateTime | undefined;
    dateOfLastSapUpdate!: DateTime | undefined;
    id!: number;

    constructor(data?: ISapInvoiceSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sapId = _data["sapId"];
            this.sapBillNumber = _data["sapBillNumber"];
            this.sapErrorMessage = _data["sapErrorMessage"];
            this.orderingPersonId = _data["orderingPersonId"];
            this.orderingSponsorshipId = _data["orderingSponsorshipId"];
            this.ordererSapId = _data["ordererSapId"];
            this.orderer = _data["orderer"];
            this.debitorPersonId = _data["debitorPersonId"];
            this.debitorSponsorshipId = _data["debitorSponsorshipId"];
            this.debitorSapId = _data["debitorSapId"];
            this.debitor = _data["debitor"];
            this.statusId = _data["statusId"];
            this.amount = _data["amount"];
            this.headerInformation = _data["headerInformation"];
            this.cantonalDepartmentId = _data["cantonalDepartmentId"];
            this.distributionMethodId = _data["distributionMethodId"];
            this.dateOfBilling = _data["dateOfBilling"] ? DateTime.fromISO(_data["dateOfBilling"].toString()) : <any>undefined;
            this.dateOfCancellation = _data["dateOfCancellation"] ? DateTime.fromISO(_data["dateOfCancellation"].toString()) : <any>undefined;
            this.cancellationReasonId = _data["cancellationReasonId"];
            this.cancellationSapId = _data["cancellationSapId"];
            this.sapCancellationBillNumber = _data["sapCancellationBillNumber"];
            this.dateOfPayment = _data["dateOfPayment"] ? DateTime.fromISO(_data["dateOfPayment"].toString()) : <any>undefined;
            this.dunningLevel = _data["dunningLevel"];
            this.dateOfDunning = _data["dateOfDunning"] ? DateTime.fromISO(_data["dateOfDunning"].toString()) : <any>undefined;
            this.dateOfLastSapUpdate = _data["dateOfLastSapUpdate"] ? DateTime.fromISO(_data["dateOfLastSapUpdate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SapInvoiceSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new SapInvoiceSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sapId"] = this.sapId;
        data["sapBillNumber"] = this.sapBillNumber;
        data["sapErrorMessage"] = this.sapErrorMessage;
        data["orderingPersonId"] = this.orderingPersonId;
        data["orderingSponsorshipId"] = this.orderingSponsorshipId;
        data["ordererSapId"] = this.ordererSapId;
        data["orderer"] = this.orderer;
        data["debitorPersonId"] = this.debitorPersonId;
        data["debitorSponsorshipId"] = this.debitorSponsorshipId;
        data["debitorSapId"] = this.debitorSapId;
        data["debitor"] = this.debitor;
        data["statusId"] = this.statusId;
        data["amount"] = this.amount;
        data["headerInformation"] = this.headerInformation;
        data["cantonalDepartmentId"] = this.cantonalDepartmentId;
        data["distributionMethodId"] = this.distributionMethodId;
        data["dateOfBilling"] = this.dateOfBilling ? this.dateOfBilling.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfCancellation"] = this.dateOfCancellation ? this.dateOfCancellation.toFormat('yyyy-MM-dd') : <any>undefined;
        data["cancellationReasonId"] = this.cancellationReasonId;
        data["cancellationSapId"] = this.cancellationSapId;
        data["sapCancellationBillNumber"] = this.sapCancellationBillNumber;
        data["dateOfPayment"] = this.dateOfPayment ? this.dateOfPayment.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dunningLevel"] = this.dunningLevel;
        data["dateOfDunning"] = this.dateOfDunning ? this.dateOfDunning.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfLastSapUpdate"] = this.dateOfLastSapUpdate ? this.dateOfLastSapUpdate.toFormat('yyyy-MM-dd') : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ISapInvoiceSearchDto {
    sapId: string | undefined;
    sapBillNumber: string | undefined;
    sapErrorMessage: string | undefined;
    orderingPersonId: number | undefined;
    orderingSponsorshipId: number | undefined;
    ordererSapId: string | undefined;
    orderer: string | undefined;
    debitorPersonId: number | undefined;
    debitorSponsorshipId: number | undefined;
    debitorSapId: string | undefined;
    debitor: string | undefined;
    statusId: string | undefined;
    amount: number;
    headerInformation: string | undefined;
    cantonalDepartmentId: string | undefined;
    distributionMethodId: string | undefined;
    dateOfBilling: DateTime | undefined;
    dateOfCancellation: DateTime | undefined;
    cancellationReasonId: number | undefined;
    cancellationSapId: string | undefined;
    sapCancellationBillNumber: string | undefined;
    dateOfPayment: DateTime | undefined;
    dunningLevel: string | undefined;
    dateOfDunning: DateTime | undefined;
    dateOfLastSapUpdate: DateTime | undefined;
    id: number;
}

export class SapPersonDto implements ISapPersonDto {
    sapId!: string | undefined;
    isInterCompany!: boolean | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    dateOfBirth!: DateTime | undefined;
    gln!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    countryId!: string | undefined;
    email!: string | undefined;
    contact!: ContactDto;
    invoiceAddress!: InvoiceAddressDto;
    employments!: GetEmploymentDto[] | undefined;
    id!: number;

    constructor(data?: ISapPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sapId = _data["sapId"];
            this.isInterCompany = _data["isInterCompany"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"] ? DateTime.fromISO(_data["dateOfBirth"].toString()) : <any>undefined;
            this.gln = _data["gln"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.countryId = _data["countryId"];
            this.email = _data["email"];
            this.contact = _data["contact"] ? ContactDto.fromJS(_data["contact"]) : <any>undefined;
            this.invoiceAddress = _data["invoiceAddress"] ? InvoiceAddressDto.fromJS(_data["invoiceAddress"]) : <any>undefined;
            if (Array.isArray(_data["employments"])) {
                this.employments = [] as any;
                for (let item of _data["employments"])
                    this.employments!.push(GetEmploymentDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SapPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new SapPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sapId"] = this.sapId;
        data["isInterCompany"] = this.isInterCompany;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toFormat('yyyy-MM-dd') : <any>undefined;
        data["gln"] = this.gln;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["countryId"] = this.countryId;
        data["email"] = this.email;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["invoiceAddress"] = this.invoiceAddress ? this.invoiceAddress.toJSON() : <any>undefined;
        if (Array.isArray(this.employments)) {
            data["employments"] = [];
            for (let item of this.employments)
                data["employments"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ISapPersonDto {
    sapId: string | undefined;
    isInterCompany: boolean | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    dateOfBirth: DateTime | undefined;
    gln: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    countryId: string | undefined;
    email: string | undefined;
    contact: ContactDto;
    invoiceAddress: InvoiceAddressDto;
    employments: GetEmploymentDto[] | undefined;
    id: number;
}

export class SapProductDto implements ISapProductDto {
    sapId!: string;
    sapDescription!: string;
    detailedDescription!: string | undefined;
    pricePerUnit!: number | undefined;
    cantonalDepartmentId!: string;
    accountAssignmentGroup!: string;
    contextId!: string;
    personLicenceType!: PersonLicenceType;
    professionId!: string | undefined;
    corporateLicenceType!: CorporateLicenceType;
    sponsorshipTypeId!: string | undefined;
    isForTimeLimitedLicences!: boolean;
    isForRenewal!: boolean;
    billingDelayedDays!: number | undefined;
    validFrom!: DateTime;
    validTo!: DateTime | undefined;
    id!: number;

    constructor(data?: ISapProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sapId = _data["sapId"];
            this.sapDescription = _data["sapDescription"];
            this.detailedDescription = _data["detailedDescription"];
            this.pricePerUnit = _data["pricePerUnit"];
            this.cantonalDepartmentId = _data["cantonalDepartmentId"];
            this.accountAssignmentGroup = _data["accountAssignmentGroup"];
            this.contextId = _data["contextId"];
            this.personLicenceType = _data["personLicenceType"];
            this.professionId = _data["professionId"];
            this.corporateLicenceType = _data["corporateLicenceType"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.isForTimeLimitedLicences = _data["isForTimeLimitedLicences"];
            this.isForRenewal = _data["isForRenewal"];
            this.billingDelayedDays = _data["billingDelayedDays"];
            this.validFrom = _data["validFrom"] ? DateTime.fromISO(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? DateTime.fromISO(_data["validTo"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SapProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new SapProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sapId"] = this.sapId;
        data["sapDescription"] = this.sapDescription;
        data["detailedDescription"] = this.detailedDescription;
        data["pricePerUnit"] = this.pricePerUnit;
        data["cantonalDepartmentId"] = this.cantonalDepartmentId;
        data["accountAssignmentGroup"] = this.accountAssignmentGroup;
        data["contextId"] = this.contextId;
        data["personLicenceType"] = this.personLicenceType;
        data["professionId"] = this.professionId;
        data["corporateLicenceType"] = this.corporateLicenceType;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["isForTimeLimitedLicences"] = this.isForTimeLimitedLicences;
        data["isForRenewal"] = this.isForRenewal;
        data["billingDelayedDays"] = this.billingDelayedDays;
        data["validFrom"] = this.validFrom ? this.validFrom.toFormat('yyyy-MM-dd') : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toFormat('yyyy-MM-dd') : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ISapProductDto {
    sapId: string;
    sapDescription: string;
    detailedDescription: string | undefined;
    pricePerUnit: number | undefined;
    cantonalDepartmentId: string;
    accountAssignmentGroup: string;
    contextId: string;
    personLicenceType: PersonLicenceType;
    professionId: string | undefined;
    corporateLicenceType: CorporateLicenceType;
    sponsorshipTypeId: string | undefined;
    isForTimeLimitedLicences: boolean;
    isForRenewal: boolean;
    billingDelayedDays: number | undefined;
    validFrom: DateTime;
    validTo: DateTime | undefined;
    id: number;
}

export class SapSponsorshipDto implements ISapSponsorshipDto {
    sapId!: string | undefined;
    isInterCompany!: boolean | undefined;
    name!: string | undefined;
    additionalName!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string | undefined;
    email!: string | undefined;
    invoiceAddress!: SponsorshipInvoiceAddressDto;
    businesses!: SapBusinessDto[] | undefined;
    id!: number;

    constructor(data?: ISapSponsorshipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sapId = _data["sapId"];
            this.isInterCompany = _data["isInterCompany"];
            this.name = _data["name"];
            this.additionalName = _data["additionalName"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.email = _data["email"];
            this.invoiceAddress = _data["invoiceAddress"] ? SponsorshipInvoiceAddressDto.fromJS(_data["invoiceAddress"]) : <any>undefined;
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(SapBusinessDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SapSponsorshipDto {
        data = typeof data === 'object' ? data : {};
        let result = new SapSponsorshipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sapId"] = this.sapId;
        data["isInterCompany"] = this.isInterCompany;
        data["name"] = this.name;
        data["additionalName"] = this.additionalName;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["email"] = this.email;
        data["invoiceAddress"] = this.invoiceAddress ? this.invoiceAddress.toJSON() : <any>undefined;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ISapSponsorshipDto {
    sapId: string | undefined;
    isInterCompany: boolean | undefined;
    name: string | undefined;
    additionalName: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string | undefined;
    email: string | undefined;
    invoiceAddress: SponsorshipInvoiceAddressDto;
    businesses: SapBusinessDto[] | undefined;
    id: number;
}

export class SearchCancellationReasonsInput implements ISearchCancellationReasonsInput {
    filter!: string | undefined;
    sorting!: string | undefined;
    maxResultCount!: number;
    skipCount!: number;

    constructor(data?: ISearchCancellationReasonsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): SearchCancellationReasonsInput {
        data = typeof data === 'object' ? data : {};
        let result = new SearchCancellationReasonsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }
}

export interface ISearchCancellationReasonsInput {
    filter: string | undefined;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
}

export class SearchCancellationReasonsOutput implements ISearchCancellationReasonsOutput {
    totalCount!: number;
    items!: SapCancellationReasonDto[] | undefined;

    constructor(data?: ISearchCancellationReasonsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SapCancellationReasonDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchCancellationReasonsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SearchCancellationReasonsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchCancellationReasonsOutput {
    totalCount: number;
    items: SapCancellationReasonDto[] | undefined;
}

export class SearchInvoicesInput implements ISearchInvoicesInput {
    personId!: number | undefined;
    sponsorshipId!: number | undefined;
    filter!: string | undefined;
    sorting!: string | undefined;
    maxResultCount!: number;
    skipCount!: number;

    constructor(data?: ISearchInvoicesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.sponsorshipId = _data["sponsorshipId"];
            this.filter = _data["filter"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): SearchInvoicesInput {
        data = typeof data === 'object' ? data : {};
        let result = new SearchInvoicesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["sponsorshipId"] = this.sponsorshipId;
        data["filter"] = this.filter;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }
}

export interface ISearchInvoicesInput {
    personId: number | undefined;
    sponsorshipId: number | undefined;
    filter: string | undefined;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
}

export class SearchInvoicesOutput implements ISearchInvoicesOutput {
    totalCount!: number;
    items!: SapInvoiceSearchDto[] | undefined;

    constructor(data?: ISearchInvoicesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SapInvoiceSearchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchInvoicesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SearchInvoicesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchInvoicesOutput {
    totalCount: number;
    items: SapInvoiceSearchDto[] | undefined;
}

export class SearchProductsInput implements ISearchProductsInput {
    filter!: string | undefined;
    sorting!: string | undefined;
    maxResultCount!: number;
    skipCount!: number;

    constructor(data?: ISearchProductsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): SearchProductsInput {
        data = typeof data === 'object' ? data : {};
        let result = new SearchProductsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }
}

export interface ISearchProductsInput {
    filter: string | undefined;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
}

export class SearchProductsOutput implements ISearchProductsOutput {
    totalCount!: number;
    items!: SapProductDto[] | undefined;

    constructor(data?: ISearchProductsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SapProductDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchProductsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SearchProductsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchProductsOutput {
    totalCount: number;
    items: SapProductDto[] | undefined;
}

export class PasswordComplexitySetting implements IPasswordComplexitySetting {
    readonly allowedMinimumLength!: number;
    requireDigit!: boolean;
    requireLowercase!: boolean;
    requireNonAlphanumeric!: boolean;
    requireUppercase!: boolean;
    requiredLength!: number;

    constructor(data?: IPasswordComplexitySetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).allowedMinimumLength = _data["allowedMinimumLength"];
            this.requireDigit = _data["requireDigit"];
            this.requireLowercase = _data["requireLowercase"];
            this.requireNonAlphanumeric = _data["requireNonAlphanumeric"];
            this.requireUppercase = _data["requireUppercase"];
            this.requiredLength = _data["requiredLength"];
        }
    }

    static fromJS(data: any): PasswordComplexitySetting {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordComplexitySetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowedMinimumLength"] = this.allowedMinimumLength;
        data["requireDigit"] = this.requireDigit;
        data["requireLowercase"] = this.requireLowercase;
        data["requireNonAlphanumeric"] = this.requireNonAlphanumeric;
        data["requireUppercase"] = this.requireUppercase;
        data["requiredLength"] = this.requiredLength;
        return data;
    }
}

export interface IPasswordComplexitySetting {
    allowedMinimumLength: number;
    requireDigit: boolean;
    requireLowercase: boolean;
    requireNonAlphanumeric: boolean;
    requireUppercase: boolean;
    requiredLength: number;
}

export class GetSensitiveDataDto implements IGetSensitiveDataDto {
    ongoingLegalProceeding!: boolean;
    remark!: string | undefined;
    records!: GetSensitiveDataRecordDto[] | undefined;
    id!: number;

    constructor(data?: IGetSensitiveDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ongoingLegalProceeding = _data["ongoingLegalProceeding"];
            this.remark = _data["remark"];
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(GetSensitiveDataRecordDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetSensitiveDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSensitiveDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ongoingLegalProceeding"] = this.ongoingLegalProceeding;
        data["remark"] = this.remark;
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IGetSensitiveDataDto {
    ongoingLegalProceeding: boolean;
    remark: string | undefined;
    records: GetSensitiveDataRecordDto[] | undefined;
    id: number;
}

export class UpdateSensitiveDataDto implements IUpdateSensitiveDataDto {
    ongoingLegalProceeding!: boolean;
    remark!: string | undefined;

    constructor(data?: IUpdateSensitiveDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ongoingLegalProceeding = _data["ongoingLegalProceeding"];
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): UpdateSensitiveDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSensitiveDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ongoingLegalProceeding"] = this.ongoingLegalProceeding;
        data["remark"] = this.remark;
        return data;
    }
}

export interface IUpdateSensitiveDataDto {
    ongoingLegalProceeding: boolean;
    remark: string | undefined;
}

export class CreateSensitiveDataRecordDto implements ICreateSensitiveDataRecordDto {
    discriminator!: SensitiveDataRecordDiscriminator;
    legalBasisId!: string | undefined;
    typeId!: string | undefined;
    context!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfEffectivness!: DateTime | undefined;
    dateOfLegalForce!: DateTime | undefined;
    isDeletedOrRepealed!: boolean;
    dateOfIsDeletedOrRepealed!: DateTime | undefined;
    reason!: string | undefined;
    remark!: string | undefined;
    dateOfApplication!: DateTime | undefined;
    sapInvoiceStatusId!: string | undefined;
    dateOfSapInvoiceBilling!: DateTime | undefined;
    personLicenceId!: number | undefined;
    financialPenalty!: number | undefined;
    deleteReason!: string | undefined;
    sponsorshipTypeId!: string | undefined;
    corporateLicenceId!: number | undefined;
    businessIds!: number[] | undefined;

    constructor(data?: ICreateSensitiveDataRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discriminator = _data["discriminator"];
            this.legalBasisId = _data["legalBasisId"];
            this.typeId = _data["typeId"];
            this.context = _data["context"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfEffectivness = _data["dateOfEffectivness"] ? DateTime.fromISO(_data["dateOfEffectivness"].toString()) : <any>undefined;
            this.dateOfLegalForce = _data["dateOfLegalForce"] ? DateTime.fromISO(_data["dateOfLegalForce"].toString()) : <any>undefined;
            this.isDeletedOrRepealed = _data["isDeletedOrRepealed"];
            this.dateOfIsDeletedOrRepealed = _data["dateOfIsDeletedOrRepealed"] ? DateTime.fromISO(_data["dateOfIsDeletedOrRepealed"].toString()) : <any>undefined;
            this.reason = _data["reason"];
            this.remark = _data["remark"];
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.sapInvoiceStatusId = _data["sapInvoiceStatusId"];
            this.dateOfSapInvoiceBilling = _data["dateOfSapInvoiceBilling"] ? DateTime.fromISO(_data["dateOfSapInvoiceBilling"].toString()) : <any>undefined;
            this.personLicenceId = _data["personLicenceId"];
            this.financialPenalty = _data["financialPenalty"];
            this.deleteReason = _data["deleteReason"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.corporateLicenceId = _data["corporateLicenceId"];
            if (Array.isArray(_data["businessIds"])) {
                this.businessIds = [] as any;
                for (let item of _data["businessIds"])
                    this.businessIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateSensitiveDataRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSensitiveDataRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this.discriminator;
        data["legalBasisId"] = this.legalBasisId;
        data["typeId"] = this.typeId;
        data["context"] = this.context;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEffectivness"] = this.dateOfEffectivness ? this.dateOfEffectivness.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfLegalForce"] = this.dateOfLegalForce ? this.dateOfLegalForce.toFormat('yyyy-MM-dd') : <any>undefined;
        data["isDeletedOrRepealed"] = this.isDeletedOrRepealed;
        data["dateOfIsDeletedOrRepealed"] = this.dateOfIsDeletedOrRepealed ? this.dateOfIsDeletedOrRepealed.toFormat('yyyy-MM-dd') : <any>undefined;
        data["reason"] = this.reason;
        data["remark"] = this.remark;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["sapInvoiceStatusId"] = this.sapInvoiceStatusId;
        data["dateOfSapInvoiceBilling"] = this.dateOfSapInvoiceBilling ? this.dateOfSapInvoiceBilling.toFormat('yyyy-MM-dd') : <any>undefined;
        data["personLicenceId"] = this.personLicenceId;
        data["financialPenalty"] = this.financialPenalty;
        data["deleteReason"] = this.deleteReason;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["corporateLicenceId"] = this.corporateLicenceId;
        if (Array.isArray(this.businessIds)) {
            data["businessIds"] = [];
            for (let item of this.businessIds)
                data["businessIds"].push(item);
        }
        return data;
    }
}

export interface ICreateSensitiveDataRecordDto {
    discriminator: SensitiveDataRecordDiscriminator;
    legalBasisId: string | undefined;
    typeId: string | undefined;
    context: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfEffectivness: DateTime | undefined;
    dateOfLegalForce: DateTime | undefined;
    isDeletedOrRepealed: boolean;
    dateOfIsDeletedOrRepealed: DateTime | undefined;
    reason: string | undefined;
    remark: string | undefined;
    dateOfApplication: DateTime | undefined;
    sapInvoiceStatusId: string | undefined;
    dateOfSapInvoiceBilling: DateTime | undefined;
    personLicenceId: number | undefined;
    financialPenalty: number | undefined;
    deleteReason: string | undefined;
    sponsorshipTypeId: string | undefined;
    corporateLicenceId: number | undefined;
    businessIds: number[] | undefined;
}

export class GetSensitiveDataRecordDto implements IGetSensitiveDataRecordDto {
    id!: number;
    discriminator!: SensitiveDataRecordDiscriminator;
    legalBasisId!: string | undefined;
    typeId!: string | undefined;
    context!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfEffectivness!: DateTime | undefined;
    dateOfLegalForce!: DateTime | undefined;
    isDeletedOrRepealed!: boolean;
    dateOfIsDeletedOrRepealed!: DateTime | undefined;
    reason!: string | undefined;
    remark!: string | undefined;
    dateOfApplication!: DateTime | undefined;
    sapInvoiceStatusId!: string | undefined;
    dateOfSapInvoiceBilling!: DateTime | undefined;
    personLicenceId!: number | undefined;
    financialPenalty!: number | undefined;
    deleteReason!: string | undefined;
    sponsorshipTypeId!: string | undefined;
    corporateLicenceId!: number | undefined;
    businessIds!: number[] | undefined;

    constructor(data?: IGetSensitiveDataRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.discriminator = _data["discriminator"];
            this.legalBasisId = _data["legalBasisId"];
            this.typeId = _data["typeId"];
            this.context = _data["context"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfEffectivness = _data["dateOfEffectivness"] ? DateTime.fromISO(_data["dateOfEffectivness"].toString()) : <any>undefined;
            this.dateOfLegalForce = _data["dateOfLegalForce"] ? DateTime.fromISO(_data["dateOfLegalForce"].toString()) : <any>undefined;
            this.isDeletedOrRepealed = _data["isDeletedOrRepealed"];
            this.dateOfIsDeletedOrRepealed = _data["dateOfIsDeletedOrRepealed"] ? DateTime.fromISO(_data["dateOfIsDeletedOrRepealed"].toString()) : <any>undefined;
            this.reason = _data["reason"];
            this.remark = _data["remark"];
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.sapInvoiceStatusId = _data["sapInvoiceStatusId"];
            this.dateOfSapInvoiceBilling = _data["dateOfSapInvoiceBilling"] ? DateTime.fromISO(_data["dateOfSapInvoiceBilling"].toString()) : <any>undefined;
            this.personLicenceId = _data["personLicenceId"];
            this.financialPenalty = _data["financialPenalty"];
            this.deleteReason = _data["deleteReason"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.corporateLicenceId = _data["corporateLicenceId"];
            if (Array.isArray(_data["businessIds"])) {
                this.businessIds = [] as any;
                for (let item of _data["businessIds"])
                    this.businessIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GetSensitiveDataRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSensitiveDataRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["discriminator"] = this.discriminator;
        data["legalBasisId"] = this.legalBasisId;
        data["typeId"] = this.typeId;
        data["context"] = this.context;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEffectivness"] = this.dateOfEffectivness ? this.dateOfEffectivness.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfLegalForce"] = this.dateOfLegalForce ? this.dateOfLegalForce.toFormat('yyyy-MM-dd') : <any>undefined;
        data["isDeletedOrRepealed"] = this.isDeletedOrRepealed;
        data["dateOfIsDeletedOrRepealed"] = this.dateOfIsDeletedOrRepealed ? this.dateOfIsDeletedOrRepealed.toFormat('yyyy-MM-dd') : <any>undefined;
        data["reason"] = this.reason;
        data["remark"] = this.remark;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["sapInvoiceStatusId"] = this.sapInvoiceStatusId;
        data["dateOfSapInvoiceBilling"] = this.dateOfSapInvoiceBilling ? this.dateOfSapInvoiceBilling.toFormat('yyyy-MM-dd') : <any>undefined;
        data["personLicenceId"] = this.personLicenceId;
        data["financialPenalty"] = this.financialPenalty;
        data["deleteReason"] = this.deleteReason;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["corporateLicenceId"] = this.corporateLicenceId;
        if (Array.isArray(this.businessIds)) {
            data["businessIds"] = [];
            for (let item of this.businessIds)
                data["businessIds"].push(item);
        }
        return data;
    }
}

export interface IGetSensitiveDataRecordDto {
    id: number;
    discriminator: SensitiveDataRecordDiscriminator;
    legalBasisId: string | undefined;
    typeId: string | undefined;
    context: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfEffectivness: DateTime | undefined;
    dateOfLegalForce: DateTime | undefined;
    isDeletedOrRepealed: boolean;
    dateOfIsDeletedOrRepealed: DateTime | undefined;
    reason: string | undefined;
    remark: string | undefined;
    dateOfApplication: DateTime | undefined;
    sapInvoiceStatusId: string | undefined;
    dateOfSapInvoiceBilling: DateTime | undefined;
    personLicenceId: number | undefined;
    financialPenalty: number | undefined;
    deleteReason: string | undefined;
    sponsorshipTypeId: string | undefined;
    corporateLicenceId: number | undefined;
    businessIds: number[] | undefined;
}

export class GetSensitiveDataSearchOutputDto implements IGetSensitiveDataSearchOutputDto {
    totalCount!: number;
    items!: GetSensitiveDataRecordDto[] | undefined;

    constructor(data?: IGetSensitiveDataSearchOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetSensitiveDataRecordDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSensitiveDataSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSensitiveDataSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSensitiveDataSearchOutputDto {
    totalCount: number;
    items: GetSensitiveDataRecordDto[] | undefined;
}

export class UpdateSensitiveDataRecordDto implements IUpdateSensitiveDataRecordDto {
    legalBasisId!: string | undefined;
    typeId!: string | undefined;
    context!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfEnd!: DateTime | undefined;
    dateOfEffectivness!: DateTime | undefined;
    dateOfLegalForce!: DateTime | undefined;
    isDeletedOrRepealed!: boolean;
    dateOfIsDeletedOrRepealed!: DateTime | undefined;
    reason!: string | undefined;
    remark!: string | undefined;
    dateOfApplication!: DateTime | undefined;
    sapInvoiceStatusId!: string | undefined;
    dateOfSapInvoiceBilling!: DateTime | undefined;
    personLicenceId!: number | undefined;
    financialPenalty!: number | undefined;
    deleteReason!: string | undefined;
    sponsorshipTypeId!: string | undefined;
    corporateLicenceId!: number | undefined;
    businessIds!: number[] | undefined;

    constructor(data?: IUpdateSensitiveDataRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.legalBasisId = _data["legalBasisId"];
            this.typeId = _data["typeId"];
            this.context = _data["context"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfEnd = _data["dateOfEnd"] ? DateTime.fromISO(_data["dateOfEnd"].toString()) : <any>undefined;
            this.dateOfEffectivness = _data["dateOfEffectivness"] ? DateTime.fromISO(_data["dateOfEffectivness"].toString()) : <any>undefined;
            this.dateOfLegalForce = _data["dateOfLegalForce"] ? DateTime.fromISO(_data["dateOfLegalForce"].toString()) : <any>undefined;
            this.isDeletedOrRepealed = _data["isDeletedOrRepealed"];
            this.dateOfIsDeletedOrRepealed = _data["dateOfIsDeletedOrRepealed"] ? DateTime.fromISO(_data["dateOfIsDeletedOrRepealed"].toString()) : <any>undefined;
            this.reason = _data["reason"];
            this.remark = _data["remark"];
            this.dateOfApplication = _data["dateOfApplication"] ? DateTime.fromISO(_data["dateOfApplication"].toString()) : <any>undefined;
            this.sapInvoiceStatusId = _data["sapInvoiceStatusId"];
            this.dateOfSapInvoiceBilling = _data["dateOfSapInvoiceBilling"] ? DateTime.fromISO(_data["dateOfSapInvoiceBilling"].toString()) : <any>undefined;
            this.personLicenceId = _data["personLicenceId"];
            this.financialPenalty = _data["financialPenalty"];
            this.deleteReason = _data["deleteReason"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.corporateLicenceId = _data["corporateLicenceId"];
            if (Array.isArray(_data["businessIds"])) {
                this.businessIds = [] as any;
                for (let item of _data["businessIds"])
                    this.businessIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateSensitiveDataRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSensitiveDataRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalBasisId"] = this.legalBasisId;
        data["typeId"] = this.typeId;
        data["context"] = this.context;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEnd"] = this.dateOfEnd ? this.dateOfEnd.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfEffectivness"] = this.dateOfEffectivness ? this.dateOfEffectivness.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfLegalForce"] = this.dateOfLegalForce ? this.dateOfLegalForce.toFormat('yyyy-MM-dd') : <any>undefined;
        data["isDeletedOrRepealed"] = this.isDeletedOrRepealed;
        data["dateOfIsDeletedOrRepealed"] = this.dateOfIsDeletedOrRepealed ? this.dateOfIsDeletedOrRepealed.toFormat('yyyy-MM-dd') : <any>undefined;
        data["reason"] = this.reason;
        data["remark"] = this.remark;
        data["dateOfApplication"] = this.dateOfApplication ? this.dateOfApplication.toFormat('yyyy-MM-dd') : <any>undefined;
        data["sapInvoiceStatusId"] = this.sapInvoiceStatusId;
        data["dateOfSapInvoiceBilling"] = this.dateOfSapInvoiceBilling ? this.dateOfSapInvoiceBilling.toFormat('yyyy-MM-dd') : <any>undefined;
        data["personLicenceId"] = this.personLicenceId;
        data["financialPenalty"] = this.financialPenalty;
        data["deleteReason"] = this.deleteReason;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["corporateLicenceId"] = this.corporateLicenceId;
        if (Array.isArray(this.businessIds)) {
            data["businessIds"] = [];
            for (let item of this.businessIds)
                data["businessIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateSensitiveDataRecordDto {
    legalBasisId: string | undefined;
    typeId: string | undefined;
    context: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfEnd: DateTime | undefined;
    dateOfEffectivness: DateTime | undefined;
    dateOfLegalForce: DateTime | undefined;
    isDeletedOrRepealed: boolean;
    dateOfIsDeletedOrRepealed: DateTime | undefined;
    reason: string | undefined;
    remark: string | undefined;
    dateOfApplication: DateTime | undefined;
    sapInvoiceStatusId: string | undefined;
    dateOfSapInvoiceBilling: DateTime | undefined;
    personLicenceId: number | undefined;
    financialPenalty: number | undefined;
    deleteReason: string | undefined;
    sponsorshipTypeId: string | undefined;
    corporateLicenceId: number | undefined;
    businessIds: number[] | undefined;
}

export enum SensitiveDataDiscriminator {
    Person = 0,
    Sponsorship = 1,
}

export enum SensitiveDataRecordDiscriminator {
    PersonRestriction = 0,
    PersonRequirement = 1,
    PersonPrecautionaryMeasures = 2,
    PersonDisciplinaryMeasures = 3,
    PersonRejection = 4,
    PersonWithdrawal = 5,
    SponsorshipRestriction = 100,
    SponsorshipRequirement = 101,
    SponsorshipPrecautionaryMeasures = 102,
    SponsorshipRejection = 103,
    SponsorshipWithdrawal = 104,
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version!: string | undefined;
    releaseDate!: DateTime;
    currency!: string | undefined;
    currencySign!: string | undefined;
    allowTenantsToChangeEmailSettings!: boolean;
    userDelegationIsEnabled!: boolean;
    twoFactorCodeExpireSeconds!: number;
    features!: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.releaseDate = _data["releaseDate"] ? DateTime.fromISO(_data["releaseDate"].toString()) : <any>undefined;
            this.currency = _data["currency"];
            this.currencySign = _data["currencySign"];
            this.allowTenantsToChangeEmailSettings = _data["allowTenantsToChangeEmailSettings"];
            this.userDelegationIsEnabled = _data["userDelegationIsEnabled"];
            this.twoFactorCodeExpireSeconds = _data["twoFactorCodeExpireSeconds"];
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        (<any>this.features)![key] = _data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toString() : <any>undefined;
        data["currency"] = this.currency;
        data["currencySign"] = this.currencySign;
        data["allowTenantsToChangeEmailSettings"] = this.allowTenantsToChangeEmailSettings;
        data["userDelegationIsEnabled"] = this.userDelegationIsEnabled;
        data["twoFactorCodeExpireSeconds"] = this.twoFactorCodeExpireSeconds;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    (<any>data["features"])[key] = (<any>this.features)[key];
            }
        }
        return data;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: DateTime;
    currency: string | undefined;
    currencySign: string | undefined;
    allowTenantsToChangeEmailSettings: boolean;
    userDelegationIsEnabled: boolean;
    twoFactorCodeExpireSeconds: number;
    features: { [key: string]: boolean; } | undefined;
}

export class EditionInfoDto implements IEditionInfoDto {
    displayName!: string | undefined;
    trialDayCount!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    isHighestEdition!: boolean;
    isFree!: boolean;
    id!: number;

    constructor(data?: IEditionInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.trialDayCount = _data["trialDayCount"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.annualPrice = _data["annualPrice"];
            this.isHighestEdition = _data["isHighestEdition"];
            this.isFree = _data["isFree"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EditionInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["trialDayCount"] = this.trialDayCount;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["isHighestEdition"] = this.isHighestEdition;
        data["isFree"] = this.isFree;
        data["id"] = this.id;
        return data;
    }
}

export interface IEditionInfoDto {
    displayName: string | undefined;
    trialDayCount: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    isHighestEdition: boolean;
    isFree: boolean;
    id: number;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    user!: UserLoginInfoDto;
    impersonatorUser!: UserLoginInfoDto;
    tenant!: TenantLoginInfoDto;
    impersonatorTenant!: TenantLoginInfoDto;
    application!: ApplicationInfoDto;
    theme!: UiCustomizationSettingsDto;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"]) : <any>undefined;
            this.impersonatorUser = _data["impersonatorUser"] ? UserLoginInfoDto.fromJS(_data["impersonatorUser"]) : <any>undefined;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : <any>undefined;
            this.impersonatorTenant = _data["impersonatorTenant"] ? TenantLoginInfoDto.fromJS(_data["impersonatorTenant"]) : <any>undefined;
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : <any>undefined;
            this.theme = _data["theme"] ? UiCustomizationSettingsDto.fromJS(_data["theme"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["impersonatorUser"] = this.impersonatorUser ? this.impersonatorUser.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["impersonatorTenant"] = this.impersonatorTenant ? this.impersonatorTenant.toJSON() : <any>undefined;
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["theme"] = this.theme ? this.theme.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    user: UserLoginInfoDto;
    impersonatorUser: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
    impersonatorTenant: TenantLoginInfoDto;
    application: ApplicationInfoDto;
    theme: UiCustomizationSettingsDto;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    tenancyName!: string | undefined;
    name!: string | undefined;
    darkLogoId!: string | undefined;
    darkLogoFileType!: string | undefined;
    lightLogoId!: string | undefined;
    lightLogoFileType!: string | undefined;
    customCssId!: string | undefined;
    emailLogoId!: string | undefined;
    subscriptionEndDateUtc!: DateTime | undefined;
    isInTrialPeriod!: boolean;
    subscriptionPaymentType!: SubscriptionPaymentType;
    edition!: EditionInfoDto;
    featureValues!: NameValueDto[] | undefined;
    creationTime!: DateTime;
    paymentPeriodType!: PaymentPeriodType;
    subscriptionDateString!: string | undefined;
    creationTimeString!: string | undefined;
    id!: number;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.darkLogoId = _data["darkLogoId"];
            this.darkLogoFileType = _data["darkLogoFileType"];
            this.lightLogoId = _data["lightLogoId"];
            this.lightLogoFileType = _data["lightLogoFileType"];
            this.customCssId = _data["customCssId"];
            this.emailLogoId = _data["emailLogoId"];
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? DateTime.fromISO(_data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.subscriptionPaymentType = _data["subscriptionPaymentType"];
            this.edition = _data["edition"] ? EditionInfoDto.fromJS(_data["edition"]) : <any>undefined;
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.paymentPeriodType = _data["paymentPeriodType"];
            this.subscriptionDateString = _data["subscriptionDateString"];
            this.creationTimeString = _data["creationTimeString"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["darkLogoId"] = this.darkLogoId;
        data["darkLogoFileType"] = this.darkLogoFileType;
        data["lightLogoId"] = this.lightLogoId;
        data["lightLogoFileType"] = this.lightLogoFileType;
        data["customCssId"] = this.customCssId;
        data["emailLogoId"] = this.emailLogoId;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["subscriptionPaymentType"] = this.subscriptionPaymentType;
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["subscriptionDateString"] = this.subscriptionDateString;
        data["creationTimeString"] = this.creationTimeString;
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantLoginInfoDto {
    tenancyName: string | undefined;
    name: string | undefined;
    darkLogoId: string | undefined;
    darkLogoFileType: string | undefined;
    lightLogoId: string | undefined;
    lightLogoFileType: string | undefined;
    customCssId: string | undefined;
    emailLogoId: string | undefined;
    subscriptionEndDateUtc: DateTime | undefined;
    isInTrialPeriod: boolean;
    subscriptionPaymentType: SubscriptionPaymentType;
    edition: EditionInfoDto;
    featureValues: NameValueDto[] | undefined;
    creationTime: DateTime;
    paymentPeriodType: PaymentPeriodType;
    subscriptionDateString: string | undefined;
    creationTimeString: string | undefined;
    id: number;
}

export class UpdateUserSignInTokenOutput implements IUpdateUserSignInTokenOutput {
    signInToken!: string | undefined;
    encodedUserId!: string | undefined;
    encodedTenantId!: string | undefined;

    constructor(data?: IUpdateUserSignInTokenOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.signInToken = _data["signInToken"];
            this.encodedUserId = _data["encodedUserId"];
            this.encodedTenantId = _data["encodedTenantId"];
        }
    }

    static fromJS(data: any): UpdateUserSignInTokenOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserSignInTokenOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signInToken"] = this.signInToken;
        data["encodedUserId"] = this.encodedUserId;
        data["encodedTenantId"] = this.encodedTenantId;
        return data;
    }
}

export interface IUpdateUserSignInTokenOutput {
    signInToken: string | undefined;
    encodedUserId: string | undefined;
    encodedTenantId: string | undefined;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    profilePictureId!: string | undefined;
    id!: number;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.profilePictureId = _data["profilePictureId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserLoginInfoDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;
    id: number;
}

export class GetSidapDocumentGroupsInputDto implements IGetSidapDocumentGroupsInputDto {
    filter!: string | undefined;
    sorting!: string | undefined;
    maxResultCount!: number;
    skipCount!: number;

    constructor(data?: IGetSidapDocumentGroupsInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): GetSidapDocumentGroupsInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSidapDocumentGroupsInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }
}

export interface IGetSidapDocumentGroupsInputDto {
    filter: string | undefined;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
}

export class GetSidapDocumentGroupsOutputDto implements IGetSidapDocumentGroupsOutputDto {
    items!: SidapDocumentGroupDto[] | undefined;

    constructor(data?: IGetSidapDocumentGroupsOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SidapDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSidapDocumentGroupsOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSidapDocumentGroupsOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSidapDocumentGroupsOutputDto {
    items: SidapDocumentGroupDto[] | undefined;
}

export class GetSidapOperationsInputDto implements IGetSidapOperationsInputDto {
    filter!: string | undefined;
    sorting!: string | undefined;
    maxResultCount!: number;
    skipCount!: number;

    constructor(data?: IGetSidapOperationsInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): GetSidapOperationsInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSidapOperationsInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }
}

export interface IGetSidapOperationsInputDto {
    filter: string | undefined;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
}

export class GetSidapOperationsOutputDto implements IGetSidapOperationsOutputDto {
    items!: SidapOperationDto[] | undefined;

    constructor(data?: IGetSidapOperationsOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SidapOperationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSidapOperationsOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSidapOperationsOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSidapOperationsOutputDto {
    items: SidapOperationDto[] | undefined;
}

export class SidapDocumentGroupDto implements ISidapDocumentGroupDto {
    applicationType!: ApplicationType;
    professionId!: string | undefined;
    sponsorshipTypeId!: string | undefined;
    step!: number;
    typeId!: string | undefined;
    isMandatory!: boolean;
    info!: string | undefined;
    additionalProperties!: { [key: string]: string; } | undefined;

    constructor(data?: ISidapDocumentGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationType = _data["applicationType"];
            this.professionId = _data["professionId"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.step = _data["step"];
            this.typeId = _data["typeId"];
            this.isMandatory = _data["isMandatory"];
            this.info = _data["info"];
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): SidapDocumentGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new SidapDocumentGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationType"] = this.applicationType;
        data["professionId"] = this.professionId;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["step"] = this.step;
        data["typeId"] = this.typeId;
        data["isMandatory"] = this.isMandatory;
        data["info"] = this.info;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        return data;
    }
}

export interface ISidapDocumentGroupDto {
    applicationType: ApplicationType;
    professionId: string | undefined;
    sponsorshipTypeId: string | undefined;
    step: number;
    typeId: string | undefined;
    isMandatory: boolean;
    info: string | undefined;
    additionalProperties: { [key: string]: string; } | undefined;
}

export class SidapOperationDto implements ISidapOperationDto {
    operation!: string;
    protocolInfoFile!: GeneralFileInfoDto;
    jsonSchema!: string | undefined;

    constructor(data?: ISidapOperationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operation = _data["operation"];
            this.protocolInfoFile = _data["protocolInfoFile"] ? GeneralFileInfoDto.fromJS(_data["protocolInfoFile"]) : <any>undefined;
            this.jsonSchema = _data["jsonSchema"];
        }
    }

    static fromJS(data: any): SidapOperationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SidapOperationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operation"] = this.operation;
        data["protocolInfoFile"] = this.protocolInfoFile ? this.protocolInfoFile.toJSON() : <any>undefined;
        data["jsonSchema"] = this.jsonSchema;
        return data;
    }
}

export interface ISidapOperationDto {
    operation: string;
    protocolInfoFile: GeneralFileInfoDto;
    jsonSchema: string | undefined;
}

export class CreateOrUpdateSplPostgraduateTitlesInput implements ICreateOrUpdateSplPostgraduateTitlesInput {
    postgraduateTitles!: SplPostgraduateTitleDto[] | undefined;

    constructor(data?: ICreateOrUpdateSplPostgraduateTitlesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["postgraduateTitles"])) {
                this.postgraduateTitles = [] as any;
                for (let item of _data["postgraduateTitles"])
                    this.postgraduateTitles!.push(SplPostgraduateTitleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateSplPostgraduateTitlesInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateSplPostgraduateTitlesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.postgraduateTitles)) {
            data["postgraduateTitles"] = [];
            for (let item of this.postgraduateTitles)
                data["postgraduateTitles"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateSplPostgraduateTitlesInput {
    postgraduateTitles: SplPostgraduateTitleDto[] | undefined;
}

export class CreateSplInput implements ICreateSplInput {
    applicationTypeId!: ApplicationType;

    constructor(data?: ICreateSplInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationTypeId = _data["applicationTypeId"];
        }
    }

    static fromJS(data: any): CreateSplInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSplInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationTypeId"] = this.applicationTypeId;
        return data;
    }
}

export interface ICreateSplInput {
    applicationTypeId: ApplicationType;
}

export class CreateSplOutput implements ICreateSplOutput {
    caseId!: string | undefined;

    constructor(data?: ICreateSplOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
        }
    }

    static fromJS(data: any): CreateSplOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSplOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        return data;
    }
}

export interface ICreateSplOutput {
    caseId: string | undefined;
}

export class GetSplDocumentsInput implements IGetSplDocumentsInput {
    caseId!: string;
    step!: SplStatus;

    constructor(data?: IGetSplDocumentsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.step = _data["step"];
        }
    }

    static fromJS(data: any): GetSplDocumentsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSplDocumentsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["step"] = this.step;
        return data;
    }
}

export interface IGetSplDocumentsInput {
    caseId: string;
    step: SplStatus;
}

export class GetSplFileInput implements IGetSplFileInput {
    caseId!: string;
    step!: SplStatus;
    id!: number;

    constructor(data?: IGetSplFileInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.step = _data["step"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetSplFileInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSplFileInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["step"] = this.step;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetSplFileInput {
    caseId: string;
    step: SplStatus;
    id: number;
}

export class GetSplOutput implements IGetSplOutput {
    spl!: SplDto;

    constructor(data?: IGetSplOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.spl = _data["spl"] ? SplDto.fromJS(_data["spl"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSplOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSplOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["spl"] = this.spl ? this.spl.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSplOutput {
    spl: SplDto;
}

export class SplDocumentsOutput implements ISplDocumentsOutput {
    caseId!: string;
    documents!: GeneralDocumentGroupDto[];

    constructor(data?: ISplDocumentsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.documents = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SplDocumentsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SplDocumentsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISplDocumentsOutput {
    caseId: string;
    documents: GeneralDocumentGroupDto[];
}

export class SplDto implements ISplDto {
    application!: ApplicationDto;
    statusId!: SplStatus;
    person!: SplPersonDto;
    narcoticKnowledge!: SplNarcoticKnowledgeDto;
    postgraduateTitles!: SplPostgraduateTitleDto[] | undefined;
    documents!: GeneralDocumentGroupDto[] | undefined;

    constructor(data?: ISplDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationDto.fromJS(_data["application"]) : <any>undefined;
            this.statusId = _data["statusId"];
            this.person = _data["person"] ? SplPersonDto.fromJS(_data["person"]) : <any>undefined;
            this.narcoticKnowledge = _data["narcoticKnowledge"] ? SplNarcoticKnowledgeDto.fromJS(_data["narcoticKnowledge"]) : <any>undefined;
            if (Array.isArray(_data["postgraduateTitles"])) {
                this.postgraduateTitles = [] as any;
                for (let item of _data["postgraduateTitles"])
                    this.postgraduateTitles!.push(SplPostgraduateTitleDto.fromJS(item));
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(GeneralDocumentGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SplDto {
        data = typeof data === 'object' ? data : {};
        let result = new SplDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["statusId"] = this.statusId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["narcoticKnowledge"] = this.narcoticKnowledge ? this.narcoticKnowledge.toJSON() : <any>undefined;
        if (Array.isArray(this.postgraduateTitles)) {
            data["postgraduateTitles"] = [];
            for (let item of this.postgraduateTitles)
                data["postgraduateTitles"].push(item.toJSON());
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISplDto {
    application: ApplicationDto;
    statusId: SplStatus;
    person: SplPersonDto;
    narcoticKnowledge: SplNarcoticKnowledgeDto;
    postgraduateTitles: SplPostgraduateTitleDto[] | undefined;
    documents: GeneralDocumentGroupDto[] | undefined;
}

export class SplNarcoticKnowledgeDto implements ISplNarcoticKnowledgeDto {
    id!: number | undefined;
    hasAttendedBasicCourseOfNarcosticsTreatment!: string | undefined;
    courseDetails!: string | undefined;
    otherDetails!: string | undefined;

    constructor(data?: ISplNarcoticKnowledgeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.hasAttendedBasicCourseOfNarcosticsTreatment = _data["hasAttendedBasicCourseOfNarcosticsTreatment"];
            this.courseDetails = _data["courseDetails"];
            this.otherDetails = _data["otherDetails"];
        }
    }

    static fromJS(data: any): SplNarcoticKnowledgeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SplNarcoticKnowledgeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["hasAttendedBasicCourseOfNarcosticsTreatment"] = this.hasAttendedBasicCourseOfNarcosticsTreatment;
        data["courseDetails"] = this.courseDetails;
        data["otherDetails"] = this.otherDetails;
        return data;
    }
}

export interface ISplNarcoticKnowledgeDto {
    id: number | undefined;
    hasAttendedBasicCourseOfNarcosticsTreatment: string | undefined;
    courseDetails: string | undefined;
    otherDetails: string | undefined;
}

export class SplPersonDto implements ISplPersonDto {
    id!: number | undefined;
    firstName!: string;
    lastName!: string;
    gln!: string;
    licenceTypeId!: string | undefined;
    licenceCantonId!: string | undefined;
    licenceStatusId!: string | undefined;
    activityStatusId!: string | undefined;
    hasAppliedForProfessionalLicenceId!: string | undefined;

    constructor(data?: ISplPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.gln = _data["gln"];
            this.licenceTypeId = _data["licenceTypeId"];
            this.licenceCantonId = _data["licenceCantonId"];
            this.licenceStatusId = _data["licenceStatusId"];
            this.activityStatusId = _data["activityStatusId"];
            this.hasAppliedForProfessionalLicenceId = _data["hasAppliedForProfessionalLicenceId"];
        }
    }

    static fromJS(data: any): SplPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new SplPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["gln"] = this.gln;
        data["licenceTypeId"] = this.licenceTypeId;
        data["licenceCantonId"] = this.licenceCantonId;
        data["licenceStatusId"] = this.licenceStatusId;
        data["activityStatusId"] = this.activityStatusId;
        data["hasAppliedForProfessionalLicenceId"] = this.hasAppliedForProfessionalLicenceId;
        return data;
    }
}

export interface ISplPersonDto {
    id: number | undefined;
    firstName: string;
    lastName: string;
    gln: string;
    licenceTypeId: string | undefined;
    licenceCantonId: string | undefined;
    licenceStatusId: string | undefined;
    activityStatusId: string | undefined;
    hasAppliedForProfessionalLicenceId: string | undefined;
}

export class SplPostgraduateTitleDto implements ISplPostgraduateTitleDto {
    id!: number | undefined;
    titleId!: string | undefined;
    typeId!: string | undefined;
    placeOfIssue!: string | undefined;
    countryId!: string | undefined;
    dateOfIssue!: DateTime | undefined;
    dateOfRecognition!: DateTime | undefined;

    constructor(data?: ISplPostgraduateTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.titleId = _data["titleId"];
            this.typeId = _data["typeId"];
            this.placeOfIssue = _data["placeOfIssue"];
            this.countryId = _data["countryId"];
            this.dateOfIssue = _data["dateOfIssue"] ? DateTime.fromISO(_data["dateOfIssue"].toString()) : <any>undefined;
            this.dateOfRecognition = _data["dateOfRecognition"] ? DateTime.fromISO(_data["dateOfRecognition"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SplPostgraduateTitleDto {
        data = typeof data === 'object' ? data : {};
        let result = new SplPostgraduateTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["titleId"] = this.titleId;
        data["typeId"] = this.typeId;
        data["placeOfIssue"] = this.placeOfIssue;
        data["countryId"] = this.countryId;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toFormat('yyyy-MM-dd') : <any>undefined;
        data["dateOfRecognition"] = this.dateOfRecognition ? this.dateOfRecognition.toFormat('yyyy-MM-dd') : <any>undefined;
        return data;
    }
}

export interface ISplPostgraduateTitleDto {
    id: number | undefined;
    titleId: string | undefined;
    typeId: string | undefined;
    placeOfIssue: string | undefined;
    countryId: string | undefined;
    dateOfIssue: DateTime | undefined;
    dateOfRecognition: DateTime | undefined;
}

export enum SplStatus {
    Person = 0,
    PostgraduateTitle = 1,
    NarcoticKnowledge = 2,
    Release = 97,
    Released = 98,
    FinishReview = 99,
}

export class CreateOrUpdateSponsorshipDto implements ICreateOrUpdateSponsorshipDto {
    id!: number | undefined;
    name!: string;
    additionalName!: string | undefined;
    legalFormId!: string;
    postCode!: string;
    city!: string;
    street!: string;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string;
    cantonId!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    fax!: string | undefined;
    website!: string | undefined;
    uid!: string | undefined;
    sapId!: string | undefined;
    comments!: string | undefined;
    eDossierNumber!: string | undefined;
    rangeOfServices!: SponsorshipRangeOfServiceDto[] | undefined;
    otherSponsorshipRangeOfService!: string | undefined;
    sponsorshipFieldId!: string | undefined;

    constructor(data?: ICreateOrUpdateSponsorshipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.additionalName = _data["additionalName"];
            this.legalFormId = _data["legalFormId"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.cantonId = _data["cantonId"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.fax = _data["fax"];
            this.website = _data["website"];
            this.uid = _data["uid"];
            this.sapId = _data["sapId"];
            this.comments = _data["comments"];
            this.eDossierNumber = _data["eDossierNumber"];
            if (Array.isArray(_data["rangeOfServices"])) {
                this.rangeOfServices = [] as any;
                for (let item of _data["rangeOfServices"])
                    this.rangeOfServices!.push(SponsorshipRangeOfServiceDto.fromJS(item));
            }
            this.otherSponsorshipRangeOfService = _data["otherSponsorshipRangeOfService"];
            this.sponsorshipFieldId = _data["sponsorshipFieldId"];
        }
    }

    static fromJS(data: any): CreateOrUpdateSponsorshipDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateSponsorshipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["additionalName"] = this.additionalName;
        data["legalFormId"] = this.legalFormId;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["cantonId"] = this.cantonId;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["fax"] = this.fax;
        data["website"] = this.website;
        data["uid"] = this.uid;
        data["sapId"] = this.sapId;
        data["comments"] = this.comments;
        data["eDossierNumber"] = this.eDossierNumber;
        if (Array.isArray(this.rangeOfServices)) {
            data["rangeOfServices"] = [];
            for (let item of this.rangeOfServices)
                data["rangeOfServices"].push(item.toJSON());
        }
        data["otherSponsorshipRangeOfService"] = this.otherSponsorshipRangeOfService;
        data["sponsorshipFieldId"] = this.sponsorshipFieldId;
        return data;
    }
}

export interface ICreateOrUpdateSponsorshipDto {
    id: number | undefined;
    name: string;
    additionalName: string | undefined;
    legalFormId: string;
    postCode: string;
    city: string;
    street: string;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string;
    cantonId: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    fax: string | undefined;
    website: string | undefined;
    uid: string | undefined;
    sapId: string | undefined;
    comments: string | undefined;
    eDossierNumber: string | undefined;
    rangeOfServices: SponsorshipRangeOfServiceDto[] | undefined;
    otherSponsorshipRangeOfService: string | undefined;
    sponsorshipFieldId: string | undefined;
}

export class CreateOrUpdateSponsorshipNursingInstitutionInput implements ICreateOrUpdateSponsorshipNursingInstitutionInput {
    sponsorshipNursingInstitution!: SponsorshipNursingInstitutionDto;
    sponsorshipId!: number;

    constructor(data?: ICreateOrUpdateSponsorshipNursingInstitutionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sponsorshipNursingInstitution = _data["sponsorshipNursingInstitution"] ? SponsorshipNursingInstitutionDto.fromJS(_data["sponsorshipNursingInstitution"]) : <any>undefined;
            this.sponsorshipId = _data["sponsorshipId"];
        }
    }

    static fromJS(data: any): CreateOrUpdateSponsorshipNursingInstitutionInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateSponsorshipNursingInstitutionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sponsorshipNursingInstitution"] = this.sponsorshipNursingInstitution ? this.sponsorshipNursingInstitution.toJSON() : <any>undefined;
        data["sponsorshipId"] = this.sponsorshipId;
        return data;
    }
}

export interface ICreateOrUpdateSponsorshipNursingInstitutionInput {
    sponsorshipNursingInstitution: SponsorshipNursingInstitutionDto;
    sponsorshipId: number;
}

export class GetSponsorshipDossierSearchOutput implements IGetSponsorshipDossierSearchOutput {
    totalCount!: number;
    items!: SponsorshipDossierSearchDto[] | undefined;

    constructor(data?: IGetSponsorshipDossierSearchOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SponsorshipDossierSearchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSponsorshipDossierSearchOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSponsorshipDossierSearchOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSponsorshipDossierSearchOutput {
    totalCount: number;
    items: SponsorshipDossierSearchDto[] | undefined;
}

export class GetSponsorshipDto implements IGetSponsorshipDto {
    medRegId!: number | undefined;
    naregId!: number | undefined;
    psyRegId!: number | undefined;
    isPublicPharmacy!: boolean;
    isArchived!: boolean;
    sapBusinessPartner!: SapBusinessPartnerDto;
    sponsorshipNursingInstitution!: SponsorshipNursingInstitutionDto;
    businesses!: GetBusinessDto[] | undefined;
    id!: number | undefined;
    name!: string;
    additionalName!: string | undefined;
    legalFormId!: string;
    postCode!: string;
    city!: string;
    street!: string;
    streetNr!: string | undefined;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string;
    cantonId!: string | undefined;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    fax!: string | undefined;
    website!: string | undefined;
    uid!: string | undefined;
    sapId!: string | undefined;
    comments!: string | undefined;
    eDossierNumber!: string | undefined;
    rangeOfServices!: SponsorshipRangeOfServiceDto[] | undefined;
    otherSponsorshipRangeOfService!: string | undefined;
    sponsorshipFieldId!: string | undefined;

    constructor(data?: IGetSponsorshipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.medRegId = _data["medRegId"];
            this.naregId = _data["naregId"];
            this.psyRegId = _data["psyRegId"];
            this.isPublicPharmacy = _data["isPublicPharmacy"];
            this.isArchived = _data["isArchived"];
            this.sapBusinessPartner = _data["sapBusinessPartner"] ? SapBusinessPartnerDto.fromJS(_data["sapBusinessPartner"]) : <any>undefined;
            this.sponsorshipNursingInstitution = _data["sponsorshipNursingInstitution"] ? SponsorshipNursingInstitutionDto.fromJS(_data["sponsorshipNursingInstitution"]) : <any>undefined;
            if (Array.isArray(_data["businesses"])) {
                this.businesses = [] as any;
                for (let item of _data["businesses"])
                    this.businesses!.push(GetBusinessDto.fromJS(item));
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.additionalName = _data["additionalName"];
            this.legalFormId = _data["legalFormId"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.cantonId = _data["cantonId"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.fax = _data["fax"];
            this.website = _data["website"];
            this.uid = _data["uid"];
            this.sapId = _data["sapId"];
            this.comments = _data["comments"];
            this.eDossierNumber = _data["eDossierNumber"];
            if (Array.isArray(_data["rangeOfServices"])) {
                this.rangeOfServices = [] as any;
                for (let item of _data["rangeOfServices"])
                    this.rangeOfServices!.push(SponsorshipRangeOfServiceDto.fromJS(item));
            }
            this.otherSponsorshipRangeOfService = _data["otherSponsorshipRangeOfService"];
            this.sponsorshipFieldId = _data["sponsorshipFieldId"];
        }
    }

    static fromJS(data: any): GetSponsorshipDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSponsorshipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medRegId"] = this.medRegId;
        data["naregId"] = this.naregId;
        data["psyRegId"] = this.psyRegId;
        data["isPublicPharmacy"] = this.isPublicPharmacy;
        data["isArchived"] = this.isArchived;
        data["sapBusinessPartner"] = this.sapBusinessPartner ? this.sapBusinessPartner.toJSON() : <any>undefined;
        data["sponsorshipNursingInstitution"] = this.sponsorshipNursingInstitution ? this.sponsorshipNursingInstitution.toJSON() : <any>undefined;
        if (Array.isArray(this.businesses)) {
            data["businesses"] = [];
            for (let item of this.businesses)
                data["businesses"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["additionalName"] = this.additionalName;
        data["legalFormId"] = this.legalFormId;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["cantonId"] = this.cantonId;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["fax"] = this.fax;
        data["website"] = this.website;
        data["uid"] = this.uid;
        data["sapId"] = this.sapId;
        data["comments"] = this.comments;
        data["eDossierNumber"] = this.eDossierNumber;
        if (Array.isArray(this.rangeOfServices)) {
            data["rangeOfServices"] = [];
            for (let item of this.rangeOfServices)
                data["rangeOfServices"].push(item.toJSON());
        }
        data["otherSponsorshipRangeOfService"] = this.otherSponsorshipRangeOfService;
        data["sponsorshipFieldId"] = this.sponsorshipFieldId;
        return data;
    }
}

export interface IGetSponsorshipDto {
    medRegId: number | undefined;
    naregId: number | undefined;
    psyRegId: number | undefined;
    isPublicPharmacy: boolean;
    isArchived: boolean;
    sapBusinessPartner: SapBusinessPartnerDto;
    sponsorshipNursingInstitution: SponsorshipNursingInstitutionDto;
    businesses: GetBusinessDto[] | undefined;
    id: number | undefined;
    name: string;
    additionalName: string | undefined;
    legalFormId: string;
    postCode: string;
    city: string;
    street: string;
    streetNr: string | undefined;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string;
    cantonId: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    fax: string | undefined;
    website: string | undefined;
    uid: string | undefined;
    sapId: string | undefined;
    comments: string | undefined;
    eDossierNumber: string | undefined;
    rangeOfServices: SponsorshipRangeOfServiceDto[] | undefined;
    otherSponsorshipRangeOfService: string | undefined;
    sponsorshipFieldId: string | undefined;
}

export class SponsorshipDossierSearchDto implements ISponsorshipDossierSearchDto {
    name!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    uid!: string | undefined;
    legalFormId!: string | undefined;
    sponsorshipFieldId!: string | undefined;
    sponsorshipTypes!: string | undefined;
    readonly sponsorshipTypeList!: string[] | undefined;
    id!: number;

    constructor(data?: ISponsorshipDossierSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.uid = _data["uid"];
            this.legalFormId = _data["legalFormId"];
            this.sponsorshipFieldId = _data["sponsorshipFieldId"];
            this.sponsorshipTypes = _data["sponsorshipTypes"];
            if (Array.isArray(_data["sponsorshipTypeList"])) {
                (<any>this).sponsorshipTypeList = [] as any;
                for (let item of _data["sponsorshipTypeList"])
                    (<any>this).sponsorshipTypeList!.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SponsorshipDossierSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new SponsorshipDossierSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["uid"] = this.uid;
        data["legalFormId"] = this.legalFormId;
        data["sponsorshipFieldId"] = this.sponsorshipFieldId;
        data["sponsorshipTypes"] = this.sponsorshipTypes;
        if (Array.isArray(this.sponsorshipTypeList)) {
            data["sponsorshipTypeList"] = [];
            for (let item of this.sponsorshipTypeList)
                data["sponsorshipTypeList"].push(item);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface ISponsorshipDossierSearchDto {
    name: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    uid: string | undefined;
    legalFormId: string | undefined;
    sponsorshipFieldId: string | undefined;
    sponsorshipTypes: string | undefined;
    sponsorshipTypeList: string[] | undefined;
    id: number;
}

export class SponsorshipDto implements ISponsorshipDto {
    name!: string;
    additionalName!: string | undefined;
    legalFormId!: string;
    postCode!: string;
    city!: string;
    street!: string;
    streetNr!: string;
    postOfficeBox!: string | undefined;
    addressAddition!: string | undefined;
    countryId!: string;
    cantonId!: string;
    phone1!: string | undefined;
    phone2!: string | undefined;
    email!: string | undefined;
    fax!: string | undefined;
    website!: string | undefined;
    uid!: string | undefined;
    comments!: string | undefined;
    rangeOfServices!: SponsorshipRangeOfServiceDto[] | undefined;
    otherSponsorshipRangeOfService!: string | undefined;
    sponsorshipFieldId!: string | undefined;
    sponsorshipNursingInstitution!: SponsorshipNursingInstitutionDto;
    id!: number;

    constructor(data?: ISponsorshipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.additionalName = _data["additionalName"];
            this.legalFormId = _data["legalFormId"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postOfficeBox = _data["postOfficeBox"];
            this.addressAddition = _data["addressAddition"];
            this.countryId = _data["countryId"];
            this.cantonId = _data["cantonId"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.email = _data["email"];
            this.fax = _data["fax"];
            this.website = _data["website"];
            this.uid = _data["uid"];
            this.comments = _data["comments"];
            if (Array.isArray(_data["rangeOfServices"])) {
                this.rangeOfServices = [] as any;
                for (let item of _data["rangeOfServices"])
                    this.rangeOfServices!.push(SponsorshipRangeOfServiceDto.fromJS(item));
            }
            this.otherSponsorshipRangeOfService = _data["otherSponsorshipRangeOfService"];
            this.sponsorshipFieldId = _data["sponsorshipFieldId"];
            this.sponsorshipNursingInstitution = _data["sponsorshipNursingInstitution"] ? SponsorshipNursingInstitutionDto.fromJS(_data["sponsorshipNursingInstitution"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SponsorshipDto {
        data = typeof data === 'object' ? data : {};
        let result = new SponsorshipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["additionalName"] = this.additionalName;
        data["legalFormId"] = this.legalFormId;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postOfficeBox"] = this.postOfficeBox;
        data["addressAddition"] = this.addressAddition;
        data["countryId"] = this.countryId;
        data["cantonId"] = this.cantonId;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["email"] = this.email;
        data["fax"] = this.fax;
        data["website"] = this.website;
        data["uid"] = this.uid;
        data["comments"] = this.comments;
        if (Array.isArray(this.rangeOfServices)) {
            data["rangeOfServices"] = [];
            for (let item of this.rangeOfServices)
                data["rangeOfServices"].push(item.toJSON());
        }
        data["otherSponsorshipRangeOfService"] = this.otherSponsorshipRangeOfService;
        data["sponsorshipFieldId"] = this.sponsorshipFieldId;
        data["sponsorshipNursingInstitution"] = this.sponsorshipNursingInstitution ? this.sponsorshipNursingInstitution.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ISponsorshipDto {
    name: string;
    additionalName: string | undefined;
    legalFormId: string;
    postCode: string;
    city: string;
    street: string;
    streetNr: string;
    postOfficeBox: string | undefined;
    addressAddition: string | undefined;
    countryId: string;
    cantonId: string;
    phone1: string | undefined;
    phone2: string | undefined;
    email: string | undefined;
    fax: string | undefined;
    website: string | undefined;
    uid: string | undefined;
    comments: string | undefined;
    rangeOfServices: SponsorshipRangeOfServiceDto[] | undefined;
    otherSponsorshipRangeOfService: string | undefined;
    sponsorshipFieldId: string | undefined;
    sponsorshipNursingInstitution: SponsorshipNursingInstitutionDto;
    id: number;
}

export class SponsorshipFormSearchDto implements ISponsorshipFormSearchDto {
    sponsorshipId!: number | undefined;
    legalFormId!: string | undefined;
    sponsorshipTypeId!: string | undefined;
    sponsorshipFieldId!: string | undefined;
    sponsorshipRangeOfServiceIds!: string[] | undefined;
    name!: string | undefined;
    additionalName!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    uid!: string | undefined;
    email!: string | undefined;

    constructor(data?: ISponsorshipFormSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sponsorshipId = _data["sponsorshipId"];
            this.legalFormId = _data["legalFormId"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.sponsorshipFieldId = _data["sponsorshipFieldId"];
            if (Array.isArray(_data["sponsorshipRangeOfServiceIds"])) {
                this.sponsorshipRangeOfServiceIds = [] as any;
                for (let item of _data["sponsorshipRangeOfServiceIds"])
                    this.sponsorshipRangeOfServiceIds!.push(item);
            }
            this.name = _data["name"];
            this.additionalName = _data["additionalName"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.uid = _data["uid"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): SponsorshipFormSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new SponsorshipFormSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sponsorshipId"] = this.sponsorshipId;
        data["legalFormId"] = this.legalFormId;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["sponsorshipFieldId"] = this.sponsorshipFieldId;
        if (Array.isArray(this.sponsorshipRangeOfServiceIds)) {
            data["sponsorshipRangeOfServiceIds"] = [];
            for (let item of this.sponsorshipRangeOfServiceIds)
                data["sponsorshipRangeOfServiceIds"].push(item);
        }
        data["name"] = this.name;
        data["additionalName"] = this.additionalName;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["uid"] = this.uid;
        data["email"] = this.email;
        return data;
    }
}

export interface ISponsorshipFormSearchDto {
    sponsorshipId: number | undefined;
    legalFormId: string | undefined;
    sponsorshipTypeId: string | undefined;
    sponsorshipFieldId: string | undefined;
    sponsorshipRangeOfServiceIds: string[] | undefined;
    name: string | undefined;
    additionalName: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    uid: string | undefined;
    email: string | undefined;
}

export class SponsorshipFormSearchInput implements ISponsorshipFormSearchInput {
    sponsorshipId!: number | undefined;
    name!: string | undefined;
    sponsorshipTypeId!: string | undefined;
    legalFormId!: string | undefined;
    street!: string | undefined;
    streetNr!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    uid!: string | undefined;
    email!: string | undefined;
    sponsorshipFieldId!: string | undefined;
    sponsorshipRangeOfServiceId!: string | undefined;
    maxResultCount!: number | undefined;
    skipCount!: number | undefined;

    constructor(data?: ISponsorshipFormSearchInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sponsorshipId = _data["sponsorshipId"];
            this.name = _data["name"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.legalFormId = _data["legalFormId"];
            this.street = _data["street"];
            this.streetNr = _data["streetNr"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.uid = _data["uid"];
            this.email = _data["email"];
            this.sponsorshipFieldId = _data["sponsorshipFieldId"];
            this.sponsorshipRangeOfServiceId = _data["sponsorshipRangeOfServiceId"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): SponsorshipFormSearchInput {
        data = typeof data === 'object' ? data : {};
        let result = new SponsorshipFormSearchInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sponsorshipId"] = this.sponsorshipId;
        data["name"] = this.name;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["legalFormId"] = this.legalFormId;
        data["street"] = this.street;
        data["streetNr"] = this.streetNr;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["uid"] = this.uid;
        data["email"] = this.email;
        data["sponsorshipFieldId"] = this.sponsorshipFieldId;
        data["sponsorshipRangeOfServiceId"] = this.sponsorshipRangeOfServiceId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }
}

export interface ISponsorshipFormSearchInput {
    sponsorshipId: number | undefined;
    name: string | undefined;
    sponsorshipTypeId: string | undefined;
    legalFormId: string | undefined;
    street: string | undefined;
    streetNr: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    uid: string | undefined;
    email: string | undefined;
    sponsorshipFieldId: string | undefined;
    sponsorshipRangeOfServiceId: string | undefined;
    maxResultCount: number | undefined;
    skipCount: number | undefined;
}

export class SponsorshipFormSearchOutput implements ISponsorshipFormSearchOutput {
    totalCount!: number;
    items!: SponsorshipFormSearchDto[] | undefined;

    constructor(data?: ISponsorshipFormSearchOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SponsorshipFormSearchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SponsorshipFormSearchOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SponsorshipFormSearchOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISponsorshipFormSearchOutput {
    totalCount: number;
    items: SponsorshipFormSearchDto[] | undefined;
}

export class SponsorshipNursingInstitutionDto implements ISponsorshipNursingInstitutionDto {
    nursingHomeCategoryId!: string | undefined;
    totalAllowedBeds!: number;

    constructor(data?: ISponsorshipNursingInstitutionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nursingHomeCategoryId = _data["nursingHomeCategoryId"];
            this.totalAllowedBeds = _data["totalAllowedBeds"];
        }
    }

    static fromJS(data: any): SponsorshipNursingInstitutionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SponsorshipNursingInstitutionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nursingHomeCategoryId"] = this.nursingHomeCategoryId;
        data["totalAllowedBeds"] = this.totalAllowedBeds;
        return data;
    }
}

export interface ISponsorshipNursingInstitutionDto {
    nursingHomeCategoryId: string | undefined;
    totalAllowedBeds: number;
}

export class GetSponsorshipApplicationsOutput implements IGetSponsorshipApplicationsOutput {
    totalCount!: number;
    items!: SponsorshipApplicationSearchDto[] | undefined;

    constructor(data?: IGetSponsorshipApplicationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SponsorshipApplicationSearchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSponsorshipApplicationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSponsorshipApplicationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSponsorshipApplicationsOutput {
    totalCount: number;
    items: SponsorshipApplicationSearchDto[] | undefined;
}

export class SponsorshipApplicationSearchDto implements ISponsorshipApplicationSearchDto {
    id!: number;
    responsibleId!: number | undefined;
    responsibleFullName!: string | undefined;
    iAmResponsible!: boolean;
    caseId!: string | undefined;
    caseIdSearchable!: string | undefined;
    corporateLicenceType!: CorporateLicenceType;
    userFullName!: string | undefined;
    userEmail!: string | undefined;
    sponsorshipName!: string | undefined;
    businessName!: string | undefined;
    postCode!: string | undefined;
    city!: string | undefined;
    sponsorshipTypeId!: string | undefined;
    type!: number;
    status!: ApplicationStatus;
    dateOfStatusChange!: DateTime;
    submittedCount!: number;
    submittedDate!: DateTime | undefined;
    lastSubmittedDate!: DateTime | undefined;

    constructor(data?: ISponsorshipApplicationSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.responsibleId = _data["responsibleId"];
            this.responsibleFullName = _data["responsibleFullName"];
            this.iAmResponsible = _data["iAmResponsible"];
            this.caseId = _data["caseId"];
            this.caseIdSearchable = _data["caseIdSearchable"];
            this.corporateLicenceType = _data["corporateLicenceType"];
            this.userFullName = _data["userFullName"];
            this.userEmail = _data["userEmail"];
            this.sponsorshipName = _data["sponsorshipName"];
            this.businessName = _data["businessName"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.sponsorshipTypeId = _data["sponsorshipTypeId"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.dateOfStatusChange = _data["dateOfStatusChange"] ? DateTime.fromISO(_data["dateOfStatusChange"].toString()) : <any>undefined;
            this.submittedCount = _data["submittedCount"];
            this.submittedDate = _data["submittedDate"] ? DateTime.fromISO(_data["submittedDate"].toString()) : <any>undefined;
            this.lastSubmittedDate = _data["lastSubmittedDate"] ? DateTime.fromISO(_data["lastSubmittedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SponsorshipApplicationSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new SponsorshipApplicationSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["responsibleId"] = this.responsibleId;
        data["responsibleFullName"] = this.responsibleFullName;
        data["iAmResponsible"] = this.iAmResponsible;
        data["caseId"] = this.caseId;
        data["caseIdSearchable"] = this.caseIdSearchable;
        data["corporateLicenceType"] = this.corporateLicenceType;
        data["userFullName"] = this.userFullName;
        data["userEmail"] = this.userEmail;
        data["sponsorshipName"] = this.sponsorshipName;
        data["businessName"] = this.businessName;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["sponsorshipTypeId"] = this.sponsorshipTypeId;
        data["type"] = this.type;
        data["status"] = this.status;
        data["dateOfStatusChange"] = this.dateOfStatusChange ? this.dateOfStatusChange.toString() : <any>undefined;
        data["submittedCount"] = this.submittedCount;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toString() : <any>undefined;
        data["lastSubmittedDate"] = this.lastSubmittedDate ? this.lastSubmittedDate.toString() : <any>undefined;
        return data;
    }
}

export interface ISponsorshipApplicationSearchDto {
    id: number;
    responsibleId: number | undefined;
    responsibleFullName: string | undefined;
    iAmResponsible: boolean;
    caseId: string | undefined;
    caseIdSearchable: string | undefined;
    corporateLicenceType: CorporateLicenceType;
    userFullName: string | undefined;
    userEmail: string | undefined;
    sponsorshipName: string | undefined;
    businessName: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    sponsorshipTypeId: string | undefined;
    type: number;
    status: ApplicationStatus;
    dateOfStatusChange: DateTime;
    submittedCount: number;
    submittedDate: DateTime | undefined;
    lastSubmittedDate: DateTime | undefined;
}

export class GetSqlQueryDto implements IGetSqlQueryDto {
    id!: number;
    name!: string | undefined;
    description!: string | undefined;
    categoryId!: string | undefined;
    query!: string | undefined;
    parameters!: SqlQueryParameterDto[] | undefined;

    constructor(data?: IGetSqlQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.categoryId = _data["categoryId"];
            this.query = _data["query"];
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters!.push(SqlQueryParameterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSqlQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetSqlQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["categoryId"] = this.categoryId;
        data["query"] = this.query;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSqlQueryDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
    categoryId: string | undefined;
    query: string | undefined;
    parameters: SqlQueryParameterDto[] | undefined;
}

export class GetSqlQuerySearchInput implements IGetSqlQuerySearchInput {
    filter!: string | undefined;
    sorting!: string | undefined;
    maxResultCount!: number;
    skipCount!: number;

    constructor(data?: IGetSqlQuerySearchInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            this.sorting = _data["sorting"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
        }
    }

    static fromJS(data: any): GetSqlQuerySearchInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSqlQuerySearchInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data;
    }
}

export interface IGetSqlQuerySearchInput {
    filter: string | undefined;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
}

export class GetSqlQuerySearchOutput implements IGetSqlQuerySearchOutput {
    totalCount!: number;
    items!: SqlQuerySearchResultDto[] | undefined;

    constructor(data?: IGetSqlQuerySearchOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SqlQuerySearchResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSqlQuerySearchOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSqlQuerySearchOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSqlQuerySearchOutput {
    totalCount: number;
    items: SqlQuerySearchResultDto[] | undefined;
}

export class RunSqlQueryResultDto implements IRunSqlQueryResultDto {
    columns!: SqlColumnMetaDto[] | undefined;
    rows!: { [key: string]: any; }[] | undefined;

    constructor(data?: IRunSqlQueryResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(SqlColumnMetaDto.fromJS(item));
            }
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(item);
            }
        }
    }

    static fromJS(data: any): RunSqlQueryResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RunSqlQueryResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item);
        }
        return data;
    }
}

export interface IRunSqlQueryResultDto {
    columns: SqlColumnMetaDto[] | undefined;
    rows: { [key: string]: any; }[] | undefined;
}

export class SqlColumnMetaDto implements ISqlColumnMetaDto {
    name!: string | undefined;
    ordinal!: number;
    size!: number;
    dataType!: string | undefined;
    dbDataType!: string | undefined;
    isCode!: boolean;

    constructor(data?: ISqlColumnMetaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.ordinal = _data["ordinal"];
            this.size = _data["size"];
            this.dataType = _data["dataType"];
            this.dbDataType = _data["dbDataType"];
            this.isCode = _data["isCode"];
        }
    }

    static fromJS(data: any): SqlColumnMetaDto {
        data = typeof data === 'object' ? data : {};
        let result = new SqlColumnMetaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["ordinal"] = this.ordinal;
        data["size"] = this.size;
        data["dataType"] = this.dataType;
        data["dbDataType"] = this.dbDataType;
        data["isCode"] = this.isCode;
        return data;
    }
}

export interface ISqlColumnMetaDto {
    name: string | undefined;
    ordinal: number;
    size: number;
    dataType: string | undefined;
    dbDataType: string | undefined;
    isCode: boolean;
}

export class SqlQueryAnalyseResultDto implements ISqlQueryAnalyseResultDto {
    validSqlStatement!: boolean;
    errors!: string[] | undefined;
    onlySelectStatements!: boolean | undefined;
    parameters!: string[] | undefined;

    constructor(data?: ISqlQueryAnalyseResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.validSqlStatement = _data["validSqlStatement"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.onlySelectStatements = _data["onlySelectStatements"];
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters!.push(item);
            }
        }
    }

    static fromJS(data: any): SqlQueryAnalyseResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SqlQueryAnalyseResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validSqlStatement"] = this.validSqlStatement;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["onlySelectStatements"] = this.onlySelectStatements;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item);
        }
        return data;
    }
}

export interface ISqlQueryAnalyseResultDto {
    validSqlStatement: boolean;
    errors: string[] | undefined;
    onlySelectStatements: boolean | undefined;
    parameters: string[] | undefined;
}

export class SqlQueryDto implements ISqlQueryDto {
    name!: string;
    description!: string | undefined;
    categoryId!: string;
    query!: string;
    cron!: string | undefined;
    outputPath!: string | undefined;
    roles!: number[] | undefined;
    parameters!: SqlQueryParameterDto[] | undefined;

    constructor(data?: ISqlQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.categoryId = _data["categoryId"];
            this.query = _data["query"];
            this.cron = _data["cron"];
            this.outputPath = _data["outputPath"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters!.push(SqlQueryParameterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SqlQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new SqlQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["categoryId"] = this.categoryId;
        data["query"] = this.query;
        data["cron"] = this.cron;
        data["outputPath"] = this.outputPath;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISqlQueryDto {
    name: string;
    description: string | undefined;
    categoryId: string;
    query: string;
    cron: string | undefined;
    outputPath: string | undefined;
    roles: number[] | undefined;
    parameters: SqlQueryParameterDto[] | undefined;
}

export class SqlQueryParameterDto implements ISqlQueryParameterDto {
    name!: string;
    displayName!: string;
    type!: SqlParameterType;
    codeCategoryId!: CodeCategory;
    isRequired!: boolean;
    isMultiselect!: boolean;
    defaultValue!: string | undefined;

    constructor(data?: ISqlQueryParameterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.type = _data["type"];
            this.codeCategoryId = _data["codeCategoryId"];
            this.isRequired = _data["isRequired"];
            this.isMultiselect = _data["isMultiselect"];
            this.defaultValue = _data["defaultValue"];
        }
    }

    static fromJS(data: any): SqlQueryParameterDto {
        data = typeof data === 'object' ? data : {};
        let result = new SqlQueryParameterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["type"] = this.type;
        data["codeCategoryId"] = this.codeCategoryId;
        data["isRequired"] = this.isRequired;
        data["isMultiselect"] = this.isMultiselect;
        data["defaultValue"] = this.defaultValue;
        return data;
    }
}

export interface ISqlQueryParameterDto {
    name: string;
    displayName: string;
    type: SqlParameterType;
    codeCategoryId: CodeCategory;
    isRequired: boolean;
    isMultiselect: boolean;
    defaultValue: string | undefined;
}

export class SqlQuerySearchResultDto implements ISqlQuerySearchResultDto {
    name!: string | undefined;
    description!: string | undefined;
    categoryId!: string | undefined;
    query!: string | undefined;
    cron!: string | undefined;
    outputPath!: string | undefined;
    id!: number;

    constructor(data?: ISqlQuerySearchResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.categoryId = _data["categoryId"];
            this.query = _data["query"];
            this.cron = _data["cron"];
            this.outputPath = _data["outputPath"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SqlQuerySearchResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SqlQuerySearchResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["categoryId"] = this.categoryId;
        data["query"] = this.query;
        data["cron"] = this.cron;
        data["outputPath"] = this.outputPath;
        data["id"] = this.id;
        return data;
    }
}

export interface ISqlQuerySearchResultDto {
    name: string | undefined;
    description: string | undefined;
    categoryId: string | undefined;
    query: string | undefined;
    cron: string | undefined;
    outputPath: string | undefined;
    id: number;
}

export class DocumentDto implements IDocumentDto {
    typeId!: string | undefined;
    name!: string | undefined;
    mimeHeader!: string | undefined;
    file!: string | undefined;

    constructor(data?: IDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeId = _data["typeId"];
            this.name = _data["name"];
            this.mimeHeader = _data["mimeHeader"];
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): DocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["name"] = this.name;
        data["mimeHeader"] = this.mimeHeader;
        data["file"] = this.file;
        return data;
    }
}

export interface IDocumentDto {
    typeId: string | undefined;
    name: string | undefined;
    mimeHeader: string | undefined;
    file: string | undefined;
}

export class UiCustomizationSettingsDto implements IUiCustomizationSettingsDto {
    baseSettings!: ThemeSettingsDto;
    isLeftMenuUsed!: boolean;
    isTopMenuUsed!: boolean;
    isTabMenuUsed!: boolean;
    allowMenuScroll!: boolean;

    constructor(data?: IUiCustomizationSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseSettings = _data["baseSettings"] ? ThemeSettingsDto.fromJS(_data["baseSettings"]) : <any>undefined;
            this.isLeftMenuUsed = _data["isLeftMenuUsed"];
            this.isTopMenuUsed = _data["isTopMenuUsed"];
            this.isTabMenuUsed = _data["isTabMenuUsed"];
            this.allowMenuScroll = _data["allowMenuScroll"];
        }
    }

    static fromJS(data: any): UiCustomizationSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UiCustomizationSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseSettings"] = this.baseSettings ? this.baseSettings.toJSON() : <any>undefined;
        data["isLeftMenuUsed"] = this.isLeftMenuUsed;
        data["isTopMenuUsed"] = this.isTopMenuUsed;
        data["isTabMenuUsed"] = this.isTabMenuUsed;
        data["allowMenuScroll"] = this.allowMenuScroll;
        return data;
    }
}

export interface IUiCustomizationSettingsDto {
    baseSettings: ThemeSettingsDto;
    isLeftMenuUsed: boolean;
    isTopMenuUsed: boolean;
    isTabMenuUsed: boolean;
    allowMenuScroll: boolean;
}

export enum EnumUidStatus {
    Provisorisch = 0,
    InReaktivierung = 1,
    Definitiv = 2,
    InMutation = 3,
    Geloescht = 4,
    DefinitivGeloescht = 5,
    Annulliert = 6,
}

export class UidEntityDto implements IUidEntityDto {
    uid!: string | undefined;
    organisationName!: string | undefined;
    additionalName!: string | undefined;
    legalFormId!: string | undefined;
    street!: string | undefined;
    houseNumber!: string | undefined;
    zipCode!: string | undefined;
    town!: string | undefined;
    cantonId!: string | undefined;
    countryId!: string | undefined;
    status!: EnumUidStatus;
    rating!: number;

    constructor(data?: IUidEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uid = _data["uid"];
            this.organisationName = _data["organisationName"];
            this.additionalName = _data["additionalName"];
            this.legalFormId = _data["legalFormId"];
            this.street = _data["street"];
            this.houseNumber = _data["houseNumber"];
            this.zipCode = _data["zipCode"];
            this.town = _data["town"];
            this.cantonId = _data["cantonId"];
            this.countryId = _data["countryId"];
            this.status = _data["status"];
            this.rating = _data["rating"];
        }
    }

    static fromJS(data: any): UidEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new UidEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uid"] = this.uid;
        data["organisationName"] = this.organisationName;
        data["additionalName"] = this.additionalName;
        data["legalFormId"] = this.legalFormId;
        data["street"] = this.street;
        data["houseNumber"] = this.houseNumber;
        data["zipCode"] = this.zipCode;
        data["town"] = this.town;
        data["cantonId"] = this.cantonId;
        data["countryId"] = this.countryId;
        data["status"] = this.status;
        data["rating"] = this.rating;
        return data;
    }
}

export interface IUidEntityDto {
    uid: string | undefined;
    organisationName: string | undefined;
    additionalName: string | undefined;
    legalFormId: string | undefined;
    street: string | undefined;
    houseNumber: string | undefined;
    zipCode: string | undefined;
    town: string | undefined;
    cantonId: string | undefined;
    countryId: string | undefined;
    status: EnumUidStatus;
    rating: number;
}

export class GetVisibilityOutput implements IGetVisibilityOutput {
    items!: StatusVisibility[] | undefined;
    currentStatus!: number;

    constructor(data?: IGetVisibilityOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StatusVisibility.fromJS(item));
            }
            this.currentStatus = _data["currentStatus"];
        }
    }

    static fromJS(data: any): GetVisibilityOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetVisibilityOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["currentStatus"] = this.currentStatus;
        return data;
    }
}

export interface IGetVisibilityOutput {
    items: StatusVisibility[] | undefined;
    currentStatus: number;
}

export enum TabVisibility {
    Hidden = 0,
    NonNavigable = 1,
    Read = 2,
    Write = 3,
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress!: string;
    password!: string;
    twoFactorVerificationCode!: string | undefined;
    rememberClient!: boolean;
    twoFactorRememberClientToken!: string | undefined;
    singleSignIn!: boolean | undefined;
    returnUrl!: string | undefined;
    captchaResponse!: string | undefined;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.password = _data["password"];
            this.twoFactorVerificationCode = _data["twoFactorVerificationCode"];
            this.rememberClient = _data["rememberClient"];
            this.twoFactorRememberClientToken = _data["twoFactorRememberClientToken"];
            this.singleSignIn = _data["singleSignIn"];
            this.returnUrl = _data["returnUrl"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["twoFactorVerificationCode"] = this.twoFactorVerificationCode;
        data["rememberClient"] = this.rememberClient;
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["singleSignIn"] = this.singleSignIn;
        data["returnUrl"] = this.returnUrl;
        data["captchaResponse"] = this.captchaResponse;
        return data;
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    twoFactorVerificationCode: string | undefined;
    rememberClient: boolean;
    twoFactorRememberClientToken: string | undefined;
    singleSignIn: boolean | undefined;
    returnUrl: string | undefined;
    captchaResponse: string | undefined;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    shouldResetPassword!: boolean;
    passwordResetCode!: string | undefined;
    userId!: number;
    requiresTwoFactorVerification!: boolean;
    twoFactorAuthProviders!: string[] | undefined;
    twoFactorRememberClientToken!: string | undefined;
    returnUrl!: string | undefined;
    c!: string | undefined;
    waitingForActivation!: boolean;
    resetGoogleAuthenticatorTwoFactor!: boolean;
    email!: string | undefined;
    refreshToken!: string | undefined;
    refreshTokenExpireInSeconds!: number;
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shouldResetPassword = _data["shouldResetPassword"];
            this.passwordResetCode = _data["passwordResetCode"];
            this.userId = _data["userId"];
            this.requiresTwoFactorVerification = _data["requiresTwoFactorVerification"];
            if (Array.isArray(_data["twoFactorAuthProviders"])) {
                this.twoFactorAuthProviders = [] as any;
                for (let item of _data["twoFactorAuthProviders"])
                    this.twoFactorAuthProviders!.push(item);
            }
            this.twoFactorRememberClientToken = _data["twoFactorRememberClientToken"];
            this.returnUrl = _data["returnUrl"];
            this.c = _data["c"];
            this.waitingForActivation = _data["waitingForActivation"];
            this.resetGoogleAuthenticatorTwoFactor = _data["resetGoogleAuthenticatorTwoFactor"];
            this.email = _data["email"];
            this.refreshToken = _data["refreshToken"];
            this.refreshTokenExpireInSeconds = _data["refreshTokenExpireInSeconds"];
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shouldResetPassword"] = this.shouldResetPassword;
        data["passwordResetCode"] = this.passwordResetCode;
        data["userId"] = this.userId;
        data["requiresTwoFactorVerification"] = this.requiresTwoFactorVerification;
        if (Array.isArray(this.twoFactorAuthProviders)) {
            data["twoFactorAuthProviders"] = [];
            for (let item of this.twoFactorAuthProviders)
                data["twoFactorAuthProviders"].push(item);
        }
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["returnUrl"] = this.returnUrl;
        data["c"] = this.c;
        data["waitingForActivation"] = this.waitingForActivation;
        data["resetGoogleAuthenticatorTwoFactor"] = this.resetGoogleAuthenticatorTwoFactor;
        data["email"] = this.email;
        data["refreshToken"] = this.refreshToken;
        data["refreshTokenExpireInSeconds"] = this.refreshTokenExpireInSeconds;
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data;
    }
}

export interface IAuthenticateResultModel {
    shouldResetPassword: boolean;
    passwordResetCode: string | undefined;
    userId: number;
    requiresTwoFactorVerification: boolean;
    twoFactorAuthProviders: string[] | undefined;
    twoFactorRememberClientToken: string | undefined;
    returnUrl: string | undefined;
    c: string | undefined;
    waitingForActivation: boolean;
    resetGoogleAuthenticatorTwoFactor: boolean;
    email: string | undefined;
    refreshToken: string | undefined;
    refreshTokenExpireInSeconds: number;
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider!: string;
    providerKey!: string;
    providerAccessCode!: string;
    returnUrl!: string | undefined;
    singleSignIn!: boolean | undefined;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authProvider = _data["authProvider"];
            this.providerKey = _data["providerKey"];
            this.providerAccessCode = _data["providerAccessCode"];
            this.returnUrl = _data["returnUrl"];
            this.singleSignIn = _data["singleSignIn"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        data["returnUrl"] = this.returnUrl;
        data["singleSignIn"] = this.singleSignIn;
        return data;
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
    returnUrl: string | undefined;
    singleSignIn: boolean | undefined;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    waitingForActivation!: boolean;
    returnUrl!: string | undefined;
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;
    refreshToken!: string | undefined;
    refreshTokenExpireInSeconds!: number;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.waitingForActivation = _data["waitingForActivation"];
            this.returnUrl = _data["returnUrl"];
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.refreshToken = _data["refreshToken"];
            this.refreshTokenExpireInSeconds = _data["refreshTokenExpireInSeconds"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["waitingForActivation"] = this.waitingForActivation;
        data["returnUrl"] = this.returnUrl;
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["refreshToken"] = this.refreshToken;
        data["refreshTokenExpireInSeconds"] = this.refreshTokenExpireInSeconds;
        return data;
    }
}

export interface IExternalAuthenticateResultModel {
    waitingForActivation: boolean;
    returnUrl: string | undefined;
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    refreshToken: string | undefined;
    refreshTokenExpireInSeconds: number;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name!: string | undefined;
    clientId!: string | undefined;
    additionalParams!: { [key: string]: string; } | undefined;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.clientId = _data["clientId"];
            if (_data["additionalParams"]) {
                this.additionalParams = {} as any;
                for (let key in _data["additionalParams"]) {
                    if (_data["additionalParams"].hasOwnProperty(key))
                        (<any>this.additionalParams)![key] = _data["additionalParams"][key];
                }
            }
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        if (this.additionalParams) {
            data["additionalParams"] = {};
            for (let key in this.additionalParams) {
                if (this.additionalParams.hasOwnProperty(key))
                    (<any>data["additionalParams"])[key] = (<any>this.additionalParams)[key];
            }
        }
        return data;
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;
    additionalParams: { [key: string]: string; } | undefined;
}

export class SendTwoFactorAuthCodeModel implements ISendTwoFactorAuthCodeModel {
    userId!: number;
    provider!: string;

    constructor(data?: ISendTwoFactorAuthCodeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.provider = _data["provider"];
        }
    }

    static fromJS(data: any): SendTwoFactorAuthCodeModel {
        data = typeof data === 'object' ? data : {};
        let result = new SendTwoFactorAuthCodeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["provider"] = this.provider;
        return data;
    }
}

export interface ISendTwoFactorAuthCodeModel {
    userId: number;
    provider: string;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}